import { useCallback as e, useEffect as t, useMemo as n, useState as r } from "react";
import { Fragment as i, jsx as a, jsxs as o } from "react/jsx-runtime";
import { Alert as s, Avatar as c, Badge as l, Button as u, Card as d, Checkbox as f, Col as p, Collapse as m, ConfigProvider as h, DatePicker as g, Divider as ee, Drawer as te, Dropdown as ne, Form as _, Image as re, Input as v, Layout as y, Menu as ie, Modal as ae, Popover as oe, Progress as se, Radio as b, Row as ce, Select as x, Slider as le, Space as ue, Statistic as de, Steps as fe, Switch as pe, Table as me, Tag as he, TimePicker as ge, Tree as _e, Typography as S, Upload as ve, notification as ye, theme as C } from "antd";
import w from "@emotion/styled";
import { Fragment as T, jsx as E, jsxs as D } from "@emotion/react/jsx-runtime";
import { css as O } from "@emotion/react";
import { SearchOutlined as be } from "@ant-design/icons";
//#region \0rolldown/runtime.js
var xe = Object.defineProperty, k = (e, t) => {
	let n = {};
	for (var r in e) xe(n, r, {
		get: e[r],
		enumerable: !0
	});
	return t || xe(n, Symbol.toStringTag, { value: "Module" }), n;
}, Se = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 8V12M12 16H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ce = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M11.9998 8.99999V13M11.9998 17H12.0098M10.6151 3.89171L2.39019 18.0983C1.93398 18.8863 1.70588 19.2803 1.73959 19.6037C1.769 19.8857 1.91677 20.142 2.14613 20.3088C2.40908 20.5 2.86435 20.5 3.77487 20.5H20.2246C21.1352 20.5 21.5904 20.5 21.8534 20.3088C22.0827 20.142 22.2305 19.8857 22.2599 19.6037C22.2936 19.2803 22.0655 18.8863 21.6093 18.0983L13.3844 3.89171C12.9299 3.10654 12.7026 2.71396 12.4061 2.58211C12.1474 2.4671 11.8521 2.4671 11.5935 2.58211C11.2969 2.71396 11.0696 3.10655 10.6151 3.89171Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), we = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 8.00008V12.0001M12 16.0001H12.01M3 7.94153V16.0586C3 16.4013 3 16.5726 3.05048 16.7254C3.09515 16.8606 3.16816 16.9847 3.26463 17.0893C3.37369 17.2077 3.52345 17.2909 3.82297 17.4573L11.223 21.5684C11.5066 21.726 11.6484 21.8047 11.7985 21.8356C11.9315 21.863 12.0685 21.863 12.2015 21.8356C12.3516 21.8047 12.4934 21.726 12.777 21.5684L20.177 17.4573C20.4766 17.2909 20.6263 17.2077 20.7354 17.0893C20.8318 16.9847 20.9049 16.8606 20.9495 16.7254C21 16.5726 21 16.4013 21 16.0586V7.94153C21 7.59889 21 7.42756 20.9495 7.27477C20.9049 7.13959 20.8318 7.01551 20.7354 6.91082C20.6263 6.79248 20.4766 6.70928 20.177 6.54288L12.777 2.43177C12.4934 2.27421 12.3516 2.19543 12.2015 2.16454C12.0685 2.13721 11.9315 2.13721 11.7985 2.16454C11.6484 2.19543 11.5066 2.27421 11.223 2.43177L3.82297 6.54288C3.52345 6.70928 3.37369 6.79248 3.26463 6.91082C3.16816 7.01551 3.09515 7.13959 3.05048 7.27477C3 7.42756 3 7.59889 3 7.94153Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Te = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 8V12M12 16H12.01M2 8.52274V15.4773C2 15.7218 2 15.8441 2.02763 15.9592C2.05213 16.0613 2.09253 16.1588 2.14736 16.2483C2.2092 16.3492 2.29568 16.4357 2.46863 16.6086L7.39137 21.5314C7.56432 21.7043 7.6508 21.7908 7.75172 21.8526C7.84119 21.9075 7.93873 21.9479 8.04077 21.9724C8.15586 22 8.27815 22 8.52274 22H15.4773C15.7218 22 15.8441 22 15.9592 21.9724C16.0613 21.9479 16.1588 21.9075 16.2483 21.8526C16.3492 21.7908 16.4357 21.7043 16.6086 21.5314L21.5314 16.6086C21.7043 16.4357 21.7908 16.3492 21.8526 16.2483C21.9075 16.1588 21.9479 16.0613 21.9724 15.9592C22 15.8441 22 15.7218 22 15.4773V8.52274C22 8.27815 22 8.15586 21.9724 8.04077C21.9479 7.93873 21.9075 7.84119 21.8526 7.75172C21.7908 7.6508 21.7043 7.56432 21.5314 7.39137L16.6086 2.46863C16.4357 2.29568 16.3492 2.2092 16.2483 2.14736C16.1588 2.09253 16.0613 2.05213 15.9592 2.02763C15.8441 2 15.7218 2 15.4773 2H8.52274C8.27815 2 8.15586 2 8.04077 2.02763C7.93873 2.05213 7.84119 2.09253 7.75172 2.14736C7.6508 2.2092 7.56432 2.29568 7.39137 2.46863L2.46863 7.39137C2.29568 7.56432 2.2092 7.6508 2.14736 7.75172C2.09253 7.84119 2.05213 7.93873 2.02763 8.04077C2 8.15586 2 8.27815 2 8.52274Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ee = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 8V12M12 16H12.01M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), De = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M22 7.99992V11.9999M10.25 5.49991H6.8C5.11984 5.49991 4.27976 5.49991 3.63803 5.82689C3.07354 6.11451 2.6146 6.57345 2.32698 7.13794C2 7.77968 2 8.61976 2 10.2999L2 11.4999C2 12.4318 2 12.8977 2.15224 13.2653C2.35523 13.7553 2.74458 14.1447 3.23463 14.3477C3.60218 14.4999 4.06812 14.4999 5 14.4999V18.7499C5 18.9821 5 19.0982 5.00963 19.1959C5.10316 20.1455 5.85441 20.8968 6.80397 20.9903C6.90175 20.9999 7.01783 20.9999 7.25 20.9999C7.48217 20.9999 7.59826 20.9999 7.69604 20.9903C8.64559 20.8968 9.39685 20.1455 9.49037 19.1959C9.5 19.0982 9.5 18.9821 9.5 18.7499V14.4999H10.25C12.0164 14.4999 14.1772 15.4468 15.8443 16.3556C16.8168 16.8857 17.3031 17.1508 17.6216 17.1118C17.9169 17.0756 18.1402 16.943 18.3133 16.701C18.5 16.4401 18.5 15.9179 18.5 14.8736V5.1262C18.5 4.08191 18.5 3.55976 18.3133 3.2988C18.1402 3.05681 17.9169 2.92421 17.6216 2.88804C17.3031 2.84903 16.8168 3.11411 15.8443 3.64427C14.1772 4.55302 12.0164 5.49991 10.25 5.49991Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Oe = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M4 13.9999L5.57465 20.2985C5.61893 20.4756 5.64107 20.5642 5.66727 20.6415C5.92317 21.397 6.60352 21.9282 7.39852 21.9933C7.4799 21.9999 7.5712 21.9999 7.75379 21.9999C7.98244 21.9999 8.09677 21.9999 8.19308 21.9906C9.145 21.8982 9.89834 21.1449 9.99066 20.193C10 20.0967 10 19.9823 10 19.7537V5.49991M18.5 13.4999C20.433 13.4999 22 11.9329 22 9.99991C22 8.06691 20.433 6.49991 18.5 6.49991M10.25 5.49991H6.5C4.01472 5.49991 2 7.51463 2 9.99991C2 12.4852 4.01472 14.4999 6.5 14.4999H10.25C12.0164 14.4999 14.1772 15.4468 15.8443 16.3556C16.8168 16.8857 17.3031 17.1508 17.6216 17.1118C17.9169 17.0756 18.1402 16.943 18.3133 16.701C18.5 16.4401 18.5 15.9179 18.5 14.8736V5.1262C18.5 4.08191 18.5 3.55976 18.3133 3.2988C18.1402 3.05681 17.9169 2.92421 17.6216 2.88804C17.3031 2.84903 16.8168 3.11411 15.8443 3.64427C14.1772 4.55302 12.0164 5.49991 10.25 5.49991Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ke = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M18.5 16C20.433 16 22 13.0899 22 9.5C22 5.91015 20.433 3 18.5 3M18.5 16C16.567 16 15 13.0899 15 9.5C15 5.91015 16.567 3 18.5 3M18.5 16L5.44354 13.6261C4.51605 13.4575 4.05231 13.3731 3.67733 13.189C2.91447 12.8142 2.34636 12.1335 2.11414 11.3159C2 10.914 2 10.4427 2 9.5C2 8.5573 2 8.08595 2.11414 7.68407C2.34636 6.86649 2.91447 6.18577 3.67733 5.81105C4.05231 5.62685 4.51605 5.54254 5.44354 5.3739L18.5 3M5 14L5.39386 19.514C5.43126 20.0376 5.44996 20.2995 5.56387 20.4979C5.66417 20.6726 5.81489 20.8129 5.99629 20.9005C6.20232 21 6.46481 21 6.98979 21H8.7722C9.37234 21 9.67242 21 9.89451 20.8803C10.0897 20.7751 10.2443 20.6081 10.3342 20.4055C10.4365 20.1749 10.4135 19.8757 10.3675 19.2773L10 14.5",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ae = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9.35419 21C10.0593 21.6224 10.9856 22 12 22C13.0145 22 13.9407 21.6224 14.6458 21M18 8C18 6.4087 17.3679 4.88258 16.2427 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.8826 2.63214 7.75738 3.75736C6.63216 4.88258 6.00002 6.4087 6.00002 8C6.00002 11.0902 5.22049 13.206 4.34968 14.6054C3.61515 15.7859 3.24788 16.3761 3.26134 16.5408C3.27626 16.7231 3.31488 16.7926 3.46179 16.9016C3.59448 17 4.19261 17 5.38887 17H18.6112C19.8074 17 20.4056 17 20.5382 16.9016C20.6852 16.7926 20.7238 16.7231 20.7387 16.5408C20.7522 16.3761 20.3849 15.7859 19.6504 14.6054C18.7795 13.206 18 11.0902 18 8Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), je = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M14 21H10M18 8C18 6.4087 17.3679 4.88258 16.2427 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.8826 2.63214 7.75738 3.75736C6.63216 4.88258 6.00002 6.4087 6.00002 8C6.00002 11.0902 5.22049 13.206 4.34968 14.6054C3.61515 15.7859 3.24788 16.3761 3.26134 16.5408C3.27626 16.7231 3.31488 16.7926 3.46179 16.9016C3.59448 17 4.19261 17 5.38887 17H18.6112C19.8074 17 20.4056 17 20.5382 16.9016C20.6852 16.7926 20.7238 16.7231 20.7387 16.5408C20.7522 16.3761 20.3849 15.7859 19.6504 14.6054C18.7795 13.206 18 11.0902 18 8Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Me = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M14.9997 19C14.9997 20.6569 13.6566 22 11.9997 22C10.3429 22 8.99972 20.6569 8.99972 19M13.7962 6.23856C14.2317 5.78864 14.4997 5.17562 14.4997 4.5C14.4997 3.11929 13.3804 2 11.9997 2C10.619 2 9.49972 3.11929 9.49972 4.5C9.49972 5.17562 9.76772 5.78864 10.2032 6.23856M17.9997 11.2C17.9997 9.82087 17.3676 8.49823 16.2424 7.52304C15.1171 6.54786 13.591 6 11.9997 6C10.4084 6 8.8823 6.54786 7.75708 7.52304C6.63186 8.49823 5.99972 9.82087 5.99972 11.2C5.99972 13.4818 5.43385 15.1506 4.72778 16.3447C3.92306 17.7056 3.5207 18.3861 3.53659 18.5486C3.55476 18.7346 3.58824 18.7933 3.73906 18.9036C3.87089 19 4.53323 19 5.85791 19H18.1415C19.4662 19 20.1286 19 20.2604 18.9036C20.4112 18.7933 20.4447 18.7346 20.4629 18.5486C20.4787 18.3861 20.0764 17.7056 19.2717 16.3447C18.5656 15.1506 17.9997 13.4818 17.9997 11.2Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ne = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M14.391 18.015C14.8198 19.6154 13.8701 21.2604 12.2697 21.6893C10.6693 22.1181 9.02426 21.1683 8.59543 19.5679M10.8915 5.74109C11.1957 5.19379 11.2959 4.53229 11.1211 3.8797C10.7637 2.54603 9.39288 1.75457 8.05921 2.11193C6.72555 2.46928 5.93409 3.84013 6.29144 5.17379C6.46631 5.82639 6.88384 6.34916 7.42094 6.67103M16.2359 9.44553C15.879 8.1134 14.926 6.99944 13.5868 6.3487C12.2475 5.69797 10.6316 5.56377 9.09449 5.97563C7.55741 6.38749 6.22508 7.31167 5.3906 8.54486C4.55612 9.77805 4.28785 11.2192 4.64479 12.5514C5.23537 14.7554 5.12069 16.5138 4.74774 17.8499C4.32267 19.3728 4.11014 20.1342 4.16756 20.2871C4.23325 20.462 4.28076 20.5101 4.455 20.5776C4.60729 20.6366 5.24706 20.4651 6.5266 20.1223L18.3917 16.9431C19.6712 16.6002 20.311 16.4288 20.4134 16.3015C20.5305 16.1559 20.5476 16.0906 20.5171 15.9063C20.4904 15.7451 19.9256 15.192 18.796 14.0857C17.805 13.115 16.8265 11.6496 16.2359 9.44553Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Pe = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9.35419 21C10.0593 21.6224 10.9856 22 12 22C13.0145 22 13.9407 21.6224 14.6458 21M15 5H21M13 2.08389C12.6717 2.02841 12.3373 2 12 2C10.4087 2 8.8826 2.63214 7.75738 3.75736C6.63216 4.88258 6.00002 6.4087 6.00002 8C6.00002 11.0902 5.22049 13.206 4.34968 14.6054C3.61515 15.7859 3.24788 16.3761 3.26134 16.5408C3.27626 16.7231 3.31488 16.7926 3.46179 16.9016C3.59448 17 4.19261 17 5.38887 17H18.6112C19.8075 17 20.4056 17 20.5383 16.9016C20.6852 16.7926 20.7239 16.7231 20.7388 16.5407C20.7522 16.3761 20.385 15.786 19.6505 14.6057C18.877 13.3626 18.1754 11.5544 18.0283 9",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Fe = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M8.63306 3.03371C9.61959 2.3649 10.791 2 12 2C13.5913 2 15.1174 2.63214 16.2426 3.75736C17.3679 4.88258 18 6.4087 18 8C18 10.1008 18.2702 11.7512 18.6484 13.0324M6.25867 6.25724C6.08866 6.81726 6 7.40406 6 8C6 11.0902 5.22047 13.206 4.34966 14.6054C3.61513 15.7859 3.24786 16.3761 3.26132 16.5408C3.27624 16.7231 3.31486 16.7926 3.46178 16.9016C3.59446 17 4.19259 17 5.38885 17H17M9.35418 21C10.0593 21.6224 10.9856 22 12 22C13.0144 22 13.9407 21.6224 14.6458 21M21 21L3 3",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ie = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M14 21H10M8.63306 3.03371C9.61959 2.3649 10.791 2 12 2C13.5913 2 15.1174 2.63214 16.2426 3.75736C17.3679 4.88258 18 6.4087 18 8C18 10.1008 18.2702 11.7512 18.6484 13.0324M6.25867 6.25723C6.08866 6.81726 6 7.40406 6 8C6 11.0902 5.22047 13.206 4.34966 14.6054C3.61513 15.7859 3.24786 16.3761 3.26132 16.5408C3.27624 16.7231 3.31486 16.7926 3.46178 16.9016C3.59446 17 4.19259 17 5.38885 17H17M21 21L3 3",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Le = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M15 19C15 20.6569 13.6569 22 12 22C10.3431 22 9 20.6569 9 19M7.37748 7.88479C6.49088 8.81326 6 9.9847 6 11.2C6 13.4818 5.43413 15.1506 4.72806 16.3447C3.92334 17.7056 3.52098 18.3861 3.53686 18.5486C3.55504 18.7346 3.58852 18.7933 3.73934 18.9036C3.87117 19 4.53351 19 5.85819 19H19.88M12 6C11.7071 6 11.4164 6.01856 11.13 6.05493C10.7485 6.10339 10.5577 6.12762 10.3662 6.07557C10.2284 6.0381 10.0206 5.91728 9.91979 5.81604C9.77982 5.67541 9.74922 5.60123 9.68801 5.45287C9.56684 5.15921 9.5 4.83741 9.5 4.5C9.5 3.11929 10.6193 2 12 2C13.3807 2 14.5 3.11929 14.5 4.5C14.5 5.17562 14.232 5.78864 13.7965 6.23856C13.2203 6.08184 12.615 6 12 6ZM12 6C13.5913 6 15.1174 6.54786 16.2426 7.52304C17.3679 8.49823 18 9.82087 18 11.2C18 11.5348 18.0091 11.8563 18.0264 12.1652M21 20L3 4",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Re = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9.35419 21C10.0593 21.6224 10.9856 22 12 22C13.0145 22 13.9407 21.6224 14.6458 21M18 8V2M15 5H21M13 2.08389C12.6717 2.02841 12.3373 2 12 2C10.4087 2 8.8826 2.63214 7.75738 3.75736C6.63216 4.88258 6.00002 6.4087 6.00002 8C6.00002 11.0902 5.22049 13.206 4.34968 14.6054C3.61515 15.7859 3.24788 16.3761 3.26134 16.5408C3.27626 16.7231 3.31488 16.7926 3.46179 16.9016C3.59448 17 4.19261 17 5.38887 17H18.6112C19.8074 17 20.4055 17 20.5382 16.9016C20.6851 16.7926 20.7237 16.7231 20.7386 16.5408C20.7521 16.3761 20.3848 15.7858 19.6502 14.6052C19.1582 13.8144 18.6953 12.7948 18.3857 11.5",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ze = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9.35442 21C10.0596 21.6224 10.9858 22 12.0002 22C13.0147 22 13.9409 21.6224 14.6461 21M2.29414 5.81989C2.27979 4.36854 3.06227 3.01325 4.32635 2.3M21.7024 5.8199C21.7167 4.36855 20.9342 3.01325 19.6702 2.3M18.0002 8C18.0002 6.4087 17.3681 4.88258 16.2429 3.75736C15.1177 2.63214 13.5915 2 12.0002 2C10.4089 2 8.88283 2.63214 7.75761 3.75736C6.63239 4.88258 6.00025 6.4087 6.00025 8C6.00025 11.0902 5.22072 13.206 4.34991 14.6054C3.61538 15.7859 3.24811 16.3761 3.26157 16.5408C3.27649 16.7231 3.31511 16.7926 3.46203 16.9016C3.59471 17 4.19284 17 5.3891 17H18.6114C19.8077 17 20.4058 17 20.5385 16.9016C20.6854 16.7926 20.724 16.7231 20.7389 16.5408C20.7524 16.3761 20.3851 15.7859 19.6506 14.6054C18.7798 13.206 18.0002 11.0902 18.0002 8Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Be = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M14.0003 21H10.0003M2.29414 5.81989C2.27979 4.36854 3.06227 3.01325 4.32635 2.3M21.7025 5.8199C21.7169 4.36855 20.9344 3.01325 19.6703 2.3M18.0003 8C18.0003 6.4087 17.3682 4.88258 16.2429 3.75736C15.1177 2.63214 13.5916 2 12.0003 2C10.409 2 8.88288 2.63214 7.75766 3.75736C6.63244 4.88258 6.0003 6.4087 6.0003 8C6.0003 11.0902 5.22077 13.206 4.34996 14.6054C3.61542 15.7859 3.24816 16.3761 3.26162 16.5408C3.27653 16.7231 3.31516 16.7926 3.46207 16.9016C3.59476 17 4.19289 17 5.38915 17H18.6114C19.8077 17 20.4058 17 20.5385 16.9016C20.6854 16.7926 20.7241 16.7231 20.739 16.5408C20.7524 16.3761 20.3852 15.7859 19.6506 14.6054C18.7798 13.206 18.0003 11.0902 18.0003 8Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ve = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M15.0002 19C15.0002 20.6569 13.6571 22 12.0002 22C10.3434 22 9.00025 20.6569 9.00025 19M13.7968 6.23856C14.2322 5.78864 14.5002 5.17562 14.5002 4.5C14.5002 3.11929 13.381 2 12.0002 2C10.6195 2 9.50025 3.11929 9.50025 4.5C9.50025 5.17562 9.76825 5.78864 10.2037 6.23856M2.54707 8.32296C2.53272 6.87161 3.3152 5.51631 4.57928 4.80306M21.4534 8.32296C21.4678 6.87161 20.6853 5.51631 19.4212 4.80306M18.0002 11.2C18.0002 9.82087 17.3681 8.49823 16.2429 7.52304C15.1177 6.54786 13.5915 6 12.0002 6C10.4089 6 8.88283 6.54786 7.75761 7.52304C6.63239 8.49823 6.00025 9.82087 6.00025 11.2C6.00025 13.4818 5.43438 15.1506 4.72831 16.3447C3.92359 17.7056 3.52122 18.3861 3.53711 18.5486C3.55529 18.7346 3.58876 18.7933 3.73959 18.9036C3.87142 19 4.53376 19 5.85844 19H18.1421C19.4667 19 20.1291 19 20.2609 18.9036C20.4117 18.7933 20.4452 18.7346 20.4634 18.5486C20.4793 18.3861 20.0769 17.7056 19.2722 16.3447C18.5661 15.1506 18.0002 13.4818 18.0002 11.2Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), He = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M15.6459 18.0148C16.0747 19.6152 15.125 21.2602 13.5246 21.689C11.9242 22.1178 10.2792 21.1681 9.85036 19.5677M2.05683 11.6133C1.66734 10.2151 2.07238 8.70349 3.10878 7.68738M12.1463 5.74085C12.4505 5.19355 12.5507 4.53205 12.3759 3.87945C12.0185 2.54579 10.6477 1.75433 9.314 2.11168C7.98034 2.46904 7.18888 3.83988 7.54624 5.17355C7.7211 5.82614 8.13863 6.34891 8.67573 6.67079M20.319 6.72C19.9572 5.31439 18.8506 4.20779 17.445 3.84602M17.4906 9.44528C17.1337 8.11315 16.1808 6.99919 14.8415 6.34845C13.5022 5.69772 11.8863 5.56352 10.3492 5.97538C8.81214 6.38724 7.47981 7.31142 6.64533 8.54461C5.81085 9.77779 5.54258 11.219 5.89952 12.5511C6.4901 14.7552 6.37542 16.5135 6.00247 17.8497C5.5774 19.3725 5.36487 20.134 5.42228 20.2869C5.48798 20.4618 5.53549 20.5098 5.70973 20.5773C5.86202 20.6363 6.50179 20.4649 7.78133 20.122L19.6464 16.9428C20.9259 16.5999 21.5657 16.4285 21.6681 16.3013C21.7852 16.1557 21.8024 16.0904 21.7718 15.906C21.7451 15.7449 21.1803 15.1918 20.0508 14.0855C19.0597 13.1148 18.0812 11.6493 17.4906 9.44528Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ue = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M11 4H7.8C6.11984 4 5.27976 4 4.63803 4.32698C4.07354 4.6146 3.6146 5.07354 3.32698 5.63803C3 6.27976 3 7.11984 3 8.8V14C3 14.93 3 15.395 3.10222 15.7765C3.37962 16.8117 4.18827 17.6204 5.22354 17.8978C5.60504 18 6.07003 18 7 18V20.3355C7 20.8684 7 21.1348 7.10923 21.2716C7.20422 21.3906 7.34827 21.4599 7.50054 21.4597C7.67563 21.4595 7.88367 21.2931 8.29976 20.9602L10.6852 19.0518C11.1725 18.662 11.4162 18.4671 11.6875 18.3285C11.9282 18.2055 12.1844 18.1156 12.4492 18.0613C12.7477 18 13.0597 18 13.6837 18H15.2C16.8802 18 17.7202 18 18.362 17.673C18.9265 17.3854 19.3854 16.9265 19.673 16.362C20 15.7202 20 14.8802 20 13.2V13M20.1213 3.87868C21.2929 5.05025 21.2929 6.94975 20.1213 8.12132C18.9497 9.29289 17.0503 9.29289 15.8787 8.12132C14.7071 6.94975 14.7071 5.05025 15.8787 3.87868C17.0503 2.70711 18.9497 2.70711 20.1213 3.87868Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), We = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M11 4H7.8C6.11984 4 5.27976 4 4.63803 4.32698C4.07354 4.6146 3.6146 5.07354 3.32698 5.63803C3 6.27976 3 7.11984 3 8.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H15.2C16.8802 21 17.7202 21 18.362 20.673C18.9265 20.3854 19.3854 19.9265 19.673 19.362C20 18.7202 20 17.8802 20 16.2V13M20.1213 3.87868C21.2929 5.05025 21.2929 6.94975 20.1213 8.12132C18.9497 9.29289 17.0503 9.29289 15.8787 8.12132C14.7071 6.94975 14.7071 5.05025 15.8787 3.87868C17.0503 2.70711 18.9497 2.70711 20.1213 3.87868Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ge = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M11 4H7.8C6.11984 4 5.27976 4 4.63803 4.32698C4.07354 4.6146 3.6146 5.07354 3.32698 5.63803C3 6.27976 3 7.11984 3 8.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H15.2C16.8802 21 17.7202 21 18.362 20.673C18.9265 20.3854 19.3854 19.9265 19.673 19.362C20 18.7202 20 17.8802 20 16.2V13M13 17H7M15 13H7M20.1213 3.87868C21.2929 5.05025 21.2929 6.94975 20.1213 8.12132C18.9497 9.29289 17.0503 9.29289 15.8787 8.12132C14.7071 6.94975 14.7071 5.05025 15.8787 3.87868C17.0503 2.70711 18.9497 2.70711 20.1213 3.87868Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ke = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M17.0001 2V13M22.0001 9.8V5.2C22.0001 4.07989 22.0001 3.51984 21.7821 3.09202C21.5903 2.71569 21.2844 2.40973 20.908 2.21799C20.4802 2 19.9202 2 18.8001 2H8.11806C6.65658 2 5.92584 2 5.33563 2.26743C4.81545 2.50314 4.37335 2.88242 4.06129 3.36072C3.70722 3.90339 3.59611 4.62564 3.37388 6.07012L2.8508 9.47012C2.5577 11.3753 2.41114 12.3279 2.69386 13.0691C2.94199 13.7197 3.4087 14.2637 4.01398 14.6079C4.70358 15 5.66739 15 7.59499 15H8.40005C8.96011 15 9.24013 15 9.45404 15.109C9.64221 15.2049 9.79519 15.3578 9.89106 15.546C10.0001 15.7599 10.0001 16.0399 10.0001 16.6V19.5342C10.0001 20.896 11.104 22 12.4659 22C12.7907 22 13.0851 21.8087 13.217 21.5119L16.5778 13.9502C16.7306 13.6062 16.807 13.4343 16.9278 13.3082C17.0346 13.1967 17.1658 13.1115 17.311 13.0592C17.4753 13 17.6635 13 18.0398 13H18.8001C19.9202 13 20.4802 13 20.908 12.782C21.2844 12.5903 21.5903 12.2843 21.7821 11.908C22.0001 11.4802 22.0001 10.9201 22.0001 9.8Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), qe = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M7 22V11M2 13V20C2 21.1046 2.89543 22 4 22H17.4262C18.907 22 20.1662 20.9197 20.3914 19.4562L21.4683 12.4562C21.7479 10.6389 20.3418 9 18.5032 9H15C14.4477 9 14 8.55228 14 8V4.46584C14 3.10399 12.896 2 11.5342 2C11.2093 2 10.915 2.1913 10.7831 2.48812L7.26394 10.4061C7.10344 10.7673 6.74532 11 6.35013 11H4C2.89543 11 2 11.8954 2 13Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Je = /* @__PURE__ */ k({
	AlertCircle: () => Se,
	AlertHexagon: () => we,
	AlertOctagon: () => Te,
	AlertSquare: () => Ee,
	AlertTriangle: () => Ce,
	Announcement01: () => De,
	Announcement02: () => Oe,
	Announcement03: () => ke,
	Bell01: () => Ae,
	Bell02: () => je,
	Bell03: () => Me,
	Bell04: () => Ne,
	BellMinus: () => Pe,
	BellOff01: () => Fe,
	BellOff02: () => Ie,
	BellOff03: () => Le,
	BellPlus: () => Re,
	BellRinging01: () => ze,
	BellRinging02: () => Be,
	BellRinging03: () => Ve,
	BellRinging04: () => He,
	MessageNotificationSquare: () => Ue,
	NotificationBox: () => We,
	NotificationText: () => Ge,
	ThumbsDown: () => Ke,
	ThumbsUp: () => qe
}), Ye = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M3.33789 7C5.06694 4.01099 8.29866 2 12.0001 2C17.5229 2 22.0001 6.47715 22.0001 12C22.0001 17.5228 17.5229 22 12.0001 22C8.29866 22 5.06694 19.989 3.33789 17M12 16L16 12M16 12L12 8M16 12H2",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Xe = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M3 9H16.5C18.9853 9 21 11.0147 21 13.5C21 15.9853 18.9853 18 16.5 18H12M3 9L7 5M3 9L7 13",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ze = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M21 10C21 10 18.995 7.26822 17.3662 5.63824C15.7373 4.00827 13.4864 3 11 3C6.02944 3 2 7.02944 2 12C2 16.9706 6.02944 21 11 21C15.1031 21 18.5649 18.2543 19.6482 14.5M21 10V4M21 10H15",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Qe = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 5V19M12 19L19 12M12 19L5 12",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), $e = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 19V5M12 5L5 12M12 5L19 12",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), et = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M4 12H20M20 12L14 6M20 12L14 18",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), tt = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M20 12H4M4 12L10 18M4 12L10 6",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), nt = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M6 9L12 15L18 9",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), rt = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M15 18L9 12L15 6",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), it = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9 18L15 12L9 6",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), at = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M18 15L12 9L6 15",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ot = /* @__PURE__ */ k({
	ArrowCircleBrokenRight: () => Ye,
	ArrowDown: () => Qe,
	ArrowNarrowLeft: () => tt,
	ArrowNarrowRight: () => et,
	ArrowUp: () => $e,
	ChevronDown: () => nt,
	ChevronLeft: () => rt,
	ChevronRight: () => it,
	ChevronUp: () => at,
	FlipBackward: () => Xe,
	RefreshCW01: () => Ze
}), st = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M20 20V13M12 20V10M4 20L4 16M13.4067 5.0275L18.5751 6.96567M10.7988 5.40092L5.20023 9.59983M21.0607 6.43934C21.6464 7.02513 21.6464 7.97487 21.0607 8.56066C20.4749 9.14645 19.5251 9.14645 18.9393 8.56066C18.3536 7.97487 18.3536 7.02513 18.9393 6.43934C19.5251 5.85355 20.4749 5.85355 21.0607 6.43934ZM5.06066 9.43934C5.64645 10.0251 5.64645 10.9749 5.06066 11.5607C4.47487 12.1464 3.52513 12.1464 2.93934 11.5607C2.35355 10.9749 2.35355 10.0251 2.93934 9.43934C3.52513 8.85355 4.47487 8.85355 5.06066 9.43934ZM13.0607 3.43934C13.6464 4.02513 13.6464 4.97487 13.0607 5.56066C12.4749 6.14645 11.5251 6.14645 10.9393 5.56066C10.3536 4.97487 10.3536 4.02513 10.9393 3.43934C11.5251 2.85355 12.4749 2.85355 13.0607 3.43934Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ct = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M18 20V10M12 20V4M6 20V14",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), lt = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M18 20V4M6 20V16M12 20V10",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ut = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M6 20V4M18 20V16M12 20V10",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), dt = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M3 11L3 21M15 11L15 21M9 3L9 21M21 3V21",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ft = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M3 17V21M15 8V21M9 13V21M21 3V21",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), pt = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9 8V21M21 17V21M3 3V21M15 13V21",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), mt = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M21 21H6.2C5.07989 21 4.51984 21 4.09202 20.782C3.71569 20.5903 3.40973 20.2843 3.21799 19.908C3 19.4802 3 18.9201 3 17.8V3M7 10.5V17.5M11.5 5.5V17.5M16 10.5V17.5M20.5 5.5V17.5",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ht = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M21 21H6.2C5.07989 21 4.51984 21 4.09202 20.782C3.71569 20.5903 3.40973 20.2843 3.21799 19.908C3 19.4802 3 18.9201 3 17.8V3M7 14.5V17.5M11.5 11.5V17.5M16 8.5V17.5M20.5 5.5V17.5",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), gt = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M21 21H6.2C5.07989 21 4.51984 21 4.09202 20.782C3.71569 20.5903 3.40973 20.2843 3.21799 19.908C3 19.4802 3 18.9201 3 17.8V3M7 5.5V17.5M11.5 8.5V17.5M16 11.5V17.5M20.5 14.5V17.5",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), _t = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9 7H4.6C4.03995 7 3.75992 7 3.54601 7.10899C3.35785 7.20487 3.20487 7.35785 3.10899 7.54601C3 7.75992 3 8.03995 3 8.6V19.4C3 19.9601 3 20.2401 3.10899 20.454C3.20487 20.6422 3.35785 20.7951 3.54601 20.891C3.75992 21 4.03995 21 4.6 21H9M9 21H15M9 21L9 4.6C9 4.03995 9 3.75992 9.10899 3.54601C9.20487 3.35785 9.35785 3.20487 9.54601 3.10899C9.75992 3 10.0399 3 10.6 3L13.4 3C13.9601 3 14.2401 3 14.454 3.10899C14.6422 3.20487 14.7951 3.35785 14.891 3.54601C15 3.75992 15 4.03995 15 4.6V21M15 11H19.4C19.9601 11 20.2401 11 20.454 11.109C20.6422 11.2049 20.7951 11.3578 20.891 11.546C21 11.7599 21 12.0399 21 12.6V19.4C21 19.9601 21 20.2401 20.891 20.454C20.7951 20.6422 20.6422 20.7951 20.454 20.891C20.2401 21 19.9601 21 19.4 21H15",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), vt = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9 21H4.6C4.03995 21 3.75992 21 3.54601 20.891C3.35785 20.7951 3.20487 20.6422 3.10899 20.454C3 20.2401 3 19.9601 3 19.4V4.6C3 4.03995 3 3.75992 3.10899 3.54601C3.20487 3.35785 3.35785 3.20487 3.54601 3.10899C3.75992 3 4.03995 3 4.6 3H7.4C7.96005 3 8.24008 3 8.45399 3.10899C8.64215 3.20487 8.79513 3.35785 8.89101 3.54601C9 3.75992 9 4.03995 9 4.6V7M9 21H15M9 21L9 7M9 7H13.4C13.9601 7 14.2401 7 14.454 7.10899C14.6422 7.20487 14.7951 7.35785 14.891 7.54601C15 7.75992 15 8.03995 15 8.6V21M15 11H19.4C19.9601 11 20.2401 11 20.454 11.109C20.6422 11.2049 20.7951 11.3578 20.891 11.546C21 11.7599 21 12.0399 21 12.6V19.4C21 19.9601 21 20.2401 20.891 20.454C20.7951 20.6422 20.6422 20.7951 20.454 20.891C20.2401 21 19.9601 21 19.4 21H15",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), yt = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9 12H4.6C4.03995 12 3.75992 12 3.54601 12.109C3.35785 12.2049 3.20487 12.3578 3.10899 12.546C3 12.7599 3 13.0399 3 13.6V19.4C3 19.9601 3 20.2401 3.10899 20.454C3.20487 20.6422 3.35785 20.7951 3.54601 20.891C3.75992 21 4.03995 21 4.6 21H9M9 21H15M9 21L9 8.6C9 8.03995 9 7.75992 9.10899 7.54601C9.20487 7.35785 9.35785 7.20487 9.54601 7.10899C9.75992 7 10.0399 7 10.6 7H13.4C13.9601 7 14.2401 7 14.454 7.10899C14.6422 7.20487 14.7951 7.35785 14.891 7.54601C15 7.75992 15 8.03995 15 8.6V21M15 21H19.4C19.9601 21 20.2401 21 20.454 20.891C20.6422 20.7951 20.7951 20.6422 20.891 20.454C21 20.2401 21 19.9601 21 19.4V4.6C21 4.03995 21 3.75992 20.891 3.54601C20.7951 3.35785 20.6422 3.20487 20.454 3.10899C20.2401 3 19.9601 3 19.4 3H16.6C16.0399 3 15.7599 3 15.546 3.10899C15.3578 3.20487 15.2049 3.35785 15.109 3.54601C15 3.75992 15 4.03995 15 4.6V8",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), bt = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M8 13V17M16 11V17M12 7V17M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), xt = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M8 15V17M12 11V17M16 7V17M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), St = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M8 7V17M12 11V17M16 15V17M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ct = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M8 13V17M16 11V17M12 7V17M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), wt = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M17 9.5V12.9C17 13.4601 17 13.7401 16.891 13.954C16.7951 14.1422 16.6422 14.2951 16.454 14.391C16.2401 14.5 15.9601 14.5 15.4 14.5L3 14.5M13 14.5V17.9C13 18.4601 13 18.7401 12.891 18.954C12.7951 19.1422 12.6422 19.2951 12.454 19.391C12.2401 19.5 11.9601 19.5 11.4 19.5H3M3 2L3 22M3 9.5L19.4 9.5C19.9601 9.5 20.2401 9.5 20.454 9.39101C20.6422 9.29513 20.7951 9.14215 20.891 8.95399C21 8.74008 21 8.46005 21 7.9V6.1C21 5.53995 21 5.25992 20.891 5.04601C20.7951 4.85785 20.6422 4.70487 20.454 4.60899C20.2401 4.5 19.9601 4.5 19.4 4.5L3 4.5L3 9.5Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Tt = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M13 9.5V6.1C13 5.53995 13 5.25992 12.891 5.04601C12.7951 4.85785 12.6422 4.70487 12.454 4.60899C12.2401 4.5 11.9601 4.5 11.4 4.5H3M17 14.5V11.1C17 10.5399 17 10.2599 16.891 10.046C16.7951 9.85785 16.6422 9.70487 16.454 9.60899C16.2401 9.5 15.9601 9.5 15.4 9.5H3M3 2L3 22M3 19.5H19.4C19.9601 19.5 20.2401 19.5 20.454 19.391C20.6422 19.2951 20.7951 19.1422 20.891 18.954C21 18.7401 21 18.4601 21 17.9V16.1C21 15.5399 21 15.2599 20.891 15.046C20.7951 14.8578 20.6422 14.7049 20.454 14.609C20.2401 14.5 19.9601 14.5 19.4 14.5L3 14.5L3 19.5Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Et = (e) => /* @__PURE__ */ a("svg", {
	width: 22,
	height: 22,
	viewBox: "0 0 22 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M7 14V16M11 10V16M15 6V16M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Dt = (e) => /* @__PURE__ */ a("svg", {
	width: 22,
	height: 22,
	viewBox: "0 0 22 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M7 6V16M11 10V16M15 14V16M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ot = (e) => /* @__PURE__ */ a("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M6 11V15M14 9V15M10 5V15M5.8 19H14.2C15.8802 19 16.7202 19 17.362 18.673C17.9265 18.3854 18.3854 17.9265 18.673 17.362C19 16.7202 19 15.8802 19 14.2V5.8C19 4.11984 19 3.27976 18.673 2.63803C18.3854 2.07354 17.9265 1.6146 17.362 1.32698C16.7202 1 15.8802 1 14.2 1H5.8C4.11984 1 3.27976 1 2.63803 1.32698C2.07354 1.6146 1.6146 2.07354 1.32698 2.63803C1 3.27976 1 4.11984 1 5.8V14.2C1 15.8802 1 16.7202 1.32698 17.362C1.6146 17.9265 2.07354 18.3854 2.63803 18.673C3.27976 19 4.11984 19 5.8 19Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), kt = (e) => /* @__PURE__ */ a("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M6 13V15M10 9V15M14 5V15M5.8 19H14.2C15.8802 19 16.7202 19 17.362 18.673C17.9265 18.3854 18.3854 17.9265 18.673 17.362C19 16.7202 19 15.8802 19 14.2V5.8C19 4.11984 19 3.27976 18.673 2.63803C18.3854 2.07354 17.9265 1.6146 17.362 1.32698C16.7202 1 15.8802 1 14.2 1H5.8C4.11984 1 3.27976 1 2.63803 1.32698C2.07354 1.6146 1.6146 2.07354 1.32698 2.63803C1 3.27976 1 4.11984 1 5.8V14.2C1 15.8802 1 16.7202 1.32698 17.362C1.6146 17.9265 2.07354 18.3854 2.63803 18.673C3.27976 19 4.11984 19 5.8 19Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), At = (e) => /* @__PURE__ */ a("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M6 5V15M10 9V15M14 13V15M5.8 19H14.2C15.8802 19 16.7202 19 17.362 18.673C17.9265 18.3854 18.3854 17.9265 18.673 17.362C19 16.7202 19 15.8802 19 14.2V5.8C19 4.11984 19 3.27976 18.673 2.63803C18.3854 2.07354 17.9265 1.6146 17.362 1.32698C16.7202 1 15.8802 1 14.2 1H5.8C4.11984 1 3.27976 1 2.63803 1.32698C2.07354 1.6146 1.6146 2.07354 1.32698 2.63803C1 3.27976 1 4.11984 1 5.8V14.2C1 15.8802 1 16.7202 1.32698 17.362C1.6146 17.9265 2.07354 18.3854 2.63803 18.673C3.27976 19 4.11984 19 5.8 19Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), jt = (e) => /* @__PURE__ */ a("svg", {
	width: 21,
	height: 21,
	viewBox: "0 0 21 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M11 2H15.2C16.8802 2 17.7202 2 18.362 2.32698C18.9265 2.6146 19.3854 3.07354 19.673 3.63803C20 4.27976 20 5.11984 20 6.8V15.2C20 16.8802 20 17.7202 19.673 18.362C19.3854 18.9265 18.9265 19.3854 18.362 19.673C17.7202 20 16.8802 20 15.2 20H6.8C5.11984 20 4.27976 20 3.63803 19.673C3.07354 19.3854 2.6146 18.9265 2.32698 18.362C2 17.7202 2 16.8802 2 15.2V11M7 12V16M15 10V16M11 6V16M1 4L4 7M4 7L7 4M4 7L4 1",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Mt = (e) => /* @__PURE__ */ a("svg", {
	width: 21,
	height: 20,
	viewBox: "0 0 21 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M11 1H15.2C16.8802 1 17.7202 1 18.362 1.32698C18.9265 1.6146 19.3854 2.07354 19.673 2.63803C20 3.27976 20 4.11984 20 5.8V14.2C20 15.8802 20 16.7202 19.673 17.362C19.3854 17.9265 18.9265 18.3854 18.362 18.673C17.7202 19 16.8802 19 15.2 19H6.8C5.11984 19 4.27976 19 3.63803 18.673C3.07354 18.3854 2.6146 17.9265 2.32698 17.362C2 16.7202 2 15.8802 2 14.2V10M7 11V15M15 9V15M11 5V15M1 3H7",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Nt = (e) => /* @__PURE__ */ a("svg", {
	width: 21,
	height: 21,
	viewBox: "0 0 21 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M11 2H15.2C16.8802 2 17.7202 2 18.362 2.32698C18.9265 2.6146 19.3854 3.07354 19.673 3.63803C20 4.27976 20 5.11984 20 6.8V15.2C20 16.8802 20 17.7202 19.673 18.362C19.3854 18.9265 18.9265 19.3854 18.362 19.673C17.7202 20 16.8802 20 15.2 20H6.8C5.11984 20 4.27976 20 3.63803 19.673C3.07354 19.3854 2.6146 18.9265 2.32698 18.362C2 17.7202 2 16.8802 2 15.2V11M7 12V16M15 10V16M11 6V16M4 7V1M1 4H7",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Pt = (e) => /* @__PURE__ */ a("svg", {
	width: 21,
	height: 21,
	viewBox: "0 0 21 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M11 2H15.2C16.8802 2 17.7202 2 18.362 2.32698C18.9265 2.6146 19.3854 3.07354 19.673 3.63803C20 4.27976 20 5.11984 20 6.8V15.2C20 16.8802 20 17.7202 19.673 18.362C19.3854 18.9265 18.9265 19.3854 18.362 19.673C17.7202 20 16.8802 20 15.2 20H6.8C5.11984 20 4.27976 20 3.63803 19.673C3.07354 19.3854 2.6146 18.9265 2.32698 18.362C2 17.7202 2 16.8802 2 15.2V11M7 12V16M15 10V16M11 6V16M1 4L4 1M4 1L7 4M4 1L4 7",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ft = (e) => /* @__PURE__ */ a("svg", {
	width: 22,
	height: 19,
	viewBox: "0 0 22 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M19 18V11M11 18V8M3 18L3 14M12.4067 3.0275L17.5751 4.96567M9.79877 3.40092L4.20023 7.59983M20.0607 4.43934C20.6464 5.02513 20.6464 5.97487 20.0607 6.56066C19.4749 7.14645 18.5251 7.14645 17.9393 6.56066C17.3536 5.97487 17.3536 5.02513 17.9393 4.43934C18.5251 3.85355 19.4749 3.85355 20.0607 4.43934ZM4.06066 7.43934C4.64645 8.02513 4.64645 8.97487 4.06066 9.56066C3.47487 10.1464 2.52513 10.1464 1.93934 9.56066C1.35355 8.97487 1.35355 8.02513 1.93934 7.43934C2.52513 6.85355 3.47487 6.85355 4.06066 7.43934ZM12.0607 1.43934C12.6464 2.02513 12.6464 2.97487 12.0607 3.56066C11.4749 4.14645 10.5251 4.14645 9.93934 3.56066C9.35355 2.97487 9.35355 2.02513 9.93934 1.43934C10.5251 0.853553 11.4749 0.853553 12.0607 1.43934Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), It = (e) => /* @__PURE__ */ a("svg", {
	width: 23,
	height: 22,
	viewBox: "0 0 23 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M14.5 2.5V1M18.4393 3.56066L19.5 2.5M19.5103 7.5H21.0103M20.9506 12C20.4489 17.0533 16.1853 21 11 21C5.47715 21 1 16.5228 1 11C1 5.81465 4.94668 1.5511 10 1.04938M11 7H15V11M14.6197 7C12.2653 10.3276 8.38636 12.5 4 12.5C2.9971 12.5 2.02072 12.3864 1.08302 12.1715",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Lt = (e) => /* @__PURE__ */ a("svg", {
	width: 22,
	height: 21,
	viewBox: "0 0 22 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9 2H5.8C4.11984 2 3.27976 2 2.63803 2.32698C2.07354 2.6146 1.6146 3.07354 1.32698 3.63803C1 4.27976 1 5.11984 1 6.8V15.2C1 16.8802 1 17.7202 1.32698 18.362C1.6146 18.9265 2.07354 19.3854 2.63803 19.673C3.27976 20 4.11984 20 5.8 20H14.2C15.8802 20 16.7202 20 17.362 19.673C17.9265 19.3854 18.3854 18.9265 18.673 18.362C19 17.7202 19 16.8802 19 15.2V12M10 7H14V11M13.5 2.5V1M17.4393 3.56066L18.5 2.5M18.5103 7.5H20.0103M1 12.3471C1.65194 12.4478 2.31987 12.5 3 12.5C7.38636 12.5 11.2653 10.3276 13.6197 7",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Rt = (e) => /* @__PURE__ */ a("svg", {
	width: 20,
	height: 22,
	viewBox: "0 0 20 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M15 8.5V5.1C15 4.53995 15 4.25992 14.891 4.04601C14.7951 3.85785 14.6422 3.70487 14.454 3.60899C14.2401 3.5 13.9601 3.5 13.4 3.5H1M11 13.5V16.9C11 17.4601 11 17.7401 10.891 17.954C10.7951 18.1422 10.6422 18.2951 10.454 18.391C10.2401 18.5 9.96005 18.5 9.4 18.5H1M1 1L1 21M1 13.5L17.4 13.5C17.9601 13.5 18.2401 13.5 18.454 13.391C18.6422 13.2951 18.7951 13.1422 18.891 12.954C19 12.7401 19 12.4601 19 11.9V10.1C19 9.53995 19 9.25992 18.891 9.04601C18.7951 8.85785 18.6422 8.70487 18.454 8.60899C18.2401 8.5 17.9601 8.5 17.4 8.5L1 8.5L1 13.5Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), zt = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M21 21H4.6C4.03995 21 3.75992 21 3.54601 20.891C3.35785 20.7951 3.20487 20.6422 3.10899 20.454C3 20.2401 3 19.9601 3 19.4V3M20 15L16.0811 10.8173C15.9326 10.6588 15.8584 10.5796 15.7688 10.5386C15.6897 10.5024 15.6026 10.4875 15.516 10.4953C15.4179 10.5042 15.3215 10.5542 15.1287 10.6543L11.8713 12.3457C11.6785 12.4458 11.5821 12.4958 11.484 12.5047C11.3974 12.5125 11.3103 12.4976 11.2312 12.4614C11.1416 12.4204 11.0674 12.3412 10.9189 12.1827L7 8",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Bt = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M21 21H4.6C4.03995 21 3.75992 21 3.54601 20.891C3.35785 20.7951 3.20487 20.6422 3.10899 20.454C3 20.2401 3 19.9601 3 19.4V3M21 15L15.5657 9.56569C15.3677 9.36768 15.2687 9.26867 15.1545 9.23158C15.0541 9.19895 14.9459 9.19895 14.8455 9.23158C14.7313 9.26867 14.6323 9.36768 14.4343 9.56569L12.5657 11.4343C12.3677 11.6323 12.2687 11.7313 12.1545 11.7684C12.0541 11.8011 11.9459 11.8011 11.8455 11.7684C11.7313 11.7313 11.6323 11.6323 11.4343 11.4343L7 7M21 15H17M21 15V11",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Vt = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M17 15L11.5657 9.56569C11.3677 9.36768 11.2687 9.26867 11.1545 9.23158C11.0541 9.19895 10.9459 9.19895 10.8455 9.23158C10.7313 9.26867 10.6323 9.36768 10.4343 9.56569L8.56569 11.4343C8.36768 11.6323 8.26867 11.7313 8.15451 11.7684C8.05409 11.8011 7.94591 11.8011 7.84549 11.7684C7.73133 11.7313 7.63232 11.6323 7.43431 11.4343L3 7M17 15H13M17 15V11M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ht = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M3 9L9.65533 13.7538C9.85422 13.8959 10.1267 13.8733 10.2995 13.7005L13.7005 10.2995C13.8733 10.1267 14.1458 10.1041 14.3447 10.2462L21 15M6 21H18C19.6569 21 21 19.6569 21 18V6C21 4.34315 19.6569 3 18 3H6C4.34315 3 3 4.34315 3 6V18C3 19.6569 4.34315 21 6 21Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ut = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M6 10L9.43431 13.4343C9.63232 13.6323 9.73133 13.7313 9.84549 13.7684C9.94591 13.8011 10.0541 13.8011 10.1545 13.7684C10.2687 13.7313 10.3677 13.6323 10.5657 13.4343L13.4343 10.5657C13.6323 10.3677 13.7313 10.2687 13.8455 10.2316C13.9459 10.1989 14.0541 10.1989 14.1545 10.2316C14.2687 10.2687 14.3677 10.3677 14.5657 10.5657L18 14M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Wt = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M21 21H4.6C4.03995 21 3.75992 21 3.54601 20.891C3.35785 20.7951 3.20487 20.6422 3.10899 20.454C3 20.2401 3 19.9601 3 19.4V3M20 8L16.0811 12.1827C15.9326 12.3412 15.8584 12.4204 15.7688 12.4614C15.6897 12.4976 15.6026 12.5125 15.516 12.5047C15.4179 12.4958 15.3215 12.4458 15.1287 12.3457L11.8713 10.6543C11.6785 10.5542 11.5821 10.5042 11.484 10.4953C11.3974 10.4875 11.3103 10.5024 11.2312 10.5386C11.1416 10.5796 11.0674 10.6588 10.9189 10.8173L7 15",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Gt = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M21 21H4.6C4.03995 21 3.75992 21 3.54601 20.891C3.35785 20.7951 3.20487 20.6422 3.10899 20.454C3 20.2401 3 19.9601 3 19.4V3M21 7L15.5657 12.4343C15.3677 12.6323 15.2687 12.7313 15.1545 12.7684C15.0541 12.8011 14.9459 12.8011 14.8455 12.7684C14.7313 12.7313 14.6323 12.6323 14.4343 12.4343L12.5657 10.5657C12.3677 10.3677 12.2687 10.2687 12.1545 10.2316C12.0541 10.1989 11.9459 10.1989 11.8455 10.2316C11.7313 10.2687 11.6323 10.3677 11.4343 10.5657L7 15M21 7H17M21 7V11",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Kt = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M17 9L11.5657 14.4343C11.3677 14.6323 11.2687 14.7313 11.1545 14.7684C11.0541 14.8011 10.9459 14.8011 10.8455 14.7684C10.7313 14.7313 10.6323 14.6323 10.4343 14.4343L8.56569 12.5657C8.36768 12.3677 8.26867 12.2687 8.15451 12.2316C8.05409 12.1989 7.94591 12.1989 7.84549 12.2316C7.73133 12.2687 7.63232 12.3677 7.43431 12.5657L3 17M17 9H13M17 9V13M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), qt = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M21 9L14.5515 13.6061C14.3555 13.746 14.2576 13.816 14.1527 13.8371C14.0602 13.8557 13.9643 13.8478 13.8762 13.8142C13.7762 13.7762 13.691 13.691 13.5208 13.5208L10.4792 10.4792C10.309 10.309 10.2238 10.2238 10.1238 10.1858C10.0357 10.1522 9.9398 10.1443 9.84732 10.1629C9.74241 10.184 9.64445 10.254 9.44853 10.3939L3 15M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Jt = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M18 10L14.5657 13.4343C14.3677 13.6323 14.2687 13.7313 14.1545 13.7684C14.0541 13.8011 13.9459 13.8011 13.8455 13.7684C13.7313 13.7313 13.6323 13.6323 13.4343 13.4343L10.5657 10.5657C10.3677 10.3677 10.2687 10.2687 10.1545 10.2316C10.0541 10.1989 9.94591 10.1989 9.84549 10.2316C9.73133 10.2687 9.63232 10.3677 9.43431 10.5657L6 14M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Yt = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M21.2104 15.8899C20.5742 17.3944 19.5792 18.7202 18.3123 19.7512C17.0454 20.7823 15.5452 21.4874 13.9428 21.8047C12.3405 22.1221 10.6848 22.0421 9.12055 21.5717C7.55627 21.1014 6.13103 20.255 4.96942 19.1066C3.80782 17.9582 2.94522 16.5427 2.45704 14.9839C1.96886 13.4251 1.86996 11.7704 2.169 10.1646C2.46804 8.55873 3.1559 7.05058 4.17245 5.77198C5.189 4.49338 6.50329 3.48327 8.0004 2.82995M21.2392 8.17311C21.6395 9.13958 21.8851 10.1613 21.9684 11.2008C21.989 11.4576 21.9993 11.586 21.9483 11.7017C21.9057 11.7983 21.8213 11.8897 21.7284 11.9399C21.6172 11.9999 21.4783 11.9999 21.2004 11.9999H12.8004C12.5204 11.9999 12.3804 11.9999 12.2734 11.9455C12.1793 11.8975 12.1028 11.821 12.0549 11.7269C12.0004 11.62 12.0004 11.48 12.0004 11.1999V2.79995C12.0004 2.52208 12.0004 2.38315 12.0605 2.27193C12.1107 2.17903 12.2021 2.09464 12.2987 2.05204C12.4144 2.00105 12.5428 2.01134 12.7996 2.03193C13.839 2.11527 14.8608 2.36083 15.8272 2.76115C17.0405 3.2637 18.1429 4.00029 19.0715 4.92888C20.0001 5.85747 20.7367 6.95986 21.2392 8.17311Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Xt = (e) => /* @__PURE__ */ o("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ a("path", {
		d: "M17.2 14C17.477 14 17.6155 14 17.7278 14.0615C17.8204 14.1122 17.9065 14.2075 17.9478 14.3047C17.9978 14.4225 17.9852 14.5479 17.96 14.7987C17.8296 16.0987 17.3822 17.3514 16.6518 18.4445C15.7727 19.7601 14.5233 20.7855 13.0615 21.391C11.5997 21.9965 9.99113 22.155 8.43928 21.8463C6.88743 21.5376 5.46197 20.7757 4.34315 19.6568C3.22433 18.538 2.4624 17.1126 2.15372 15.5607C1.84504 14.0089 2.00347 12.4003 2.60897 10.9385C3.21447 9.47671 4.23985 8.22728 5.55544 7.34823C6.64856 6.61783 7.90125 6.17039 9.20131 6.03995C9.45207 6.01479 9.57745 6.00221 9.69528 6.0522C9.79249 6.09344 9.88776 6.17964 9.9385 6.27224C10 6.38449 10 6.52299 10 6.79999V13.2C10 13.48 10 13.62 10.0545 13.727C10.1024 13.8211 10.1789 13.8976 10.273 13.9455C10.38 14 10.52 14 10.8 14H17.2Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ a("path", {
		d: "M14 2.79999C14 2.52298 14 2.38448 14.0615 2.27223C14.1122 2.17963 14.2075 2.09344 14.3047 2.0522C14.4225 2.0022 14.5479 2.01478 14.7987 2.03993C16.6271 2.22333 18.346 3.03229 19.6569 4.34313C20.9677 5.65398 21.7767 7.37289 21.9601 9.20129C21.9852 9.45206 21.9978 9.57744 21.9478 9.69527C21.9066 9.79248 21.8204 9.88774 21.7278 9.93848C21.6155 9.99998 21.477 9.99999 21.2 9.99999L14.8 9.99999C14.52 9.99999 14.38 9.99999 14.273 9.94549C14.1789 9.89755 14.1024 9.82106 14.0545 9.72698C14 9.62003 14 9.48001 14 9.19999V2.79999Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
}), Zt = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 2C13.3132 2 14.6136 2.25866 15.8268 2.76121C17.0401 3.26375 18.1425 4.00035 19.0711 4.92893C19.9997 5.85752 20.7363 6.95991 21.2388 8.17317C21.7413 9.38643 22 10.6868 22 12M12 2V12M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5229 22 12M12 2C17.5228 2 22 6.47716 22 12M22 12L12 12M22 12C22 13.5781 21.6265 15.1338 20.9101 16.5399C20.1936 17.946 19.1546 19.1626 17.8779 20.0902L12 12",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Qt = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 12L2.33178 9.44554C1.70974 11.7999 1.96813 14.3002 3.05847 16.4776C4.14881 18.6549 5.99616 20.3596 8.25395 21.2718L12 12ZM12 12L12.1047 2.00055C9.88558 1.97731 7.72174 2.69293 5.95402 4.0347C4.1863 5.37647 2.91514 7.26815 2.34075 9.41181L12 12ZM22 12C22 17.5228 17.5229 22 12 22C6.47716 22 2.00001 17.5228 2.00001 12C2.00001 6.47715 6.47716 2 12 2C17.5229 2 22 6.47715 22 12Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), $t = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 16V21M12 16L18 21M12 16L6 21M21 3V11.2C21 12.8802 21 13.7202 20.673 14.362C20.3854 14.9265 19.9265 15.3854 19.362 15.673C18.7202 16 17.8802 16 16.2 16H7.8C6.11984 16 5.27976 16 4.63803 15.673C4.07354 15.3854 3.6146 14.9265 3.32698 14.362C3 13.7202 3 12.8802 3 11.2V3M8 9V12M12 7V12M16 11V12M22 3H2",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), en = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 16V21M18 21L14.0486 17.7072C13.3198 17.0998 12.9554 16.7962 12.5487 16.6801C12.19 16.5778 11.81 16.5778 11.4513 16.6801C11.0446 16.7962 10.6802 17.0998 9.95141 17.7072L6 21M8 11V12M12 9V12M16 7V12M22 3H2M3 3H21V11.2C21 12.8802 21 13.7202 20.673 14.362C20.3854 14.9265 19.9265 15.3854 19.362 15.673C18.7202 16 17.8802 16 16.2 16H7.8C6.11984 16 5.27976 16 4.63803 15.673C4.07354 15.3854 3.6146 14.9265 3.32698 14.362C3 13.7202 3 12.8802 3 11.2V3Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), tn = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 16V21M12 16L18 21M12 16L6 21M8 7V12M12 9V12M16 11V12M22 3H2M3 3H21V11.2C21 12.8802 21 13.7202 20.673 14.362C20.3854 14.9265 19.9265 15.3854 19.362 15.673C18.7202 16 17.8802 16 16.2 16H7.8C6.11984 16 5.27976 16 4.63803 15.673C4.07354 15.3854 3.6146 14.9265 3.32698 14.362C3 13.7202 3 12.8802 3 11.2V3Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), nn = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M22 17L14.1314 9.13137C13.7354 8.73535 13.5373 8.53735 13.309 8.46316C13.1082 8.3979 12.8918 8.3979 12.691 8.46316C12.4627 8.53735 12.2646 8.73535 11.8686 9.13137L9.13137 11.8686C8.73535 12.2646 8.53735 12.4627 8.30902 12.5368C8.10817 12.6021 7.89183 12.6021 7.69098 12.5368C7.46265 12.4627 7.26465 12.2646 6.86863 11.8686L2 7M22 17H15M22 17V10",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), rn = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M7 7L17 17M17 17V7M17 17H7",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), an = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M22 7L14.1314 14.8686C13.7354 15.2646 13.5373 15.4627 13.309 15.5368C13.1082 15.6021 12.8918 15.6021 12.691 15.5368C12.4627 15.4627 12.2646 15.2646 11.8686 14.8686L9.13137 12.1314C8.73535 11.7354 8.53735 11.5373 8.30902 11.4632C8.10817 11.3979 7.89183 11.3979 7.69098 11.4632C7.46265 11.5373 7.26465 11.7354 6.86863 12.1314L2 17M22 7H15M22 7V14",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), on = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M7 17L17 7M17 7H7M17 7V17",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), sn = /* @__PURE__ */ k({
	BarChart01: () => ct,
	BarChart02: () => lt,
	BarChart03: () => ut,
	BarChart04: () => dt,
	BarChart05: () => ft,
	BarChart06: () => pt,
	BarChart07: () => mt,
	BarChart08: () => ht,
	BarChart09: () => gt,
	BarChart10: () => _t,
	BarChart11: () => vt,
	BarChart12: () => yt,
	BarChartCircle: () => Ct,
	BarChartSquare01: () => bt,
	BarChartSquare02: () => xt,
	BarChartSquare03: () => St,
	BarLineChart: () => st,
	HorizontalBar2: () => wt,
	HorizontalBar3: () => Tt,
	Icon: () => Et,
	Icon1: () => Dt,
	Icon10: () => It,
	Icon11: () => Lt,
	Icon12: () => Rt,
	Icon2: () => Ot,
	Icon3: () => kt,
	Icon4: () => At,
	Icon5: () => jt,
	Icon6: () => Mt,
	Icon7: () => Nt,
	Icon8: () => Pt,
	Icon9: () => Ft,
	LineChartdown01: () => zt,
	LineChartdown02: () => Bt,
	LineChartdown03: () => Vt,
	LineChartdown04: () => Ht,
	LineChartdown05: () => Ut,
	LineChartup01: () => Wt,
	LineChartup02: () => Gt,
	LineChartup03: () => Kt,
	LineChartup04: () => qt,
	LineChartup05: () => Jt,
	PieChart01: () => Yt,
	PieChart02: () => Xt,
	PieChart03: () => Zt,
	PieChart04: () => Qt,
	PresentationChart01: () => $t,
	PresentationChart02: () => en,
	PresentationChart03: () => tn,
	TrendDown01: () => nn,
	TrendDown02: () => rn,
	TrendUp01: () => an,
	TrendUp02: () => on
}), cn = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M3 7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V13.5C21 14.8978 21 15.5967 20.7716 16.1481C20.4672 16.8831 19.8831 17.4672 19.1481 17.7716C18.5967 18 17.8978 18 16.5 18C16.0114 18 15.7671 18 15.5405 18.0535C15.2383 18.1248 14.9569 18.2656 14.7185 18.4645C14.5397 18.6137 14.3931 18.8091 14.1 19.2L12.64 21.1467C12.4229 21.4362 12.3143 21.5809 12.1812 21.6327C12.0647 21.678 11.9353 21.678 11.8188 21.6327C11.6857 21.5809 11.5771 21.4362 11.36 21.1467L9.9 19.2C9.60685 18.8091 9.46028 18.6137 9.2815 18.4645C9.04312 18.2656 8.76169 18.1248 8.45951 18.0535C8.23287 18 7.98858 18 7.5 18C6.10218 18 5.40326 18 4.85195 17.7716C4.11687 17.4672 3.53284 16.8831 3.22836 16.1481C3 15.5967 3 14.8978 3 13.5V7.8Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ln = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 10.5V7M12 14H12.01M9.9 19.2L11.36 21.1467C11.5771 21.4362 11.6857 21.5809 11.8188 21.6327C11.9353 21.678 12.0647 21.678 12.1812 21.6327C12.3143 21.5809 12.4229 21.4362 12.64 21.1467L14.1 19.2C14.3931 18.8091 14.5397 18.6137 14.7185 18.4645C14.9569 18.2656 15.2383 18.1248 15.5405 18.0535C15.7671 18 16.0114 18 16.5 18C17.8978 18 18.5967 18 19.1481 17.7716C19.8831 17.4672 20.4672 16.8831 20.7716 16.1481C21 15.5967 21 14.8978 21 13.5V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V13.5C3 14.8978 3 15.5967 3.22836 16.1481C3.53284 16.8831 4.11687 17.4672 4.85195 17.7716C5.40326 18 6.10218 18 7.5 18C7.98858 18 8.23287 18 8.45951 18.0535C8.76169 18.1248 9.04312 18.2656 9.2815 18.4645C9.46028 18.6137 9.60685 18.8091 9.9 19.2Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), un = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9 11L11 13L15.5 8.5M9.9 19.2L11.36 21.1467C11.5771 21.4362 11.6857 21.5809 11.8188 21.6327C11.9353 21.678 12.0647 21.678 12.1812 21.6327C12.3143 21.5809 12.4229 21.4362 12.64 21.1467L14.1 19.2C14.3931 18.8091 14.5397 18.6137 14.7185 18.4645C14.9569 18.2656 15.2383 18.1248 15.5405 18.0535C15.7671 18 16.0114 18 16.5 18C17.8978 18 18.5967 18 19.1481 17.7716C19.8831 17.4672 20.4672 16.8831 20.7716 16.1481C21 15.5967 21 14.8978 21 13.5V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V13.5C3 14.8978 3 15.5967 3.22836 16.1481C3.53284 16.8831 4.11687 17.4672 4.85195 17.7716C5.40326 18 6.10218 18 7.5 18C7.98858 18 8.23287 18 8.45951 18.0535C8.76169 18.1248 9.04312 18.2656 9.2815 18.4645C9.46028 18.6137 9.60685 18.8091 9.9 19.2Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), dn = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M7.5 10.5H7.51M12 10.5H12.01M16.5 10.5H16.51M9.9 19.2L11.36 21.1467C11.5771 21.4362 11.6857 21.5809 11.8188 21.6327C11.9353 21.678 12.0647 21.678 12.1812 21.6327C12.3143 21.5809 12.4229 21.4362 12.64 21.1467L14.1 19.2C14.3931 18.8091 14.5397 18.6137 14.7185 18.4645C14.9569 18.2656 15.2383 18.1248 15.5405 18.0535C15.7671 18 16.0114 18 16.5 18C17.8978 18 18.5967 18 19.1481 17.7716C19.8831 17.4672 20.4672 16.8831 20.7716 16.1481C21 15.5967 21 14.8978 21 13.5V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V13.5C3 14.8978 3 15.5967 3.22836 16.1481C3.53284 16.8831 4.11687 17.4672 4.85195 17.7716C5.40326 18 6.10218 18 7.5 18C7.98858 18 8.23287 18 8.45951 18.0535C8.76169 18.1248 9.04312 18.2656 9.2815 18.4645C9.46028 18.6137 9.60685 18.8091 9.9 19.2ZM8 10.5C8 10.7761 7.77614 11 7.5 11C7.22386 11 7 10.7761 7 10.5C7 10.2239 7.22386 10 7.5 10C7.77614 10 8 10.2239 8 10.5ZM12.5 10.5C12.5 10.7761 12.2761 11 12 11C11.7239 11 11.5 10.7761 11.5 10.5C11.5 10.2239 11.7239 10 12 10C12.2761 10 12.5 10.2239 12.5 10.5ZM17 10.5C17 10.7761 16.7761 11 16.5 11C16.2239 11 16 10.7761 16 10.5C16 10.2239 16.2239 10 16.5 10C16.7761 10 17 10.2239 17 10.5Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), fn = (e) => /* @__PURE__ */ o("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ a("path", {
		d: "M3 7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V13.5C21 14.8978 21 15.5967 20.7716 16.1481C20.4672 16.8831 19.8831 17.4672 19.1481 17.7716C18.5967 18 17.8978 18 16.5 18C16.0114 18 15.7671 18 15.5405 18.0535C15.2383 18.1248 14.9569 18.2656 14.7185 18.4645C14.5397 18.6137 14.3931 18.8091 14.1 19.2L12.64 21.1467C12.4229 21.4362 12.3143 21.5809 12.1812 21.6327C12.0647 21.678 11.9353 21.678 11.8188 21.6327C11.6857 21.5809 11.5771 21.4362 11.36 21.1467L9.9 19.2C9.60685 18.8091 9.46028 18.6137 9.2815 18.4645C9.04312 18.2656 8.76169 18.1248 8.45951 18.0535C8.23287 18 7.98858 18 7.5 18C6.10218 18 5.40326 18 4.85195 17.7716C4.11687 17.4672 3.53284 16.8831 3.22836 16.1481C3 15.5967 3 14.8978 3 13.5V7.8Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ a("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.9973 8.33059C11.1975 7.4216 9.8639 7.17708 8.86188 8.00945C7.85986 8.84182 7.71879 10.2335 8.50568 11.2179C8.97361 11.8033 10.1197 12.8531 10.9719 13.6079C11.3237 13.9195 11.4996 14.0753 11.7114 14.1385C11.8925 14.1926 12.102 14.1926 12.2832 14.1385C12.4949 14.0753 12.6708 13.9195 13.0226 13.6079C13.8748 12.8531 15.0209 11.8033 15.4888 11.2179C16.2757 10.2335 16.1519 8.83306 15.1326 8.00945C14.1134 7.18584 12.797 7.4216 11.9973 8.33059Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
}), pn = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 14V10.5M12 7H12.01M9.9 19.2L11.36 21.1467C11.5771 21.4362 11.6857 21.5809 11.8188 21.6327C11.9353 21.678 12.0647 21.678 12.1812 21.6327C12.3143 21.5809 12.4229 21.4362 12.64 21.1467L14.1 19.2C14.3931 18.8091 14.5397 18.6137 14.7185 18.4645C14.9569 18.2656 15.2383 18.1248 15.5405 18.0535C15.7671 18 16.0114 18 16.5 18C17.8978 18 18.5967 18 19.1481 17.7716C19.8831 17.4672 20.4672 16.8831 20.7716 16.1481C21 15.5967 21 14.8978 21 13.5V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V13.5C3 14.8978 3 15.5967 3.22836 16.1481C3.53284 16.8831 4.11687 17.4672 4.85195 17.7716C5.40326 18 6.10218 18 7.5 18C7.98858 18 8.23287 18 8.45951 18.0535C8.76169 18.1248 9.04312 18.2656 9.2815 18.4645C9.46028 18.6137 9.60685 18.8091 9.9 19.2Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), mn = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 13.5V7.5M9 10.5H15M9.9 19.2L11.36 21.1467C11.5771 21.4362 11.6857 21.5809 11.8188 21.6327C11.9353 21.678 12.0647 21.678 12.1812 21.6327C12.3143 21.5809 12.4229 21.4362 12.64 21.1467L14.1 19.2C14.3931 18.8091 14.5397 18.6137 14.7185 18.4645C14.9569 18.2656 15.2383 18.1248 15.5405 18.0535C15.7671 18 16.0114 18 16.5 18C17.8978 18 18.5967 18 19.1481 17.7716C19.8831 17.4672 20.4672 16.8831 20.7716 16.1481C21 15.5967 21 14.8978 21 13.5V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V13.5C3 14.8978 3 15.5967 3.22836 16.1481C3.53284 16.8831 4.11687 17.4672 4.85195 17.7716C5.40326 18 6.10218 18 7.5 18C7.98858 18 8.23287 18 8.45951 18.0535C8.76169 18.1248 9.04312 18.2656 9.2815 18.4645C9.46028 18.6137 9.60685 18.8091 9.9 19.2Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), hn = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M10 8.50224C10.1762 8.00136 10.524 7.579 10.9817 7.30998C11.4395 7.04095 11.9777 6.9426 12.501 7.03237C13.0243 7.12213 13.499 7.39421 13.8409 7.80041C14.1829 8.20661 14.37 8.72072 14.3692 9.25168C14.3692 10.7506 12.1209 11.5 12.1209 11.5M12.1499 14.5H12.1599M9.9 19.2L11.36 21.1467C11.5771 21.4362 11.6857 21.5809 11.8188 21.6327C11.9353 21.678 12.0647 21.678 12.1812 21.6327C12.3143 21.5809 12.4229 21.4362 12.64 21.1467L14.1 19.2C14.3931 18.8091 14.5397 18.6137 14.7185 18.4645C14.9569 18.2656 15.2383 18.1248 15.5405 18.0535C15.7671 18 16.0114 18 16.5 18C17.8978 18 18.5967 18 19.1481 17.7716C19.8831 17.4672 20.4672 16.8831 20.7716 16.1481C21 15.5967 21 14.8978 21 13.5V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V13.5C3 14.8978 3 15.5967 3.22836 16.1481C3.53284 16.8831 4.11687 17.4672 4.85195 17.7716C5.40326 18 6.10218 18 7.5 18C7.98858 18 8.23287 18 8.45951 18.0535C8.76169 18.1248 9.04312 18.2656 9.2815 18.4645C9.46028 18.6137 9.60685 18.8091 9.9 19.2Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), gn = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9.5 8L14.5 13M14.5 8L9.5 13M9.9 19.2L11.36 21.1467C11.5771 21.4362 11.6857 21.5809 11.8188 21.6327C11.9353 21.678 12.0647 21.678 12.1812 21.6327C12.3143 21.5809 12.4229 21.4362 12.64 21.1467L14.1 19.2C14.3931 18.8091 14.5397 18.6137 14.7185 18.4645C14.9569 18.2656 15.2383 18.1248 15.5405 18.0535C15.7671 18 16.0114 18 16.5 18C17.8978 18 18.5967 18 19.1481 17.7716C19.8831 17.4672 20.4672 16.8831 20.7716 16.1481C21 15.5967 21 14.8978 21 13.5V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V13.5C3 14.8978 3 15.5967 3.22836 16.1481C3.53284 16.8831 4.11687 17.4672 4.85195 17.7716C5.40326 18 6.10218 18 7.5 18C7.98858 18 8.23287 18 8.45951 18.0535C8.76169 18.1248 9.04312 18.2656 9.2815 18.4645C9.46028 18.6137 9.60685 18.8091 9.9 19.2Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), _n = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M2.5 12H5.88197C6.56717 12 7.19357 12.3871 7.5 13C7.80643 13.6129 8.43283 14 9.11803 14H14.882C15.5672 14 16.1936 13.6129 16.5 13C16.8064 12.3871 17.4328 12 18.118 12H21.5M8.96656 4H15.0334C16.1103 4 16.6487 4 17.1241 4.16396C17.5445 4.30896 17.9274 4.5456 18.2451 4.85675C18.6043 5.2086 18.8451 5.6902 19.3267 6.65337L21.4932 10.9865C21.6822 11.3645 21.7767 11.5535 21.8434 11.7515C21.9026 11.9275 21.9453 12.1085 21.971 12.2923C22 12.4992 22 12.7105 22 13.1331V15.2C22 16.8802 22 17.7202 21.673 18.362C21.3854 18.9265 20.9265 19.3854 20.362 19.673C19.7202 20 18.8802 20 17.2 20H6.8C5.11984 20 4.27976 20 3.63803 19.673C3.07354 19.3854 2.6146 18.9265 2.32698 18.362C2 17.7202 2 16.8802 2 15.2V13.1331C2 12.7105 2 12.4992 2.02897 12.2923C2.05471 12.1085 2.09744 11.9275 2.15662 11.7515C2.22326 11.5535 2.31776 11.3645 2.50675 10.9865L4.67331 6.65337C5.1549 5.69019 5.3957 5.2086 5.75495 4.85675C6.07263 4.5456 6.45551 4.30896 6.87589 4.16396C7.35125 4 7.88969 4 8.96656 4Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), vn = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M2 12H5.88197C6.56717 12 7.19357 12.3871 7.5 13C7.80643 13.6129 8.43283 14 9.11803 14H14.882C15.5672 14 16.1936 13.6129 16.5 13C16.8064 12.3871 17.4328 12 18.118 12H22M2 12V8.8C2 7.11984 2 6.27976 2.32698 5.63803C2.6146 5.07354 3.07354 4.6146 3.63803 4.32698C4.27976 4 5.11984 4 6.8 4H17.2C18.8802 4 19.7202 4 20.362 4.32698C20.9265 4.6146 21.3854 5.07354 21.673 5.63803C22 6.27976 22 7.11984 22 8.8V12M2 12V15.2C2 16.8802 2 17.7202 2.32698 18.362C2.6146 18.9265 3.07354 19.3854 3.63803 19.673C4.27976 20 5.11984 20 6.8 20H17.2C18.8802 20 19.7202 20 20.362 19.673C20.9265 19.3854 21.3854 18.9265 21.673 18.362C22 17.7202 22 16.8802 22 15.2V12",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), yn = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M2 7L10.1649 12.7154C10.8261 13.1783 11.1567 13.4097 11.5163 13.4993C11.8339 13.5785 12.1661 13.5785 12.4837 13.4993C12.8433 13.4097 13.1739 13.1783 13.8351 12.7154L22 7M6.8 20H17.2C18.8802 20 19.7202 20 20.362 19.673C20.9265 19.3854 21.3854 18.9265 21.673 18.362C22 17.7202 22 16.8802 22 15.2V8.8C22 7.11984 22 6.27976 21.673 5.63803C21.3854 5.07354 20.9265 4.6146 20.362 4.32698C19.7202 4 18.8802 4 17.2 4H6.8C5.11984 4 4.27976 4 3.63803 4.32698C3.07354 4.6146 2.6146 5.07354 2.32698 5.63803C2 6.27976 2 7.11984 2 8.8V15.2C2 16.8802 2 17.7202 2.32698 18.362C2.6146 18.9265 3.07354 19.3854 3.63803 19.673C4.27976 20 5.11984 20 6.8 20Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), bn = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M21.5 18L14.8571 12M9.14286 12L2.50003 18M2 7L10.1649 12.7154C10.8261 13.1783 11.1567 13.4097 11.5163 13.4993C11.8339 13.5785 12.1661 13.5785 12.4837 13.4993C12.8433 13.4097 13.1739 13.1783 13.8351 12.7154L22 7M6.8 20H17.2C18.8802 20 19.7202 20 20.362 19.673C20.9265 19.3854 21.3854 18.9265 21.673 18.362C22 17.7202 22 16.8802 22 15.2V8.8C22 7.11984 22 6.27976 21.673 5.63803C21.3854 5.07354 20.9265 4.6146 20.362 4.32698C19.7202 4 18.8802 4 17.2 4H6.8C5.11984 4 4.27976 4 3.63803 4.32698C3.07354 4.6146 2.6146 5.07354 2.32698 5.63803C2 6.27976 2 7.11984 2 8.8V15.2C2 16.8802 2 17.7202 2.32698 18.362C2.6146 18.9265 3.07354 19.3854 3.63803 19.673C4.27976 20 5.11984 20 6.8 20Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), xn = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M2 7L7.19384 10.4626C7.49349 10.6623 7.64331 10.7622 7.8054 10.833C7.94927 10.8958 8.10003 10.9414 8.25458 10.969C8.42869 11 8.60876 11 8.96888 11H15.0311C15.3912 11 15.5713 11 15.7454 10.969C15.9 10.9414 16.0507 10.8958 16.1946 10.833C16.3567 10.7622 16.5065 10.6623 16.8062 10.4626L22 7M6.8 20H17.2C18.8802 20 19.7202 20 20.362 19.673C20.9265 19.3854 21.3854 18.9265 21.673 18.362C22 17.7202 22 16.8802 22 15.2V8.8C22 7.11984 22 6.27976 21.673 5.63803C21.3854 5.07354 20.9265 4.6146 20.362 4.32698C19.7202 4 18.8802 4 17.2 4H6.8C5.11984 4 4.27976 4 3.63803 4.32698C3.07354 4.6146 2.6146 5.07354 2.32698 5.63803C2 6.27976 2 7.11984 2 8.8V15.2C2 16.8802 2 17.7202 2.32698 18.362C2.6146 18.9265 3.07354 19.3854 3.63803 19.673C4.27976 20 5.11984 20 6.8 20Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Sn = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M13.744 2.63346L21.272 7.52667C21.538 7.69957 21.671 7.78602 21.7674 7.90134C21.8527 8.00342 21.9167 8.12149 21.9558 8.24865C22 8.39229 22 8.55092 22 8.86818V16.1999C22 17.88 22 18.7201 21.673 19.3619C21.3854 19.9263 20.9265 20.3853 20.362 20.6729C19.7202 20.9999 18.8802 20.9999 17.2 20.9999H6.8C5.11984 20.9999 4.27976 20.9999 3.63803 20.6729C3.07354 20.3853 2.6146 19.9263 2.32698 19.3619C2 18.7201 2 17.88 2 16.1999V8.86818C2 8.55092 2 8.39229 2.04417 8.24865C2.08327 8.12149 2.14735 8.00342 2.23265 7.90134C2.32901 7.78602 2.46201 7.69957 2.72802 7.52667L10.256 2.63346M13.744 2.63346C13.1127 2.22315 12.7971 2.01799 12.457 1.93817C12.1564 1.86761 11.8436 1.86761 11.543 1.93817C11.2029 2.01799 10.8873 2.22315 10.256 2.63346M13.744 2.63346L20.9681 7.32913C21.312 7.55268 21.484 7.66445 21.5435 7.8062C21.5956 7.93008 21.5956 8.06969 21.5435 8.19356C21.484 8.33531 21.312 8.44709 20.9681 8.67064L13.744 13.3663C13.1127 13.7766 12.7971 13.9818 12.457 14.0616C12.1564 14.1321 11.8436 14.1321 11.543 14.0616C11.2029 13.9818 10.8873 13.7766 10.256 13.3663L3.03193 8.67064C2.68801 8.44709 2.51604 8.33531 2.45649 8.19356C2.40444 8.06969 2.40444 7.93008 2.45649 7.8062C2.51604 7.66445 2.68801 7.55268 3.03193 7.32913L10.256 2.63346",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Cn = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M13.744 2.63358L21.272 7.52679C21.538 7.69969 21.671 7.78615 21.7674 7.90146C21.8527 8.00354 21.9167 8.12162 21.9558 8.24877C22 8.39241 22 8.55104 22 8.8683V16.2C22 17.8802 22 18.7202 21.673 19.362C21.3854 19.9265 20.9265 20.3854 20.362 20.673C19.7202 21 18.8802 21 17.2 21H6.8C5.11984 21 4.27976 21 3.63803 20.673C3.07354 20.3854 2.6146 19.9265 2.32698 19.362C2 18.7202 2 17.8802 2 16.2V8.8683C2 8.55104 2 8.39241 2.04417 8.24877C2.08327 8.12162 2.14735 8.00354 2.23265 7.90146C2.32901 7.78615 2.46201 7.69969 2.72802 7.52679L10.256 2.63358M13.744 2.63358C13.1127 2.22327 12.7971 2.01812 12.457 1.93829C12.1564 1.86774 11.8436 1.86774 11.543 1.93829C11.2029 2.01812 10.8873 2.22327 10.256 2.63358M13.744 2.63358L19.9361 6.65849C20.624 7.10559 20.9679 7.32915 21.087 7.61264C21.1911 7.86039 21.1911 8.13961 21.087 8.38737C20.9679 8.67086 20.624 8.89441 19.9361 9.34152L13.744 13.3664C13.1127 13.7767 12.7971 13.9819 12.457 14.0617C12.1564 14.1323 11.8436 14.1323 11.543 14.0617C11.2029 13.9819 10.8873 13.7767 10.256 13.3664L4.06386 9.34151C3.37601 8.89441 3.03209 8.67086 2.91297 8.38737C2.80888 8.13961 2.80888 7.86039 2.91297 7.61264C3.03209 7.32915 3.37601 7.1056 4.06386 6.65849L10.256 2.63358M21.5 19L14.8572 13M9.14282 13L2.5 19",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), wn = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12.4996 11V7.5M12.4996 14.5H12.5096M12.4996 20C17.194 20 20.9996 16.1944 20.9996 11.5C20.9996 6.80558 17.194 3 12.4996 3C7.8052 3 3.99962 6.80558 3.99962 11.5C3.99962 12.45 4.15547 13.3636 4.443 14.2166C4.55119 14.5376 4.60529 14.6981 4.61505 14.8214C4.62469 14.9432 4.6174 15.0286 4.58728 15.1469C4.55677 15.2668 4.48942 15.3915 4.35472 15.6408L2.71906 18.6684C2.48575 19.1002 2.36909 19.3161 2.3952 19.4828C2.41794 19.6279 2.50337 19.7557 2.6288 19.8322C2.7728 19.9201 3.01692 19.8948 3.50517 19.8444L8.62619 19.315C8.78127 19.299 8.85881 19.291 8.92949 19.2937C8.999 19.2963 9.04807 19.3029 9.11586 19.3185C9.18478 19.3344 9.27145 19.3678 9.44478 19.4345C10.3928 19.7998 11.4228 20 12.4996 20Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Tn = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 10.5V7M12 14H12.01M7 18V20.3355C7 20.8684 7 21.1348 7.10923 21.2716C7.20422 21.3906 7.34827 21.4599 7.50054 21.4597C7.67563 21.4595 7.88367 21.2931 8.29976 20.9602L10.6852 19.0518C11.1725 18.662 11.4162 18.4671 11.6875 18.3285C11.9282 18.2055 12.1844 18.1156 12.4492 18.0613C12.7477 18 13.0597 18 13.6837 18H16.2C17.8802 18 18.7202 18 19.362 17.673C19.9265 17.3854 20.3854 16.9265 20.673 16.362C21 15.7202 21 14.8802 21 13.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V14C3 14.93 3 15.395 3.10222 15.7765C3.37962 16.8117 4.18827 17.6204 5.22354 17.8978C5.60504 18 6.07003 18 7 18Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), En = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M6.09436 11.2288C6.03221 10.8282 5.99996 10.4179 5.99996 10C5.99996 5.58172 9.60525 2 14.0526 2C18.4999 2 22.1052 5.58172 22.1052 10C22.1052 10.9981 21.9213 11.9535 21.5852 12.8345C21.5154 13.0175 21.4804 13.109 21.4646 13.1804C21.4489 13.2512 21.4428 13.301 21.4411 13.3735C21.4394 13.4466 21.4493 13.5272 21.4692 13.6883L21.8717 16.9585C21.9153 17.3125 21.9371 17.4895 21.8782 17.6182C21.8266 17.731 21.735 17.8205 21.6211 17.8695C21.4911 17.9254 21.3146 17.8995 20.9617 17.8478L17.7765 17.3809C17.6101 17.3565 17.527 17.3443 17.4512 17.3448C17.3763 17.3452 17.3245 17.3507 17.2511 17.3661C17.177 17.3817 17.0823 17.4172 16.893 17.4881C16.0097 17.819 15.0524 18 14.0526 18C13.6344 18 13.2237 17.9683 12.8227 17.9073M7.63158 22C10.5965 22 13 19.5376 13 16.5C13 13.4624 10.5965 11 7.63158 11C4.66668 11 2.26316 13.4624 2.26316 16.5C2.26316 17.1106 2.36028 17.6979 2.53955 18.2467C2.61533 18.4787 2.65322 18.5947 2.66566 18.6739C2.67864 18.7567 2.68091 18.8031 2.67608 18.8867C2.67145 18.9668 2.65141 19.0573 2.61134 19.2383L2 22L4.9948 21.591C5.15827 21.5687 5.24 21.5575 5.31137 21.558C5.38652 21.5585 5.42641 21.5626 5.50011 21.5773C5.5701 21.5912 5.67416 21.6279 5.88227 21.7014C6.43059 21.8949 7.01911 22 7.63158 22Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Dn = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M10 15L6.92474 18.1137C6.49579 18.548 6.28131 18.7652 6.09695 18.7805C5.93701 18.7938 5.78042 18.7295 5.67596 18.6076C5.55556 18.4672 5.55556 18.162 5.55556 17.5515V15.9916C5.55556 15.444 5.10707 15.0477 4.5652 14.9683V14.9683C3.25374 14.7762 2.22378 13.7463 2.03168 12.4348C2 12.2186 2 11.9605 2 11.4444V6.8C2 5.11984 2 4.27976 2.32698 3.63803C2.6146 3.07354 3.07354 2.6146 3.63803 2.32698C4.27976 2 5.11984 2 6.8 2H14.2C15.8802 2 16.7202 2 17.362 2.32698C17.9265 2.6146 18.3854 3.07354 18.673 3.63803C19 4.27976 19 5.11984 19 6.8V11M19 22L16.8236 20.4869C16.5177 20.2742 16.3647 20.1678 16.1982 20.0924C16.0504 20.0255 15.8951 19.9768 15.7356 19.9474C15.5558 19.9143 15.3695 19.9143 14.9969 19.9143H13.2C12.0799 19.9143 11.5198 19.9143 11.092 19.6963C10.7157 19.5046 10.4097 19.1986 10.218 18.8223C10 18.3944 10 17.8344 10 16.7143V14.2C10 13.0799 10 12.5198 10.218 12.092C10.4097 11.7157 10.7157 11.4097 11.092 11.218C11.5198 11 12.0799 11 13.2 11H18.8C19.9201 11 20.4802 11 20.908 11.218C21.2843 11.4097 21.5903 11.7157 21.782 12.092C22 12.5198 22 13.0799 22 14.2V16.9143C22 17.8462 22 18.3121 21.8478 18.6797C21.6448 19.1697 21.2554 19.5591 20.7654 19.762C20.3978 19.9143 19.9319 19.9143 19 19.9143V22Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), On = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9.49962 11.5L11.4996 13.5L15.9996 9M12.4996 20C17.194 20 20.9996 16.1944 20.9996 11.5C20.9996 6.80558 17.194 3 12.4996 3C7.8052 3 3.99962 6.80558 3.99962 11.5C3.99962 12.45 4.15547 13.3636 4.443 14.2166C4.55119 14.5376 4.60529 14.6981 4.61505 14.8214C4.62469 14.9432 4.6174 15.0286 4.58728 15.1469C4.55677 15.2668 4.48942 15.3915 4.35472 15.6408L2.71906 18.6684C2.48575 19.1002 2.36909 19.3161 2.3952 19.4828C2.41794 19.6279 2.50337 19.7557 2.6288 19.8322C2.7728 19.9201 3.01692 19.8948 3.50517 19.8444L8.62619 19.315C8.78127 19.299 8.85881 19.291 8.92949 19.2937C8.999 19.2963 9.04807 19.3029 9.11586 19.3185C9.18478 19.3344 9.27145 19.3678 9.44478 19.4345C10.3928 19.7998 11.4228 20 12.4996 20Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), kn = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9 10.5L11 12.5L15.5 8M7 18V20.3355C7 20.8684 7 21.1348 7.10923 21.2716C7.20422 21.3906 7.34827 21.4599 7.50054 21.4597C7.67563 21.4595 7.88367 21.2931 8.29976 20.9602L10.6852 19.0518C11.1725 18.662 11.4162 18.4671 11.6875 18.3285C11.9282 18.2055 12.1844 18.1156 12.4492 18.0613C12.7477 18 13.0597 18 13.6837 18H16.2C17.8802 18 18.7202 18 19.362 17.673C19.9265 17.3854 20.3854 16.9265 20.673 16.362C21 15.7202 21 14.8802 21 13.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V14C3 14.93 3 15.395 3.10222 15.7765C3.37962 16.8117 4.18827 17.6204 5.22354 17.8978C5.60504 18 6.07003 18 7 18Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), An = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M20.9996 11.5C20.9996 16.1944 17.194 20 12.4996 20C11.4228 20 10.3928 19.7998 9.44478 19.4345C9.27145 19.3678 9.18478 19.3344 9.11586 19.3185C9.04807 19.3029 8.999 19.2963 8.92949 19.2937C8.85881 19.291 8.78127 19.299 8.62619 19.315L3.50517 19.8444C3.01692 19.8948 2.7728 19.9201 2.6288 19.8322C2.50337 19.7557 2.41794 19.6279 2.3952 19.4828C2.36909 19.3161 2.48575 19.1002 2.71906 18.6684L4.35472 15.6408C4.48942 15.3915 4.55677 15.2668 4.58728 15.1469C4.6174 15.0286 4.62469 14.9432 4.61505 14.8214C4.60529 14.6981 4.55119 14.5376 4.443 14.2166C4.15547 13.3636 3.99962 12.45 3.99962 11.5C3.99962 6.80558 7.8052 3 12.4996 3C17.194 3 20.9996 6.80558 20.9996 11.5Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), jn = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M21 12C21 16.9706 16.9706 21 12 21C10.8029 21 9.6603 20.7663 8.61549 20.3419C8.41552 20.2607 8.31554 20.2201 8.23472 20.202C8.15566 20.1843 8.09715 20.1778 8.01613 20.1778C7.9333 20.1778 7.84309 20.1928 7.66265 20.2229L4.10476 20.8159C3.73218 20.878 3.54589 20.909 3.41118 20.8512C3.29328 20.8007 3.19933 20.7067 3.14876 20.5888C3.09098 20.4541 3.12203 20.2678 3.18413 19.8952L3.77711 16.3374C3.80718 16.1569 3.82222 16.0667 3.82221 15.9839C3.8222 15.9028 3.81572 15.8443 3.798 15.7653C3.77988 15.6845 3.73927 15.5845 3.65806 15.3845C3.23374 14.3397 3 13.1971 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Mn = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M7.5 12H7.51M12 12H12.01M16.5 12H16.51M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 13.1971 3.23374 14.3397 3.65806 15.3845C3.73927 15.5845 3.77988 15.6845 3.798 15.7653C3.81572 15.8443 3.8222 15.9028 3.82221 15.9839C3.82222 16.0667 3.80718 16.1569 3.77711 16.3374L3.18413 19.8952C3.12203 20.2678 3.09098 20.4541 3.14876 20.5888C3.19933 20.7067 3.29328 20.8007 3.41118 20.8512C3.54589 20.909 3.73218 20.878 4.10476 20.8159L7.66265 20.2229C7.84309 20.1928 7.9333 20.1778 8.01613 20.1778C8.09715 20.1778 8.15566 20.1843 8.23472 20.202C8.31554 20.2201 8.41552 20.2607 8.61549 20.3419C9.6603 20.7663 10.8029 21 12 21ZM8 12C8 12.2761 7.77614 12.5 7.5 12.5C7.22386 12.5 7 12.2761 7 12C7 11.7239 7.22386 11.5 7.5 11.5C7.77614 11.5 8 11.7239 8 12ZM12.5 12C12.5 12.2761 12.2761 12.5 12 12.5C11.7239 12.5 11.5 12.2761 11.5 12C11.5 11.7239 11.7239 11.5 12 11.5C12.2761 11.5 12.5 11.7239 12.5 12ZM17 12C17 12.2761 16.7761 12.5 16.5 12.5C16.2239 12.5 16 12.2761 16 12C16 11.7239 16.2239 11.5 16.5 11.5C16.7761 11.5 17 11.7239 17 12Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Nn = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M7.5 10.5H7.51M12 10.5H12.01M16.5 10.5H16.51M7 18V20.3355C7 20.8684 7 21.1348 7.10923 21.2716C7.20422 21.3906 7.34827 21.4599 7.50054 21.4597C7.67563 21.4595 7.88367 21.2931 8.29976 20.9602L10.6852 19.0518C11.1725 18.662 11.4162 18.4671 11.6875 18.3285C11.9282 18.2055 12.1844 18.1156 12.4492 18.0613C12.7477 18 13.0597 18 13.6837 18H16.2C17.8802 18 18.7202 18 19.362 17.673C19.9265 17.3854 20.3854 16.9265 20.673 16.362C21 15.7202 21 14.8802 21 13.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V14C3 14.93 3 15.395 3.10222 15.7765C3.37962 16.8117 4.18827 17.6204 5.22354 17.8978C5.60504 18 6.07003 18 7 18ZM8 10.5C8 10.7761 7.77614 11 7.5 11C7.22386 11 7 10.7761 7 10.5C7 10.2239 7.22386 10 7.5 10C7.77614 10 8 10.2239 8 10.5ZM12.5 10.5C12.5 10.7761 12.2761 11 12 11C11.7239 11 11.5 10.7761 11.5 10.5C11.5 10.2239 11.7239 10 12 10C12.2761 10 12.5 10.2239 12.5 10.5ZM17 10.5C17 10.7761 16.7761 11 16.5 11C16.2239 11 16 10.7761 16 10.5C16 10.2239 16.2239 10 16.5 10C16.7761 10 17 10.2239 17 10.5Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Pn = (e) => /* @__PURE__ */ o("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ a("path", {
		d: "M20.9996 11.5C20.9996 16.1944 17.194 20 12.4996 20C11.4228 20 10.3928 19.7998 9.44478 19.4345C9.27145 19.3678 9.18478 19.3344 9.11586 19.3185C9.04807 19.3029 8.999 19.2963 8.92949 19.2937C8.85881 19.291 8.78127 19.299 8.62619 19.315L3.50517 19.8444C3.01692 19.8948 2.7728 19.9201 2.6288 19.8322C2.50337 19.7557 2.41794 19.6279 2.3952 19.4828C2.36909 19.3161 2.48575 19.1002 2.71906 18.6684L4.35472 15.6408C4.48942 15.3915 4.55677 15.2668 4.58728 15.1469C4.6174 15.0286 4.62469 14.9432 4.61505 14.8214C4.60529 14.6981 4.55119 14.5376 4.443 14.2166C4.15547 13.3636 3.99962 12.45 3.99962 11.5C3.99962 6.80558 7.8052 3 12.4996 3C17.194 3 20.9996 6.80558 20.9996 11.5Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ a("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12.4965 8.94925C11.5968 7.9104 10.0965 7.63095 8.96924 8.58223C7.84196 9.5335 7.68326 11.124 8.56851 12.2491C9.11696 12.9461 10.4935 14.2191 11.4616 15.087C11.8172 15.4057 11.995 15.5651 12.2084 15.6293C12.3914 15.6844 12.6017 15.6844 12.7847 15.6293C12.9981 15.5651 13.1759 15.4057 13.5315 15.087C14.4996 14.2191 15.8761 12.9461 16.4246 12.2491C17.3098 11.124 17.1705 9.5235 16.0238 8.58223C14.8772 7.64096 13.3963 7.9104 12.4965 8.94925Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
}), Fn = (e) => /* @__PURE__ */ o("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ a("path", {
		d: "M3 7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V13.2C21 14.8802 21 15.7202 20.673 16.362C20.3854 16.9265 19.9265 17.3854 19.362 17.673C18.7202 18 17.8802 18 16.2 18H13.6837C13.0597 18 12.7477 18 12.4492 18.0613C12.1844 18.1156 11.9282 18.2055 11.6875 18.3285C11.4162 18.4671 11.1725 18.662 10.6852 19.0518L8.29976 20.9602C7.88367 21.2931 7.67563 21.4595 7.50054 21.4597C7.34827 21.4599 7.20422 21.3906 7.10923 21.2716C7 21.1348 7 20.8684 7 20.3355V18C6.07003 18 5.60504 18 5.22354 17.8978C4.18827 17.6204 3.37962 16.8117 3.10222 15.7765C3 15.395 3 14.93 3 14V7.8Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ a("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.9969 7.69925C11.0972 6.6604 9.59689 6.38095 8.46961 7.33223C7.34234 8.2835 7.18364 9.87399 8.06889 10.9991C8.61733 11.6961 9.99389 12.9691 10.962 13.837C11.3176 14.1557 11.4953 14.3151 11.7087 14.3793C11.8918 14.4344 12.1021 14.4344 12.2851 14.3793C12.4985 14.3151 12.6763 14.1557 13.0319 13.837C13.9999 12.9691 15.3765 11.6961 15.9249 10.9991C16.8102 9.87399 16.6709 8.2735 15.5242 7.33223C14.3776 6.39096 12.8966 6.6604 11.9969 7.69925Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
}), In = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M11.707 3.03647C7.38421 3.43621 3.99962 7.07285 3.99962 11.5C3.99962 12.45 4.15547 13.3636 4.44299 14.2166C4.55119 14.5376 4.60529 14.6981 4.61505 14.8214C4.62469 14.9432 4.6174 15.0286 4.58728 15.1469C4.55677 15.2668 4.48942 15.3915 4.35472 15.6408L2.71906 18.6684C2.48575 19.1002 2.36909 19.3161 2.3952 19.4828C2.41794 19.6279 2.50337 19.7557 2.6288 19.8322C2.7728 19.9201 3.01692 19.8948 3.50517 19.8444L8.62619 19.315C8.78121 19.299 8.85882 19.291 8.92949 19.2937C8.999 19.2963 9.04807 19.3029 9.11586 19.3185C9.18478 19.3344 9.27145 19.3678 9.44478 19.4345C10.3928 19.7998 11.4228 20 12.4996 20C16.9304 20 20.5694 16.6098 20.9641 12.2819M20.1209 3.87868C21.2925 5.05025 21.2925 6.94975 20.1209 8.12132C18.9494 9.29289 17.0499 9.29289 15.8783 8.12132C14.7067 6.94975 14.7067 5.05025 15.8783 3.87868C17.0499 2.70711 18.9494 2.70711 20.1209 3.87868Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ln = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M11 4H7.8C6.11984 4 5.27976 4 4.63803 4.32698C4.07354 4.6146 3.6146 5.07354 3.32698 5.63803C3 6.27976 3 7.11984 3 8.8V14C3 14.93 3 15.395 3.10222 15.7765C3.37962 16.8117 4.18827 17.6204 5.22354 17.8978C5.60504 18 6.07003 18 7 18V20.3355C7 20.8684 7 21.1348 7.10923 21.2716C7.20422 21.3906 7.34827 21.4599 7.50054 21.4597C7.67563 21.4595 7.88367 21.2931 8.29976 20.9602L10.6852 19.0518C11.1725 18.662 11.4162 18.4671 11.6875 18.3285C11.9282 18.2055 12.1844 18.1156 12.4492 18.0613C12.7477 18 13.0597 18 13.6837 18H15.2C16.8802 18 17.7202 18 18.362 17.673C18.9265 17.3854 19.3854 16.9265 19.673 16.362C20 15.7202 20 14.8802 20 13.2V13M20.1213 3.87868C21.2929 5.05025 21.2929 6.94975 20.1213 8.12132C18.9497 9.29289 17.0503 9.29289 15.8787 8.12132C14.7071 6.94975 14.7071 5.05025 15.8787 3.87868C17.0503 2.70711 18.9497 2.70711 20.1213 3.87868Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Rn = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12.4996 14.5V8.5M9.49962 11.5H15.4996M12.4996 20C17.194 20 20.9996 16.1944 20.9996 11.5C20.9996 6.80558 17.194 3 12.4996 3C7.8052 3 3.99962 6.80558 3.99962 11.5C3.99962 12.45 4.15547 13.3636 4.443 14.2166C4.55119 14.5376 4.60529 14.6981 4.61505 14.8214C4.62469 14.9432 4.6174 15.0286 4.58728 15.1469C4.55677 15.2668 4.48942 15.3915 4.35472 15.6408L2.71906 18.6684C2.48575 19.1002 2.36909 19.3161 2.3952 19.4828C2.41794 19.6279 2.50337 19.7557 2.6288 19.8322C2.7728 19.9201 3.01692 19.8948 3.50517 19.8444L8.62619 19.315C8.78127 19.299 8.85881 19.291 8.92949 19.2937C8.999 19.2963 9.04807 19.3029 9.11586 19.3185C9.18478 19.3344 9.27145 19.3678 9.44478 19.4345C10.3928 19.7998 11.4228 20 12.4996 20Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), zn = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 13.5V7.5M9 10.5H15M7 18V20.3355C7 20.8684 7 21.1348 7.10923 21.2716C7.20422 21.3906 7.34827 21.4599 7.50054 21.4597C7.67563 21.4595 7.88367 21.2931 8.29976 20.9602L10.6852 19.0518C11.1725 18.662 11.4162 18.4671 11.6875 18.3285C11.9282 18.2055 12.1844 18.1156 12.4492 18.0613C12.7477 18 13.0597 18 13.6837 18H16.2C17.8802 18 18.7202 18 19.362 17.673C19.9265 17.3854 20.3854 16.9265 20.673 16.362C21 15.7202 21 14.8802 21 13.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V14C3 14.93 3 15.395 3.10222 15.7765C3.37962 16.8117 4.18827 17.6204 5.22354 17.8978C5.60504 18 6.07003 18 7 18Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Bn = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M10.4996 9.00224C10.6758 8.50136 11.0236 8.079 11.4814 7.80998C11.9391 7.54095 12.4773 7.4426 13.0006 7.53237C13.524 7.62213 13.9986 7.89421 14.3406 8.30041C14.6825 8.70661 14.8697 9.22072 14.8689 9.75168C14.8689 11.2506 12.6205 12 12.6205 12M12.6495 15H12.6595M12.4996 20C17.194 20 20.9996 16.1944 20.9996 11.5C20.9996 6.80558 17.194 3 12.4996 3C7.8052 3 3.99962 6.80558 3.99962 11.5C3.99962 12.45 4.15547 13.3636 4.443 14.2166C4.55119 14.5376 4.60529 14.6981 4.61505 14.8214C4.62469 14.9432 4.6174 15.0286 4.58728 15.1469C4.55677 15.2668 4.48942 15.3915 4.35472 15.6408L2.71906 18.6684C2.48575 19.1002 2.36909 19.3161 2.3952 19.4828C2.41794 19.6279 2.50337 19.7557 2.6288 19.8322C2.7728 19.9201 3.01692 19.8948 3.50517 19.8444L8.62619 19.315C8.78127 19.299 8.85881 19.291 8.92949 19.2937C8.999 19.2963 9.04807 19.3029 9.11586 19.3185C9.18478 19.3344 9.27145 19.3678 9.44478 19.4345C10.3928 19.7998 11.4228 20 12.4996 20Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Vn = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M10 8.00224C10.1762 7.50136 10.524 7.07901 10.9817 6.80998C11.4395 6.54095 11.9777 6.4426 12.501 6.53237C13.0243 6.62213 13.499 6.89421 13.8409 7.30041C14.1829 7.70661 14.37 8.22072 14.3692 8.75168C14.3692 10.2506 12.1209 11 12.1209 11M12.1499 14H12.1599M7 18V20.3355C7 20.8684 7 21.1348 7.10923 21.2716C7.20422 21.3906 7.34827 21.4599 7.50054 21.4597C7.67563 21.4595 7.88367 21.2931 8.29976 20.9602L10.6852 19.0518C11.1725 18.662 11.4162 18.4671 11.6875 18.3285C11.9282 18.2055 12.1844 18.1156 12.4492 18.0613C12.7477 18 13.0597 18 13.6837 18H16.2C17.8802 18 18.7202 18 19.362 17.673C19.9265 17.3854 20.3854 16.9265 20.673 16.362C21 15.7202 21 14.8802 21 13.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V14C3 14.93 3 15.395 3.10222 15.7765C3.37962 16.8117 4.18827 17.6204 5.22354 17.8978C5.60504 18 6.07003 18 7 18Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Hn = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M8.99962 14C8.99962 14 10.3121 15.5 12.4996 15.5C14.6871 15.5 15.9996 14 15.9996 14M15.2496 9H15.2596M9.74962 9H9.75962M12.4996 20C17.194 20 20.9996 16.1944 20.9996 11.5C20.9996 6.80558 17.194 3 12.4996 3C7.8052 3 3.99962 6.80558 3.99962 11.5C3.99962 12.45 4.15547 13.3636 4.443 14.2166C4.55119 14.5376 4.60529 14.6981 4.61505 14.8214C4.62469 14.9432 4.6174 15.0286 4.58728 15.1469C4.55677 15.2668 4.48942 15.3915 4.35472 15.6408L2.71906 18.6684C2.48575 19.1002 2.36909 19.3161 2.3952 19.4828C2.41794 19.6279 2.50337 19.7557 2.6288 19.8322C2.7728 19.9201 3.01692 19.8948 3.50517 19.8444L8.62619 19.315C8.78127 19.299 8.85881 19.291 8.92949 19.2937C8.999 19.2963 9.04807 19.3029 9.11586 19.3185C9.18478 19.3344 9.27145 19.3678 9.44478 19.4345C10.3928 19.7998 11.4228 20 12.4996 20ZM15.7496 9C15.7496 9.27614 15.5258 9.5 15.2496 9.5C14.9735 9.5 14.7496 9.27614 14.7496 9C14.7496 8.72386 14.9735 8.5 15.2496 8.5C15.5258 8.5 15.7496 8.72386 15.7496 9ZM10.2496 9C10.2496 9.27614 10.0258 9.5 9.74962 9.5C9.47348 9.5 9.24962 9.27614 9.24962 9C9.24962 8.72386 9.47348 8.5 9.74962 8.5C10.0258 8.5 10.2496 8.72386 10.2496 9Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Un = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M8.5 12.5C8.5 12.5 9.8125 14 12 14C14.1875 14 15.5 12.5 15.5 12.5M14.75 7.5H14.76M9.25 7.5H9.26M7 18V20.3355C7 20.8684 7 21.1348 7.10923 21.2716C7.20422 21.3906 7.34827 21.4599 7.50054 21.4597C7.67563 21.4595 7.88367 21.2931 8.29976 20.9602L10.6852 19.0518C11.1725 18.662 11.4162 18.4671 11.6875 18.3285C11.9282 18.2055 12.1844 18.1156 12.4492 18.0613C12.7477 18 13.0597 18 13.6837 18H16.2C17.8802 18 18.7202 18 19.362 17.673C19.9265 17.3854 20.3854 16.9265 20.673 16.362C21 15.7202 21 14.8802 21 13.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V14C3 14.93 3 15.395 3.10222 15.7765C3.37962 16.8117 4.18827 17.6204 5.22354 17.8978C5.60504 18 6.07003 18 7 18ZM15.25 7.5C15.25 7.77614 15.0261 8 14.75 8C14.4739 8 14.25 7.77614 14.25 7.5C14.25 7.22386 14.4739 7 14.75 7C15.0261 7 15.25 7.22386 15.25 7.5ZM9.75 7.5C9.75 7.77614 9.52614 8 9.25 8C8.97386 8 8.75 7.77614 8.75 7.5C8.75 7.22386 8.97386 7 9.25 7C9.52614 7 9.75 7.22386 9.75 7.5Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Wn = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M3 7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V13.2C21 14.8802 21 15.7202 20.673 16.362C20.3854 16.9265 19.9265 17.3854 19.362 17.673C18.7202 18 17.8802 18 16.2 18H9.68375C9.0597 18 8.74767 18 8.44921 18.0613C8.18443 18.1156 7.9282 18.2055 7.68749 18.3285C7.41617 18.4671 7.17252 18.662 6.68521 19.0518L4.29976 20.9602C3.88367 21.2931 3.67563 21.4595 3.50054 21.4597C3.34827 21.4599 3.20422 21.3906 3.10923 21.2716C3 21.1348 3 20.8684 3 20.3355V7.8Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Gn = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M3 7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V13.2C21 14.8802 21 15.7202 20.673 16.362C20.3854 16.9265 19.9265 17.3854 19.362 17.673C18.7202 18 17.8802 18 16.2 18H13.6837C13.0597 18 12.7477 18 12.4492 18.0613C12.1844 18.1156 11.9282 18.2055 11.6875 18.3285C11.4162 18.4671 11.1725 18.662 10.6852 19.0518L8.29976 20.9602C7.88367 21.2931 7.67563 21.4595 7.50054 21.4597C7.34827 21.4599 7.20422 21.3906 7.10923 21.2716C7 21.1348 7 20.8684 7 20.3355V18C6.07003 18 5.60504 18 5.22354 17.8978C4.18827 17.6204 3.37962 16.8117 3.10222 15.7765C3 15.395 3 14.93 3 14V7.8Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Kn = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M7.99962 9.5H11.9996M7.99962 13H14.9996M12.4996 20C17.194 20 20.9996 16.1944 20.9996 11.5C20.9996 6.80558 17.194 3 12.4996 3C7.8052 3 3.99962 6.80558 3.99962 11.5C3.99962 12.45 4.15547 13.3636 4.443 14.2166C4.55119 14.5376 4.60529 14.6981 4.61505 14.8214C4.62469 14.9432 4.6174 15.0286 4.58728 15.1469C4.55677 15.2668 4.48942 15.3915 4.35472 15.6408L2.71906 18.6684C2.48575 19.1002 2.36909 19.3161 2.3952 19.4828C2.41794 19.6279 2.50337 19.7557 2.6288 19.8322C2.7728 19.9201 3.01692 19.8948 3.50517 19.8444L8.62619 19.315C8.78127 19.299 8.85881 19.291 8.92949 19.2937C8.999 19.2963 9.04807 19.3029 9.11586 19.3185C9.18478 19.3344 9.27145 19.3678 9.44478 19.4345C10.3928 19.7998 11.4228 20 12.4996 20Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), qn = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M8 9.5H12M8 13H15M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 13.1971 3.23374 14.3397 3.65806 15.3845C3.73927 15.5845 3.77988 15.6845 3.798 15.7653C3.81572 15.8443 3.8222 15.9028 3.82221 15.9839C3.82222 16.0667 3.80718 16.1569 3.77711 16.3374L3.18413 19.8952C3.12203 20.2678 3.09098 20.4541 3.14876 20.5888C3.19933 20.7067 3.29328 20.8007 3.41118 20.8512C3.54589 20.909 3.73218 20.878 4.10476 20.8159L7.66265 20.2229C7.84309 20.1928 7.9333 20.1778 8.01613 20.1778C8.09715 20.1778 8.15566 20.1843 8.23472 20.202C8.31554 20.2201 8.41552 20.2607 8.61549 20.3419C9.6603 20.7663 10.8029 21 12 21Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Jn = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M7 8.5H12M7 12H15M9.68375 18H16.2C17.8802 18 18.7202 18 19.362 17.673C19.9265 17.3854 20.3854 16.9265 20.673 16.362C21 15.7202 21 14.8802 21 13.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V20.3355C3 20.8684 3 21.1348 3.10923 21.2716C3.20422 21.3906 3.34827 21.4599 3.50054 21.4597C3.67563 21.4595 3.88367 21.2931 4.29976 20.9602L6.68521 19.0518C7.17252 18.662 7.41617 18.4671 7.68749 18.3285C7.9282 18.2055 8.18443 18.1156 8.44921 18.0613C8.74767 18 9.0597 18 9.68375 18Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Yn = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M7 8.5H12M7 12H15M7 18V20.3355C7 20.8684 7 21.1348 7.10923 21.2716C7.20422 21.3906 7.34827 21.4599 7.50054 21.4597C7.67563 21.4595 7.88367 21.2931 8.29976 20.9602L10.6852 19.0518C11.1725 18.662 11.4162 18.4671 11.6875 18.3285C11.9282 18.2055 12.1844 18.1156 12.4492 18.0613C12.7477 18 13.0597 18 13.6837 18H16.2C17.8802 18 18.7202 18 19.362 17.673C19.9265 17.3854 20.3854 16.9265 20.673 16.362C21 15.7202 21 14.8802 21 13.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V14C3 14.93 3 15.395 3.10222 15.7765C3.37962 16.8117 4.18827 17.6204 5.22354 17.8978C5.60504 18 6.07003 18 7 18Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Xn = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9.99962 9L14.9996 14M14.9996 9L9.99962 14M12.4996 20C17.194 20 20.9996 16.1944 20.9996 11.5C20.9996 6.80558 17.194 3 12.4996 3C7.8052 3 3.99962 6.80558 3.99962 11.5C3.99962 12.45 4.15547 13.3636 4.443 14.2166C4.55119 14.5376 4.60529 14.6981 4.61505 14.8214C4.62469 14.9432 4.6174 15.0286 4.58728 15.1469C4.55677 15.2668 4.48942 15.3915 4.35472 15.6408L2.71906 18.6684C2.48575 19.1002 2.36909 19.3161 2.3952 19.4828C2.41794 19.6279 2.50337 19.7557 2.6288 19.8322C2.7728 19.9201 3.01692 19.8948 3.50517 19.8444L8.62619 19.315C8.78127 19.299 8.85881 19.291 8.92949 19.2937C8.999 19.2963 9.04807 19.3029 9.11586 19.3185C9.18478 19.3344 9.27145 19.3678 9.44478 19.4345C10.3928 19.7998 11.4228 20 12.4996 20Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Zn = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9.5 8L14.5 13M14.5 8L9.5 13M7 18V20.3355C7 20.8684 7 21.1348 7.10923 21.2716C7.20422 21.3906 7.34827 21.4599 7.50054 21.4597C7.67563 21.4595 7.88367 21.2931 8.29976 20.9602L10.6852 19.0518C11.1725 18.662 11.4162 18.4671 11.6875 18.3285C11.9282 18.2055 12.1844 18.1156 12.4492 18.0613C12.7477 18 13.0597 18 13.6837 18H16.2C17.8802 18 18.7202 18 19.362 17.673C19.9265 17.3854 20.3854 16.9265 20.673 16.362C21 15.7202 21 14.8802 21 13.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V14C3 14.93 3 15.395 3.10222 15.7765C3.37962 16.8117 4.18827 17.6204 5.22354 17.8978C5.60504 18 6.07003 18 7 18Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Qn = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M8.38028 8.85335C9.07627 10.303 10.0251 11.6616 11.2266 12.8632C12.4282 14.0648 13.7869 15.0136 15.2365 15.7096C15.3612 15.7694 15.4235 15.7994 15.5024 15.8224C15.7828 15.9041 16.127 15.8454 16.3644 15.6754C16.4313 15.6275 16.4884 15.5704 16.6027 15.4561C16.9523 15.1064 17.1271 14.9316 17.3029 14.8174C17.9658 14.3864 18.8204 14.3864 19.4833 14.8174C19.6591 14.9316 19.8339 15.1064 20.1835 15.4561L20.3783 15.6509C20.9098 16.1824 21.1755 16.4481 21.3198 16.7335C21.6069 17.301 21.6069 17.9713 21.3198 18.5389C21.1755 18.8242 20.9098 19.09 20.3783 19.6214L20.2207 19.779C19.6911 20.3087 19.4263 20.5735 19.0662 20.7757C18.6667 21.0001 18.0462 21.1615 17.588 21.1601C17.1751 21.1589 16.8928 21.0788 16.3284 20.9186C13.295 20.0576 10.4326 18.4332 8.04466 16.0452C5.65668 13.6572 4.03221 10.7948 3.17124 7.76144C3.01103 7.19699 2.93092 6.91477 2.9297 6.50182C2.92833 6.0436 3.08969 5.42311 3.31411 5.0236C3.51636 4.66357 3.78117 4.39876 4.3108 3.86913L4.46843 3.7115C4.99987 3.18006 5.2656 2.91433 5.55098 2.76999C6.11854 2.48292 6.7888 2.48292 7.35636 2.76999C7.64174 2.91433 7.90747 3.18006 8.43891 3.7115L8.63378 3.90637C8.98338 4.25597 9.15819 4.43078 9.27247 4.60655C9.70347 5.26945 9.70347 6.12403 9.27247 6.78692C9.15819 6.96269 8.98338 7.1375 8.63378 7.4871C8.51947 7.60142 8.46231 7.65857 8.41447 7.72538C8.24446 7.96281 8.18576 8.30707 8.26748 8.58743C8.29048 8.66632 8.32041 8.72866 8.38028 8.85335Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), $n = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M14.0497 6C15.0264 6.19057 15.924 6.66826 16.6277 7.37194C17.3314 8.07561 17.8091 8.97326 17.9997 9.95M14.0497 2C16.0789 2.22544 17.9713 3.13417 19.4159 4.57701C20.8606 6.01984 21.7717 7.91101 21.9997 9.94M10.2266 13.8631C9.02506 12.6615 8.07627 11.3028 7.38028 9.85323C7.32041 9.72854 7.29048 9.66619 7.26748 9.5873C7.18576 9.30695 7.24446 8.96269 7.41447 8.72526C7.46231 8.65845 7.51947 8.60129 7.63378 8.48698C7.98338 8.13737 8.15819 7.96257 8.27247 7.78679C8.70347 7.1239 8.70347 6.26932 8.27247 5.60643C8.15819 5.43065 7.98338 5.25585 7.63378 4.90624L7.43891 4.71137C6.90747 4.17993 6.64174 3.91421 6.35636 3.76987C5.7888 3.4828 5.11854 3.4828 4.55098 3.76987C4.2656 3.91421 3.99987 4.17993 3.46843 4.71137L3.3108 4.86901C2.78117 5.39863 2.51636 5.66344 2.31411 6.02348C2.08969 6.42298 1.92833 7.04347 1.9297 7.5017C1.93092 7.91464 2.01103 8.19687 2.17124 8.76131C3.03221 11.7947 4.65668 14.6571 7.04466 17.045C9.43264 19.433 12.295 21.0575 15.3284 21.9185C15.8928 22.0787 16.1751 22.1588 16.588 22.16C17.0462 22.1614 17.6667 22 18.0662 21.7756C18.4263 21.5733 18.6911 21.3085 19.2207 20.7789L19.3783 20.6213C19.9098 20.0898 20.1755 19.8241 20.3198 19.5387C20.6069 18.9712 20.6069 18.3009 20.3198 17.7333C20.1755 17.448 19.9098 17.1822 19.3783 16.6508L19.1835 16.4559C18.8339 16.1063 18.6591 15.9315 18.4833 15.8172C17.8204 15.3862 16.9658 15.3862 16.3029 15.8172C16.1271 15.9315 15.9523 16.1063 15.6027 16.4559C15.4884 16.5702 15.4313 16.6274 15.3644 16.6752C15.127 16.8453 14.7828 16.904 14.5024 16.8222C14.4235 16.7992 14.3612 16.7693 14.2365 16.7094C12.7869 16.0134 11.4282 15.0646 10.2266 13.8631Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), er = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M4.85864 6C6.67357 4.14864 9.20268 3 12.0001 3C14.7975 3 17.3266 4.14864 19.1415 6M16.4723 9C15.3736 7.7725 13.777 7 12 7C10.223 7 8.62647 7.7725 7.52783 9M12 17C13.5105 17 14.9608 17.2576 16.3094 17.7313C16.3542 17.747 16.3767 17.7549 16.412 17.7705C16.7326 17.9118 16.9788 18.2591 17.0058 18.6084C17.0088 18.647 17.0088 18.6811 17.0088 18.7494C17.0088 18.9821 17.0088 19.0985 17.0185 19.1965C17.1122 20.1457 17.8631 20.8966 18.8123 20.9903C18.9103 21 19.0267 21 19.2594 21H19.5044C19.965 21 20.1952 21 20.3868 20.9622C21.1829 20.8053 21.8053 20.1829 21.9622 19.3868C22 19.1952 22 18.965 22 18.5044V18.3062C22 17.831 22 17.5933 21.9493 17.3209C21.8358 16.7119 21.3933 15.9583 20.9166 15.5624C20.7035 15.3854 20.5589 15.3048 20.2698 15.1435C17.822 13.7781 15.0019 13 12 13C8.99812 13 6.17797 13.7781 3.73021 15.1435C3.4411 15.3048 3.29654 15.3854 3.0834 15.5624C2.60675 15.9583 2.16421 16.7119 2.05074 17.3209C2 17.5933 2 17.831 2 18.3062V18.5044C2 18.965 2 19.1952 2.03776 19.3868C2.19469 20.1829 2.81709 20.8053 3.61321 20.9622C3.80476 21 4.03504 21 4.4956 21H4.74057C4.97332 21 5.0897 21 5.18773 20.9903C6.13689 20.8966 6.8878 20.1457 6.98152 19.1965C6.9912 19.0985 6.9912 18.9821 6.9912 18.7494C6.9912 18.6811 6.9912 18.647 6.99418 18.6084C7.02122 18.2591 7.2674 17.9118 7.58798 17.7705C7.62335 17.7549 7.64577 17.747 7.69061 17.7313C9.03921 17.2576 10.4895 17 12 17Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), tr = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M5.47542 12.8631C4.44449 11.2622 3.67643 9.54121 3.17124 7.76131C3.01103 7.19687 2.93093 6.91464 2.9297 6.5017C2.92833 6.04347 3.08969 5.42298 3.31412 5.02348C3.51636 4.66345 3.78117 4.39863 4.3108 3.86901L4.46843 3.71138C4.99987 3.17993 5.2656 2.91421 5.55098 2.76987C6.11854 2.4828 6.7888 2.4828 7.35636 2.76987C7.64174 2.91421 7.90747 3.17993 8.43891 3.71138L8.63378 3.90625C8.98338 4.25585 9.15819 4.43066 9.27247 4.60643C9.70347 5.26932 9.70347 6.1239 9.27247 6.7868C9.15819 6.96257 8.98338 7.13738 8.63378 7.48698C8.51947 7.60129 8.46231 7.65845 8.41447 7.72526C8.24446 7.96269 8.18576 8.30695 8.26748 8.58731C8.29048 8.6662 8.32041 8.72855 8.38028 8.85324C8.50111 9.10491 8.62956 9.35383 8.76563 9.59967M11.1817 12.8179L11.2266 12.8631C12.4282 14.0646 13.7869 15.0134 15.2365 15.7094C15.3612 15.7693 15.4235 15.7992 15.5024 15.8222C15.7828 15.904 16.127 15.8453 16.3644 15.6752C16.4313 15.6274 16.4884 15.5702 16.6027 15.4559C16.9523 15.1063 17.1271 14.9315 17.3029 14.8172C17.9658 14.3862 18.8204 14.3862 19.4833 14.8172C19.6591 14.9315 19.8339 15.1063 20.1835 15.4559L20.3783 15.6508C20.9098 16.1822 21.1755 16.448 21.3198 16.7333C21.6069 17.3009 21.6069 17.9712 21.3198 18.5387C21.1755 18.8241 20.9098 19.0898 20.3783 19.6213L20.2207 19.7789C19.6911 20.3085 19.4263 20.5733 19.0662 20.7756C18.6667 21 18.0462 21.1614 17.588 21.16C17.1751 21.1588 16.8928 21.0787 16.3284 20.9185C13.295 20.0575 10.4326 18.433 8.04466 16.045L7.99976 16M20.9996 3L2.99961 21",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), nr = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M14.9996 4V9M14.9996 9L19.9996 9M14.9996 9L20.9996 3M10.2266 13.8631C9.02506 12.6615 8.07627 11.3028 7.38028 9.85323C7.32041 9.72854 7.29048 9.66619 7.26748 9.5873C7.18576 9.30695 7.24446 8.96269 7.41447 8.72526C7.46231 8.65845 7.51947 8.60129 7.63378 8.48698C7.98338 8.13737 8.15819 7.96257 8.27247 7.78679C8.70347 7.1239 8.70347 6.26932 8.27247 5.60643C8.15819 5.43065 7.98338 5.25585 7.63378 4.90624L7.43891 4.71137C6.90747 4.17993 6.64174 3.91421 6.35636 3.76987C5.7888 3.4828 5.11854 3.4828 4.55098 3.76987C4.2656 3.91421 3.99987 4.17993 3.46843 4.71137L3.3108 4.86901C2.78117 5.39863 2.51636 5.66344 2.31411 6.02348C2.08969 6.42298 1.92833 7.04347 1.9297 7.5017C1.93092 7.91464 2.01103 8.19687 2.17124 8.76131C3.03221 11.7947 4.65668 14.6571 7.04466 17.045C9.43264 19.433 12.295 21.0575 15.3284 21.9185C15.8928 22.0787 16.1751 22.1588 16.588 22.16C17.0462 22.1614 17.6667 22 18.0662 21.7756C18.4263 21.5733 18.6911 21.3085 19.2207 20.7789L19.3783 20.6213C19.9098 20.0898 20.1755 19.8241 20.3198 19.5387C20.6069 18.9712 20.6069 18.3009 20.3198 17.7333C20.1755 17.448 19.9098 17.1822 19.3783 16.6508L19.1835 16.4559C18.8339 16.1063 18.6591 15.9315 18.4833 15.8172C17.8204 15.3862 16.9658 15.3862 16.3029 15.8172C16.1271 15.9315 15.9523 16.1063 15.6027 16.4559C15.4884 16.5702 15.4313 16.6274 15.3644 16.6752C15.127 16.8453 14.7828 16.904 14.5024 16.8222C14.4235 16.7992 14.3612 16.7693 14.2365 16.7094C12.7869 16.0134 11.4282 15.0646 10.2266 13.8631Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), rr = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M16.4996 3L12.9996 6.5M12.9996 6.5L16.4996 10M12.9996 6.5H20.9996M10.2266 13.8631C9.02506 12.6615 8.07627 11.3028 7.38028 9.85323C7.32041 9.72854 7.29048 9.66619 7.26748 9.5873C7.18576 9.30695 7.24446 8.96269 7.41447 8.72526C7.46231 8.65845 7.51947 8.60129 7.63378 8.48698C7.98338 8.13737 8.15819 7.96257 8.27247 7.78679C8.70347 7.1239 8.70347 6.26932 8.27247 5.60643C8.15819 5.43065 7.98338 5.25585 7.63378 4.90624L7.43891 4.71137C6.90747 4.17993 6.64174 3.91421 6.35636 3.76987C5.7888 3.4828 5.11854 3.4828 4.55098 3.76987C4.2656 3.91421 3.99987 4.17993 3.46843 4.71137L3.3108 4.86901C2.78117 5.39863 2.51636 5.66344 2.31411 6.02348C2.08969 6.42298 1.92833 7.04347 1.9297 7.5017C1.93092 7.91464 2.01103 8.19687 2.17124 8.76131C3.03221 11.7947 4.65668 14.6571 7.04466 17.045C9.43264 19.433 12.295 21.0575 15.3284 21.9185C15.8928 22.0787 16.1751 22.1588 16.588 22.16C17.0462 22.1614 17.6667 22 18.0662 21.7756C18.4263 21.5733 18.6911 21.3085 19.2207 20.7789L19.3783 20.6213C19.9098 20.0898 20.1755 19.8241 20.3198 19.5387C20.6069 18.9712 20.6069 18.3009 20.3198 17.7333C20.1755 17.448 19.9098 17.1822 19.3783 16.6508L19.1835 16.4559C18.8339 16.1063 18.6591 15.9315 18.4833 15.8172C17.8204 15.3862 16.9658 15.3862 16.3029 15.8172C16.1271 15.9315 15.9523 16.1063 15.6027 16.4559C15.4884 16.5702 15.4313 16.6274 15.3644 16.6752C15.127 16.8453 14.7828 16.904 14.5024 16.8222C14.4235 16.7992 14.3612 16.7693 14.2365 16.7094C12.7869 16.0134 11.4282 15.0646 10.2266 13.8631Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ir = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M20.9996 8V3M20.9996 3H15.9996M20.9996 3L14.9996 9M10.2266 13.8631C9.02506 12.6615 8.07627 11.3028 7.38028 9.85323C7.32041 9.72854 7.29048 9.66619 7.26748 9.5873C7.18576 9.30695 7.24446 8.96269 7.41447 8.72526C7.46231 8.65845 7.51947 8.60129 7.63378 8.48698C7.98338 8.13737 8.15819 7.96257 8.27247 7.78679C8.70347 7.1239 8.70347 6.26932 8.27247 5.60643C8.15819 5.43065 7.98338 5.25585 7.63378 4.90624L7.43891 4.71137C6.90747 4.17993 6.64174 3.91421 6.35636 3.76987C5.7888 3.4828 5.11854 3.4828 4.55098 3.76987C4.2656 3.91421 3.99987 4.17993 3.46843 4.71137L3.3108 4.86901C2.78117 5.39863 2.51636 5.66344 2.31411 6.02348C2.08969 6.42298 1.92833 7.04347 1.9297 7.5017C1.93092 7.91464 2.01103 8.19687 2.17124 8.76131C3.03221 11.7947 4.65668 14.6571 7.04466 17.045C9.43264 19.433 12.295 21.0575 15.3284 21.9185C15.8928 22.0787 16.1751 22.1588 16.588 22.16C17.0462 22.1614 17.6667 22 18.0662 21.7756C18.4263 21.5733 18.6911 21.3085 19.2207 20.7789L19.3783 20.6213C19.9098 20.0898 20.1755 19.8241 20.3198 19.5387C20.6069 18.9712 20.6069 18.3009 20.3198 17.7333C20.1755 17.448 19.9098 17.1822 19.3783 16.6508L19.1835 16.4559C18.8339 16.1063 18.6591 15.9315 18.4833 15.8172C17.8204 15.3862 16.9658 15.3862 16.3029 15.8172C16.1271 15.9315 15.9523 16.1063 15.6027 16.4559C15.4884 16.5702 15.4313 16.6274 15.3644 16.6752C15.127 16.8453 14.7828 16.904 14.5024 16.8222C14.4235 16.7992 14.3612 16.7693 14.2365 16.7094C12.7869 16.0134 11.4282 15.0646 10.2266 13.8631Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ar = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M17.4996 3L20.9996 6.5M20.9996 6.5L17.4996 10M20.9996 6.5H12.9996M10.2266 13.8631C9.02506 12.6615 8.07627 11.3028 7.38028 9.85323C7.32041 9.72854 7.29048 9.66619 7.26748 9.5873C7.18576 9.30695 7.24446 8.96269 7.41447 8.72526C7.46231 8.65845 7.51947 8.60129 7.63378 8.48698C7.98338 8.13737 8.15819 7.96257 8.27247 7.78679C8.70347 7.1239 8.70347 6.26932 8.27247 5.60643C8.15819 5.43065 7.98338 5.25585 7.63378 4.90624L7.43891 4.71137C6.90747 4.17993 6.64174 3.91421 6.35636 3.76987C5.7888 3.4828 5.11854 3.4828 4.55098 3.76987C4.2656 3.91421 3.99987 4.17993 3.46843 4.71137L3.3108 4.86901C2.78117 5.39863 2.51636 5.66344 2.31411 6.02348C2.08969 6.42298 1.92833 7.04347 1.9297 7.5017C1.93092 7.91464 2.01103 8.19687 2.17124 8.76131C3.03221 11.7947 4.65668 14.6571 7.04466 17.045C9.43264 19.433 12.295 21.0575 15.3284 21.9185C15.8928 22.0787 16.1751 22.1588 16.588 22.16C17.0462 22.1614 17.6667 22 18.0662 21.7756C18.4263 21.5733 18.6911 21.3085 19.2207 20.7789L19.3783 20.6213C19.9098 20.0898 20.1755 19.8241 20.3198 19.5387C20.6069 18.9712 20.6069 18.3009 20.3198 17.7333C20.1755 17.448 19.9098 17.1822 19.3783 16.6508L19.1835 16.4559C18.8339 16.1063 18.6591 15.9315 18.4833 15.8172C17.8204 15.3862 16.9658 15.3862 16.3029 15.8172C16.1271 15.9315 15.9523 16.1063 15.6027 16.4559C15.4884 16.5702 15.4313 16.6274 15.3644 16.6752C15.127 16.8453 14.7828 16.904 14.5024 16.8222C14.4235 16.7992 14.3612 16.7693 14.2365 16.7094C12.7869 16.0134 11.4282 15.0646 10.2266 13.8631Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), or = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M19.9996 10V3M14.9996 10V3M10.2266 13.8631C9.02506 12.6615 8.07627 11.3028 7.38028 9.85323C7.32041 9.72854 7.29048 9.66619 7.26748 9.5873C7.18576 9.30695 7.24446 8.96269 7.41447 8.72526C7.46231 8.65845 7.51947 8.60129 7.63378 8.48698C7.98338 8.13737 8.15819 7.96257 8.27247 7.78679C8.70347 7.1239 8.70347 6.26932 8.27247 5.60643C8.15819 5.43065 7.98338 5.25585 7.63378 4.90624L7.43891 4.71137C6.90747 4.17993 6.64174 3.91421 6.35636 3.76987C5.7888 3.4828 5.11854 3.4828 4.55098 3.76987C4.2656 3.91421 3.99987 4.17993 3.46843 4.71137L3.3108 4.86901C2.78117 5.39863 2.51636 5.66344 2.31411 6.02348C2.08969 6.42298 1.92833 7.04347 1.9297 7.5017C1.93092 7.91464 2.01103 8.19687 2.17124 8.76131C3.03221 11.7947 4.65668 14.6571 7.04466 17.045C9.43264 19.433 12.295 21.0575 15.3284 21.9185C15.8928 22.0787 16.1751 22.1588 16.588 22.16C17.0462 22.1614 17.6667 22 18.0662 21.7756C18.4263 21.5733 18.6911 21.3085 19.2207 20.7789L19.3783 20.6213C19.9098 20.0898 20.1755 19.8241 20.3198 19.5387C20.6069 18.9712 20.6069 18.3009 20.3198 17.7333C20.1755 17.448 19.9098 17.1822 19.3783 16.6508L19.1835 16.4559C18.8339 16.1063 18.6591 15.9315 18.4833 15.8172C17.8204 15.3862 16.9658 15.3862 16.3029 15.8172C16.1271 15.9315 15.9523 16.1063 15.6027 16.4559C15.4884 16.5702 15.4313 16.6274 15.3644 16.6752C15.127 16.8453 14.7828 16.904 14.5024 16.8222C14.4235 16.7992 14.3612 16.7693 14.2365 16.7094C12.7869 16.0134 11.4282 15.0646 10.2266 13.8631Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), sr = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M16.9996 11V3M12.9996 7H20.9996M10.2266 13.8631C9.02506 12.6615 8.07627 11.3028 7.38028 9.85323C7.32041 9.72854 7.29048 9.66619 7.26748 9.5873C7.18576 9.30695 7.24446 8.96269 7.41447 8.72526C7.46231 8.65845 7.51947 8.60129 7.63378 8.48698C7.98338 8.13737 8.15819 7.96257 8.27247 7.78679C8.70347 7.1239 8.70347 6.26932 8.27247 5.60643C8.15819 5.43065 7.98338 5.25585 7.63378 4.90624L7.43891 4.71137C6.90747 4.17993 6.64174 3.91421 6.35636 3.76987C5.7888 3.4828 5.11854 3.4828 4.55098 3.76987C4.2656 3.91421 3.99987 4.17993 3.46843 4.71137L3.3108 4.86901C2.78117 5.39863 2.51636 5.66344 2.31411 6.02348C2.08969 6.42298 1.92833 7.04347 1.9297 7.5017C1.93092 7.91464 2.01103 8.19687 2.17124 8.76131C3.03221 11.7947 4.65668 14.6571 7.04466 17.045C9.43264 19.433 12.295 21.0575 15.3284 21.9185C15.8928 22.0787 16.1751 22.1588 16.588 22.16C17.0462 22.1614 17.6667 22 18.0662 21.7756C18.4263 21.5733 18.6911 21.3085 19.2207 20.7789L19.3783 20.6213C19.9098 20.0898 20.1755 19.8241 20.3198 19.5387C20.6069 18.9712 20.6069 18.3009 20.3198 17.7333C20.1755 17.448 19.9098 17.1822 19.3783 16.6508L19.1835 16.4559C18.8339 16.1063 18.6591 15.9315 18.4833 15.8172C17.8204 15.3862 16.9658 15.3862 16.3029 15.8172C16.1271 15.9315 15.9523 16.1063 15.6027 16.4559C15.4884 16.5702 15.4313 16.6274 15.3644 16.6752C15.127 16.8453 14.7828 16.904 14.5024 16.8222C14.4235 16.7992 14.3612 16.7693 14.2365 16.7094C12.7869 16.0134 11.4282 15.0646 10.2266 13.8631Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), cr = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M20.9996 3L14.9996 9M14.9996 3L20.9996 9M10.2266 13.8631C9.02506 12.6615 8.07627 11.3028 7.38028 9.85323C7.32041 9.72854 7.29048 9.66619 7.26748 9.5873C7.18576 9.30695 7.24446 8.96269 7.41447 8.72526C7.46231 8.65845 7.51947 8.60129 7.63378 8.48698C7.98338 8.13737 8.15819 7.96257 8.27247 7.78679C8.70347 7.1239 8.70347 6.26932 8.27247 5.60643C8.15819 5.43065 7.98338 5.25585 7.63378 4.90624L7.43891 4.71137C6.90747 4.17993 6.64174 3.91421 6.35636 3.76987C5.7888 3.4828 5.11854 3.4828 4.55098 3.76987C4.2656 3.91421 3.99987 4.17993 3.46843 4.71137L3.3108 4.86901C2.78117 5.39863 2.51636 5.66344 2.31411 6.02348C2.08969 6.42298 1.92833 7.04347 1.9297 7.5017C1.93092 7.91464 2.01103 8.19687 2.17124 8.76131C3.03221 11.7947 4.65668 14.6571 7.04466 17.045C9.43264 19.433 12.295 21.0575 15.3284 21.9185C15.8928 22.0787 16.1751 22.1588 16.588 22.16C17.0462 22.1614 17.6667 22 18.0662 21.7756C18.4263 21.5733 18.6911 21.3085 19.2207 20.7789L19.3783 20.6213C19.9098 20.0898 20.1755 19.8241 20.3198 19.5387C20.6069 18.9712 20.6069 18.3009 20.3198 17.7333C20.1755 17.448 19.9098 17.1822 19.3783 16.6508L19.1835 16.4559C18.8339 16.1063 18.6591 15.9315 18.4833 15.8172C17.8204 15.3862 16.9658 15.3862 16.3029 15.8172C16.1271 15.9315 15.9523 16.1063 15.6027 16.4559C15.4884 16.5702 15.4313 16.6274 15.3644 16.6752C15.127 16.8453 14.7828 16.904 14.5024 16.8222C14.4235 16.7992 14.3612 16.7693 14.2365 16.7094C12.7869 16.0134 11.4282 15.0646 10.2266 13.8631Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), lr = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M10.4995 13.5002L20.9995 3.00017M10.6271 13.8282L13.2552 20.5862C13.4867 21.1816 13.6025 21.4793 13.7693 21.5662C13.9139 21.6415 14.0862 21.6416 14.2308 21.5664C14.3977 21.4797 14.5139 21.1822 14.7461 20.5871L21.3364 3.69937C21.5461 3.16219 21.6509 2.8936 21.5935 2.72197C21.5437 2.57292 21.4268 2.45596 21.2777 2.40616C21.1061 2.34883 20.8375 2.45364 20.3003 2.66327L3.41258 9.25361C2.8175 9.48584 2.51997 9.60195 2.43326 9.76886C2.35809 9.91354 2.35819 10.0858 2.43353 10.2304C2.52043 10.3972 2.81811 10.513 3.41345 10.7445L10.1715 13.3726C10.2923 13.4196 10.3527 13.4431 10.4036 13.4794C10.4487 13.5115 10.4881 13.551 10.5203 13.5961C10.5566 13.647 10.5801 13.7074 10.6271 13.8282Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ur = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12.0005 18.9998V11.9998M12.292 19.0845L19.2704 21.4207C19.8173 21.6038 20.0908 21.6953 20.2594 21.6296C20.4059 21.5726 20.517 21.45 20.5594 21.2987C20.6082 21.1244 20.4903 20.8613 20.2545 20.3349L12.766 3.6222C12.5354 3.1075 12.4201 2.85015 12.2594 2.77041C12.1199 2.70113 11.956 2.70087 11.8162 2.7697C11.6553 2.84892 11.5392 3.1059 11.3069 3.61986L3.75244 20.3359C3.51474 20.8619 3.39589 21.1248 3.44422 21.2993C3.48619 21.4508 3.59697 21.5737 3.74329 21.6312C3.91178 21.6974 4.18567 21.6064 4.73346 21.4246L11.786 19.0838C11.8799 19.0527 11.9268 19.0371 11.9749 19.0309C12.0175 19.0255 12.0606 19.0255 12.1032 19.0311C12.1512 19.0374 12.1981 19.0531 12.292 19.0845Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), dr = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M10.5004 12H5.00043M4.91577 12.2915L2.58085 19.2662C2.39742 19.8142 2.3057 20.0881 2.37152 20.2569C2.42868 20.4034 2.55144 20.5145 2.70292 20.5567C2.87736 20.6054 3.14083 20.4869 3.66776 20.2497L20.3792 12.7296C20.8936 12.4981 21.1507 12.3824 21.2302 12.2216C21.2993 12.082 21.2993 11.9181 21.2302 11.7784C21.1507 11.6177 20.8936 11.5019 20.3792 11.2705L3.66193 3.74776C3.13659 3.51135 2.87392 3.39315 2.69966 3.44164C2.54832 3.48375 2.42556 3.59454 2.36821 3.74078C2.30216 3.90917 2.3929 4.18255 2.57437 4.72931L4.91642 11.7856C4.94759 11.8795 4.96317 11.9264 4.96933 11.9744C4.97479 12.0171 4.97473 12.0602 4.96916 12.1028C4.96289 12.1508 4.94718 12.1977 4.91577 12.2915Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), fr = /* @__PURE__ */ k({
	Annotation: () => cn,
	AnnotationAlert: () => ln,
	AnnotationCheck: () => un,
	AnnotationDots: () => dn,
	AnnotationHeart: () => fn,
	AnnotationInfo: () => pn,
	AnnotationPlus: () => mn,
	AnnotationQuestion: () => hn,
	AnnotationX: () => gn,
	Inbox01: () => _n,
	Inbox02: () => vn,
	Mail01: () => yn,
	Mail02: () => bn,
	Mail03: () => xn,
	Mail04: () => Sn,
	Mail05: () => Cn,
	MessageAlertCircle: () => wn,
	MessageAlertSquare: () => Tn,
	MessageChatCircle: () => En,
	MessageChatSquare: () => Dn,
	MessageCheckCircle: () => On,
	MessageCheckSquare: () => kn,
	MessageCircle01: () => An,
	MessageCircle02: () => jn,
	MessageDotsCircle: () => Mn,
	MessageDotsSquare: () => Nn,
	MessageHeartCircle: () => Pn,
	MessageHeartSquare: () => Fn,
	MessageNotificationCircle: () => In,
	MessageNotificationSquare: () => Ln,
	MessagePlusCircle: () => Rn,
	MessagePlusSquare: () => zn,
	MessageQuestionCircle: () => Bn,
	MessageQuestionSquare: () => Vn,
	MessageSmileCircle: () => Hn,
	MessageSmileSquare: () => Un,
	MessageSquare01: () => Wn,
	MessageSquare02: () => Gn,
	MessageTextCircle01: () => Kn,
	MessageTextCircle02: () => qn,
	MessageTextSquare01: () => Jn,
	MessageTextSquare02: () => Yn,
	MessageXCircle: () => Xn,
	MessageXSquare: () => Zn,
	Phone: () => Qn,
	PhoneCall01: () => $n,
	PhoneCall02: () => er,
	PhoneHangUp: () => tr,
	PhoneIncoming01: () => nr,
	PhoneIncoming02: () => rr,
	PhoneOutgoing01: () => ir,
	PhoneOutgoing02: () => ar,
	PhonePause: () => or,
	PhonePlus: () => sr,
	PhoneX: () => cr,
	Send01: () => lr,
	Send02: () => ur,
	Send03: () => dr
}), pr = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M17 20H16.8C15.1198 20 14.2798 20 13.638 19.673C13.0735 19.3854 12.6146 18.9265 12.327 18.362C12 17.7202 12 16.8802 12 15.2V8.8C12 7.11984 12 6.27976 12.327 5.63803C12.6146 5.07354 13.0735 4.6146 13.638 4.32698C14.2798 4 15.1198 4 16.8 4H17M17 20C17 21.1046 17.8954 22 19 22C20.1046 22 21 21.1046 21 20C21 18.8954 20.1046 18 19 18C17.8954 18 17 18.8954 17 20ZM17 4C17 5.10457 17.8954 6 19 6C20.1046 6 21 5.10457 21 4C21 2.89543 20.1046 2 19 2C17.8954 2 17 2.89543 17 4ZM7 12L17 12M7 12C7 13.1046 6.10457 14 5 14C3.89543 14 3 13.1046 3 12C3 10.8954 3.89543 10 5 10C6.10457 10 7 10.8954 7 12ZM17 12C17 13.1046 17.8954 14 19 14C20.1046 14 21 13.1046 21 12C21 10.8954 20.1046 10 19 10C17.8954 10 17 10.8954 17 12Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), mr = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M18.5708 20C19.8328 20 20.8568 18.977 20.8568 17.714V13.143L21.9998 12L20.8568 10.857V6.286C20.8568 5.023 19.8338 4 18.5708 4M5.429 4C4.166 4 3.143 5.023 3.143 6.286V10.857L2 12L3.143 13.143V17.714C3.143 18.977 4.166 20 5.429 20",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), hr = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M18.5708 20C19.8328 20 20.8568 18.977 20.8568 17.714V13.143L21.9998 12L20.8568 10.857V6.286C20.8568 5.023 19.8338 4 18.5708 4M5.429 4C4.166 4 3.143 5.023 3.143 6.286V10.857L2 12L3.143 13.143V17.714C3.143 18.977 4.166 20 5.429 20M7.5 12L9.93431 14.4343C10.1323 14.6323 10.2313 14.7313 10.3455 14.7684C10.4459 14.8011 10.5541 14.8011 10.6545 14.7684C10.7687 14.7313 10.8677 14.6323 11.0657 14.4343L16.5 9",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), gr = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M18.5708 20C19.8328 20 20.8568 18.977 20.8568 17.714V13.143L21.9998 12L20.8568 10.857V6.286C20.8568 5.023 19.8338 4 18.5708 4M5.429 4C4.166 4 3.143 5.023 3.143 6.286V10.857L2 12L3.143 13.143V17.714C3.143 18.977 4.166 20 5.429 20M7.5 12H7.51M12 12H12.01M16.5 12H16.51M8 12C8 12.2761 7.77614 12.5 7.5 12.5C7.22386 12.5 7 12.2761 7 12C7 11.7239 7.22386 11.5 7.5 11.5C7.77614 11.5 8 11.7239 8 12ZM12.5 12C12.5 12.2761 12.2761 12.5 12 12.5C11.7239 12.5 11.5 12.2761 11.5 12C11.5 11.7239 11.7239 11.5 12 11.5C12.2761 11.5 12.5 11.7239 12.5 12ZM17 12C17 12.2761 16.7761 12.5 16.5 12.5C16.2239 12.5 16 12.2761 16 12C16 11.7239 16.2239 11.5 16.5 11.5C16.7761 11.5 17 11.7239 17 12Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), _r = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M18.5708 20C19.8328 20 20.8568 18.977 20.8568 17.714V13.143L21.9998 12L20.8568 10.857V6.286C20.8568 5.023 19.8338 4 18.5708 4M5.429 4C4.166 4 3.143 5.023 3.143 6.286V10.857L2 12L3.143 13.143V17.714C3.143 18.977 4.166 20 5.429 20M8 12H16",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), vr = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M18.5708 20C19.8328 20 20.8568 18.977 20.8568 17.714V13.143L21.9998 12L20.8568 10.857V6.286C20.8568 5.023 19.8338 4 18.5708 4M5.429 4C4.166 4 3.143 5.023 3.143 6.286V10.857L2 12L3.143 13.143V17.714C3.143 18.977 4.166 20 5.429 20M12 8V16M8 12H16",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), yr = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M18.5708 20C19.8328 20 20.8568 18.977 20.8568 17.714V13.143L21.9998 12L20.8568 10.857V6.286C20.8568 5.023 19.8338 4 18.5708 4M5.429 4C4.166 4 3.143 5.023 3.143 6.286V10.857L2 12L3.143 13.143V17.714C3.143 18.977 4.166 20 5.429 20M9 17L15 7",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), br = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M18.5708 20C19.8328 20 20.8568 18.977 20.8568 17.714V13.143L21.9998 12L20.8568 10.857V6.286C20.8568 5.023 19.8338 4 18.5708 4M5.429 4C4.166 4 3.143 5.023 3.143 6.286V10.857L2 12L3.143 13.143V17.714C3.143 18.977 4.166 20 5.429 20M15 9L9 15M9 9L15 15",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), xr = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M22 9H2M2 7.8L2 16.2C2 17.8802 2 18.7202 2.32698 19.362C2.6146 19.9265 3.07354 20.3854 3.63803 20.673C4.27976 21 5.11984 21 6.8 21H17.2C18.8802 21 19.7202 21 20.362 20.673C20.9265 20.3854 21.3854 19.9265 21.673 19.362C22 18.7202 22 17.8802 22 16.2V7.8C22 6.11984 22 5.27977 21.673 4.63803C21.3854 4.07354 20.9265 3.6146 20.362 3.32698C19.7202 3 18.8802 3 17.2 3L6.8 3C5.11984 3 4.27976 3 3.63803 3.32698C3.07354 3.6146 2.6146 4.07354 2.32698 4.63803C2 5.27976 2 6.11984 2 7.8Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Sr = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M16 18L22 12L16 6M8 6L2 12L8 18",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Cr = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M17 17L22 12L17 7M7 7L2 12L7 17M14 3L10 21",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), wr = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M22 9H2M14 17.5L16.5 15L14 12.5M10 12.5L7.5 15L10 17.5M2 7.8L2 16.2C2 17.8802 2 18.7202 2.32698 19.362C2.6146 19.9265 3.07354 20.3854 3.63803 20.673C4.27976 21 5.11984 21 6.8 21H17.2C18.8802 21 19.7202 21 20.362 20.673C20.9265 20.3854 21.3854 19.9265 21.673 19.362C22 18.7202 22 17.8802 22 16.2V7.8C22 6.11984 22 5.27977 21.673 4.63803C21.3854 4.07354 20.9265 3.6146 20.362 3.32698C19.7202 3 18.8802 3 17.2 3L6.8 3C5.11984 3 4.27976 3 3.63803 3.32698C3.07354 3.6146 2.6146 4.07354 2.32698 4.63803C2 5.27976 2 6.11984 2 7.8Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Tr = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M14.5 15L17.5 12L14.5 9M9.5 9L6.5 12L9.5 15M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Er = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M14 17L17 14L14 11M10 7L7 10L10 13M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Dr = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M15.5 15L18.5 12L15.5 9M8.5 9L5.5 12L8.5 15M13 7L11 17M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Or = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 9.00019L4.06386 14.1587C3.37601 14.6058 3.03209 14.8293 2.91297 15.1128C2.80888 15.3606 2.80888 15.6398 2.91297 15.8875M12 9.00019L19.9361 14.1587C20.624 14.6058 20.9679 14.8293 21.087 15.1128C21.1911 15.3606 21.1911 15.6398 21.087 15.8875M12 9.00019V2.50019M12 15.0002L4.06386 9.8417C3.37601 9.39459 3.03209 9.17104 2.91297 8.88755C2.80888 8.6398 2.80888 8.36057 2.91297 8.11282M12 15.0002L19.9361 9.8417C20.624 9.39459 20.9679 9.17104 21.087 8.88755C21.1911 8.6398 21.1911 8.36057 21.087 8.11282M12 15.0002V21.5002M21.272 15.9734L12.872 21.4334C12.5564 21.6386 12.3985 21.7411 12.2285 21.781C12.0782 21.8163 11.9218 21.8163 11.7715 21.781C11.6015 21.7411 11.4436 21.6386 11.128 21.4334L2.72802 15.9734C2.46201 15.8005 2.32901 15.714 2.23265 15.5987C2.14735 15.4966 2.08327 15.3786 2.04417 15.2514C2 15.1078 2 14.9491 2 14.6319V9.36848C2 9.05122 2 8.89259 2.04417 8.74895C2.08327 8.6218 2.14735 8.50372 2.23265 8.40165C2.32901 8.28633 2.46201 8.19988 2.72802 8.02697L11.128 2.56697C11.4436 2.36182 11.6015 2.25924 11.7715 2.21933C11.9218 2.18405 12.0782 2.18405 12.2285 2.21933C12.3985 2.25924 12.5564 2.36182 12.872 2.56697L21.272 8.02697C21.538 8.19988 21.671 8.28633 21.7674 8.40165C21.8527 8.50372 21.9167 8.6218 21.9558 8.74895C22 8.89259 22 9.05122 22 9.36848V14.6319C22 14.9491 22 15.1078 21.9558 15.2514C21.9167 15.3786 21.8527 15.4966 21.7674 15.5987C21.671 15.714 21.538 15.8005 21.272 15.9734Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), kr = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M14.5 15L17.5 12L14.5 9M9.5 9L6.5 12L9.5 15M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ar = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M14 17L17 14L14 11M10 7L7 10L10 13M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), jr = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M20.5 7.27783L12 12.0001M12 12.0001L3.49997 7.27783M12 12.0001L12 21.5001M21 16.0586V7.94153C21 7.59889 21 7.42757 20.9495 7.27477C20.9049 7.13959 20.8318 7.01551 20.7354 6.91082C20.6263 6.79248 20.4766 6.70928 20.177 6.54288L12.777 2.43177C12.4934 2.27421 12.3516 2.19543 12.2015 2.16454C12.0685 2.13721 11.9315 2.13721 11.7986 2.16454C11.6484 2.19543 11.5066 2.27421 11.223 2.43177L3.82297 6.54288C3.52345 6.70928 3.37369 6.79248 3.26463 6.91082C3.16816 7.01551 3.09515 7.13959 3.05048 7.27477C3 7.42757 3 7.59889 3 7.94153V16.0586C3 16.4013 3 16.5726 3.05048 16.7254C3.09515 16.8606 3.16816 16.9847 3.26463 17.0893C3.37369 17.2077 3.52345 17.2909 3.82297 17.4573L11.223 21.5684C11.5066 21.726 11.6484 21.8047 11.7986 21.8356C11.9315 21.863 12.0685 21.863 12.2015 21.8356C12.3516 21.8047 12.4934 21.726 12.777 21.5684L20.177 17.4573C20.4766 17.2909 20.6263 17.2077 20.7354 17.0893C20.8318 16.9847 20.9049 16.8606 20.9495 16.7254C21 16.5726 21 16.4013 21 16.0586Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Mr = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9 2V4M15 2V4M9 20V22M15 20V22M20 9H22M20 14H22M2 9H4M2 14H4M8.8 20H15.2C16.8802 20 17.7202 20 18.362 19.673C18.9265 19.3854 19.3854 18.9265 19.673 18.362C20 17.7202 20 16.8802 20 15.2V8.8C20 7.11984 20 6.27976 19.673 5.63803C19.3854 5.07354 18.9265 4.6146 18.362 4.32698C17.7202 4 16.8802 4 15.2 4H8.8C7.11984 4 6.27976 4 5.63803 4.32698C5.07354 4.6146 4.6146 5.07354 4.32698 5.63803C4 6.27976 4 7.11984 4 8.8V15.2C4 16.8802 4 17.7202 4.32698 18.362C4.6146 18.9265 5.07354 19.3854 5.63803 19.673C6.27976 20 7.11984 20 8.8 20ZM10.6 15H13.4C13.9601 15 14.2401 15 14.454 14.891C14.6422 14.7951 14.7951 14.6422 14.891 14.454C15 14.2401 15 13.9601 15 13.4V10.6C15 10.0399 15 9.75992 14.891 9.54601C14.7951 9.35785 14.6422 9.20487 14.454 9.10899C14.2401 9 13.9601 9 13.4 9H10.6C10.0399 9 9.75992 9 9.54601 9.10899C9.35785 9.20487 9.20487 9.35785 9.10899 9.54601C9 9.75992 9 10.0399 9 10.6V13.4C9 13.9601 9 14.2401 9.10899 14.454C9.20487 14.6422 9.35785 14.7951 9.54601 14.891C9.75992 15 10.0399 15 10.6 15Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Nr = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9 2V5M15 2V5M9 19V22M15 19V22M19 9H22M19 14H22M2 9H5M2 14H5M9.8 19H14.2C15.8802 19 16.7202 19 17.362 18.673C17.9265 18.3854 18.3854 17.9265 18.673 17.362C19 16.7202 19 15.8802 19 14.2V9.8C19 8.11984 19 7.27976 18.673 6.63803C18.3854 6.07354 17.9265 5.6146 17.362 5.32698C16.7202 5 15.8802 5 14.2 5H9.8C8.11984 5 7.27976 5 6.63803 5.32698C6.07354 5.6146 5.6146 6.07354 5.32698 6.63803C5 7.27976 5 8.11984 5 9.8V14.2C5 15.8802 5 16.7202 5.32698 17.362C5.6146 17.9265 6.07354 18.3854 6.63803 18.673C7.27976 19 8.11984 19 9.8 19Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Pr = (e) => /* @__PURE__ */ o("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ a("path", {
			d: "M21.2 22C21.48 22 21.62 22 21.727 21.9455C21.8211 21.8976 21.8976 21.8211 21.9455 21.727C22 21.62 22 21.48 22 21.2V10.8C22 10.52 22 10.38 21.9455 10.273C21.8976 10.1789 21.8211 10.1024 21.727 10.0545C21.62 10 21.48 10 21.2 10L18.8 10C18.52 10 18.38 10 18.273 10.0545C18.1789 10.1024 18.1024 10.1789 18.0545 10.273C18 10.38 18 10.52 18 10.8V13.2C18 13.48 18 13.62 17.9455 13.727C17.8976 13.8211 17.8211 13.8976 17.727 13.9455C17.62 14 17.48 14 17.2 14H14.8C14.52 14 14.38 14 14.273 14.0545C14.1789 14.1024 14.1024 14.1789 14.0545 14.273C14 14.38 14 14.52 14 14.8V17.2C14 17.48 14 17.62 13.9455 17.727C13.8976 17.8211 13.8211 17.8976 13.727 17.9455C13.62 18 13.48 18 13.2 18H10.8C10.52 18 10.38 18 10.273 18.0545C10.1789 18.1024 10.1024 18.1789 10.0545 18.273C10 18.38 10 18.52 10 18.8V21.2C10 21.48 10 21.62 10.0545 21.727C10.1024 21.8211 10.1789 21.8976 10.273 21.9455C10.38 22 10.52 22 10.8 22L21.2 22Z",
			stroke: "black",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ a("path", {
			d: "M10 6.8C10 6.51997 10 6.37996 10.0545 6.273C10.1024 6.17892 10.1789 6.10243 10.273 6.0545C10.38 6 10.52 6 10.8 6H13.2C13.48 6 13.62 6 13.727 6.0545C13.8211 6.10243 13.8976 6.17892 13.9455 6.273C14 6.37996 14 6.51997 14 6.8V9.2C14 9.48003 14 9.62004 13.9455 9.727C13.8976 9.82108 13.8211 9.89757 13.727 9.9455C13.62 10 13.48 10 13.2 10H10.8C10.52 10 10.38 10 10.273 9.9455C10.1789 9.89757 10.1024 9.82108 10.0545 9.727C10 9.62004 10 9.48003 10 9.2V6.8Z",
			stroke: "black",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ a("path", {
			d: "M3 12.8C3 12.52 3 12.38 3.0545 12.273C3.10243 12.1789 3.17892 12.1024 3.273 12.0545C3.37996 12 3.51997 12 3.8 12H6.2C6.48003 12 6.62004 12 6.727 12.0545C6.82108 12.1024 6.89757 12.1789 6.9455 12.273C7 12.38 7 12.52 7 12.8V15.2C7 15.48 7 15.62 6.9455 15.727C6.89757 15.8211 6.82108 15.8976 6.727 15.9455C6.62004 16 6.48003 16 6.2 16H3.8C3.51997 16 3.37996 16 3.273 15.9455C3.17892 15.8976 3.10243 15.8211 3.0545 15.727C3 15.62 3 15.48 3 15.2V12.8Z",
			stroke: "black",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ a("path", {
			d: "M2 2.8C2 2.51997 2 2.37996 2.0545 2.273C2.10243 2.17892 2.17892 2.10243 2.273 2.0545C2.37996 2 2.51997 2 2.8 2H5.2C5.48003 2 5.62004 2 5.727 2.0545C5.82108 2.10243 5.89757 2.17892 5.9455 2.273C6 2.37996 6 2.51997 6 2.8V5.2C6 5.48003 6 5.62004 5.9455 5.727C5.89757 5.82108 5.82108 5.89757 5.727 5.9455C5.62004 6 5.48003 6 5.2 6H2.8C2.51997 6 2.37996 6 2.273 5.9455C2.17892 5.89757 2.10243 5.82108 2.0545 5.727C2 5.62004 2 5.48003 2 5.2V2.8Z",
			stroke: "black",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
}), Fr = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M21 5C21 6.65685 16.9706 8 12 8C7.02944 8 3 6.65685 3 5M21 5C21 3.34315 16.9706 2 12 2C7.02944 2 3 3.34315 3 5M21 5V19C21 20.66 17 22 12 22C7 22 3 20.66 3 19V5M21 12C21 13.66 17 15 12 15C7 15 3 13.66 3 12",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ir = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M21 5C21 6.65685 16.9706 8 12 8C7.02944 8 3 6.65685 3 5M21 5C21 3.34315 16.9706 2 12 2C7.02944 2 3 3.34315 3 5M21 5V19C21 20.66 17 22 12 22C7 22 3 20.66 3 19V5M21 9.72021C21 11.3802 17 12.7202 12 12.7202C7 12.7202 3 11.3802 3 9.72021M21 14.44C21 16.1 17 17.44 12 17.44C7 17.44 3 16.1 3 14.44",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Lr = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M14 20C14 21.1046 13.1046 22 12 22C10.8954 22 10 21.1046 10 20M14 20C14 18.8954 13.1046 18 12 18M14 20H21M10 20C10 18.8954 10.8954 18 12 18M10 20H3M12 18V14M21 5C21 6.65685 16.9706 8 12 8C7.02944 8 3 6.65685 3 5M21 5C21 3.34315 16.9706 2 12 2C7.02944 2 3 3.34315 3 5M21 5V11C21 12.66 17 14 12 14M3 5V11C3 12.66 7 14 12 14",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Rr = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 4V15.2C12 16.8802 12 17.7202 12.327 18.362C12.6146 18.9265 13.0735 19.3854 13.638 19.673C14.2798 20 15.1198 20 16.8 20H17M17 20C17 21.1046 17.8954 22 19 22C20.1046 22 21 21.1046 21 20C21 18.8954 20.1046 18 19 18C17.8954 18 17 18.8954 17 20ZM7 4L17 4M7 4C7 5.10457 6.10457 6 5 6C3.89543 6 3 5.10457 3 4C3 2.89543 3.89543 2 5 2C6.10457 2 7 2.89543 7 4ZM17 4C17 5.10457 17.8954 6 19 6C20.1046 6 21 5.10457 21 4C21 2.89543 20.1046 2 19 2C17.8954 2 17 2.89543 17 4ZM12 12H17M17 12C17 13.1046 17.8954 14 19 14C20.1046 14 21 13.1046 21 12C21 10.8954 20.1046 10 19 10C17.8954 10 17 10.8954 17 12Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), zr = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M11 4.5H18.3C19.4201 4.5 19.9802 4.5 20.408 4.71799C20.7843 4.90973 21.0903 5.21569 21.282 5.59202C21.5 6.01984 21.5 6.57989 21.5 7.7V9C21.5 9.93188 21.5 10.3978 21.3478 10.7654C21.1448 11.2554 20.7554 11.6448 20.2654 11.8478C19.8978 12 19.4319 12 18.5 12M13 19.5H5.7C4.5799 19.5 4.01984 19.5 3.59202 19.282C3.21569 19.0903 2.90973 18.7843 2.71799 18.408C2.5 17.9802 2.5 17.4201 2.5 16.3V15C2.5 14.0681 2.5 13.6022 2.65224 13.2346C2.85523 12.7446 3.24458 12.3552 3.73463 12.1522C4.10218 12 4.56812 12 5.5 12M10.3 14.5H13.7C13.98 14.5 14.12 14.5 14.227 14.4455C14.3211 14.3976 14.3976 14.3211 14.4455 14.227C14.5 14.12 14.5 13.98 14.5 13.7V10.3C14.5 10.02 14.5 9.87996 14.4455 9.773C14.3976 9.67892 14.3211 9.60243 14.227 9.5545C14.12 9.5 13.98 9.5 13.7 9.5H10.3C10.02 9.5 9.87996 9.5 9.773 9.5545C9.67892 9.60243 9.60243 9.67892 9.5545 9.773C9.5 9.87996 9.5 10.02 9.5 10.3V13.7C9.5 13.98 9.5 14.12 9.5545 14.227C9.60243 14.3211 9.67892 14.3976 9.773 14.4455C9.87996 14.5 10.02 14.5 10.3 14.5ZM17.8 22H21.2C21.48 22 21.62 22 21.727 21.9455C21.8211 21.8976 21.8976 21.8211 21.9455 21.727C22 21.62 22 21.48 22 21.2V17.8C22 17.52 22 17.38 21.9455 17.273C21.8976 17.1789 21.8211 17.1024 21.727 17.0545C21.62 17 21.48 17 21.2 17H17.8C17.52 17 17.38 17 17.273 17.0545C17.1789 17.1024 17.1024 17.1789 17.0545 17.273C17 17.38 17 17.52 17 17.8V21.2C17 21.48 17 21.62 17.0545 21.727C17.1024 21.8211 17.1789 21.8976 17.273 21.9455C17.38 22 17.52 22 17.8 22ZM2.8 7H6.2C6.48003 7 6.62004 7 6.727 6.9455C6.82108 6.89757 6.89757 6.82108 6.9455 6.727C7 6.62004 7 6.48003 7 6.2V2.8C7 2.51997 7 2.37996 6.9455 2.273C6.89757 2.17892 6.82108 2.10243 6.727 2.0545C6.62004 2 6.48003 2 6.2 2H2.8C2.51997 2 2.37996 2 2.273 2.0545C2.17892 2.10243 2.10243 2.17892 2.0545 2.273C2 2.37996 2 2.51997 2 2.8V6.2C2 6.48003 2 6.62004 2.0545 6.727C2.10243 6.82108 2.17892 6.89757 2.273 6.9455C2.37996 7 2.51997 7 2.8 7Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Br = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M4 18V17.8C4 16.1198 4 15.2798 4.32698 14.638C4.6146 14.0735 5.07354 13.6146 5.63803 13.327C6.27976 13 7.11984 13 8.8 13H15.2C16.8802 13 17.7202 13 18.362 13.327C18.9265 13.6146 19.3854 14.0735 19.673 14.638C20 15.2798 20 16.1198 20 17.8V18M4 18C2.89543 18 2 18.8954 2 20C2 21.1046 2.89543 22 4 22C5.10457 22 6 21.1046 6 20C6 18.8954 5.10457 18 4 18ZM20 18C18.8954 18 18 18.8954 18 20C18 21.1046 18.8954 22 20 22C21.1046 22 22 21.1046 22 20C22 18.8954 21.1046 18 20 18ZM12 18C10.8954 18 10 18.8954 10 20C10 21.1046 10.8954 22 12 22C13.1046 22 14 21.1046 14 20C14 18.8954 13.1046 18 12 18ZM12 18V8M6 8H18C18.9319 8 19.3978 8 19.7654 7.84776C20.2554 7.64477 20.6448 7.25542 20.8478 6.76537C21 6.39782 21 5.93188 21 5C21 4.06812 21 3.60218 20.8478 3.23463C20.6448 2.74458 20.2554 2.35523 19.7654 2.15224C19.3978 2 18.9319 2 18 2H6C5.06812 2 4.60218 2 4.23463 2.15224C3.74458 2.35523 3.35523 2.74458 3.15224 3.23463C3 3.60218 3 4.06812 3 5C3 5.93188 3 6.39782 3.15224 6.76537C3.35523 7.25542 3.74458 7.64477 4.23463 7.84776C4.60218 8 5.06812 8 6 8Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Vr = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M8 14C8 14 9.5 16 12 16C14.5 16 16 14 16 14M17 9.24C16.605 9.725 16.065 10 15.5 10C14.935 10 14.41 9.725 14 9.24M10 9.24C9.605 9.725 9.065 10 8.5 10C7.935 10 7.41 9.725 7 9.24M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Hr = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M16 16C16 16 14.5 14 12 14C9.5 14 8 16 8 16M15 9H15.01M9 9H9.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM15.5 9C15.5 9.27614 15.2761 9.5 15 9.5C14.7239 9.5 14.5 9.27614 14.5 9C14.5 8.72386 14.7239 8.5 15 8.5C15.2761 8.5 15.5 8.72386 15.5 9ZM9.5 9C9.5 9.27614 9.27614 9.5 9 9.5C8.72386 9.5 8.5 9.27614 8.5 9C8.5 8.72386 8.72386 8.5 9 8.5C9.27614 8.5 9.5 8.72386 9.5 9Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ur = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M15 9H15.01M9 9H9.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM15.5 9C15.5 9.27614 15.2761 9.5 15 9.5C14.7239 9.5 14.5 9.27614 14.5 9C14.5 8.72386 14.7239 8.5 15 8.5C15.2761 8.5 15.5 8.72386 15.5 9ZM9.5 9C9.5 9.27614 9.27614 9.5 9 9.5C8.72386 9.5 8.5 9.27614 8.5 9C8.5 8.72386 8.72386 8.5 9 8.5C9.27614 8.5 9.5 8.72386 9.5 9ZM12 17.5C14.5005 17.5 16.5 15.667 16.5 14H7.5C7.5 15.667 9.4995 17.5 12 17.5Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Wr = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M8 15H16M15 9H15.01M9 9H9.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM15.5 9C15.5 9.27614 15.2761 9.5 15 9.5C14.7239 9.5 14.5 9.27614 14.5 9C14.5 8.72386 14.7239 8.5 15 8.5C15.2761 8.5 15.5 8.72386 15.5 9ZM9.5 9C9.5 9.27614 9.27614 9.5 9 9.5C8.72386 9.5 8.5 9.27614 8.5 9C8.5 8.72386 8.72386 8.5 9 8.5C9.27614 8.5 9.5 8.72386 9.5 9Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Gr = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M16 16C16 16 14.5 14 12 14C9.5 14 8 16 8 16M17 9.24C16.605 9.725 16.065 10 15.5 10C14.935 10 14.41 9.725 14 9.24M10 9.24C9.605 9.725 9.065 10 8.5 10C7.935 10 7.41 9.725 7 9.24M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Kr = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M8 14C8 14 9.5 16 12 16C14.5 16 16 14 16 14M15 9H15.01M9 9H9.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM15.5 9C15.5 9.27614 15.2761 9.5 15 9.5C14.7239 9.5 14.5 9.27614 14.5 9C14.5 8.72386 14.7239 8.5 15 8.5C15.2761 8.5 15.5 8.72386 15.5 9ZM9.5 9C9.5 9.27614 9.27614 9.5 9 9.5C8.72386 9.5 8.5 9.27614 8.5 9C8.5 8.72386 8.72386 8.5 9 8.5C9.27614 8.5 9.5 8.72386 9.5 9Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), qr = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M8 14C8 14 9.5 16 12 16C14.5 16 16 14 16 14M15 9H15.01M8 9H10M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM15.5 9C15.5 9.27614 15.2761 9.5 15 9.5C14.7239 9.5 14.5 9.27614 14.5 9C14.5 8.72386 14.7239 8.5 15 8.5C15.2761 8.5 15.5 8.72386 15.5 9Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Jr = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M14 2.26953V6.40007C14 6.96012 14 7.24015 14.109 7.45406C14.2049 7.64222 14.3578 7.7952 14.546 7.89108C14.7599 8.00007 15.0399 8.00007 15.6 8.00007H19.7305M14 17.5L16.5 15L14 12.5M10 12.5L7.5 15L10 17.5M20 9.98822V17.2C20 18.8802 20 19.7202 19.673 20.362C19.3854 20.9265 18.9265 21.3854 18.362 21.673C17.7202 22 16.8802 22 15.2 22H8.8C7.11984 22 6.27976 22 5.63803 21.673C5.07354 21.3854 4.6146 20.9265 4.32698 20.362C4 19.7202 4 18.8802 4 17.2V6.8C4 5.11984 4 4.27976 4.32698 3.63803C4.6146 3.07354 5.07354 2.6146 5.63803 2.32698C6.27976 2 7.11984 2 8.8 2H12.0118C12.7455 2 13.1124 2 13.4577 2.08289C13.7638 2.15638 14.0564 2.27759 14.3249 2.44208C14.6276 2.6276 14.887 2.88703 15.4059 3.40589L18.5941 6.59411C19.113 7.11297 19.3724 7.3724 19.5579 7.67515C19.7224 7.94356 19.8436 8.2362 19.9171 8.5423C20 8.88757 20 9.25445 20 9.98822Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Yr = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M5 18.5C5 18.9644 5 19.1966 5.02567 19.3916C5.2029 20.7378 6.26222 21.7971 7.60842 21.9743C7.80337 22 8.03558 22 8.5 22H16.2C17.8802 22 18.7202 22 19.362 21.673C19.9265 21.3854 20.3854 20.9265 20.673 20.362C21 19.7202 21 18.8802 21 17.2V9.98822C21 9.25445 21 8.88757 20.9171 8.5423C20.8436 8.2362 20.7224 7.94356 20.5579 7.67515C20.3724 7.3724 20.113 7.11296 19.5941 6.59411L16.4059 3.40589C15.887 2.88703 15.6276 2.6276 15.3249 2.44208C15.0564 2.27759 14.7638 2.15638 14.4577 2.08289C14.1124 2 13.7455 2 13.0118 2H8.5C8.03558 2 7.80337 2 7.60842 2.02567C6.26222 2.2029 5.2029 3.26222 5.02567 4.60842C5 4.80337 5 5.03558 5 5.5M9 14.5L11.5 12L9 9.5M5 9.5L2.5 12L5 14.5",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Xr = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M13 7L11.8845 4.76892C11.5634 4.1268 11.4029 3.80573 11.1634 3.57116C10.9516 3.36373 10.6963 3.20597 10.4161 3.10931C10.0992 3 9.74021 3 9.02229 3H5.2C4.0799 3 3.51984 3 3.09202 3.21799C2.71569 3.40973 2.40973 3.71569 2.21799 4.09202C2 4.51984 2 5.0799 2 6.2V7M2 7H17.2C18.8802 7 19.7202 7 20.362 7.32698C20.9265 7.6146 21.3854 8.07354 21.673 8.63803C22 9.27976 22 10.1198 22 11.8V16.2C22 17.8802 22 18.7202 21.673 19.362C21.3854 19.9265 20.9265 20.3854 20.362 20.673C19.7202 21 18.8802 21 17.2 21H6.8C5.11984 21 4.27976 21 3.63803 20.673C3.07354 20.3854 2.6146 19.9265 2.32698 19.362C2 18.7202 2 17.8802 2 16.2V7ZM14 16.5L16.5 14L14 11.5M10 11.5L7.5 14L10 16.5",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Zr = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M3 3V13.2C3 14.8802 3 15.7202 3.32698 16.362C3.6146 16.9265 4.07354 17.3854 4.63803 17.673C5.27976 18 6.11984 18 7.8 18H15M15 18C15 19.6569 16.3431 21 18 21C19.6569 21 21 19.6569 21 18C21 16.3431 19.6569 15 18 15C16.3431 15 15 16.3431 15 18ZM3 8L15 8M15 8C15 9.65686 16.3431 11 18 11C19.6569 11 21 9.65685 21 8C21 6.34315 19.6569 5 18 5C16.3431 5 15 6.34315 15 8Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Qr = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M6 3V15M6 15C4.34315 15 3 16.3431 3 18C3 19.6569 4.34315 21 6 21C7.65685 21 9 19.6569 9 18M6 15C7.65685 15 9 16.3431 9 18M18 9C19.6569 9 21 7.65685 21 6C21 4.34315 19.6569 3 18 3C16.3431 3 15 4.34315 15 6C15 7.65685 16.3431 9 18 9ZM18 9C18 11.3869 17.0518 13.6761 15.364 15.364C13.6761 17.0518 11.3869 18 9 18",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), $r = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M16 12C16 14.2091 14.2091 16 12 16C9.79085 16 7.99999 14.2091 7.99999 12M16 12C16 9.79086 14.2091 8 12 8C9.79085 8 7.99999 9.79086 7.99999 12M16 12H22M7.99999 12H2.00018",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ei = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M15 18C15 19.6569 16.3431 21 18 21C19.6569 21 21 19.6569 21 18C21 16.3431 19.6569 15 18 15C16.3431 15 15 16.3431 15 18ZM15 18C12.6131 18 10.3239 17.0518 8.63604 15.364C6.94821 13.6761 6 11.3869 6 9M6 9C7.65685 9 9 7.65685 9 6C9 4.34315 7.65685 3 6 3C4.34315 3 3 4.34315 3 6C3 7.65685 4.34315 9 6 9ZM6 9V21",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ti = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M18 15C16.3431 15 15 16.3431 15 18C15 19.6569 16.3431 21 18 21C19.6569 21 21 19.6569 21 18C21 16.3431 19.6569 15 18 15ZM18 15V8C18 7.46957 17.7893 6.96086 17.4142 6.58579C17.0391 6.21071 16.5304 6 16 6H13M6 9C7.65685 9 9 7.65685 9 6C9 4.34315 7.65685 3 6 3C4.34315 3 3 4.34315 3 6C3 7.65685 4.34315 9 6 9ZM6 9V21",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ni = (e) => /* @__PURE__ */ o("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ a("path", {
		d: "M20.5 7.27783L12 12.0001M12 12.0001L3.49997 7.27783M12 12.0001L12 21.5001M21 16.0586V7.94153C21 7.59889 21 7.42757 20.9495 7.27477C20.9049 7.13959 20.8318 7.01551 20.7354 6.91082C20.6263 6.79248 20.4766 6.70928 20.177 6.54288L12.777 2.43177C12.4934 2.27421 12.3516 2.19543 12.2015 2.16454C12.0685 2.13721 11.9315 2.13721 11.7986 2.16454C11.6484 2.19543 11.5066 2.27421 11.223 2.43177L3.82297 6.54288C3.52345 6.70928 3.37369 6.79248 3.26463 6.91082C3.16816 7.01551 3.09515 7.13959 3.05048 7.27477C3 7.42757 3 7.59889 3 7.94153V16.0586C3 16.4013 3 16.5726 3.05048 16.7254C3.09515 16.8606 3.16816 16.9847 3.26463 17.0893C3.37369 17.2077 3.52345 17.2909 3.82297 17.4573L11.223 21.5684C11.5066 21.726 11.6484 21.8047 11.7986 21.8356C11.9315 21.863 12.0685 21.863 12.2015 21.8356C12.3516 21.8047 12.4934 21.726 12.777 21.5684L20.177 17.4573C20.4766 17.2909 20.6263 17.2077 20.7354 17.0893C20.8318 16.9847 20.9049 16.8606 20.9495 16.7254C21 16.5726 21 16.4013 21 16.0586Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ a("path", {
		d: "M16.5 9.5L7.5 4.5",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
}), ri = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M20.5 7.27783L12 12.0001M12 12.0001L3.49997 7.27783M12 12.0001L12 21.5001M14 20.889L12.777 21.5684C12.4934 21.726 12.3516 21.8047 12.2015 21.8356C12.0685 21.863 11.9315 21.863 11.7986 21.8356C11.6484 21.8047 11.5066 21.726 11.223 21.5684L3.82297 17.4573C3.52346 17.2909 3.37368 17.2077 3.26463 17.0893C3.16816 16.9847 3.09515 16.8606 3.05048 16.7254C3 16.5726 3 16.4013 3 16.0586V7.94153C3 7.59889 3 7.42757 3.05048 7.27477C3.09515 7.13959 3.16816 7.01551 3.26463 6.91082C3.37368 6.79248 3.52345 6.70928 3.82297 6.54288L11.223 2.43177C11.5066 2.27421 11.6484 2.19543 11.7986 2.16454C11.9315 2.13721 12.0685 2.13721 12.2015 2.16454C12.3516 2.19543 12.4934 2.27421 12.777 2.43177L20.177 6.54288C20.4766 6.70928 20.6263 6.79248 20.7354 6.91082C20.8318 7.01551 20.9049 7.13959 20.9495 7.27477C21 7.42757 21 7.59889 21 7.94153L21 12.5001M7.5 4.50008L16.5 9.50008M16 18.0001L18 20.0001L22 16.0001",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ii = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M20.5 7.27783L12 12.0001M12 12.0001L3.49997 7.27783M12 12.0001L12 21.5001M14 20.889L12.777 21.5684C12.4934 21.726 12.3516 21.8047 12.2015 21.8356C12.0685 21.863 11.9315 21.863 11.7986 21.8356C11.6484 21.8047 11.5066 21.726 11.223 21.5684L3.82297 17.4573C3.52346 17.2909 3.37368 17.2077 3.26463 17.0893C3.16816 16.9847 3.09515 16.8606 3.05048 16.7254C3 16.5726 3 16.4013 3 16.0586V7.94153C3 7.59889 3 7.42757 3.05048 7.27477C3.09515 7.13959 3.16816 7.01551 3.26463 6.91082C3.37368 6.79248 3.52345 6.70928 3.82297 6.54288L11.223 2.43177C11.5066 2.27421 11.6484 2.19543 11.7986 2.16454C11.9315 2.13721 12.0685 2.13721 12.2015 2.16454C12.3516 2.19543 12.4934 2.27421 12.777 2.43177L20.177 6.54288C20.4766 6.70928 20.6263 6.79248 20.7354 6.91082C20.8318 7.01551 20.9049 7.13959 20.9495 7.27477C21 7.42757 21 7.59889 21 7.94153V13.0001M7.5 4.50008L16.5 9.50008M16 18.0001H22",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ai = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M20.5 7.27783L12 12.0001M12 12.0001L3.49997 7.27783M12 12.0001L12 21.5001M14 20.889L12.777 21.5684C12.4934 21.726 12.3516 21.8047 12.2015 21.8356C12.0685 21.863 11.9315 21.863 11.7986 21.8356C11.6484 21.8047 11.5066 21.726 11.223 21.5684L3.82297 17.4573C3.52346 17.2909 3.37368 17.2077 3.26463 17.0893C3.16816 16.9847 3.09515 16.8606 3.05048 16.7254C3 16.5726 3 16.4013 3 16.0586V7.94153C3 7.59889 3 7.42757 3.05048 7.27477C3.09515 7.13959 3.16816 7.01551 3.26463 6.91082C3.37368 6.79248 3.52345 6.70928 3.82297 6.54288L11.223 2.43177C11.5066 2.27421 11.6484 2.19543 11.7986 2.16454C11.9315 2.13721 12.0685 2.13721 12.2015 2.16454C12.3516 2.19543 12.4934 2.27421 12.777 2.43177L20.177 6.54288C20.4766 6.70928 20.6263 6.79248 20.7354 6.91082C20.8318 7.01551 20.9049 7.13959 20.9495 7.27477C21 7.42757 21 7.59889 21 7.94153L21 12.5001M7.5 4.50008L16.5 9.50008M19 21.0001V15.0001M16 18.0001H22",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), oi = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M20.5 7.27783L12 12.0001M12 12.0001L3.49997 7.27783M12 12.0001L12 21.5001M21 12.0001V7.94153C21 7.59889 21 7.42757 20.9495 7.27477C20.9049 7.13959 20.8318 7.01551 20.7354 6.91082C20.6263 6.79248 20.4766 6.70928 20.177 6.54288L12.777 2.43177C12.4934 2.27421 12.3516 2.19543 12.2015 2.16454C12.0685 2.13721 11.9315 2.13721 11.7986 2.16454C11.6484 2.19543 11.5066 2.27421 11.223 2.43177L3.82297 6.54288C3.52345 6.70928 3.37368 6.79248 3.26463 6.91082C3.16816 7.01551 3.09515 7.13959 3.05048 7.27477C3 7.42757 3 7.59889 3 7.94153V16.0586C3 16.4013 3 16.5726 3.05048 16.7254C3.09515 16.8606 3.16816 16.9847 3.26463 17.0893C3.37368 17.2077 3.52346 17.2909 3.82297 17.4573L11.223 21.5684C11.5066 21.726 11.6484 21.8047 11.7986 21.8356C11.9315 21.863 12.0685 21.863 12.2015 21.8356C12.3516 21.8047 12.4934 21.726 12.777 21.5684L13 21.4445M7.5 4.50008L16.5 9.50008M22 21.5001L21 20.5001M22 18.0001C22 19.6569 20.6569 21.0001 19 21.0001C17.3431 21.0001 16 19.6569 16 18.0001C16 16.3432 17.3431 15.0001 19 15.0001C20.6569 15.0001 22 16.3432 22 18.0001Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), si = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M20.5 7.27783L12 12.0001M12 12.0001L3.49997 7.27783M12 12.0001L12 21.5001M21 12.5001L21 7.94153C21 7.59889 21 7.42757 20.9495 7.27477C20.9049 7.13959 20.8318 7.01551 20.7354 6.91082C20.6263 6.79248 20.4766 6.70928 20.177 6.54288L12.777 2.43177C12.4934 2.27421 12.3516 2.19543 12.2015 2.16454C12.0685 2.13721 11.9315 2.13721 11.7986 2.16454C11.6484 2.19543 11.5066 2.27421 11.223 2.43177L3.82297 6.54288C3.52345 6.70928 3.37368 6.79248 3.26463 6.91082C3.16816 7.01551 3.09515 7.13959 3.05048 7.27477C3 7.42757 3 7.59889 3 7.94153V16.0586C3 16.4013 3 16.5726 3.05048 16.7254C3.09515 16.8606 3.16816 16.9847 3.26463 17.0893C3.37368 17.2077 3.52346 17.2909 3.82297 17.4573L11.223 21.5684C11.5066 21.726 11.6484 21.8047 11.7986 21.8356C11.9315 21.863 12.0685 21.863 12.2015 21.8356C12.3516 21.8047 12.4934 21.726 12.777 21.5684L13 21.4445M7.5 4.50008L16.5 9.50008M16.5 16.0001L21.5 21.0001M21.5 16.0001L16.5 21.0001",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ci = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M7.5 4.5C7.5 3.11929 8.61929 2 10 2C11.3807 2 12.5 3.11929 12.5 4.5V6H13.5C14.8978 6 15.5967 6 16.1481 6.22836C16.8831 6.53284 17.4672 7.11687 17.7716 7.85195C18 8.40326 18 9.10218 18 10.5H19.5C20.8807 10.5 22 11.6193 22 13C22 14.3807 20.8807 15.5 19.5 15.5H18V17.2C18 18.8802 18 19.7202 17.673 20.362C17.3854 20.9265 16.9265 21.3854 16.362 21.673C15.7202 22 14.8802 22 13.2 22H12.5V20.25C12.5 19.0074 11.4926 18 10.25 18C9.00736 18 8 19.0074 8 20.25V22H6.8C5.11984 22 4.27976 22 3.63803 21.673C3.07354 21.3854 2.6146 20.9265 2.32698 20.362C2 19.7202 2 18.8802 2 17.2V15.5H3.5C4.88071 15.5 6 14.3807 6 13C6 11.6193 4.88071 10.5 3.5 10.5H2C2 9.10218 2 8.40326 2.22836 7.85195C2.53284 7.11687 3.11687 6.53284 3.85195 6.22836C4.40326 6 5.10218 6 6.5 6H7.5V4.5Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), li = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 2L15.6 5.6C18 -0.7 24.7 6 18.4 8.4L22 12L18.4 15.6C16 9.3 9.3 16 15.6 18.4L12 22L8.4 18.4C6 24.7 -0.7 18 5.6 15.6L2 12L5.6 8.4C8 14.7 14.7 8 8.4 5.6L12 2Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ui = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M7 12H12V17M3.01 12H3M8.01 17H8M12.01 21H12M21.01 12H21M3 17H4.5M15.5 12H17.5M3 21H8M12 2V8M17.6 21H19.4C19.9601 21 20.2401 21 20.454 20.891C20.6422 20.7951 20.7951 20.6422 20.891 20.454C21 20.2401 21 19.9601 21 19.4V17.6C21 17.0399 21 16.7599 20.891 16.546C20.7951 16.3578 20.6422 16.2049 20.454 16.109C20.2401 16 19.9601 16 19.4 16H17.6C17.0399 16 16.7599 16 16.546 16.109C16.3578 16.2049 16.2049 16.3578 16.109 16.546C16 16.7599 16 17.0399 16 17.6V19.4C16 19.9601 16 20.2401 16.109 20.454C16.2049 20.6422 16.3578 20.7951 16.546 20.891C16.7599 21 17.0399 21 17.6 21ZM17.6 8H19.4C19.9601 8 20.2401 8 20.454 7.89101C20.6422 7.79513 20.7951 7.64215 20.891 7.45399C21 7.24008 21 6.96005 21 6.4V4.6C21 4.03995 21 3.75992 20.891 3.54601C20.7951 3.35785 20.6422 3.20487 20.454 3.10899C20.2401 3 19.9601 3 19.4 3H17.6C17.0399 3 16.7599 3 16.546 3.10899C16.3578 3.20487 16.2049 3.35785 16.109 3.54601C16 3.75992 16 4.03995 16 4.6V6.4C16 6.96005 16 7.24008 16.109 7.45399C16.2049 7.64215 16.3578 7.79513 16.546 7.89101C16.7599 8 17.0399 8 17.6 8ZM4.6 8H6.4C6.96005 8 7.24008 8 7.45399 7.89101C7.64215 7.79513 7.79513 7.64215 7.89101 7.45399C8 7.24008 8 6.96005 8 6.4V4.6C8 4.03995 8 3.75992 7.89101 3.54601C7.79513 3.35785 7.64215 3.20487 7.45399 3.10899C7.24008 3 6.96005 3 6.4 3H4.6C4.03995 3 3.75992 3 3.54601 3.10899C3.35785 3.20487 3.20487 3.35785 3.10899 3.54601C3 3.75992 3 4.03995 3 4.6V6.4C3 6.96005 3 7.24008 3.10899 7.45399C3.20487 7.64215 3.35785 7.79513 3.54601 7.89101C3.75992 8 4.03995 8 4.6 8Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), di = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M6.5 6.5H6.51M17.5 6.5H17.51M6.5 17.5H6.51M13 13H13.01M17.5 17.5H17.51M17 21H21V17M14 16.5V21M21 14H16.5M15.6 10H19.4C19.9601 10 20.2401 10 20.454 9.89101C20.6422 9.79513 20.7951 9.64215 20.891 9.45399C21 9.24008 21 8.96005 21 8.4V4.6C21 4.03995 21 3.75992 20.891 3.54601C20.7951 3.35785 20.6422 3.20487 20.454 3.10899C20.2401 3 19.9601 3 19.4 3H15.6C15.0399 3 14.7599 3 14.546 3.10899C14.3578 3.20487 14.2049 3.35785 14.109 3.54601C14 3.75992 14 4.03995 14 4.6V8.4C14 8.96005 14 9.24008 14.109 9.45399C14.2049 9.64215 14.3578 9.79513 14.546 9.89101C14.7599 10 15.0399 10 15.6 10ZM4.6 10H8.4C8.96005 10 9.24008 10 9.45399 9.89101C9.64215 9.79513 9.79513 9.64215 9.89101 9.45399C10 9.24008 10 8.96005 10 8.4V4.6C10 4.03995 10 3.75992 9.89101 3.54601C9.79513 3.35785 9.64215 3.20487 9.45399 3.10899C9.24008 3 8.96005 3 8.4 3H4.6C4.03995 3 3.75992 3 3.54601 3.10899C3.35785 3.20487 3.20487 3.35785 3.10899 3.54601C3 3.75992 3 4.03995 3 4.6V8.4C3 8.96005 3 9.24008 3.10899 9.45399C3.20487 9.64215 3.35785 9.79513 3.54601 9.89101C3.75992 10 4.03995 10 4.6 10ZM4.6 21H8.4C8.96005 21 9.24008 21 9.45399 20.891C9.64215 20.7951 9.79513 20.6422 9.89101 20.454C10 20.2401 10 19.9601 10 19.4V15.6C10 15.0399 10 14.7599 9.89101 14.546C9.79513 14.3578 9.64215 14.2049 9.45399 14.109C9.24008 14 8.96005 14 8.4 14H4.6C4.03995 14 3.75992 14 3.54601 14.109C3.35785 14.2049 3.20487 14.3578 3.10899 14.546C3 14.7599 3 15.0399 3 15.6V19.4C3 19.9601 3 20.2401 3.10899 20.454C3.20487 20.6422 3.35785 20.7951 3.54601 20.891C3.75992 21 4.03995 21 4.6 21Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), fi = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M6 6H6.01M6 18H6.01M5.2 10H18.8C19.9201 10 20.4802 10 20.908 9.78201C21.2843 9.59027 21.5903 9.28431 21.782 8.90798C22 8.48016 22 7.92011 22 6.8V5.2C22 4.0799 22 3.51984 21.782 3.09202C21.5903 2.71569 21.2843 2.40973 20.908 2.21799C20.4802 2 19.9201 2 18.8 2H5.2C4.07989 2 3.51984 2 3.09202 2.21799C2.71569 2.40973 2.40973 2.71569 2.21799 3.09202C2 3.51984 2 4.07989 2 5.2V6.8C2 7.92011 2 8.48016 2.21799 8.90798C2.40973 9.28431 2.71569 9.59027 3.09202 9.78201C3.51984 10 4.0799 10 5.2 10ZM5.2 22H18.8C19.9201 22 20.4802 22 20.908 21.782C21.2843 21.5903 21.5903 21.2843 21.782 20.908C22 20.4802 22 19.9201 22 18.8V17.2C22 16.0799 22 15.5198 21.782 15.092C21.5903 14.7157 21.2843 14.4097 20.908 14.218C20.4802 14 19.9201 14 18.8 14H5.2C4.07989 14 3.51984 14 3.09202 14.218C2.71569 14.4097 2.40973 14.7157 2.21799 15.092C2 15.5198 2 16.0799 2 17.2V18.8C2 19.9201 2 20.4802 2.21799 20.908C2.40973 21.2843 2.71569 21.5903 3.09202 21.782C3.51984 22 4.0799 22 5.2 22Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), pi = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M6 8H6.01M6 16H6.01M6 12H18M6 12C3.79086 12 2 10.2091 2 8C2 5.79086 3.79086 4 6 4H18C20.2091 4 22 5.79086 22 8C22 10.2091 20.2091 12 18 12M6 12C3.79086 12 2 13.7909 2 16C2 18.2091 3.79086 20 6 20H18C20.2091 20 22 18.2091 22 16C22 13.7909 20.2091 12 18 12",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), mi = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M22 17.5L21.3083 7.46975C21.1997 5.89504 21.1454 5.10768 20.8041 4.51082C20.5036 3.98533 20.0512 3.56304 19.5062 3.29942C18.8873 3 18.0981 3 16.5196 3H7.48037C5.90191 3 5.11268 3 4.49376 3.29942C3.94884 3.56304 3.49642 3.98533 3.19594 4.51082C2.85464 5.10768 2.80034 5.89503 2.69174 7.46975L2 17.5M22 17.5C22 19.433 20.433 21 18.5 21H5.5C3.567 21 2 19.433 2 17.5M22 17.5C22 15.567 20.433 14 18.5 14H5.5C3.567 14 2 15.567 2 17.5M6 17.5H6.01M12 17.5H18",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), hi = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M22 10.5L21.5256 6.70463C21.3395 5.21602 21.2465 4.47169 20.8961 3.9108C20.5875 3.41662 20.1416 3.02301 19.613 2.77804C19.013 2.5 18.2629 2.5 16.7626 2.5H7.23735C5.73714 2.5 4.98704 2.5 4.38702 2.77804C3.85838 3.02301 3.4125 3.41662 3.10386 3.9108C2.75354 4.47169 2.6605 5.21601 2.47442 6.70463L2 10.5M5.5 14.5H18.5M5.5 14.5C3.567 14.5 2 12.933 2 11C2 9.067 3.567 7.5 5.5 7.5H18.5C20.433 7.5 22 9.067 22 11C22 12.933 20.433 14.5 18.5 14.5M5.5 14.5C3.567 14.5 2 16.067 2 18C2 19.933 3.567 21.5 5.5 21.5H18.5C20.433 21.5 22 19.933 22 18C22 16.067 20.433 14.5 18.5 14.5M6 11H6.01M6 18H6.01M12 11H18M12 18H18",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), gi = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M19 9C19 12.866 15.866 16 12 16M19 9C19 5.13401 15.866 2 12 2M19 9H5M12 16C8.13401 16 5 12.866 5 9M12 16C13.7509 14.0832 14.7468 11.5956 14.8009 9C14.7468 6.40442 13.7509 3.91685 12 2M12 16C10.2491 14.0832 9.25498 11.5956 9.20091 9C9.25498 6.40442 10.2491 3.91685 12 2M12 16V18M5 9C5 5.13401 8.13401 2 12 2M14 20C14 21.1046 13.1046 22 12 22C10.8954 22 10 21.1046 10 20M14 20C14 18.8954 13.1046 18 12 18M14 20H21M10 20C10 18.8954 10.8954 18 12 18M10 20H3",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), _i = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M20 12C20 16.4183 16.4183 20 12 20M20 12C20 7.58172 16.4183 4 12 4M20 12H4M12 20C7.58172 20 4 16.4183 4 12M12 20C14.001 17.8093 15.1388 14.9664 15.2006 12C15.1388 9.03363 14.001 6.19068 12 4M12 20C9.99898 17.8093 8.86235 14.9664 8.80055 12C8.86235 9.03363 9.99898 6.19068 12 4M4 12C4 7.58172 7.58172 4 12 4M6 20C6 21.1046 5.10457 22 4 22C2.89543 22 2 21.1046 2 20C2 18.8954 2.89543 18 4 18C5.10457 18 6 18.8954 6 20ZM22 20C22 21.1046 21.1046 22 20 22C18.8954 22 18 21.1046 18 20C18 18.8954 18.8954 18 20 18C21.1046 18 22 18.8954 22 20ZM6 4C6 5.10457 5.10457 6 4 6C2.89543 6 2 5.10457 2 4C2 2.89543 2.89543 2 4 2C5.10457 2 6 2.89543 6 4ZM22 4C22 5.10457 21.1046 6 20 6C18.8954 6 18 5.10457 18 4C18 2.89543 18.8954 2 20 2C21.1046 2 22 2.89543 22 4Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), vi = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M4 17L10 11L4 5M12 19H20",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), yi = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M22 9H2M6 17.5L8.5 15L6 12.5M11 17.5L15 17.5M2 7.8L2 16.2C2 17.8802 2 18.7202 2.32698 19.362C2.6146 19.9265 3.07354 20.3854 3.63803 20.673C4.27976 21 5.11984 21 6.8 21H17.2C18.8802 21 19.7202 21 20.362 20.673C20.9265 20.3854 21.3854 19.9265 21.673 19.362C22 18.7202 22 17.8802 22 16.2V7.8C22 6.11984 22 5.27977 21.673 4.63803C21.3854 4.07354 20.9265 3.6146 20.362 3.32698C19.7202 3 18.8802 3 17.2 3L6.8 3C5.11984 3 4.27976 3 3.63803 3.32698C3.07354 3.6146 2.6146 4.07354 2.32698 4.63803C2 5.27976 2 6.11984 2 7.8Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), bi = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M7 15L10 12L7 9M13 15H17M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), xi = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M7 15L10 12L7 9M13 15H17M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Si = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M19.9061 21C21.2464 18.2888 22 15.2329 22 12C22 8.76711 21.2464 5.71116 19.9061 3M4.09393 3C2.75363 5.71116 2 8.76711 2 12C2 15.2329 2.75363 18.2888 4.09393 21M16.5486 8.625H16.459C15.8056 8.625 15.1848 8.91202 14.7596 9.41072L9.38471 15.7143C8.95948 16.213 8.33871 16.5 7.6853 16.5H7.59563M8.71483 8.625H10.1089C10.6086 8.625 11.0477 8.95797 11.185 9.44094L12.9594 15.6841C13.0967 16.167 13.5358 16.5 14.0355 16.5H15.4296",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ci = /* @__PURE__ */ k({
	Brackets: () => mr,
	BracketsCheck: () => hr,
	BracketsEllipses: () => gr,
	BracketsMinus: () => _r,
	BracketsPlus: () => vr,
	BracketsSlash: () => yr,
	BracketsX: () => br,
	Code01: () => Sr,
	Code02: () => Cr,
	CodeBrowser: () => wr,
	CodeCircle01: () => Tr,
	CodeCircle02: () => Er,
	CodeCircle03: () => Dr,
	CodeSquare01: () => kr,
	CodeSquare02: () => Ar,
	Container: () => jr,
	CpuChip01: () => Mr,
	CpuChip02: () => Nr,
	Data: () => Pr,
	DataFlow1: () => pr,
	Database01: () => Fr,
	Database02: () => Ir,
	Database03: () => Lr,
	Dataflow01: () => pr,
	Dataflow02: () => Rr,
	Dataflow03: () => zr,
	Dataflow04: () => Br,
	FaceContent: () => Vr,
	FaceFrown: () => Hr,
	FaceHappy: () => Ur,
	FaceNeutral: () => Wr,
	FaceSad: () => Gr,
	FaceSmile: () => Kr,
	FaceWink: () => qr,
	FileCode01: () => Jr,
	FileCode02: () => Yr,
	FolderCode: () => Xr,
	GitBranch01: () => Zr,
	GitBranch02: () => Qr,
	GitCommit: () => $r,
	GitMerge: () => ei,
	GitPullRequest: () => ti,
	Package: () => ni,
	PackageCheck: () => ri,
	PackageMinus: () => ii,
	PackagePlus: () => ai,
	PackageSearch: () => oi,
	PackageX: () => si,
	PuzzlePiece: () => ci,
	PuzzlePiece02: () => li,
	QrCode01: () => ui,
	QrCode02: () => di,
	Server01: () => fi,
	Server02: () => pi,
	Server03: () => mi,
	Server04: () => hi,
	Server05: () => gi,
	Server06: () => _i,
	Terminal: () => vi,
	TerminalBrowser: () => yi,
	TerminalCircle: () => bi,
	TerminalSquare: () => xi,
	Variable: () => Si,
	browser: () => xr,
	codepen: () => Or
}), wi = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M18 10H6M21 6H3M21 14H3M18 18H6",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ti = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M21 10H3M21 18H3M21 6H3M21 14H3",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ei = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M16 10H3M20 6H3M20 14H3M16 18H3",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Di = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M21 10H8M21 6H4M21 14H4M21 18H8",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Oi = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M21.1525 10.8995L12.1369 19.9151C10.0866 21.9653 6.7625 21.9653 4.71225 19.9151C2.662 17.8648 2.662 14.5407 4.71225 12.4904L13.7279 3.47483C15.0947 2.108 17.3108 2.108 18.6776 3.47483C20.0444 4.84167 20.0444 7.05775 18.6776 8.42458L10.0156 17.0866C9.33213 17.7701 8.22409 17.7701 7.54068 17.0866C6.85726 16.4032 6.85726 15.2952 7.54068 14.6118L15.1421 7.01037",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ki = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M17.5 5.25581V16.5C17.5 19.5376 15.0376 22 12 22C8.96243 22 6.5 19.5376 6.5 16.5V5.66667C6.5 3.64162 8.14162 2 10.1667 2C12.1917 2 13.8333 3.64162 13.8333 5.66667V16.4457C13.8333 17.4583 13.0125 18.2791 12 18.2791C10.9875 18.2791 10.1667 17.4583 10.1667 16.4457V6.65116",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ai = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M10 7L3 7M21 7L14 7M14 7.25195C17.4505 8.14004 20 11.2722 20 14.9999M4 14.9999C4 11.2722 6.54955 8.14004 10 7.25195M3.6 19H4.4C4.96005 19 5.24008 19 5.45399 18.891C5.64215 18.7951 5.79513 18.6422 5.89101 18.454C6 18.2401 6 17.9601 6 17.4V16.6C6 16.0399 6 15.7599 5.89101 15.546C5.79513 15.3578 5.64215 15.2049 5.45399 15.109C5.24008 15 4.96005 15 4.4 15H3.6C3.03995 15 2.75992 15 2.54601 15.109C2.35785 15.2049 2.20487 15.3578 2.10899 15.546C2 15.7599 2 16.0399 2 16.6V17.4C2 17.9601 2 18.2401 2.10899 18.454C2.20487 18.6422 2.35785 18.7951 2.54601 18.891C2.75992 19 3.03995 19 3.6 19ZM11.6 9H12.4C12.9601 9 13.2401 9 13.454 8.89101C13.6422 8.79513 13.7951 8.64215 13.891 8.45399C14 8.24008 14 7.96005 14 7.4V6.6C14 6.03995 14 5.75992 13.891 5.54601C13.7951 5.35785 13.6422 5.20487 13.454 5.10899C13.2401 5 12.9601 5 12.4 5H11.6C11.0399 5 10.7599 5 10.546 5.10899C10.3578 5.20487 10.2049 5.35785 10.109 5.54601C10 5.75992 10 6.03995 10 6.6V7.4C10 7.96005 10 8.24008 10.109 8.45399C10.2049 8.64215 10.3578 8.79513 10.546 8.89101C10.7599 9 11.0399 9 11.6 9ZM19.6 19H20.4C20.9601 19 21.2401 19 21.454 18.891C21.6422 18.7951 21.7951 18.6422 21.891 18.454C22 18.2401 22 17.9601 22 17.4V16.6C22 16.0399 22 15.7599 21.891 15.546C21.7951 15.3578 21.6422 15.2049 21.454 15.109C21.2401 15 20.9601 15 20.4 15H19.6C19.0399 15 18.7599 15 18.546 15.109C18.3578 15.2049 18.2049 15.3578 18.109 15.546C18 15.7599 18 16.0399 18 16.6V17.4C18 17.9601 18 18.2401 18.109 18.454C18.2049 18.6422 18.3578 18.7951 18.546 18.891C18.7599 19 19.0399 19 19.6 19ZM22 7C22 7.55228 21.5523 8 21 8C20.4477 8 20 7.55228 20 7C20 6.44772 20.4477 6 21 6C21.5523 6 22 6.44772 22 7ZM4 7C4 7.55228 3.55228 8 3 8C2.44772 8 2 7.55228 2 7C2 6.44772 2.44772 6 3 6C3.55228 6 4 6.44772 4 7Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ji = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9.9998 20.2633C6.91189 19.5185 4.48131 17.0879 3.73662 13.9999M20.2636 14C19.5188 17.0879 17.0883 19.5185 14.0004 20.2633M14.0002 3.73657C17.0882 4.48129 19.5188 6.91193 20.2636 9.99989M3.73682 10C4.48152 6.91199 6.9122 4.4813 10.0002 3.73657M3.6 14H4.4C4.96005 14 5.24008 14 5.45399 13.891C5.64215 13.7951 5.79513 13.6422 5.89101 13.454C6 13.2401 6 12.9601 6 12.4V11.6C6 11.0399 6 10.7599 5.89101 10.546C5.79513 10.3578 5.64215 10.2049 5.45399 10.109C5.24008 10 4.96005 10 4.4 10H3.6C3.03995 10 2.75992 10 2.54601 10.109C2.35785 10.2049 2.20487 10.3578 2.10899 10.546C2 10.7599 2 11.0399 2 11.6V12.4C2 12.9601 2 13.2401 2.10899 13.454C2.20487 13.6422 2.35785 13.7951 2.54601 13.891C2.75992 14 3.03995 14 3.6 14ZM19.6 14H20.4C20.9601 14 21.2401 14 21.454 13.891C21.6422 13.7951 21.7951 13.6422 21.891 13.454C22 13.2401 22 12.9601 22 12.4V11.6C22 11.0399 22 10.7599 21.891 10.546C21.7951 10.3578 21.6422 10.2049 21.454 10.109C21.2401 10 20.9601 10 20.4 10H19.6C19.0399 10 18.7599 10 18.546 10.109C18.3578 10.2049 18.2049 10.3578 18.109 10.546C18 10.7599 18 11.0399 18 11.6V12.4C18 12.9601 18 13.2401 18.109 13.454C18.2049 13.6422 18.3578 13.7951 18.546 13.891C18.7599 14 19.0399 14 19.6 14ZM11.6 6H12.4C12.9601 6 13.2401 6 13.454 5.89101C13.6422 5.79513 13.7951 5.64215 13.891 5.45399C14 5.24008 14 4.96005 14 4.4V3.6C14 3.03995 14 2.75992 13.891 2.54601C13.7951 2.35785 13.6422 2.20487 13.454 2.10899C13.2401 2 12.9601 2 12.4 2H11.6C11.0399 2 10.7599 2 10.546 2.10899C10.3578 2.20487 10.2049 2.35785 10.109 2.54601C10 2.75992 10 3.03995 10 3.6V4.4C10 4.96005 10 5.24008 10.109 5.45399C10.2049 5.64215 10.3578 5.79513 10.546 5.89101C10.7599 6 11.0399 6 11.6 6ZM11.6 22H12.4C12.9601 22 13.2401 22 13.454 21.891C13.6422 21.7951 13.7951 21.6422 13.891 21.454C14 21.2401 14 20.9601 14 20.4V19.6C14 19.0399 14 18.7599 13.891 18.546C13.7951 18.3578 13.6422 18.2049 13.454 18.109C13.2401 18 12.9601 18 12.4 18H11.6C11.0399 18 10.7599 18 10.546 18.109C10.3578 18.2049 10.2049 18.3578 10.109 18.546C10 18.7599 10 19.0399 10 19.6V20.4C10 20.9601 10 21.2401 10.109 21.454C10.2049 21.6422 10.3578 21.7951 10.546 21.891C10.7599 22 11.0399 22 11.6 22Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Mi = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M10.8571 7L5.14286 17M6 19H17.9998M18.8571 17L13.1429 7M3.6 21H4.4C4.96005 21 5.24008 21 5.45399 20.891C5.64215 20.7951 5.79513 20.6422 5.89101 20.454C6 20.2401 6 19.9601 6 19.4V18.6C6 18.0399 6 17.7599 5.89101 17.546C5.79513 17.3578 5.64215 17.2049 5.45399 17.109C5.24008 17 4.96005 17 4.4 17H3.6C3.03995 17 2.75992 17 2.54601 17.109C2.35785 17.2049 2.20487 17.3578 2.10899 17.546C2 17.7599 2 18.0399 2 18.6V19.4C2 19.9601 2 20.2401 2.10899 20.454C2.20487 20.6422 2.35785 20.7951 2.54601 20.891C2.75992 21 3.03995 21 3.6 21ZM19.6 21H20.4C20.9601 21 21.2401 21 21.454 20.891C21.6422 20.7951 21.7951 20.6422 21.891 20.454C22 20.2401 22 19.9601 22 19.4V18.6C22 18.0399 22 17.7599 21.891 17.546C21.7951 17.3578 21.6422 17.2049 21.454 17.109C21.2401 17 20.9601 17 20.4 17H19.6C19.0399 17 18.7599 17 18.546 17.109C18.3578 17.2049 18.2049 17.3578 18.109 17.546C18 17.7599 18 18.0399 18 18.6V19.4C18 19.9601 18 20.2401 18.109 20.454C18.2049 20.6422 18.3578 20.7951 18.546 20.891C18.7599 21 19.0399 21 19.6 21ZM11.6 7H12.4C12.9601 7 13.2401 7 13.454 6.89101C13.6422 6.79513 13.7951 6.64215 13.891 6.45399C14 6.24008 14 5.96005 14 5.4V4.6C14 4.03995 14 3.75992 13.891 3.54601C13.7951 3.35785 13.6422 3.20487 13.454 3.10899C13.2401 3 12.9601 3 12.4 3H11.6C11.0399 3 10.7599 3 10.546 3.10899C10.3578 3.20487 10.2049 3.35785 10.109 3.54601C10 3.75992 10 4.03995 10 4.6V5.4C10 5.96005 10 6.24008 10.109 6.45399C10.2049 6.64215 10.3578 6.79513 10.546 6.89101C10.7599 7 11.0399 7 11.6 7Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ni = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M6 12H14C16.2091 12 18 10.2091 18 8C18 5.79086 16.2091 4 14 4H6V12ZM6 12H15C17.2091 12 19 13.7909 19 16C19 18.2091 17.2091 20 15 20H6V12Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Pi = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M6 4V20M9.5 4H15.5C17.7091 4 19.5 5.79086 19.5 8C19.5 10.2091 17.7091 12 15.5 12H9.5H16.5C18.7091 12 20.5 13.7909 20.5 16C20.5 18.2091 18.7091 20 16.5 20H9.5M9.5 4V20M9.5 4H4M9.5 20H4",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Fi = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M8.5 12H13C14.3807 12 15.5 10.8807 15.5 9.5C15.5 8.11929 14.3807 7 13 7H8.5V12ZM8.5 12H14C15.3807 12 16.5 13.1193 16.5 14.5C16.5 15.8807 15.3807 17 14 17H8.5V12ZM7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ii = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M8.99997 11.2224L12.7778 15.0002M7.97485 20.975C6.60801 22.3419 4 22.0002 2 22.0002C3.0251 20.0002 1.65827 17.3921 3.0251 16.0253C4.39194 14.6585 6.60801 14.6585 7.97485 16.0253C9.34168 17.3921 9.34168 19.6082 7.97485 20.975ZM11.9216 15.9248L21.0587 6.05671C21.8635 5.18755 21.8375 3.83776 20.9999 3.00017C20.1624 2.16258 18.8126 2.13663 17.9434 2.94141L8.07534 12.0785C7.5654 12.5507 7.31043 12.7868 7.16173 13.0385C6.80514 13.6423 6.79079 14.3887 7.12391 15.0057C7.26283 15.2631 7.50853 15.5088 7.99995 16.0002C8.49136 16.4916 8.73707 16.7373 8.99438 16.8762C9.6114 17.2093 10.3578 17.195 10.9616 16.8384C11.2134 16.6897 11.4494 16.4347 11.9216 15.9248Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Li = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M18 10V3.6C18 3.03995 18 2.75992 17.891 2.54601C17.7951 2.35785 17.6422 2.20487 17.454 2.10899C17.2401 2 16.9601 2 16.4 2H7.6C7.03995 2 6.75992 2 6.54601 2.10899C6.35785 2.20487 6.20487 2.35785 6.10899 2.54601C6 2.75992 6 3.03995 6 3.6V10M18 10H6M18 10V10.2C18 11.8802 18 12.7202 17.673 13.362C17.3854 13.9265 16.9265 14.3854 16.362 14.673C15.7202 15 14.8802 15 13.2 15H10.8C9.11984 15 8.27976 15 7.63803 14.673C7.07354 14.3854 6.6146 13.9265 6.32698 13.362C6 12.7202 6 11.8802 6 10.2V10M14.5 15V19.5C14.5 20.8807 13.3807 22 12 22C10.6193 22 9.5 20.8807 9.5 19.5V15",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ri = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M20 10V3.6C20 3.03995 20 2.75992 19.891 2.54601C19.7951 2.35785 19.6422 2.20487 19.454 2.10899C19.2401 2 18.9601 2 18.4 2H5.6C5.03995 2 4.75992 2 4.54601 2.10899C4.35785 2.20487 4.20487 2.35785 4.10899 2.54601C4 2.75992 4 3.03995 4 3.6V10M20 10H4M20 10V10.2C20 11.8802 20 12.7202 19.673 13.362C19.3854 13.9265 18.9265 14.3854 18.362 14.673C17.7202 15 16.8802 15 15.2 15H8.8C7.11984 15 6.27976 15 5.63803 14.673C5.07354 14.3854 4.6146 13.9265 4.32698 13.362C4 12.7202 4 11.8802 4 10.2V10M14.5 15V19.5C14.5 20.8807 13.3807 22 12 22C10.6193 22 9.5 20.8807 9.5 19.5V15",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), zi = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M7 20.6622C9.98901 18.9331 12 15.7014 12 12C12 8.29859 9.98901 5.06687 7 3.33782M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Bi = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M16 18L22 12L16 6M8 6L2 12L8 18",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Vi = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M17 17L22 12L17 7M7 7L2 12L7 17M14 3L10 21",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Hi = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 20.4722C13.0615 21.4223 14.4633 22 16 22C19.3137 22 22 19.3137 22 16C22 13.2331 20.1271 10.9036 17.5798 10.2102M6.42018 10.2102C3.87293 10.9036 2 13.2331 2 16C2 19.3137 4.68629 22 8 22C11.3137 22 14 19.3137 14 16C14 15.2195 13.851 14.4738 13.5798 13.7898M18 8C18 11.3137 15.3137 14 12 14C8.68629 14 6 11.3137 6 8C6 4.68629 8.68629 2 12 2C15.3137 2 18 4.68629 18 8Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ui = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9 9V6C9 4.34315 7.65685 3 6 3C4.34315 3 3 4.34315 3 6C3 7.65685 4.34315 9 6 9H9ZM9 9V15M9 9H15M9 15V18C9 19.6569 7.65685 21 6 21C4.34315 21 3 19.6569 3 18C3 16.3431 4.34315 15 6 15H9ZM9 15H15M15 15H18C19.6569 15 21 16.3431 21 18C21 19.6569 19.6569 21 18 21C16.3431 21 15 19.6569 15 18V15ZM15 15V9M15 9V6C15 4.34315 16.3431 3 18 3C19.6569 3 21 4.34315 21 6C21 7.65685 19.6569 9 18 9H15Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Wi = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 2C12.5917 2 13.1713 2.05139 13.7348 2.14994M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22M12 2V22M17.738 3.809C18.6922 4.47869 19.5241 5.31089 20.1934 6.26541M21.8501 10.2656C21.9486 10.8289 22 11.4085 22 12C22 12.5915 21.9486 13.1711 21.8501 13.7344M20.1892 17.7406C19.5203 18.693 18.6896 19.5233 17.7369 20.1917M13.7328 21.8504C13.17 21.9487 12.591 22 12 22",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Gi = (e) => /* @__PURE__ */ o("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ a("path", {
		d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ a("path", {
		d: "M12 18.5C15.5899 18.5 18.5 15.5899 18.5 12C18.5 8.41015 15.5899 5.5 12 5.5V18.5Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
}), Ki = (e) => /* @__PURE__ */ o("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ a("path", {
		d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ a("path", {
		d: "M16 8.5C16 12.6421 12.6421 16 8.5 16C7.88534 16 7.28795 15.9261 6.71623 15.7866C7.89585 17.4297 9.82294 18.5 12 18.5C15.5899 18.5 18.5 15.5899 18.5 12C18.5 9.82294 17.4297 7.89585 15.7866 6.71623C15.9261 7.28795 16 7.88534 16 8.5Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
}), qi = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M2 6H14.8C15.9201 6 16.4802 6 16.908 6.21799C17.2843 6.40973 17.5903 6.71569 17.782 7.09202C18 7.51984 18 8.07989 18 9.2V22M22 18L9.2 18C8.07989 18 7.51984 18 7.09202 17.782C6.71569 17.5903 6.40973 17.2843 6.21799 16.908C6 16.4802 6 15.9201 6 14.8V2",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ji = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M10 6H14.8C15.9201 6 16.4802 6 16.908 6.21799C17.2843 6.40973 17.5903 6.71569 17.782 7.09202C18 7.51984 18 8.07989 18 9.2V14M2 6H6M18 18V22M22 18L9.2 18C8.07989 18 7.51984 18 7.09202 17.782C6.71569 17.5903 6.40973 17.2843 6.21799 16.908C6 16.4802 6 15.9201 6 14.8V2",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Yi = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12.9999 12.9999L18.9999 18.9999M17.964 10.7512L12.9533 12.4531C12.8163 12.4996 12.7478 12.5229 12.6908 12.562C12.6404 12.5967 12.5967 12.6404 12.562 12.6908C12.5229 12.7478 12.4996 12.8163 12.4531 12.9533L10.7512 17.964C10.5402 18.5854 10.4346 18.896 10.2696 18.99C10.1267 19.0713 9.95281 19.0772 9.80468 19.0056C9.63374 18.923 9.50756 18.6201 9.25521 18.0144L3.74699 4.79312C3.51283 4.23109 3.39576 3.95007 3.45272 3.77426C3.50214 3.62172 3.62172 3.50214 3.77426 3.45272C3.95007 3.39576 4.23109 3.51283 4.79312 3.74699L18.0144 9.25521C18.6201 9.50756 18.923 9.63374 19.0056 9.80468C19.0772 9.95281 19.0713 10.1267 18.99 10.2696C18.896 10.4346 18.5854 10.5402 17.964 10.7512Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Xi = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M20.5056 10.7754C21.1225 10.5355 21.431 10.4155 21.5176 10.2459C21.5926 10.099 21.5903 9.92446 21.5115 9.77954C21.4205 9.61226 21.109 9.50044 20.486 9.2768L4.59629 3.5728C4.0866 3.38983 3.83175 3.29835 3.66514 3.35605C3.52029 3.40621 3.40645 3.52004 3.35629 3.6649C3.29859 3.8315 3.39008 4.08635 3.57304 4.59605L9.277 20.4858C9.50064 21.1088 9.61246 21.4203 9.77973 21.5113C9.92465 21.5901 10.0991 21.5924 10.2461 21.5174C10.4157 21.4308 10.5356 21.1223 10.7756 20.5054L13.3724 13.8278C13.4194 13.707 13.4429 13.6466 13.4792 13.5957C13.5114 13.5506 13.5508 13.5112 13.5959 13.479C13.6468 13.4427 13.7072 13.4192 13.828 13.3722L20.5056 10.7754Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Zi = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M4.71152 3.67446C4.17096 3.46151 3.90067 3.35504 3.72846 3.41232C3.57892 3.46207 3.46158 3.5794 3.41184 3.72894C3.35455 3.90116 3.46102 4.17144 3.67397 4.71201L8.97461 18.1675C9.14612 18.6028 9.23188 18.8205 9.37164 18.9079C9.49348 18.9841 9.64219 19.0041 9.77986 18.963C9.93778 18.9158 10.0782 18.7286 10.3589 18.3542L12.4996 15.5001L15.9489 20.2429C16.1385 20.5036 16.2334 20.634 16.3542 20.6885C16.4602 20.7363 16.5796 20.7457 16.6918 20.715C16.8196 20.68 16.9336 20.566 17.1616 20.338L20.3376 17.1621C20.5655 16.9341 20.6795 16.8201 20.7145 16.6923C20.7452 16.5801 20.7359 16.4607 20.688 16.3547C20.6335 16.2338 20.5032 16.139 20.2424 15.9494L15.4996 12.5001L18.3538 10.3594C18.7281 10.0787 18.9153 9.93827 18.9625 9.78035C19.0036 9.64268 18.9836 9.49397 18.9074 9.37213C18.82 9.23237 18.6024 9.14661 18.167 8.97509L4.71152 3.67446Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Qi = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M4.40701 3.41403C3.94876 3.27925 3.71963 3.21186 3.56363 3.27001C3.42768 3.32069 3.32045 3.42793 3.26977 3.56387C3.21162 3.71988 3.27901 3.949 3.41379 4.40726L7.61969 18.7073C7.74493 19.1332 7.80756 19.3461 7.93395 19.4449C8.04424 19.5312 8.18564 19.5672 8.32377 19.5443C8.48206 19.5181 8.639 19.3611 8.95286 19.0473L11.9999 16.0002L16.4343 20.4345C16.6323 20.6325 16.7313 20.7315 16.8454 20.7686C16.9459 20.8012 17.054 20.8012 17.1545 20.7686C17.2686 20.7315 17.3676 20.6325 17.5656 20.4345L20.4343 17.5659C20.6323 17.3679 20.7313 17.2689 20.7684 17.1547C20.801 17.0543 20.801 16.9461 20.7684 16.8457C20.7313 16.7315 20.6323 16.6325 20.4343 16.4345L15.9999 12.0002L19.047 8.95311C19.3609 8.63924 19.5178 8.48231 19.5441 8.32402C19.567 8.18589 19.5309 8.04448 19.4447 7.93419C19.3458 7.8078 19.1329 7.74518 18.7071 7.61993L4.40701 3.41403Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), $i = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M21 9.5V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H9.5M17.3862 17.7113L15.6879 20.8653C15.4103 21.3808 15.2715 21.6386 15.1023 21.7059C14.9555 21.7643 14.7896 21.7498 14.6551 21.6668C14.5001 21.5712 14.4081 21.2933 14.2241 20.7375L11.5004 12.5113C11.3392 12.0245 11.2586 11.7812 11.3166 11.6191C11.367 11.478 11.478 11.367 11.6191 11.3166C11.7812 11.2586 12.0245 11.3392 12.5113 11.5004L20.7374 14.2241C21.2933 14.4082 21.5712 14.5002 21.6668 14.6551C21.7498 14.7897 21.7642 14.9555 21.7058 15.1024C21.6386 15.2715 21.3808 15.4103 20.8652 15.6879L17.7113 17.3862C17.6328 17.4285 17.5935 17.4497 17.5591 17.4768C17.5286 17.501 17.501 17.5286 17.4768 17.5591C17.4497 17.5935 17.4285 17.6328 17.3862 17.7113Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ea = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9 3.5V2M5.06066 5.06066L4 4M5.06066 13L4 14.0607M13 5.06066L14.0607 4M3.5 9H2M15.8645 16.1896L13.3727 20.817C13.0881 21.3457 12.9457 21.61 12.7745 21.6769C12.6259 21.7349 12.4585 21.7185 12.324 21.6328C12.1689 21.534 12.0806 21.2471 11.9038 20.6733L8.44519 9.44525C8.3008 8.97651 8.2286 8.74213 8.28669 8.58383C8.33729 8.44595 8.44595 8.33729 8.58383 8.2867C8.74213 8.22861 8.9765 8.3008 9.44525 8.44519L20.6732 11.9038C21.247 12.0806 21.5339 12.169 21.6327 12.324C21.7185 12.4586 21.7348 12.6259 21.6768 12.7745C21.61 12.9458 21.3456 13.0881 20.817 13.3728L16.1896 15.8645C16.111 15.9068 16.0717 15.9279 16.0374 15.9551C16.0068 15.9792 15.9792 16.0068 15.9551 16.0374C15.9279 16.0717 15.9068 16.111 15.8645 16.1896Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ta = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9 3.5V2M5.06066 5.06066L4 4M5.06066 13L4 14.0607M13 5.06066L14.0607 4M3.5 9H2M8.5 8.5L12.6111 21.2778L15.5 18.3889L19.1111 22L22 19.1111L18.3889 15.5L21.2778 12.6111L8.5 8.5Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), na = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M17 9L11 15M11 9L17 15M2.72 12.96L7.04 18.72C7.392 19.1893 7.568 19.424 7.79105 19.5932C7.9886 19.7432 8.21232 19.855 8.45077 19.9231C8.72 20 9.01334 20 9.6 20H17.2C18.8802 20 19.7202 20 20.362 19.673C20.9265 19.3854 21.3854 18.9265 21.673 18.362C22 17.7202 22 16.8802 22 15.2V8.8C22 7.11984 22 6.27976 21.673 5.63803C21.3854 5.07354 20.9265 4.6146 20.362 4.32698C19.7202 4 18.8802 4 17.2 4H9.6C9.01334 4 8.72 4 8.45077 4.07689C8.21232 4.14499 7.9886 4.25685 7.79105 4.40675C7.568 4.576 7.392 4.81067 7.04 5.28L2.72 11.04C2.46181 11.3843 2.33271 11.5564 2.28294 11.7454C2.23902 11.9123 2.23902 12.0877 2.28294 12.2546C2.33271 12.4436 2.46181 12.6157 2.72 12.96Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ra = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M21 12L9 12M21 6L9 6M21 18L9 18M5 12C5 12.5523 4.55228 13 4 13C3.44772 13 3 12.5523 3 12C3 11.4477 3.44772 11 4 11C4.55228 11 5 11.4477 5 12ZM5 6C5 6.55228 4.55228 7 4 7C3.44772 7 3 6.55228 3 6C3 5.44772 3.44772 5 4 5C4.55228 5 5 5.44772 5 6ZM5 18C5 18.5523 4.55228 19 4 19C3.44772 19 3 18.5523 3 18C3 17.4477 3.44772 17 4 17C4.55228 17 5 17.4477 5 18Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ia = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M21 5L10 5M21 19L10 19M21 12L10 12M6 5C6 5.82843 5.32843 6.5 4.5 6.5C3.67157 6.5 3 5.82843 3 5C3 4.17157 3.67157 3.5 4.5 3.5C5.32843 3.5 6 4.17157 6 5ZM6 19C6 19.8284 5.32843 20.5 4.5 20.5C3.67157 20.5 3 19.8284 3 19C3 18.1716 3.67157 17.5 4.5 17.5C5.32843 17.5 6 18.1716 6 19ZM6 12C6 12.8284 5.32843 13.5 4.5 13.5C3.67157 13.5 3 12.8284 3 12C3 11.1716 3.67157 10.5 4.5 10.5C5.32843 10.5 6 11.1716 6 12Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), aa = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M20 14C20 18.4183 16.4183 22 12 22C7.58172 22 4 18.4183 4 14C4 12.9391 4.20651 11.9264 4.58152 11C5.76829 8.06817 12 2 12 2C12 2 18.2317 8.06817 19.4185 11C19.7935 11.9264 20 12.9391 20 14Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), oa = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M10.5 6.49981L17.5 13.4998M2 21.9998C2 21.9998 6.5 21.4998 9 18.9998L21 6.99982C22.1046 5.89525 22.1046 4.10438 21 2.99982C19.8954 1.89525 18.1046 1.89524 17 2.99981L5 14.9998C2.5 17.4998 2 21.9998 2 21.9998Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), sa = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M17.9995 13L10.9995 6.00004M20.9995 21H7.99955M10.9368 20.0628L19.6054 11.3941C20.7935 10.2061 21.3875 9.61207 21.6101 8.92709C21.8058 8.32456 21.8058 7.67551 21.6101 7.07298C21.3875 6.388 20.7935 5.79397 19.6054 4.60592L19.3937 4.39415C18.2056 3.2061 17.6116 2.61207 16.9266 2.38951C16.3241 2.19373 15.675 2.19373 15.0725 2.38951C14.3875 2.61207 13.7935 3.2061 12.6054 4.39415L4.39366 12.6059C3.20561 13.794 2.61158 14.388 2.38902 15.073C2.19324 15.6755 2.19324 16.3246 2.38902 16.9271C2.61158 17.6121 3.20561 18.2061 4.39366 19.3941L5.06229 20.0628C5.40819 20.4087 5.58114 20.5816 5.78298 20.7053C5.96192 20.815 6.15701 20.8958 6.36108 20.9448C6.59126 21 6.83585 21 7.32503 21H8.67406C9.16324 21 9.40784 21 9.63801 20.9448C9.84208 20.8958 10.0372 20.815 10.2161 20.7053C10.418 20.5816 10.5909 20.4087 10.9368 20.0628Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ca = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M16 8.00007L2 22.0001M18 15.0001H9M6.6 19.0001H13.3373C13.5818 19.0001 13.7041 19.0001 13.8192 18.9724C13.9213 18.9479 14.0188 18.9075 14.1083 18.8527C14.2092 18.7909 14.2957 18.7044 14.4686 18.5314L19.5 13.5001C19.739 13.2611 19.8584 13.1416 19.9546 13.0358C22.0348 10.7474 22.0348 7.25275 19.9546 4.9643C19.8584 4.85851 19.739 4.73903 19.5 4.50007C19.261 4.26111 19.1416 4.14163 19.0358 4.04547C16.7473 1.96531 13.2527 1.96531 10.9642 4.04547C10.8584 4.14163 10.739 4.26111 10.5 4.50007L5.46863 9.53144C5.29568 9.70439 5.2092 9.79087 5.14736 9.89179C5.09253 9.98126 5.05213 10.0788 5.02763 10.1808C5 10.2959 5 10.4182 5 10.6628V17.4001C5 17.9601 5 18.2401 5.10899 18.4541C5.20487 18.6422 5.35785 18.7952 5.54601 18.8911C5.75992 19.0001 6.03995 19.0001 6.6 19.0001Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), la = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 1.5H8.5C6.567 1.5 5 3.067 5 5C5 6.933 6.567 8.5 8.5 8.5M12 1.5V8.5M12 1.5H15.5C17.433 1.5 19 3.067 19 5C19 6.933 17.433 8.5 15.5 8.5M12 8.5H8.5M12 8.5V15.5M12 8.5H15.5M8.5 8.5C6.567 8.5 5 10.067 5 12C5 13.933 6.567 15.5 8.5 15.5M12 15.5H8.5M12 15.5V19C12 20.933 10.433 22.5 8.5 22.5C6.567 22.5 5 20.933 5 19C5 17.067 6.567 15.5 8.5 15.5M15.5 8.5C17.433 8.5 19 10.067 19 12C19 13.933 17.433 15.5 15.5 15.5C13.567 15.5 12 13.933 12 12C12 10.067 13.567 8.5 15.5 8.5Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ua = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 15.5V22.5L5 15.5M5 15.5V8.5H12M5 15.5H19L12 8.5M12 8.5H19V1.5H5L12 8.5Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), da = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M6.9 11.4444V14.2222M6.9 11.4444V4.77778C6.9 3.8573 7.66112 3.11111 8.6 3.11111C9.53888 3.11111 10.3 3.8573 10.3 4.77778M6.9 11.4444C6.9 10.524 6.13888 9.77778 5.2 9.77778C4.26112 9.77778 3.5 10.524 3.5 11.4444V13.6667C3.5 18.269 7.30558 22 12 22C16.6944 22 20.5 18.269 20.5 13.6667V8.11111C20.5 7.19064 19.7389 6.44444 18.8 6.44444C17.8611 6.44444 17.1 7.19064 17.1 8.11111M10.3 4.77778V10.8889M10.3 4.77778V3.66667C10.3 2.74619 11.0611 2 12 2C12.9389 2 13.7 2.74619 13.7 3.66667V4.77778M13.7 4.77778V10.8889M13.7 4.77778C13.7 3.8573 14.4611 3.11111 15.4 3.11111C16.3389 3.11111 17.1 3.8573 17.1 4.77778V8.11111M17.1 8.11111V10.8889",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), fa = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M6 4V20M18 4V20M8 4H4M18 12L6 12M8 20H4M20 20H16M20 4H16",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), pa = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M6 4V20M18 4V20M9.5 4V20M11.5 4H4M18 12H9.5M11.5 20H4M20 20H16M20 4H16",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ma = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M8 7V17M16 7V17M16 12L8 12M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ha = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M21 9.25H15M21 4H3M21 14.75H15M21 20H3M4.6 16H9.4C9.96005 16 10.2401 16 10.454 15.891C10.6422 15.7951 10.7951 15.6422 10.891 15.454C11 15.2401 11 14.9601 11 14.4V9.6C11 9.03995 11 8.75992 10.891 8.54601C10.7951 8.35785 10.6422 8.20487 10.454 8.10899C10.2401 8 9.96005 8 9.4 8H4.6C4.03995 8 3.75992 8 3.54601 8.10899C3.35785 8.20487 3.20487 8.35785 3.10899 8.54601C3 8.75992 3 9.03995 3 9.6V14.4C3 14.9601 3 15.2401 3.10899 15.454C3.20487 15.6422 3.35785 15.7951 3.54601 15.891C3.75992 16 4.03995 16 4.6 16Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ga = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M21 4H3M21 20H3M9 9.25H3M9 14.75H3M14.6 16H19.4C19.9601 16 20.2401 16 20.454 15.891C20.6422 15.7951 20.7951 15.6422 20.891 15.454C21 15.2401 21 14.9601 21 14.4V9.6C21 9.03995 21 8.75992 20.891 8.54601C20.7951 8.35785 20.6422 8.20487 20.454 8.10899C20.2401 8 19.9601 8 19.4 8H14.6C14.0399 8 13.7599 8 13.546 8.10899C13.3578 8.20487 13.2049 8.35785 13.109 8.54601C13 8.75992 13 9.03995 13 9.6V14.4C13 14.9601 13 15.2401 13.109 15.454C13.2049 15.6422 13.3578 15.7951 13.546 15.891C13.7599 16 14.0399 16 14.6 16Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), _a = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M19 4H10M14 20H5M15 4L9 20",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), va = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M13.25 4L7.25 20M16.75 4L10.75 20M19.5 4L9.5 4M14.5 20H4.5",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ya = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M14 7L10 17M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ba = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M21 9.25H12M21 4H3M21 14.75H12M21 20H3M4.28 8.56L8.14667 11.46C8.43616 11.6771 8.5809 11.7857 8.63266 11.9188C8.678 12.0353 8.678 12.1647 8.63266 12.2812C8.5809 12.4143 8.43616 12.5229 8.14667 12.74L4.28 15.64C3.86802 15.949 3.66203 16.1035 3.48961 16.0999C3.33956 16.0968 3.19885 16.0264 3.10632 15.9082C3 15.7725 3 15.515 3 15V9.2C3 8.68503 3 8.42754 3.10632 8.29175C3.19885 8.17358 3.33956 8.10323 3.48961 8.10011C3.66203 8.09652 3.86802 8.25102 4.28 8.56Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), xa = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M21 9.24995H12M21 3.99995L12 3.99995M21 14.75H3M21 20H3M4.28 2.95995L8.14667 5.85995C8.43616 6.07707 8.5809 6.18563 8.63266 6.31872C8.678 6.43529 8.678 6.56462 8.63266 6.68119C8.5809 6.81427 8.43616 6.92283 8.14667 7.13995L4.28 10.04C3.86802 10.3489 3.66203 10.5034 3.48961 10.4998C3.33956 10.4967 3.19885 10.4264 3.10632 10.3082C3 10.1724 3 9.91493 3 9.39995V3.59995C3 3.08498 3 2.82749 3.10632 2.6917C3.19885 2.57354 3.33956 2.50318 3.48961 2.50006C3.66203 2.49648 3.86802 2.65097 4.28 2.95995Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Sa = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9 13L15 13M7 17L11.2717 7.60225C11.5031 7.09323 11.6188 6.83872 11.7791 6.75976C11.9184 6.69115 12.0816 6.69115 12.2209 6.75976C12.3812 6.83872 12.4969 7.09323 12.7283 7.60225L17 17M21 3V21M3 3L3 21",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ca = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M2 18H22M2 18L5 15M2 18L5 21M22 18L19 15M22 18L19 21M7 3H17M12 3V14",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), wa = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9 13H15M7 17L11.2717 7.60224C11.5031 7.09323 11.6188 6.83872 11.7791 6.75976C11.9184 6.69115 12.0816 6.69115 12.2209 6.75976C12.3812 6.83872 12.4969 7.09323 12.7283 7.60224L17 17M21 21H3M21 3H3",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ta = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M13.0001 14L10.0001 11M15.0104 3.5V2M18.9498 5.06066L20.0104 4M18.9498 13L20.0104 14.0607M11.0104 5.06066L9.94979 4M20.5104 9H22.0104M6.13146 20.8686L15.3687 11.6314C15.7647 11.2354 15.9627 11.0373 16.0369 10.809C16.1022 10.6082 16.1022 10.3918 16.0369 10.191C15.9627 9.96265 15.7647 9.76465 15.3687 9.36863L14.6315 8.63137C14.2354 8.23535 14.0374 8.03735 13.8091 7.96316C13.6083 7.8979 13.3919 7.8979 13.1911 7.96316C12.9627 8.03735 12.7647 8.23535 12.3687 8.63137L3.13146 17.8686C2.73545 18.2646 2.53744 18.4627 2.46325 18.691C2.39799 18.8918 2.39799 19.1082 2.46325 19.309C2.53744 19.5373 2.73545 19.7354 3.13146 20.1314L3.86872 20.8686C4.26474 21.2646 4.46275 21.4627 4.69108 21.5368C4.89192 21.6021 5.10827 21.6021 5.30911 21.5368C5.53744 21.4627 5.73545 21.2646 6.13146 20.8686Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ea = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M15 4V2M15 16V14M8 9H10M20 9H22M17.8 11.8L19 13M17.8 6.2L19 5M3 21L12 12M12.2 6.2L11 5",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Da = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M5 9L2 12M2 12L5 15M2 12H22M9 5L12 2M12 2L15 5M12 2V22M15 19L12 22M12 22L9 19M19 9L22 12M22 12L19 15",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Oa = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M2.99955 13H19.9995M11.9995 3.5L10.4995 2M11.4995 3L20.3682 11.8686C20.7642 12.2646 20.9622 12.4627 21.0364 12.691C21.1016 12.8918 21.1016 13.1082 21.0364 13.309C20.9622 13.5373 20.7642 13.7354 20.3682 14.1314L14.8937 19.6059C13.7056 20.7939 13.1116 21.388 12.4266 21.6105C11.8241 21.8063 11.175 21.8063 10.5725 21.6105C9.88751 21.388 9.29349 20.7939 8.10543 19.6059L4.89366 16.3941C3.70561 15.2061 3.11158 14.612 2.88902 13.9271C2.69324 13.3245 2.69324 12.6755 2.88902 12.0729C3.11158 11.388 3.70561 10.7939 4.89366 9.60589L11.4995 3Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ka = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M15.9997 11L1.9997 11M9.9997 4L7.9997 2M13.9997 22L1.9997 22M21.9997 16C21.9997 17.1046 21.1043 18 19.9997 18C18.8951 18 17.9997 17.1046 17.9997 16C17.9997 14.8954 19.9997 13 19.9997 13C19.9997 13 21.9997 14.8954 21.9997 16ZM8.9997 3L15.8683 9.86863C16.2643 10.2646 16.4624 10.4627 16.5365 10.691C16.6018 10.8918 16.6018 11.1082 16.5365 11.309C16.4624 11.5373 16.2643 11.7354 15.8683 12.1314L11.2624 16.7373C10.4704 17.5293 10.0744 17.9253 9.61773 18.0737C9.21605 18.2042 8.78335 18.2042 8.38166 18.0737C7.92501 17.9253 7.52899 17.5293 6.73696 16.7373L3.26244 13.2627C2.4704 12.4707 2.07439 12.0747 1.92601 11.618C1.7955 11.2163 1.7955 10.7837 1.92601 10.382C2.07439 9.92531 2.47041 9.52929 3.26244 8.73726L8.9997 3Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Aa = (e) => /* @__PURE__ */ o("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ a("path", {
			d: "M2 12C2 17.5228 6.47715 22 12 22C13.6569 22 15 20.6569 15 19V18.5C15 18.0356 15 17.8034 15.0257 17.6084C15.2029 16.2622 16.2622 15.2029 17.6084 15.0257C17.8034 15 18.0356 15 18.5 15H19C20.6569 15 22 13.6569 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12Z",
			stroke: "black",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ a("path", {
			d: "M7 13C7.55228 13 8 12.5523 8 12C8 11.4477 7.55228 11 7 11C6.44772 11 6 11.4477 6 12C6 12.5523 6.44772 13 7 13Z",
			stroke: "black",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ a("path", {
			d: "M16 9C16.5523 9 17 8.55228 17 8C17 7.44772 16.5523 7 16 7C15.4477 7 15 7.44772 15 8C15 8.55228 15.4477 9 16 9Z",
			stroke: "black",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ a("path", {
			d: "M10 8C10.5523 8 11 7.55228 11 7C11 6.44772 10.5523 6 10 6C9.44772 6 9 6.44772 9 7C9 7.55228 9.44772 8 10 8Z",
			stroke: "black",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
}), ja = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M21 10H13M21 6H13M21 14H13M21 18H13M6 20L6 4M6 20L3 17M6 20L9 17M6 4L3 7M6 4L9 7",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ma = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M3 6H21M3 12H18C18.7956 12 19.5587 12.3161 20.1213 12.8787C20.6839 13.4413 21 14.2044 21 15C21 15.7956 20.6839 16.5587 20.1213 17.1213C19.5587 17.6839 18.7956 18 18 18H14M14 18L16 16M14 18L16 20M3 18H10",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Na = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M2.5 21.4998L8.04927 19.3655C8.40421 19.229 8.58168 19.1607 8.74772 19.0716C8.8952 18.9924 9.0358 18.901 9.16804 18.7984C9.31692 18.6829 9.45137 18.5484 9.72028 18.2795L21 6.99982C22.1046 5.89525 22.1046 4.10438 21 2.99981C19.8955 1.89525 18.1046 1.89524 17 2.99981L5.72028 14.2795C5.45138 14.5484 5.31692 14.6829 5.20139 14.8318C5.09877 14.964 5.0074 15.1046 4.92823 15.2521C4.83911 15.4181 4.77085 15.5956 4.63433 15.9506L2.5 21.4998ZM2.5 21.4998L4.55812 16.1488C4.7054 15.7659 4.77903 15.5744 4.90534 15.4867C5.01572 15.4101 5.1523 15.3811 5.2843 15.4063C5.43533 15.4351 5.58038 15.5802 5.87048 15.8703L8.12957 18.1294C8.41967 18.4195 8.56472 18.5645 8.59356 18.7155C8.61877 18.8475 8.58979 18.9841 8.51314 19.0945C8.42545 19.2208 8.23399 19.2944 7.85107 19.4417L2.5 21.4998Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Pa = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M18 2L22 6M2 22L3.2764 17.3199C3.35968 17.0145 3.40131 16.8619 3.46523 16.7195C3.52199 16.5931 3.59172 16.4729 3.67332 16.3609C3.76521 16.2348 3.87711 16.1229 4.1009 15.8991L14.4343 5.56569C14.6323 5.36768 14.7313 5.26867 14.8455 5.23158C14.9459 5.19895 15.0541 5.19895 15.1545 5.23158C15.2687 5.26867 15.3677 5.36768 15.5657 5.56569L18.4343 8.43431C18.6323 8.63232 18.7313 8.73133 18.7684 8.84549C18.8011 8.94591 18.8011 9.05409 18.7684 9.15451C18.7313 9.26867 18.6323 9.36768 18.4343 9.56569L8.1009 19.8991C7.87711 20.1229 7.76521 20.2348 7.63908 20.3267C7.52709 20.4083 7.40692 20.478 7.28052 20.5348C7.13815 20.5987 6.98548 20.6403 6.68014 20.7236L2 22Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Fa = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M21 20.9998H13M2.5 21.4998L8.04927 19.3655C8.40421 19.229 8.58168 19.1607 8.74772 19.0716C8.8952 18.9924 9.0358 18.901 9.16804 18.7984C9.31692 18.6829 9.45137 18.5484 9.72028 18.2795L21 6.99982C22.1046 5.89525 22.1046 4.10438 21 2.99981C19.8955 1.89525 18.1046 1.89524 17 2.99981L5.72028 14.2795C5.45138 14.5484 5.31692 14.6829 5.20139 14.8318C5.09877 14.964 5.0074 15.1046 4.92823 15.2521C4.83911 15.4181 4.77085 15.5956 4.63433 15.9506L2.5 21.4998ZM2.5 21.4998L4.55812 16.1488C4.7054 15.7659 4.77903 15.5744 4.90534 15.4867C5.01572 15.4101 5.1523 15.3811 5.2843 15.4063C5.43533 15.4351 5.58038 15.5802 5.87048 15.8703L8.12957 18.1294C8.41967 18.4195 8.56472 18.5645 8.59356 18.7155C8.61877 18.8475 8.58979 18.9841 8.51314 19.0945C8.42545 19.2208 8.23399 19.2944 7.85107 19.4417L2.5 21.4998Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ia = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M18 13L16.7004 6.50182C16.6278 6.13883 16.5915 5.95733 16.5032 5.80953C16.4252 5.67886 16.3183 5.56773 16.1908 5.4846C16.0466 5.39057 15.8667 5.34714 15.5069 5.26028L2 2M2 2L5.26028 15.5069C5.34714 15.8667 5.39057 16.0466 5.4846 16.1908C5.56773 16.3183 5.67886 16.4252 5.80953 16.5032C5.95733 16.5915 6.13883 16.6278 6.50182 16.7004L13 18M2 2L9.586 9.586M16.1314 20.8686L20.8686 16.1314C21.2646 15.7354 21.4627 15.5373 21.5368 15.309C21.6021 15.1082 21.6021 14.8918 21.5368 14.691C21.4627 14.4627 21.2646 14.2646 20.8686 13.8686L20.1314 13.1314C19.7354 12.7354 19.5373 12.5373 19.309 12.4632C19.1082 12.3979 18.8918 12.3979 18.691 12.4632C18.4627 12.5373 18.2646 12.7354 17.8686 13.1314L13.1314 17.8686C12.7354 18.2646 12.5373 18.4627 12.4632 18.691C12.3979 18.8918 12.3979 19.1082 12.4632 19.309C12.5373 19.5373 12.7354 19.7354 13.1314 20.1314L13.8686 20.8686C14.2646 21.2646 14.4627 21.4627 14.691 21.5368C14.8918 21.6021 15.1082 21.6021 15.309 21.5368C15.5373 21.4627 15.7354 21.2646 16.1314 20.8686ZM13 11C13 12.1046 12.1046 13 11 13C9.89543 13 9 12.1046 9 11C9 9.89543 9.89543 9 11 9C12.1046 9 13 9.89543 13 11Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), La = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M13 5.99985L6.50182 7.29948C6.13883 7.37208 5.95733 7.40838 5.80952 7.49665C5.67886 7.57469 5.56772 7.68152 5.4846 7.80901C5.39057 7.95321 5.34714 8.13314 5.26028 8.49299L2 21.9998M2 21.9998L15.5069 18.7396C15.8667 18.6527 16.0466 18.6093 16.1908 18.5153C16.3183 18.4321 16.4252 18.321 16.5032 18.1903C16.5915 18.0425 16.6278 17.861 16.7004 17.498L18 10.9998M2 21.9998L9.586 14.4138M20.8686 7.86848L16.1314 3.13122C15.7354 2.7352 15.5373 2.53719 15.309 2.46301C15.1082 2.39775 14.8918 2.39775 14.691 2.46301C14.4627 2.53719 14.2646 2.7352 13.8686 3.13122L13.1314 3.86848C12.7354 4.2645 12.5373 4.4625 12.4632 4.69083C12.3979 4.89168 12.3979 5.10802 12.4632 5.30887C12.5373 5.53719 12.7354 5.7352 13.1314 6.13122L17.8686 10.8685C18.2646 11.2645 18.4627 11.4625 18.691 11.5367C18.8918 11.6019 19.1082 11.6019 19.309 11.5367C19.5373 11.4625 19.7354 11.2645 20.1314 10.8685L20.8686 10.1312C21.2646 9.7352 21.4627 9.53719 21.5368 9.30887C21.6021 9.10802 21.6021 8.89168 21.5368 8.69083C21.4627 8.4625 21.2646 8.2645 20.8686 7.86848ZM11 10.9998C12.1046 10.9998 13 11.8953 13 12.9998C13 14.1044 12.1046 14.9998 11 14.9998C9.89543 14.9998 9 14.1044 9 12.9998C9 11.8953 9.89543 10.9998 11 10.9998Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ra = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M2 4.99985H8M15 6.99985L8.83447 8.76143C8.52956 8.84855 8.37711 8.8921 8.25117 8.97398C8.13969 9.04647 8.04379 9.14045 7.96907 9.25045C7.88466 9.3747 7.83803 9.52625 7.74477 9.82933L4 21.9998M4 21.9998L16.1705 18.2551C16.4736 18.1618 16.6251 18.1152 16.7494 18.0308C16.8594 17.9561 16.9534 17.8602 17.0259 17.7487C17.1077 17.6227 17.1513 17.4703 17.2384 17.1654L19 10.9998M4 21.9998L10.586 15.4138M21.8686 7.86848L18.1314 4.13122C17.7354 3.7352 17.5373 3.53719 17.309 3.46301C17.1082 3.39775 16.8918 3.39775 16.691 3.46301C16.4627 3.53719 16.2646 3.7352 15.8686 4.13122L15.1314 4.86848C14.7354 5.2645 14.5373 5.4625 14.4632 5.69083C14.3979 5.89168 14.3979 6.10802 14.4632 6.30887C14.5373 6.53719 14.7354 6.7352 15.1314 7.13122L18.8686 10.8685C19.2646 11.2645 19.4627 11.4625 19.691 11.5367C19.8918 11.6019 20.1082 11.6019 20.309 11.5367C20.5373 11.4625 20.7354 11.2645 21.1314 10.8685L21.8686 10.1312C22.2646 9.7352 22.4627 9.53719 22.5368 9.30887C22.6021 9.10802 22.6021 8.89168 22.5368 8.69083C22.4627 8.4625 22.2646 8.26449 21.8686 7.86848ZM12 11.9998C13.1046 11.9998 14 12.8953 14 13.9998C14 15.1044 13.1046 15.9998 12 15.9998C10.8954 15.9998 10 15.1044 10 13.9998C10 12.8953 10.8954 11.9998 12 11.9998Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), za = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M15 7L8.83447 8.76158C8.52956 8.8487 8.37711 8.89226 8.25117 8.97414C8.13969 9.04662 8.04379 9.1406 7.96907 9.2506C7.88466 9.37485 7.83803 9.5264 7.74477 9.82948L4 22M4 22L16.1705 18.2552C16.4736 18.162 16.6251 18.1153 16.7494 18.0309C16.8594 17.9562 16.9534 17.8603 17.0259 17.7488C17.1077 17.6229 17.1513 17.4704 17.2384 17.1655L19 11M4 22L10.586 15.4139M5 8V2M2 5H8M21.8686 7.86863L18.1314 4.13137C17.7354 3.73535 17.5373 3.53735 17.309 3.46316C17.1082 3.3979 16.8918 3.3979 16.691 3.46316C16.4627 3.53735 16.2646 3.73535 15.8686 4.13137L15.1314 4.86863C14.7354 5.26465 14.5373 5.46265 14.4632 5.69098C14.3979 5.89183 14.3979 6.10817 14.4632 6.30902C14.5373 6.53735 14.7354 6.73535 15.1314 7.13137L18.8686 10.8686C19.2646 11.2646 19.4627 11.4627 19.691 11.5368C19.8918 11.6021 20.1082 11.6021 20.309 11.5368C20.5373 11.4627 20.7354 11.2646 21.1314 10.8686L21.8686 10.1314C22.2646 9.73535 22.4627 9.53735 22.5368 9.30902C22.6021 9.10817 22.6021 8.89183 22.5368 8.69098C22.4627 8.46265 22.2646 8.26465 21.8686 7.86863ZM12 12C13.1046 12 14 12.8954 14 14C14 15.1046 13.1046 16 12 16C10.8954 16 10 15.1046 10 14C10 12.8954 10.8954 12 12 12Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ba = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M19 9V15M5 7V17M17 6.71429L7 5.28571M17 17.2857L7 18.7143M4.6 7H5.4C5.96005 7 6.24008 7 6.45399 6.89101C6.64215 6.79513 6.79513 6.64215 6.89101 6.45399C7 6.24008 7 5.96005 7 5.4V4.6C7 4.03995 7 3.75992 6.89101 3.54601C6.79513 3.35785 6.64215 3.20487 6.45399 3.10899C6.24008 3 5.96005 3 5.4 3H4.6C4.03995 3 3.75992 3 3.54601 3.10899C3.35785 3.20487 3.20487 3.35785 3.10899 3.54601C3 3.75992 3 4.03995 3 4.6V5.4C3 5.96005 3 6.24008 3.10899 6.45399C3.20487 6.64215 3.35785 6.79513 3.54601 6.89101C3.75992 7 4.03995 7 4.6 7ZM4.6 21H5.4C5.96005 21 6.24008 21 6.45399 20.891C6.64215 20.7951 6.79513 20.6422 6.89101 20.454C7 20.2401 7 19.9601 7 19.4V18.6C7 18.0399 7 17.7599 6.89101 17.546C6.79513 17.3578 6.64215 17.2049 6.45399 17.109C6.24008 17 5.96005 17 5.4 17H4.6C4.03995 17 3.75992 17 3.54601 17.109C3.35785 17.2049 3.20487 17.3578 3.10899 17.546C3 17.7599 3 18.0399 3 18.6V19.4C3 19.9601 3 20.2401 3.10899 20.454C3.20487 20.6422 3.35785 20.7951 3.54601 20.891C3.75992 21 4.03995 21 4.6 21ZM18.6 9H19.4C19.9601 9 20.2401 9 20.454 8.89101C20.6422 8.79513 20.7951 8.64215 20.891 8.45399C21 8.24008 21 7.96005 21 7.4V6.6C21 6.03995 21 5.75992 20.891 5.54601C20.7951 5.35785 20.6422 5.20487 20.454 5.10899C20.2401 5 19.9601 5 19.4 5H18.6C18.0399 5 17.7599 5 17.546 5.10899C17.3578 5.20487 17.2049 5.35785 17.109 5.54601C17 5.75992 17 6.03995 17 6.6V7.4C17 7.96005 17 8.24008 17.109 8.45399C17.2049 8.64215 17.3578 8.79513 17.546 8.89101C17.7599 9 18.0399 9 18.6 9ZM18.6 19H19.4C19.9601 19 20.2401 19 20.454 18.891C20.6422 18.7951 20.7951 18.6422 20.891 18.454C21 18.2401 21 17.9601 21 17.4V16.6C21 16.0399 21 15.7599 20.891 15.546C20.7951 15.3578 20.6422 15.2049 20.454 15.109C20.2401 15 19.9601 15 19.4 15H18.6C18.0399 15 17.7599 15 17.546 15.109C17.3578 15.2049 17.2049 15.3578 17.109 15.546C17 15.7599 17 16.0399 17 16.6V17.4C17 17.9601 17 18.2401 17.109 18.454C17.2049 18.6422 17.3578 18.7951 17.546 18.891C17.7599 19 18.0399 19 18.6 19Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Va = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M16 5.00007L16 19.0001M10 4.00007L10 20.0001M3 12.0001H21M3 5.98924L3 18.0109C3 19.3749 3 20.0569 3.28134 20.5297C3.52803 20.9442 3.9162 21.2556 4.37434 21.4065C4.89685 21.5785 5.56262 21.4306 6.89418 21.1347L18.4942 18.5569C19.3883 18.3582 19.8354 18.2589 20.1691 18.0185C20.4634 17.8064 20.6945 17.5183 20.8377 17.1849C21 16.807 21 16.3491 21 15.4331V8.56702C21 7.65109 21 7.19312 20.8377 6.8152C20.6945 6.48186 20.4634 6.19373 20.1691 5.98168C19.8354 5.74126 19.3883 5.64191 18.4942 5.44322L6.89418 2.86544C5.56262 2.56954 4.89685 2.42159 4.37434 2.59368C3.9162 2.74457 3.52803 3.05596 3.28134 3.47045C3 3.94318 3 4.6252 3 5.98924Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ha = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M16 4V20M16 4H18M16 4H10.5C8.01472 4 6 6.01472 6 8.5C6 10.9853 8.01472 13 10.5 13H16V4ZM14 20H18",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ua = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M17.5 4V20M19.5 4H9C6.79086 4 5 5.79086 5 8C5 10.2091 6.79086 12 9 12H14M14 4V20M12 20H19.5",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Wa = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M15 17V7H11C9.34315 7 8 8.34315 8 10C8 11.6569 9.34315 13 11 13H15M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ga = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 3V6M12 10.5V13.5M12 18V21M3.28777 7.99059L7.67567 11.3659C7.95617 11.5817 8.09641 11.6895 8.14681 11.821C8.19098 11.9363 8.19098 12.0637 8.14681 12.179C8.09641 12.3105 7.95617 12.4183 7.67567 12.6341L3.28777 16.0094C2.87415 16.3276 2.66735 16.4867 2.49387 16.4845C2.34295 16.4827 2.20094 16.4128 2.10745 16.2943C2 16.1581 2 15.8971 2 15.3753V8.62469C2 8.10286 2 7.84195 2.10745 7.70574C2.20094 7.58724 2.34295 7.51732 2.49387 7.51547C2.66735 7.51334 2.87415 7.67243 3.28777 7.99059ZM20.7122 7.99059L16.3243 11.3659C16.0438 11.5817 15.9036 11.6895 15.8532 11.821C15.809 11.9363 15.809 12.0637 15.8532 12.179C15.9036 12.3105 16.0438 12.4183 16.3243 12.6341L20.7122 16.0094C21.1258 16.3276 21.3327 16.4867 21.5061 16.4845C21.6571 16.4827 21.7991 16.4128 21.8925 16.2943C22 16.1581 22 15.8971 22 15.3753V8.62469C22 8.10286 22 7.84195 21.8925 7.70574C21.7991 7.58724 21.6571 7.51732 21.5061 7.51547C21.3327 7.51334 21.1258 7.67243 20.7122 7.99059Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ka = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 3V6M12 10.5V13.5M12 18V21M22 12H15.5M15.5 12L19.5 16M15.5 12L19.5 8M2 12H8.5M8.5 12L4.5 16M8.5 12L4.5 8",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), qa = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M21 4H3M21 20H3M12 9.25H3M12 14.75H3M19.72 8.46L15.8533 11.36C15.5638 11.5771 15.4191 11.6857 15.3673 11.8188C15.322 11.9353 15.322 12.0647 15.3673 12.1812C15.4191 12.3143 15.5638 12.4229 15.8533 12.64L19.72 15.54C20.132 15.849 20.338 16.0035 20.5104 15.9999C20.6604 15.9968 20.8012 15.9264 20.8937 15.8082C21 15.6725 21 15.415 21 14.9V9.1C21 8.58503 21 8.32754 20.8937 8.19175C20.8012 8.07358 20.6604 8.00323 20.5104 8.00011C20.338 7.99652 20.132 8.15102 19.72 8.46Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ja = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 9.24995H3M12 3.99995L3 3.99995M21 14.75H3M21 20H3M19.72 2.95995L15.8533 5.85995C15.5638 6.07707 15.4191 6.18563 15.3673 6.31872C15.322 6.43529 15.322 6.56462 15.3673 6.68119C15.4191 6.81427 15.5638 6.92283 15.8533 7.13995L19.72 10.04C20.132 10.3489 20.338 10.5034 20.5104 10.4998C20.6604 10.4967 20.8012 10.4264 20.8937 10.3082C21 10.1724 21 9.91493 21 9.39995V3.59995C21 3.08498 21 2.82749 20.8937 2.6917C20.8012 2.57354 20.6604 2.50318 20.5104 2.50006C20.338 2.49648 20.132 2.65097 19.72 2.95995Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ya = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M19 4.5C19 4.96466 19 5.19698 18.9616 5.39018C18.8038 6.18356 18.1836 6.80376 17.3902 6.96157C17.197 7 16.9647 7 16.5 7H5.5C5.03534 7 4.80302 7 4.60982 6.96157C3.81644 6.80376 3.19624 6.18356 3.03843 5.39018C3 5.19698 3 4.96466 3 4.5C3 4.03534 3 3.80302 3.03843 3.60982C3.19624 2.81644 3.81644 2.19624 4.60982 2.03843C4.80302 2 5.03534 2 5.5 2H16.5C16.9647 2 17.197 2 17.3902 2.03843C18.1836 2.19624 18.8038 2.81644 18.9616 3.60982C19 3.80302 19 4.03534 19 4.5ZM19 4.5C19.9319 4.5 20.3978 4.5 20.7654 4.65224C21.2554 4.85523 21.6448 5.24458 21.8478 5.73463C22 6.10218 22 6.56812 22 7.5V7.8C22 8.9201 22 9.48016 21.782 9.90798C21.5903 10.2843 21.2843 10.5903 20.908 10.782C20.4802 11 19.9201 11 18.8 11H15.2C14.0799 11 13.5198 11 13.092 11.218C12.7157 11.4097 12.4097 11.7157 12.218 12.092C12 12.5198 12 13.0799 12 14.2V15M11.6 22H12.4C12.9601 22 13.2401 22 13.454 21.891C13.6422 21.7951 13.7951 21.6422 13.891 21.454C14 21.2401 14 20.9601 14 20.4V16.6C14 16.0399 14 15.7599 13.891 15.546C13.7951 15.3578 13.6422 15.2049 13.454 15.109C13.2401 15 12.9601 15 12.4 15H11.6C11.0399 15 10.7599 15 10.546 15.109C10.3578 15.2049 10.2049 15.3578 10.109 15.546C10 15.7599 10 16.0399 10 16.6V20.4C10 20.9601 10 21.2401 10.109 21.454C10.2049 21.6422 10.3578 21.7951 10.546 21.891C10.7599 22 11.0399 22 11.6 22Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Xa = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M14 22H6.8M6.8 22C5.11984 22 4.27976 22 3.63803 21.673C3.07354 21.3854 2.6146 20.9265 2.32698 20.362C2 19.7202 2 18.8802 2 17.2M6.8 22H7.2C8.88016 22 9.72024 22 10.362 21.673C10.9265 21.3854 11.3854 20.9265 11.673 20.362C12 19.7202 12 18.8802 12 17.2V16.8C12 15.1198 12 14.2798 11.673 13.638C11.3854 13.0735 10.9265 12.6146 10.362 12.327C9.72024 12 8.88016 12 7.2 12H6.8C5.11984 12 4.27976 12 3.63803 12.327C3.07354 12.6146 2.6146 13.0735 2.32698 13.638C2 14.2798 2 15.1198 2 16.8V17.2M2 17.2V10M10 2H14M22 10V14M18 22C18.93 22 19.395 22 19.7765 21.8978C20.8117 21.6204 21.6204 20.8117 21.8978 19.7765C22 19.395 22 18.93 22 18M22 6C22 5.07003 22 4.60504 21.8978 4.22354C21.6204 3.18827 20.8117 2.37962 19.7765 2.10222C19.395 2 18.93 2 18 2M6 2C5.07003 2 4.60504 2 4.22354 2.10222C3.18827 2.37962 2.37962 3.18827 2.10222 4.22354C2 4.60504 2 5.07003 2 6",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Za = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M16 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V8M11.5 12.5L17 7M17 7H12M17 7V12M6.2 21H8.8C9.9201 21 10.4802 21 10.908 20.782C11.2843 20.5903 11.5903 20.2843 11.782 19.908C12 19.4802 12 18.9201 12 17.8V15.2C12 14.0799 12 13.5198 11.782 13.092C11.5903 12.7157 11.2843 12.4097 10.908 12.218C10.4802 12 9.92011 12 8.8 12H6.2C5.0799 12 4.51984 12 4.09202 12.218C3.71569 12.4097 3.40973 12.7157 3.21799 13.092C3 13.5198 3 14.0799 3 15.2V17.8C3 18.9201 3 19.4802 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.07989 21 6.2 21Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Qa = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8M16.2 3C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8M16.2 3H15.2C14.0799 3 13.5198 3 13.092 3.21799C12.7157 3.40973 12.4097 3.71569 12.218 4.09202C12 4.51984 12 5.07989 12 6.2V8.8C12 9.9201 12 10.4802 12.218 10.908C12.4097 11.2843 12.7157 11.5903 13.092 11.782C13.5198 12 14.0799 12 15.2 12H17.8C18.9201 12 19.4802 12 19.908 11.782C20.2843 11.5903 20.5903 11.2843 20.782 10.908C21 10.4802 21 9.92011 21 8.8V7.8M12.5 11.5L7 17M7 17H12M7 17L7 12",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), $a = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M20 4L8.5 15.5M8.5 8.5L20 20M6 3C7.65685 3 9 4.34315 9 6C9 7.65685 7.65685 9 6 9C4.34315 9 3 7.65685 3 6C3 4.34315 4.34315 3 6 3ZM6 15C7.65685 15 9 16.3431 9 18C9 19.6569 7.65685 21 6 21C4.34315 21 3 19.6569 3 18C3 16.3431 4.34315 15 6 15Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), eo = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M4.5 8.6L21 17M21 7L4.5 15.4M6 3C7.65685 3 9 4.34315 9 6C9 7.65685 7.65685 9 6 9C4.34315 9 3 7.65685 3 6C3 4.34315 4.34315 3 6 3ZM6 15C7.65685 15 9 16.3431 9 18C9 19.6569 7.65685 21 6 21C4.34315 21 3 19.6569 3 18C3 16.3431 4.34315 15 6 15Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), to = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M20 4L8.5 15.5M8.5 8.5L20 20M17.5 12H17.51M22 12H22.01M6 3C7.65685 3 9 4.34315 9 6C9 7.65685 7.65685 9 6 9C4.34315 9 3 7.65685 3 6C3 4.34315 4.34315 3 6 3ZM6 15C7.65685 15 9 16.3431 9 18C9 19.6569 7.65685 21 6 21C4.34315 21 3 19.6569 3 18C3 16.3431 4.34315 15 6 15Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), no = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M4.5 8.6L21 17M21 7L4.5 15.4M17.5 12H17.51M22 12H22.01M6 3C7.65685 3 9 4.34315 9 6C9 7.65685 7.65685 9 6 9C4.34315 9 3 7.65685 3 6C3 4.34315 4.34315 3 6 3ZM6 15C7.65685 15 9 16.3431 9 18C9 19.6569 7.65685 21 6 21C4.34315 21 3 19.6569 3 18C3 16.3431 4.34315 15 6 15Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ro = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M19.7141 6.9999L18.2856 16.9999M6.14286 7L4.35714 17M18 5L8 5M16 19L6 19M5.6 7H6.4C6.96005 7 7.24008 7 7.45399 6.89101C7.64215 6.79513 7.79513 6.64215 7.89101 6.45399C8 6.24008 8 5.96005 8 5.4V4.6C8 4.03995 8 3.75992 7.89101 3.54601C7.79513 3.35785 7.64215 3.20487 7.45399 3.10899C7.24008 3 6.96005 3 6.4 3H5.6C5.03995 3 4.75992 3 4.54601 3.10899C4.35785 3.20487 4.20487 3.35785 4.10899 3.54601C4 3.75992 4 4.03995 4 4.6V5.4C4 5.96005 4 6.24008 4.10899 6.45399C4.20487 6.64215 4.35785 6.79513 4.54601 6.89101C4.75992 7 5.03995 7 5.6 7ZM3.6 21H4.4C4.96005 21 5.24008 21 5.45399 20.891C5.64215 20.7951 5.79513 20.6422 5.89101 20.454C6 20.2401 6 19.9601 6 19.4V18.6C6 18.0399 6 17.7599 5.89101 17.546C5.79513 17.3578 5.64215 17.2049 5.45399 17.109C5.24008 17 4.96005 17 4.4 17H3.6C3.03995 17 2.75992 17 2.54601 17.109C2.35785 17.2049 2.20487 17.3578 2.10899 17.546C2 17.7599 2 18.0399 2 18.6V19.4C2 19.9601 2 20.2401 2.10899 20.454C2.20487 20.6422 2.35785 20.7951 2.54601 20.891C2.75992 21 3.03995 21 3.6 21ZM19.6 7H20.4C20.9601 7 21.2401 7 21.454 6.89101C21.6422 6.79513 21.7951 6.64215 21.891 6.45399C22 6.24008 22 5.96005 22 5.4V4.6C22 4.03995 22 3.75992 21.891 3.54601C21.7951 3.35785 21.6422 3.20487 21.454 3.10899C21.2401 3 20.9601 3 20.4 3H19.6C19.0399 3 18.7599 3 18.546 3.10899C18.3578 3.20487 18.2049 3.35785 18.109 3.54601C18 3.75992 18 4.03995 18 4.6V5.4C18 5.96005 18 6.24008 18.109 6.45399C18.2049 6.64215 18.3578 6.79513 18.546 6.89101C18.7599 7 19.0399 7 19.6 7ZM17.6 21H18.4C18.9601 21 19.2401 21 19.454 20.891C19.6422 20.7951 19.7951 20.6422 19.891 20.454C20 20.2401 20 19.9601 20 19.4V18.6C20 18.0399 20 17.7599 19.891 17.546C19.7951 17.3578 19.6422 17.2049 19.454 17.109C19.2401 17 18.9601 17 18.4 17H17.6C17.0399 17 16.7599 17 16.546 17.109C16.3578 17.2049 16.2049 17.3578 16.109 17.546C16 17.7599 16 18.0399 16 18.6V19.4C16 19.9601 16 20.2401 16.109 20.454C16.2049 20.6422 16.3578 20.7951 16.546 20.891C16.7599 21 17.0399 21 17.6 21Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), io = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M6 16C6 18.2091 7.79086 20 10 20H14C16.2091 20 18 18.2091 18 16C18 13.7909 16.2091 12 14 12M18 8C18 5.79086 16.2091 4 14 4H10C7.79086 4 6 5.79086 6 8M3 12H21",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ao = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M6 16C6 18.2091 7.79086 20 10 20H14C16.2091 20 18 18.2091 18 16C18 13.7909 16.2091 12 14 12M10.5 20C12.7091 20 14.5 18.2091 14.5 16C14.5 13.7909 12.7091 12 10.5 12M18 8C18 5.79086 16.2091 4 14 4H10C7.79086 4 6 5.79086 6 8M13.5 4C11.2909 4 9.5 5.79086 9.5 8M3 12H21",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), oo = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M6 12H18M11 12H13C14.3807 12 15.5 13.1193 15.5 14.5C15.5 15.8807 14.3807 17 13 17H10.8333C9.83827 17 8.98868 16.3771 8.65321 15.5M15.3468 8.5C15.0113 7.62288 14.1617 7 13.1667 7H11C9.97484 7 9.0938 7.61705 8.70802 8.5M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), so = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M3 5L13 15M13 5L3 15M21 19.0001H17C17 17.5001 17.44 17.0001 18.5 16.5001C19.56 16.0001 21 15.3301 21 14.0001C21 13.5301 20.83 13.0701 20.52 12.7101C20.1999 12.3476 19.7649 12.1061 19.2879 12.026C18.811 11.9459 18.321 12.0321 17.9 12.2701C17.48 12.5101 17.16 12.8901 17 13.3401",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), co = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M13 7H5.2C4.0799 7 3.51984 7 3.09202 7.21799C2.71569 7.40973 2.40973 7.71569 2.21799 8.09202C2 8.51984 2 9.0799 2 10.2V13.8C2 14.9201 2 15.4802 2.21799 15.908C2.40973 16.2843 2.71569 16.5903 3.09202 16.782C3.51984 17 4.07989 17 5.2 17H13M17 7H18.8C19.9201 7 20.4802 7 20.908 7.21799C21.2843 7.40973 21.5903 7.71569 21.782 8.09202C22 8.51984 22 9.0799 22 10.2V13.8C22 14.9201 22 15.4802 21.782 15.908C21.5903 16.2843 21.2843 16.5903 20.908 16.782C20.4802 17 19.9201 17 18.8 17H17M17 21L17 3M19.5 3.00001L14.5 3M19.5 21L14.5 21",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), lo = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M19 7V17M5 7V17M17 5L7 5M17 19H7M4.6 7H5.4C5.96005 7 6.24008 7 6.45399 6.89101C6.64215 6.79513 6.79513 6.64215 6.89101 6.45399C7 6.24008 7 5.96005 7 5.4V4.6C7 4.03995 7 3.75992 6.89101 3.54601C6.79513 3.35785 6.64215 3.20487 6.45399 3.10899C6.24008 3 5.96005 3 5.4 3H4.6C4.03995 3 3.75992 3 3.54601 3.10899C3.35785 3.20487 3.20487 3.35785 3.10899 3.54601C3 3.75992 3 4.03995 3 4.6V5.4C3 5.96005 3 6.24008 3.10899 6.45399C3.20487 6.64215 3.35785 6.79513 3.54601 6.89101C3.75992 7 4.03995 7 4.6 7ZM4.6 21H5.4C5.96005 21 6.24008 21 6.45399 20.891C6.64215 20.7951 6.79513 20.6422 6.89101 20.454C7 20.2401 7 19.9601 7 19.4V18.6C7 18.0399 7 17.7599 6.89101 17.546C6.79513 17.3578 6.64215 17.2049 6.45399 17.109C6.24008 17 5.96005 17 5.4 17H4.6C4.03995 17 3.75992 17 3.54601 17.109C3.35785 17.2049 3.20487 17.3578 3.10899 17.546C3 17.7599 3 18.0399 3 18.6V19.4C3 19.9601 3 20.2401 3.10899 20.454C3.20487 20.6422 3.35785 20.7951 3.54601 20.891C3.75992 21 4.03995 21 4.6 21ZM18.6 7H19.4C19.9601 7 20.2401 7 20.454 6.89101C20.6422 6.79513 20.7951 6.64215 20.891 6.45399C21 6.24008 21 5.96005 21 5.4V4.6C21 4.03995 21 3.75992 20.891 3.54601C20.7951 3.35785 20.6422 3.20487 20.454 3.10899C20.2401 3 19.9601 3 19.4 3H18.6C18.0399 3 17.7599 3 17.546 3.10899C17.3578 3.20487 17.2049 3.35785 17.109 3.54601C17 3.75992 17 4.03995 17 4.6V5.4C17 5.96005 17 6.24008 17.109 6.45399C17.2049 6.64215 17.3578 6.79513 17.546 6.89101C17.7599 7 18.0399 7 18.6 7ZM18.6 21H19.4C19.9601 21 20.2401 21 20.454 20.891C20.6422 20.7951 20.7951 20.6422 20.891 20.454C21 20.2401 21 19.9601 21 19.4V18.6C21 18.0399 21 17.7599 20.891 17.546C20.7951 17.3578 20.6422 17.2049 20.454 17.109C20.2401 17 19.9601 17 19.4 17H18.6C18.0399 17 17.7599 17 17.546 17.109C17.3578 17.2049 17.2049 17.3578 17.109 17.546C17 17.7599 17 18.0399 17 18.6V19.4C17 19.9601 17 20.2401 17.109 20.454C17.2049 20.6422 17.3578 20.7951 17.546 20.891C17.7599 21 18.0399 21 18.6 21Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), uo = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M4 7C4 6.06812 4 5.60218 4.15224 5.23463C4.35523 4.74458 4.74458 4.35523 5.23463 4.15224C5.60218 4 6.06812 4 7 4H17C17.9319 4 18.3978 4 18.7654 4.15224C19.2554 4.35523 19.6448 4.74458 19.8478 5.23463C20 5.60218 20 6.06812 20 7M9 20H15M12 4V20",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), fo = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M4 7C4 6.06812 4 5.60218 4.15224 5.23463C4.35523 4.74458 4.74458 4.35523 5.23463 4.15224C5.60218 4 6.06812 4 7 4H17C17.9319 4 18.3978 4 18.7654 4.15224C19.2554 4.35523 19.6448 4.74458 19.8478 5.23463C20 5.60218 20 6.06812 20 7M8 20H16M10.25 4V20M13.75 4V20",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), po = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M8 7H16M12 7V17M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), mo = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M4 7V6C4 5.45879 4.21497 4.96778 4.56419 4.60772M9 20H15M12 12V20M3 3L21 21M9.5 4H17C17.9319 4 18.3978 4 18.7654 4.15224C19.2554 4.35523 19.6448 4.74458 19.8478 5.23463C20 5.60218 20 6.06812 20 7M12 4V6.5",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ho = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M8 20H16M10.25 10.5V20M13.75 14V20M3 3L21 21M4 6.99995V5.99995C4 5.45873 4.21497 4.96773 4.56419 4.60767M9.5 4H17C17.9319 4 18.3978 4 18.7654 4.15224C19.2554 4.35523 19.6448 4.74458 19.8478 5.23463C20 5.60218 20 6.06812 20 7M10.25 4V5M13.75 4V8",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), go = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M18 4V11C18 14.3137 15.3137 17 12 17C8.68629 17 6 14.3137 6 11V4M4 21H20",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), _o = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M19 4V10C19 13.866 15.866 17 12 17C8.13401 17 5 13.866 5 10V4M8.5 4V10C8.5 13.2218 10.6766 15.9352 13.6395 16.7501M4 21H20M3 4L10.5 4M17 4L21 4",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), vo = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M15.5 7V10.5C15.5 12.433 13.933 14 12 14C10.067 14 8.5 12.433 8.5 10.5V7M8 17H16M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), yo = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M21 21L16.65 16.65M11 8V14M8 11H14M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), bo = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M21 21L16.65 16.65M8 11H14M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), xo = /* @__PURE__ */ k({
	AlignCenter: () => wi,
	AlignJustify: () => Ti,
	AlignLeft: () => Ei,
	AlignRight: () => Di,
	Attachment01: () => Oi,
	Attachment02: () => ki,
	BezierCurve01: () => Ai,
	BezierCurve02: () => ji,
	BezierCurve03: () => Mi,
	Bold01: () => Ni,
	Bold02: () => Pi,
	BoldSquare: () => Fi,
	Brush01: () => Ii,
	Brush02: () => Li,
	Brush03: () => Ri,
	CircleCut: () => zi,
	CodeSnippet01: () => Bi,
	CodeSnippet02: () => Vi,
	Colors: () => Hi,
	Command: () => Ui,
	Contrast01: () => Wi,
	Contrast02: () => Gi,
	Contrast03: () => Ki,
	Crop01: () => qi,
	Crop02: () => Ji,
	Cursor01: () => Yi,
	Cursor02: () => Xi,
	Cursor03: () => Zi,
	Cursor04: () => Qi,
	CursorBox: () => $i,
	CursorClick01: () => ea,
	CursorClick02: () => ta,
	Delete: () => na,
	Dotpoints01: () => ra,
	Dotpoints02: () => ia,
	Drop: () => aa,
	Dropper: () => oa,
	Eraser: () => sa,
	Feather: () => ca,
	Figma: () => la,
	Framer: () => ua,
	Hand: () => da,
	Heading01: () => fa,
	Heading02: () => pa,
	HeadingSquare: () => ma,
	ImageIndentLeft: () => ha,
	ImageIndentRight: () => ga,
	Italic01: () => _a,
	Italic02: () => va,
	ItalicSquare: () => ya,
	LeftIndent01: () => ba,
	LeftIndent02: () => xa,
	LetterSpacing01: () => Sa,
	LetterSpacing02: () => Ca,
	LineHeight: () => wa,
	MagicWand01: () => Ta,
	MagicWand02: () => Ea,
	Move: () => Da,
	Paint: () => Oa,
	PaintPour: () => ka,
	Palette: () => Aa,
	ParagraphSpacing: () => ja,
	ParagraphWrap: () => Ma,
	PenTool01: () => Ia,
	PenTool02: () => La,
	PenToolMinus: () => Ra,
	PenToolPlus: () => za,
	Pencil01: () => Na,
	Pencil02: () => Pa,
	PencilLine: () => Fa,
	Perspective01: () => Ba,
	Perspective02: () => Va,
	Pilcrow01: () => Ha,
	Pilcrow02: () => Ua,
	PilcrowSquare: () => Wa,
	Reflect01: () => Ga,
	Reflect02: () => Ka,
	RightIndent01: () => qa,
	RightIndent02: () => Ja,
	RollerBrush: () => Ya,
	Scale01: () => Xa,
	Scale02: () => Za,
	Scale03: () => Qa,
	Scissors01: () => $a,
	Scissors02: () => eo,
	ScissorsCut01: () => to,
	ScissorsCut02: () => no,
	Skew: () => ro,
	Strikethrough01: () => io,
	Strikethrough02: () => ao,
	StrikethroughSquare: () => oo,
	Subscript: () => so,
	TextInput: () => co,
	Transform: () => lo,
	Type01: () => uo,
	Type02: () => fo,
	Typesquare: () => po,
	Typestrikethrough01: () => mo,
	Typestrikethrough02: () => ho,
	Underline01: () => go,
	Underline02: () => _o,
	UnderlineSquare: () => vo,
	Zoomin: () => yo,
	Zoomout: () => bo
}), So = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M11.9995 12.0001H12.0095M15.535 15.5357C10.8488 20.222 5.46685 22.438 3.51423 20.4854C1.56161 18.5328 3.77769 13.1509 8.46398 8.46461C13.1503 3.77832 18.5322 1.56224 20.4848 3.51486C22.4374 5.46748 20.2213 10.8494 15.535 15.5357ZM15.535 8.46443C20.2213 13.1507 22.4374 18.5326 20.4848 20.4852C18.5321 22.4379 13.1502 20.2218 8.46394 15.5355C3.77765 10.8492 1.56157 5.4673 3.51419 3.51468C5.46681 1.56206 10.8487 3.77814 15.535 8.46443ZM12.4995 12.0001C12.4995 12.2763 12.2757 12.5001 11.9995 12.5001C11.7234 12.5001 11.4995 12.2763 11.4995 12.0001C11.4995 11.724 11.7234 11.5001 11.9995 11.5001C12.2757 11.5001 12.4995 11.724 12.4995 12.0001Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Co = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M17.1153 15.3582C16.8446 15.6642 16.5606 15.9665 16.2635 16.2635C11.9678 20.5593 6.58585 22.1422 4.2427 19.7991C2.6363 18.1926 2.8752 15.158 4.56847 12.0242M6.88967 8.72526C7.17138 8.40495 7.46772 8.08875 7.77824 7.77824C12.074 3.48247 17.4559 1.89956 19.7991 4.2427C21.4066 5.85021 21.1662 8.88795 19.4698 12.024M16.2635 7.77824C20.5593 12.074 22.1422 17.4559 19.7991 19.7991C17.4559 22.1422 12.074 20.5593 7.77824 16.2635C3.48247 11.9678 1.89956 6.58585 4.2427 4.2427C6.58585 1.89956 11.9678 3.48247 16.2635 7.77824ZM13.0001 12C13.0001 12.5523 12.5523 13 12.0001 13C11.4478 13 11.0001 12.5523 11.0001 12C11.0001 11.4477 11.4478 11 12.0001 11C12.5523 11 13.0001 11.4477 13.0001 12Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), wo = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M7.96668 14.7219L7 22L11.5884 19.247C11.7381 19.1572 11.8129 19.1123 11.8928 19.0947C11.9634 19.0792 12.0366 19.0792 12.1072 19.0947C12.1871 19.1123 12.2619 19.1572 12.4116 19.247L17 22L16.0343 14.7212M19 9C19 12.866 15.866 16 12 16C8.13401 16 5 12.866 5 9C5 5.13401 8.13401 2 12 2C15.866 2 19 5.13401 19 9Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), To = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M7 15.0903V22L11.7029 20.1188C11.8126 20.0749 11.8675 20.053 11.9242 20.0443C11.9744 20.0366 12.0256 20.0366 12.0758 20.0443C12.1325 20.053 12.1874 20.0749 12.2971 20.1188L17 22V15.0903M19.5 9.5C19.5 13.6421 16.1421 17 12 17C7.85786 17 4.5 13.6421 4.5 9.5C4.5 5.35786 7.85786 2 12 2C16.1421 2 19.5 5.35786 19.5 9.5Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Eo = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M7.86866 15.4599L7 22L11.5884 19.247C11.7381 19.1572 11.8129 19.1123 11.8928 19.0947C11.9634 19.0792 12.0366 19.0792 12.1072 19.0947C12.1871 19.1123 12.2619 19.1572 12.4116 19.247L17 22L16.1319 15.4571M16.4259 4.24888C16.5803 4.6224 16.8768 4.9193 17.25 5.0743L18.5589 5.61648C18.9325 5.77121 19.2292 6.06799 19.384 6.44154C19.5387 6.81509 19.5387 7.23481 19.384 7.60836L18.8422 8.91635C18.6874 9.29007 18.6872 9.71021 18.8427 10.0837L19.3835 11.3913C19.4602 11.5764 19.4997 11.7747 19.4997 11.975C19.4998 12.1752 19.4603 12.3736 19.3837 12.5586C19.3071 12.7436 19.1947 12.9118 19.0531 13.0534C18.9114 13.195 18.7433 13.3073 18.5582 13.3839L17.2503 13.9256C16.8768 14.0801 16.5799 14.3765 16.4249 14.7498L15.8827 16.0588C15.728 16.4323 15.4312 16.7291 15.0577 16.8838C14.6841 17.0386 14.2644 17.0386 13.8909 16.8838L12.583 16.342C12.2094 16.1877 11.7899 16.188 11.4166 16.3429L10.1077 16.8843C9.73434 17.0387 9.31501 17.0386 8.94178 16.884C8.56854 16.7293 8.27194 16.4329 8.11711 16.0598L7.57479 14.7504C7.42035 14.3769 7.12391 14.08 6.75064 13.925L5.44175 13.3828C5.06838 13.2282 4.77169 12.9316 4.61691 12.5582C4.46213 12.1849 4.46192 11.7654 4.61633 11.3919L5.1581 10.0839C5.31244 9.71035 5.31213 9.29079 5.15722 8.91746L4.61623 7.60759C4.53953 7.42257 4.50003 7.22426 4.5 7.02397C4.49997 6.82369 4.5394 6.62536 4.61604 6.44032C4.69268 6.25529 4.80504 6.08716 4.94668 5.94556C5.08832 5.80396 5.25647 5.69166 5.44152 5.61508L6.74947 5.07329C7.12265 4.91898 7.41936 4.6229 7.57448 4.25004L8.11664 2.94111C8.27136 2.56756 8.56813 2.27078 8.94167 2.11605C9.3152 1.96132 9.7349 1.96132 10.1084 2.11605L11.4164 2.65784C11.7899 2.81218 12.2095 2.81187 12.5828 2.65696L13.8922 2.11689C14.2657 1.96224 14.6853 1.96228 15.0588 2.11697C15.4322 2.27167 15.729 2.56837 15.8837 2.94182L16.426 4.25115L16.4259 4.24888Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Do = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M8.87625 13.0953L4.70122 7.87653C4.44132 7.55166 4.31138 7.38922 4.21897 7.20834C4.13698 7.04787 4.07706 6.87705 4.04084 6.70052C4 6.50155 4 6.29354 4 5.8775V5.2C4 4.0799 4 3.51984 4.21799 3.09202C4.40973 2.71569 4.71569 2.40973 5.09202 2.21799C5.51984 2 6.0799 2 7.2 2H16.8C17.9201 2 18.4802 2 18.908 2.21799C19.2843 2.40973 19.5903 2.71569 19.782 3.09202C20 3.51984 20 4.0799 20 5.2V5.8775C20 6.29354 20 6.50155 19.9592 6.70052C19.9229 6.87705 19.863 7.04787 19.781 7.20834C19.6886 7.38922 19.5587 7.55166 19.2988 7.87652L15.1238 13.0953M5.00005 3L12.0001 12L19 3M15.5355 13.4645C17.4882 15.4171 17.4882 18.5829 15.5355 20.5355C13.5829 22.4882 10.4171 22.4882 8.46446 20.5355C6.51185 18.5829 6.51185 15.4171 8.46446 13.4645C10.4171 11.5118 13.5829 11.5118 15.5355 13.4645Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Oo = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M7.13515 11.189L3.3304 4.38052C2.89291 3.59765 2.67417 3.20621 2.71103 2.88573C2.7432 2.60611 2.8917 2.353 3.1201 2.18852C3.38188 2 3.83029 2 4.72711 2H6.96193C7.29523 2 7.46187 2 7.61135 2.04813C7.74362 2.09073 7.86556 2.16042 7.96939 2.25276C8.08674 2.35712 8.17132 2.5007 8.3405 2.78788L12.0001 9L15.6597 2.78788C15.8289 2.5007 15.9135 2.35712 16.0308 2.25276C16.1347 2.16042 16.2566 2.09073 16.3889 2.04813C16.5383 2 16.705 2 17.0383 2H19.2731C20.1699 2 20.6183 2 20.8801 2.18852C21.1085 2.353 21.257 2.60611 21.2892 2.88573C21.326 3.20621 21.1073 3.59765 20.6698 4.38052L16.8651 11.189M10.5001 14L12.0001 13V18M10.7501 18H13.2501M16.5963 10.9038C19.1347 13.4422 19.1347 17.5578 16.5963 20.0962C14.0579 22.6346 9.94232 22.6346 7.40391 20.0962C4.8655 17.5578 4.8655 13.4422 7.40391 10.9038C9.94231 8.3654 14.0579 8.3654 16.5963 10.9038Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ko = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M20 13V17.8C20 18.9201 20 19.4802 19.782 19.908C19.5903 20.2843 19.2843 20.5903 18.908 20.782C18.4802 21 17.9201 21 16.8 21H7.2C6.0799 21 5.51984 21 5.09202 20.782C4.71569 20.5903 4.40973 20.2843 4.21799 19.908C4 19.4802 4 18.9201 4 17.8V13M9 10H15M9.28571 14H14.7143C16.8467 14 17.913 14 18.7355 13.6039C19.552 13.2107 20.2107 12.552 20.6039 11.7355C21 10.913 21 9.84674 21 7.71429C21 6.11494 21 5.31527 20.7029 4.69835C20.408 4.08603 19.914 3.59197 19.3017 3.29709C18.6847 3 17.8851 3 16.2857 3H7.71429C6.11494 3 5.31527 3 4.69835 3.29709C4.08603 3.59197 3.59197 4.08603 3.29709 4.69835C3 5.31527 3 6.11494 3 7.71429C3 9.84674 3 10.913 3.39612 11.7355C3.7893 12.552 4.44803 13.2107 5.26447 13.6039C6.08703 14 7.15326 14 9.28571 14Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ao = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M10 2.00008V6.6605C10 6.87768 10 6.98626 9.9669 7.07264C9.93568 7.15413 9.89435 7.21328 9.82858 7.27063C9.75885 7.33142 9.64593 7.37279 9.42008 7.45553C6.54892 8.50734 4.5 11.2644 4.5 14.5C4.5 18.6421 7.85786 22 12 22C16.1421 22 19.5 18.6421 19.5 14.5C19.5 11.2644 17.4511 8.50734 14.5799 7.45553C14.3541 7.37279 14.2411 7.33142 14.1714 7.27063C14.1056 7.21328 14.0643 7.15413 14.0331 7.07264C14 6.98626 14 6.87768 14 6.6605V2.00008M8.5 2H15.5",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), jo = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9 6V10.5012C9 11.0521 9 11.3276 8.93132 11.5829C8.87047 11.809 8.77037 12.0228 8.63557 12.2143C8.48344 12.4305 8.27182 12.6068 7.84859 12.9595L4.15141 16.0405C3.72818 16.3932 3.51656 16.5695 3.36443 16.7857C3.22963 16.9772 3.12953 17.191 3.06868 17.4171C3 17.6724 3 17.9479 3 18.4988V18.8C3 19.9201 3 20.4802 3.21799 20.908C3.40973 21.2843 3.71569 21.5903 4.09202 21.782C4.51984 22 5.0799 22 6.2 22H17.8C18.9201 22 19.4802 22 19.908 21.782C20.2843 21.5903 20.5903 21.2843 20.782 20.908C21 20.4802 21 19.9201 21 18.8V18.4988C21 17.9479 21 17.6724 20.9313 17.4171C20.8705 17.191 20.7704 16.9772 20.6356 16.7857C20.4834 16.5695 20.2718 16.3932 19.8486 16.0405L16.1514 12.9595C15.7282 12.6068 15.5166 12.4305 15.3644 12.2143C15.2296 12.0228 15.1295 11.809 15.0687 11.5829C15 11.3276 15 11.0521 15 10.5012V6M8.3 6H15.7C15.98 6 16.12 6 16.227 5.9455C16.3211 5.89757 16.3976 5.82108 16.4455 5.727C16.5 5.62004 16.5 5.48003 16.5 5.2V2.8C16.5 2.51997 16.5 2.37996 16.4455 2.273C16.3976 2.17892 16.3211 2.10243 16.227 2.0545C16.12 2 15.98 2 15.7 2H8.3C8.01997 2 7.87996 2 7.773 2.0545C7.67892 2.10243 7.60243 2.17892 7.5545 2.273C7.5 2.37996 7.5 2.51997 7.5 2.8V5.2C7.5 5.48003 7.5 5.62004 7.5545 5.727C7.60243 5.82108 7.67892 5.89757 7.773 5.9455C7.87996 6 8.01997 6 8.3 6ZM5.5 17H18.5C18.9647 17 19.197 17 19.3902 17.0384C20.1836 17.1962 20.8038 17.8164 20.9616 18.6098C21 18.803 21 19.0353 21 19.5C21 19.9647 21 20.197 20.9616 20.3902C20.8038 21.1836 20.1836 21.8038 19.3902 21.9616C19.197 22 18.9647 22 18.5 22H5.5C5.03534 22 4.80302 22 4.60982 21.9616C3.81644 21.8038 3.19624 21.1836 3.03843 20.3902C3 20.197 3 19.9647 3 19.5C3 19.0353 3 18.803 3.03843 18.6098C3.19624 17.8164 3.81644 17.1962 4.60982 17.0384C4.80302 17 5.03534 17 5.5 17Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Mo = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M20 19V16H7C5.34315 16 4 17.3431 4 19M8.8 22H16.8C17.9201 22 18.4802 22 18.908 21.782C19.2843 21.5903 19.5903 21.2843 19.782 20.908C20 20.4802 20 19.9201 20 18.8V5.2C20 4.07989 20 3.51984 19.782 3.09202C19.5903 2.71569 19.2843 2.40973 18.908 2.21799C18.4802 2 17.9201 2 16.8 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), No = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 21L11.8999 20.8499C11.2053 19.808 10.858 19.287 10.3991 18.9098C9.99286 18.5759 9.52476 18.3254 9.02161 18.1726C8.45325 18 7.82711 18 6.57482 18H5.2C4.07989 18 3.51984 18 3.09202 17.782C2.71569 17.5903 2.40973 17.2843 2.21799 16.908C2 16.4802 2 15.9201 2 14.8V6.2C2 5.07989 2 4.51984 2.21799 4.09202C2.40973 3.71569 2.71569 3.40973 3.09202 3.21799C3.51984 3 4.07989 3 5.2 3H5.6C7.84021 3 8.96031 3 9.81596 3.43597C10.5686 3.81947 11.1805 4.43139 11.564 5.18404C12 6.03968 12 7.15979 12 9.4M12 21V9.4M12 21L12.1001 20.8499C12.7947 19.808 13.142 19.287 13.6009 18.9098C14.0071 18.5759 14.4752 18.3254 14.9784 18.1726C15.5467 18 16.1729 18 17.4252 18H18.8C19.9201 18 20.4802 18 20.908 17.782C21.2843 17.5903 21.5903 17.2843 21.782 16.908C22 16.4802 22 15.9201 22 14.8V6.2C22 5.07989 22 4.51984 21.782 4.09202C21.5903 3.71569 21.2843 3.40973 20.908 3.21799C20.4802 3 19.9201 3 18.8 3H18.4C16.1598 3 15.0397 3 14.184 3.43597C13.4314 3.81947 12.8195 4.43139 12.436 5.18404C12 6.03968 12 7.15979 12 9.4",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Po = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 20H5.2C4.07989 20 3.51984 20 3.09202 19.782C2.71569 19.5903 2.40973 19.2843 2.21799 18.908C2 18.4802 2 17.9201 2 16.8V7.2C2 6.07989 2 5.51984 2.21799 5.09202C2.40973 4.71569 2.71569 4.40973 3.09202 4.21799C3.51984 4 4.07989 4 5.2 4H5.6C7.84021 4 8.96031 4 9.81596 4.43597C10.5686 4.81947 11.1805 5.43139 11.564 6.18404C12 7.03968 12 8.15979 12 10.4M12 20V10.4M12 20H18.8C19.9201 20 20.4802 20 20.908 19.782C21.2843 19.5903 21.5903 19.2843 21.782 18.908C22 18.4802 22 17.9201 22 16.8V7.2C22 6.07989 22 5.51984 21.782 5.09202C21.5903 4.71569 21.2843 4.40973 20.908 4.21799C20.4802 4 19.9201 4 18.8 4H18.4C16.1598 4 15.0397 4 14.184 4.43597C13.4314 4.81947 12.8195 5.43139 12.436 6.18404C12 7.03968 12 8.15979 12 10.4",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Fo = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M16 7C16 6.07003 16 5.60504 15.8978 5.22354C15.6204 4.18827 14.8117 3.37962 13.7765 3.10222C13.395 3 12.93 3 12 3C11.07 3 10.605 3 10.2235 3.10222C9.18827 3.37962 8.37962 4.18827 8.10222 5.22354C8 5.60504 8 6.07003 8 7M5.2 21H18.8C19.9201 21 20.4802 21 20.908 20.782C21.2843 20.5903 21.5903 20.2843 21.782 19.908C22 19.4802 22 18.9201 22 17.8V10.2C22 9.07989 22 8.51984 21.782 8.09202C21.5903 7.71569 21.2843 7.40973 20.908 7.21799C20.4802 7 19.9201 7 18.8 7H5.2C4.07989 7 3.51984 7 3.09202 7.21799C2.71569 7.40973 2.40973 7.71569 2.21799 8.09202C2 8.51984 2 9.07989 2 10.2V17.8C2 18.9201 2 19.4802 2.21799 19.908C2.40973 20.2843 2.71569 20.5903 3.09202 20.782C3.51984 21 4.0799 21 5.2 21Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Io = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M8 21V7C8 6.07003 8 5.60504 8.10222 5.22354C8.37962 4.18827 9.18827 3.37962 10.2235 3.10222C10.605 3 11.07 3 12 3C12.93 3 13.395 3 13.7765 3.10222C14.8117 3.37962 15.6204 4.18827 15.8978 5.22354C16 5.60504 16 6.07003 16 7V21M5.2 21H18.8C19.9201 21 20.4802 21 20.908 20.782C21.2843 20.5903 21.5903 20.2843 21.782 19.908C22 19.4802 22 18.9201 22 17.8V10.2C22 9.07989 22 8.51984 21.782 8.09202C21.5903 7.71569 21.2843 7.40973 20.908 7.21799C20.4802 7 19.9201 7 18.8 7H5.2C4.07989 7 3.51984 7 3.09202 7.21799C2.71569 7.40973 2.40973 7.71569 2.21799 8.09202C2 8.51984 2 9.07989 2 10.2V17.8C2 18.9201 2 19.4802 2.21799 19.908C2.40973 20.2843 2.71569 20.5903 3.09202 20.782C3.51984 21 4.0799 21 5.2 21Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Lo = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M17.5 6.5L6.5 17.5M8.5 10.5V6.5M6.5 8.5H10.5M13.5 15.5H17.5M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ro = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M6.5 20H5C3.89543 20 3 19.1046 3 18V4C3 2.89543 3.89543 2 5 2H19C20.1046 2 21 2.89543 21 4V18C21 19.1046 20.1046 20 19 20H17.5M12 19C13.6569 19 15 17.6569 15 16C15 14.3431 13.6569 13 12 13C10.3431 13 9 14.3431 9 16C9 17.6569 10.3431 19 12 19ZM12 19L12.0214 18.9998L8.82867 22.1926L6.00024 19.3641L9.01965 16.3447M12 19L15.1928 22.1926L18.0212 19.3641L15.0018 16.3447M9 6H15M7 9.5H17",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), zo = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9 18.5H15M7 15H17M5 2H19C20.1046 2 21 2.99492 21 4.22222V19.7778C21 21.0051 20.1046 22 19 22H5C3.89543 22 3 21.0051 3 19.7778V4.22222C3 2.99492 3.89543 2 5 2ZM11.9976 6.21194C11.2978 5.4328 10.1309 5.22321 9.25414 5.93667C8.37738 6.65013 8.25394 7.84299 8.94247 8.6868C9.631 9.53061 11.9976 11.5 11.9976 11.5C11.9976 11.5 14.3642 9.53061 15.0527 8.6868C15.7413 7.84299 15.6329 6.64262 14.7411 5.93667C13.8492 5.23072 12.6974 5.4328 11.9976 6.21194Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Bo = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 4C10.6193 4 9.5 5.11929 9.5 6.5C9.5 7.88071 10.6193 9 12 9C13.3807 9 14.5 7.88071 14.5 6.5C14.5 5.11929 13.3807 4 12 4ZM12 4V2M21 14.9375C18.8012 17.4287 15.5841 19 12 19C8.41592 19 5.19883 17.4287 3 14.9375M10.7448 8.66169L3 22M13.2552 8.66169L21 22",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Vo = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M10 11.5347C11.2335 10.8218 12.7663 10.8218 13.9999 11.5347M8.82843 9.17157C10.3905 10.7337 10.3905 13.2663 8.82843 14.8284C7.26634 16.3905 4.73367 16.3905 3.17157 14.8284C1.60948 13.2663 1.60948 10.7337 3.17157 9.17157C4.73366 7.60948 7.26633 7.60948 8.82843 9.17157ZM20.8284 9.17157C22.3905 10.7337 22.3905 13.2663 20.8284 14.8284C19.2663 16.3905 16.7337 16.3905 15.1716 14.8284C13.6095 13.2663 13.6095 10.7337 15.1716 9.17157C16.7337 7.60948 19.2663 7.60948 20.8284 9.17157Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ho = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M10 14.5347C11.2335 13.8218 12.7663 13.8218 13.9999 14.5347M2 15L2.70149 7.98511C2.72808 7.71915 2.74138 7.58617 2.76178 7.47208C3.00222 6.12702 4.1212 5.11436 5.48352 5.00894C5.59907 5 5.73271 5 6 5M22 15L21.2985 7.98511C21.2719 7.71916 21.2586 7.58617 21.2382 7.47208C20.9978 6.12702 19.8788 5.11436 18.5165 5.00894C18.4009 5 18.2673 5 18 5M8.82843 12.1716C10.3905 13.7337 10.3905 16.2663 8.82843 17.8284C7.26634 19.3905 4.73367 19.3905 3.17157 17.8284C1.60948 16.2663 1.60948 13.7337 3.17157 12.1716C4.73366 10.6095 7.26633 10.6095 8.82843 12.1716ZM20.8284 12.1716C22.3905 13.7337 22.3905 16.2663 20.8284 17.8284C19.2663 19.3905 16.7337 19.3905 15.1716 17.8284C13.6095 16.2663 13.6095 13.7337 15.1716 12.1716C16.7337 10.6095 19.2663 10.6095 20.8284 12.1716Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Uo = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M18.6317 2.36816C23.1227 6.85919 23.1227 14.1406 18.6317 18.6316C14.3308 22.9325 7.47094 23.1146 2.95335 19.178C2.75634 19.0064 2.65783 18.9205 2.61336 18.8032C2.57595 18.7044 2.57176 18.5824 2.60232 18.4813C2.63863 18.3612 2.73705 18.2628 2.93388 18.0659L5.14913 15.8507M17.9999 10.4999C17.9999 14.642 14.6421 17.9999 10.4999 17.9999C6.35779 17.9999 2.99992 14.642 2.99992 10.4999C2.99992 6.35776 6.35779 2.99989 10.4999 2.99989C14.6421 2.99989 17.9999 6.35776 17.9999 10.4999Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Wo = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M2.66113 18.3391L7.25499 13.7452M18.2175 2.78271C21.9275 6.4927 21.9275 12.5078 18.2175 16.2177C14.5075 19.9277 8.49243 19.9277 4.78245 16.2177M17 22.0002H6.99997M12 22.0002V19.0002M17.5 9.50023C17.5 12.8139 14.8137 15.5002 11.5 15.5002C8.18626 15.5002 5.49997 12.8139 5.49997 9.50023C5.49997 6.18652 8.18626 3.50023 11.5 3.50023C14.8137 3.50023 17.5 6.18652 17.5 9.50023Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Go = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M5 10.0001V16.0112C5 16.3702 5 16.5496 5.05465 16.7081C5.10299 16.8482 5.18187 16.9759 5.28558 17.0817C5.40287 17.2015 5.5634 17.2818 5.88446 17.4423L11.2845 20.1423C11.5468 20.2735 11.678 20.3391 11.8156 20.3649C11.9375 20.3877 12.0625 20.3877 12.1844 20.3649C12.322 20.3391 12.4532 20.2735 12.7155 20.1423L18.1155 17.4423C18.4366 17.2818 18.5971 17.2015 18.7144 17.0817C18.8181 16.9759 18.897 16.8482 18.9453 16.7081C19 16.5496 19 16.3702 19 16.0112V10.0001M2 8.50006L11.6422 3.67895C11.7734 3.61336 11.839 3.58056 11.9078 3.56766C11.9687 3.55622 12.0313 3.55622 12.0922 3.56766C12.161 3.58056 12.2266 3.61336 12.3578 3.67895L22 8.50006L12.3578 13.3212C12.2266 13.3868 12.161 13.4196 12.0922 13.4325C12.0313 13.4439 11.9687 13.4439 11.9078 13.4325C11.839 13.4196 11.7734 13.3868 11.6422 13.3212L2 8.50006Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ko = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M17 14.5001V11.4945C17 11.315 17 11.2253 16.9727 11.146C16.9485 11.076 16.9091 11.0122 16.8572 10.9592C16.7986 10.8993 16.7183 10.8592 16.5578 10.779L12 8.50006M4 9.50006V16.3067C4 16.6786 4 16.8645 4.05802 17.0274C4.10931 17.1713 4.1929 17.3016 4.30238 17.4082C4.42622 17.5287 4.59527 17.6062 4.93335 17.7612L11.3334 20.6945C11.5786 20.8069 11.7012 20.8631 11.8289 20.8853C11.9421 20.9049 12.0579 20.9049 12.1711 20.8853C12.2988 20.8631 12.4214 20.8069 12.6666 20.6945L19.0666 17.7612C19.4047 17.6062 19.5738 17.5287 19.6976 17.4082C19.8071 17.3016 19.8907 17.1713 19.942 17.0274C20 16.8645 20 16.6786 20 16.3067V9.50006M2 8.50006L11.6422 3.67895C11.7734 3.61336 11.839 3.58056 11.9078 3.56766C11.9687 3.55622 12.0313 3.55622 12.0922 3.56766C12.161 3.58056 12.2266 3.61336 12.3578 3.67895L22 8.50006L12.3578 13.3212C12.2266 13.3868 12.161 13.4196 12.0922 13.4325C12.0313 13.4439 11.9687 13.4439 11.9078 13.4325C11.839 13.4196 11.7734 13.3868 11.6422 13.3212L2 8.50006Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), qo = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M3 22H12M11 6.25204C11.6392 6.08751 12.3094 6 13 6C17.4183 6 21 9.58172 21 14C21 17.3574 18.9318 20.2317 16 21.4185M5.5 13H9.5C9.96466 13 10.197 13 10.3902 13.0384C11.1836 13.1962 11.8038 13.8164 11.9616 14.6098C12 14.803 12 15.0353 12 15.5C12 15.9647 12 16.197 11.9616 16.3902C11.8038 17.1836 11.1836 17.8038 10.3902 17.9616C10.197 18 9.96466 18 9.5 18H5.5C5.03534 18 4.80302 18 4.60982 17.9616C3.81644 17.8038 3.19624 17.1836 3.03843 16.3902C3 16.197 3 15.9647 3 15.5C3 15.0353 3 14.803 3.03843 14.6098C3.19624 13.8164 3.81644 13.1962 4.60982 13.0384C4.80302 13 5.03534 13 5.5 13ZM4 5.5V13H11V5.5C11 3.567 9.433 2 7.5 2C5.567 2 4 3.567 4 5.5Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Jo = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M14.5 5.49989L16 6.99989M11.5 8.49989L13 9.99989M8.49996 11.4999L9.99996 12.9999M5.49996 14.4999L6.99996 15.9999M2.56561 17.5656L6.43424 21.4342C6.63225 21.6322 6.73125 21.7313 6.84542 21.7683C6.94584 21.801 7.05401 21.801 7.15443 21.7683C7.2686 21.7313 7.3676 21.6322 7.56561 21.4342L21.4342 7.56561C21.6322 7.3676 21.7313 7.2686 21.7683 7.15443C21.801 7.05401 21.801 6.94584 21.7683 6.84542C21.7313 6.73125 21.6322 6.63225 21.4342 6.43424L17.5656 2.56561C17.3676 2.3676 17.2686 2.2686 17.1544 2.2315C17.054 2.19887 16.9458 2.19887 16.8454 2.2315C16.7313 2.2686 16.6322 2.3676 16.4342 2.56561L2.56561 16.4342C2.3676 16.6322 2.2686 16.7313 2.2315 16.8454C2.19887 16.9458 2.19887 17.054 2.2315 17.1544C2.2686 17.2686 2.3676 17.3676 2.56561 17.5656Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Yo = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9 17L4 22M15 17L20 22M12 2V4M12 22V17M5.2 17H18.8C19.9201 17 20.4802 17 20.908 16.782C21.2843 16.5903 21.5903 16.2843 21.782 15.908C22 15.4802 22 14.9201 22 13.8V7.2C22 6.07989 22 5.51984 21.782 5.09202C21.5903 4.71569 21.2843 4.40973 20.908 4.21799C20.4802 4 19.9201 4 18.8 4H5.2C4.07989 4 3.51984 4 3.09202 4.21799C2.71569 4.40973 2.40973 4.71569 2.21799 5.09202C2 5.51984 2 6.07989 2 7.2V13.8C2 14.9201 2 15.4802 2.21799 15.908C2.40973 16.2843 2.71569 16.5903 3.09202 16.782C3.51984 17 4.0799 17 5.2 17Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Xo = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M13.1218 14.8446L18.0004 21.9999M10.879 14.8446L6.00041 21.9999M14.0004 13.2C14.0004 14.3045 13.105 15.2 12.0004 15.2C10.8958 15.2 10.0004 14.3045 10.0004 13.2C10.0004 12.0954 10.8958 11.2 12.0004 11.2C13.105 11.2 14.0004 12.0954 14.0004 13.2ZM17.1489 4.53225L5.36462 7.68984C5.09414 7.76232 4.95889 7.79855 4.86969 7.87888C4.79122 7.94953 4.73713 8.04321 4.71518 8.14649C4.69022 8.26391 4.72646 8.39915 4.79893 8.66964L5.67892 11.9538C5.7514 12.2243 5.78763 12.3595 5.86796 12.4487C5.93861 12.5272 6.03229 12.5813 6.13557 12.6032C6.25299 12.6282 6.38823 12.5919 6.65871 12.5195L18.443 9.36188L17.1489 4.53225ZM21.7928 9.49958C20.7109 9.78949 20.1699 9.93444 19.7002 9.83461C19.2871 9.74679 18.9124 9.53045 18.6298 9.21657C18.3085 8.85975 18.1635 8.31878 17.8736 7.23684L17.7183 6.65728C17.4284 5.57535 17.2835 5.03438 17.3833 4.56471C17.4711 4.15158 17.6875 3.77686 18.0013 3.49425C18.3582 3.17296 18.8991 3.02801 19.9811 2.7381C20.2515 2.66562 20.3868 2.62939 20.5042 2.65434C20.6075 2.6763 20.7012 2.73038 20.7718 2.80885C20.8521 2.89806 20.8884 3.0333 20.9609 3.30379L22.3585 8.51979C22.431 8.79027 22.4672 8.92551 22.4422 9.04293C22.4203 9.14621 22.3662 9.23989 22.2877 9.31055C22.1985 9.39087 22.0633 9.42711 21.7928 9.49958ZM3.50212 12.33L4.85441 11.9677C5.1249 11.8952 5.26014 11.8589 5.34935 11.7786C5.42782 11.708 5.4819 11.6143 5.50386 11.511C5.52881 11.3936 5.49258 11.2583 5.4201 10.9879L5.05775 9.63556C4.98528 9.36508 4.94904 9.22983 4.86872 9.14063C4.79806 9.06216 4.70438 9.00807 4.6011 8.98612C4.48368 8.96116 4.34844 8.9974 4.07796 9.06988L2.72566 9.43222C2.45518 9.5047 2.31993 9.54094 2.23073 9.62126C2.15226 9.69191 2.09817 9.78559 2.07622 9.88888C2.05126 10.0063 2.0875 10.1415 2.15998 10.412L2.52232 11.7643C2.5948 12.0348 2.63104 12.17 2.71136 12.2592C2.78201 12.3377 2.87569 12.3918 2.97898 12.4138C3.09639 12.4387 3.23163 12.4025 3.50212 12.33Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Zo = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 15C8.68629 15 6 12.3137 6 9V3.44444C6 3.0306 6 2.82367 6.06031 2.65798C6.16141 2.38021 6.38021 2.16141 6.65798 2.06031C6.82367 2 7.0306 2 7.44444 2H16.5556C16.9694 2 17.1763 2 17.342 2.06031C17.6198 2.16141 17.8386 2.38021 17.9397 2.65798C18 2.82367 18 3.0306 18 3.44444V9C18 12.3137 15.3137 15 12 15ZM12 15V18M18 4H20.5C20.9659 4 21.1989 4 21.3827 4.07612C21.6277 4.17761 21.8224 4.37229 21.9239 4.61732C22 4.80109 22 5.03406 22 5.5V6C22 6.92997 22 7.39496 21.8978 7.77646C21.6204 8.81173 20.8117 9.62038 19.7765 9.89778C19.395 10 18.93 10 18 10M6 4H3.5C3.03406 4 2.80109 4 2.61732 4.07612C2.37229 4.17761 2.17761 4.37229 2.07612 4.61732C2 4.80109 2 5.03406 2 5.5V6C2 6.92997 2 7.39496 2.10222 7.77646C2.37962 8.81173 3.18827 9.62038 4.22354 9.89778C4.60504 10 5.07003 10 6 10M7.44444 22H16.5556C16.801 22 17 21.801 17 21.5556C17 19.5919 15.4081 18 13.4444 18H10.5556C8.59188 18 7 19.5919 7 21.5556C7 21.801 7.19898 22 7.44444 22Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Qo = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 17C8.41015 17 5.5 14.0899 5.5 10.5V4.55556C5.5 4.03739 5.5 3.77831 5.59369 3.57738C5.69305 3.36431 5.86431 3.19305 6.07738 3.09369C6.27831 3 6.53739 3 7.05556 3H16.9444C17.4626 3 17.7217 3 17.9226 3.09369C18.1357 3.19305 18.3069 3.36431 18.4063 3.57738C18.5 3.77831 18.5 4.03739 18.5 4.55556V10.5C18.5 14.0899 15.5899 17 12 17ZM12 17V21M17 21H7M22 5V10M2 5V10",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), $o = /* @__PURE__ */ k({
	Atom01: () => So,
	Atom02: () => Co,
	Award01: () => wo,
	Award02: () => To,
	Award03: () => Eo,
	Award04: () => Do,
	Award05: () => Oo,
	Backpack: () => ko,
	Beaker01: () => Ao,
	Beaker02: () => jo,
	BookClosed: () => Mo,
	BookOpen01: () => No,
	BookOpen02: () => Po,
	Briefcase01: () => Fo,
	Briefcase02: () => Io,
	Calculator: () => Lo,
	Certificate01: () => Ro,
	Certificate02: () => zo,
	Compass: () => Bo,
	Glasses01: () => Vo,
	Glasses02: () => Ho,
	Globe01: () => Uo,
	Globe02: () => Wo,
	GraduationHat01: () => Go,
	GraduationHat02: () => Ko,
	Microscope: () => qo,
	Ruler: () => Jo,
	Stand: () => Yo,
	Telescope: () => Xo,
	Trophy01: () => Zo,
	Trophy02: () => Qo
}), es = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M20 10.5V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H12M18 21V15M15 18H21",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ts = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M20 10.5V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H12M14 11H8M10 15H8M16 7H8M18 21V15M15 18H21",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ns = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M14 2.26953V6.40007C14 6.96012 14 7.24015 14.109 7.45406C14.2049 7.64222 14.3578 7.7952 14.546 7.89108C14.7599 8.00007 15.0399 8.00007 15.6 8.00007H19.7305M12 18V12M9 15H15M14 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H15.2C16.8802 22 17.7202 22 18.362 21.673C18.9265 21.3854 19.3854 20.9265 19.673 20.362C20 19.7202 20 18.8802 20 17.2V8L14 2Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), rs = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M20 9.5V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H14M14 11H8M10 15H8M16 7H8M16.5 15.0022C16.6762 14.5014 17.024 14.079 17.4817 13.81C17.9395 13.5409 18.4777 13.4426 19.001 13.5324C19.5243 13.6221 19.999 13.8942 20.3409 14.3004C20.6829 14.7066 20.87 15.2207 20.8692 15.7517C20.8692 17.2506 18.6209 18 18.6209 18M18.6499 21H18.6599",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), is = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M14 11H8M10 15H8M16 7H8M20 10.5V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H11.5M22 22L20.5 20.5M21.5 18C21.5 19.933 19.933 21.5 18 21.5C16.067 21.5 14.5 19.933 14.5 18C14.5 16.067 16.067 14.5 18 14.5C19.933 14.5 21.5 16.067 21.5 18Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), as = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M13 7L11.8845 4.76892C11.5634 4.1268 11.4029 3.80573 11.1634 3.57116C10.9516 3.36373 10.6963 3.20597 10.4161 3.10931C10.0992 3 9.74021 3 9.02229 3H5.2C4.0799 3 3.51984 3 3.09202 3.21799C2.71569 3.40973 2.40973 3.71569 2.21799 4.09202C2 4.51984 2 5.0799 2 6.2V7M2 7H17.2C18.8802 7 19.7202 7 20.362 7.32698C20.9265 7.6146 21.3854 8.07354 21.673 8.63803C22 9.27976 22 10.1198 22 11.8V16.2C22 17.8802 22 18.7202 21.673 19.362C21.3854 19.9265 20.9265 20.3854 20.362 20.673C19.7202 21 18.8802 21 17.2 21H6.8C5.11984 21 4.27976 21 3.63803 20.673C3.07354 20.3854 2.6146 19.9265 2.32698 19.362C2 18.7202 2 17.8802 2 16.2V7ZM12 17V11M9 14H15",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), os = /* @__PURE__ */ k({
	FilePlus01: () => es,
	FilePlus02: () => ts,
	FilePlus03: () => ns,
	FileQuestion02: () => rs,
	FileSearch02: () => is,
	FolderPlus: () => as
}), ss = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M5 9.00002V17M9.5 9.00002V17M14.5 9.00002V17M19 9.00002V17M3 18.6L3 19.4C3 19.9601 3 20.2401 3.10899 20.454C3.20487 20.6422 3.35785 20.7952 3.54601 20.891C3.75992 21 4.03995 21 4.6 21H19.4C19.9601 21 20.2401 21 20.454 20.891C20.6422 20.7952 20.7951 20.6422 20.891 20.454C21 20.2401 21 19.9601 21 19.4V18.6C21 18.04 21 17.7599 20.891 17.546C20.7951 17.3579 20.6422 17.2049 20.454 17.109C20.2401 17 19.9601 17 19.4 17H4.6C4.03995 17 3.75992 17 3.54601 17.109C3.35785 17.2049 3.20487 17.3579 3.10899 17.546C3 17.7599 3 18.04 3 18.6ZM11.6529 3.07715L4.25291 4.7216C3.80585 4.82094 3.58232 4.87062 3.41546 4.99082C3.26829 5.09685 3.15273 5.24092 3.08115 5.40759C3 5.59654 3 5.82553 3 6.28349L3 7.40002C3 7.96007 3 8.2401 3.10899 8.45401C3.20487 8.64217 3.35785 8.79515 3.54601 8.89103C3.75992 9.00002 4.03995 9.00002 4.6 9.00002H19.4C19.9601 9.00002 20.2401 9.00002 20.454 8.89103C20.6422 8.79515 20.7951 8.64217 20.891 8.45401C21 8.2401 21 7.96007 21 7.40002V6.2835C21 5.82553 21 5.59655 20.9188 5.40759C20.8473 5.24092 20.7317 5.09685 20.5845 4.99082C20.4177 4.87062 20.1942 4.82094 19.7471 4.7216L12.3471 3.07715C12.2176 3.04837 12.1528 3.03398 12.0874 3.02824C12.0292 3.02314 11.9708 3.02314 11.9126 3.02824C11.8472 3.03398 11.7824 3.04837 11.6529 3.07715Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), cs = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M6 11V15M18 9V13M17 4C19.4487 4 20.7731 4.37476 21.4321 4.66544C21.5199 4.70415 21.5638 4.72351 21.6904 4.84437C21.7663 4.91682 21.9049 5.12939 21.9405 5.22809C22 5.39274 22 5.48274 22 5.66274V16.4111C22 17.3199 22 17.7743 21.8637 18.0079C21.7251 18.2454 21.5914 18.3559 21.3319 18.4472C21.0769 18.5369 20.562 18.438 19.5322 18.2401C18.8114 18.1017 17.9565 18 17 18C14 18 11 20 7 20C4.55129 20 3.22687 19.6252 2.56788 19.3346C2.48012 19.2958 2.43624 19.2765 2.3096 19.1556C2.23369 19.0832 2.09512 18.8706 2.05947 18.7719C2 18.6073 2 18.5173 2 18.3373L2 7.58885C2 6.68009 2 6.2257 2.13628 5.99214C2.2749 5.75456 2.40859 5.64412 2.66806 5.55281C2.92314 5.46305 3.43803 5.56198 4.46783 5.75985C5.18862 5.89834 6.04348 6 7 6C10 6 13 4 17 4ZM14.5 12C14.5 13.3807 13.3807 14.5 12 14.5C10.6193 14.5 9.5 13.3807 9.5 12C9.5 10.6193 10.6193 9.5 12 9.5C13.3807 9.5 14.5 10.6193 14.5 12Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ls = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M6 10V14M18 10V14M2 8.2L2 15.8C2 16.9201 2 17.4802 2.21799 17.908C2.40973 18.2843 2.71569 18.5903 3.09202 18.782C3.51984 19 4.07989 19 5.2 19L18.8 19C19.9201 19 20.4802 19 20.908 18.782C21.2843 18.5903 21.5903 18.2843 21.782 17.908C22 17.4802 22 16.9201 22 15.8V8.2C22 7.0799 22 6.51984 21.782 6.09202C21.5903 5.7157 21.2843 5.40974 20.908 5.21799C20.4802 5 19.9201 5 18.8 5L5.2 5C4.0799 5 3.51984 5 3.09202 5.21799C2.7157 5.40973 2.40973 5.71569 2.21799 6.09202C2 6.51984 2 7.07989 2 8.2ZM14.5 12C14.5 13.3807 13.3807 14.5 12 14.5C10.6193 14.5 9.5 13.3807 9.5 12C9.5 10.6193 10.6193 9.5 12 9.5C13.3807 9.5 14.5 10.6193 14.5 12Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), us = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M14 9H11.5C10.6716 9 10 9.67157 10 10.5C10 11.3284 10.6716 12 11.5 12H12.5C13.3284 12 14 12.6716 14 13.5C14 14.3284 13.3284 15 12.5 15H10M12 8V9M12 15V16M18 12H18.01M6 12H6.01M2 8.2L2 15.8C2 16.9201 2 17.4802 2.21799 17.908C2.40973 18.2843 2.71569 18.5903 3.09202 18.782C3.51984 19 4.07989 19 5.2 19L18.8 19C19.9201 19 20.4802 19 20.908 18.782C21.2843 18.5903 21.5903 18.2843 21.782 17.908C22 17.4802 22 16.9201 22 15.8V8.2C22 7.0799 22 6.51984 21.782 6.09202C21.5903 5.7157 21.2843 5.40974 20.908 5.21799C20.4802 5 19.9201 5 18.8 5L5.2 5C4.0799 5 3.51984 5 3.09202 5.21799C2.7157 5.40973 2.40973 5.71569 2.21799 6.09202C2 6.51984 2 7.07989 2 8.2ZM18.5 12C18.5 12.2761 18.2761 12.5 18 12.5C17.7239 12.5 17.5 12.2761 17.5 12C17.5 11.7239 17.7239 11.5 18 11.5C18.2761 11.5 18.5 11.7239 18.5 12ZM6.5 12C6.5 12.2761 6.27614 12.5 6 12.5C5.72386 12.5 5.5 12.2761 5.5 12C5.5 11.7239 5.72386 11.5 6 11.5C6.27614 11.5 6.5 11.7239 6.5 12Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ds = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M15.9377 15.9377C19.3603 15.4795 22 12.548 22 9C22 5.13401 18.866 2 15 2C11.452 2 8.52049 4.63967 8.06227 8.06227M16 15C16 18.866 12.866 22 9 22C5.13401 22 2 18.866 2 15C2 11.134 5.13401 8 9 8C12.866 8 16 11.134 16 15Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), fs = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M15.9377 15.9377C19.3603 15.4795 22 12.548 22 9C22 5.13401 18.866 2 15 2C11.452 2 8.52049 4.63967 8.06227 8.06227M7.5 13L9 12V17.5M7.5 17.5H10.5M16 15C16 18.866 12.866 22 9 22C5.13401 22 2 18.866 2 15C2 11.134 5.13401 8 9 8C12.866 8 16 11.134 16 15Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ps = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M10.101 4C11.3636 2.76281 13.0927 2 15 2C18.866 2 22 5.13401 22 9C22 10.9073 21.2372 12.6365 19.9999 13.899M16 15C16 18.866 12.866 22 9 22C5.13401 22 2 18.866 2 15C2 11.134 5.13401 8 9 8C12.866 8 16 11.134 16 15Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ms = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M10.101 4C11.3636 2.76281 13.0927 2 15 2C18.866 2 22 5.13401 22 9C22 10.9073 21.2372 12.6365 19.9999 13.899M7.5 13L9 12V17.5M7.5 17.5H10.5M16 15C16 18.866 12.866 22 9 22C5.13401 22 2 18.866 2 15C2 11.134 5.13401 8 9 8C12.866 8 16 11.134 16 15Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), hs = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M13.5295 8.35186C12.9571 8.75995 12.2566 9 11.5 9C9.567 9 8 7.433 8 5.5C8 3.567 9.567 2 11.5 2C12.753 2 13.8522 2.65842 14.4705 3.64814M6 20.0872H8.61029C8.95063 20.0872 9.28888 20.1277 9.61881 20.2086L12.3769 20.8789C12.9753 21.0247 13.5988 21.0388 14.2035 20.9214L17.253 20.3281C18.0585 20.1712 18.7996 19.7854 19.3803 19.2205L21.5379 17.1217C22.154 16.5234 22.154 15.5524 21.5379 14.9531C20.9832 14.4134 20.1047 14.3527 19.4771 14.8103L16.9626 16.6449C16.6025 16.9081 16.1643 17.0498 15.7137 17.0498H13.2855L14.8311 17.0498C15.7022 17.0498 16.4079 16.3633 16.4079 15.5159V15.2091C16.4079 14.5055 15.9156 13.892 15.2141 13.7219L12.8286 13.1417C12.4404 13.0476 12.0428 13 11.6431 13C10.6783 13 8.93189 13.7988 8.93189 13.7988L6 15.0249M20 6.5C20 8.433 18.433 10 16.5 10C14.567 10 13 8.433 13 6.5C13 4.567 14.567 3 16.5 3C18.433 3 20 4.567 20 6.5ZM2 14.6L2 20.4C2 20.9601 2 21.2401 2.10899 21.454C2.20487 21.6422 2.35785 21.7951 2.54601 21.891C2.75992 22 3.03995 22 3.6 22H4.4C4.96005 22 5.24008 22 5.45399 21.891C5.64215 21.7951 5.79513 21.6422 5.89101 21.454C6 21.2401 6 20.9601 6 20.4V14.6C6 14.0399 6 13.7599 5.89101 13.546C5.79513 13.3578 5.64215 13.2049 5.45399 13.109C5.24008 13 4.96005 13 4.4 13L3.6 13C3.03995 13 2.75992 13 2.54601 13.109C2.35785 13.2049 2.20487 13.3578 2.10899 13.546C2 13.7599 2 14.0399 2 14.6Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), gs = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 17C12 19.7614 14.2386 22 17 22C19.7614 22 22 19.7614 22 17C22 14.2386 19.7614 12 17 12C14.2386 12 12 14.2386 12 17ZM12 17C12 15.8742 12.3721 14.8353 13 13.9995V5M12 17C12 17.8254 12.2 18.604 12.5541 19.2901C11.7117 20.0018 9.76584 20.5 7.5 20.5C4.46243 20.5 2 19.6046 2 18.5V5M13 5C13 6.10457 10.5376 7 7.5 7C4.46243 7 2 6.10457 2 5M13 5C13 3.89543 10.5376 3 7.5 3C4.46243 3 2 3.89543 2 5M2 14C2 15.1046 4.46243 16 7.5 16C9.689 16 11.5793 15.535 12.4646 14.8618M13 9.5C13 10.6046 10.5376 11.5 7.5 11.5C4.46243 11.5 2 10.6046 2 9.5",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), _s = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M13 5C13 6.10457 10.5376 7 7.5 7C4.46243 7 2 6.10457 2 5M13 5C13 3.89543 10.5376 3 7.5 3C4.46243 3 2 3.89543 2 5M13 5V9.45715C11.7785 9.82398 11 10.3789 11 11M2 5V17C2 18.1046 4.46243 19 7.5 19C8.82963 19 10.0491 18.8284 11 18.5429V11M2 9C2 10.1046 4.46243 11 7.5 11C8.82963 11 10.0491 10.8284 11 10.5429M2 13C2 14.1046 4.46243 15 7.5 15C8.82963 15 10.0491 14.8284 11 14.5429M22 11C22 12.1046 19.5376 13 16.5 13C13.4624 13 11 12.1046 11 11M22 11C22 9.89543 19.5376 9 16.5 9C13.4624 9 11 9.89543 11 11M22 11V19C22 20.1046 19.5376 21 16.5 21C13.4624 21 11 20.1046 11 19V11M22 15C22 16.1046 19.5376 17 16.5 17C13.4624 17 11 16.1046 11 15",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), vs = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M13 5C13 6.10457 10.5376 7 7.5 7C4.46243 7 2 6.10457 2 5M13 5C13 3.89543 10.5376 3 7.5 3C4.46243 3 2 3.89543 2 5M13 5V6.5M2 5V17C2 18.1046 4.46243 19 7.5 19M7.5 11C7.33145 11 7.16468 10.9972 7 10.9918C4.19675 10.9 2 10.0433 2 9M7.5 15C4.46243 15 2 14.1046 2 13M22 11.5C22 12.6046 19.5376 13.5 16.5 13.5C13.4624 13.5 11 12.6046 11 11.5M22 11.5C22 10.3954 19.5376 9.5 16.5 9.5C13.4624 9.5 11 10.3954 11 11.5M22 11.5V19C22 20.1046 19.5376 21 16.5 21C13.4624 21 11 20.1046 11 19V11.5M22 15.25C22 16.3546 19.5376 17.25 16.5 17.25C13.4624 17.25 11 16.3546 11 15.25",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ys = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M20 5C20 6.65685 16.4183 8 12 8C7.58172 8 4 6.65685 4 5M20 5C20 3.34315 16.4183 2 12 2C7.58172 2 4 3.34315 4 5M20 5V19C20 20.6569 16.4183 22 12 22C7.58172 22 4 20.6569 4 19V5M20 9.6666C20 11.3235 16.4183 12.6666 12 12.6666C7.58172 12.6666 4 11.3235 4 9.6666M20 14.33C20 15.9869 16.4183 17.33 12 17.33C7.58172 17.33 4 15.9869 4 14.33",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), bs = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M6 6L8 4M8 4L6 2M8 4H6C3.79086 4 2 5.79086 2 8M18 18L16 20M16 20L18 22M16 20H18C20.2091 20 22 18.2091 22 16M13.4172 13.4172C14.1994 13.7908 15.0753 14 16 14C19.3137 14 22 11.3137 22 8C22 4.68629 19.3137 2 16 2C12.6863 2 10 4.68629 10 8C10 8.92472 10.2092 9.80057 10.5828 10.5828M14 16C14 19.3137 11.3137 22 8 22C4.68629 22 2 19.3137 2 16C2 12.6863 4.68629 10 8 10C11.3137 10 14 12.6863 14 16Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), xs = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M6 6L8 4M8 4L6 2M8 4H6C3.79086 4 2 5.79086 2 8M18 18L16 20M16 20L18 22M16 20H18C20.2091 20 22 18.2091 22 16M10.189 6.5C10.8551 3.91216 13.2042 2 16 2C19.3137 2 22 4.68629 22 8C22 10.7957 20.0879 13.1449 17.5001 13.811M14 16C14 19.3137 11.3137 22 8 22C4.68629 22 2 19.3137 2 16C2 12.6863 4.68629 10 8 10C11.3137 10 14 12.6863 14 16Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ss = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M22 10H2M2 8.2L2 15.8C2 16.9201 2 17.4802 2.21799 17.908C2.40973 18.2843 2.71569 18.5903 3.09202 18.782C3.51984 19 4.07989 19 5.2 19L18.8 19C19.9201 19 20.4802 19 20.908 18.782C21.2843 18.5903 21.5903 18.2843 21.782 17.908C22 17.4802 22 16.9201 22 15.8V8.2C22 7.0799 22 6.51984 21.782 6.09202C21.5903 5.7157 21.2843 5.40974 20.908 5.21799C20.4802 5 19.9201 5 18.8 5L5.2 5C4.0799 5 3.51984 5 3.09202 5.21799C2.7157 5.40973 2.40973 5.71569 2.21799 6.09202C2 6.51984 2 7.07989 2 8.2Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Cs = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M22 10H2M11 14H6M2 8.2L2 15.8C2 16.9201 2 17.4802 2.21799 17.908C2.40973 18.2843 2.71569 18.5903 3.09202 18.782C3.51984 19 4.07989 19 5.2 19L18.8 19C19.9201 19 20.4802 19 20.908 18.782C21.2843 18.5903 21.5903 18.2843 21.782 17.908C22 17.4802 22 16.9201 22 15.8V8.2C22 7.0799 22 6.51984 21.782 6.09202C21.5903 5.7157 21.2843 5.40974 20.908 5.21799C20.4802 5 19.9201 5 18.8 5L5.2 5C4.0799 5 3.51984 5 3.09202 5.21799C2.7157 5.40973 2.40973 5.71569 2.21799 6.09202C2 6.51984 2 7.07989 2 8.2Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ws = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M16 18L18 20L22 16M22 10H2M22 12V8.2C22 7.0799 22 6.51984 21.782 6.09202C21.5903 5.7157 21.2843 5.40974 20.908 5.21799C20.4802 5 19.9201 5 18.8 5H5.2C4.0799 5 3.51984 5 3.09202 5.21799C2.7157 5.40973 2.40973 5.71569 2.21799 6.09202C2 6.51984 2 7.0799 2 8.2V15.8C2 16.9201 2 17.4802 2.21799 17.908C2.40973 18.2843 2.71569 18.5903 3.09202 18.782C3.51984 19 4.0799 19 5.2 19H12",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ts = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M16 18L19 21M19 21L22 18M19 21V15M22 10H2M22 12V8.2C22 7.0799 22 6.51984 21.782 6.09202C21.5903 5.7157 21.2843 5.40974 20.908 5.21799C20.4802 5 19.9201 5 18.8 5H5.2C4.0799 5 3.51984 5 3.09202 5.21799C2.7157 5.40973 2.40973 5.71569 2.21799 6.09202C2 6.51984 2 7.0799 2 8.2V15.8C2 16.9201 2 17.4802 2.21799 17.908C2.40973 18.2843 2.71569 18.5903 3.09202 18.782C3.51984 19 4.0799 19 5.2 19H12",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Es = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9 17L12 20M12 20L15 17M12 20V13M22 9H2M5.5 18H5.2C4.0799 18 3.51984 18 3.09202 17.782C2.71569 17.5903 2.40973 17.2843 2.21799 16.908C2 16.4802 2 15.9201 2 14.8V7.2C2 6.0799 2 5.51984 2.21799 5.09202C2.40973 4.71569 2.7157 4.40973 3.09202 4.21799C3.51984 4 4.0799 4 5.2 4H18.8C19.9201 4 20.4802 4 20.908 4.21799C21.2843 4.40974 21.5903 4.7157 21.782 5.09202C22 5.51984 22 6.0799 22 7.2V14.8C22 15.9201 22 16.4802 21.782 16.908C21.5903 17.2843 21.2843 17.5903 20.908 17.782C20.4802 18 19.9201 18 18.8 18H18.5",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ds = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M2 10H22V8.2C22 7.0799 22 6.51984 21.782 6.09202C21.5903 5.7157 21.2843 5.40974 20.908 5.21799C20.4802 5 19.9201 5 18.8 5H5.2C4.0799 5 3.51984 5 3.09202 5.21799C2.7157 5.40973 2.40973 5.71569 2.21799 6.09202C2 6.51984 2 7.0799 2 8.2V15.8C2 16.9201 2 17.4802 2.21799 17.908C2.40973 18.2843 2.71569 18.5903 3.09202 18.782C3.51984 19 4.0799 19 5.2 19H11M14.5 21L16.525 20.595C16.7015 20.5597 16.7898 20.542 16.8721 20.5097C16.9452 20.4811 17.0147 20.4439 17.079 20.399C17.1516 20.3484 17.2152 20.2848 17.3426 20.1574L21.5 16C22.0523 15.4477 22.0523 14.5523 21.5 14C20.9477 13.4477 20.0523 13.4477 19.5 14L15.3426 18.1574C15.2152 18.2848 15.1516 18.3484 15.101 18.421C15.0561 18.4853 15.0189 18.5548 14.9903 18.6279C14.958 18.7102 14.9403 18.7985 14.905 18.975L14.5 21Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Os = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M20.25 17.5V15.75C20.25 14.7835 19.4665 14 18.5 14C17.5335 14 16.75 14.7835 16.75 15.75V17.5M22 10H2M22 11V8.2C22 7.0799 22 6.51984 21.782 6.09202C21.5903 5.7157 21.2843 5.40974 20.908 5.21799C20.4802 5 19.9201 5 18.8 5H5.2C4.0799 5 3.51984 5 3.09202 5.21799C2.7157 5.40973 2.40973 5.71569 2.21799 6.09202C2 6.51984 2 7.0799 2 8.2V15.8C2 16.9201 2 17.4802 2.21799 17.908C2.40973 18.2843 2.71569 18.5903 3.09202 18.782C3.51984 19 4.0799 19 5.2 19H11M16.6 21.5H20.4C20.9601 21.5 21.2401 21.5 21.454 21.391C21.6422 21.2951 21.7951 21.1422 21.891 20.954C22 20.7401 22 20.4601 22 19.9V19.1C22 18.5399 22 18.2599 21.891 18.046C21.7951 17.8578 21.6422 17.7049 21.454 17.609C21.2401 17.5 20.9601 17.5 20.4 17.5H16.6C16.0399 17.5 15.7599 17.5 15.546 17.609C15.3578 17.7049 15.2049 17.8578 15.109 18.046C15 18.2599 15 18.5399 15 19.1V19.9C15 20.4601 15 20.7401 15.109 20.954C15.2049 21.1422 15.3578 21.2951 15.546 21.391C15.7599 21.5 16.0399 21.5 16.6 21.5Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ks = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M16 18H22M22 10H2M22 13.5V8.2C22 7.0799 22 6.51984 21.782 6.09202C21.5903 5.7157 21.2843 5.40974 20.908 5.21799C20.4802 5 19.9201 5 18.8 5H5.2C4.0799 5 3.51984 5 3.09202 5.21799C2.7157 5.40973 2.40973 5.71569 2.21799 6.09202C2 6.51984 2 7.0799 2 8.2V15.8C2 16.9201 2 17.4802 2.21799 17.908C2.40973 18.2843 2.71569 18.5903 3.09202 18.782C3.51984 19 4.0799 19 5.2 19H12",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), As = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M19 21V15M16 18H22M22 10H2M22 12V8.2C22 7.0799 22 6.51984 21.782 6.09202C21.5903 5.7157 21.2843 5.40974 20.908 5.21799C20.4802 5 19.9201 5 18.8 5H5.2C4.0799 5 3.51984 5 3.09202 5.21799C2.7157 5.40973 2.40973 5.71569 2.21799 6.09202C2 6.51984 2 7.0799 2 8.2V15.8C2 16.9201 2 17.4802 2.21799 17.908C2.40973 18.2843 2.71569 18.5903 3.09202 18.782C3.51984 19 4.0799 19 5.2 19H12",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), js = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M22 10H2M11 19L18.8 19C19.9201 19 20.4802 19 20.908 18.782C21.2843 18.5903 21.5903 18.2843 21.782 17.908C22 17.4802 22 16.9201 22 15.8V8.2C22 7.0799 22 6.51984 21.782 6.09202C21.5903 5.7157 21.2843 5.40974 20.908 5.21799C20.4802 5 19.9201 5 18.8 5H17M11 19L13 21M11 19L13 17M7 19H5.2C4.07989 19 3.51984 19 3.09202 18.782C2.71569 18.5903 2.40973 18.2843 2.21799 17.908C2 17.4802 2 16.9201 2 15.8V8.2C2 7.0799 2 6.51984 2.21799 6.09202C2.40973 5.71569 2.7157 5.40973 3.09202 5.21799C3.51984 5 4.0799 5 5.2 5H13M13 5L11 7M13 5L11 3",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ms = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M22 22L20.5 20.5M22 10H2M22 12V8.2C22 7.0799 22 6.51984 21.782 6.09202C21.5903 5.7157 21.2843 5.40974 20.908 5.21799C20.4802 5 19.9201 5 18.8 5H5.2C4.0799 5 3.51984 5 3.09202 5.21799C2.7157 5.40973 2.40973 5.71569 2.21799 6.09202C2 6.51984 2 7.0799 2 8.2V15.8C2 16.9201 2 17.4802 2.21799 17.908C2.40973 18.2843 2.71569 18.5903 3.09202 18.782C3.51984 19 4.0799 19 5.2 19H10.5M21.5 18C21.5 19.933 19.933 21.5 18 21.5C16.067 21.5 14.5 19.933 14.5 18C14.5 16.067 16.067 14.5 18 14.5C19.933 14.5 21.5 16.067 21.5 18Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ns = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M22 10H2M22 11V8.2C22 7.0799 22 6.51984 21.782 6.09202C21.5903 5.7157 21.2843 5.40974 20.908 5.21799C20.4802 5 19.9201 5 18.8 5H5.2C4.0799 5 3.51984 5 3.09202 5.21799C2.7157 5.40973 2.40973 5.71569 2.21799 6.09202C2 6.51984 2 7.0799 2 8.2V15.8C2 16.9201 2 17.4802 2.21799 17.908C2.40973 18.2843 2.71569 18.5903 3.09202 18.782C3.51984 19 4.07989 19 5.2 19H11.5M18 21C18 21 21 19.5701 21 17.4252V14.9229L18.8124 14.1412C18.2868 13.9529 17.712 13.9529 17.1864 14.1412L15 14.9229V17.4252C15 19.5701 18 21 18 21Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ps = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M16 18L19 15M19 15L22 18M19 15V21M22 10H2M22 12V8.2C22 7.0799 22 6.51984 21.782 6.09202C21.5903 5.7157 21.2843 5.40974 20.908 5.21799C20.4802 5 19.9201 5 18.8 5H5.2C4.0799 5 3.51984 5 3.09202 5.21799C2.7157 5.40973 2.40973 5.71569 2.21799 6.09202C2 6.51984 2 7.0799 2 8.2V15.8C2 16.9201 2 17.4802 2.21799 17.908C2.40973 18.2843 2.71569 18.5903 3.09202 18.782C3.51984 19 4.0799 19 5.2 19H12",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Fs = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9 16L12 13M12 13L15 16M12 13V20M22 9H2M5.5 18H5.2C4.0799 18 3.51984 18 3.09202 17.782C2.71569 17.5903 2.40973 17.2843 2.21799 16.908C2 16.4802 2 15.9201 2 14.8V7.2C2 6.0799 2 5.51984 2.21799 5.09202C2.40973 4.71569 2.7157 4.40973 3.09202 4.21799C3.51984 4 4.0799 4 5.2 4H18.8C19.9201 4 20.4802 4 20.908 4.21799C21.2843 4.40974 21.5903 4.7157 21.782 5.09202C22 5.51984 22 6.0799 22 7.2V14.8C22 15.9201 22 16.4802 21.782 16.908C21.5903 17.2843 21.2843 17.5903 20.908 17.782C20.4802 18 19.9201 18 18.8 18H18.5",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Is = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M16.5 16L21.5 21M21.5 16L16.5 21M22 10H2M22 12V8.2C22 7.0799 22 6.51984 21.782 6.09202C21.5903 5.7157 21.2843 5.40974 20.908 5.21799C20.4802 5 19.9201 5 18.8 5H5.2C4.0799 5 3.51984 5 3.09202 5.21799C2.7157 5.40973 2.40973 5.71569 2.21799 6.09202C2 6.51984 2 7.0799 2 8.2V15.8C2 16.9201 2 17.4802 2.21799 17.908C2.40973 18.2843 2.71569 18.5903 3.09202 18.782C3.51984 19 4.0799 19 5.2 19H12",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ls = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M17.8779 20.0899C16.1694 21.3312 14.1118 21.9998 12 21.9998C9.88821 21.9998 7.83063 21.3312 6.12215 20.0899M16.3837 3.01182C18.2818 3.93756 19.8381 5.44044 20.8295 7.30504C21.8209 9.16964 22.1966 11.3002 21.9027 13.3915M2.09742 13.3914C1.80352 11.3002 2.1792 9.16955 3.17063 7.30494C4.16205 5.44034 5.71832 3.93747 7.61639 3.01172M17.5 11.9998C17.5 15.0373 15.0376 17.4998 12 17.4998C8.96244 17.4998 6.50001 15.0373 6.50001 11.9998C6.50001 8.96219 8.96244 6.49976 12 6.49976C15.0376 6.49976 17.5 8.96219 17.5 11.9998Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Rs = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M17.8779 20.0899C16.1694 21.3312 14.1118 21.9998 12 21.9998C9.88821 21.9998 7.83063 21.3312 6.12215 20.0899M16.3837 3.01182C18.2818 3.93756 19.8381 5.44044 20.8295 7.30504C21.8209 9.16964 22.1966 11.3002 21.9027 13.3915M2.09742 13.3914C1.80352 11.3002 2.1792 9.16955 3.17063 7.30494C4.16205 5.44034 5.71832 3.93747 7.61639 3.01172M11.4343 6.56544L6.56569 11.4341C6.36768 11.6321 6.26868 11.7311 6.23158 11.8452C6.19895 11.9457 6.19895 12.0538 6.23158 12.1543C6.26868 12.2684 6.36768 12.3674 6.56569 12.5654L11.4343 17.4341C11.6323 17.6321 11.7313 17.7311 11.8455 17.7682C11.9459 17.8008 12.0541 17.8008 12.1545 17.7682C12.2687 17.7311 12.3677 17.6321 12.5657 17.4341L17.4343 12.5654C17.6323 12.3674 17.7313 12.2684 17.7684 12.1543C17.8011 12.0538 17.8011 11.9457 17.7684 11.8452C17.7313 11.7311 17.6323 11.6321 17.4343 11.4341L12.5657 6.56544C12.3677 6.36743 12.2687 6.26843 12.1545 6.23134C12.0541 6.19871 11.9459 6.19871 11.8455 6.23134C11.7313 6.26843 11.6323 6.36743 11.4343 6.56544Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), zs = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M2 2L4 4M22 2L20 4M22 22L20 20M2 22L4 20M2 16H3.5M8 2V3.5M22 8H20.5M16 22V20.5M18 16H21.5M16 2V6M2 8H6M8 22V18M16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Bs = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M2 2L4 4M22 2L20 4M22 22L20 20M2 22L4 20M2 16H3.5M8 2V3.5M22 8H20.5M16 22V20.5M18 16H21.5M16 2V6M2 8H6M8 22V18M11.4343 7.56569L7.56569 11.4343C7.36768 11.6323 7.26867 11.7313 7.23158 11.8455C7.19895 11.9459 7.19895 12.0541 7.23158 12.1545C7.26867 12.2687 7.36768 12.3677 7.56569 12.5657L11.4343 16.4343C11.6323 16.6323 11.7313 16.7313 11.8455 16.7684C11.9459 16.8011 12.0541 16.8011 12.1545 16.7684C12.2687 16.7313 12.3677 16.6323 12.5657 16.4343L16.4343 12.5657C16.6323 12.3677 16.7313 12.2687 16.7684 12.1545C16.8011 12.0541 16.8011 11.9459 16.7684 11.8455C16.7313 11.7313 16.6323 11.6323 16.4343 11.4343L12.5657 7.56569C12.3677 7.36768 12.2687 7.26867 12.1545 7.23158C12.0541 7.19895 11.9459 7.19895 11.8455 7.23158C11.7313 7.26867 11.6323 7.36768 11.4343 7.56569Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Vs = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9.5 2V4M9.5 20V22M13.5 2V4M13.5 20V22M7.5 4H14C16.2091 4 18 5.79086 18 8C18 10.2091 16.2091 12 14 12H7.5H15C17.2091 12 19 13.7909 19 16C19 18.2091 17.2091 20 15 20H7.5M7.5 4H5.5M7.5 4V20M7.5 20H5.5",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Hs = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9.5 7.5H13.75C14.9926 7.5 16 8.50736 16 9.75C16 10.9926 14.9926 12 13.75 12H9.5H14.25C15.4926 12 16.5 13.0074 16.5 14.25C16.5 15.4926 15.4926 16.5 14.25 16.5H9.5M9.5 7.5H8M9.5 7.5V16.5M9.5 16.5H8M10 6V7.5M10 16.5V18M13 6V7.5M13 16.5V18M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Us = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M6 16C6 18.2091 7.79086 20 10 20H14C16.2091 20 18 18.2091 18 16C18 13.7909 16.2091 12 14 12H10C7.79086 12 6 10.2091 6 8C6 5.79086 7.79086 4 10 4H14C16.2091 4 18 5.79086 18 8M12 2V22",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ws = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M8.5 14.6667C8.5 15.9553 9.54467 17 10.8333 17H13C14.3807 17 15.5 15.8807 15.5 14.5C15.5 13.1193 14.3807 12 13 12H11C9.61929 12 8.5 10.8807 8.5 9.5C8.5 8.11929 9.61929 7 11 7H13.1667C14.4553 7 15.5 8.04467 15.5 9.33333M12 5.5V7M12 17V18.5M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Gs = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M4 11.0001L12 13L20 11M4 11.0001L12 2M4 11.0001L12 9.00008M20 11L12 2M20 11L12 9.00008M12 2V9.00008M5.5 15L12.0001 22L18.5 15L12 16.5L5.5 15Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ks = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M6.5 15.5L12.0002 18L17.5 15.5M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM6.5 11.5L12.0002 14L17.5 11.5L12.0002 5L6.5 11.5Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), qs = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M19 5.51903C17.5176 4.25973 15.5975 3.5 13.5 3.5C8.80558 3.5 5 7.30558 5 12C5 16.6944 8.80558 20.5 13.5 20.5C15.5975 20.5 17.5176 19.7403 19 18.481M3 14H13M3 10H13",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Js = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M15.3333 8.27316C14.4487 7.48142 13.2806 7 12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17C13.2806 17 14.4487 16.5186 15.3333 15.7268M6 13.5H11M6 10.5H11M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ys = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M17.5 20.5H6.5C6.5 20.5 10 17.7413 10 13.5C10 10.6725 7.91376 9.66123 7.8837 7.30497C7.88566 2.64078 13.5005 2.88877 15.4521 4.74258M6.5 13.5H15",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Xs = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M15 17.5H9C9 17.5 11 15.2444 11 12.5C11 11 9.91479 10.4867 9.89534 8.96204C9.8966 5.94404 13.5297 6.1045 14.7926 7.30402M9 12.5H14M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Zs = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M8.5 11.5H14.5C16.7091 11.5 18.5 9.70914 18.5 7.5C18.5 5.29086 16.7091 3.5 14.5 3.5H8.5V11.5ZM8.5 11.5H6.5M13.5 15.5H6.5M8.5 4V20.5",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Qs = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9.5 6.5H14C15.3807 6.5 16.5 7.61929 16.5 9C16.5 10.3807 15.3807 11.5 14 11.5H9.5V6.5ZM9.5 6.5V17.5M9.75 11.5H8M13 14.75H8M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), $s = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M6 3H18M6 8H18M14.5 21L6 13H9C15.667 13 15.667 3 9 3",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ec = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M8.5 9.99984H15.5M8.5 6.5H15.5M14 18.0002L8.5 13.5002L10 13.5C14.4447 13.5 14.4447 6.5 10 6.5M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), tc = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 20.5V11.5M12 11.5L18.5001 3.5M12 11.5L5.50012 3.5M18 11.5H5.99998M17 15.5H6.99998",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), nc = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 18V12M12 12L16 7M12 12L8 7M16 12H8M15.5 15H8.5M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), rc = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M2.49954 9H21.4995M9.99954 3L7.99954 9L11.9995 20.5L15.9995 9L13.9995 3M12.6141 20.2625L21.5727 9.51215C21.7246 9.32995 21.8005 9.23885 21.8295 9.13717C21.8551 9.04751 21.8551 8.95249 21.8295 8.86283C21.8005 8.76114 21.7246 8.67005 21.5727 8.48785L17.2394 3.28785C17.1512 3.18204 17.1072 3.12914 17.0531 3.09111C17.0052 3.05741 16.9518 3.03238 16.8953 3.01717C16.8314 3 16.7626 3 16.6248 3H7.37424C7.2365 3 7.16764 3 7.10382 3.01717C7.04728 3.03238 6.99385 3.05741 6.94596 3.09111C6.89192 3.12914 6.84783 3.18204 6.75966 3.28785L2.42633 8.48785C2.2745 8.67004 2.19858 8.76114 2.16957 8.86283C2.144 8.95249 2.144 9.04751 2.16957 9.13716C2.19858 9.23885 2.2745 9.32995 2.42633 9.51215L11.385 20.2625C11.596 20.5158 11.7015 20.6424 11.8279 20.6886C11.9387 20.7291 12.0603 20.7291 12.1712 20.6886C12.2975 20.6424 12.4031 20.5158 12.6141 20.2625Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ic = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M5.00033 22H19.0003M2.50033 8H21.5003M10.0003 2L8.00033 8L12.0003 18.5L16.0003 8L14.0003 2M12.5923 18.3489L21.5319 8.5153C21.6979 8.33264 21.781 8.24131 21.814 8.13732C21.8432 8.04569 21.8453 7.94759 21.8201 7.85478C21.7916 7.74946 21.7125 7.65465 21.5545 7.46501L17.2402 2.28785C17.152 2.18204 17.108 2.12914 17.0539 2.09111C17.006 2.05741 16.9526 2.03238 16.896 2.01717C16.8322 2 16.7634 2 16.6256 2H7.37503C7.2373 2 7.16844 2 7.10462 2.01717C7.04808 2.03238 6.99465 2.05741 6.94676 2.09111C6.89272 2.12914 6.84863 2.18204 6.76046 2.28785L2.44616 7.46501C2.28813 7.65464 2.20911 7.74946 2.18054 7.85478C2.15535 7.94759 2.15747 8.04569 2.18662 8.13732C2.21971 8.24131 2.30273 8.33264 2.46879 8.51529L11.4084 18.3489C11.6136 18.5746 11.7162 18.6875 11.8368 18.7292C11.9427 18.7659 12.0579 18.7659 12.1639 18.7292C12.2845 18.6875 12.3871 18.5746 12.5923 18.3489Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ac = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 6V22M12 6H8.46429C7.94332 6 7.4437 5.78929 7.07533 5.41421C6.70695 5.03914 6.5 4.53043 6.5 4C6.5 3.46957 6.70695 2.96086 7.07533 2.58579C7.4437 2.21071 7.94332 2 8.46429 2C11.2143 2 12 6 12 6ZM12 6H15.5357C16.0567 6 16.5563 5.78929 16.9247 5.41421C17.293 5.03914 17.5 4.53043 17.5 4C17.5 3.46957 17.293 2.96086 16.9247 2.58579C16.5563 2.21071 16.0567 2 15.5357 2C12.7857 2 12 6 12 6ZM20 11V18.8C20 19.9201 20 20.4802 19.782 20.908C19.5903 21.2843 19.2843 21.5903 18.908 21.782C18.4802 22 17.9201 22 16.8 22L7.2 22C6.07989 22 5.51984 22 5.09202 21.782C4.71569 21.5903 4.40973 21.2843 4.21799 20.908C4 20.4802 4 19.9201 4 18.8V11M2 7.6L2 9.4C2 9.96005 2 10.2401 2.10899 10.454C2.20487 10.6422 2.35785 10.7951 2.54601 10.891C2.75992 11 3.03995 11 3.6 11L20.4 11C20.9601 11 21.2401 11 21.454 10.891C21.6422 10.7951 21.7951 10.6422 21.891 10.454C22 10.2401 22 9.96005 22 9.4V7.6C22 7.03995 22 6.75992 21.891 6.54601C21.7951 6.35785 21.6422 6.20487 21.454 6.10899C21.2401 6 20.9601 6 20.4 6L3.6 6C3.03995 6 2.75992 6 2.54601 6.10899C2.35785 6.20487 2.20487 6.35785 2.10899 6.54601C2 6.75992 2 7.03995 2 7.6Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), oc = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 7H7.5C6.83696 7 6.20107 6.73661 5.73223 6.26777C5.26339 5.79893 5 5.16304 5 4.5C5 3.83696 5.26339 3.20107 5.73223 2.73223C6.20107 2.26339 6.83696 2 7.5 2C11 2 12 7 12 7ZM12 7H16.5C17.163 7 17.7989 6.73661 18.2678 6.26777C18.7366 5.79893 19 5.16304 19 4.5C19 3.83696 18.7366 3.20107 18.2678 2.73223C17.7989 2.26339 17.163 2 16.5 2C13 2 12 7 12 7ZM12 7L12 22M2 14H22M2 10.2L2 18.8C2 19.9201 2 20.4802 2.21799 20.908C2.40973 21.2843 2.71569 21.5903 3.09202 21.782C3.51984 22 4.07989 22 5.2 22L18.8 22C19.9201 22 20.4802 22 20.908 21.782C21.2843 21.5903 21.5903 21.2843 21.782 20.908C22 20.4802 22 19.9201 22 18.8V10.2C22 9.0799 22 8.51984 21.782 8.09202C21.5903 7.7157 21.2843 7.40974 20.908 7.21799C20.4802 7 19.9201 7 18.8 7L5.2 7C4.0799 7 3.51984 7 3.09202 7.21799C2.7157 7.40973 2.40973 7.71569 2.21799 8.09202C2 8.51984 2 9.07989 2 10.2Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), sc = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M4.99993 13C4.99993 14.6484 5.66466 16.1415 6.74067 17.226C6.84445 17.3305 6.89633 17.3828 6.92696 17.4331C6.95619 17.4811 6.9732 17.5224 6.98625 17.5771C6.99993 17.6343 6.99993 17.6995 6.99993 17.8298V20.2C6.99993 20.48 6.99993 20.62 7.05443 20.727C7.10236 20.8211 7.17885 20.8976 7.27293 20.9455C7.37989 21 7.5199 21 7.79993 21H9.69993C9.97996 21 10.12 21 10.2269 20.9455C10.321 20.8976 10.3975 20.8211 10.4454 20.727C10.4999 20.62 10.4999 20.48 10.4999 20.2V19.8C10.4999 19.52 10.4999 19.38 10.5544 19.273C10.6024 19.1789 10.6789 19.1024 10.7729 19.0545C10.8799 19 11.0199 19 11.2999 19H12.6999C12.98 19 13.12 19 13.2269 19.0545C13.321 19.1024 13.3975 19.1789 13.4454 19.273C13.4999 19.38 13.4999 19.52 13.4999 19.8V20.2C13.4999 20.48 13.4999 20.62 13.5544 20.727C13.6024 20.8211 13.6789 20.8976 13.7729 20.9455C13.8799 21 14.0199 21 14.2999 21H16.2C16.48 21 16.62 21 16.727 20.9455C16.8211 20.8976 16.8976 20.8211 16.9455 20.727C17 20.62 17 20.48 17 20.2V19.2243C17 19.0223 17 18.9212 17.0288 18.8401C17.0563 18.7624 17.0911 18.708 17.15 18.6502C17.2114 18.59 17.3155 18.5417 17.5237 18.445C18.5059 17.989 19.344 17.2751 19.9511 16.3902C20.0579 16.2346 20.1112 16.1568 20.1683 16.1108C20.2228 16.0668 20.2717 16.0411 20.3387 16.021C20.4089 16 20.4922 16 20.6587 16H21.2C21.48 16 21.62 16 21.727 15.9455C21.8211 15.8976 21.8976 15.8211 21.9455 15.727C22 15.62 22 15.48 22 15.2V11.7857C22 11.5192 22 11.3859 21.9505 11.283C21.9013 11.181 21.819 11.0987 21.717 11.0495C21.6141 11 21.4808 11 21.2143 11C21.0213 11 20.9248 11 20.8471 10.9738C20.7633 10.9456 20.7045 10.908 20.6437 10.8438C20.5874 10.7842 20.5413 10.6846 20.4493 10.4855C20.1538 9.84622 19.7492 9.26777 19.2593 8.77404C19.1555 8.66945 19.1036 8.61716 19.073 8.56687C19.0437 8.51889 19.0267 8.47759 19.0137 8.42294C19 8.36567 19 8.30051 19 8.17018V7.06058C19 6.70053 19 6.52051 18.925 6.39951C18.8593 6.29351 18.7564 6.21588 18.6365 6.18184C18.4995 6.14299 18.3264 6.19245 17.9802 6.29136L15.6077 6.96922C15.5673 6.98074 15.5472 6.9865 15.5267 6.99054C15.5085 6.99414 15.4901 6.99671 15.4716 6.99826C15.4508 7 15.4298 7 15.3879 7H14.959M4.99993 13C4.99993 10.6959 6.29864 8.6952 8.20397 7.6899M4.99993 13H4C2.89543 13 2 12.1046 2 11C2 10.2597 2.4022 9.61337 3 9.26756M15 6.5C15 8.433 13.433 10 11.5 10C9.567 10 8 8.433 8 6.5C8 4.567 9.567 3 11.5 3C13.433 3 15 4.567 15 6.5Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), cc = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M4.99993 13C4.99993 9.68629 7.68622 7 10.9999 7M4.99993 13C4.99993 14.6484 5.66466 16.1415 6.74067 17.226C6.84445 17.3305 6.89633 17.3828 6.92696 17.4331C6.95619 17.4811 6.9732 17.5224 6.98625 17.5771C6.99993 17.6343 6.99993 17.6995 6.99993 17.8298V20.2C6.99993 20.48 6.99993 20.62 7.05443 20.727C7.10236 20.8211 7.17885 20.8976 7.27293 20.9455C7.37989 21 7.5199 21 7.79993 21H9.69993C9.97996 21 10.12 21 10.2269 20.9455C10.321 20.8976 10.3975 20.8211 10.4454 20.727C10.4999 20.62 10.4999 20.48 10.4999 20.2V19.8C10.4999 19.52 10.4999 19.38 10.5544 19.273C10.6024 19.1789 10.6789 19.1024 10.7729 19.0545C10.8799 19 11.0199 19 11.2999 19H12.6999C12.98 19 13.12 19 13.2269 19.0545C13.321 19.1024 13.3975 19.1789 13.4454 19.273C13.4999 19.38 13.4999 19.52 13.4999 19.8V20.2C13.4999 20.48 13.4999 20.62 13.5544 20.727C13.6024 20.8211 13.6789 20.8976 13.7729 20.9455C13.8799 21 14.0199 21 14.2999 21H16.2C16.48 21 16.62 21 16.727 20.9455C16.8211 20.8976 16.8976 20.8211 16.9455 20.727C17 20.62 17 20.48 17 20.2V19.2243C17 19.0223 17 18.9212 17.0288 18.8401C17.0563 18.7624 17.0911 18.708 17.15 18.6502C17.2114 18.59 17.3155 18.5417 17.5237 18.445C18.5059 17.989 19.344 17.2751 19.9511 16.3902C20.0579 16.2346 20.1112 16.1568 20.1683 16.1108C20.2228 16.0668 20.2717 16.0411 20.3387 16.021C20.4089 16 20.4922 16 20.6587 16H21.2C21.48 16 21.62 16 21.727 15.9455C21.8211 15.8976 21.8976 15.8211 21.9455 15.727C22 15.62 22 15.48 22 15.2V11.7857C22 11.5192 22 11.3859 21.9505 11.283C21.9013 11.181 21.819 11.0987 21.717 11.0495C21.6141 11 21.4808 11 21.2143 11C21.0213 11 20.9248 11 20.8471 10.9738C20.7633 10.9456 20.7045 10.908 20.6437 10.8438C20.5874 10.7842 20.5413 10.6846 20.4493 10.4855C20.1538 9.84622 19.7492 9.26777 19.2593 8.77404C19.1555 8.66945 19.1036 8.61716 19.073 8.56687C19.0437 8.51889 19.0267 8.47759 19.0137 8.42294C19 8.36567 19 8.30051 19 8.17018V7.06058C19 6.70053 19 6.52051 18.925 6.39951C18.8593 6.29351 18.7564 6.21588 18.6365 6.18184C18.4995 6.14299 18.3264 6.19245 17.9802 6.29136L15.6077 6.96922C15.5673 6.98074 15.5472 6.9865 15.5267 6.99054C15.5085 6.99414 15.4901 6.99671 15.4716 6.99826C15.4508 7 15.4297 7 15.3874 7H10.9999M4.99993 13H4C2.89543 13 2 12.1046 2 11C2 10.2597 2.4022 9.61337 3 9.26756M10.9999 7H14.9646C14.9879 6.8367 15 6.66976 15 6.5C15 4.567 13.433 3 11.5 3C9.567 3 8 4.567 8 6.5C8 6.9172 8.073 7.31736 8.20692 7.68839C9.04114 7.24881 9.99144 7 10.9999 7Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), lc = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M4 7.8C4 6.11984 4 5.27976 4.32698 4.63803C4.6146 4.07354 5.07354 3.6146 5.63803 3.32698C6.27976 3 7.11984 3 8.8 3H15.2C16.8802 3 17.7202 3 18.362 3.32698C18.9265 3.6146 19.3854 4.07354 19.673 4.63803C20 5.27976 20 6.11984 20 7.8V21L17.25 19L14.75 21L12 19L9.25 21L6.75 19L4 21V7.8Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), uc = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9 10.5L11 12.5L15.5 8M20 21V7.8C20 6.11984 20 5.27976 19.673 4.63803C19.3854 4.07354 18.9265 3.6146 18.362 3.32698C17.7202 3 16.8802 3 15.2 3H8.8C7.11984 3 6.27976 3 5.63803 3.32698C5.07354 3.6146 4.6146 4.07354 4.32698 4.63803C4 5.27976 4 6.11984 4 7.8V21L6.75 19L9.25 21L12 19L14.75 21L17.25 19L20 21Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), dc = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M6 21H9M15 21H18M17.5 6.5V14.5M3 6.2L3 14.8C3 15.9201 3 16.4802 3.21799 16.908C3.40973 17.2843 3.71569 17.5903 4.09202 17.782C4.51984 18 5.07989 18 6.2 18L17.8 18C18.9201 18 19.4802 18 19.908 17.782C20.2843 17.5903 20.5903 17.2843 20.782 16.908C21 16.4802 21 15.9201 21 14.8V6.2C21 5.0799 21 4.51984 20.782 4.09202C20.5903 3.7157 20.2843 3.40974 19.908 3.21799C19.4802 3 18.9201 3 17.8 3L6.2 3C5.0799 3 4.51984 3 4.09202 3.21799C3.7157 3.40973 3.40973 3.71569 3.21799 4.09202C3 4.51984 3 5.07989 3 6.2ZM11.5 10.5C11.5 11.8807 10.3807 13 9 13C7.61929 13 6.5 11.8807 6.5 10.5C6.5 9.11929 7.61929 8 9 8C10.3807 8 11.5 9.11929 11.5 10.5Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), fc = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9 9H9.01M15 15H15.01M16 8L8 16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM9.5 9C9.5 9.27614 9.27614 9.5 9 9.5C8.72386 9.5 8.5 9.27614 8.5 9C8.5 8.72386 8.72386 8.5 9 8.5C9.27614 8.5 9.5 8.72386 9.5 9ZM15.5 15C15.5 15.2761 15.2761 15.5 15 15.5C14.7239 15.5 14.5 15.2761 14.5 15C14.5 14.7239 14.7239 14.5 15 14.5C15.2761 14.5 15.5 14.7239 15.5 15Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), pc = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9 9H9.01M15 15H15.01M16 8L8 16M7.33377 3.8187C8.1376 3.75455 8.90071 3.43846 9.51447 2.91542C10.9467 1.69486 13.0533 1.69486 14.4855 2.91542C15.0993 3.43846 15.8624 3.75455 16.6662 3.8187C18.5421 3.96839 20.0316 5.45794 20.1813 7.33377C20.2455 8.1376 20.5615 8.90071 21.0846 9.51447C22.3051 10.9467 22.3051 13.0533 21.0846 14.4855C20.5615 15.0993 20.2455 15.8624 20.1813 16.6662C20.0316 18.5421 18.5421 20.0316 16.6662 20.1813C15.8624 20.2455 15.0993 20.5615 14.4855 21.0846C13.0533 22.3051 10.9467 22.3051 9.51447 21.0846C8.90071 20.5615 8.1376 20.2455 7.33377 20.1813C5.45794 20.0316 3.96839 18.5421 3.8187 16.6662C3.75455 15.8624 3.43846 15.0993 2.91542 14.4855C1.69486 13.0533 1.69486 10.9467 2.91542 9.51447C3.43846 8.90071 3.75455 8.1376 3.8187 7.33377C3.96839 5.45794 5.45794 3.96839 7.33377 3.8187ZM9.5 9C9.5 9.27614 9.27614 9.5 9 9.5C8.72386 9.5 8.5 9.27614 8.5 9C8.5 8.72386 8.72386 8.5 9 8.5C9.27614 8.5 9.5 8.72386 9.5 9ZM15.5 15C15.5 15.2761 15.2761 15.5 15 15.5C14.7239 15.5 14.5 15.2761 14.5 15C14.5 14.7239 14.7239 14.5 15 14.5C15.2761 14.5 15.5 14.7239 15.5 15Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), mc = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9 9H9.01M15 15H15.01M16 8L8 16M17.9012 4.99851C18.1071 5.49653 18.5024 5.8924 19.0001 6.09907L20.7452 6.82198C21.2433 7.02828 21.639 7.42399 21.8453 7.92206C22.0516 8.42012 22.0516 8.97974 21.8453 9.47781L21.1229 11.2218C20.9165 11.7201 20.9162 12.2803 21.1236 12.7783L21.8447 14.5218C21.9469 14.7685 21.9996 15.0329 21.9996 15.2999C21.9997 15.567 21.9471 15.8314 21.8449 16.0781C21.7427 16.3249 21.5929 16.549 21.4041 16.7378C21.2152 16.9266 20.991 17.0764 20.7443 17.1785L19.0004 17.9009C18.5023 18.1068 18.1065 18.5021 17.8998 18.9998L17.1769 20.745C16.9706 21.2431 16.575 21.6388 16.0769 21.8451C15.5789 22.0514 15.0193 22.0514 14.5212 21.8451L12.7773 21.1227C12.2792 20.9169 11.7198 20.9173 11.2221 21.1239L9.47689 21.8458C8.97912 22.0516 8.42001 22.0514 7.92237 21.8453C7.42473 21.6391 7.02925 21.2439 6.82281 20.7464L6.09972 19.0006C5.8938 18.5026 5.49854 18.1067 5.00085 17.9L3.25566 17.1771C2.75783 16.9709 2.36226 16.5754 2.15588 16.0777C1.94951 15.5799 1.94923 15.0205 2.1551 14.5225L2.87746 12.7786C3.08325 12.2805 3.08283 11.7211 2.8763 11.2233L2.15497 9.47678C2.0527 9.2301 2.00004 8.96568 2 8.69863C1.99996 8.43159 2.05253 8.16715 2.15472 7.92043C2.25691 7.67372 2.40671 7.44955 2.59557 7.26075C2.78442 7.07195 3.00862 6.92222 3.25537 6.8201L4.9993 6.09772C5.49687 5.89197 5.89248 5.4972 6.0993 5.00006L6.82218 3.25481C7.02848 2.75674 7.42418 2.36103 7.92222 2.15473C8.42027 1.94842 8.97987 1.94842 9.47792 2.15473L11.2218 2.87712C11.7199 3.08291 12.2793 3.08249 12.7771 2.87595L14.523 2.15585C15.021 1.94966 15.5804 1.9497 16.0784 2.15597C16.5763 2.36223 16.972 2.75783 17.1783 3.25576L17.9014 5.00153L17.9012 4.99851ZM9.5 9C9.5 9.27614 9.27614 9.5 9 9.5C8.72386 9.5 8.5 9.27614 8.5 9C8.5 8.72386 8.72386 8.5 9 8.5C9.27614 8.5 9.5 8.72386 9.5 9ZM15.5 15C15.5 15.2761 15.2761 15.5 15 15.5C14.7239 15.5 14.5 15.2761 14.5 15C14.5 14.7239 14.7239 14.5 15 14.5C15.2761 14.5 15.5 14.7239 15.5 15Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), hc = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9 9H9.01M15 15H15.01M16 8L8 16M9.2019 20.6009C9.52965 20.5575 9.86073 20.6464 10.1218 20.8475L11.3251 21.7708C11.7228 22.0764 12.2761 22.0764 12.6727 21.7708L13.9215 20.812C14.1548 20.6331 14.4492 20.5542 14.7403 20.5931L16.3024 20.7986C16.799 20.8642 17.2779 20.5875 17.4701 20.1242L18.0712 18.6709C18.1834 18.3987 18.3989 18.1832 18.6711 18.0709L20.1243 17.4698C20.5876 17.2787 20.8643 16.7988 20.7987 16.3021L20.601 14.7966C20.5576 14.4688 20.6465 14.1377 20.8476 13.8766L21.7709 12.6733C22.0764 12.2755 22.0764 11.7222 21.7709 11.3256L20.812 10.0767C20.6332 9.84339 20.5543 9.54896 20.5932 9.25785L20.7987 7.69568C20.8643 7.19902 20.5876 6.72015 20.1243 6.52793L18.6711 5.92684C18.3989 5.81462 18.1834 5.59907 18.0712 5.32685L17.4701 3.87356C17.279 3.41024 16.799 3.13358 16.3024 3.19913L14.7403 3.40468C14.4492 3.44468 14.1548 3.36579 13.9226 3.18802L12.6738 2.22916C12.2761 1.92361 11.7228 1.92361 11.3262 2.22916L10.0774 3.18802C9.84407 3.36579 9.54965 3.44468 9.25856 3.40691L7.69647 3.20136C7.19984 3.1358 6.721 3.41246 6.52879 3.87578L5.92884 5.32907C5.81552 5.60018 5.59998 5.81573 5.32889 5.92906L3.87568 6.52904C3.41238 6.72126 3.13574 7.20013 3.20129 7.69679L3.40683 9.25897C3.4446 9.55007 3.36572 9.8445 3.18796 10.0767L2.22915 11.3256C1.92362 11.7233 1.92362 12.2767 2.22915 12.6733L3.18796 13.9222C3.36683 14.1555 3.44571 14.4499 3.40683 14.741L3.20129 16.3032C3.13574 16.7999 3.41238 17.2787 3.87568 17.471L5.32889 18.0721C5.60109 18.1843 5.81663 18.3998 5.92884 18.672L6.5299 20.1253C6.721 20.5887 7.20096 20.8653 7.69758 20.7998L9.2019 20.6009ZM9.5 9C9.5 9.27614 9.27614 9.5 9 9.5C8.72386 9.5 8.5 9.27614 8.5 9C8.5 8.72386 8.72386 8.5 9 8.5C9.27614 8.5 9.5 8.72386 9.5 9ZM15.5 15C15.5 15.2761 15.2761 15.5 15 15.5C14.7239 15.5 14.5 15.2761 14.5 15C14.5 14.7239 14.7239 14.5 15 14.5C15.2761 14.5 15.5 14.7239 15.5 15Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), gc = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M2 17V16.8498C2 16.5333 2 16.3751 2.02421 16.2209C2.0457 16.084 2.08136 15.9497 2.13061 15.8202C2.18609 15.6743 2.2646 15.5369 2.42162 15.2622L6 9M2 17C2 19.2091 3.79086 21 6 21C8.20914 21 10 19.2091 10 17M2 17V16.8C2 16.52 2 16.38 2.0545 16.273C2.10243 16.1789 2.17892 16.1024 2.273 16.0545C2.37996 16 2.51997 16 2.8 16H9.2C9.48003 16 9.62004 16 9.727 16.0545C9.82108 16.1024 9.89757 16.1789 9.9455 16.273C10 16.38 10 16.52 10 16.8V17M6 9L9.57838 15.2622C9.7354 15.5369 9.81391 15.6743 9.86939 15.8202C9.91864 15.9497 9.9543 16.084 9.97579 16.2209C10 16.3751 10 16.5333 10 16.8498V17M6 9L18 7M14 15V14.8498C14 14.5333 14 14.3751 14.0242 14.2209C14.0457 14.084 14.0814 13.9497 14.1306 13.8202C14.1861 13.6743 14.2646 13.5369 14.4216 13.2622L18 7M14 15C14 17.2091 15.7909 19 18 19C20.2091 19 22 17.2091 22 15M14 15V14.8C14 14.52 14 14.38 14.0545 14.273C14.1024 14.1789 14.1789 14.1024 14.273 14.0545C14.38 14 14.52 14 14.8 14H21.2C21.48 14 21.62 14 21.727 14.0545C21.8211 14.1024 21.8976 14.1789 21.9455 14.273C22 14.38 22 14.52 22 14.8V15M18 7L21.5784 13.2622C21.7354 13.5369 21.8139 13.6743 21.8694 13.8202C21.9186 13.9497 21.9543 14.084 21.9758 14.2209C22 14.3751 22 14.5333 22 14.8498V15M12 3V8",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), _c = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M2.50047 13H8.50047M15.5005 13H21.5005M12.0005 7V21M12.0005 7C13.3812 7 14.5005 5.88071 14.5005 4.5M12.0005 7C10.6198 7 9.50047 5.88071 9.50047 4.5M4.00047 21L20.0005 21M4.00047 4.50001L9.50047 4.5M9.50047 4.5C9.50047 3.11929 10.6198 2 12.0005 2C13.3812 2 14.5005 3.11929 14.5005 4.5M14.5005 4.5L20.0005 4.5M8.88091 14.3364C8.48022 15.8706 7.11858 17 5.50047 17C3.88237 17 2.52073 15.8706 2.12004 14.3364C2.0873 14.211 2.07093 14.1483 2.06935 13.8979C2.06838 13.7443 2.12544 13.3904 2.17459 13.2449C2.25478 13.0076 2.34158 12.8737 2.51519 12.6059L5.50047 8L8.48576 12.6059C8.65937 12.8737 8.74617 13.0076 8.82636 13.2449C8.87551 13.3904 8.93257 13.7443 8.9316 13.8979C8.93002 14.1483 8.91365 14.211 8.88091 14.3364ZM21.8809 14.3364C21.4802 15.8706 20.1186 17 18.5005 17C16.8824 17 15.5207 15.8706 15.12 14.3364C15.0873 14.211 15.0709 14.1483 15.0693 13.8979C15.0684 13.7443 15.1254 13.3904 15.1746 13.2449C15.2548 13.0076 15.3416 12.8737 15.5152 12.6059L18.5005 8L21.4858 12.6059C21.6594 12.8737 21.7462 13.0076 21.8264 13.2449C21.8755 13.3904 21.9326 13.7443 21.9316 13.8979C21.93 14.1483 21.9137 14.211 21.8809 14.3364Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), vc = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M5.52 2.64L3.96 4.72C3.65102 5.13198 3.49652 5.33797 3.50011 5.51039C3.50323 5.66044 3.57358 5.80115 3.69175 5.89368C3.82754 6 4.08503 6 4.6 6H19.4C19.915 6 20.1725 6 20.3083 5.89368C20.4264 5.80115 20.4968 5.66044 20.4999 5.51039C20.5035 5.33797 20.349 5.13198 20.04 4.72L18.48 2.64M5.52 2.64C5.696 2.40533 5.784 2.288 5.89552 2.20338C5.9943 2.12842 6.10616 2.0725 6.22539 2.03845C6.36 2 6.50667 2 6.8 2H17.2C17.4933 2 17.64 2 17.7746 2.03845C17.8938 2.0725 18.0057 2.12842 18.1045 2.20338C18.216 2.288 18.304 2.40533 18.48 2.64M5.52 2.64L3.64 5.14666C3.40254 5.46328 3.28381 5.62159 3.1995 5.79592C3.12469 5.95062 3.07012 6.11431 3.03715 6.28296C3 6.47301 3 6.6709 3 7.06666L3 18.8C3 19.9201 3 20.4802 3.21799 20.908C3.40973 21.2843 3.71569 21.5903 4.09202 21.782C4.51984 22 5.07989 22 6.2 22L17.8 22C18.9201 22 19.4802 22 19.908 21.782C20.2843 21.5903 20.5903 21.2843 20.782 20.908C21 20.4802 21 19.9201 21 18.8V7.06667C21 6.6709 21 6.47301 20.9628 6.28296C20.9299 6.11431 20.8753 5.95062 20.8005 5.79592C20.7162 5.62159 20.5975 5.46328 20.36 5.14667L18.48 2.64M16 10C16 11.0609 15.5786 12.0783 14.8284 12.8284C14.0783 13.5786 13.0609 14 12 14C10.9391 14 9.92172 13.5786 9.17157 12.8284C8.42143 12.0783 8 11.0609 8 10",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), yc = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M16.0004 9V6C16.0004 3.79086 14.2095 2 12.0004 2C9.79123 2 8.00037 3.79086 8.00037 6V9M3.59237 10.352L2.99237 16.752C2.82178 18.5717 2.73648 19.4815 3.03842 20.1843C3.30367 20.8016 3.76849 21.3121 4.35839 21.6338C5.0299 22 5.94374 22 7.77142 22H16.2293C18.057 22 18.9708 22 19.6423 21.6338C20.2322 21.3121 20.6971 20.8016 20.9623 20.1843C21.2643 19.4815 21.179 18.5717 21.0084 16.752L20.4084 10.352C20.2643 8.81535 20.1923 8.04704 19.8467 7.46616C19.5424 6.95458 19.0927 6.54511 18.555 6.28984C17.9444 6 17.1727 6 15.6293 6L8.37142 6C6.82806 6 6.05638 6 5.44579 6.28984C4.90803 6.54511 4.45838 6.95458 4.15403 7.46616C3.80846 8.04704 3.73643 8.81534 3.59237 10.352Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), bc = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M15.9996 8C15.9996 9.06087 15.5782 10.0783 14.828 10.8284C14.0779 11.5786 13.0605 12 11.9996 12C10.9387 12 9.92131 11.5786 9.17116 10.8284C8.42102 10.0783 7.99959 9.06087 7.99959 8M3.63281 7.40138L2.93281 15.8014C2.78243 17.6059 2.70724 18.5082 3.01227 19.2042C3.28027 19.8157 3.74462 20.3204 4.33177 20.6382C5.00006 21 5.90545 21 7.71623 21H16.283C18.0937 21 18.9991 21 19.6674 20.6382C20.2546 20.3204 20.7189 19.8157 20.9869 19.2042C21.2919 18.5082 21.2167 17.6059 21.0664 15.8014L20.3664 7.40138C20.237 5.84875 20.1723 5.07243 19.8285 4.48486C19.5257 3.96744 19.0748 3.5526 18.5341 3.29385C17.92 3 17.141 3 15.583 3L8.41623 3C6.85821 3 6.07921 3 5.4651 3.29384C4.92433 3.5526 4.47349 3.96744 4.17071 4.48486C3.82689 5.07243 3.76219 5.84875 3.63281 7.40138Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), xc = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M2 2H3.30616C3.55218 2 3.67519 2 3.77418 2.04524C3.86142 2.08511 3.93535 2.14922 3.98715 2.22995C4.04593 2.32154 4.06333 2.44332 4.09812 2.68686L4.57143 6M4.57143 6L5.62332 13.7314C5.75681 14.7125 5.82355 15.2031 6.0581 15.5723C6.26478 15.8977 6.56108 16.1564 6.91135 16.3174C7.30886 16.5 7.80394 16.5 8.79411 16.5H17.352C18.2945 16.5 18.7658 16.5 19.151 16.3304C19.4905 16.1809 19.7818 15.9398 19.9923 15.6342C20.2309 15.2876 20.3191 14.8247 20.4955 13.8988L21.8191 6.94969C21.8812 6.62381 21.9122 6.46087 21.8672 6.3335C21.8278 6.22177 21.7499 6.12768 21.6475 6.06802C21.5308 6 21.365 6 21.0332 6H4.57143ZM10 21C10 21.5523 9.55228 22 9 22C8.44772 22 8 21.5523 8 21C8 20.4477 8.44772 20 9 20C9.55228 20 10 20.4477 10 21ZM18 21C18 21.5523 17.5523 22 17 22C16.4477 22 16 21.5523 16 21C16 20.4477 16.4477 20 17 20C17.5523 20 18 20.4477 18 21Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Sc = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M6.50014 17H17.3294C18.2793 17 18.7543 17 19.1414 16.8284C19.4827 16.6771 19.7748 16.4333 19.9847 16.1246C20.2228 15.7744 20.3078 15.3071 20.4777 14.3724L21.8285 6.94311C21.8874 6.61918 21.9169 6.45721 21.8714 6.33074C21.8315 6.21979 21.7536 6.12651 21.6516 6.06739C21.5353 6 21.3707 6 21.0414 6H5.00014M2 2H3.3164C3.55909 2 3.68044 2 3.77858 2.04433C3.86507 2.0834 3.93867 2.14628 3.99075 2.22563C4.04984 2.31565 4.06876 2.43551 4.10662 2.67523L6.89338 20.3248C6.93124 20.5645 6.95016 20.6843 7.00925 20.7744C7.06133 20.8537 7.13493 20.9166 7.22142 20.9557C7.31956 21 7.44091 21 7.6836 21H19",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Cc = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M5.00014 14H18.1359C19.1487 14 19.6551 14 20.0582 13.8112C20.4134 13.6448 20.7118 13.3777 20.9163 13.0432C21.1485 12.6633 21.2044 12.16 21.3163 11.1534L21.9013 5.88835C21.9355 5.58088 21.9525 5.42715 21.9031 5.30816C21.8597 5.20366 21.7821 5.11697 21.683 5.06228C21.5702 5 21.4155 5 21.1062 5H4.50014M2 2H3.24844C3.51306 2 3.64537 2 3.74889 2.05032C3.84002 2.09463 3.91554 2.16557 3.96544 2.25376C4.02212 2.35394 4.03037 2.48599 4.04688 2.7501L4.95312 17.2499C4.96963 17.514 4.97788 17.6461 5.03456 17.7462C5.08446 17.8344 5.15998 17.9054 5.25111 17.9497C5.35463 18 5.48694 18 5.75156 18H19M7.5 21.5H7.51M16.5 21.5H16.51M8 21.5C8 21.7761 7.77614 22 7.5 22C7.22386 22 7 21.7761 7 21.5C7 21.2239 7.22386 21 7.5 21C7.77614 21 8 21.2239 8 21.5ZM17 21.5C17 21.7761 16.7761 22 16.5 22C16.2239 22 16 21.7761 16 21.5C16 21.2239 16.2239 21 16.5 21C16.7761 21 17 21.2239 17 21.5Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), wc = (e) => /* @__PURE__ */ o("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ a("path", {
		d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ a("path", {
		d: "M8 9.6C8 9.03995 8 8.75992 8.10899 8.54601C8.20487 8.35785 8.35785 8.20487 8.54601 8.10899C8.75992 8 9.03995 8 9.6 8H14.4C14.9601 8 15.2401 8 15.454 8.10899C15.6422 8.20487 15.7951 8.35785 15.891 8.54601C16 8.75992 16 9.03995 16 9.6V14.4C16 14.9601 16 15.2401 15.891 15.454C15.7951 15.6422 15.6422 15.7951 15.454 15.891C15.2401 16 14.9601 16 14.4 16H9.6C9.03995 16 8.75992 16 8.54601 15.891C8.35785 15.7951 8.20487 15.6422 8.10899 15.454C8 15.2401 8 14.9601 8 14.4V9.6Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
}), Tc = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M8 8H8.01M2 5.2L2 9.67451C2 10.1637 2 10.4083 2.05526 10.6385C2.10425 10.8425 2.18506 11.0376 2.29472 11.2166C2.4184 11.4184 2.59135 11.5914 2.93726 11.9373L10.6059 19.6059C11.7939 20.7939 12.388 21.388 13.0729 21.6105C13.6755 21.8063 14.3245 21.8063 14.927 21.6105C15.612 21.388 16.2061 20.7939 17.3941 19.6059L19.6059 17.3941C20.7939 16.2061 21.388 15.612 21.6105 14.927C21.8063 14.3245 21.8063 13.6755 21.6105 13.0729C21.388 12.388 20.7939 11.7939 19.6059 10.6059L11.9373 2.93726C11.5914 2.59135 11.4184 2.4184 11.2166 2.29472C11.0376 2.18506 10.8425 2.10425 10.6385 2.05526C10.4083 2 10.1637 2 9.67452 2L5.2 2C4.0799 2 3.51984 2 3.09202 2.21799C2.7157 2.40973 2.40973 2.71569 2.21799 3.09202C2 3.51984 2 4.07989 2 5.2ZM8.5 8C8.5 8.27614 8.27614 8.5 8 8.5C7.72386 8.5 7.5 8.27614 7.5 8C7.5 7.72386 7.72386 7.5 8 7.5C8.27614 7.5 8.5 7.72386 8.5 8Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ec = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M8 8H8.01M4.56274 2.93726L2.93726 4.56274C2.59136 4.90864 2.4184 5.0816 2.29472 5.28343C2.18506 5.46237 2.10425 5.65746 2.05526 5.86154C2 6.09171 2 6.3363 2 6.82548L2 9.67452C2 10.1637 2 10.4083 2.05526 10.6385C2.10425 10.8425 2.18506 11.0376 2.29472 11.2166C2.4184 11.4184 2.59135 11.5914 2.93726 11.9373L10.6059 19.6059C11.7939 20.7939 12.388 21.388 13.0729 21.6105C13.6755 21.8063 14.3245 21.8063 14.927 21.6105C15.612 21.388 16.2061 20.7939 17.3941 19.6059L19.6059 17.3941C20.7939 16.2061 21.388 15.612 21.6105 14.927C21.8063 14.3245 21.8063 13.6755 21.6105 13.0729C21.388 12.388 20.7939 11.7939 19.6059 10.6059L11.9373 2.93726C11.5914 2.59136 11.4184 2.4184 11.2166 2.29472C11.0376 2.18506 10.8425 2.10425 10.6385 2.05526C10.4083 2 10.1637 2 9.67452 2L6.82548 2C6.3363 2 6.09171 2 5.86154 2.05526C5.65746 2.10425 5.46237 2.18506 5.28343 2.29472C5.0816 2.4184 4.90865 2.59135 4.56274 2.93726ZM8.5 8C8.5 8.27614 8.27614 8.5 8 8.5C7.72386 8.5 7.5 8.27614 7.5 8C7.5 7.72386 7.72386 7.5 8 7.5C8.27614 7.5 8.5 7.72386 8.5 8Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Dc = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M21 11L13.4059 3.40589C12.887 2.88703 12.6276 2.6276 12.3249 2.44208C12.0564 2.27759 11.7638 2.15638 11.4577 2.08289C11.1124 2 10.7455 2 10.0118 2L6 2M3 8.7L3 10.6745C3 11.1637 3 11.4083 3.05526 11.6385C3.10425 11.8425 3.18506 12.0376 3.29472 12.2166C3.4184 12.4184 3.59136 12.5914 3.93726 12.9373L11.7373 20.7373C12.5293 21.5293 12.9253 21.9253 13.382 22.0737C13.7837 22.2042 14.2163 22.2042 14.618 22.0737C15.0747 21.9253 15.4707 21.5293 16.2627 20.7373L18.7373 18.2627C19.5293 17.4707 19.9253 17.0747 20.0737 16.618C20.2042 16.2163 20.2042 15.7837 20.0737 15.382C19.9253 14.9253 19.5293 14.5293 18.7373 13.7373L11.4373 6.43726C11.0914 6.09136 10.9184 5.9184 10.7166 5.79472C10.5376 5.68506 10.3425 5.60425 10.1385 5.55526C9.90829 5.5 9.6637 5.5 9.17452 5.5H6.2C5.0799 5.5 4.51984 5.5 4.09202 5.71799C3.7157 5.90973 3.40973 6.21569 3.21799 6.59202C3 7.01984 3 7.57989 3 8.7Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Oc = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M22 8.5H2M2 12.5H5.54668C6.08687 12.5 6.35696 12.5 6.61813 12.5466C6.84995 12.5879 7.0761 12.6563 7.29191 12.7506C7.53504 12.8567 7.75977 13.0065 8.20924 13.3062L8.79076 13.6938C9.24023 13.9935 9.46496 14.1433 9.70809 14.2494C9.9239 14.3437 10.15 14.4121 10.3819 14.4534C10.643 14.5 10.9131 14.5 11.4533 14.5H12.5467C13.0869 14.5 13.357 14.5 13.6181 14.4534C13.85 14.4121 14.0761 14.3437 14.2919 14.2494C14.535 14.1433 14.7598 13.9935 15.2092 13.6938L15.7908 13.3062C16.2402 13.0065 16.465 12.8567 16.7081 12.7506C16.9239 12.6563 17.15 12.5879 17.3819 12.5466C17.643 12.5 17.9131 12.5 18.4533 12.5H22M2 7.2L2 16.8C2 17.9201 2 18.4802 2.21799 18.908C2.40973 19.2843 2.71569 19.5903 3.09202 19.782C3.51984 20 4.07989 20 5.2 20L18.8 20C19.9201 20 20.4802 20 20.908 19.782C21.2843 19.5903 21.5903 19.2843 21.782 18.908C22 18.4802 22 17.9201 22 16.8V7.2C22 6.0799 22 5.51984 21.782 5.09202C21.5903 4.7157 21.2843 4.40974 20.908 4.21799C20.4802 4 19.9201 4 18.8 4L5.2 4C4.0799 4 3.51984 4 3.09202 4.21799C2.7157 4.40973 2.40973 4.71569 2.21799 5.09202C2 5.51984 2 6.07989 2 7.2Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), kc = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M16 7.99983V4.50048C16 3.66874 16 3.25287 15.8248 2.9973C15.6717 2.77401 15.4346 2.62232 15.1678 2.57691C14.8623 2.52493 14.4847 2.6992 13.7295 3.04775L4.85901 7.14182C4.18551 7.45267 3.84875 7.6081 3.60211 7.84915C3.38406 8.06225 3.21762 8.32238 3.1155 8.60966C3 8.93462 3 9.30551 3 10.0473V14.9998M16.5 14.4998H16.51M3 11.1998L3 17.7998C3 18.9199 3 19.48 3.21799 19.9078C3.40973 20.2841 3.71569 20.5901 4.09202 20.7818C4.51984 20.9998 5.07989 20.9998 6.2 20.9998H17.8C18.9201 20.9998 19.4802 20.9998 19.908 20.7818C20.2843 20.5901 20.5903 20.2841 20.782 19.9078C21 19.48 21 18.9199 21 17.7998V11.1998C21 10.0797 21 9.51967 20.782 9.09185C20.5903 8.71552 20.2843 8.40956 19.908 8.21782C19.4802 7.99983 18.9201 7.99983 17.8 7.99983L6.2 7.99983C5.0799 7.99983 4.51984 7.99983 4.09202 8.21781C3.7157 8.40956 3.40973 8.71552 3.21799 9.09185C3 9.51967 3 10.0797 3 11.1998ZM17 14.4998C17 14.776 16.7761 14.9998 16.5 14.9998C16.2239 14.9998 16 14.776 16 14.4998C16 14.2237 16.2239 13.9998 16.5 13.9998C16.7761 13.9998 17 14.2237 17 14.4998Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ac = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M16.5 14H16.51M3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V9C21 7.89543 20.1046 7 19 7L5 7C3.89543 7 3 6.10457 3 5ZM3 5C3 3.89543 3.89543 3 5 3H17M17 14C17 14.2761 16.7761 14.5 16.5 14.5C16.2239 14.5 16 14.2761 16 14C16 13.7239 16.2239 13.5 16.5 13.5C16.7761 13.5 17 13.7239 17 14Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), jc = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M20 9.5V7.2C20 6.0799 20 5.51984 19.782 5.09202C19.5903 4.7157 19.2843 4.40974 18.908 4.21799C18.4802 4 17.9201 4 16.8 4H5.2C4.0799 4 3.51984 4 3.09202 4.21799C2.7157 4.40973 2.40973 4.71569 2.21799 5.09202C2 5.51984 2 6.0799 2 7.2V16.8C2 17.9201 2 18.4802 2.21799 18.908C2.40973 19.2843 2.71569 19.5903 3.09202 19.782C3.51984 20 4.07989 20 5.2 20L16.8 20C17.9201 20 18.4802 20 18.908 19.782C19.2843 19.5903 19.5903 19.2843 19.782 18.908C20 18.4802 20 17.9201 20 16.8V14.5M15 12C15 11.5353 15 11.303 15.0384 11.1098C15.1962 10.3164 15.8164 9.69624 16.6098 9.53843C16.803 9.5 17.0353 9.5 17.5 9.5H19.5C19.9647 9.5 20.197 9.5 20.3902 9.53843C21.1836 9.69624 21.8038 10.3164 21.9616 11.1098C22 11.303 22 11.5353 22 12C22 12.4647 22 12.697 21.9616 12.8902C21.8038 13.6836 21.1836 14.3038 20.3902 14.4616C20.197 14.5 19.9647 14.5 19.5 14.5H17.5C17.0353 14.5 16.803 14.5 16.6098 14.4616C15.8164 14.3038 15.1962 13.6836 15.0384 12.8902C15 12.697 15 12.4647 15 12Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Mc = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M19 10L5.00003 10M19 10L20.8642 13.1069C21.282 13.8032 21.4909 14.1514 21.5993 14.5262C21.6955 14.8582 21.7335 15.2045 21.7117 15.5495C21.6871 15.9389 21.5587 16.324 21.3019 17.0944L21.0941 17.7179C20.7007 18.8981 20.5039 19.4882 20.1391 19.9245C19.8169 20.3098 19.4032 20.608 18.9358 20.7918C18.4065 21 17.7845 21 16.5404 21L7.45967 21C6.2156 21 5.59356 21 5.06429 20.7918C4.5969 20.608 4.18315 20.3098 3.86096 19.9245C3.49611 19.4882 3.2994 18.8981 2.90599 17.7179L2.69816 17.0944C2.44137 16.324 2.31298 15.9389 2.28838 15.5495C2.26658 15.2044 2.30458 14.8582 2.40071 14.5261C2.5092 14.1514 2.71809 13.8032 3.13587 13.1069L5.00003 10M19 10L19.4173 8.53955C19.6151 7.84717 19.714 7.50097 19.6363 7.22708C19.5683 6.98715 19.413 6.78132 19.201 6.64996C18.959 6.5 18.599 6.5 17.8789 6.5L6.1212 6.5C5.4011 6.5 5.04105 6.5 4.79904 6.64996C4.58705 6.78132 4.43179 6.98715 4.36372 7.22708C4.28602 7.50097 4.38493 7.84717 4.58276 8.53955L5.00003 10M12 6.5H8.46431C7.94335 6.5 7.44373 6.28929 7.07535 5.91421C6.70698 5.53914 6.50003 5.03043 6.50003 4.5C6.50003 3.96957 6.70698 3.46086 7.07535 3.08579C7.44373 2.71071 7.94335 2.5 8.46431 2.5C11.2143 2.5 12 6.5 12 6.5ZM12 6.5H15.5357C16.0567 6.5 16.5563 6.28929 16.9247 5.91421C17.2931 5.53914 17.5 5.03043 17.5 4.5C17.5 3.96957 17.2931 3.46086 16.9247 3.08579C16.5563 2.71071 16.0567 2.5 15.5357 2.5C12.7857 2.5 12 6.5 12 6.5Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Nc = /* @__PURE__ */ k({
	Bank: () => ss,
	BankNote01: () => cs,
	BankNote02: () => ls,
	BankNote03: () => us,
	Coins01: () => ds,
	Coins02: () => fs,
	Coins03: () => ps,
	Coins04: () => ms,
	CoinsHandsvg: () => hs,
	CoinsStacked01: () => gs,
	CoinsStacked02: () => _s,
	CoinsStacked03: () => vs,
	CoinsStacked04: () => ys,
	CoinsSwap01: () => bs,
	CoinsSwap02: () => xs,
	CreditCard01: () => Ss,
	CreditCard02: () => Cs,
	CreditCardCheck: () => ws,
	CreditCardDown: () => Ts,
	CreditCardDownload: () => Es,
	CreditCardEdit: () => Ds,
	CreditCardLock: () => Os,
	CreditCardMinus: () => ks,
	CreditCardPlus: () => As,
	CreditCardRefresh: () => js,
	CreditCardSearch: () => Ms,
	CreditCardShield: () => Ns,
	CreditCardUp: () => Ps,
	CreditCardUpload: () => Fs,
	CreditCardX: () => Is,
	Cryptocurrency01: () => Ls,
	Cryptocurrency02: () => Rs,
	Cryptocurrency03: () => zs,
	Cryptocurrency04: () => Bs,
	CurrencyBitcoin: () => Vs,
	CurrencyBitcoinCircle: () => Hs,
	CurrencyDollar: () => Us,
	CurrencyDollarCircle: () => Ws,
	CurrencyEthereum: () => Gs,
	CurrencyEthereumCircle: () => Ks,
	CurrencyEuro: () => qs,
	CurrencyEuroCircle: () => Js,
	CurrencyPound: () => Ys,
	CurrencyPoundCircle: () => Xs,
	CurrencyRuble: () => Zs,
	CurrencyRubleCircle: () => Qs,
	CurrencyRupee: () => $s,
	CurrencyRupeeCircle: () => ec,
	CurrencyYen: () => tc,
	CurrencyYenCircle: () => nc,
	Diamond01: () => rc,
	Diamond02: () => ic,
	Gift01: () => ac,
	Gift02: () => oc,
	PiggyBank01: () => sc,
	PiggyBank02: () => cc,
	Receipt: () => lc,
	ReceiptCheck: () => uc,
	Safe: () => dc,
	Sale01: () => fc,
	Sale02: () => pc,
	Sale03: () => mc,
	Sale04: () => hc,
	Scales01: () => gc,
	Scales02: () => _c,
	ShoppingBag01: () => vc,
	ShoppingBag02: () => yc,
	ShoppingBag03: () => bc,
	ShoppingCart01: () => xc,
	ShoppingCart02: () => Sc,
	ShoppingCart03: () => Cc,
	StopCircle: () => wc,
	Tag01: () => Tc,
	Tag02: () => Ec,
	Tag03: () => Dc,
	Wallet01: () => Oc,
	Wallet02: () => kc,
	Wallet03: () => Ac,
	Wallet04: () => jc,
	Wallet05: () => Mc
}), Pc = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M22 12H18L15 21L9 3L6 12H2",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Fc = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M15.5 11.5H14.5L13 14.5L11 8.5L9.5 11.5H8.5M11.9932 5.13581C9.9938 2.7984 6.65975 2.16964 4.15469 4.31001C1.64964 6.45038 1.29697 10.029 3.2642 12.5604C4.75009 14.4724 8.97129 18.311 10.948 20.0749C11.3114 20.3991 11.4931 20.5613 11.7058 20.6251C11.8905 20.6805 12.0958 20.6805 12.2805 20.6251C12.4932 20.5613 12.6749 20.3991 13.0383 20.0749C15.015 18.311 19.2362 14.4724 20.7221 12.5604C22.6893 10.029 22.3797 6.42787 19.8316 4.31001C17.2835 2.19216 13.9925 2.7984 11.9932 5.13581Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ic = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 8C13.6569 8 15 6.65685 15 5C15 3.34315 13.6569 2 12 2C10.3431 2 9 3.34315 9 5C9 6.65685 10.3431 8 12 8ZM12 8V22M12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12H5M12 22C14.6522 22 17.1957 20.9464 19.0711 19.0711C20.9464 17.1957 22 14.6522 22 12H19",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Lc = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M4 7.9966C3.83599 7.99236 3.7169 7.98287 3.60982 7.96157C2.81644 7.80376 2.19624 7.18356 2.03843 6.39018C2 6.19698 2 5.96466 2 5.5C2 5.03534 2 4.80302 2.03843 4.60982C2.19624 3.81644 2.81644 3.19624 3.60982 3.03843C3.80302 3 4.03534 3 4.5 3H19.5C19.9647 3 20.197 3 20.3902 3.03843C21.1836 3.19624 21.8038 3.81644 21.9616 4.60982C22 4.80302 22 5.03534 22 5.5C22 5.96466 22 6.19698 21.9616 6.39018C21.8038 7.18356 21.1836 7.80376 20.3902 7.96157C20.2831 7.98287 20.164 7.99236 20 7.9966M10 13H14M4 8H20V16.2C20 17.8802 20 18.7202 19.673 19.362C19.3854 19.9265 18.9265 20.3854 18.362 20.673C17.7202 21 16.8802 21 15.2 21H8.8C7.11984 21 6.27976 21 5.63803 20.673C5.07354 20.3854 4.6146 19.9265 4.32698 19.362C4 18.7202 4 17.8802 4 16.2V8Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Rc = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 2V22M19.0711 4.92893L4.92893 19.0711M22 12H2M19.0711 19.0711L4.92893 4.92893",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), zc = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 4V20M18 6L6 18M20 12H4M18 18L6 6",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Bc = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M16 7.99999V13C16 13.7956 16.3161 14.5587 16.8787 15.1213C17.4413 15.6839 18.2043 16 19 16C19.7956 16 20.5587 15.6839 21.1213 15.1213C21.6839 14.5587 22 13.7956 22 13V12C21.9999 9.74302 21.2362 7.55247 19.8333 5.78452C18.4303 4.01658 16.4705 2.77521 14.2726 2.26229C12.0747 1.74936 9.76793 1.99503 7.72734 2.95936C5.68676 3.92368 4.03239 5.54995 3.03325 7.57371C2.03411 9.59748 1.74896 11.8997 2.22416 14.1061C2.69936 16.3125 3.90697 18.2932 5.65062 19.7263C7.39428 21.1593 9.57143 21.9603 11.8281 21.9991C14.0847 22.0379 16.2881 21.3122 18.08 19.94M16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79085 9.79086 7.99999 12 7.99999C14.2091 7.99999 16 9.79085 16 12Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Vc = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M5 7.8C5 6.11984 5 5.27976 5.32698 4.63803C5.6146 4.07354 6.07354 3.6146 6.63803 3.32698C7.27976 3 8.11984 3 9.8 3H14.2C15.8802 3 16.7202 3 17.362 3.32698C17.9265 3.6146 18.3854 4.07354 18.673 4.63803C19 5.27976 19 6.11984 19 7.8V21L12 17L5 21V7.8Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Hc = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 13V7M9 10H15M19 21V7.8C19 6.11984 19 5.27976 18.673 4.63803C18.3854 4.07354 17.9265 3.6146 17.362 3.32698C16.7202 3 15.8802 3 14.2 3H9.8C8.11984 3 7.27976 3 6.63803 3.32698C6.07354 3.6146 5.6146 4.07354 5.32698 4.63803C5 5.27976 5 6.11984 5 7.8V21L12 17L19 21Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Uc = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9 10.5L11 12.5L15.5 8M19 21V7.8C19 6.11984 19 5.27976 18.673 4.63803C18.3854 4.07354 17.9265 3.6146 17.362 3.32698C16.7202 3 15.8802 3 14.2 3H9.8C8.11984 3 7.27976 3 6.63803 3.32698C6.07354 3.6146 5.6146 4.07354 5.32698 4.63803C5 5.27976 5 6.11984 5 7.8V21L12 17L19 21Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Wc = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9 10H15M19 21V7.8C19 6.11984 19 5.27976 18.673 4.63803C18.3854 4.07354 17.9265 3.6146 17.362 3.32698C16.7202 3 15.8802 3 14.2 3H9.8C8.11984 3 7.27976 3 6.63803 3.32698C6.07354 3.6146 5.6146 4.07354 5.32698 4.63803C5 5.27976 5 6.11984 5 7.8V21L12 17L19 21Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Gc = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9.5 7.5L14.5 12.5M14.5 7.5L9.5 12.5M19 21V7.8C19 6.11984 19 5.27976 18.673 4.63803C18.3854 4.07354 17.9265 3.6146 17.362 3.32698C16.7202 3 15.8802 3 14.2 3H9.8C8.11984 3 7.27976 3 6.63803 3.32698C6.07354 3.6146 5.6146 4.07354 5.32698 4.63803C5 5.27976 5 6.11984 5 7.8V21L12 17L19 21Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Kc = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M15 21V15.6C15 15.0399 15 14.7599 14.891 14.546C14.7951 14.3578 14.6422 14.2049 14.454 14.109C14.2401 14 13.9601 14 13.4 14H10.6C10.0399 14 9.75992 14 9.54601 14.109C9.35785 14.2049 9.20487 14.3578 9.10899 14.546C9 14.7599 9 15.0399 9 15.6V21M19 21V6.2C19 5.0799 19 4.51984 18.782 4.09202C18.5903 3.71569 18.2843 3.40973 17.908 3.21799C17.4802 3 16.9201 3 15.8 3H8.2C7.07989 3 6.51984 3 6.09202 3.21799C5.71569 3.40973 5.40973 3.71569 5.21799 4.09202C5 4.51984 5 5.0799 5 6.2V21M21 21H3M9.5 8H9.51M14.5 8H14.51M10 8C10 8.27614 9.77614 8.5 9.5 8.5C9.22386 8.5 9 8.27614 9 8C9 7.72386 9.22386 7.5 9.5 7.5C9.77614 7.5 10 7.72386 10 8ZM15 8C15 8.27614 14.7761 8.5 14.5 8.5C14.2239 8.5 14 8.27614 14 8C14 7.72386 14.2239 7.5 14.5 7.5C14.7761 7.5 15 7.72386 15 8Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), qc = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M15 21V15.6C15 15.0399 15 14.7599 14.891 14.546C14.7951 14.3578 14.6422 14.2049 14.454 14.109C14.2401 14 13.9601 14 13.4 14H10.6C10.0399 14 9.75992 14 9.54601 14.109C9.35785 14.2049 9.20487 14.3578 9.10899 14.546C9 14.7599 9 15.0399 9 15.6V21M3 7C3 8.65685 4.34315 10 6 10C7.65685 10 9 8.65685 9 7C9 8.65685 10.3431 10 12 10C13.6569 10 15 8.65685 15 7C15 8.65685 16.3431 10 18 10C19.6569 10 21 8.65685 21 7M6.2 21H17.8C18.9201 21 19.4802 21 19.908 20.782C20.2843 20.5903 20.5903 20.2843 20.782 19.908C21 19.4802 21 18.9201 21 17.8V6.2C21 5.0799 21 4.51984 20.782 4.09202C20.5903 3.71569 20.2843 3.40973 19.908 3.21799C19.4802 3 18.9201 3 17.8 3H6.2C5.0799 3 4.51984 3 4.09202 3.21799C3.71569 3.40973 3.40973 3.71569 3.21799 4.09202C3 4.51984 3 5.07989 3 6.2V17.8C3 18.9201 3 19.4802 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.07989 21 6.2 21Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Jc = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M7.5 7H10.25M7.5 11H10.25M7.5 15H10.25M13.75 7H16.5M13.75 11H16.5M13.75 15H16.5M20 21V6.2C20 5.0799 20 4.51984 19.782 4.09202C19.5903 3.71569 19.2843 3.40973 18.908 3.21799C18.4802 3 17.9201 3 16.8 3H7.2C6.07989 3 5.51984 3 5.09202 3.21799C4.71569 3.40973 4.40973 3.71569 4.21799 4.09202C4 4.51984 4 5.0799 4 6.2V21M22 21H2",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Yc = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9.5 7H14.5M9.5 11H14.5M9.5 15H14.5M18 21V6.2C18 5.0799 18 4.51984 17.782 4.09202C17.5903 3.71569 17.2843 3.40973 16.908 3.21799C16.4802 3 15.9201 3 14.8 3H9.2C8.0799 3 7.51984 3 7.09202 3.21799C6.71569 3.40973 6.40973 3.71569 6.21799 4.09202C6 4.51984 6 5.0799 6 6.2V21M20 21H4",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Xc = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M13 11H17.8C18.9201 11 19.4802 11 19.908 11.218C20.2843 11.4097 20.5903 11.7157 20.782 12.092C21 12.5198 21 13.0799 21 14.2V21M13 21V6.2C13 5.0799 13 4.51984 12.782 4.09202C12.5903 3.71569 12.2843 3.40973 11.908 3.21799C11.4802 3 10.9201 3 9.8 3H6.2C5.0799 3 4.51984 3 4.09202 3.21799C3.71569 3.40973 3.40973 3.71569 3.21799 4.09202C3 4.51984 3 5.0799 3 6.2V21M22 21H2M6.5 7H9.5M6.5 11H9.5M6.5 15H9.5",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Zc = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M11 11H6.2C5.07989 11 4.51984 11 4.09202 11.218C3.71569 11.4097 3.40973 11.7157 3.21799 12.092C3 12.5198 3 13.0799 3 14.2V21M21 21V6.2C21 5.0799 21 4.51984 20.782 4.09202C20.5903 3.71569 20.2843 3.40973 19.908 3.21799C19.4802 3 18.9201 3 17.8 3H14.2C13.0799 3 12.5198 3 12.092 3.21799C11.7157 3.40973 11.4097 3.71569 11.218 4.09202C11 4.51984 11 5.0799 11 6.2V21M22 21H2M14.5 7H17.5M14.5 11H17.5M14.5 15H17.5",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Qc = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M7.5 11H4.6C4.03995 11 3.75992 11 3.54601 11.109C3.35785 11.2049 3.20487 11.3578 3.10899 11.546C3 11.7599 3 12.0399 3 12.6V21M16.5 11H19.4C19.9601 11 20.2401 11 20.454 11.109C20.6422 11.2049 20.7951 11.3578 20.891 11.546C21 11.7599 21 12.0399 21 12.6V21M16.5 21V6.2C16.5 5.0799 16.5 4.51984 16.282 4.09202C16.0903 3.71569 15.7843 3.40973 15.408 3.21799C14.9802 3 14.4201 3 13.3 3H10.7C9.57989 3 9.01984 3 8.59202 3.21799C8.21569 3.40973 7.90973 3.71569 7.71799 4.09202C7.5 4.51984 7.5 5.0799 7.5 6.2V21M22 21H2M11 7H13M11 11H13M11 15H13",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), $c = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M3 21H21M6 18V9.99998M10 18V9.99998M14 18V9.99998M18 18V9.99998M20 6.99998L12.424 2.26498C12.2702 2.16884 12.1933 2.12077 12.1108 2.10203C12.0379 2.08546 11.9621 2.08546 11.8892 2.10203C11.8067 2.12077 11.7298 2.16884 11.576 2.26498L4 6.99998H20Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), el = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M20 6L9 17L4 12",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), tl = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M7.5 12L10.5 15L16.5 9M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), nl = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M22 11.0857V12.0057C21.9988 14.1621 21.3005 16.2604 20.0093 17.9875C18.7182 19.7147 16.9033 20.9782 14.8354 21.5896C12.7674 22.201 10.5573 22.1276 8.53447 21.3803C6.51168 20.633 4.78465 19.2518 3.61096 17.4428C2.43727 15.6338 1.87979 13.4938 2.02168 11.342C2.16356 9.19029 2.99721 7.14205 4.39828 5.5028C5.79935 3.86354 7.69279 2.72111 9.79619 2.24587C11.8996 1.77063 14.1003 1.98806 16.07 2.86572M22 4L12 14.01L9 11.01",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), rl = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M6 15L8 17L12.5 12.5M8 8V5.2C8 4.0799 8 3.51984 8.21799 3.09202C8.40973 2.71569 8.71569 2.40973 9.09202 2.21799C9.51984 2 10.0799 2 11.2 2H18.8C19.9201 2 20.4802 2 20.908 2.21799C21.2843 2.40973 21.5903 2.71569 21.782 3.09202C22 3.51984 22 4.0799 22 5.2V12.8C22 13.9201 22 14.4802 21.782 14.908C21.5903 15.2843 21.2843 15.5903 20.908 15.782C20.4802 16 19.9201 16 18.8 16H16M5.2 22H12.8C13.9201 22 14.4802 22 14.908 21.782C15.2843 21.5903 15.5903 21.2843 15.782 20.908C16 20.4802 16 19.9201 16 18.8V11.2C16 10.0799 16 9.51984 15.782 9.09202C15.5903 8.71569 15.2843 8.40973 14.908 8.21799C14.4802 8 13.9201 8 12.8 8H5.2C4.0799 8 3.51984 8 3.09202 8.21799C2.71569 8.40973 2.40973 8.71569 2.21799 9.09202C2 9.51984 2 10.0799 2 11.2V18.8C2 19.9201 2 20.4802 2.21799 20.908C2.40973 21.2843 2.71569 21.5903 3.09202 21.782C3.51984 22 4.07989 22 5.2 22Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), il = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M16 8V5.2C16 4.0799 16 3.51984 15.782 3.09202C15.5903 2.71569 15.2843 2.40973 14.908 2.21799C14.4802 2 13.9201 2 12.8 2H5.2C4.0799 2 3.51984 2 3.09202 2.21799C2.71569 2.40973 2.40973 2.71569 2.21799 3.09202C2 3.51984 2 4.0799 2 5.2V12.8C2 13.9201 2 14.4802 2.21799 14.908C2.40973 15.2843 2.71569 15.5903 3.09202 15.782C3.51984 16 4.0799 16 5.2 16H8M12 15L14 17L18.5 12.5M11.2 22H18.8C19.9201 22 20.4802 22 20.908 21.782C21.2843 21.5903 21.5903 21.2843 21.782 20.908C22 20.4802 22 19.9201 22 18.8V11.2C22 10.0799 22 9.51984 21.782 9.09202C21.5903 8.71569 21.2843 8.40973 20.908 8.21799C20.4802 8 19.9201 8 18.8 8H11.2C10.0799 8 9.51984 8 9.09202 8.21799C8.71569 8.40973 8.40973 8.71569 8.21799 9.09202C8 9.51984 8 10.0799 8 11.2V18.8C8 19.9201 8 20.4802 8.21799 20.908C8.40973 21.2843 8.71569 21.5903 9.09202 21.782C9.51984 22 10.0799 22 11.2 22Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), al = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9 11L11 13L15.5 8.5M11.9932 5.13581C9.9938 2.7984 6.65975 2.16964 4.15469 4.31001C1.64964 6.45038 1.29697 10.029 3.2642 12.5604C4.75009 14.4724 8.97129 18.311 10.948 20.0749C11.3114 20.3991 11.4931 20.5613 11.7058 20.6251C11.8905 20.6805 12.0958 20.6805 12.2805 20.6251C12.4932 20.5613 12.6749 20.3991 13.0383 20.0749C15.015 18.311 19.2362 14.4724 20.7221 12.5604C22.6893 10.029 22.3797 6.42787 19.8316 4.31001C17.2835 2.19216 13.9925 2.7984 11.9932 5.13581Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ol = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M7.5 12L10.5 15L16.5 9M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), sl = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9 11L12 14L22 4M16 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V12",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), cl = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9 12L11 14L15.5 9.5M7.33377 3.8187C8.1376 3.75455 8.90071 3.43846 9.51447 2.91542C10.9467 1.69486 13.0533 1.69486 14.4855 2.91542C15.0993 3.43846 15.8624 3.75455 16.6662 3.8187C18.5421 3.96839 20.0316 5.45794 20.1813 7.33377C20.2455 8.1376 20.5615 8.90071 21.0846 9.51447C22.3051 10.9467 22.3051 13.0533 21.0846 14.4855C20.5615 15.0993 20.2455 15.8624 20.1813 16.6662C20.0316 18.5421 18.5421 20.0316 16.6662 20.1813C15.8624 20.2455 15.0993 20.5615 14.4855 21.0846C13.0533 22.3051 10.9467 22.3051 9.51447 21.0846C8.90071 20.5615 8.1376 20.2455 7.33377 20.1813C5.45794 20.0316 3.96839 18.5421 3.8187 16.6662C3.75455 15.8624 3.43846 15.0993 2.91542 14.4855C1.69486 13.0533 1.69486 10.9467 2.91542 9.51447C3.43846 8.90071 3.75455 8.1376 3.8187 7.33377C3.96839 5.45794 5.45794 3.96839 7.33377 3.8187Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ll = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9 12L11 14L15.5 9.5M17.9012 4.99851C18.1071 5.49653 18.5024 5.8924 19.0001 6.09907L20.7452 6.82198C21.2433 7.02828 21.639 7.42399 21.8453 7.92206C22.0516 8.42012 22.0516 8.97974 21.8453 9.47781L21.1229 11.2218C20.9165 11.7201 20.9162 12.2803 21.1236 12.7783L21.8447 14.5218C21.9469 14.7685 21.9996 15.0329 21.9996 15.2999C21.9997 15.567 21.9471 15.8314 21.8449 16.0781C21.7427 16.3249 21.5929 16.549 21.4041 16.7378C21.2152 16.9266 20.991 17.0764 20.7443 17.1785L19.0004 17.9009C18.5023 18.1068 18.1065 18.5021 17.8998 18.9998L17.1769 20.745C16.9706 21.2431 16.575 21.6388 16.0769 21.8451C15.5789 22.0514 15.0193 22.0514 14.5212 21.8451L12.7773 21.1227C12.2792 20.9169 11.7198 20.9173 11.2221 21.1239L9.47689 21.8458C8.97912 22.0516 8.42001 22.0514 7.92237 21.8453C7.42473 21.6391 7.02925 21.2439 6.82281 20.7464L6.09972 19.0006C5.8938 18.5026 5.49854 18.1067 5.00085 17.9L3.25566 17.1771C2.75783 16.9709 2.36226 16.5754 2.15588 16.0777C1.94951 15.5799 1.94923 15.0205 2.1551 14.5225L2.87746 12.7786C3.08325 12.2805 3.08283 11.7211 2.8763 11.2233L2.15497 9.47678C2.0527 9.2301 2.00004 8.96568 2 8.69863C1.99996 8.43159 2.05253 8.16715 2.15472 7.92043C2.25691 7.67372 2.40671 7.44955 2.59557 7.26075C2.78442 7.07195 3.00862 6.92222 3.25537 6.8201L4.9993 6.09772C5.49687 5.89197 5.89248 5.4972 6.0993 5.00006L6.82218 3.25481C7.02848 2.75674 7.42418 2.36103 7.92222 2.15473C8.42027 1.94842 8.97987 1.94842 9.47792 2.15473L11.2218 2.87712C11.7199 3.08291 12.2793 3.08249 12.7771 2.87595L14.523 2.15585C15.021 1.94966 15.5804 1.9497 16.0784 2.15597C16.5763 2.36223 16.972 2.75783 17.1783 3.25576L17.9014 5.00153L17.9012 4.99851Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ul = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9 12L11 14L15.5 9.5M9.2019 20.6009C9.52965 20.5575 9.86073 20.6464 10.1218 20.8475L11.3251 21.7708C11.7228 22.0764 12.2761 22.0764 12.6727 21.7708L13.9215 20.812C14.1548 20.6331 14.4492 20.5542 14.7403 20.5931L16.3024 20.7986C16.799 20.8642 17.2779 20.5875 17.4701 20.1242L18.0712 18.6709C18.1834 18.3987 18.3989 18.1832 18.6711 18.0709L20.1243 17.4698C20.5876 17.2787 20.8643 16.7988 20.7987 16.3021L20.601 14.7966C20.5576 14.4688 20.6465 14.1377 20.8476 13.8766L21.7709 12.6733C22.0764 12.2755 22.0764 11.7222 21.7709 11.3256L20.812 10.0767C20.6332 9.84339 20.5543 9.54896 20.5932 9.25785L20.7987 7.69568C20.8643 7.19902 20.5876 6.72015 20.1243 6.52793L18.6711 5.92684C18.3989 5.81462 18.1834 5.59907 18.0712 5.32685L17.4701 3.87356C17.279 3.41024 16.799 3.13358 16.3024 3.19913L14.7403 3.40468C14.4492 3.44468 14.1548 3.36579 13.9226 3.18802L12.6738 2.22916C12.2761 1.92361 11.7228 1.92361 11.3262 2.22916L10.0774 3.18802C9.84407 3.36579 9.54965 3.44468 9.25856 3.40691L7.69647 3.20136C7.19984 3.1358 6.721 3.41246 6.52879 3.87578L5.92884 5.32907C5.81552 5.60018 5.59998 5.81573 5.32889 5.92906L3.87568 6.52904C3.41238 6.72126 3.13574 7.20013 3.20129 7.69679L3.40683 9.25897C3.4446 9.55007 3.36572 9.8445 3.18796 10.0767L2.22915 11.3256C1.92362 11.7233 1.92362 12.2767 2.22915 12.6733L3.18796 13.9222C3.36683 14.1555 3.44571 14.4499 3.40683 14.741L3.20129 16.3032C3.13574 16.7999 3.41238 17.2787 3.87568 17.471L5.32889 18.0721C5.60109 18.1843 5.81663 18.3998 5.92884 18.672L6.5299 20.1253C6.721 20.5887 7.20096 20.8653 7.69758 20.7998L9.2019 20.6009Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), dl = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M6.5 19C4.01472 19 2 16.9853 2 14.5C2 12.1564 3.79151 10.2313 6.07974 10.0194C6.54781 7.17213 9.02024 5 12 5C14.9798 5 17.4522 7.17213 17.9203 10.0194C20.2085 10.2313 22 12.1564 22 14.5C22 16.9853 19.9853 19 17.5 19C13.1102 19 10.3433 19 6.5 19Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), fl = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9.5 19C5.35786 19 2 15.6421 2 11.5C2 7.35786 5.35786 4 9.5 4C12.3827 4 14.8855 5.62634 16.141 8.01153C16.2597 8.00388 16.3794 8 16.5 8C19.5376 8 22 10.4624 22 13.5C22 16.5376 19.5376 19 16.5 19C13.9485 19 12.1224 19 9.5 19Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), pl = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M20.5 7.27783L12 12.0001M12 12.0001L3.49997 7.27783M12 12.0001L12 21.5001M21 16.0586V7.94153C21 7.59889 21 7.42757 20.9495 7.27477C20.9049 7.13959 20.8318 7.01551 20.7354 6.91082C20.6263 6.79248 20.4766 6.70928 20.177 6.54288L12.777 2.43177C12.4934 2.27421 12.3516 2.19543 12.2015 2.16454C12.0685 2.13721 11.9315 2.13721 11.7986 2.16454C11.6484 2.19543 11.5066 2.27421 11.223 2.43177L3.82297 6.54288C3.52345 6.70928 3.37369 6.79248 3.26463 6.91082C3.16816 7.01551 3.09515 7.13959 3.05048 7.27477C3 7.42757 3 7.59889 3 7.94153V16.0586C3 16.4013 3 16.5726 3.05048 16.7254C3.09515 16.8606 3.16816 16.9847 3.26463 17.0893C3.37369 17.2077 3.52345 17.2909 3.82297 17.4573L11.223 21.5684C11.5066 21.726 11.6484 21.8047 11.7986 21.8356C11.9315 21.863 12.0685 21.863 12.2015 21.8356C12.3516 21.8047 12.4934 21.726 12.777 21.5684L20.177 17.4573C20.4766 17.2909 20.6263 17.2077 20.7354 17.0893C20.8318 16.9847 20.9049 16.8606 20.9495 16.7254C21 16.5726 21 16.4013 21 16.0586Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ml = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M5 15C4.06812 15 3.60218 15 3.23463 14.8478C2.74458 14.6448 2.35523 14.2554 2.15224 13.7654C2 13.3978 2 12.9319 2 12V5.2C2 4.0799 2 3.51984 2.21799 3.09202C2.40973 2.71569 2.71569 2.40973 3.09202 2.21799C3.51984 2 4.0799 2 5.2 2H12C12.9319 2 13.3978 2 13.7654 2.15224C14.2554 2.35523 14.6448 2.74458 14.8478 3.23463C15 3.60218 15 4.06812 15 5M12.2 22H18.8C19.9201 22 20.4802 22 20.908 21.782C21.2843 21.5903 21.5903 21.2843 21.782 20.908C22 20.4802 22 19.9201 22 18.8V12.2C22 11.0799 22 10.5198 21.782 10.092C21.5903 9.71569 21.2843 9.40973 20.908 9.21799C20.4802 9 19.9201 9 18.8 9H12.2C11.0799 9 10.5198 9 10.092 9.21799C9.71569 9.40973 9.40973 9.71569 9.21799 10.092C9 10.5198 9 11.0799 9 12.2V18.8C9 19.9201 9 20.4802 9.21799 20.908C9.40973 21.2843 9.71569 21.5903 10.092 21.782C10.5198 22 11.0799 22 12.2 22Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), hl = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M16 8V5.2C16 4.0799 16 3.51984 15.782 3.09202C15.5903 2.71569 15.2843 2.40973 14.908 2.21799C14.4802 2 13.9201 2 12.8 2H5.2C4.0799 2 3.51984 2 3.09202 2.21799C2.71569 2.40973 2.40973 2.71569 2.21799 3.09202C2 3.51984 2 4.0799 2 5.2V12.8C2 13.9201 2 14.4802 2.21799 14.908C2.40973 15.2843 2.71569 15.5903 3.09202 15.782C3.51984 16 4.0799 16 5.2 16H8M11.2 22H18.8C19.9201 22 20.4802 22 20.908 21.782C21.2843 21.5903 21.5903 21.2843 21.782 20.908C22 20.4802 22 19.9201 22 18.8V11.2C22 10.0799 22 9.51984 21.782 9.09202C21.5903 8.71569 21.2843 8.40973 20.908 8.21799C20.4802 8 19.9201 8 18.8 8H11.2C10.0799 8 9.51984 8 9.09202 8.21799C8.71569 8.40973 8.40973 8.71569 8.21799 9.09202C8 9.51984 8 10.0799 8 11.2V18.8C8 19.9201 8 20.4802 8.21799 20.908C8.40973 21.2843 8.71569 21.5903 9.09202 21.782C9.51984 22 10.0799 22 11.2 22Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), gl = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M8 8V5.2C8 4.0799 8 3.51984 8.21799 3.09202C8.40973 2.71569 8.71569 2.40973 9.09202 2.21799C9.51984 2 10.0799 2 11.2 2H18.8C19.9201 2 20.4802 2 20.908 2.21799C21.2843 2.40973 21.5903 2.71569 21.782 3.09202C22 3.51984 22 4.0799 22 5.2V12.8C22 13.9201 22 14.4802 21.782 14.908C21.5903 15.2843 21.2843 15.5903 20.908 15.782C20.4802 16 19.9201 16 18.8 16H16M5.2 22H12.8C13.9201 22 14.4802 22 14.908 21.782C15.2843 21.5903 15.5903 21.2843 15.782 20.908C16 20.4802 16 19.9201 16 18.8V11.2C16 10.0799 16 9.51984 15.782 9.09202C15.5903 8.71569 15.2843 8.40973 14.908 8.21799C14.4802 8 13.9201 8 12.8 8H5.2C4.0799 8 3.51984 8 3.09202 8.21799C2.71569 8.40973 2.40973 8.71569 2.21799 9.09202C2 9.51984 2 10.0799 2 11.2V18.8C2 19.9201 2 20.4802 2.21799 20.908C2.40973 21.2843 2.71569 21.5903 3.09202 21.782C3.51984 22 4.07989 22 5.2 22Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), _l = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M16 16V18.8C16 19.9201 16 20.4802 15.782 20.908C15.5903 21.2843 15.2843 21.5903 14.908 21.782C14.4802 22 13.9201 22 12.8 22H5.2C4.0799 22 3.51984 22 3.09202 21.782C2.71569 21.5903 2.40973 21.2843 2.21799 20.908C2 20.4802 2 19.9201 2 18.8V11.2C2 10.0799 2 9.51984 2.21799 9.09202C2.40973 8.71569 2.71569 8.40973 3.09202 8.21799C3.51984 8 4.0799 8 5.2 8H8M11.2 16H18.8C19.9201 16 20.4802 16 20.908 15.782C21.2843 15.5903 21.5903 15.2843 21.782 14.908C22 14.4802 22 13.9201 22 12.8V5.2C22 4.0799 22 3.51984 21.782 3.09202C21.5903 2.71569 21.2843 2.40973 20.908 2.21799C20.4802 2 19.9201 2 18.8 2H11.2C10.0799 2 9.51984 2 9.09202 2.21799C8.71569 2.40973 8.40973 2.71569 8.21799 3.09202C8 3.51984 8 4.07989 8 5.2V12.8C8 13.9201 8 14.4802 8.21799 14.908C8.40973 15.2843 8.71569 15.5903 9.09202 15.782C9.51984 16 10.0799 16 11.2 16Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), vl = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M8 16V18.8C8 19.9201 8 20.4802 8.21799 20.908C8.40973 21.2843 8.71569 21.5903 9.09202 21.782C9.51984 22 10.0799 22 11.2 22H18.8C19.9201 22 20.4802 22 20.908 21.782C21.2843 21.5903 21.5903 21.2843 21.782 20.908C22 20.4802 22 19.9201 22 18.8V11.2C22 10.0799 22 9.51984 21.782 9.09202C21.5903 8.71569 21.2843 8.40973 20.908 8.21799C20.4802 8 19.9201 8 18.8 8H16M5.2 16H12.8C13.9201 16 14.4802 16 14.908 15.782C15.2843 15.5903 15.5903 15.2843 15.782 14.908C16 14.4802 16 13.9201 16 12.8V5.2C16 4.0799 16 3.51984 15.782 3.09202C15.5903 2.71569 15.2843 2.40973 14.908 2.21799C14.4802 2 13.9201 2 12.8 2H5.2C4.0799 2 3.51984 2 3.09202 2.21799C2.71569 2.40973 2.40973 2.71569 2.21799 3.09202C2 3.51984 2 4.07989 2 5.2V12.8C2 13.9201 2 14.4802 2.21799 14.908C2.40973 15.2843 2.71569 15.5903 3.09202 15.782C3.51984 16 4.07989 16 5.2 16Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), yl = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M7.5 3H14.6C16.8402 3 17.9603 3 18.816 3.43597C19.5686 3.81947 20.1805 4.43139 20.564 5.18404C21 6.03969 21 7.15979 21 9.4V16.5M6.2 21H14.3C15.4201 21 15.9802 21 16.408 20.782C16.7843 20.5903 17.0903 20.2843 17.282 19.908C17.5 19.4802 17.5 18.9201 17.5 17.8V9.7C17.5 8.57989 17.5 8.01984 17.282 7.59202C17.0903 7.21569 16.7843 6.90973 16.408 6.71799C15.9802 6.5 15.4201 6.5 14.3 6.5H6.2C5.0799 6.5 4.51984 6.5 4.09202 6.71799C3.71569 6.90973 3.40973 7.21569 3.21799 7.59202C3 8.01984 3 8.57989 3 9.7V17.8C3 18.9201 3 19.4802 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.0799 21 6.2 21Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), bl = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M10.5 2.0028C9.82495 2.01194 9.4197 2.05103 9.09202 2.21799C8.71569 2.40973 8.40973 2.71569 8.21799 3.09202C8.05103 3.4197 8.01194 3.82495 8.0028 4.5M19.5 2.0028C20.1751 2.01194 20.5803 2.05103 20.908 2.21799C21.2843 2.40973 21.5903 2.71569 21.782 3.09202C21.949 3.4197 21.9881 3.82494 21.9972 4.49999M21.9972 13.5C21.9881 14.175 21.949 14.5803 21.782 14.908C21.5903 15.2843 21.2843 15.5903 20.908 15.782C20.5803 15.949 20.1751 15.9881 19.5 15.9972M22 7.99999V9.99999M14.0001 2H16M5.2 22H12.8C13.9201 22 14.4802 22 14.908 21.782C15.2843 21.5903 15.5903 21.2843 15.782 20.908C16 20.4802 16 19.9201 16 18.8V11.2C16 10.0799 16 9.51984 15.782 9.09202C15.5903 8.71569 15.2843 8.40973 14.908 8.21799C14.4802 8 13.9201 8 12.8 8H5.2C4.0799 8 3.51984 8 3.09202 8.21799C2.71569 8.40973 2.40973 8.71569 2.21799 9.09202C2 9.51984 2 10.0799 2 11.2V18.8C2 19.9201 2 20.4802 2.21799 20.908C2.40973 21.2843 2.71569 21.5903 3.09202 21.782C3.51984 22 4.07989 22 5.2 22Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), xl = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M4 12H20M13 6C13 6.55228 12.5523 7 12 7C11.4477 7 11 6.55228 11 6C11 5.44772 11.4477 5 12 5C12.5523 5 13 5.44772 13 6ZM13 18C13 18.5523 12.5523 19 12 19C11.4477 19 11 18.5523 11 18C11 17.4477 11.4477 17 12 17C12.5523 17 13 17.4477 13 18Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Sl = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M4 12H20M14 6C14 7.10457 13.1046 8 12 8C10.8954 8 10 7.10457 10 6C10 4.89543 10.8954 4 12 4C13.1046 4 14 4.89543 14 6ZM14 18C14 19.1046 13.1046 20 12 20C10.8954 20 10 19.1046 10 18C10 16.8954 10.8954 16 12 16C13.1046 16 14 16.8954 14 18Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Cl = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 8H12.01M12 16H12.01M7 12H17M12.5 8C12.5 8.27614 12.2761 8.5 12 8.5C11.7239 8.5 11.5 8.27614 11.5 8C11.5 7.72386 11.7239 7.5 12 7.5C12.2761 7.5 12.5 7.72386 12.5 8ZM12.5 16C12.5 16.2761 12.2761 16.5 12 16.5C11.7239 16.5 11.5 16.2761 11.5 16C11.5 15.7239 11.7239 15.5 12 15.5C12.2761 15.5 12.5 15.7239 12.5 16ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), wl = (e) => /* @__PURE__ */ o("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ a("path", {
			d: "M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z",
			stroke: "black",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ a("path", {
			d: "M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z",
			stroke: "black",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ a("path", {
			d: "M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z",
			stroke: "black",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ a("path", {
			d: "M19 6C19.5523 6 20 5.55228 20 5C20 4.44772 19.5523 4 19 4C18.4477 4 18 4.44772 18 5C18 5.55228 18.4477 6 19 6Z",
			stroke: "black",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ a("path", {
			d: "M19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13Z",
			stroke: "black",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ a("path", {
			d: "M19 20C19.5523 20 20 19.5523 20 19C20 18.4477 19.5523 18 19 18C18.4477 18 18 18.4477 18 19C18 19.5523 18.4477 20 19 20Z",
			stroke: "black",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ a("path", {
			d: "M5 6C5.55228 6 6 5.55228 6 5C6 4.44772 5.55228 4 5 4C4.44772 4 4 4.44772 4 5C4 5.55228 4.44772 6 5 6Z",
			stroke: "black",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ a("path", {
			d: "M5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13Z",
			stroke: "black",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ a("path", {
			d: "M5 20C5.55228 20 6 19.5523 6 19C6 18.4477 5.55228 18 5 18C4.44772 18 4 18.4477 4 19C4 19.5523 4.44772 20 5 20Z",
			stroke: "black",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
}), Tl = (e) => /* @__PURE__ */ o("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ a("path", {
			d: "M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z",
			stroke: "black",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ a("path", {
			d: "M19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13Z",
			stroke: "black",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ a("path", {
			d: "M5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13Z",
			stroke: "black",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
}), El = (e) => /* @__PURE__ */ o("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ a("path", {
			d: "M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z",
			stroke: "black",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ a("path", {
			d: "M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z",
			stroke: "black",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ a("path", {
			d: "M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z",
			stroke: "black",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
}), Dl = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M21 15V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V15M17 10L12 15M12 15L7 10M12 15V3",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ol = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M21 21H3M18 11L12 17M12 17L6 11M12 17V3",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), kl = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M8 12L12 16M12 16L16 12M12 16V8M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Al = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M8 12L12 16M12 16L16 12M12 16V6.8C12 5.40929 12 4.71394 11.4495 3.9354C11.0837 3.41812 10.0306 2.77968 9.40278 2.69462C8.45789 2.5666 8.09907 2.75378 7.38143 3.12814C4.18333 4.79643 2 8.14324 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 8.29859 19.989 5.06687 17 3.33782",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), jl = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M4 16.2422C2.79401 15.435 2 14.0602 2 12.5C2 10.1564 3.79151 8.23129 6.07974 8.01937C6.54781 5.17213 9.02024 3 12 3C14.9798 3 17.4522 5.17213 17.9203 8.01937C20.2085 8.23129 22 10.1564 22 12.5C22 14.0602 21.206 15.435 20 16.2422M8 17L12 21M12 21L16 17M12 21V12",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ml = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M8 17L12 21M12 21L16 17M12 21V12M20 16.7428C21.2215 15.734 22 14.2079 22 12.5C22 9.46243 19.5376 7 16.5 7C16.2815 7 16.0771 6.886 15.9661 6.69774C14.6621 4.48484 12.2544 3 9.5 3C5.35786 3 2 6.35786 2 10.5C2 12.5661 2.83545 14.4371 4.18695 15.7935",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Nl = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M2.87601 18.1156C2.92195 17.7021 2.94493 17.4954 3.00748 17.3022C3.06298 17.1307 3.1414 16.9676 3.24061 16.8171C3.35242 16.6475 3.49952 16.5005 3.7937 16.2063L17 3C18.1046 1.89543 19.8954 1.89543 21 3C22.1046 4.10457 22.1046 5.89543 21 7L7.7937 20.2063C7.49951 20.5005 7.35242 20.6475 7.18286 20.7594C7.03242 20.8586 6.86926 20.937 6.69782 20.9925C6.50457 21.055 6.29783 21.078 5.88434 21.124L2.49997 21.5L2.87601 18.1156Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Pl = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M18 10L14 6M2.49997 21.5L5.88434 21.124C6.29783 21.078 6.50457 21.055 6.69782 20.9925C6.86926 20.937 7.03242 20.8586 7.18286 20.7594C7.35242 20.6475 7.49951 20.5005 7.7937 20.2063L21 7C22.1046 5.89543 22.1046 4.10457 21 3C19.8954 1.89543 18.1046 1.89543 17 3L3.7937 16.2063C3.49952 16.5005 3.35242 16.6475 3.24061 16.8171C3.1414 16.9676 3.06298 17.1307 3.00748 17.3022C2.94493 17.4954 2.92195 17.7021 2.87601 18.1156L2.49997 21.5Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Fl = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 20H21M3.00003 20H4.67457C5.16376 20 5.40835 20 5.63852 19.9447C5.84259 19.8957 6.03768 19.8149 6.21663 19.7053C6.41846 19.5816 6.59141 19.4086 6.93732 19.0627L19.5001 6.49998C20.3285 5.67156 20.3285 4.32841 19.5001 3.49998C18.6716 2.67156 17.3285 2.67156 16.5001 3.49998L3.93729 16.0627C3.59139 16.4086 3.41843 16.5816 3.29475 16.7834C3.18509 16.9624 3.10428 17.1574 3.05529 17.3615C3.00003 17.5917 3.00003 17.8363 3.00003 18.3255V20Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Il = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M21 18L19.9999 19.094C19.4695 19.6741 18.7502 20 18.0002 20C17.2501 20 16.5308 19.6741 16.0004 19.094C15.4693 18.5151 14.75 18.1901 14.0002 18.1901C13.2504 18.1901 12.5312 18.5151 12 19.094M3.00003 20H4.67457C5.16376 20 5.40835 20 5.63852 19.9447C5.84259 19.8957 6.03768 19.8149 6.21663 19.7053C6.41846 19.5816 6.59141 19.4086 6.93732 19.0627L19.5001 6.49998C20.3285 5.67156 20.3285 4.32841 19.5001 3.49998C18.6716 2.67156 17.3285 2.67156 16.5001 3.49998L3.93729 16.0627C3.59139 16.4086 3.41843 16.5816 3.29475 16.7834C3.18509 16.9624 3.10428 17.1574 3.05529 17.3615C3.00003 17.5917 3.00003 17.8363 3.00003 18.3255V20Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ll = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M11 3.99998H6.8C5.11984 3.99998 4.27976 3.99998 3.63803 4.32696C3.07354 4.61458 2.6146 5.07353 2.32698 5.63801C2 6.27975 2 7.11983 2 8.79998V17.2C2 18.8801 2 19.7202 2.32698 20.362C2.6146 20.9264 3.07354 21.3854 3.63803 21.673C4.27976 22 5.11984 22 6.8 22H15.2C16.8802 22 17.7202 22 18.362 21.673C18.9265 21.3854 19.3854 20.9264 19.673 20.362C20 19.7202 20 18.8801 20 17.2V13M7.99997 16H9.67452C10.1637 16 10.4083 16 10.6385 15.9447C10.8425 15.8957 11.0376 15.8149 11.2166 15.7053C11.4184 15.5816 11.5914 15.4086 11.9373 15.0627L21.5 5.49998C22.3284 4.67156 22.3284 3.32841 21.5 2.49998C20.6716 1.67156 19.3284 1.67155 18.5 2.49998L8.93723 12.0627C8.59133 12.4086 8.41838 12.5816 8.29469 12.7834C8.18504 12.9624 8.10423 13.1574 8.05523 13.3615C7.99997 13.5917 7.99997 13.8363 7.99997 14.3255V16Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Rl = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M5 9H19M5 15H19",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), zl = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M5 9H19M5 15H19M19 5L5 19",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Bl = (e) => /* @__PURE__ */ o("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ a("path", {
		d: "M2.42012 12.7132C2.28394 12.4975 2.21584 12.3897 2.17772 12.2234C2.14909 12.0985 2.14909 11.9015 2.17772 11.7766C2.21584 11.6103 2.28394 11.5025 2.42012 11.2868C3.54553 9.50484 6.8954 5 12.0004 5C17.1054 5 20.4553 9.50484 21.5807 11.2868C21.7169 11.5025 21.785 11.6103 21.8231 11.7766C21.8517 11.9015 21.8517 12.0985 21.8231 12.2234C21.785 12.3897 21.7169 12.4975 21.5807 12.7132C20.4553 14.4952 17.1054 19 12.0004 19C6.8954 19 3.54553 14.4952 2.42012 12.7132Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ a("path", {
		d: "M12.0004 15C13.6573 15 15.0004 13.6569 15.0004 12C15.0004 10.3431 13.6573 9 12.0004 9C10.3435 9 9.0004 10.3431 9.0004 12C9.0004 13.6569 10.3435 15 12.0004 15Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
}), Vl = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M10.7429 5.09232C11.1494 5.03223 11.5686 5 12.0004 5C17.1054 5 20.4553 9.50484 21.5807 11.2868C21.7169 11.5025 21.785 11.6103 21.8231 11.7767C21.8518 11.9016 21.8517 12.0987 21.8231 12.2236C21.7849 12.3899 21.7164 12.4985 21.5792 12.7156C21.2793 13.1901 20.8222 13.8571 20.2165 14.5805M6.72432 6.71504C4.56225 8.1817 3.09445 10.2194 2.42111 11.2853C2.28428 11.5019 2.21587 11.6102 2.17774 11.7765C2.1491 11.9014 2.14909 12.0984 2.17771 12.2234C2.21583 12.3897 2.28393 12.4975 2.42013 12.7132C3.54554 14.4952 6.89541 19 12.0004 19C14.0588 19 15.8319 18.2676 17.2888 17.2766M3.00042 3L21.0004 21M9.8791 9.87868C9.3362 10.4216 9.00042 11.1716 9.00042 12C9.00042 13.6569 10.3436 15 12.0004 15C12.8288 15 13.5788 14.6642 14.1217 14.1213",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Hl = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M2 4.6C2 4.03995 2 3.75992 2.10899 3.54601C2.20487 3.35785 2.35785 3.20487 2.54601 3.10899C2.75992 3 3.03995 3 3.6 3H20.4C20.9601 3 21.2401 3 21.454 3.10899C21.6422 3.20487 21.7951 3.35785 21.891 3.54601C22 3.75992 22 4.03995 22 4.6V5.26939C22 5.53819 22 5.67259 21.9672 5.79756C21.938 5.90831 21.8901 6.01323 21.8255 6.10776C21.7526 6.21443 21.651 6.30245 21.4479 6.4785L15.0521 12.0215C14.849 12.1975 14.7474 12.2856 14.6745 12.3922C14.6099 12.4868 14.562 12.5917 14.5328 12.7024C14.5 12.8274 14.5 12.9618 14.5 13.2306V18.4584C14.5 18.6539 14.5 18.7517 14.4685 18.8363C14.4406 18.911 14.3953 18.9779 14.3363 19.0315C14.2695 19.0922 14.1787 19.1285 13.9971 19.2012L10.5971 20.5612C10.2296 20.7082 10.0458 20.7817 9.89827 20.751C9.76927 20.7242 9.65605 20.6476 9.58325 20.5377C9.5 20.4122 9.5 20.2142 9.5 19.8184V13.2306C9.5 12.9618 9.5 12.8274 9.46715 12.7024C9.43805 12.5917 9.39014 12.4868 9.32551 12.3922C9.25258 12.2856 9.15102 12.1975 8.94789 12.0215L2.55211 6.4785C2.34898 6.30245 2.24742 6.21443 2.17449 6.10776C2.10986 6.01323 2.06195 5.90831 2.03285 5.79756C2 5.67259 2 5.53819 2 5.26939V4.6Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ul = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M3.38589 5.66687C2.62955 4.82155 2.25138 4.39889 2.23712 4.03968C2.22473 3.72764 2.35882 3.42772 2.59963 3.22889C2.87684 3 3.44399 3 4.57828 3H19.4212C20.5555 3 21.1227 3 21.3999 3.22889C21.6407 3.42772 21.7748 3.72764 21.7624 4.03968C21.7481 4.39889 21.3699 4.82155 20.6136 5.66687L14.9074 12.0444C14.7566 12.2129 14.6812 12.2972 14.6275 12.3931C14.5798 12.4781 14.5448 12.5697 14.5236 12.6648C14.4997 12.7721 14.4997 12.8852 14.4997 13.1113V18.4584C14.4997 18.6539 14.4997 18.7517 14.4682 18.8363C14.4403 18.911 14.395 18.9779 14.336 19.0315C14.2692 19.0922 14.1784 19.1285 13.9969 19.2012L10.5969 20.5612C10.2293 20.7082 10.0455 20.7817 9.89802 20.751C9.76901 20.7242 9.6558 20.6476 9.583 20.5377C9.49975 20.4122 9.49975 20.2142 9.49975 19.8184V13.1113C9.49975 12.8852 9.49975 12.7721 9.47587 12.6648C9.45469 12.5697 9.41971 12.4781 9.37204 12.3931C9.31828 12.2972 9.2429 12.2129 9.09213 12.0444L3.38589 5.66687Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Wl = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M6 12H18M3 6H21M9 18H15",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Gl = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8ZM12 8H21.17M3.95 6.06L8.54 14M10.88 21.94L15.46 14M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Kl = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M4 8H20M4 16H20M8 3V21M16 3V21",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ql = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9.49999 3L6.49999 21M17.5 3L14.5 21M20.5 8H3.5M19.5 16H2.5",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Jl = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.9932 5.13581C9.9938 2.7984 6.65975 2.16964 4.15469 4.31001C1.64964 6.45038 1.29697 10.029 3.2642 12.5604C4.89982 14.6651 9.84977 19.1041 11.4721 20.5408C11.6536 20.7016 11.7444 20.7819 11.8502 20.8135C11.9426 20.8411 12.0437 20.8411 12.1361 20.8135C12.2419 20.7819 12.3327 20.7016 12.5142 20.5408C14.1365 19.1041 19.0865 14.6651 20.7221 12.5604C22.6893 10.029 22.3797 6.42787 19.8316 4.31001C17.2835 2.19216 13.9925 2.7984 11.9932 5.13581Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Yl = (e) => /* @__PURE__ */ o("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ a("path", {
		d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ a("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.9966 9.06791C10.9969 7.8992 9.32987 7.58482 8.07735 8.65501C6.82482 9.72519 6.64848 11.5145 7.6321 12.7802C8.26211 13.5909 9.87558 15.0942 10.9542 16.0704C11.3127 16.3947 11.4919 16.5569 11.7066 16.622C11.8911 16.6779 12.102 16.6779 12.2866 16.622C12.5012 16.5569 12.6805 16.3947 13.0389 16.0704C14.1176 15.0942 15.731 13.5909 16.3611 12.7802C17.3447 11.5145 17.1899 9.71393 15.9158 8.65501C14.6417 7.59608 12.9963 7.8992 11.9966 9.06791Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
}), Xl = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M6 20.0872H8.61029C8.95063 20.0872 9.28888 20.1277 9.61881 20.2087L12.3769 20.8789C12.9753 21.0247 13.5988 21.0389 14.2035 20.9214L17.253 20.3281C18.0585 20.1712 18.7996 19.7855 19.3803 19.2205L21.5379 17.1217C22.154 16.5234 22.154 15.5524 21.5379 14.9531C20.9832 14.4135 20.1047 14.3527 19.4771 14.8103L16.9626 16.6449C16.6025 16.9081 16.1643 17.0498 15.7137 17.0498H13.2855L14.8311 17.0498C15.7022 17.0498 16.4079 16.3633 16.4079 15.5159V15.2092C16.4079 14.5055 15.9156 13.892 15.2141 13.7219L12.8286 13.1418C12.4404 13.0476 12.0428 13 11.6431 13C10.6783 13 8.93189 13.7988 8.93189 13.7988L6 15.0249M2 14.6L2 20.4C2 20.9601 2 21.2401 2.10899 21.454C2.20487 21.6422 2.35785 21.7951 2.54601 21.891C2.75992 22 3.03995 22 3.6 22H4.4C4.96005 22 5.24008 22 5.45399 21.891C5.64215 21.7952 5.79513 21.6422 5.89101 21.454C6 21.2401 6 20.9601 6 20.4V14.6C6 14.04 6 13.7599 5.89101 13.546C5.79513 13.3579 5.64215 13.2049 5.45399 13.109C5.24008 13 4.96005 13 4.4 13H3.6C3.03995 13 2.75992 13 2.54601 13.109C2.35785 13.2049 2.20487 13.3579 2.10899 13.546C2 13.7599 2 14.04 2 14.6ZM17.1914 3.59227C16.5946 2.34341 15.2186 1.6818 13.8804 2.32039C12.5423 2.95898 11.9722 4.4734 12.5325 5.80284C12.8787 6.62448 13.8707 8.22002 14.5781 9.31905C14.8394 9.72513 14.9701 9.92817 15.161 10.0469C15.3247 10.1488 15.5297 10.2037 15.7224 10.1974C15.9471 10.1899 16.1618 10.0794 16.5911 9.85845C17.7532 9.26033 19.4101 8.37457 20.1208 7.83614C21.2707 6.96494 21.5556 5.36359 20.6947 4.14626C19.8337 2.92892 18.3327 2.80914 17.1914 3.59227Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Zl = (e) => /* @__PURE__ */ o("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ a("path", {
		d: "M7.39137 2.46863C7.56432 2.29568 7.6508 2.2092 7.75172 2.14736C7.84119 2.09253 7.93873 2.05213 8.04077 2.02763C8.15586 2 8.27815 2 8.52274 2H15.4773C15.7218 2 15.8441 2 15.9592 2.02763C16.0613 2.05213 16.1588 2.09253 16.2483 2.14736C16.3492 2.2092 16.4357 2.29568 16.6086 2.46863L21.5314 7.39137C21.7043 7.56432 21.7908 7.6508 21.8526 7.75172C21.9075 7.84119 21.9479 7.93873 21.9724 8.04077C22 8.15586 22 8.27815 22 8.52274V15.4773C22 15.7218 22 15.8441 21.9724 15.9592C21.9479 16.0613 21.9075 16.1588 21.8526 16.2483C21.7908 16.3492 21.7043 16.4357 21.5314 16.6086L16.6086 21.5314C16.4357 21.7043 16.3492 21.7908 16.2483 21.8526C16.1588 21.9075 16.0613 21.9479 15.9592 21.9724C15.8441 22 15.7218 22 15.4773 22H8.52274C8.27815 22 8.15586 22 8.04077 21.9724C7.93873 21.9479 7.84119 21.9075 7.75172 21.8526C7.6508 21.7908 7.56432 21.7043 7.39137 21.5314L2.46863 16.6086C2.29568 16.4357 2.2092 16.3492 2.14736 16.2483C2.09253 16.1588 2.05213 16.0613 2.02763 15.9592C2 15.8441 2 15.7218 2 15.4773V8.52274C2 8.27815 2 8.15586 2.02763 8.04077C2.05213 7.93873 2.09253 7.84119 2.14736 7.75172C2.2092 7.6508 2.29568 7.56432 2.46863 7.39137L7.39137 2.46863Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ a("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.9966 9.06791C10.9969 7.8992 9.32987 7.58482 8.07735 8.65501C6.82482 9.72519 6.64848 11.5145 7.6321 12.7802C8.26211 13.5909 9.87558 15.0942 10.9542 16.0704C11.3127 16.3947 11.4919 16.5569 11.7066 16.622C11.8911 16.6779 12.102 16.6779 12.2866 16.622C12.5012 16.5569 12.6805 16.3947 13.0389 16.0704C14.1176 15.0942 15.731 13.5909 16.3611 12.7802C17.3447 11.5145 17.1899 9.71393 15.9158 8.65501C14.6417 7.59608 12.9963 7.8992 11.9966 9.06791Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
}), Ql = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M16.1111 3C19.6333 3 22 6.3525 22 9.48C22 15.8138 12.1778 21 12 21C11.8222 21 2 15.8138 2 9.48C2 6.3525 4.36667 3 7.88889 3C9.91111 3 11.2333 4.02375 12 4.92375C12.7667 4.02375 14.0889 3 16.1111 3Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), $l = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M15.5455 9.92543C15.9195 9.26103 16.2313 8.66151 16.4236 8.20521C17.3573 5.98947 16.434 3.44077 14.1769 2.40112C11.9199 1.36148 9.65341 2.4395 8.65871 4.52093C6.75657 3.2157 4.21918 3.40739 2.81989 5.44424C1.42059 7.48108 1.85975 10.142 3.77629 11.594C4.6461 12.253 6.36636 13.2242 7.98596 14.0884M16.2972 11.7499C15.8751 9.482 13.9454 7.82334 11.5156 8.27415C9.08592 8.72497 7.51488 10.9171 7.84335 13.299C8.10725 15.2127 9.56392 19.7027 10.1264 21.394C10.2032 21.6248 10.2415 21.7402 10.3175 21.8206C10.3837 21.8907 10.4717 21.9416 10.5655 21.9638C10.6732 21.9894 10.7923 21.9649 11.0306 21.916C12.7765 21.5575 17.3933 20.574 19.1826 19.8457C21.4096 18.9392 22.5589 16.4841 21.6981 14.153C20.8372 11.8219 18.4723 10.9815 16.2972 11.7499Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), eu = (e) => /* @__PURE__ */ o("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ a("path", {
		d: "M3 7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ a("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.9966 9.06791C10.9969 7.8992 9.32987 7.58482 8.07735 8.65501C6.82482 9.72519 6.64848 11.5145 7.6321 12.7802C8.26211 13.5909 9.87558 15.0942 10.9542 16.0704C11.3127 16.3947 11.4919 16.5569 11.7066 16.622C11.8911 16.6779 12.102 16.6779 12.2866 16.622C12.5012 16.5569 12.6805 16.3947 13.0389 16.0704C14.1176 15.0942 15.731 13.5909 16.3611 12.7802C17.3447 11.5145 17.1899 9.71393 15.9158 8.65501C14.6417 7.59608 12.9963 7.8992 11.9966 9.06791Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
}), tu = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9.09 9C9.3251 8.33167 9.78915 7.76811 10.4 7.40913C11.0108 7.05016 11.7289 6.91894 12.4272 7.03871C13.1255 7.15849 13.7588 7.52152 14.2151 8.06353C14.6713 8.60553 14.9211 9.29152 14.92 10C14.92 12 11.92 13 11.92 13M12 17H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), nu = (e) => /* @__PURE__ */ o("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ a("path", {
		d: "M11.223 2.43164C11.5066 2.27409 11.6484 2.19531 11.7985 2.16442C11.9315 2.13709 12.0685 2.13709 12.2015 2.16442C12.3516 2.19531 12.4934 2.27409 12.777 2.43164L20.177 6.54276C20.4766 6.70916 20.6263 6.79236 20.7354 6.9107C20.8318 7.01539 20.9049 7.13947 20.9495 7.27464C21 7.42744 21 7.59876 21 7.94141V16.0585C21 16.4012 21 16.5725 20.9495 16.7253C20.9049 16.8605 20.8318 16.9845 20.7354 17.0892C20.6263 17.2076 20.4766 17.2908 20.177 17.4572L12.777 21.5683C12.4934 21.7258 12.3516 21.8046 12.2015 21.8355C12.0685 21.8628 11.9315 21.8628 11.7985 21.8355C11.6484 21.8046 11.5066 21.7258 11.223 21.5683L3.82297 17.4572C3.52345 17.2908 3.37369 17.2076 3.26463 17.0892C3.16816 16.9845 3.09515 16.8605 3.05048 16.7253C3 16.5725 3 16.4012 3 16.0585V7.94141C3 7.59876 3 7.42744 3.05048 7.27464C3.09515 7.13947 3.16816 7.01539 3.26463 6.9107C3.37369 6.79236 3.52345 6.70916 3.82297 6.54276L11.223 2.43164Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ a("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.9966 9.06787C10.9969 7.89916 9.32987 7.58478 8.07735 8.65497C6.82482 9.72515 6.64848 11.5145 7.6321 12.7802C8.26211 13.5909 9.87558 15.0942 10.9542 16.0703C11.3127 16.3947 11.4919 16.5569 11.7066 16.6219C11.8911 16.6779 12.102 16.6779 12.2866 16.6219C12.5012 16.5569 12.6805 16.3947 13.0389 16.0703C14.1176 15.0942 15.731 13.5909 16.3611 12.7802C17.3447 11.5145 17.1899 9.7139 15.9158 8.65497C14.6417 7.59604 12.9963 7.89916 11.9966 9.06787Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
}), ru = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9.08997 8.99995C9.32507 8.33162 9.78912 7.76806 10.3999 7.40908C11.0107 7.05011 11.7289 6.91889 12.4271 7.03866C13.1254 7.15844 13.7588 7.52148 14.215 8.06348C14.6713 8.60548 14.921 9.29147 14.92 9.99995C14.92 12 11.92 13 11.92 13M12 17H12.01M3 7.94141V16.0585C3 16.4012 3 16.5725 3.05048 16.7253C3.09515 16.8605 3.16816 16.9845 3.26463 17.0892C3.37369 17.2076 3.52345 17.2908 3.82297 17.4572L11.223 21.5683C11.5066 21.7258 11.6484 21.8046 11.7985 21.8355C11.9315 21.8628 12.0685 21.8628 12.2015 21.8355C12.3516 21.8046 12.4934 21.7258 12.777 21.5683L20.177 17.4572C20.4766 17.2908 20.6263 17.2076 20.7354 17.0892C20.8318 16.9845 20.9049 16.8605 20.9495 16.7253C21 16.5725 21 16.4012 21 16.0585V7.94141C21 7.59876 21 7.42744 20.9495 7.27464C20.9049 7.13947 20.8318 7.01539 20.7354 6.9107C20.6263 6.79236 20.4766 6.70916 20.177 6.54276L12.777 2.43164C12.4934 2.27409 12.3516 2.19531 12.2015 2.16442C12.0685 2.13709 11.9315 2.13709 11.7985 2.16442C11.6484 2.19531 11.5066 2.27409 11.223 2.43164L3.82297 6.54276C3.52345 6.70916 3.37369 6.79236 3.26463 6.9107C3.16816 7.01539 3.09515 7.13947 3.05048 7.27464C3 7.42744 3 7.59876 3 7.94141Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), iu = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9.08997 8.99999C9.32507 8.33166 9.78912 7.7681 10.3999 7.40912C11.0107 7.05015 11.7289 6.91893 12.4271 7.0387C13.1254 7.15848 13.7588 7.52151 14.215 8.06352C14.6713 8.60552 14.921 9.29151 14.92 9.99999C14.92 12 11.92 13 11.92 13M12 17H12.01M2 8.52274V15.4773C2 15.7218 2 15.8441 2.02763 15.9592C2.05213 16.0613 2.09253 16.1588 2.14736 16.2483C2.2092 16.3492 2.29568 16.4357 2.46863 16.6086L7.39137 21.5314C7.56432 21.7043 7.6508 21.7908 7.75172 21.8526C7.84119 21.9075 7.93873 21.9479 8.04077 21.9724C8.15586 22 8.27815 22 8.52274 22H15.4773C15.7218 22 15.8441 22 15.9592 21.9724C16.0613 21.9479 16.1588 21.9075 16.2483 21.8526C16.3492 21.7908 16.4357 21.7043 16.6086 21.5314L21.5314 16.6086C21.7043 16.4357 21.7908 16.3492 21.8526 16.2483C21.9075 16.1588 21.9479 16.0613 21.9724 15.9592C22 15.8441 22 15.7218 22 15.4773V8.52274C22 8.27815 22 8.15586 21.9724 8.04077C21.9479 7.93873 21.9075 7.84119 21.8526 7.75172C21.7908 7.6508 21.7043 7.56432 21.5314 7.39137L16.6086 2.46863C16.4357 2.29568 16.3492 2.2092 16.2483 2.14736C16.1588 2.09253 16.0613 2.05213 15.9592 2.02763C15.8441 2 15.7218 2 15.4773 2H8.52274C8.27815 2 8.15586 2 8.04077 2.02763C7.93873 2.05213 7.84119 2.09253 7.75172 2.14736C7.6508 2.2092 7.56432 2.29568 7.39137 2.46863L2.46863 7.39137C2.29568 7.56432 2.2092 7.6508 2.14736 7.75172C2.09253 7.84119 2.05213 7.93873 2.02763 8.04077C2 8.15586 2 8.27815 2 8.52274Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), au = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9.09 9C9.3251 8.33167 9.78915 7.76811 10.4 7.40913C11.0108 7.05016 11.7289 6.91894 12.4272 7.03871C13.1255 7.15849 13.7588 7.52152 14.2151 8.06353C14.6713 8.60553 14.9211 9.29152 14.92 10C14.92 12 11.92 13 11.92 13M12 17H12.01M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ou = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M3 10.5651C3 9.9907 3 9.70352 3.07403 9.43905C3.1396 9.20478 3.24737 8.98444 3.39203 8.78886C3.55534 8.56806 3.78202 8.39175 4.23539 8.03912L11.0177 2.764C11.369 2.49075 11.5447 2.35412 11.7387 2.3016C11.9098 2.25526 12.0902 2.25526 12.2613 2.3016C12.4553 2.35412 12.631 2.49075 12.9823 2.764L19.7646 8.03913C20.218 8.39175 20.4447 8.56806 20.608 8.78886C20.7526 8.98444 20.8604 9.20478 20.926 9.43905C21 9.70352 21 9.9907 21 10.5651V17.8C21 18.9201 21 19.4801 20.782 19.908C20.5903 20.2843 20.2843 20.5903 19.908 20.782C19.4802 21 18.9201 21 17.8 21H6.2C5.07989 21 4.51984 21 4.09202 20.782C3.71569 20.5903 3.40973 20.2843 3.21799 19.908C3 19.4801 3 18.9201 3 17.8V10.5651Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), su = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9 21V13.6C9 13.0399 9 12.7599 9.10899 12.546C9.20487 12.3578 9.35785 12.2049 9.54601 12.109C9.75992 12 10.0399 12 10.6 12H13.4C13.9601 12 14.2401 12 14.454 12.109C14.6422 12.2049 14.7951 12.3578 14.891 12.546C15 12.7599 15 13.0399 15 13.6V21M11.0177 2.764L4.23539 8.03912C3.78202 8.39175 3.55534 8.56806 3.39203 8.78886C3.24737 8.98444 3.1396 9.20478 3.07403 9.43905C3 9.70352 3 9.9907 3 10.5651V17.8C3 18.9201 3 19.4801 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.07989 21 6.2 21H17.8C18.9201 21 19.4802 21 19.908 20.782C20.2843 20.5903 20.5903 20.2843 20.782 19.908C21 19.4801 21 18.9201 21 17.8V10.5651C21 9.9907 21 9.70352 20.926 9.43905C20.8604 9.20478 20.7526 8.98444 20.608 8.78886C20.4447 8.56806 20.218 8.39175 19.7646 8.03913L12.9823 2.764C12.631 2.49075 12.4553 2.35412 12.2613 2.3016C12.0902 2.25526 11.9098 2.25526 11.7387 2.3016C11.5447 2.35412 11.369 2.49075 11.0177 2.764Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), cu = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9 21V13.6C9 13.0399 9 12.7599 9.109 12.546C9.20487 12.3578 9.35785 12.2049 9.54601 12.109C9.75993 12 10.04 12 10.6 12H13.4C13.9601 12 14.2401 12 14.454 12.109C14.6422 12.2049 14.7951 12.3578 14.891 12.546C15 12.7599 15 13.0399 15 13.6V21M2 9.5L11.04 2.72C11.3843 2.46181 11.5564 2.33271 11.7454 2.28294C11.9123 2.23902 12.0877 2.23902 12.2546 2.28295C12.4436 2.33271 12.6157 2.46181 12.96 2.72L22 9.5M4 8V17.8C4 18.9201 4 19.4802 4.21799 19.908C4.40974 20.2843 4.7157 20.5903 5.09202 20.782C5.51985 21 6.0799 21 7.2 21H16.8C17.9201 21 18.4802 21 18.908 20.782C19.2843 20.5903 19.5903 20.2843 19.782 19.908C20 19.4802 20 18.9201 20 17.8V8L13.92 3.44C13.2315 2.92361 12.8872 2.66542 12.5091 2.56589C12.1754 2.47804 11.8246 2.47804 11.4909 2.56589C11.1128 2.66542 10.7685 2.92361 10.08 3.44L4 8Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), lu = (e) => /* @__PURE__ */ o("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ a("path", {
		d: "M12 16C13.6569 16 15 14.6568 15 13C15 11.3431 13.6569 9.99998 12 9.99998C10.3431 9.99998 9 11.3431 9 13C9 14.6568 10.3431 16 12 16Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ a("path", {
		d: "M3 10.5651C3 9.9907 3 9.70352 3.07403 9.43905C3.1396 9.20478 3.24737 8.98444 3.39203 8.78886C3.55534 8.56806 3.78202 8.39175 4.23539 8.03912L11.0177 2.764C11.369 2.49075 11.5447 2.35412 11.7387 2.3016C11.9098 2.25526 12.0902 2.25526 12.2613 2.3016C12.4553 2.35412 12.631 2.49075 12.9823 2.764L19.7646 8.03913C20.218 8.39175 20.4447 8.56806 20.608 8.78886C20.7526 8.98444 20.8604 9.20478 20.926 9.43905C21 9.70352 21 9.9907 21 10.5651V17.8C21 18.9201 21 19.4801 20.782 19.908C20.5903 20.2843 20.2843 20.5903 19.908 20.782C19.4802 21 18.9201 21 17.8 21H6.2C5.07989 21 4.51984 21 4.09202 20.782C3.71569 20.5903 3.40973 20.2843 3.21799 19.908C3 19.4801 3 18.9201 3 17.8V10.5651Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
}), uu = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12.9823 2.764C12.631 2.49075 12.4553 2.35412 12.2613 2.3016C12.0902 2.25526 11.9098 2.25526 11.7387 2.3016C11.5447 2.35412 11.369 2.49075 11.0177 2.764L4.23539 8.03912C3.78202 8.39175 3.55534 8.56806 3.39203 8.78886C3.24737 8.98444 3.1396 9.20478 3.07403 9.43905C3 9.70352 3 9.9907 3 10.5651V17.8C3 18.9201 3 19.4801 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.0799 21 6.2 21H8.2C8.48003 21 8.62004 21 8.727 20.9455C8.82108 20.8976 8.89757 20.8211 8.9455 20.727C9 20.62 9 20.48 9 20.2V13.6C9 13.0399 9 12.7599 9.10899 12.546C9.20487 12.3578 9.35785 12.2049 9.54601 12.109C9.75992 12 10.0399 12 10.6 12H13.4C13.9601 12 14.2401 12 14.454 12.109C14.6422 12.2049 14.7951 12.3578 14.891 12.546C15 12.7599 15 13.0399 15 13.6V20.2C15 20.48 15 20.62 15.0545 20.727C15.1024 20.8211 15.1789 20.8976 15.273 20.9455C15.38 21 15.52 21 15.8 21H17.8C18.9201 21 19.4802 21 19.908 20.782C20.2843 20.5903 20.5903 20.2843 20.782 19.908C21 19.4801 21 18.9201 21 17.8V10.5651C21 9.9907 21 9.70352 20.926 9.43905C20.8604 9.20478 20.7526 8.98444 20.608 8.78886C20.4447 8.56806 20.218 8.39175 19.7646 8.03913L12.9823 2.764Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), du = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M8 17H16M11.0177 2.764L4.23539 8.03912C3.78202 8.39175 3.55534 8.56806 3.39203 8.78886C3.24737 8.98444 3.1396 9.20478 3.07403 9.43905C3 9.70352 3 9.9907 3 10.5651V17.8C3 18.9201 3 19.4801 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.07989 21 6.2 21H17.8C18.9201 21 19.4802 21 19.908 20.782C20.2843 20.5903 20.5903 20.2843 20.782 19.908C21 19.4801 21 18.9201 21 17.8V10.5651C21 9.9907 21 9.70352 20.926 9.43905C20.8604 9.20478 20.7526 8.98444 20.608 8.78886C20.4447 8.56806 20.218 8.39175 19.7646 8.03913L12.9823 2.764C12.631 2.49075 12.4553 2.35412 12.2613 2.3016C12.0902 2.25526 11.9098 2.25526 11.7387 2.3016C11.5447 2.35412 11.369 2.49075 11.0177 2.764Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), fu = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M8.12602 14C8.57006 15.7252 10.1362 17 12 17C13.8638 17 15.4299 15.7252 15.874 14M11.0177 2.764L4.23539 8.03912C3.78202 8.39175 3.55534 8.56806 3.39203 8.78886C3.24737 8.98444 3.1396 9.20478 3.07403 9.43905C3 9.70352 3 9.9907 3 10.5651V17.8C3 18.9201 3 19.4801 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.07989 21 6.2 21H17.8C18.9201 21 19.4802 21 19.908 20.782C20.2843 20.5903 20.5903 20.2843 20.782 19.908C21 19.4801 21 18.9201 21 17.8V10.5651C21 9.9907 21 9.70352 20.926 9.43905C20.8604 9.20478 20.7526 8.98444 20.608 8.78886C20.4447 8.56806 20.218 8.39175 19.7646 8.03913L12.9823 2.764C12.631 2.49075 12.4553 2.35412 12.2613 2.3016C12.0902 2.25526 11.9098 2.25526 11.7387 2.3016C11.5447 2.35412 11.369 2.49075 11.0177 2.764Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), pu = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 16V12M12 8H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), mu = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 16.0001V12.0001M12 8.00008H12.01M3 7.94153V16.0586C3 16.4013 3 16.5726 3.05048 16.7254C3.09515 16.8606 3.16816 16.9847 3.26463 17.0893C3.37369 17.2077 3.52345 17.2909 3.82297 17.4573L11.223 21.5684C11.5066 21.726 11.6484 21.8047 11.7985 21.8356C11.9315 21.863 12.0685 21.863 12.2015 21.8356C12.3516 21.8047 12.4934 21.726 12.777 21.5684L20.177 17.4573C20.4766 17.2909 20.6263 17.2077 20.7354 17.0893C20.8318 16.9847 20.9049 16.8606 20.9495 16.7254C21 16.5726 21 16.4013 21 16.0586V7.94153C21 7.59889 21 7.42756 20.9495 7.27477C20.9049 7.13959 20.8318 7.01551 20.7354 6.91082C20.6263 6.79248 20.4766 6.70928 20.177 6.54288L12.777 2.43177C12.4934 2.27421 12.3516 2.19543 12.2015 2.16454C12.0685 2.13721 11.9315 2.13721 11.7985 2.16454C11.6484 2.19543 11.5066 2.27421 11.223 2.43177L3.82297 6.54288C3.52345 6.70928 3.37369 6.79248 3.26463 6.91082C3.16816 7.01551 3.09515 7.13959 3.05048 7.27477C3 7.42756 3 7.59889 3 7.94153Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), hu = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 16V12M12 8H12.01M2 8.52274V15.4773C2 15.7218 2 15.8441 2.02763 15.9592C2.05213 16.0613 2.09253 16.1588 2.14736 16.2483C2.2092 16.3492 2.29568 16.4357 2.46863 16.6086L7.39137 21.5314C7.56432 21.7043 7.6508 21.7908 7.75172 21.8526C7.84119 21.9075 7.93873 21.9479 8.04077 21.9724C8.15586 22 8.27815 22 8.52274 22H15.4773C15.7218 22 15.8441 22 15.9592 21.9724C16.0613 21.9479 16.1588 21.9075 16.2483 21.8526C16.3492 21.7908 16.4357 21.7043 16.6086 21.5314L21.5314 16.6086C21.7043 16.4357 21.7908 16.3492 21.8526 16.2483C21.9075 16.1588 21.9479 16.0613 21.9724 15.9592C22 15.8441 22 15.7218 22 15.4773V8.52274C22 8.27815 22 8.15586 21.9724 8.04077C21.9479 7.93873 21.9075 7.84119 21.8526 7.75172C21.7908 7.6508 21.7043 7.56432 21.5314 7.39137L16.6086 2.46863C16.4357 2.29568 16.3492 2.2092 16.2483 2.14736C16.1588 2.09253 16.0613 2.05213 15.9592 2.02763C15.8441 2 15.7218 2 15.4773 2H8.52274C8.27815 2 8.15586 2 8.04077 2.02763C7.93873 2.05213 7.84119 2.09253 7.75172 2.14736C7.6508 2.2092 7.56432 2.29568 7.39137 2.46863L2.46863 7.39137C2.29568 7.56432 2.2092 7.6508 2.14736 7.75172C2.09253 7.84119 2.05213 7.93873 2.02763 8.04077C2 8.15586 2 8.27815 2 8.52274Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), gu = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 16V12M12 8H12.01M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), _u = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M2 14.5001L11.6422 19.3212C11.7734 19.3868 11.839 19.4196 11.9078 19.4325C11.9687 19.4439 12.0313 19.4439 12.0922 19.4325C12.161 19.4196 12.2266 19.3868 12.3578 19.3212L22 14.5001M2 9.50006L11.6422 4.67895C11.7734 4.61336 11.839 4.58056 11.9078 4.56766C11.9687 4.55622 12.0313 4.55622 12.0922 4.56766C12.161 4.58056 12.2266 4.61336 12.3578 4.67895L22 9.50006L12.3578 14.3212C12.2266 14.3868 12.161 14.4196 12.0922 14.4325C12.0313 14.4439 11.9687 14.4439 11.9078 14.4325C11.839 14.4196 11.7734 14.3868 11.6422 14.3212L2 9.50006Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), vu = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9.13626 9.13628L4.92893 4.92896M4.92893 19.0711L9.16797 14.8321M14.8611 14.8638L19.0684 19.0711M19.0684 4.92896L14.8287 9.16862M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), yu = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M8.46445 8.46448L4.92893 4.92896M4.92893 19.0711L8.46448 15.5355M15.5355 15.5355L19.0711 19.071M19.0711 4.92891L15.5355 8.46445M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), bu = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12.7076 18.3639L11.2933 19.7781C9.34072 21.7308 6.1749 21.7308 4.22228 19.7781C2.26966 17.8255 2.26966 14.6597 4.22228 12.7071L5.63649 11.2929M18.3644 12.7071L19.7786 11.2929C21.7312 9.34024 21.7312 6.17441 19.7786 4.22179C17.826 2.26917 14.6602 2.26917 12.7076 4.22179L11.2933 5.636M8.50045 15.4999L15.5005 8.49994",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), xu = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9 17H7C4.23858 17 2 14.7614 2 12C2 9.23858 4.23858 7 7 7H9M15 17H17C19.7614 17 22 14.7614 22 12C22 9.23858 19.7614 7 17 7H15M7 12L17 12",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Su = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9.99999 13C10.4294 13.5741 10.9773 14.0491 11.6065 14.3929C12.2357 14.7367 12.9315 14.9411 13.6466 14.9923C14.3618 15.0435 15.0796 14.9403 15.7513 14.6897C16.4231 14.4392 17.0331 14.047 17.54 13.54L20.54 10.54C21.4508 9.59695 21.9547 8.33394 21.9434 7.02296C21.932 5.71198 21.4061 4.45791 20.4791 3.53087C19.552 2.60383 18.298 2.07799 16.987 2.0666C15.676 2.0552 14.413 2.55918 13.47 3.46997L11.75 5.17997M14 11C13.5705 10.4258 13.0226 9.95078 12.3934 9.60703C11.7642 9.26327 11.0685 9.05885 10.3533 9.00763C9.63819 8.95641 8.9204 9.0596 8.24864 9.31018C7.57688 9.56077 6.96687 9.9529 6.45999 10.46L3.45999 13.46C2.5492 14.403 2.04522 15.666 2.05662 16.977C2.06801 18.288 2.59385 19.542 3.52089 20.4691C4.44793 21.3961 5.702 21.9219 7.01298 21.9333C8.32396 21.9447 9.58697 21.4408 10.53 20.53L12.24 18.82",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Cu = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M7.5 7H7C4.23858 7 2 9.23858 2 12C2 14.7614 4.23858 17 7 17H9C11.7614 17 14 14.7614 14 12M16.5 17H17C19.7614 17 22 14.7614 22 12C22 9.23858 19.7614 7 17 7H15C12.2386 7 10 9.23858 10 12",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), wu = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9 17H7C4.23858 17 2 14.7614 2 12C2 9.23858 4.23858 7 7 7H9M8 12L18 12M15.7778 17H17C19.7614 17 22 14.7614 22 12C22 9.23858 19.7614 7 17 7H15.7778C15.3482 7 15 7.34822 15 7.77778V16.2222C15 16.6518 15.3482 17 15.7778 17Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Tu = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9 4V2M15 20V22M4 9H2M20 15H22M4.91421 4.91421L3.5 3.5M19.0858 19.0858L20.5 20.5M12 17.6569L9.87868 19.7782C8.31658 21.3403 5.78392 21.3403 4.22183 19.7782C2.65973 18.2161 2.65973 15.6834 4.22183 14.1213L6.34315 12M17.6569 12L19.7782 9.87868C21.3403 8.31658 21.3403 5.78392 19.7782 4.22183C18.2161 2.65973 15.6834 2.65973 14.1213 4.22183L12 6.34315",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Eu = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M8.5 15.5L15.5 8.49998M9 4V2M15 20V22M4 9H2M20 15H22M4.91421 4.91421L3.5 3.5M19.0858 19.0857L20.5 20.4999M12 17.6568L9.87871 19.7781C8.31662 21.3402 5.78396 21.3402 4.22186 19.7781C2.65976 18.216 2.65976 15.6833 4.22186 14.1212L6.34318 11.9999M17.6569 11.9999L19.7782 9.87859C21.3403 8.31649 21.3403 5.78383 19.7782 4.22174C18.2161 2.65964 15.6835 2.65964 14.1214 4.22174L12 6.34306",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Du = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M21 9L21 3M21 3H15M21 3L13 11M10 5H7.8C6.11984 5 5.27976 5 4.63803 5.32698C4.07354 5.6146 3.6146 6.07354 3.32698 6.63803C3 7.27976 3 8.11984 3 9.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H14.2C15.8802 21 16.7202 21 17.362 20.673C17.9265 20.3854 18.3854 19.9265 18.673 19.362C19 18.7202 19 17.8802 19 16.2V14",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ou = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M21 9.00001L21 3.00001M21 3.00001H15M21 3.00001L12 12M10 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V14",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ku = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 2.25V4.75M12 18V22M5.75 12H2.25M21.25 12H19.75M18.4571 18.4571L17.75 17.75M18.6642 5.41579L17.25 6.83M4.92157 19.0784L7.75 16.25M5.12868 5.20868L7.25 7.33",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Au = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 2V6M12 18V22M6 12H2M22 12H18M19.0784 19.0784L16.25 16.25M19.0784 4.99994L16.25 7.82837M4.92157 19.0784L7.75 16.25M4.92157 4.99994L7.75 7.82837",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ju = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M3.34025 16.9997C2.0881 14.8298 2.72473 12.0644 4.79795 10.6601L4.80018 10.6578C6.46564 9.53235 8.65775 9.57012 10.2843 10.7523L13.7164 13.2477C15.3418 14.4299 17.5339 14.4676 19.2005 13.3421L19.2027 13.3399C21.2771 11.9356 21.9148 9.16792 20.6604 7.00026M17.002 20.6593C14.8321 21.9114 12.0667 21.2748 10.6623 19.2016L10.6601 19.1994C9.53457 17.5339 9.57234 15.3418 10.7545 13.7152L13.2499 10.2832C14.4321 8.6577 14.4699 6.46559 13.3444 4.79901L13.3399 4.79679C11.9356 2.72468 9.16792 2.08582 7.00026 3.3402M19.0705 4.92901C22.9758 8.83436 22.9758 15.1651 19.0705 19.0705C15.1651 22.9758 8.83436 22.9758 4.92901 19.0705C1.02366 15.1651 1.02366 8.83436 4.92901 4.92901C8.83436 1.02366 15.1651 1.02366 19.0705 4.92901Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Mu = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M15 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11985 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H15M10 7L15 12M15 12L10 17M15 12L3 12",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Nu = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M6 17C6 17.93 6 18.395 6.10222 18.7765C6.37962 19.8117 7.18827 20.6204 8.22354 20.8978C8.60504 21 9.07003 21 10 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H10C9.07003 3 8.60504 3 8.22354 3.10222C7.18827 3.37962 6.37962 4.18827 6.10222 5.22354C6 5.60504 6 6.07003 6 7M12 8L16 12M16 12L12 16M16 12H3",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Pu = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M6 17C6 17.3513 6 17.5269 6.01567 17.6796C6.14575 18.9474 7.0626 19.9946 8.30206 20.2911C8.45134 20.3268 8.6255 20.35 8.97368 20.3965L15.5656 21.2754C17.442 21.5256 18.3803 21.6507 19.1084 21.3611C19.7478 21.1069 20.2803 20.6407 20.6168 20.0406C21 19.357 21 18.4105 21 16.5175V7.48244C21 5.5894 21 4.64288 20.6168 3.95935C20.2803 3.35923 19.7478 2.893 19.1084 2.6388C18.3803 2.34926 17.442 2.47435 15.5656 2.72455L8.97368 3.60347C8.62546 3.6499 8.45135 3.67311 8.30206 3.70883C7.0626 4.00532 6.14575 5.05254 6.01567 6.3203C6 6.47301 6 6.64866 6 6.99996M12 7.99996L16 12M16 12L12 16M16 12H3",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Fu = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 8L16 12M16 12L12 16M16 12H3M3.33782 7C5.06687 4.01099 8.29859 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C8.29859 22 5.06687 19.989 3.33782 17",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Iu = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M16 17L21 12M21 12L16 7M21 12H9M9 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H9",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Lu = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M16 17L21 12M21 12L16 7M21 12H9M12 17C12 17.93 12 18.395 11.8978 18.7765C11.6204 19.8117 10.8117 20.6204 9.77646 20.8978C9.39496 21 8.92997 21 8 21H7.5C6.10218 21 5.40326 21 4.85195 20.7716C4.11687 20.4672 3.53284 19.8831 3.22836 19.1481C3 18.5967 3 17.8978 3 16.5V7.5C3 6.10217 3 5.40326 3.22836 4.85195C3.53284 4.11687 4.11687 3.53284 4.85195 3.22836C5.40326 3 6.10218 3 7.5 3H8C8.92997 3 9.39496 3 9.77646 3.10222C10.8117 3.37962 11.6204 4.18827 11.8978 5.22354C12 5.60504 12 6.07003 12 7",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ru = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M16 16.9999L21 11.9999M21 11.9999L16 6.99994M21 11.9999H9M12 16.9999C12 17.2955 12 17.4433 11.989 17.5713C11.8748 18.9019 10.8949 19.9968 9.58503 20.2572C9.45903 20.2823 9.31202 20.2986 9.01835 20.3312L7.99694 20.4447C6.46248 20.6152 5.69521 20.7005 5.08566 20.5054C4.27293 20.2453 3.60942 19.6515 3.26118 18.8724C3 18.2881 3 17.5162 3 15.9722V8.02764C3 6.4837 3 5.71174 3.26118 5.12746C3.60942 4.34842 4.27293 3.75454 5.08566 3.49447C5.69521 3.29941 6.46246 3.38466 7.99694 3.55516L9.01835 3.66865C9.31212 3.70129 9.45901 3.71761 9.58503 3.74267C10.8949 4.0031 11.8748 5.09798 11.989 6.42855C12 6.55657 12 6.70436 12 6.99994",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), zu = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M18 8L22 12M22 12L18 16M22 12H9M15 4.20404C13.7252 3.43827 12.2452 3 10.6667 3C5.8802 3 2 7.02944 2 12C2 16.9706 5.8802 21 10.6667 21C12.2452 21 13.7252 20.5617 15 19.796",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Bu = (e) => /* @__PURE__ */ o("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ a("path", {
		d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ a("path", {
		d: "M13.8333 7.3C13.8333 7.01997 13.8333 6.87996 13.7788 6.773C13.7309 6.67892 13.6544 6.60243 13.5603 6.5545C13.4534 6.5 13.3134 6.5 13.0333 6.5H10.9667C10.6866 6.5 10.5466 6.5 10.4397 6.5545C10.3456 6.60243 10.2691 6.67892 10.2212 6.773C10.1667 6.87996 10.1667 7.01997 10.1667 7.3V9.36667C10.1667 9.64669 10.1667 9.78671 10.1122 9.89366C10.0642 9.98774 9.98774 10.0642 9.89366 10.1122C9.78671 10.1667 9.64669 10.1667 9.36667 10.1667H7.3C7.01997 10.1667 6.87996 10.1667 6.773 10.2212C6.67892 10.2691 6.60243 10.3456 6.5545 10.4397C6.5 10.5466 6.5 10.6866 6.5 10.9667V13.0333C6.5 13.3134 6.5 13.4534 6.5545 13.5603C6.60243 13.6544 6.67892 13.7309 6.773 13.7788C6.87996 13.8333 7.01997 13.8333 7.3 13.8333H9.36667C9.64669 13.8333 9.78671 13.8333 9.89366 13.8878C9.98774 13.9358 10.0642 14.0123 10.1122 14.1063C10.1667 14.2133 10.1667 14.3533 10.1667 14.6333V16.7C10.1667 16.98 10.1667 17.12 10.2212 17.227C10.2691 17.3211 10.3456 17.3976 10.4397 17.4455C10.5466 17.5 10.6866 17.5 10.9667 17.5H13.0333C13.3134 17.5 13.4534 17.5 13.5603 17.4455C13.6544 17.3976 13.7309 17.3211 13.7788 17.227C13.8333 17.12 13.8333 16.98 13.8333 16.7V14.6333C13.8333 14.3533 13.8333 14.2133 13.8878 14.1063C13.9358 14.0123 14.0123 13.9358 14.1063 13.8878C14.2133 13.8333 14.3533 13.8333 14.6333 13.8333H16.7C16.98 13.8333 17.12 13.8333 17.227 13.7788C17.3211 13.7309 17.3976 13.6544 17.4455 13.5603C17.5 13.4534 17.5 13.3134 17.5 13.0333V10.9667C17.5 10.6866 17.5 10.5466 17.4455 10.4397C17.3976 10.3456 17.3211 10.2691 17.227 10.2212C17.12 10.1667 16.98 10.1667 16.7 10.1667H14.6333C14.3533 10.1667 14.2133 10.1667 14.1063 10.1122C14.0123 10.0642 13.9358 9.98774 13.8878 9.89366C13.8333 9.78671 13.8333 9.64669 13.8333 9.36667V7.3Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
}), Vu = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M15 4.6C15 4.03995 15 3.75992 14.891 3.54601C14.7951 3.35785 14.6422 3.20487 14.454 3.10899C14.2401 3 13.9601 3 13.4 3H10.6C10.0399 3 9.75992 3 9.54601 3.10899C9.35785 3.20487 9.20487 3.35785 9.10899 3.54601C9 3.75992 9 4.03995 9 4.6V7.4C9 7.96005 9 8.24008 8.89101 8.45399C8.79513 8.64215 8.64215 8.79513 8.45399 8.89101C8.24008 9 7.96005 9 7.4 9H4.6C4.03995 9 3.75992 9 3.54601 9.10899C3.35785 9.20487 3.20487 9.35785 3.10899 9.54601C3 9.75992 3 10.0399 3 10.6V13.4C3 13.9601 3 14.2401 3.10899 14.454C3.20487 14.6422 3.35785 14.7951 3.54601 14.891C3.75992 15 4.03995 15 4.6 15H7.4C7.96005 15 8.24008 15 8.45399 15.109C8.64215 15.2049 8.79513 15.3578 8.89101 15.546C9 15.7599 9 16.0399 9 16.6V19.4C9 19.9601 9 20.2401 9.10899 20.454C9.20487 20.6422 9.35785 20.7951 9.54601 20.891C9.75992 21 10.0399 21 10.6 21H13.4C13.9601 21 14.2401 21 14.454 20.891C14.6422 20.7951 14.7951 20.6422 14.891 20.454C15 20.2401 15 19.9601 15 19.4V16.6C15 16.0399 15 15.7599 15.109 15.546C15.2049 15.3578 15.3578 15.2049 15.546 15.109C15.7599 15 16.0399 15 16.6 15H19.4C19.9601 15 20.2401 15 20.454 14.891C20.6422 14.7951 20.7951 14.6422 20.891 14.454C21 14.2401 21 13.9601 21 13.4V10.6C21 10.0399 21 9.75992 20.891 9.54601C20.7951 9.35785 20.6422 9.20487 20.454 9.10899C20.2401 9 19.9601 9 19.4 9L16.6 9C16.0399 9 15.7599 9 15.546 8.89101C15.3578 8.79513 15.2049 8.64215 15.109 8.45399C15 8.24008 15 7.96005 15 7.4V4.6Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Hu = (e) => /* @__PURE__ */ o("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ a("path", {
		d: "M3 7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ a("path", {
		d: "M13.8333 7.3C13.8333 7.01997 13.8333 6.87996 13.7788 6.773C13.7309 6.67892 13.6544 6.60243 13.5603 6.5545C13.4534 6.5 13.3134 6.5 13.0333 6.5H10.9667C10.6866 6.5 10.5466 6.5 10.4397 6.5545C10.3456 6.60243 10.2691 6.67892 10.2212 6.773C10.1667 6.87996 10.1667 7.01997 10.1667 7.3V9.36667C10.1667 9.64669 10.1667 9.78671 10.1122 9.89366C10.0642 9.98774 9.98774 10.0642 9.89366 10.1122C9.78671 10.1667 9.64669 10.1667 9.36667 10.1667H7.3C7.01997 10.1667 6.87996 10.1667 6.773 10.2212C6.67892 10.2691 6.60243 10.3456 6.5545 10.4397C6.5 10.5466 6.5 10.6866 6.5 10.9667V13.0333C6.5 13.3134 6.5 13.4534 6.5545 13.5603C6.60243 13.6544 6.67892 13.7309 6.773 13.7788C6.87996 13.8333 7.01997 13.8333 7.3 13.8333H9.36667C9.64669 13.8333 9.78671 13.8333 9.89366 13.8878C9.98774 13.9358 10.0642 14.0123 10.1122 14.1063C10.1667 14.2133 10.1667 14.3533 10.1667 14.6333V16.7C10.1667 16.98 10.1667 17.12 10.2212 17.227C10.2691 17.3211 10.3456 17.3976 10.4397 17.4455C10.5466 17.5 10.6866 17.5 10.9667 17.5H13.0333C13.3134 17.5 13.4534 17.5 13.5603 17.4455C13.6544 17.3976 13.7309 17.3211 13.7788 17.227C13.8333 17.12 13.8333 16.98 13.8333 16.7V14.6333C13.8333 14.3533 13.8333 14.2133 13.8878 14.1063C13.9358 14.0123 14.0123 13.9358 14.1063 13.8878C14.2133 13.8333 14.3533 13.8333 14.6333 13.8333H16.7C16.98 13.8333 17.12 13.8333 17.227 13.7788C17.3211 13.7309 17.3976 13.6544 17.4455 13.5603C17.5 13.4534 17.5 13.3134 17.5 13.0333V10.9667C17.5 10.6866 17.5 10.5466 17.4455 10.4397C17.3976 10.3456 17.3211 10.2691 17.227 10.2212C17.12 10.1667 16.98 10.1667 16.7 10.1667H14.6333C14.3533 10.1667 14.2133 10.1667 14.1063 10.1122C14.0123 10.0642 13.9358 9.98774 13.8878 9.89366C13.8333 9.78671 13.8333 9.64669 13.8333 9.36667V7.3Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
}), Uu = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M3 12H21M3 6H21M3 18H21",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Wu = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M3 12H15M3 6H21M3 18H21",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Gu = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M3 12H21M3 6H21M3 18H15",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ku = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M3 12H21M3 6H21M9 18H21",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), qu = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M3 8.5H21M3 15.5H21",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ju = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M8.99962 14C8.99962 14 10.3121 15.5 12.4996 15.5C14.6871 15.5 15.9996 14 15.9996 14M15.2496 9H15.2596M9.74962 9H9.75962M12.4996 20C17.194 20 20.9996 16.1944 20.9996 11.5C20.9996 6.80558 17.194 3 12.4996 3C7.8052 3 3.99962 6.80558 3.99962 11.5C3.99962 12.45 4.15547 13.3636 4.443 14.2166C4.55119 14.5376 4.60529 14.6981 4.61505 14.8214C4.62469 14.9432 4.6174 15.0286 4.58728 15.1469C4.55677 15.2668 4.48942 15.3915 4.35472 15.6408L2.71906 18.6684C2.48575 19.1002 2.36909 19.3161 2.3952 19.4828C2.41794 19.6279 2.50337 19.7557 2.6288 19.8322C2.7728 19.9201 3.01692 19.8948 3.50517 19.8444L8.62619 19.315C8.78127 19.299 8.85881 19.291 8.92949 19.2937C8.999 19.2963 9.04807 19.3029 9.11586 19.3185C9.18478 19.3344 9.27145 19.3678 9.44478 19.4345C10.3928 19.7998 11.4228 20 12.4996 20ZM15.7496 9C15.7496 9.27614 15.5258 9.5 15.2496 9.5C14.9735 9.5 14.7496 9.27614 14.7496 9C14.7496 8.72386 14.9735 8.5 15.2496 8.5C15.5258 8.5 15.7496 8.72386 15.7496 9ZM10.2496 9C10.2496 9.27614 10.0258 9.5 9.74962 9.5C9.47348 9.5 9.24962 9.27614 9.24962 9C9.24962 8.72386 9.47348 8.5 9.74962 8.5C10.0258 8.5 10.2496 8.72386 10.2496 9Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Yu = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M5 12H19",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Xu = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M8 12H16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Zu = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M8 12H16M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Qu = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M19 5L5 19M7.5 6.5C7.5 7.05228 7.05228 7.5 6.5 7.5C5.94772 7.5 5.5 7.05228 5.5 6.5C5.5 5.94772 5.94772 5.5 6.5 5.5C7.05228 5.5 7.5 5.94772 7.5 6.5ZM18.5 17.5C18.5 18.0523 18.0523 18.5 17.5 18.5C16.9477 18.5 16.5 18.0523 16.5 17.5C16.5 16.9477 16.9477 16.5 17.5 16.5C18.0523 16.5 18.5 16.9477 18.5 17.5Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), $u = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M19 5L5 19M9 7C9 8.10457 8.10457 9 7 9C5.89543 9 5 8.10457 5 7C5 5.89543 5.89543 5 7 5C8.10457 5 9 5.89543 9 7ZM19 17C19 18.1046 18.1046 19 17 19C15.8954 19 15 18.1046 15 17C15 15.8954 15.8954 15 17 15C18.1046 15 19 15.8954 19 17Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ed = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9 9H9.01M15 15H15.01M16 8L8 16M9.5 9C9.5 9.27614 9.27614 9.5 9 9.5C8.72386 9.5 8.5 9.27614 8.5 9C8.5 8.72386 8.72386 8.5 9 8.5C9.27614 8.5 9.5 8.72386 9.5 9ZM15.5 15C15.5 15.2761 15.2761 15.5 15 15.5C14.7239 15.5 14.5 15.2761 14.5 15C14.5 14.7239 14.7239 14.5 15 14.5C15.2761 14.5 15.5 14.7239 15.5 15ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), td = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12.0004 15L12.0004 22M8.00043 7.30813V9.43875C8.00043 9.64677 8.00043 9.75078 7.98001 9.85026C7.9619 9.93852 7.93194 10.0239 7.89095 10.1042C7.84474 10.1946 7.77977 10.2758 7.64982 10.4383L6.08004 12.4005C5.4143 13.2327 5.08143 13.6487 5.08106 13.9989C5.08073 14.3035 5.21919 14.5916 5.4572 14.7815C5.73088 15 6.26373 15 7.32943 15H16.6714C17.7371 15 18.27 15 18.5437 14.7815C18.7817 14.5916 18.9201 14.3035 18.9198 13.9989C18.9194 13.6487 18.5866 13.2327 17.9208 12.4005L16.351 10.4383C16.2211 10.2758 16.1561 10.1946 16.1099 10.1042C16.0689 10.0239 16.039 9.93852 16.0208 9.85026C16.0004 9.75078 16.0004 9.64677 16.0004 9.43875V7.30813C16.0004 7.19301 16.0004 7.13544 16.0069 7.07868C16.0127 7.02825 16.0223 6.97833 16.0357 6.92937C16.0507 6.87424 16.0721 6.8208 16.1149 6.71391L17.1227 4.19423C17.4168 3.45914 17.5638 3.09159 17.5025 2.79655C17.4489 2.53853 17.2956 2.31211 17.0759 2.1665C16.8247 2 16.4289 2 15.6372 2H8.36368C7.57197 2 7.17611 2 6.92494 2.1665C6.70529 2.31211 6.55199 2.53853 6.49838 2.79655C6.43707 3.09159 6.58408 3.45914 6.87812 4.19423L7.88599 6.71391C7.92875 6.8208 7.95013 6.87424 7.96517 6.92937C7.97853 6.97833 7.98814 7.02825 7.99392 7.07868C8.00043 7.13544 8.00043 7.19301 8.00043 7.30813Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), nd = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M8.3767 15.6163L2.71985 21.2732M11.6944 6.64181L10.1335 8.2027C10.0062 8.33003 9.94252 8.39369 9.86999 8.44427C9.80561 8.48917 9.73616 8.52634 9.66309 8.555C9.58077 8.58729 9.49249 8.60495 9.31592 8.64026L5.65145 9.37315C4.69915 9.56361 4.223 9.65884 4.00024 9.9099C3.80617 10.1286 3.71755 10.4213 3.75771 10.7109C3.8038 11.0434 4.14715 11.3867 4.83387 12.0735L11.9196 19.1592C12.6063 19.8459 12.9497 20.1893 13.2821 20.2354C13.5718 20.2755 13.8645 20.1869 14.0832 19.9928C14.3342 19.7701 14.4294 19.2939 14.6199 18.3416L15.3528 14.6771C15.3881 14.5006 15.4058 14.4123 15.4381 14.33C15.4667 14.2569 15.5039 14.1875 15.5488 14.1231C15.5994 14.0505 15.663 13.9869 15.7904 13.8596L17.3512 12.2987C17.4326 12.2173 17.4734 12.1766 17.5181 12.141C17.5578 12.1095 17.5999 12.081 17.644 12.0558C17.6936 12.0274 17.7465 12.0048 17.8523 11.9594L20.3467 10.8904C21.0744 10.5785 21.4383 10.4226 21.6035 10.1706C21.7481 9.95025 21.7998 9.68175 21.7474 9.42348C21.6875 9.12813 21.4076 8.84822 20.8478 8.28839L15.7047 3.14526C15.1448 2.58543 14.8649 2.30552 14.5696 2.24565C14.3113 2.19329 14.0428 2.245 13.8225 2.38953C13.5705 2.55481 13.4145 2.91866 13.1027 3.64636L12.0337 6.14071C11.9883 6.24653 11.9656 6.29944 11.9373 6.34905C11.9121 6.39313 11.8836 6.43522 11.852 6.47496C11.8165 6.51971 11.7758 6.56041 11.6944 6.64181Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), rd = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), id = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 5V19M5 12H19",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ad = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 8V16M8 12H16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), od = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 8V16M8 12H16M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), sd = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M7 3V6.4C7 6.96005 7 7.24008 7.10899 7.45399C7.20487 7.64215 7.35785 7.79513 7.54601 7.89101C7.75992 8 8.03995 8 8.6 8H15.4C15.9601 8 16.2401 8 16.454 7.89101C16.6422 7.79513 16.7951 7.64215 16.891 7.45399C17 7.24008 17 6.96005 17 6.4V4M17 21V14.6C17 14.0399 17 13.7599 16.891 13.546C16.7951 13.3578 16.6422 13.2049 16.454 13.109C16.2401 13 15.9601 13 15.4 13H8.6C8.03995 13 7.75992 13 7.54601 13.109C7.35785 13.2049 7.20487 13.3578 7.10899 13.546C7 13.7599 7 14.0399 7 14.6V21M21 9.32548V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H14.6745C15.1637 3 15.4083 3 15.6385 3.05526C15.8425 3.10425 16.0376 3.18506 16.2166 3.29472C16.4184 3.4184 16.5914 3.59135 16.9373 3.93726L20.0627 7.06274C20.4086 7.40865 20.5816 7.5816 20.7053 7.78343C20.8149 7.96237 20.8957 8.15746 20.9447 8.36154C21 8.59171 21 8.8363 21 9.32548Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), cd = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M15 8H8.6C8.03995 8 7.75992 8 7.54601 7.89101C7.35785 7.79513 7.20487 7.64215 7.10899 7.45399C7 7.24008 7 6.96005 7 6.4V3M17 21V14.6C17 14.0399 17 13.7599 16.891 13.546C16.7951 13.3578 16.6422 13.2049 16.454 13.109C16.2401 13 15.9601 13 15.4 13H8.6C8.03995 13 7.75992 13 7.54601 13.109C7.35785 13.2049 7.20487 13.3578 7.10899 13.546C7 13.7599 7 14.0399 7 14.6V21M21 9.32548V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H14.6745C15.1637 3 15.4083 3 15.6385 3.05526C15.8425 3.10425 16.0376 3.18506 16.2166 3.29472C16.4184 3.4184 16.5914 3.59135 16.9373 3.93726L20.0627 7.06274C20.4086 7.40865 20.5816 7.5816 20.7053 7.78343C20.8149 7.96237 20.8957 8.15746 20.9447 8.36154C21 8.59171 21 8.8363 21 9.32548Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ld = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M7 3H14.6745C15.1637 3 15.4083 3 15.6385 3.05526C15.8425 3.10425 16.0376 3.18506 16.2166 3.29472C16.4184 3.4184 16.5914 3.59135 16.9373 3.93726L20.0627 7.06274C20.4086 7.40865 20.5816 7.5816 20.7053 7.78343C20.8149 7.96237 20.8957 8.15746 20.9447 8.36154C21 8.59171 21 8.8363 21 9.32548V17M12.5 10H8.6C8.03995 10 7.75992 10 7.54601 9.89101C7.35785 9.79513 7.20487 9.64215 7.10899 9.45399C7 9.24008 7 8.96005 7 8.4V6.5M13.5 21V16.6C13.5 16.0399 13.5 15.7599 13.391 15.546C13.2951 15.3578 13.1422 15.2049 12.954 15.109C12.7401 15 12.4601 15 11.9 15H8.6C8.03995 15 7.75992 15 7.54601 15.109C7.35785 15.2049 7.20487 15.3578 7.10899 15.546C7 15.7599 7 16.0399 7 16.6V21M17.5 10.1627V17.8C17.5 18.9201 17.5 19.4802 17.282 19.908C17.0903 20.2843 16.7843 20.5903 16.408 20.782C15.9802 21 15.4201 21 14.3 21H6.2C5.0799 21 4.51984 21 4.09202 20.782C3.71569 20.5903 3.40973 20.2843 3.21799 19.908C3 19.4802 3 18.9201 3 17.8V9.7C3 8.57989 3 8.01984 3.21799 7.59202C3.40973 7.21569 3.71569 6.90973 4.09202 6.71799C4.51984 6.5 5.0799 6.5 6.2 6.5H13.8373C14.0818 6.5 14.2041 6.5 14.3192 6.52763C14.4213 6.55213 14.5188 6.59253 14.6083 6.64736C14.7092 6.7092 14.7957 6.79568 14.9686 6.96863L17.0314 9.03137C17.2043 9.20432 17.2908 9.2908 17.3526 9.39172C17.4075 9.48119 17.4479 9.57873 17.4724 9.68077C17.5 9.79586 17.5 9.91815 17.5 10.1627Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ud = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M21 21L17.5001 17.5M20 11.5C20 16.1944 16.1944 20 11.5 20C6.80558 20 3 16.1944 3 11.5C3 6.80558 6.80558 3 11.5 3C16.1944 3 20 6.80558 20 11.5Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), dd = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M21 21L16.65 16.65M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), fd = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M21 21L16.65 16.65M11 6C13.7614 6 16 8.23858 16 11M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), pd = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M21 21L15.0001 15M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), md = (e) => /* @__PURE__ */ o("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ a("path", {
		d: "M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ a("path", {
		d: "M18.7273 14.7273C18.6063 15.0015 18.5702 15.3056 18.6236 15.6005C18.6771 15.8954 18.8177 16.1676 19.0273 16.3818L19.0818 16.4364C19.2509 16.6052 19.385 16.8057 19.4765 17.0265C19.568 17.2472 19.6151 17.4838 19.6151 17.7227C19.6151 17.9617 19.568 18.1983 19.4765 18.419C19.385 18.6397 19.2509 18.8402 19.0818 19.0091C18.913 19.1781 18.7124 19.3122 18.4917 19.4037C18.271 19.4952 18.0344 19.5423 17.7955 19.5423C17.5565 19.5423 17.3199 19.4952 17.0992 19.4037C16.8785 19.3122 16.678 19.1781 16.5091 19.0091L16.4545 18.9545C16.2403 18.745 15.9682 18.6044 15.6733 18.5509C15.3784 18.4974 15.0742 18.5335 14.8 18.6545C14.5311 18.7698 14.3018 18.9611 14.1403 19.205C13.9788 19.4489 13.8921 19.7347 13.8909 20.0273V20.1818C13.8909 20.664 13.6994 21.1265 13.3584 21.4675C13.0174 21.8084 12.5549 22 12.0727 22C11.5905 22 11.1281 21.8084 10.7871 21.4675C10.4461 21.1265 10.2545 20.664 10.2545 20.1818V20.1C10.2475 19.7991 10.1501 19.5073 9.97501 19.2625C9.79991 19.0176 9.55521 18.8312 9.27273 18.7273C8.99853 18.6063 8.69437 18.5702 8.39947 18.6236C8.10456 18.6771 7.83244 18.8177 7.61818 19.0273L7.56364 19.0818C7.39478 19.2509 7.19425 19.385 6.97353 19.4765C6.7528 19.568 6.51621 19.6151 6.27727 19.6151C6.03834 19.6151 5.80174 19.568 5.58102 19.4765C5.36029 19.385 5.15977 19.2509 4.99091 19.0818C4.82186 18.913 4.68775 18.7124 4.59626 18.4917C4.50476 18.271 4.45766 18.0344 4.45766 17.7955C4.45766 17.5565 4.50476 17.3199 4.59626 17.0992C4.68775 16.8785 4.82186 16.678 4.99091 16.5091L5.04545 16.4545C5.25503 16.2403 5.39562 15.9682 5.4491 15.6733C5.50257 15.3784 5.46647 15.0742 5.34545 14.8C5.23022 14.5311 5.03887 14.3018 4.79497 14.1403C4.55107 13.9788 4.26526 13.8921 3.97273 13.8909H3.81818C3.33597 13.8909 2.87351 13.6994 2.53253 13.3584C2.19156 13.0174 2 12.5549 2 12.0727C2 11.5905 2.19156 11.1281 2.53253 10.7871C2.87351 10.4461 3.33597 10.2545 3.81818 10.2545H3.9C4.2009 10.2475 4.49273 10.1501 4.73754 9.97501C4.98236 9.79991 5.16883 9.55521 5.27273 9.27273C5.39374 8.99853 5.42984 8.69437 5.37637 8.39947C5.3229 8.10456 5.18231 7.83244 4.97273 7.61818L4.91818 7.56364C4.74913 7.39478 4.61503 7.19425 4.52353 6.97353C4.43203 6.7528 4.38493 6.51621 4.38493 6.27727C4.38493 6.03834 4.43203 5.80174 4.52353 5.58102C4.61503 5.36029 4.74913 5.15977 4.91818 4.99091C5.08704 4.82186 5.28757 4.68775 5.50829 4.59626C5.72901 4.50476 5.96561 4.45766 6.20455 4.45766C6.44348 4.45766 6.68008 4.50476 6.9008 4.59626C7.12152 4.68775 7.32205 4.82186 7.49091 4.99091L7.54545 5.04545C7.75971 5.25503 8.03183 5.39562 8.32674 5.4491C8.62164 5.50257 8.9258 5.46647 9.2 5.34545H9.27273C9.54161 5.23022 9.77093 5.03887 9.93245 4.79497C10.094 4.55107 10.1807 4.26526 10.1818 3.97273V3.81818C10.1818 3.33597 10.3734 2.87351 10.7144 2.53253C11.0553 2.19156 11.5178 2 12 2C12.4822 2 12.9447 2.19156 13.2856 2.53253C13.6266 2.87351 13.8182 3.33597 13.8182 3.81818V3.9C13.8193 4.19253 13.906 4.47834 14.0676 4.72224C14.2291 4.96614 14.4584 5.15749 14.7273 5.27273C15.0015 5.39374 15.3056 5.42984 15.6005 5.37637C15.8954 5.3229 16.1676 5.18231 16.3818 4.97273L16.4364 4.91818C16.6052 4.74913 16.8057 4.61503 17.0265 4.52353C17.2472 4.43203 17.4838 4.38493 17.7227 4.38493C17.9617 4.38493 18.1983 4.43203 18.419 4.52353C18.6397 4.61503 18.8402 4.74913 19.0091 4.91818C19.1781 5.08704 19.3122 5.28757 19.4037 5.50829C19.4952 5.72901 19.5423 5.96561 19.5423 6.20455C19.5423 6.44348 19.4952 6.68008 19.4037 6.9008C19.3122 7.12152 19.1781 7.32205 19.0091 7.49091L18.9545 7.54545C18.745 7.75971 18.6044 8.03183 18.5509 8.32674C18.4974 8.62164 18.5335 8.9258 18.6545 9.2V9.27273C18.7698 9.54161 18.9611 9.77093 19.205 9.93245C19.4489 10.094 19.7347 10.1807 20.0273 10.1818H20.1818C20.664 10.1818 21.1265 10.3734 21.4675 10.7144C21.8084 11.0553 22 11.5178 22 12C22 12.4822 21.8084 12.9447 21.4675 13.2856C21.1265 13.6266 20.664 13.8182 20.1818 13.8182H20.1C19.8075 13.8193 19.5217 13.906 19.2778 14.0676C19.0339 14.2291 18.8425 14.4584 18.7273 14.7273Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
}), hd = (e) => /* @__PURE__ */ o("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ a("path", {
		d: "M9.3951 19.3711L9.97955 20.6856C10.1533 21.0768 10.4368 21.4093 10.7958 21.6426C11.1547 21.8759 11.5737 22.0001 12.0018 22C12.4299 22.0001 12.8488 21.8759 13.2078 21.6426C13.5667 21.4093 13.8503 21.0768 14.024 20.6856L14.6084 19.3711C14.8165 18.9047 15.1664 18.5159 15.6084 18.26C16.0532 18.0034 16.5678 17.8941 17.0784 17.9478L18.5084 18.1C18.9341 18.145 19.3637 18.0656 19.7451 17.8713C20.1265 17.6771 20.4434 17.3763 20.6573 17.0056C20.8715 16.635 20.9735 16.2103 20.9511 15.7829C20.9286 15.3555 20.7825 14.9438 20.5307 14.5978L19.684 13.4344C19.3825 13.0171 19.2214 12.5148 19.224 12C19.2239 11.4866 19.3865 10.9864 19.6884 10.5711L20.5351 9.40778C20.787 9.06175 20.933 8.65007 20.9555 8.22267C20.978 7.79528 20.8759 7.37054 20.6618 7C20.4479 6.62923 20.131 6.32849 19.7496 6.13423C19.3681 5.93997 18.9386 5.86053 18.5129 5.90556L17.0829 6.05778C16.5722 6.11141 16.0577 6.00212 15.6129 5.74556C15.17 5.48825 14.82 5.09736 14.6129 4.62889L14.024 3.31444C13.8503 2.92317 13.5667 2.59072 13.2078 2.3574C12.8488 2.12408 12.4299 1.99993 12.0018 2C11.5737 1.99993 11.1547 2.12408 10.7958 2.3574C10.4368 2.59072 10.1533 2.92317 9.97955 3.31444L9.3951 4.62889C9.18803 5.09736 8.83798 5.48825 8.3951 5.74556C7.95032 6.00212 7.43577 6.11141 6.9251 6.05778L5.49066 5.90556C5.06499 5.86053 4.6354 5.93997 4.25397 6.13423C3.87255 6.32849 3.55567 6.62923 3.34177 7C3.12759 7.37054 3.02555 7.79528 3.04804 8.22267C3.07052 8.65007 3.21656 9.06175 3.46844 9.40778L4.3151 10.5711C4.61704 10.9864 4.77964 11.4866 4.77955 12C4.77964 12.5134 4.61704 13.0137 4.3151 13.4289L3.46844 14.5922C3.21656 14.9382 3.07052 15.3499 3.04804 15.7773C3.02555 16.2047 3.12759 16.6295 3.34177 17C3.55589 17.3706 3.8728 17.6712 4.25417 17.8654C4.63554 18.0596 5.06502 18.1392 5.49066 18.0944L6.92066 17.9422C7.43133 17.8886 7.94587 17.9979 8.39066 18.2544C8.83519 18.511 9.18687 18.902 9.3951 19.3711Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ a("path", {
		d: "M12 15C13.6568 15 15 13.6569 15 12C15 10.3431 13.6568 9 12 9C10.3431 9 8.99998 10.3431 8.99998 12C8.99998 13.6569 10.3431 15 12 15Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
}), gd = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M15.0505 9H5.5C4.11929 9 3 7.88071 3 6.5C3 5.11929 4.11929 4 5.5 4H15.0505M8.94949 20H18.5C19.8807 20 21 18.8807 21 17.5C21 16.1193 19.8807 15 18.5 15H8.94949M3 17.5C3 19.433 4.567 21 6.5 21C8.433 21 10 19.433 10 17.5C10 15.567 8.433 14 6.5 14C4.567 14 3 15.567 3 17.5ZM21 6.5C21 8.433 19.433 10 17.5 10C15.567 10 14 8.433 14 6.5C14 4.567 15.567 3 17.5 3C19.433 3 21 4.567 21 6.5Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), _d = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M3 8L15 8M15 8C15 9.65686 16.3431 11 18 11C19.6569 11 21 9.65685 21 8C21 6.34315 19.6569 5 18 5C16.3431 5 15 6.34315 15 8ZM9 16L21 16M9 16C9 17.6569 7.65685 19 6 19C4.34315 19 3 17.6569 3 16C3 14.3431 4.34315 13 6 13C7.65685 13 9 14.3431 9 16Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), vd = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M21 12V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V12M16 7L12 3M12 3L8 7M12 3V15",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), yd = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M7 11C6.07003 11 5.60504 11 5.22354 11.1022C4.18827 11.3796 3.37962 12.1883 3.10222 13.2235C3 13.605 3 14.07 3 15V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V15C21 14.07 21 13.605 20.8978 13.2235C20.6204 12.1883 19.8117 11.3796 18.7765 11.1022C18.395 11 17.93 11 17 11M16 7L12 3M12 3L8 7M12 3V15",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), bd = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M21 9.00001L21 3.00001M21 3.00001H15M21 3.00001L12 12M10 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V14",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), xd = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M21 9L21 3M21 3H15M21 3L13 11M10 5H7.8C6.11984 5 5.27976 5 4.63803 5.32698C4.07354 5.6146 3.6146 6.07354 3.32698 6.63803C3 7.27976 3 8.11984 3 9.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H14.2C15.8802 21 16.7202 21 17.362 20.673C17.9265 20.3854 18.3854 19.9265 18.673 19.362C19 18.7202 19 17.8802 19 16.2V14",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Sd = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M21 6H17.8C16.1198 6 15.2798 6 14.638 6.32698C14.0735 6.6146 13.6146 7.07354 13.327 7.63803C13 8.27976 13 9.11984 13 10.8V12M21 6L18 3M21 6L18 9M10 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V14",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Cd = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M20.7914 12.6074C21.0355 12.3981 21.1575 12.2935 21.2023 12.169C21.2415 12.0598 21.2415 11.9402 21.2023 11.831C21.1575 11.7065 21.0355 11.6018 20.7914 11.3926L12.3206 4.13196C11.9004 3.77176 11.6903 3.59166 11.5124 3.58725C11.3578 3.58342 11.2101 3.65134 11.1124 3.77122C11 3.90915 11 4.18589 11 4.73936V9.03462C8.86532 9.40807 6.91159 10.4897 5.45971 12.1139C3.87682 13.8845 3.00123 16.1759 3 18.551V19.1629C4.04934 17.8989 5.35951 16.8765 6.84076 16.1659C8.1467 15.5394 9.55842 15.1683 11 15.0705V19.2606C11 19.8141 11 20.0908 11.1124 20.2288C11.2101 20.3486 11.3578 20.4166 11.5124 20.4127C11.6903 20.4083 11.9004 20.2282 12.3206 19.868L20.7914 12.6074Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), wd = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M8.59 13.51L15.42 17.49M15.41 6.51L8.59 10.49M21 5C21 6.65685 19.6569 8 18 8C16.3431 8 15 6.65685 15 5C15 3.34315 16.3431 2 18 2C19.6569 2 21 3.34315 21 5ZM9 12C9 13.6569 7.65685 15 6 15C4.34315 15 3 13.6569 3 12C3 10.3431 4.34315 9 6 9C7.65685 9 9 10.3431 9 12ZM21 19C21 20.6569 19.6569 22 18 22C16.3431 22 15 20.6569 15 19C15 17.3431 16.3431 16 18 16C19.6569 16 21 17.3431 21 19Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Td = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M4.93 4.93L19.07 19.07M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ed = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M4.93 4.93L19.07 19.07M19.0699 4.92999L4.92993 19.07M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Dd = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M7 22L17 2",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Od = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M4.93 4.93L19.07 19.07M2 8.52274V15.4773C2 15.7218 2 15.8441 2.02763 15.9592C2.05213 16.0613 2.09253 16.1588 2.14736 16.2483C2.2092 16.3492 2.29568 16.4357 2.46863 16.6086L7.39137 21.5314C7.56432 21.7043 7.6508 21.7908 7.75172 21.8526C7.84119 21.9075 7.93873 21.9479 8.04077 21.9724C8.15586 22 8.27815 22 8.52274 22H15.4773C15.7218 22 15.8441 22 15.9592 21.9724C16.0613 21.9479 16.1588 21.9075 16.2483 21.8526C16.3492 21.7908 16.4357 21.7043 16.6086 21.5314L21.5314 16.6086C21.7043 16.4357 21.7908 16.3492 21.8526 16.2483C21.9075 16.1588 21.9479 16.0613 21.9724 15.9592C22 15.8441 22 15.7218 22 15.4773V8.52274C22 8.27815 22 8.15586 21.9724 8.04077C21.9479 7.93873 21.9075 7.84119 21.8526 7.75172C21.7908 7.6508 21.7043 7.56432 21.5314 7.39137L16.6086 2.46863C16.4357 2.29568 16.3492 2.2092 16.2483 2.14736C16.1588 2.09253 16.0613 2.05213 15.9592 2.02763C15.8441 2 15.7218 2 15.4773 2H8.52274C8.27815 2 8.15586 2 8.04077 2.02763C7.93873 2.05213 7.84119 2.09253 7.75172 2.14736C7.6508 2.2092 7.56432 2.29568 7.39137 2.46863L2.46863 7.39137C2.29568 7.56432 2.2092 7.6508 2.14736 7.75172C2.09253 7.84119 2.05213 7.93873 2.02763 8.04077C2 8.15586 2 8.27815 2 8.52274Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), kd = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 2V4.5M12 2C6.47715 2 2 6.47715 2 12M12 2C17.5228 2 22 6.47715 22 12M12 19.5V22M12 22C17.5228 22 22 17.5228 22 12M12 22C6.47715 22 2 17.5228 2 12M4.5 12H2M22 12H19.5M19.0784 19.0784L17.3047 17.3047M4.92163 19.0784L6.69715 17.3029M4.92163 5L6.65808 6.73645M19.0784 5L13.4999 10.5M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ad = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12M22 12C22 6.47715 17.5228 2 12 2M22 12H19.5M2 12C2 6.47715 6.47715 2 12 2M2 12H4.5M12 2V4.5M19.0784 5L13.4999 10.5M19.0784 19.0784L18.8745 18.8745C18.1827 18.1827 17.8368 17.8368 17.4331 17.5894C17.0753 17.3701 16.6851 17.2085 16.2769 17.1105C15.8166 17 15.3274 17 14.349 17L9.65096 17C8.6726 17 8.18342 17 7.72307 17.1106C7.31493 17.2086 6.92475 17.3702 6.56686 17.5895C6.1632 17.8369 5.8173 18.1828 5.12549 18.8746L4.92163 19.0784M4.92163 5L6.65808 6.73645M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), jd = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M5 12C5 8.13401 8.13401 5 12 5M16.4999 7.5L11.9999 12M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM13 12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Md = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M17.7453 16C18.5362 14.8661 19 13.4872 19 12C19 11.4851 18.9444 10.9832 18.8389 10.5M6.25469 16C5.46381 14.8662 5 13.4872 5 12C5 8.13401 8.13401 5 12 5C12.4221 5 12.8355 5.03737 13.2371 5.10897M16.4999 7.5L11.9999 12M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM13 12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Nd = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M22 12C22 17.5228 17.5228 22 12 22M22 12C22 6.47715 17.5228 2 12 2M22 12H18M12 22C6.47715 22 2 17.5228 2 12M12 22V18M2 12C2 6.47715 6.47715 2 12 2M2 12H6M12 2V6",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Pd = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M22 12H18M6 12H2M12 6V2M12 22V18M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Fd = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M22 12H18M6 12H2M12 6V2M12 22V18M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12ZM15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Id = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M16 8V5L19 2L20 4L22 5L19 8H16ZM16 8L12 11.9999M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2M17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ld = (e) => /* @__PURE__ */ o("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ a("path", {
			d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
			stroke: "black",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ a("path", {
			d: "M12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18Z",
			stroke: "black",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ a("path", {
			d: "M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z",
			stroke: "black",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
}), Rd = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M7 17H17C19.7614 17 22 14.7614 22 12C22 9.23858 19.7614 7 17 7H7M7 17C4.23858 17 2 14.7614 2 12C2 9.23858 4.23858 7 7 7M7 17C9.76142 17 12 14.7614 12 12C12 9.23858 9.76142 7 7 7",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), zd = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M17 17H7C4.23858 17 2 14.7614 2 12C2 9.23858 4.23858 7 7 7H17M17 17C19.7614 17 22 14.7614 22 12C22 9.23858 19.7614 7 17 7M17 17C14.2386 17 12 14.7614 12 12C12 9.23858 14.2386 7 17 7",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Bd = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M10.0005 16H18C20.2091 16 22 14.2091 22 12C22 9.79086 20.2091 8 18 8H10.0005M12 12C12 14.7614 9.76142 17 7 17C4.23858 17 2 14.7614 2 12C2 9.23858 4.23858 7 7 7C9.76142 7 12 9.23858 12 12Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Vd = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M13.9995 16H6C3.79086 16 2 14.2091 2 12C2 9.79086 3.79086 8 6 8H13.9995M21.9995 12C21.9995 14.7614 19.7609 17 16.9995 17C14.2381 17 11.9995 14.7614 11.9995 12C11.9995 9.23858 14.2381 7 16.9995 7C19.7609 7 21.9995 9.23858 21.9995 12Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Hd = (e) => /* @__PURE__ */ o("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ a("path", {
		d: "M2 12C2 8.68629 4.68629 6 8 6H16C19.3137 6 22 8.68629 22 12C22 15.3137 19.3137 18 16 18H8C4.68629 18 2 15.3137 2 12Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ a("path", {
		d: "M8 14.5C9.38071 14.5 10.5 13.3807 10.5 12C10.5 10.6193 9.38071 9.5 8 9.5C6.61929 9.5 5.5 10.6193 5.5 12C5.5 13.3807 6.61929 14.5 8 14.5Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
}), Ud = (e) => /* @__PURE__ */ o("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ a("path", {
		d: "M2 12C2 8.68629 4.68629 6 8 6H16C19.3137 6 22 8.68629 22 12C22 15.3137 19.3137 18 16 18H8C4.68629 18 2 15.3137 2 12Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ a("path", {
		d: "M16 14.5C17.3807 14.5 18.5 13.3807 18.5 12C18.5 10.6193 17.3807 9.5 16 9.5C14.6193 9.5 13.5 10.6193 13.5 12C13.5 13.3807 14.6193 14.5 16 14.5Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
}), Wd = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M15.6314 7.63137C15.2353 7.23535 15.0373 7.03735 14.9631 6.80902C14.8979 6.60817 14.8979 6.39183 14.9631 6.19098C15.0373 5.96265 15.2353 5.76465 15.6314 5.36863L18.4697 2.53026C17.7165 2.18962 16.8804 2 16 2C12.6863 2 9.99998 4.68629 9.99998 8C9.99998 8.49104 10.059 8.9683 10.1702 9.42509C10.2894 9.91424 10.349 10.1588 10.3384 10.3133C10.3273 10.4751 10.3032 10.5612 10.2286 10.7051C10.1574 10.8426 10.0208 10.9791 9.7478 11.2522L3.49998 17.5C2.67156 18.3284 2.67156 19.6716 3.49998 20.5C4.32841 21.3284 5.67156 21.3284 6.49998 20.5L12.7478 14.2522C13.0208 13.9791 13.1574 13.8426 13.2949 13.7714C13.4388 13.6968 13.5249 13.6727 13.6867 13.6616C13.8412 13.651 14.0857 13.7106 14.5749 13.8297C15.0317 13.941 15.5089 14 16 14C19.3137 14 22 11.3137 22 8C22 7.11959 21.8104 6.28347 21.4697 5.53026L18.6314 8.36863C18.2353 8.76465 18.0373 8.96265 17.809 9.03684C17.6082 9.1021 17.3918 9.1021 17.191 9.03684C16.9626 8.96265 16.7646 8.76465 16.3686 8.36863L15.6314 7.63137Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Gd = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M6 6L10.5 10.5M6 6H3L2 3L3 2L6 3V6ZM19.259 2.74101L16.6314 5.36863C16.2354 5.76465 16.0373 5.96265 15.9632 6.19098C15.8979 6.39183 15.8979 6.60817 15.9632 6.80902C16.0373 7.03735 16.2354 7.23535 16.6314 7.63137L16.8686 7.86863C17.2646 8.26465 17.4627 8.46265 17.691 8.53684C17.8918 8.6021 18.1082 8.6021 18.309 8.53684C18.5373 8.46265 18.7354 8.26465 19.1314 7.86863L21.5893 5.41072C21.854 6.05488 22 6.76039 22 7.5C22 10.5376 19.5376 13 16.5 13C16.1338 13 15.7759 12.9642 15.4298 12.8959C14.9436 12.8001 14.7005 12.7521 14.5532 12.7668C14.3965 12.7824 14.3193 12.8059 14.1805 12.8802C14.0499 12.9501 13.919 13.081 13.657 13.343L6.5 20.5C5.67157 21.3284 4.32843 21.3284 3.5 20.5C2.67157 19.6716 2.67157 18.3284 3.5 17.5L10.657 10.343C10.919 10.081 11.0499 9.95005 11.1198 9.81949C11.1941 9.68068 11.2176 9.60347 11.2332 9.44681C11.2479 9.29945 11.1999 9.05638 11.1041 8.57024C11.0358 8.22406 11 7.86621 11 7.5C11 4.46243 13.4624 2 16.5 2C17.5055 2 18.448 2.26982 19.259 2.74101ZM12.0001 14.9999L17.5 20.4999C18.3284 21.3283 19.6716 21.3283 20.5 20.4999C21.3284 19.6715 21.3284 18.3283 20.5 17.4999L15.9753 12.9753C15.655 12.945 15.3427 12.8872 15.0408 12.8043C14.6517 12.6975 14.2249 12.7751 13.9397 13.0603L12.0001 14.9999Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Kd = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12.913 17H20.087M12.913 17L11 21M12.913 17L15.7783 11.009C16.0092 10.5263 16.1246 10.2849 16.2826 10.2086C16.4199 10.1423 16.5801 10.1423 16.7174 10.2086C16.8754 10.2849 16.9908 10.5263 17.2217 11.009L20.087 17M20.087 17L22 21M2 5H8M8 5H11.5M8 5V3M11.5 5H14M11.5 5C11.0039 7.95729 9.85259 10.6362 8.16555 12.8844M10 14C9.38747 13.7248 8.76265 13.3421 8.16555 12.8844M8.16555 12.8844C6.81302 11.8478 5.60276 10.4266 5 9M8.16555 12.8844C6.56086 15.0229 4.47143 16.7718 2 18",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), qd = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M5 8L10 13M4 14L10 8L12 5M2 5H14M7 2H8M12.913 17H20.087M12.913 17L11 21M12.913 17L15.7783 11.009C16.0092 10.5263 16.1246 10.2849 16.2826 10.2086C16.4199 10.1423 16.5801 10.1423 16.7174 10.2086C16.8754 10.2849 16.9908 10.5263 17.2217 11.009L20.087 17M20.087 17L22 21",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Jd = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M16 6V5.2C16 4.0799 16 3.51984 15.782 3.09202C15.5903 2.71569 15.2843 2.40973 14.908 2.21799C14.4802 2 13.9201 2 12.8 2H11.2C10.0799 2 9.51984 2 9.09202 2.21799C8.71569 2.40973 8.40973 2.71569 8.21799 3.09202C8 3.51984 8 4.0799 8 5.2V6M10 11.5V16.5M14 11.5V16.5M3 6H21M19 6V17.2C19 18.8802 19 19.7202 18.673 20.362C18.3854 20.9265 17.9265 21.3854 17.362 21.673C16.7202 22 15.8802 22 14.2 22H9.8C8.11984 22 7.27976 22 6.63803 21.673C6.07354 21.3854 5.6146 20.9265 5.32698 20.362C5 19.7202 5 18.8802 5 17.2V6",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Yd = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M16 6V5.2C16 4.0799 16 3.51984 15.782 3.09202C15.5903 2.71569 15.2843 2.40973 14.908 2.21799C14.4802 2 13.9201 2 12.8 2H11.2C10.0799 2 9.51984 2 9.09202 2.21799C8.71569 2.40973 8.40973 2.71569 8.21799 3.09202C8 3.51984 8 4.0799 8 5.2V6M3 6H21M19 6V17.2C19 18.8802 19 19.7202 18.673 20.362C18.3854 20.9265 17.9265 21.3854 17.362 21.673C16.7202 22 15.8802 22 14.2 22H9.8C8.11984 22 7.27976 22 6.63803 21.673C6.07354 21.3854 5.6146 20.9265 5.32698 20.362C5 19.7202 5 18.8802 5 17.2V6",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Xd = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9 3H15M3 6H21M19 6L18.2987 16.5193C18.1935 18.0975 18.1409 18.8867 17.8 19.485C17.4999 20.0118 17.0472 20.4353 16.5017 20.6997C15.882 21 15.0911 21 13.5093 21H10.4907C8.90891 21 8.11803 21 7.49834 20.6997C6.95276 20.4353 6.50009 20.0118 6.19998 19.485C5.85911 18.8867 5.8065 18.0975 5.70129 16.5193L5 6M10 10.5V15.5M14 10.5V15.5",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Zd = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9 3H15M3 6H21M19 6L18.2987 16.5193C18.1935 18.0975 18.1409 18.8867 17.8 19.485C17.4999 20.0118 17.0472 20.4353 16.5017 20.6997C15.882 21 15.0911 21 13.5093 21H10.4907C8.90891 21 8.11803 21 7.49834 20.6997C6.95276 20.4353 6.50009 20.0118 6.19998 19.485C5.85911 18.8867 5.8065 18.0975 5.70129 16.5193L5 6",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Qd = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M21 15V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V15M17 8L12 3M12 3L7 8M12 3V15",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), $d = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M21 3H3M18 13L12 7M12 7L6 13M12 7V21",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ef = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M16 12L12 8M12 8L8 12M12 8V16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), tf = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M16 12L12 8M12 8L8 12M12 8V17.2C12 18.5907 12 19.2861 12.5505 20.0646C12.9163 20.5819 13.9694 21.2203 14.5972 21.3054C15.5421 21.4334 15.9009 21.2462 16.6186 20.8719C19.8167 19.2036 22 15.8568 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 15.7014 4.01099 18.9331 7 20.6622",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), nf = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M4 16.2422C2.79401 15.435 2 14.0602 2 12.5C2 10.1564 3.79151 8.23129 6.07974 8.01937C6.54781 5.17213 9.02024 3 12 3C14.9798 3 17.4522 5.17213 17.9203 8.01937C20.2085 8.23129 22 10.1564 22 12.5C22 14.0602 21.206 15.435 20 16.2422M8 16L12 12M12 12L16 16M12 12V21",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), rf = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M8 16L12 12M12 12L16 16M12 12V21M20 16.7428C21.2215 15.734 22 14.2079 22 12.5C22 9.46243 19.5376 7 16.5 7C16.2815 7 16.0771 6.886 15.9661 6.69774C14.6621 4.48484 12.2544 3 9.5 3C5.35786 3 2 6.35786 2 10.5C2 12.5661 2.83545 14.4371 4.18695 15.7935",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), af = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 2V7M12 2C11.2867 2 10.5909 2.07467 9.91991 2.21663M12 2C12.7132 2 13.4091 2.07467 14.08 2.21663M12 7C9.23855 7 7 9.2386 7 12M12 7C14.7614 7 17 9.2386 17 12M12 17V22M12 17C14.7614 17 17 14.7614 17 12M12 17C9.23855 17 7 14.7614 7 12M12 22C12.7122 22 13.407 21.9255 14.077 21.784M12 22C11.2851 22 10.5878 21.925 9.91545 21.7824M4.92891 4.92893L8.46444 8.46447M15.5355 15.5355L19.071 19.0711M2 12H7M2 12C2 12.7133 2.07466 13.4092 2.21664 14.0802M2 12C2 11.2857 2.07488 10.5888 2.21727 9.91683M17 12H22M22 12C22 11.2867 21.9253 10.5908 21.7833 9.91978M22 12C22 12.7131 21.9254 13.4086 21.7835 14.0794M4.92891 19.0711L8.46444 15.5355M15.5355 8.46447L19.071 4.92893M17.4466 3.61208C18.621 4.37619 19.6249 5.38023 20.3888 6.55469M20.386 17.4496C19.622 18.6229 18.6183 19.626 17.4445 20.3893M6.55371 20.3882C5.38104 19.6252 4.37831 18.623 3.61474 17.4508M3.61171 6.55387C4.37545 5.37994 5.37894 4.37633 6.55275 3.61244",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), of = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M17 7L7 17M7 7L17 17",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), sf = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M15 9L9 15M9 9L15 15M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), cf = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M18 6L6 18M6 6L18 18",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), lf = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9 9L15 15M15 9L9 15M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), uf = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M13 2L4.09344 12.6879C3.74463 13.1064 3.57023 13.3157 3.56756 13.4925C3.56524 13.6461 3.63372 13.7923 3.75324 13.8889C3.89073 14 4.16316 14 4.70802 14H12L11 22L19.9065 11.3121C20.2553 10.8936 20.4297 10.6843 20.4324 10.5075C20.4347 10.3539 20.3663 10.2077 20.2467 10.1111C20.1092 10 19.8368 10 19.292 10H12L13 2Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), df = (e) => /* @__PURE__ */ o("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ a("path", {
		d: "M12 5.5L7.36159 12.2468C7.08236 12.6529 6.94275 12.856 6.95113 13.0248C6.95843 13.1718 7.03015 13.3082 7.14716 13.3975C7.28151 13.5 7.52794 13.5 8.02082 13.5H12V18.5L16.6384 11.7532C16.9176 11.3471 17.0573 11.144 17.0489 10.9752C17.0416 10.8282 16.9699 10.6918 16.8528 10.6025C16.7185 10.5 16.4721 10.5 15.9792 10.5H12V5.5Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ a("path", {
		d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
}), ff = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9 17.5H3.5M6.5 12H2M9 6.5H4M17 3L10.4036 12.235C10.1116 12.6438 9.96562 12.8481 9.97194 13.0185C9.97744 13.1669 10.0486 13.3051 10.1661 13.3958C10.3011 13.5 10.5522 13.5 11.0546 13.5H16L15 21L21.5964 11.765C21.8884 11.3562 22.0344 11.1519 22.0281 10.9815C22.0226 10.8331 21.9514 10.6949 21.8339 10.6042C21.6989 10.5 21.4478 10.5 20.9454 10.5H16L17 3Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), pf = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M8 8L4.09346 12.6879C3.74465 13.1064 3.57024 13.3157 3.56758 13.4925C3.56526 13.6461 3.63373 13.7923 3.75326 13.8889C3.89075 14 4.16318 14 4.70803 14H12L11 22L16 16M15.65 10H19.292C19.8368 10 20.1093 10 20.2467 10.1111C20.3663 10.2077 20.4347 10.3539 20.4324 10.5075C20.4298 10.6843 20.2554 10.8936 19.9065 11.3121L18.5502 12.9397M10.5728 4.91265L13 2L12.4002 6.79771M21 21L3 3",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), mf = (e) => /* @__PURE__ */ o("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ a("path", {
		d: "M3 7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ a("path", {
		d: "M12 6L7.4336 12.2269C7.13256 12.6374 6.98205 12.8427 6.9869 13.0142C6.99113 13.1634 7.06185 13.303 7.17972 13.3947C7.31514 13.5 7.56967 13.5 8.07872 13.5H12V18L16.5664 11.7731C16.8674 11.3626 17.018 11.1573 17.0131 10.9858C17.0089 10.8366 16.9381 10.697 16.8203 10.6053C16.6849 10.5 16.4303 10.5 15.9213 10.5H12V6Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
}), hf = /* @__PURE__ */ k({
	Activity: () => Pc,
	ActivityHeart: () => Fc,
	Anchor: () => Ic,
	Archive: () => Lc,
	Asterisk01: () => Rc,
	Asterisk02: () => zc,
	AtSign: () => Bc,
	Bookmark: () => Vc,
	BookmarkAdd: () => Hc,
	BookmarkCheck: () => Uc,
	BookmarkMinus: () => Wc,
	BookmarkX: () => Gc,
	Building01: () => Kc,
	Building02: () => qc,
	Building03: () => Jc,
	Building04: () => Yc,
	Building05: () => Xc,
	Building06: () => Zc,
	Building07: () => Qc,
	Building08: () => $c,
	Check: () => el,
	CheckCircle: () => tl,
	CheckCircleBroken: () => nl,
	CheckDone01: () => rl,
	CheckDone02: () => il,
	CheckHeart: () => al,
	CheckSquare: () => ol,
	CheckSquareBroken: () => sl,
	CheckVerified01: () => cl,
	CheckVerified02: () => ll,
	CheckVerified03: () => ul,
	CloudBlank01: () => dl,
	CloudBlank02: () => fl,
	Container: () => pl,
	Copy01: () => ml,
	Copy02: () => hl,
	Copy03: () => gl,
	Copy04: () => _l,
	Copy05: () => vl,
	Copy06: () => yl,
	Copy07: () => bl,
	Divide01: () => xl,
	Divide02: () => Sl,
	Divide03: () => Cl,
	DotsGrid: () => wl,
	DotsHorizontal: () => Tl,
	DotsVertical: () => El,
	Download01: () => Dl,
	Download02: () => Ol,
	Download03: () => kl,
	Download04: () => Al,
	DownloadCloud01: () => jl,
	DownloadCloud02: () => Ml,
	Edit01: () => Nl,
	Edit02: () => Pl,
	Edit03: () => Fl,
	Edit04: () => Il,
	Edit05: () => Ll,
	Equal: () => Rl,
	EqualNot: () => zl,
	Eye: () => Bl,
	EyeOff: () => Vl,
	FilterFunnel01: () => Hl,
	FilterFunnel02: () => Ul,
	FilterLines: () => Wl,
	GoogleChrome: () => Gl,
	Hash01: () => Kl,
	Hash02: () => ql,
	Heart: () => Jl,
	HeartCircle: () => Yl,
	HeartHand: () => Xl,
	HeartOctagon: () => Zl,
	HeartRounded: () => Ql,
	HeartSquare: () => eu,
	Hearts: () => $l,
	HelpCircle: () => tu,
	HelpHexagon: () => nu,
	HelpOctagon: () => ru,
	HelpOctagon01: () => iu,
	HelpSquare: () => au,
	Home01: () => ou,
	Home02: () => su,
	Home03: () => cu,
	Home04: () => lu,
	Home05: () => uu,
	HomeLine: () => du,
	HomeSmile: () => fu,
	InfoCircle: () => pu,
	InfoHexagon: () => mu,
	InfoOctagon: () => hu,
	InfoSquare: () => gu,
	LayersTwo01: () => _u,
	LifeBuoy01: () => vu,
	LifeBuoy02: () => yu,
	Link01: () => bu,
	Link02: () => xu,
	Link03: () => Su,
	Link04: () => Cu,
	Link05: () => wu,
	LinkBroken01: () => Tu,
	LinkBroken02: () => Eu,
	LinkExternal01: () => Du,
	LinkExternal02: () => Ou,
	Loading01: () => ku,
	Loading02: () => Au,
	Loading03: () => ju,
	LogIn01: () => Mu,
	LogIn02: () => Nu,
	LogIn03: () => Pu,
	LogIn04: () => Fu,
	LogOut01: () => Iu,
	LogOut02: () => Lu,
	LogOut03: () => Ru,
	LogOut04: () => zu,
	MedicalCircle: () => Bu,
	MedicalCross: () => Vu,
	MedicalSquare: () => Hu,
	Menu01: () => Uu,
	Menu02: () => Wu,
	Menu03: () => Gu,
	Menu04: () => Ku,
	Menu05: () => qu,
	MessageSmileCircle: () => Ju,
	Minus: () => Yu,
	MinusCircle: () => Xu,
	MinusSquare: () => Zu,
	Percent01: () => Qu,
	Percent02: () => $u,
	Percent03: () => ed,
	Pin01: () => td,
	Pin02: () => nd,
	Placeholder: () => rd,
	Plus: () => id,
	PlusCircle: () => ad,
	PlusSquare: () => od,
	Save01: () => sd,
	Save02: () => cd,
	Save03: () => ld,
	SearchLg: () => ud,
	SearchMd: () => dd,
	SearchRefraction: () => fd,
	SearchSm: () => pd,
	Settings01: () => md,
	Settings02: () => hd,
	Settings03: () => gd,
	Settings04: () => _d,
	Share01: () => vd,
	Share02: () => yd,
	Share03: () => bd,
	Share04: () => xd,
	Share05: () => Sd,
	Share06: () => Cd,
	Share07: () => wd,
	SlashCircle01: () => Td,
	SlashCircle02: () => Ed,
	SlashDivider: () => Dd,
	SlashOctagon: () => Od,
	Speedometer01: () => kd,
	Speedometer02: () => Ad,
	Speedometer03: () => jd,
	Speedometer04: () => Md,
	Target01: () => Nd,
	Target02: () => Pd,
	Target03: () => Fd,
	Target04: () => Id,
	Target05: () => Ld,
	ToggleLeft01: () => Rd,
	ToggleLeft02: () => Bd,
	ToggleLeft03: () => Hd,
	ToggleRight01: () => zd,
	ToggleRight02: () => Vd,
	ToggleRight03: () => Ud,
	Tool01: () => Wd,
	Tool02: () => Gd,
	Translate01: () => Kd,
	Translate02: () => qd,
	Trash01: () => Jd,
	Trash02: () => Yd,
	Trash03: () => Xd,
	Trash04: () => Zd,
	Upload01: () => Qd,
	Upload02: () => $d,
	Upload03: () => ef,
	Upload04: () => tf,
	UploadCloud01: () => nf,
	UploadCloud02: () => rf,
	Virus: () => af,
	X: () => of,
	XCircle: () => sf,
	XClose: () => cf,
	XSquare: () => lf,
	Zap: () => uf,
	ZapCircle: () => df,
	ZapFast: () => ff,
	ZapOff: () => pf,
	ZapSquare: () => mf
}), gf = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M21 12L9 12M21 6L9 6M21 18L9 18M5 12C5 12.5523 4.55228 13 4 13C3.44772 13 3 12.5523 3 12C3 11.4477 3.44772 11 4 11C4.55228 11 5 11.4477 5 12ZM5 6C5 6.55228 4.55228 7 4 7C3.44772 7 3 6.55228 3 6C3 5.44772 3.44772 5 4 5C4.55228 5 5 5.44772 5 6ZM5 18C5 18.5523 4.55228 19 4 19C3.44772 19 3 18.5523 3 18C3 17.4477 3.44772 17 4 17C4.55228 17 5 17.4477 5 18Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), _f = /* @__PURE__ */ k({ List: () => gf }), vf = /* @__PURE__ */ k({}), yf = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M19.0003 18.9999H4.99969V5.00006H11.25V3H4.99969C3.89958 3 3 3.89986 3 5.00006V18.9999C3 20.1001 3.89958 21 4.99969 21H19.0003C20.1004 21 21 20.1001 21 18.9999V12.75H19.0003V18.9999ZM13.5 3V5.00006H17.6003L7.49995 15.1L8.89992 16.5L19.0004 6.3998V10.5H21V3H13.5Z",
		fill: "white"
	})
}), bf = (e) => /* @__PURE__ */ o("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ o("g", {
		clipPath: "url(#clip0_3304_471201)",
		children: [/* @__PURE__ */ a("path", {
			d: "M9.53834 1.60996C9.70914 1.19932 10.2909 1.19932 10.4617 1.60996L12.5278 6.57744C12.5998 6.75056 12.7626 6.86885 12.9495 6.88383L18.3123 7.31376C18.7556 7.3493 18.9354 7.90256 18.5976 8.19189L14.5117 11.6919C14.3693 11.8139 14.3071 12.0053 14.3506 12.1876L15.5989 17.4208C15.7021 17.8534 15.2315 18.1954 14.8519 17.9635L10.2606 15.1592C10.1006 15.0615 9.89938 15.0615 9.73937 15.1592L5.14806 17.9635C4.76851 18.1954 4.29788 17.8534 4.40108 17.4208L5.64939 12.1876C5.69289 12.0053 5.6307 11.8139 5.48831 11.6919L1.40241 8.19189C1.06464 7.90256 1.24441 7.3493 1.68773 7.31376L7.05054 6.88383C7.23744 6.86885 7.40024 6.75056 7.47225 6.57744L9.53834 1.60996Z",
			fill: "#F2F4F7"
		}), /* @__PURE__ */ a("g", {
			clipPath: "url(#clip1_3304_471201)",
			children: /* @__PURE__ */ a("path", {
				d: "M9.53834 1.60996C9.70914 1.19932 10.2909 1.19932 10.4617 1.60996L12.5278 6.57744C12.5998 6.75056 12.7626 6.86885 12.9495 6.88383L18.3123 7.31376C18.7556 7.3493 18.9354 7.90256 18.5976 8.19189L14.5117 11.6919C14.3693 11.8139 14.3071 12.0053 14.3506 12.1876L15.5989 17.4208C15.7021 17.8534 15.2315 18.1954 14.8519 17.9635L10.2606 15.1592C10.1006 15.0615 9.89938 15.0615 9.73937 15.1592L5.14806 17.9635C4.76851 18.1954 4.29788 17.8534 4.40108 17.4208L5.64939 12.1876C5.69289 12.0053 5.6307 11.8139 5.48831 11.6919L1.40241 8.19189C1.06464 7.90256 1.24441 7.3493 1.68773 7.31376L7.05054 6.88383C7.23744 6.86885 7.40024 6.75056 7.47225 6.57744L9.53834 1.60996Z",
				fill: "#101828"
			})
		})]
	}), /* @__PURE__ */ o("defs", { children: [/* @__PURE__ */ a("clipPath", {
		id: "clip0_3304_471201",
		children: /* @__PURE__ */ a("rect", {
			width: 20,
			height: 20,
			fill: "white"
		})
	}), /* @__PURE__ */ a("clipPath", {
		id: "clip1_3304_471201",
		children: /* @__PURE__ */ a("rect", {
			width: 20,
			height: 20,
			fill: "white"
		})
	})] })]
}), xf = /* @__PURE__ */ k({
	AndroidOpen1: () => yf,
	Star100: () => bf
}), Sf = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M8 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V8M8 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V16M21 8V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H16M21 16V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H16M7.5 8V9.5M16.5 8V9.5M11 12.6001C11.8 12.6001 12.5 11.9001 12.5 11.1001V8M15.2002 15.2C13.4002 17 10.5002 17 8.7002 15.2",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Cf = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M7.5 8V9.5M16.5 8V9.5M11 12.6001C11.8 12.6001 12.5 11.9001 12.5 11.1001V8M15.2002 15.2C13.4002 17 10.5002 17 8.7002 15.2M3 7.8L3 16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27977 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3L7.8 3C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), wf = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M20 10V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H10.5M19.25 17V15.25C19.25 14.2835 18.4665 13.5 17.5 13.5C16.5335 13.5 15.75 14.2835 15.75 15.25V17M15.6 21H19.4C19.9601 21 20.2401 21 20.454 20.891C20.6422 20.7951 20.7951 20.6422 20.891 20.454C21 20.2401 21 19.9601 21 19.4V18.6C21 18.0399 21 17.7599 20.891 17.546C20.7951 17.3578 20.6422 17.2049 20.454 17.109C20.2401 17 19.9601 17 19.4 17H15.6C15.0399 17 14.7599 17 14.546 17.109C14.3578 17.2049 14.2049 17.3578 14.109 17.546C14 17.7599 14 18.0399 14 18.6V19.4C14 19.9601 14 20.2401 14.109 20.454C14.2049 20.6422 14.3578 20.7951 14.546 20.891C14.7599 21 15.0399 21 15.6 21Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Tf = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M20 10V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H10.5M13 11H8M11 15H8M16 7H8M19.25 17V15.25C19.25 14.2835 18.4665 13.5 17.5 13.5C16.5335 13.5 15.75 14.2835 15.75 15.25V17M15.6 21H19.4C19.9601 21 20.2401 21 20.454 20.891C20.6422 20.7951 20.7951 20.6422 20.891 20.454C21 20.2401 21 19.9601 21 19.4V18.6C21 18.0399 21 17.7599 20.891 17.546C20.7951 17.3578 20.6422 17.2049 20.454 17.109C20.2401 17 19.9601 17 19.4 17H15.6C15.0399 17 14.7599 17 14.546 17.109C14.3578 17.2049 14.2049 17.3578 14.109 17.546C14 17.7599 14 18.0399 14 18.6V19.4C14 19.9601 14 20.2401 14.109 20.454C14.2049 20.6422 14.3578 20.7951 14.546 20.891C14.7599 21 15.0399 21 15.6 21Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ef = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M14 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H15.2C16.8802 22 17.7202 22 18.362 21.673C18.9265 21.3854 19.3854 20.9265 19.673 20.362C20 19.7202 20 18.8802 20 17.2V8M14 2L20 8M14 2V8H20M13.75 14V12.25C13.75 11.2835 12.9665 10.5 12 10.5C11.0335 10.5 10.25 11.2835 10.25 12.25V14M10.1 18H13.9C14.4601 18 14.7401 18 14.954 17.891C15.1422 17.7951 15.2951 17.6422 15.391 17.454C15.5 17.2401 15.5 16.9601 15.5 16.4V15.6C15.5 15.0399 15.5 14.7599 15.391 14.546C15.2951 14.3578 15.1422 14.2049 14.954 14.109C14.7401 14 14.4601 14 13.9 14H10.1C9.53995 14 9.25992 14 9.04601 14.109C8.85785 14.2049 8.70487 14.3578 8.60899 14.546C8.5 14.7599 8.5 15.0399 8.5 15.6V16.4C8.5 16.9601 8.5 17.2401 8.60899 17.454C8.70487 17.6422 8.85785 17.7951 9.04601 17.891C9.25992 18 9.53995 18 10.1 18Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Df = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M20 10V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H12.5M18 21C18 21 21 19.5701 21 17.4252V14.9229L18.8124 14.1412C18.2868 13.9529 17.712 13.9529 17.1864 14.1412L15 14.9229V17.4252C15 19.5701 18 21 18 21Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Of = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M14 11H8M10 15H8M16 7H8M20 10V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H12.5M18 21C18 21 21 19.5701 21 17.4252V14.9229L18.8124 14.1412C18.2868 13.9529 17.712 13.9529 17.1864 14.1412L15 14.9229V17.4252C15 19.5701 18 21 18 21Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), kf = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M14 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H15.2C16.8802 22 17.7202 22 18.362 21.673C18.9265 21.3854 19.3854 20.9265 19.673 20.362C20 19.7202 20 18.8802 20 17.2V8M14 2L20 8M14 2V8H20M12 18C12 18 15 16.5701 15 14.4252V11.9229L12.8124 11.1412C12.2868 10.9529 11.712 10.9529 11.1864 11.1412L9 11.9229V14.4252C9 16.5701 12 18 12 18Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Af = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M6.91822 3.38565C8.40742 2.50524 10.1447 2 12 2C17.5228 2 22 6.47715 22 12C22 12.0331 21.9998 12.0662 21.9995 12.0993M3.38114 6.92585C2.50352 8.41335 2 10.1479 2 12C2 16.6596 5.18693 20.5748 9.5 21.685M20.7076 16.9206C19.3872 19.2522 17.1574 21.001 14.5 21.685M14.0893 6.37378C13.4387 6.13207 12.7348 6 12 6C8.68629 6 6 8.68629 6 12C6 12.7387 6.13351 13.4463 6.37772 14.0999M17.6251 9.90767C17.8675 10.5591 18 11.2641 18 12C18 15.3137 15.3137 18 12 18C11.2701 18 10.5707 17.8697 9.92373 17.631M12 10V14",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), jf = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 10V14M7.44712 3.42103C8.73941 2.52503 10.3084 2 12 2C16.4183 2 20 5.58172 20 10V11.2367M4.41632 7.44607C4.14633 8.24809 4 9.10696 4 10V14C4 17.6349 6.42416 20.7035 9.74396 21.6775M19.6588 16.3187C18.9294 18.7314 17.0911 20.6626 14.7367 21.5196M14.325 6.14635C13.6464 5.7361 12.8508 5.5 12 5.5C9.51472 5.5 7.5 7.51472 7.5 10V12.95M16.5 11.04V14C16.5 16.4853 14.4853 18.5 12 18.5C11.1514 18.5 10.3576 18.2651 9.68014 17.8567",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Mf = (e) => /* @__PURE__ */ o("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ a("path", {
			d: "M8.10008 21.221C6.71021 19.2375 5.89258 16.8243 5.89258 14.2187C5.89258 10.8443 8.6265 8.10938 11.9989 8.10938C15.3712 8.10938 18.1051 10.8443 18.1051 14.2187",
			stroke: "black",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ a("path", {
			d: "M8.10008 21.221C6.71021 19.2375 5.89258 16.8243 5.89258 14.2187C5.89258 10.8443 8.6265 8.10938 11.9989 8.10938C15.3712 8.10938 18.1051 10.8443 18.1051 14.2187",
			stroke: "black",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ a("path", {
			d: "M18.4359 20.3118C18.3259 20.3179 18.218 20.3281 18.107 20.3281C14.7347 20.3281 12.0007 17.5931 12.0007 14.2188",
			stroke: "black",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ a("path", {
			d: "M18.4361 20.3118C18.3262 20.3179 18.2182 20.3281 18.1073 20.3281C14.7349 20.3281 12.001 17.5931 12.001 14.2188",
			stroke: "black",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ a("path", {
			d: "M13.2694 21.9999C10.675 20.382 8.94705 17.5024 8.94705 14.2187C8.94705 12.5315 10.3145 11.164 12.0007 11.164C13.6869 11.164 15.0543 12.5315 15.0543 14.2187C15.0543 15.9059 16.4218 17.2733 18.108 17.2733C19.7942 17.2733 21.1616 15.9059 21.1616 14.2187C21.1616 9.1571 17.0602 5.05469 12.0017 5.05469C6.94319 5.05469 2.8418 9.1571 2.8418 14.2187C2.8418 15.3469 2.96806 16.4455 3.20021 17.5045",
			stroke: "black",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ a("path", {
			d: "M13.2694 21.9999C10.675 20.382 8.94705 17.5024 8.94705 14.2187C8.94705 12.5315 10.3145 11.164 12.0007 11.164C13.6869 11.164 15.0543 12.5315 15.0543 14.2187C15.0543 15.9059 16.4218 17.2733 18.108 17.2733C19.7942 17.2733 21.1616 15.9059 21.1616 14.2187C21.1616 9.1571 17.0602 5.05469 12.0017 5.05469C6.94319 5.05469 2.8418 9.1571 2.8418 14.2187C2.8418 15.3469 2.96806 16.4455 3.20021 17.5045",
			stroke: "black",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ a("path", {
			d: "M20.5257 5.86313C18.4435 3.4978 15.399 2 12.0002 2C8.60136 2 5.55687 3.4978 3.47461 5.86313",
			stroke: "black",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ a("path", {
			d: "M20.5257 5.86313C18.4435 3.4978 15.399 2 12.0002 2C8.60136 2 5.55687 3.4978 3.47461 5.86313",
			stroke: "black",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
}), Nf = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M5.80688 18.5304C5.82459 18.5005 5.84273 18.4709 5.8613 18.4413C7.2158 16.2881 7.99991 13.7418 7.99991 11C7.99991 8.79086 9.79077 7 11.9999 7C14.209 7 15.9999 8.79086 15.9999 11C15.9999 12.017 15.9307 13.0186 15.7966 14M13.6792 20.8436C14.2909 19.6226 14.7924 18.3369 15.1707 17M19.0097 18.132C19.6547 15.8657 20 13.4732 20 11C20 6.58172 16.4183 3 12 3C10.5429 3 9.17669 3.38958 8 4.07026M3 15.3641C3.64066 14.0454 4 12.5646 4 11C4 9.54285 4.38958 8.17669 5.07026 7M11.9999 11C11.9999 14.5172 10.9911 17.7988 9.24707 20.5712",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Pf = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M13 7L11.8845 4.76892C11.5634 4.1268 11.4029 3.80573 11.1634 3.57116C10.9516 3.36373 10.6963 3.20597 10.4161 3.10931C10.0992 3 9.74021 3 9.02229 3H5.2C4.0799 3 3.51984 3 3.09202 3.21799C2.71569 3.40973 2.40973 3.71569 2.21799 4.09202C2 4.51984 2 5.0799 2 6.2V7M2 7H17.2C18.8802 7 19.7202 7 20.362 7.32698C20.9265 7.6146 21.3854 8.07354 21.673 8.63803C22 9.27976 22 10.1198 22 11.8V16.2C22 17.8802 22 18.7202 21.673 19.362C21.3854 19.9265 20.9265 20.3854 20.362 20.673C19.7202 21 18.8802 21 17.2 21H6.8C5.11984 21 4.27976 21 3.63803 20.673C3.07354 20.3854 2.6146 19.9265 2.32698 19.362C2 18.7202 2 17.8802 2 16.2V7ZM12 17.5C12 17.5 15 16.0701 15 13.9252V11.4229L12.8124 10.6412C12.2868 10.4529 11.712 10.4529 11.1864 10.6412L9 11.4229V13.9252C9 16.0701 12 17.5 12 17.5Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ff = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M17 8.99994C17 8.48812 16.8047 7.9763 16.4142 7.58579C16.0237 7.19526 15.5118 7 15 7M15 15C18.3137 15 21 12.3137 21 9C21 5.68629 18.3137 3 15 3C11.6863 3 9 5.68629 9 9C9 9.27368 9.01832 9.54308 9.05381 9.80704C9.11218 10.2412 9.14136 10.4583 9.12172 10.5956C9.10125 10.7387 9.0752 10.8157 9.00469 10.9419C8.937 11.063 8.81771 11.1823 8.57913 11.4209L3.46863 16.5314C3.29568 16.7043 3.2092 16.7908 3.14736 16.8917C3.09253 16.9812 3.05213 17.0787 3.02763 17.1808C3 17.2959 3 17.4182 3 17.6627V19.4C3 19.9601 3 20.2401 3.10899 20.454C3.20487 20.6422 3.35785 20.7951 3.54601 20.891C3.75992 21 4.03995 21 4.6 21H7V19H9V17H11L12.5791 15.4209C12.8177 15.1823 12.937 15.063 13.0581 14.9953C13.1843 14.9248 13.2613 14.8987 13.4044 14.8783C13.5417 14.8586 13.7588 14.8878 14.193 14.9462C14.4569 14.9817 14.7263 15 15 15Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), If = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M15 9H15.01M15 15C18.3137 15 21 12.3137 21 9C21 5.68629 18.3137 3 15 3C11.6863 3 9 5.68629 9 9C9 9.27368 9.01832 9.54308 9.05381 9.80704C9.11218 10.2412 9.14136 10.4583 9.12172 10.5956C9.10125 10.7387 9.0752 10.8157 9.00469 10.9419C8.937 11.063 8.81771 11.1823 8.57913 11.4209L3.46863 16.5314C3.29568 16.7043 3.2092 16.7908 3.14736 16.8917C3.09253 16.9812 3.05213 17.0787 3.02763 17.1808C3 17.2959 3 17.4182 3 17.6627V19.4C3 19.9601 3 20.2401 3.10899 20.454C3.20487 20.6422 3.35785 20.7951 3.54601 20.891C3.75992 21 4.03995 21 4.6 21H6.33726C6.58185 21 6.70414 21 6.81923 20.9724C6.92127 20.9479 7.01881 20.9075 7.10828 20.8526C7.2092 20.7908 7.29568 20.7043 7.46863 20.5314L12.5791 15.4209C12.8177 15.1823 12.937 15.063 13.0581 14.9953C13.1843 14.9248 13.2613 14.8987 13.4044 14.8783C13.5417 14.8586 13.7588 14.8878 14.193 14.9462C14.4569 14.9817 14.7263 15 15 15Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Lf = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M17 10V8C17 5.23858 14.7614 3 12 3C9.23858 3 7 5.23858 7 8V10M12 14.5V16.5M8.8 21H15.2C16.8802 21 17.7202 21 18.362 20.673C18.9265 20.3854 19.3854 19.9265 19.673 19.362C20 18.7202 20 17.8802 20 16.2V14.8C20 13.1198 20 12.2798 19.673 11.638C19.3854 11.0735 18.9265 10.6146 18.362 10.327C17.7202 10 16.8802 10 15.2 10H8.8C7.11984 10 6.27976 10 5.63803 10.327C5.07354 10.6146 4.6146 11.0735 4.32698 11.638C4 12.2798 4 13.1198 4 14.8V16.2C4 17.8802 4 18.7202 4.32698 19.362C4.6146 19.9265 5.07354 20.3854 5.63803 20.673C6.27976 21 7.11984 21 8.8 21Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Rf = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M17 11V8C17 5.23858 14.7614 3 12 3C9.23858 3 7 5.23858 7 8V11M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V15.8C21 14.1198 21 13.2798 20.673 12.638C20.3854 12.0735 19.9265 11.6146 19.362 11.327C18.7202 11 17.8802 11 16.2 11H7.8C6.11984 11 5.27976 11 4.63803 11.327C4.07354 11.6146 3.6146 12.0735 3.32698 12.638C3 13.2798 3 14.1198 3 15.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), zf = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M17 11V8C17 5.23858 14.7614 3 12 3C9.23858 3 7 5.23858 7 8V11M8.8 21H15.2C16.8802 21 17.7202 21 18.362 20.673C18.9265 20.3854 19.3854 19.9265 19.673 19.362C20 18.7202 20 17.8802 20 16.2V15.8C20 14.1198 20 13.2798 19.673 12.638C19.3854 12.0735 18.9265 11.6146 18.362 11.327C17.7202 11 16.8802 11 15.2 11H8.8C7.11984 11 6.27976 11 5.63803 11.327C5.07354 11.6146 4.6146 12.0735 4.32698 12.638C4 13.2798 4 14.1198 4 15.8V16.2C4 17.8802 4 18.7202 4.32698 19.362C4.6146 19.9265 5.07354 20.3854 5.63803 20.673C6.27976 21 7.11984 21 8.8 21Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Bf = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M7.10102 10H7V8C7 5.23858 9.23858 3 12 3C14.7614 3 17 5.23858 17 8V10H16.899M12 14V16M19 15C19 18.866 15.866 22 12 22C8.13401 22 5 18.866 5 15C5 11.134 8.13401 8 12 8C15.866 8 19 11.134 19 15Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Vf = (e) => /* @__PURE__ */ o("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ a("path", {
		d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ a("path", {
		d: "M13.7316 13.1947C13.661 12.9831 13.6257 12.8772 13.6276 12.7907C13.6295 12.6996 13.6417 12.6519 13.6836 12.5711C13.7235 12.4942 13.83 12.395 14.0432 12.1967C14.6318 11.649 15 10.8675 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 10.8675 9.36818 11.649 9.95681 12.1967C10.17 12.395 10.2765 12.4942 10.3164 12.5711C10.3583 12.6519 10.3705 12.6996 10.3724 12.7907C10.3743 12.8772 10.339 12.9831 10.2684 13.1947L9.35099 15.947C9.23249 16.3025 9.17324 16.4803 9.20877 16.6218C9.23987 16.7456 9.31718 16.8529 9.42484 16.9216C9.54783 17 9.7352 17 10.1099 17H13.8901C14.2648 17 14.4522 17 14.5752 16.9216C14.6828 16.8529 14.7601 16.7456 14.7912 16.6218C14.8268 16.4803 14.7675 16.3025 14.649 15.947L13.7316 13.1947Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
}), Hf = (e) => /* @__PURE__ */ o("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ a("path", {
		d: "M16.2 21C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27977 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3L7.8 3C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8L3 16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H16.2Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ a("path", {
		d: "M13.7316 13.1947C13.661 12.9831 13.6257 12.8772 13.6276 12.7907C13.6295 12.6996 13.6417 12.6519 13.6836 12.5711C13.7235 12.4942 13.83 12.395 14.0432 12.1967C14.6318 11.6489 15 10.8675 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 10.8675 9.36818 11.649 9.95681 12.1967C10.17 12.395 10.2765 12.4942 10.3164 12.5711C10.3583 12.6519 10.3705 12.6996 10.3724 12.7907C10.3743 12.8772 10.339 12.9831 10.2684 13.1947L9.35099 15.947C9.23249 16.3025 9.17324 16.4803 9.20877 16.6218C9.23987 16.7456 9.31718 16.8529 9.42484 16.9216C9.54783 17 9.7352 17 10.1099 17H13.8901C14.2648 17 14.4522 17 14.5752 16.9216C14.6828 16.8529 14.7601 16.7456 14.7912 16.6218C14.8268 16.4803 14.7675 16.3025 14.649 15.947L13.7316 13.1947Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
}), Uf = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M7 10V8C7 5.23858 9.23858 3 12 3C14.0503 3 15.8124 4.2341 16.584 6M12 14.5V16.5M8.8 21H15.2C16.8802 21 17.7202 21 18.362 20.673C18.9265 20.3854 19.3854 19.9265 19.673 19.362C20 18.7202 20 17.8802 20 16.2V14.8C20 13.1198 20 12.2798 19.673 11.638C19.3854 11.0735 18.9265 10.6146 18.362 10.327C17.7202 10 16.8802 10 15.2 10H8.8C7.11984 10 6.27976 10 5.63803 10.327C5.07354 10.6146 4.6146 11.0735 4.32698 11.638C4 12.2798 4 13.1198 4 14.8V16.2C4 17.8802 4 18.7202 4.32698 19.362C4.6146 19.9265 5.07354 20.3854 5.63803 20.673C6.27976 21 7.11984 21 8.8 21Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Wf = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M7 11V8C7 5.23858 9.23858 3 12 3C14.419 3 16.4367 4.71776 16.9 7M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V15.8C21 14.1198 21 13.2798 20.673 12.638C20.3854 12.0735 19.9265 11.6146 19.362 11.327C18.7202 11 17.8802 11 16.2 11H7.8C6.11984 11 5.27976 11 4.63803 11.327C4.07354 11.6146 3.6146 12.0735 3.32698 12.638C3 13.2798 3 14.1198 3 15.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Gf = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M7 11V8C7 5.23858 9.23858 3 12 3C14.419 3 16.4367 4.71776 16.9 7M8.8 21H15.2C16.8802 21 17.7202 21 18.362 20.673C18.9265 20.3854 19.3854 19.9265 19.673 19.362C20 18.7202 20 17.8802 20 16.2V15.8C20 14.1198 20 13.2798 19.673 12.638C19.3854 12.0735 18.9265 11.6146 18.362 11.327C17.7202 11 16.8802 11 15.2 11H8.8C7.11984 11 6.27976 11 5.63803 11.327C5.07354 11.6146 4.6146 12.0735 4.32698 12.638C4 13.2798 4 14.1198 4 15.8V16.2C4 17.8802 4 18.7202 4.32698 19.362C4.6146 19.9265 5.07354 20.3854 5.63803 20.673C6.27976 21 7.11984 21 8.8 21Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Kf = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M7 10V8C7 5.23858 9.23858 3 12 3C13.6358 3 15.0882 3.78555 16.0004 5M12 14V16M19 15C19 18.866 15.866 22 12 22C8.13401 22 5 18.866 5 15C5 11.134 8.13401 8 12 8C15.866 8 19 11.134 19 15Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), qf = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 12H12.005M17 12H17.005M7 12H7.005M5.2 7H18.8C19.9201 7 20.4802 7 20.908 7.21799C21.2843 7.40973 21.5903 7.71569 21.782 8.09202C22 8.51984 22 9.0799 22 10.2V13.8C22 14.9201 22 15.4802 21.782 15.908C21.5903 16.2843 21.2843 16.5903 20.908 16.782C20.4802 17 19.9201 17 18.8 17H5.2C4.0799 17 3.51984 17 3.09202 16.782C2.71569 16.5903 2.40973 16.2843 2.21799 15.908C2 15.4802 2 14.9201 2 13.8V10.2C2 9.0799 2 8.51984 2.21799 8.09202C2.40973 7.71569 2.71569 7.40973 3.09202 7.21799C3.51984 7 4.0799 7 5.2 7ZM12.25 12C12.25 12.1381 12.1381 12.25 12 12.25C11.8619 12.25 11.75 12.1381 11.75 12C11.75 11.8619 11.8619 11.75 12 11.75C12.1381 11.75 12.25 11.8619 12.25 12ZM17.25 12C17.25 12.1381 17.1381 12.25 17 12.25C16.8619 12.25 16.75 12.1381 16.75 12C16.75 11.8619 16.8619 11.75 17 11.75C17.1381 11.75 17.25 11.8619 17.25 12ZM7.25 12C7.25 12.1381 7.13807 12.25 7 12.25C6.86193 12.25 6.75 12.1381 6.75 12C6.75 11.8619 6.86193 11.75 7 11.75C7.13807 11.75 7.25 11.8619 7.25 12Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Jf = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M22 11V8.2C22 7.0799 22 6.51984 21.782 6.09202C21.5903 5.71569 21.2843 5.40973 20.908 5.21799C20.4802 5 19.9201 5 18.8 5H5.2C4.0799 5 3.51984 5 3.09202 5.21799C2.71569 5.40973 2.40973 5.71569 2.21799 6.09202C2 6.51984 2 7.0799 2 8.2V11.8C2 12.9201 2 13.4802 2.21799 13.908C2.40973 14.2843 2.71569 14.5903 3.09202 14.782C3.51984 15 4.0799 15 5.2 15H11M12 10H12.005M17 10H17.005M7 10H7.005M19.25 17V15.25C19.25 14.2835 18.4665 13.5 17.5 13.5C16.5335 13.5 15.75 14.2835 15.75 15.25V17M12.25 10C12.25 10.1381 12.1381 10.25 12 10.25C11.8619 10.25 11.75 10.1381 11.75 10C11.75 9.86193 11.8619 9.75 12 9.75C12.1381 9.75 12.25 9.86193 12.25 10ZM17.25 10C17.25 10.1381 17.1381 10.25 17 10.25C16.8619 10.25 16.75 10.1381 16.75 10C16.75 9.86193 16.8619 9.75 17 9.75C17.1381 9.75 17.25 9.86193 17.25 10ZM7.25 10C7.25 10.1381 7.13807 10.25 7 10.25C6.86193 10.25 6.75 10.1381 6.75 10C6.75 9.86193 6.86193 9.75 7 9.75C7.13807 9.75 7.25 9.86193 7.25 10ZM15.6 21H19.4C19.9601 21 20.2401 21 20.454 20.891C20.6422 20.7951 20.7951 20.6422 20.891 20.454C21 20.2401 21 19.9601 21 19.4V18.6C21 18.0399 21 17.7599 20.891 17.546C20.7951 17.3578 20.6422 17.2049 20.454 17.109C20.2401 17 19.9601 17 19.4 17H15.6C15.0399 17 14.7599 17 14.546 17.109C14.3578 17.2049 14.2049 17.3578 14.109 17.546C14 17.7599 14 18.0399 14 18.6V19.4C14 19.9601 14 20.2401 14.109 20.454C14.2049 20.6422 14.3578 20.7951 14.546 20.891C14.7599 21 15.0399 21 15.6 21Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Yf = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M8 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V8M8 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V16M21 8V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H16M21 16V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H16M3 12H3.01M7.5 12H7.51M16.5 12H16.51M12 12H12.01M21 12H21.01",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Xf = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M11.302 21.6147C11.5234 21.7439 11.6341 21.8085 11.7903 21.842C11.9116 21.868 12.0884 21.868 12.2097 21.842C12.3659 21.8085 12.4766 21.7439 12.698 21.6147C14.646 20.4783 20 16.9083 20 11.9999V7.21747C20 6.41796 20 6.0182 19.8692 5.67457C19.7537 5.37101 19.566 5.10015 19.3223 4.8854C19.0465 4.64231 18.6722 4.50195 17.9236 4.22122L12.5618 2.21054C12.3539 2.13258 12.25 2.0936 12.143 2.07815C12.0482 2.06444 11.9518 2.06444 11.857 2.07815C11.75 2.0936 11.6461 2.13258 11.4382 2.21054L6.0764 4.22122C5.3278 4.50195 4.9535 4.64231 4.67766 4.8854C4.43398 5.10015 4.24627 5.37101 4.13076 5.67457C4 6.0182 4 6.41796 4 7.21747V11.9999C4 16.9083 9.35396 20.4783 11.302 21.6147Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Zf = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M11.302 21.6149C11.5234 21.7441 11.6341 21.8087 11.7903 21.8422C11.9116 21.8682 12.0884 21.8682 12.2097 21.8422C12.3659 21.8087 12.4766 21.7441 12.698 21.6149C14.646 20.4785 20 16.9085 20 12.0001V8.20007C20 7.12617 20 6.58923 19.8345 6.20807C19.6662 5.82067 19.4986 5.61458 19.1536 5.37097C18.8141 5.13129 18.1486 4.99289 16.8177 4.71609C15.3508 4.41101 14.2243 3.8601 13.1944 3.06339C12.7005 2.68133 12.4536 2.49031 12.2603 2.43821C12.0564 2.38323 11.9436 2.38323 11.7397 2.43821C11.5464 2.49031 11.2995 2.68134 10.8056 3.06339C9.77572 3.8601 8.6492 4.41101 7.1823 4.71609C5.85137 4.99289 5.18591 5.13129 4.84645 5.37097C4.50142 5.61458 4.33379 5.82067 4.16554 6.20807C4 6.58923 4 7.12617 4 8.20007V12.0001C4 16.9085 9.35396 20.4785 11.302 21.6149Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Qf = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 2.49987V21.4999M20 11.9999C20 16.9083 14.646 20.4783 12.698 21.6147C12.4766 21.7439 12.3659 21.8085 12.2097 21.842C12.0884 21.868 11.9116 21.868 11.7903 21.842C11.6341 21.8085 11.5234 21.7439 11.302 21.6147C9.35396 20.4783 4 16.9083 4 11.9999V7.21747C4 6.41796 4 6.0182 4.13076 5.67457C4.24627 5.37101 4.43398 5.10015 4.67766 4.8854C4.9535 4.64231 5.3278 4.50195 6.0764 4.22122L11.4382 2.21054C11.6461 2.13258 11.75 2.0936 11.857 2.07815C11.9518 2.06444 12.0482 2.06444 12.143 2.07815C12.25 2.0936 12.3539 2.13258 12.5618 2.21054L17.9236 4.22122C18.6722 4.50195 19.0465 4.64231 19.3223 4.8854C19.566 5.10015 19.7537 5.37101 19.8692 5.67457C20 6.0182 20 6.41796 20 7.21747V11.9999Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), $f = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9.21296 14.4999C9.52517 15.0944 10.1486 15.4999 10.8667 15.4999H13C14.1046 15.4999 15 14.6044 15 13.4999C15 12.3953 14.1046 11.4999 13 11.4999H11C9.89543 11.4999 9 10.6044 9 9.49987C9 8.3953 9.89543 7.49987 11 7.49987H13.1333C13.8514 7.49987 14.4748 7.90536 14.787 8.49987M12 5.99987V7.49987M12 15.4999V16.9999M20 11.9999C20 16.9083 14.646 20.4783 12.698 21.6147C12.4766 21.7439 12.3659 21.8085 12.2097 21.842C12.0884 21.868 11.9116 21.868 11.7903 21.842C11.6341 21.8085 11.5234 21.7439 11.302 21.6147C9.35396 20.4783 4 16.9083 4 11.9999V7.21747C4 6.41796 4 6.0182 4.13076 5.67457C4.24627 5.37101 4.43398 5.10015 4.67766 4.8854C4.9535 4.64231 5.3278 4.50195 6.0764 4.22122L11.4382 2.21054C11.6461 2.13258 11.75 2.0936 11.857 2.07815C11.9518 2.06444 12.0482 2.06444 12.143 2.07815C12.25 2.0936 12.3539 2.13258 12.5618 2.21054L17.9236 4.22122C18.6722 4.50195 19.0465 4.64231 19.3223 4.8854C19.566 5.10015 19.7537 5.37101 19.8692 5.67457C20 6.0182 20 6.41796 20 7.21747V11.9999Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ep = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M8.80868 3.19661L11.4382 2.21054C11.6461 2.13258 11.75 2.0936 11.857 2.07815C11.9518 2.06444 12.0482 2.06444 12.143 2.07815C12.25 2.0936 12.3539 2.13258 12.5618 2.21054L17.9236 4.22122C18.6722 4.50195 19.0465 4.64231 19.3223 4.8854C19.566 5.10015 19.7537 5.37101 19.8692 5.67457C20 6.0182 20 6.41796 20 7.21747V11.9999C20 12.7202 19.8847 13.4117 19.6818 14.0708M17.6219 17.6255C15.9362 19.5859 13.7879 20.9788 12.6996 21.6138C12.4772 21.7436 12.366 21.8085 12.2098 21.842C12.0885 21.868 11.9116 21.868 11.7904 21.842C11.6341 21.8085 11.5234 21.7439 11.302 21.6147C9.35396 20.4783 4 16.9083 4 11.9999V5.77618C4 5.30923 4.28966 4.89125 4.72688 4.72729M3 2.99987L21 20.9999",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), tp = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 14.4999V8.49987M9 11.4999H15M20 11.9999C20 16.9083 14.646 20.4783 12.698 21.6147C12.4766 21.7439 12.3659 21.8085 12.2097 21.842C12.0884 21.868 11.9116 21.868 11.7903 21.842C11.6341 21.8085 11.5234 21.7439 11.302 21.6147C9.35396 20.4783 4 16.9083 4 11.9999V7.21747C4 6.41796 4 6.0182 4.13076 5.67457C4.24627 5.37101 4.43398 5.10015 4.67766 4.8854C4.9535 4.64231 5.3278 4.50195 6.0764 4.22122L11.4382 2.21054C11.6461 2.13258 11.75 2.0936 11.857 2.07815C11.9518 2.06444 12.0482 2.06444 12.143 2.07815C12.25 2.0936 12.3539 2.13258 12.5618 2.21054L17.9236 4.22122C18.6722 4.50195 19.0465 4.64231 19.3223 4.8854C19.566 5.10015 19.7537 5.37101 19.8692 5.67457C20 6.0182 20 6.41796 20 7.21747V11.9999Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), np = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9 11.4999L11 13.4999L15.5 8.99987M20 11.9999C20 16.9083 14.646 20.4783 12.698 21.6147C12.4766 21.7439 12.3659 21.8085 12.2097 21.842C12.0884 21.868 11.9116 21.868 11.7903 21.842C11.6341 21.8085 11.5234 21.7439 11.302 21.6147C9.35396 20.4783 4 16.9083 4 11.9999V7.21747C4 6.41796 4 6.0182 4.13076 5.67457C4.24627 5.37101 4.43398 5.10015 4.67766 4.8854C4.9535 4.64231 5.3278 4.50195 6.0764 4.22122L11.4382 2.21054C11.6461 2.13258 11.75 2.0936 11.857 2.07815C11.9518 2.06444 12.0482 2.06444 12.143 2.07815C12.25 2.0936 12.3539 2.13258 12.5618 2.21054L17.9236 4.22122C18.6722 4.50195 19.0465 4.64231 19.3223 4.8854C19.566 5.10015 19.7537 5.37101 19.8692 5.67457C20 6.0182 20 6.41796 20 7.21747V11.9999Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), rp = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M13 7.49987L10 10.4999L14 12.4999L11 15.4999M20 11.9999C20 16.9083 14.646 20.4783 12.698 21.6147C12.4766 21.7439 12.3659 21.8085 12.2097 21.842C12.0884 21.868 11.9116 21.868 11.7903 21.842C11.6341 21.8085 11.5234 21.7439 11.302 21.6147C9.35396 20.4783 4 16.9083 4 11.9999V7.21747C4 6.41796 4 6.0182 4.13076 5.67457C4.24627 5.37101 4.43398 5.10015 4.67766 4.8854C4.9535 4.64231 5.3278 4.50195 6.0764 4.22122L11.4382 2.21054C11.6461 2.13258 11.75 2.0936 11.857 2.07815C11.9518 2.06444 12.0482 2.06444 12.143 2.07815C12.25 2.0936 12.3539 2.13258 12.5618 2.21054L17.9236 4.22122C18.6722 4.50195 19.0465 4.64231 19.3223 4.8854C19.566 5.10015 19.7537 5.37101 19.8692 5.67457C20 6.0182 20 6.41796 20 7.21747V11.9999Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ip = /* @__PURE__ */ k({
	FaceId: () => Sf,
	FaceIdSquare: () => Cf,
	FileLock01: () => wf,
	FileLock02: () => Tf,
	FileLock03: () => Ef,
	FileShield01: () => Df,
	FileShield02: () => Of,
	FileShield03: () => kf,
	Fingerprint01: () => Af,
	Fingerprint02: () => jf,
	Fingerprint03: () => Mf,
	Fingerprint04: () => Nf,
	FolderShield: () => Pf,
	Key01: () => Ff,
	Key02: () => If,
	Lock01: () => Lf,
	Lock02: () => Rf,
	Lock03: () => zf,
	Lock04: () => Bf,
	LockKeyholeCircle: () => Vf,
	LockKeyholeSquare: () => Hf,
	LockUnlocked01: () => Uf,
	LockUnlocked02: () => Wf,
	LockUnlocked03: () => Gf,
	LockUnlocked04: () => Kf,
	Passcode: () => qf,
	PasscodeLock: () => Jf,
	Scan: () => Yf,
	Shield01: () => Xf,
	Shield02: () => Zf,
	Shield03: () => Qf,
	ShieldDollar: () => $f,
	ShieldOff: () => ep,
	ShieldPlus: () => tp,
	ShieldTick: () => np,
	ShieldZap: () => rp
}), ap = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9.35442 21C10.0596 21.6224 10.9858 22 12.0002 22C13.0147 22 13.9409 21.6224 14.6461 21M2.29414 5.81989C2.27979 4.36854 3.06227 3.01325 4.32635 2.3M21.7024 5.8199C21.7167 4.36855 20.9342 3.01325 19.6702 2.3M18.0002 8C18.0002 6.4087 17.3681 4.88258 16.2429 3.75736C15.1177 2.63214 13.5915 2 12.0002 2C10.4089 2 8.88283 2.63214 7.75761 3.75736C6.63239 4.88258 6.00025 6.4087 6.00025 8C6.00025 11.0902 5.22072 13.206 4.34991 14.6054C3.61538 15.7859 3.24811 16.3761 3.26157 16.5408C3.27649 16.7231 3.31511 16.7926 3.46203 16.9016C3.59471 17 4.19284 17 5.3891 17H18.6114C19.8077 17 20.4058 17 20.5385 16.9016C20.6854 16.7926 20.724 16.7231 20.7389 16.5408C20.7524 16.3761 20.3851 15.7859 19.6506 14.6054C18.7798 13.206 18.0002 11.0902 18.0002 8Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), op = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M14.0003 21H10.0003M2.29414 5.81989C2.27979 4.36854 3.06227 3.01325 4.32635 2.3M21.7025 5.8199C21.7169 4.36855 20.9344 3.01325 19.6703 2.3M18.0003 8C18.0003 6.4087 17.3682 4.88258 16.2429 3.75736C15.1177 2.63214 13.5916 2 12.0003 2C10.409 2 8.88288 2.63214 7.75766 3.75736C6.63244 4.88258 6.0003 6.4087 6.0003 8C6.0003 11.0902 5.22077 13.206 4.34996 14.6054C3.61542 15.7859 3.24816 16.3761 3.26162 16.5408C3.27653 16.7231 3.31516 16.7926 3.46207 16.9016C3.59476 17 4.19289 17 5.38915 17H18.6114C19.8077 17 20.4058 17 20.5385 16.9016C20.6854 16.7926 20.7241 16.7231 20.739 16.5408C20.7524 16.3761 20.3852 15.7859 19.6506 14.6054C18.7798 13.206 18.0003 11.0902 18.0003 8Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), sp = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M15.0002 19C15.0002 20.6569 13.6571 22 12.0002 22C10.3434 22 9.00025 20.6569 9.00025 19M13.7968 6.23856C14.2322 5.78864 14.5002 5.17562 14.5002 4.5C14.5002 3.11929 13.381 2 12.0002 2C10.6195 2 9.50025 3.11929 9.50025 4.5C9.50025 5.17562 9.76825 5.78864 10.2037 6.23856M2.54707 8.32296C2.53272 6.87161 3.3152 5.51631 4.57928 4.80306M21.4534 8.32296C21.4678 6.87161 20.6853 5.51631 19.4212 4.80306M18.0002 11.2C18.0002 9.82087 17.3681 8.49823 16.2429 7.52304C15.1177 6.54786 13.5915 6 12.0002 6C10.4089 6 8.88283 6.54786 7.75761 7.52304C6.63239 8.49823 6.00025 9.82087 6.00025 11.2C6.00025 13.4818 5.43438 15.1506 4.72831 16.3447C3.92359 17.7056 3.52122 18.3861 3.53711 18.5486C3.55529 18.7346 3.58876 18.7933 3.73959 18.9036C3.87142 19 4.53376 19 5.85844 19H18.1421C19.4667 19 20.1291 19 20.2609 18.9036C20.4117 18.7933 20.4452 18.7346 20.4634 18.5486C20.4793 18.3861 20.0769 17.7056 19.2722 16.3447C18.5661 15.1506 18.0002 13.4818 18.0002 11.2Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), cp = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M15.6459 18.0148C16.0747 19.6152 15.125 21.2602 13.5246 21.689C11.9242 22.1178 10.2792 21.1681 9.85036 19.5677M2.05683 11.6133C1.66734 10.2151 2.07238 8.70349 3.10878 7.68738M12.1463 5.74085C12.4505 5.19355 12.5507 4.53205 12.3759 3.87945C12.0185 2.54579 10.6477 1.75433 9.314 2.11168C7.98034 2.46904 7.18888 3.83988 7.54624 5.17355C7.7211 5.82614 8.13863 6.34891 8.67573 6.67079M20.319 6.72C19.9572 5.31439 18.8506 4.20779 17.445 3.84602M17.4906 9.44528C17.1337 8.11315 16.1808 6.99919 14.8415 6.34845C13.5022 5.69772 11.8863 5.56352 10.3492 5.97538C8.81214 6.38724 7.47981 7.31142 6.64533 8.54461C5.81085 9.77779 5.54258 11.219 5.89952 12.5511C6.4901 14.7552 6.37542 16.5135 6.00247 17.8497C5.5774 19.3725 5.36487 20.134 5.42228 20.2869C5.48798 20.4618 5.53549 20.5098 5.70973 20.5773C5.86202 20.6363 6.50179 20.4649 7.78133 20.122L19.6464 16.9428C20.9259 16.5999 21.5657 16.4285 21.6681 16.3013C21.7852 16.1557 21.8024 16.0904 21.7718 15.906C21.7451 15.7449 21.1803 15.1918 20.0508 14.0855C19.0597 13.1148 18.0812 11.6493 17.4906 9.44528Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), lp = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M21 10H3M16 2V6M8 2V6M9 16L11 18L15.5 13.5M7.8 22H16.2C17.8802 22 18.7202 22 19.362 21.673C19.9265 21.3854 20.3854 20.9265 20.673 20.362C21 19.7202 21 18.8802 21 17.2V8.8C21 7.11984 21 6.27976 20.673 5.63803C20.3854 5.07354 19.9265 4.6146 19.362 4.32698C18.7202 4 17.8802 4 16.2 4H7.8C6.11984 4 5.27976 4 4.63803 4.32698C4.07354 4.6146 3.6146 5.07354 3.32698 5.63803C3 6.27976 3 7.11984 3 8.8V17.2C3 18.8802 3 19.7202 3.32698 20.362C3.6146 20.9265 4.07354 21.3854 4.63803 21.673C5.27976 22 6.11984 22 7.8 22Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), up = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M21 10H3M21 12.5V8.8C21 7.11984 21 6.27976 20.673 5.63803C20.3854 5.07354 19.9265 4.6146 19.362 4.32698C18.7202 4 17.8802 4 16.2 4H7.8C6.11984 4 5.27976 4 4.63803 4.32698C4.07354 4.6146 3.6146 5.07354 3.32698 5.63803C3 6.27976 3 7.11984 3 8.8V17.2C3 18.8802 3 19.7202 3.32698 20.362C3.6146 20.9265 4.07354 21.3854 4.63803 21.673C5.27976 22 6.11984 22 7.8 22H12M16 2V6M8 2V6M14.5 19L16.5 21L21 16.5",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), dp = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 9.5V13.5L14.5 15M12 5C7.30558 5 3.5 8.80558 3.5 13.5C3.5 18.1944 7.30558 22 12 22C16.6944 22 20.5 18.1944 20.5 13.5C20.5 8.80558 16.6944 5 12 5ZM12 5V2M10 2H14M20.329 5.59204L18.829 4.09204L19.579 4.84204M3.67102 5.59204L5.17102 4.09204L4.42102 4.84204",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), fp = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 12L7.72711 8.43926C7.09226 7.91022 6.77484 7.6457 6.54664 7.32144C6.34444 7.03413 6.19429 6.71354 6.10301 6.37428C6 5.99139 6 5.57819 6 4.7518V2M12 12L16.2729 8.43926C16.9077 7.91022 17.2252 7.6457 17.4534 7.32144C17.6556 7.03413 17.8057 6.71354 17.897 6.37428C18 5.99139 18 5.57819 18 4.7518V2M12 12L7.72711 15.5607C7.09226 16.0898 6.77484 16.3543 6.54664 16.6786C6.34444 16.9659 6.19429 17.2865 6.10301 17.6257C6 18.0086 6 18.4218 6 19.2482V22M12 12L16.2729 15.5607C16.9077 16.0898 17.2252 16.3543 17.4534 16.6786C17.6556 16.9659 17.8057 17.2865 17.897 17.6257C18 18.0086 18 18.4218 18 19.2482V22M4 2H20M4 22H20",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), pp = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M18.1626 2H5.83744C5.37494 2 5 2.37494 5 2.83744C5 5.50268 6.05876 8.05876 7.94337 9.94337L9.16256 11.1626C9.28363 11.2836 9.34417 11.3442 9.3875 11.4023C9.65188 11.7569 9.65188 12.2431 9.3875 12.5977C9.34417 12.6558 9.28363 12.7164 9.16256 12.8374L7.94337 14.0566C6.05876 15.9412 5 18.4973 5 21.1626C5 21.6251 5.37494 22 5.83744 22H18.1626C18.6251 22 19 21.6251 19 21.1626C19 18.4973 17.9412 15.9412 16.0566 14.0566L14.8374 12.8374C14.7164 12.7164 14.6558 12.6558 14.6125 12.5977C14.3481 12.2431 14.3481 11.7569 14.6125 11.4023C14.6558 11.3442 14.7164 11.2836 14.8374 11.1626L16.0566 9.94337C17.9412 8.05876 19 5.50268 19 2.83744C19 2.37494 18.6251 2 18.1626 2Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), mp = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9 18.5H15M6.6 2H17.4C17.9601 2 18.2401 2 18.454 2.10899C18.6422 2.20487 18.7951 2.35785 18.891 2.54601C19 2.75992 19 3.03995 19 3.6V5.67452C19 6.1637 19 6.40829 18.9447 6.63846C18.8957 6.84254 18.8149 7.03763 18.7053 7.21657C18.5816 7.4184 18.4086 7.59135 18.0627 7.93726L15.1314 10.8686C14.7354 11.2646 14.5373 11.4627 14.4632 11.691C14.3979 11.8918 14.3979 12.1082 14.4632 12.309C14.5373 12.5373 14.7354 12.7354 15.1314 13.1314L18.0627 16.0627C18.4086 16.4086 18.5816 16.5816 18.7053 16.7834C18.8149 16.9624 18.8957 17.1575 18.9447 17.3615C19 17.5917 19 17.8363 19 18.3255V20.4C19 20.9601 19 21.2401 18.891 21.454C18.7951 21.6422 18.6422 21.7951 18.454 21.891C18.2401 22 17.9601 22 17.4 22H6.6C6.03995 22 5.75992 22 5.54601 21.891C5.35785 21.7951 5.20487 21.6422 5.10899 21.454C5 21.2401 5 20.9601 5 20.4V18.3255C5 17.8363 5 17.5917 5.05526 17.3615C5.10425 17.1575 5.18506 16.9624 5.29472 16.7834C5.4184 16.5816 5.59135 16.4086 5.93726 16.0627L8.86863 13.1314C9.26465 12.7354 9.46265 12.5373 9.53684 12.309C9.6021 12.1082 9.6021 11.8918 9.53684 11.691C9.46266 11.4627 9.26464 11.2646 8.86863 10.8686L5.93726 7.93726C5.59136 7.59136 5.4184 7.4184 5.29472 7.21657C5.18506 7.03763 5.10425 6.84254 5.05526 6.63846C5 6.40829 5 6.1637 5 5.67452V3.6C5 3.03995 5 2.75992 5.10899 2.54601C5.20487 2.35785 5.35785 2.20487 5.54601 2.10899C5.75992 2 6.03995 2 6.6 2Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), hp = /* @__PURE__ */ k({
	BellRinging01: () => ap,
	BellRinging02: () => op,
	BellRinging03: () => sp,
	BellRinging04: () => cp,
	CalendarCheck01: () => lp,
	CalendarCheck02: () => up,
	ClockStopwatch: () => dp,
	Hourglass01: () => fp,
	Hourglass02: () => pp,
	Hourglass03: () => mp
}), gp = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M8 14C8 14 9.5 16 12 16C14.5 16 16 14 16 14M17 9.24C16.605 9.725 16.065 10 15.5 10C14.935 10 14.41 9.725 14 9.24M10 9.24C9.605 9.725 9.065 10 8.5 10C7.935 10 7.41 9.725 7 9.24M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), _p = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M16 16C16 16 14.5 14 12 14C9.5 14 8 16 8 16M15 9H15.01M9 9H9.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM15.5 9C15.5 9.27614 15.2761 9.5 15 9.5C14.7239 9.5 14.5 9.27614 14.5 9C14.5 8.72386 14.7239 8.5 15 8.5C15.2761 8.5 15.5 8.72386 15.5 9ZM9.5 9C9.5 9.27614 9.27614 9.5 9 9.5C8.72386 9.5 8.5 9.27614 8.5 9C8.5 8.72386 8.72386 8.5 9 8.5C9.27614 8.5 9.5 8.72386 9.5 9Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), vp = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M15 9H15.01M9 9H9.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM15.5 9C15.5 9.27614 15.2761 9.5 15 9.5C14.7239 9.5 14.5 9.27614 14.5 9C14.5 8.72386 14.7239 8.5 15 8.5C15.2761 8.5 15.5 8.72386 15.5 9ZM9.5 9C9.5 9.27614 9.27614 9.5 9 9.5C8.72386 9.5 8.5 9.27614 8.5 9C8.5 8.72386 8.72386 8.5 9 8.5C9.27614 8.5 9.5 8.72386 9.5 9ZM12 17.5C14.5005 17.5 16.5 15.667 16.5 14H7.5C7.5 15.667 9.4995 17.5 12 17.5Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), yp = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M8 15H16M15 9H15.01M9 9H9.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM15.5 9C15.5 9.27614 15.2761 9.5 15 9.5C14.7239 9.5 14.5 9.27614 14.5 9C14.5 8.72386 14.7239 8.5 15 8.5C15.2761 8.5 15.5 8.72386 15.5 9ZM9.5 9C9.5 9.27614 9.27614 9.5 9 9.5C8.72386 9.5 8.5 9.27614 8.5 9C8.5 8.72386 8.72386 8.5 9 8.5C9.27614 8.5 9.5 8.72386 9.5 9Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), bp = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M16 16C16 16 14.5 14 12 14C9.5 14 8 16 8 16M17 9.24C16.605 9.725 16.065 10 15.5 10C14.935 10 14.41 9.725 14 9.24M10 9.24C9.605 9.725 9.065 10 8.5 10C7.935 10 7.41 9.725 7 9.24M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), xp = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M8 14C8 14 9.5 16 12 16C14.5 16 16 14 16 14M15 9H15.01M9 9H9.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM15.5 9C15.5 9.27614 15.2761 9.5 15 9.5C14.7239 9.5 14.5 9.27614 14.5 9C14.5 8.72386 14.7239 8.5 15 8.5C15.2761 8.5 15.5 8.72386 15.5 9ZM9.5 9C9.5 9.27614 9.27614 9.5 9 9.5C8.72386 9.5 8.5 9.27614 8.5 9C8.5 8.72386 8.72386 8.5 9 8.5C9.27614 8.5 9.5 8.72386 9.5 9Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Sp = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M8 14C8 14 9.5 16 12 16C14.5 16 16 14 16 14M15 9H15.01M8 9H10M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM15.5 9C15.5 9.27614 15.2761 9.5 15 9.5C14.7239 9.5 14.5 9.27614 14.5 9C14.5 8.72386 14.7239 8.5 15 8.5C15.2761 8.5 15.5 8.72386 15.5 9Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Cp = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M20 21C20 19.6044 20 18.9067 19.8278 18.3389C19.44 17.0605 18.4395 16.06 17.1611 15.6722C16.5933 15.5 15.8956 15.5 14.5 15.5H9.5C8.10444 15.5 7.40665 15.5 6.83886 15.6722C5.56045 16.06 4.56004 17.0605 4.17224 18.3389C4 18.9067 4 19.6044 4 21M16.5 7.5C16.5 9.98528 14.4853 12 12 12C9.51472 12 7.5 9.98528 7.5 7.5C7.5 5.01472 9.51472 3 12 3C14.4853 3 16.5 5.01472 16.5 7.5Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), wp = (e) => /* @__PURE__ */ o("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ a("path", {
		d: "M12 15C8.8299 15 6.01077 16.5306 4.21597 18.906C3.82968 19.4172 3.63653 19.6728 3.64285 20.0183C3.64773 20.2852 3.81533 20.6219 4.02534 20.7867C4.29716 21 4.67384 21 5.4272 21H18.5727C19.3261 21 19.7028 21 19.9746 20.7867C20.1846 20.6219 20.3522 20.2852 20.3571 20.0183C20.3634 19.6728 20.1703 19.4172 19.784 18.906C17.9892 16.5306 15.17 15 12 15Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ a("path", {
		d: "M12 12C14.4853 12 16.5 9.98528 16.5 7.5C16.5 5.01472 14.4853 3 12 3C9.51469 3 7.49997 5.01472 7.49997 7.5C7.49997 9.98528 9.51469 12 12 12Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
}), Tp = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M3 20C5.33579 17.5226 8.50702 16 12 16C15.493 16 18.6642 17.5226 21 20M16.5 7.5C16.5 9.98528 14.4853 12 12 12C9.51472 12 7.5 9.98528 7.5 7.5C7.5 5.01472 9.51472 3 12 3C14.4853 3 16.5 5.01472 16.5 7.5Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ep = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 15.5H7.5C6.10444 15.5 5.40665 15.5 4.83886 15.6722C3.56045 16.06 2.56004 17.0605 2.17224 18.3389C2 18.9067 2 19.6044 2 21M16 18L18 20L22 16M14.5 7.5C14.5 9.98528 12.4853 12 10 12C7.51472 12 5.5 9.98528 5.5 7.5C5.5 5.01472 7.51472 3 10 3C12.4853 3 14.5 5.01472 14.5 7.5Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Dp = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M16 21V19.8C16 18.1198 16 17.2798 15.673 16.638C15.3854 16.0735 14.9265 15.6146 14.362 15.327C13.7202 15 12.8802 15 11.2 15H6.8C5.11984 15 4.27976 15 3.63803 15.327C3.07354 15.6146 2.6146 16.0735 2.32698 16.638C2 17.2798 2 18.1198 2 19.8V21M16 6L18 8L22 4M12.5 7.5C12.5 9.433 10.933 11 9 11C7.067 11 5.5 9.433 5.5 7.5C5.5 5.567 7.067 4 9 4C10.933 4 12.5 5.567 12.5 7.5Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Op = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M5.3163 19.4384C5.92462 18.0052 7.34492 17 9 17H15C16.6551 17 18.0754 18.0052 18.6837 19.4384M16 9.5C16 11.7091 14.2091 13.5 12 13.5C9.79086 13.5 8 11.7091 8 9.5C8 7.29086 9.79086 5.5 12 5.5C14.2091 5.5 16 7.29086 16 9.5ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), kp = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 15.5H7.5C6.10444 15.5 5.40665 15.5 4.83886 15.6722C3.56045 16.06 2.56004 17.0605 2.17224 18.3389C2 18.9067 2 19.6044 2 21M16 18L19 21M19 21L22 18M19 21V15M14.5 7.5C14.5 9.98528 12.4853 12 10 12C7.51472 12 5.5 9.98528 5.5 7.5C5.5 5.01472 7.51472 3 10 3C12.4853 3 14.5 5.01472 14.5 7.5Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ap = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M16 7L19 10M19 10L22 7M19 10V4M16 21V19.8C16 18.1198 16 17.2798 15.673 16.638C15.3854 16.0735 14.9265 15.6146 14.362 15.327C13.7202 15 12.8802 15 11.2 15H6.8C5.11984 15 4.27976 15 3.63803 15.327C3.07354 15.6146 2.6146 16.0735 2.32698 16.638C2 17.2798 2 18.1198 2 19.8V21M12.5 7.5C12.5 9.433 10.933 11 9 11C7.067 11 5.5 9.433 5.5 7.5C5.5 5.567 7.067 4 9 4C10.933 4 12.5 5.567 12.5 7.5Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), jp = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9 15.5H7.5C6.10444 15.5 5.40665 15.5 4.83886 15.6722C3.56045 16.06 2.56004 17.0605 2.17224 18.3389C2 18.9067 2 19.6044 2 21M14.5 7.5C14.5 9.98528 12.4853 12 10 12C7.51472 12 5.5 9.98528 5.5 7.5C5.5 5.01472 7.51472 3 10 3C12.4853 3 14.5 5.01472 14.5 7.5ZM11 21L14.1014 20.1139C14.2499 20.0715 14.3241 20.0502 14.3934 20.0184C14.4549 19.9902 14.5134 19.9558 14.5679 19.9158C14.6293 19.8707 14.6839 19.8161 14.7932 19.7068L21.25 13.25C21.9404 12.5597 21.9404 11.4403 21.25 10.75C20.5597 10.0596 19.4404 10.0596 18.75 10.75L12.2932 17.2068C12.1839 17.3161 12.1293 17.3707 12.0842 17.4321C12.0442 17.4866 12.0098 17.5451 11.9816 17.6066C11.9497 17.6759 11.9285 17.7501 11.8861 17.8987L11 21Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Mp = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M19 21L16 18M16 18L19 15M16 18H22M12 15.5H7.5C6.10444 15.5 5.40665 15.5 4.83886 15.6722C3.56045 16.06 2.56004 17.0605 2.17224 18.3389C2 18.9067 2 19.6044 2 21M14.5 7.5C14.5 9.98528 12.4853 12 10 12C7.51472 12 5.5 9.98528 5.5 7.5C5.5 5.01472 7.51472 3 10 3C12.4853 3 14.5 5.01472 14.5 7.5Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Np = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M19 9L16 6M16 6L19 3M16 6L22 6M16 21V19.8C16 18.1198 16 17.2798 15.673 16.638C15.3854 16.0735 14.9265 15.6146 14.362 15.327C13.7202 15 12.8802 15 11.2 15H6.8C5.11984 15 4.27976 15 3.63803 15.327C3.07354 15.6146 2.6146 16.0735 2.32698 16.638C2 17.2798 2 18.1198 2 19.8V21M12.5 7.5C12.5 9.433 10.933 11 9 11C7.067 11 5.5 9.433 5.5 7.5C5.5 5.567 7.067 4 9 4C10.933 4 12.5 5.567 12.5 7.5Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Pp = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M16 18H22M12 15.5H7.5C6.10444 15.5 5.40665 15.5 4.83886 15.6722C3.56045 16.06 2.56004 17.0605 2.17224 18.3389C2 18.9067 2 19.6044 2 21M14.5 7.5C14.5 9.98528 12.4853 12 10 12C7.51472 12 5.5 9.98528 5.5 7.5C5.5 5.01472 7.51472 3 10 3C12.4853 3 14.5 5.01472 14.5 7.5Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Fp = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M16 7H22M16 21V19.8C16 18.1198 16 17.2798 15.673 16.638C15.3854 16.0735 14.9265 15.6146 14.362 15.327C13.7202 15 12.8802 15 11.2 15H6.8C5.11984 15 4.27976 15 3.63803 15.327C3.07354 15.6146 2.6146 16.0735 2.32698 16.638C2 17.2798 2 18.1198 2 19.8V21M12.5 7.5C12.5 9.433 10.933 11 9 11C7.067 11 5.5 9.433 5.5 7.5C5.5 5.567 7.067 4 9 4C10.933 4 12.5 5.567 12.5 7.5Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Ip = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 15.5H7.5C6.10444 15.5 5.40665 15.5 4.83886 15.6722C3.56045 16.06 2.56004 17.0605 2.17224 18.3389C2 18.9067 2 19.6044 2 21M19 21V15M16 18H22M14.5 7.5C14.5 9.98528 12.4853 12 10 12C7.51472 12 5.5 9.98528 5.5 7.5C5.5 5.01472 7.51472 3 10 3C12.4853 3 14.5 5.01472 14.5 7.5Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Lp = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M19 10V4M16 7H22M16 21V19.8C16 18.1198 16 17.2798 15.673 16.638C15.3854 16.0735 14.9265 15.6146 14.362 15.327C13.7202 15 12.8802 15 11.2 15H6.8C5.11984 15 4.27976 15 3.63803 15.327C3.07354 15.6146 2.6146 16.0735 2.32698 16.638C2 17.2798 2 18.1198 2 19.8V21M12.5 7.5C12.5 9.433 10.933 11 9 11C7.067 11 5.5 9.433 5.5 7.5C5.5 5.567 7.067 4 9 4C10.933 4 12.5 5.567 12.5 7.5Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Rp = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M19 21L22 18M22 18L19 15M22 18H16M12 15.5H7.5C6.10444 15.5 5.40665 15.5 4.83886 15.6722C3.56045 16.06 2.56004 17.0605 2.17224 18.3389C2 18.9067 2 19.6044 2 21M14.5 7.5C14.5 9.98528 12.4853 12 10 12C7.51472 12 5.5 9.98528 5.5 7.5C5.5 5.01472 7.51472 3 10 3C12.4853 3 14.5 5.01472 14.5 7.5Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), zp = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M19 9L22 6M22 6L19 3M22 6L16 6M16 21V19.8C16 18.1198 16 17.2798 15.673 16.638C15.3854 16.0735 14.9265 15.6146 14.362 15.327C13.7202 15 12.8802 15 11.2 15H6.8C5.11984 15 4.27976 15 3.63803 15.327C3.07354 15.6146 2.6146 16.0735 2.32698 16.638C2 17.2798 2 18.1198 2 19.8V21M12.5 7.5C12.5 9.433 10.933 11 9 11C7.067 11 5.5 9.433 5.5 7.5C5.5 5.567 7.067 4 9 4C10.933 4 12.5 5.567 12.5 7.5Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Bp = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M22 21V19C22 17.1362 20.7252 15.5701 19 15.126M15.5 3.29076C16.9659 3.88415 18 5.32131 18 7C18 8.67869 16.9659 10.1159 15.5 10.7092M17 21C17 19.1362 17 18.2044 16.6955 17.4693C16.2895 16.4892 15.5108 15.7105 14.5307 15.3045C13.7956 15 12.8638 15 11 15H8C6.13623 15 5.20435 15 4.46927 15.3045C3.48915 15.7105 2.71046 16.4892 2.30448 17.4693C2 18.2044 2 19.1362 2 21M13.5 7C13.5 9.20914 11.7091 11 9.5 11C7.29086 11 5.5 9.20914 5.5 7C5.5 4.79086 7.29086 3 9.5 3C11.7091 3 13.5 4.79086 13.5 7Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Vp = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M16 3.46776C17.4817 4.20411 18.5 5.73314 18.5 7.5C18.5 9.26686 17.4817 10.7959 16 11.5322M18 16.7664C19.5115 17.4503 20.8725 18.565 22 20M2 20C3.94649 17.5226 6.58918 16 9.5 16C12.4108 16 15.0535 17.5226 17 20M14 7.5C14 9.98528 11.9853 12 9.5 12C7.01472 12 5 9.98528 5 7.5C5 5.01472 7.01472 3 9.5 3C11.9853 3 14 5.01472 14 7.5Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Hp = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M18 15.8369C19.4559 16.5683 20.7041 17.742 21.6152 19.2096C21.7956 19.5003 21.8858 19.6456 21.917 19.8468C21.9804 20.2558 21.7008 20.7585 21.3199 20.9204C21.1325 21 20.9216 21 20.5 21M16 11.5322C17.4817 10.7959 18.5 9.26686 18.5 7.5C18.5 5.73314 17.4817 4.20411 16 3.46776M14 7.5C14 9.98528 11.9852 12 9.49996 12C7.01468 12 4.99996 9.98528 4.99996 7.5C4.99996 5.01472 7.01468 3 9.49996 3C11.9852 3 14 5.01472 14 7.5ZM2.55919 18.9383C4.1535 16.5446 6.66933 15 9.49996 15C12.3306 15 14.8464 16.5446 16.4407 18.9383C16.79 19.4628 16.9646 19.725 16.9445 20.0599C16.9289 20.3207 16.7579 20.64 16.5495 20.7976C16.2819 21 15.9138 21 15.1776 21H3.82232C3.08613 21 2.71804 21 2.4504 20.7976C2.24201 20.64 2.07105 20.3207 2.05539 20.0599C2.03529 19.725 2.20992 19.4628 2.55919 18.9383Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Up = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M16 18L18 20L22 16M12 15H8C6.13623 15 5.20435 15 4.46927 15.3045C3.48915 15.7105 2.71046 16.4892 2.30448 17.4693C2 18.2044 2 19.1362 2 21M15.5 3.29076C16.9659 3.88415 18 5.32131 18 7C18 8.67869 16.9659 10.1159 15.5 10.7092M13.5 7C13.5 9.20914 11.7091 11 9.5 11C7.29086 11 5.5 9.20914 5.5 7C5.5 4.79086 7.29086 3 9.5 3C11.7091 3 13.5 4.79086 13.5 7Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Wp = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M16 18L19 21M19 21L22 18M19 21V15M15.5 3.29076C16.9659 3.88415 18 5.32131 18 7C18 8.67869 16.9659 10.1159 15.5 10.7092M12 15H8C6.13623 15 5.20435 15 4.46927 15.3045C3.48915 15.7105 2.71046 16.4892 2.30448 17.4693C2 18.2044 2 19.1362 2 21M13.5 7C13.5 9.20914 11.7091 11 9.5 11C7.29086 11 5.5 9.20914 5.5 7C5.5 4.79086 7.29086 3 9.5 3C11.7091 3 13.5 4.79086 13.5 7Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Gp = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M11 15H8C6.13623 15 5.20435 15 4.46927 15.3045C3.48915 15.7105 2.71046 16.4892 2.30448 17.4693C2 18.2044 2 19.1362 2 21M15.5 3.29076C16.9659 3.88415 18 5.32131 18 7M11.9999 21.5L14.025 21.095C14.2015 21.0597 14.2898 21.042 14.3721 21.0097C14.4452 20.9811 14.5147 20.9439 14.579 20.899C14.6516 20.8484 14.7152 20.7848 14.8426 20.6574L21.5 14C22.0524 13.4477 22.0523 12.5523 21.5 12C20.9477 11.4477 20.0523 11.4477 19.5 12L12.8425 18.6575C12.7152 18.7848 12.6516 18.8484 12.601 18.921C12.5561 18.9853 12.5189 19.0548 12.4902 19.1278C12.458 19.2102 12.4403 19.2984 12.405 19.475L11.9999 21.5ZM13.5 7C13.5 9.20914 11.7091 11 9.5 11C7.29086 11 5.5 9.20914 5.5 7C5.5 4.79086 7.29086 3 9.5 3C11.7091 3 13.5 4.79086 13.5 7Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Kp = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M19 21L16 18M16 18L19 15M16 18H22M15.5 3.29076C16.9659 3.88415 18 5.32131 18 7C18 8.67869 16.9659 10.1159 15.5 10.7092M12 15H8C6.13623 15 5.20435 15 4.46927 15.3045C3.48915 15.7105 2.71046 16.4892 2.30448 17.4693C2 18.2044 2 19.1362 2 21M13.5 7C13.5 9.20914 11.7091 11 9.5 11C7.29086 11 5.5 9.20914 5.5 7C5.5 4.79086 7.29086 3 9.5 3C11.7091 3 13.5 4.79086 13.5 7Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), qp = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M16 18H22M15.5 3.29076C16.9659 3.88415 18 5.32131 18 7C18 8.67869 16.9659 10.1159 15.5 10.7092M12 15H8C6.13623 15 5.20435 15 4.46927 15.3045C3.48915 15.7105 2.71046 16.4892 2.30448 17.4693C2 18.2044 2 19.1362 2 21M13.5 7C13.5 9.20914 11.7091 11 9.5 11C7.29086 11 5.5 9.20914 5.5 7C5.5 4.79086 7.29086 3 9.5 3C11.7091 3 13.5 4.79086 13.5 7Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Jp = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M19 21V15M16 18H22M12 15H8C6.13623 15 5.20435 15 4.46927 15.3045C3.48915 15.7105 2.71046 16.4892 2.30448 17.4693C2 18.2044 2 19.1362 2 21M15.5 3.29076C16.9659 3.88415 18 5.32131 18 7C18 8.67869 16.9659 10.1159 15.5 10.7092M13.5 7C13.5 9.20914 11.7091 11 9.5 11C7.29086 11 5.5 9.20914 5.5 7C5.5 4.79086 7.29086 3 9.5 3C11.7091 3 13.5 4.79086 13.5 7Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Yp = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M4.00002 21.8174C4.6026 22 5.41649 22 6.8 22H17.2C18.5835 22 19.3974 22 20 21.8174M4.00002 21.8174C3.87082 21.7783 3.75133 21.7308 3.63803 21.673C3.07354 21.3854 2.6146 20.9265 2.32698 20.362C2 19.7202 2 18.8802 2 17.2V6.8C2 5.11984 2 4.27976 2.32698 3.63803C2.6146 3.07354 3.07354 2.6146 3.63803 2.32698C4.27976 2 5.11984 2 6.8 2H17.2C18.8802 2 19.7202 2 20.362 2.32698C20.9265 2.6146 21.3854 3.07354 21.673 3.63803C22 4.27976 22 5.11984 22 6.8V17.2C22 18.8802 22 19.7202 21.673 20.362C21.3854 20.9265 20.9265 21.3854 20.362 21.673C20.2487 21.7308 20.1292 21.7783 20 21.8174M4.00002 21.8174C4.00035 21.0081 4.00521 20.5799 4.07686 20.2196C4.39249 18.6329 5.63288 17.3925 7.21964 17.0769C7.60603 17 8.07069 17 9 17H15C15.9293 17 16.394 17 16.7804 17.0769C18.3671 17.3925 19.6075 18.6329 19.9231 20.2196C19.9948 20.5799 19.9996 21.0081 20 21.8174M16 9.5C16 11.7091 14.2091 13.5 12 13.5C9.79086 13.5 8 11.7091 8 9.5C8 7.29086 9.79086 5.5 12 5.5C14.2091 5.5 16 7.29086 16 9.5Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Xp = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M19 21L22 18M22 18L19 15M22 18H16M15.5 3.29076C16.9659 3.88415 18 5.32131 18 7C18 8.67869 16.9659 10.1159 15.5 10.7092M12 15H8C6.13623 15 5.20435 15 4.46927 15.3045C3.48915 15.7105 2.71046 16.4892 2.30448 17.4693C2 18.2044 2 19.1362 2 21M13.5 7C13.5 9.20914 11.7091 11 9.5 11C7.29086 11 5.5 9.20914 5.5 7C5.5 4.79086 7.29086 3 9.5 3C11.7091 3 13.5 4.79086 13.5 7Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Zp = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M16 18L19 15M19 15L22 18M19 15V21M15.5 3.29076C16.9659 3.88415 18 5.32131 18 7C18 8.67869 16.9659 10.1159 15.5 10.7092M12 15H8C6.13623 15 5.20435 15 4.46927 15.3045C3.48915 15.7105 2.71046 16.4892 2.30448 17.4693C2 18.2044 2 19.1362 2 21M13.5 7C13.5 9.20914 11.7091 11 9.5 11C7.29086 11 5.5 9.20914 5.5 7C5.5 4.79086 7.29086 3 9.5 3C11.7091 3 13.5 4.79086 13.5 7Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Qp = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M16.5 16L21.5 21M21.5 16L16.5 21M15.5 3.29076C16.9659 3.88415 18 5.32131 18 7C18 8.67869 16.9659 10.1159 15.5 10.7092M12 15H8C6.13623 15 5.20435 15 4.46927 15.3045C3.48915 15.7105 2.71046 16.4892 2.30448 17.4693C2 18.2044 2 19.1362 2 21M13.5 7C13.5 9.20914 11.7091 11 9.5 11C7.29086 11 5.5 9.20914 5.5 7C5.5 4.79086 7.29086 3 9.5 3C11.7091 3 13.5 4.79086 13.5 7Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), $p = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M16 18L19 15M19 15L22 18M19 15V21M12 15.5H7.5C6.10444 15.5 5.40665 15.5 4.83886 15.6722C3.56045 16.06 2.56004 17.0605 2.17224 18.3389C2 18.9067 2 19.6044 2 21M14.5 7.5C14.5 9.98528 12.4853 12 10 12C7.51472 12 5.5 9.98528 5.5 7.5C5.5 5.01472 7.51472 3 10 3C12.4853 3 14.5 5.01472 14.5 7.5Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), em = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M16 6L19 3M19 3L22 6M19 3V9M16 21V19.8C16 18.1198 16 17.2798 15.673 16.638C15.3854 16.0735 14.9265 15.6146 14.362 15.327C13.7202 15 12.8802 15 11.2 15H6.8C5.11984 15 4.27976 15 3.63803 15.327C3.07354 15.6146 2.6146 16.0735 2.32698 16.638C2 17.2798 2 18.1198 2 19.8V21M12.5 7.5C12.5 9.433 10.933 11 9 11C7.067 11 5.5 9.433 5.5 7.5C5.5 5.567 7.067 4 9 4C10.933 4 12.5 5.567 12.5 7.5Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), tm = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M16.5 16L21.5 21M21.5 16L16.5 21M12 15.5H7.5C6.10444 15.5 5.40665 15.5 4.83886 15.6722C3.56045 16.06 2.56004 17.0605 2.17224 18.3389C2 18.9067 2 19.6044 2 21M14.5 7.5C14.5 9.98528 12.4853 12 10 12C7.51472 12 5.5 9.98528 5.5 7.5C5.5 5.01472 7.51472 3 10 3C12.4853 3 14.5 5.01472 14.5 7.5Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), nm = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M16.5 4L21.5 9M21.5 4L16.5 9M16 21V19.8C16 18.1198 16 17.2798 15.673 16.638C15.3854 16.0735 14.9265 15.6146 14.362 15.327C13.7202 15 12.8802 15 11.2 15H6.8C5.11984 15 4.27976 15 3.63803 15.327C3.07354 15.6146 2.6146 16.0735 2.32698 16.638C2 17.2798 2 18.1198 2 19.8V21M12.5 7.5C12.5 9.433 10.933 11 9 11C7.067 11 5.5 9.433 5.5 7.5C5.5 5.567 7.067 4 9 4C10.933 4 12.5 5.567 12.5 7.5Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), rm = /* @__PURE__ */ k({
	FaceContent: () => gp,
	FaceFrown: () => _p,
	FaceHappy: () => vp,
	FaceNeutral: () => yp,
	FaceSad: () => bp,
	FaceSmile: () => xp,
	FaceWink: () => Sp,
	User01: () => Cp,
	User02: () => wp,
	User03: () => Tp,
	UserCheck01: () => Ep,
	UserCheck02: () => Dp,
	UserCircle: () => Op,
	UserDown01: () => kp,
	UserDown02: () => Ap,
	UserEdit: () => jp,
	UserLeft01: () => Mp,
	UserLeft02: () => Np,
	UserMinus01: () => Pp,
	UserMinus02: () => Fp,
	UserPlus01: () => Ip,
	UserPlus02: () => Lp,
	UserRight01: () => Rp,
	UserRight02: () => zp,
	UserSquare: () => Yp,
	UserUp01: () => $p,
	UserUp02: () => em,
	UserX01: () => tm,
	UserX02: () => nm,
	Users01: () => Bp,
	Users02: () => Vp,
	Users03: () => Hp,
	UsersCheck: () => Up,
	UsersDown: () => Wp,
	UsersEdit: () => Gp,
	UsersLeft: () => Kp,
	UsersMinus: () => qp,
	UsersPlus: () => Jp,
	UsersRight: () => Xp,
	UsersUp: () => Zp,
	UsersX: () => Qp
}), im = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M4 18H2M6.31412 12.3141L4.8999 10.8999M17.6858 12.3141L19.1 10.8999M22 18H20M7 18C7 15.2386 9.23858 13 12 13C14.7614 13 17 15.2386 17 18M22 22H2M16 5L12 9M12 9L8 5M12 9V2",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), am = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M13 2L4.09344 12.6879C3.74463 13.1064 3.57023 13.3157 3.56756 13.4925C3.56524 13.6461 3.63372 13.7923 3.75324 13.8889C3.89073 14 4.16316 14 4.70802 14H12L11 22L19.9065 11.3121C20.2553 10.8936 20.4297 10.6843 20.4324 10.5075C20.4347 10.3539 20.3663 10.2077 20.2467 10.1111C20.1092 10 19.8368 10 19.292 10H12L13 2Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), om = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M14.2495 2H8.49395C8.31447 2 8.22473 2 8.14551 2.02733C8.07544 2.05149 8.01163 2.09093 7.95868 2.14279C7.89881 2.20143 7.85868 2.2817 7.77841 2.44223L3.57841 10.8422C3.38673 11.2256 3.29089 11.4173 3.31391 11.5731C3.33401 11.7091 3.40927 11.8309 3.52197 11.9097C3.65104 12 3.86534 12 4.29395 12H10.4995L7.49953 22L19.6926 9.35531C20.104 8.9287 20.3097 8.7154 20.3217 8.53288C20.3321 8.37446 20.2667 8.22049 20.1454 8.11803C20.0057 8 19.7094 8 19.1167 8H11.9995L14.2495 2Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), sm = /* @__PURE__ */ k({
	Lightning01: () => am,
	Lightning02: () => om,
	Sunset: () => im
}), cm = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), lm = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M20.5 7.27783L12 12.0001M12 12.0001L3.49997 7.27783M12 12.0001L12 21.5001M21 16.0586V7.94153C21 7.59889 21 7.42757 20.9495 7.27477C20.9049 7.13959 20.8318 7.01551 20.7354 6.91082C20.6263 6.79248 20.4766 6.70928 20.177 6.54288L12.777 2.43177C12.4934 2.27421 12.3516 2.19543 12.2015 2.16454C12.0685 2.13721 11.9315 2.13721 11.7986 2.16454C11.6484 2.19543 11.5066 2.27421 11.223 2.43177L3.82297 6.54288C3.52345 6.70928 3.37369 6.79248 3.26463 6.91082C3.16816 7.01551 3.09515 7.13959 3.05048 7.27477C3 7.42757 3 7.59889 3 7.94153V16.0586C3 16.4013 3 16.5726 3.05048 16.7254C3.09515 16.8606 3.16816 16.9847 3.26463 17.0893C3.37369 17.2077 3.52345 17.2909 3.82297 17.4573L11.223 21.5684C11.5066 21.726 11.6484 21.8047 11.7986 21.8356C11.9315 21.863 12.0685 21.863 12.2015 21.8356C12.3516 21.8047 12.4934 21.726 12.777 21.5684L20.177 17.4573C20.4766 17.2909 20.6263 17.2077 20.7354 17.0893C20.8318 16.9847 20.9049 16.8606 20.9495 16.7254C21 16.5726 21 16.4013 21 16.0586Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), um = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 2.50008V12.0001M12 12.0001L20.5 7.27779M12 12.0001L3.5 7.27779M12 12.0001V21.5001M20.5 16.7223L12.777 12.4318C12.4934 12.2742 12.3516 12.1954 12.2015 12.1645C12.0685 12.1372 11.9315 12.1372 11.7986 12.1645C11.6484 12.1954 11.5066 12.2742 11.223 12.4318L3.5 16.7223M21 16.0586V7.94153C21 7.59889 21 7.42757 20.9495 7.27477C20.9049 7.13959 20.8318 7.01551 20.7354 6.91082C20.6263 6.79248 20.4766 6.70928 20.177 6.54288L12.777 2.43177C12.4934 2.27421 12.3516 2.19543 12.2015 2.16454C12.0685 2.13721 11.9315 2.13721 11.7986 2.16454C11.6484 2.19543 11.5066 2.27421 11.223 2.43177L3.82297 6.54288C3.52345 6.70928 3.37369 6.79248 3.26463 6.91082C3.16816 7.01551 3.09515 7.13959 3.05048 7.27477C3 7.42757 3 7.59889 3 7.94153V16.0586C3 16.4013 3 16.5726 3.05048 16.7254C3.09515 16.8606 3.16816 16.9847 3.26463 17.0893C3.37369 17.2077 3.52345 17.2909 3.82297 17.4573L11.223 21.5684C11.5066 21.726 11.6484 21.8047 11.7986 21.8356C11.9315 21.863 12.0685 21.863 12.2015 21.8356C12.3516 21.8047 12.4934 21.726 12.777 21.5684L20.177 17.4573C20.4766 17.2909 20.6263 17.2077 20.7354 17.0893C20.8318 16.9847 20.9049 16.8606 20.9495 16.7254C21 16.5726 21 16.4013 21 16.0586Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), dm = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M3.5 8H16M16 8V20.5M16 8L20.5 3.5M21 15.3373V3.8C21 3.51997 21 3.37996 20.9455 3.273C20.8976 3.17892 20.8211 3.10243 20.727 3.0545C20.62 3 20.48 3 20.2 3H8.66274C8.41815 3 8.29586 3 8.18077 3.02763C8.07873 3.05213 7.98119 3.09253 7.89172 3.14736C7.7908 3.2092 7.70432 3.29568 7.53137 3.46863L3.46863 7.53137C3.29568 7.70432 3.2092 7.7908 3.14736 7.89172C3.09253 7.98119 3.05213 8.07873 3.02763 8.18077C3 8.29586 3 8.41815 3 8.66274V20.2C3 20.48 3 20.62 3.0545 20.727C3.10243 20.8211 3.17892 20.8976 3.273 20.9455C3.37996 21 3.51997 21 3.8 21H15.3373C15.5818 21 15.7041 21 15.8192 20.9724C15.9213 20.9479 16.0188 20.9075 16.1083 20.8526C16.2092 20.7908 16.2957 20.7043 16.4686 20.5314L20.5314 16.4686C20.7043 16.2957 20.7908 16.2092 20.8526 16.1083C20.9075 16.0188 20.9479 15.9213 20.9724 15.8192C21 15.7041 21 15.5818 21 15.3373Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), fm = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M20.5 16H8M8 16V3.5M8 16L3.5 20.5M3.5 8H16M16 8V20.5M16 8L20.5 3.5M21 15.3373V3.8C21 3.51997 21 3.37996 20.9455 3.273C20.8976 3.17892 20.8211 3.10243 20.727 3.0545C20.62 3 20.48 3 20.2 3H8.66274C8.41815 3 8.29586 3 8.18077 3.02763C8.07873 3.05213 7.98119 3.09253 7.89172 3.14736C7.7908 3.2092 7.70432 3.29568 7.53137 3.46863L3.46863 7.53137C3.29568 7.70432 3.2092 7.7908 3.14736 7.89172C3.09253 7.98119 3.05213 8.07873 3.02763 8.18077C3 8.29586 3 8.41815 3 8.66274V20.2C3 20.48 3 20.62 3.0545 20.727C3.10243 20.8211 3.17892 20.8976 3.273 20.9455C3.37996 21 3.51997 21 3.8 21H15.3373C15.5818 21 15.7041 21 15.8192 20.9724C15.9213 20.9479 16.0188 20.9075 16.1083 20.8526C16.2092 20.7908 16.2957 20.7043 16.4686 20.5314L20.5314 16.4686C20.7043 16.2957 20.7908 16.2092 20.8526 16.1083C20.9075 16.0188 20.9479 15.9213 20.9724 15.8192C21 15.7041 21 15.5818 21 15.3373Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), pm = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M9.75 20.7501L11.223 21.5684C11.5066 21.726 11.6484 21.8047 11.7986 21.8356C11.9315 21.863 12.0685 21.863 12.2015 21.8356C12.3516 21.8047 12.4934 21.726 12.777 21.5684L14.25 20.7501M5.25 18.2501L3.82297 17.4573C3.52346 17.2909 3.37368 17.2077 3.26463 17.0893C3.16816 16.9847 3.09515 16.8606 3.05048 16.7254C3 16.5726 3 16.4013 3 16.0586V14.5001M3 9.50009V7.94153C3 7.59889 3 7.42757 3.05048 7.27477C3.09515 7.13959 3.16816 7.01551 3.26463 6.91082C3.37368 6.79248 3.52345 6.70928 3.82297 6.54288L5.25 5.75009M9.75 3.25008L11.223 2.43177C11.5066 2.27421 11.6484 2.19543 11.7986 2.16454C11.9315 2.13721 12.0685 2.13721 12.2015 2.16454C12.3516 2.19543 12.4934 2.27421 12.777 2.43177L14.25 3.25008M18.75 5.75008L20.177 6.54288C20.4766 6.70928 20.6263 6.79248 20.7354 6.91082C20.8318 7.01551 20.9049 7.13959 20.9495 7.27477C21 7.42757 21 7.59889 21 7.94153V9.50008M21 14.5001V16.0586C21 16.4013 21 16.5726 20.9495 16.7254C20.9049 16.8606 20.8318 16.9847 20.7354 17.0893C20.6263 17.2077 20.4766 17.2909 20.177 17.4573L18.75 18.2501M9.75 10.7501L12 12.0001M12 12.0001L14.25 10.7501M12 12.0001V14.5001M3 7.00008L5.25 8.25008M18.75 8.25008L21 7.00008M12 19.5001V22.0001",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), mm = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 11.75H12.005M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21ZM12.25 11.75C12.25 11.8881 12.1381 12 12 12C11.8619 12 11.75 11.8881 11.75 11.75C11.75 11.6119 11.8619 11.5 12 11.5C12.1381 11.5 12.25 11.6119 12.25 11.75Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), hm = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M15.25 8.75H15.255M8.75 15.25H8.755M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21ZM15.5 8.75C15.5 8.88807 15.3881 9 15.25 9C15.1119 9 15 8.88807 15 8.75C15 8.61193 15.1119 8.5 15.25 8.5C15.3881 8.5 15.5 8.61193 15.5 8.75ZM9 15.25C9 15.3881 8.88807 15.5 8.75 15.5C8.61193 15.5 8.5 15.3881 8.5 15.25C8.5 15.1119 8.61193 15 8.75 15C8.88807 15 9 15.1119 9 15.25Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), gm = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M16.25 7.75H16.255M12 11.75H12.005M7.75 16.25H7.755M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21ZM16.5 7.75C16.5 7.88807 16.3881 8 16.25 8C16.1119 8 16 7.88807 16 7.75C16 7.61193 16.1119 7.5 16.25 7.5C16.3881 7.5 16.5 7.61193 16.5 7.75ZM12.25 11.75C12.25 11.8881 12.1381 12 12 12C11.8619 12 11.75 11.8881 11.75 11.75C11.75 11.6119 11.8619 11.5 12 11.5C12.1381 11.5 12.25 11.6119 12.25 11.75ZM8 16.25C8 16.3881 7.88807 16.5 7.75 16.5C7.61193 16.5 7.5 16.3881 7.5 16.25C7.5 16.1119 7.61193 16 7.75 16C7.88807 16 8 16.1119 8 16.25Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), _m = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M16.25 7.75H16.255M16.25 16.25H16.255M7.75 7.75H7.755M7.75 16.25H7.755M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21ZM16.5 7.75C16.5 7.88807 16.3881 8 16.25 8C16.1119 8 16 7.88807 16 7.75C16 7.61193 16.1119 7.5 16.25 7.5C16.3881 7.5 16.5 7.61193 16.5 7.75ZM16.5 16.25C16.5 16.3881 16.3881 16.5 16.25 16.5C16.1119 16.5 16 16.3881 16 16.25C16 16.1119 16.1119 16 16.25 16C16.3881 16 16.5 16.1119 16.5 16.25ZM8 7.75C8 7.88807 7.88807 8 7.75 8C7.61193 8 7.5 7.88807 7.5 7.75C7.5 7.61193 7.61193 7.5 7.75 7.5C7.88807 7.5 8 7.61193 8 7.75ZM8 16.25C8 16.3881 7.88807 16.5 7.75 16.5C7.61193 16.5 7.5 16.3881 7.5 16.25C7.5 16.1119 7.61193 16 7.75 16C7.88807 16 8 16.1119 8 16.25Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), vm = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M16.25 7.75H16.255M16.25 16.25H16.255M7.75 7.75H7.755M12 11.75H12.005M7.75 16.25H7.755M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21ZM16.5 7.75C16.5 7.88807 16.3881 8 16.25 8C16.1119 8 16 7.88807 16 7.75C16 7.61193 16.1119 7.5 16.25 7.5C16.3881 7.5 16.5 7.61193 16.5 7.75ZM16.5 16.25C16.5 16.3881 16.3881 16.5 16.25 16.5C16.1119 16.5 16 16.3881 16 16.25C16 16.1119 16.1119 16 16.25 16C16.3881 16 16.5 16.1119 16.5 16.25ZM8 7.75C8 7.88807 7.88807 8 7.75 8C7.61193 8 7.5 7.88807 7.5 7.75C7.5 7.61193 7.61193 7.5 7.75 7.5C7.88807 7.5 8 7.61193 8 7.75ZM12.25 11.75C12.25 11.8881 12.1381 12 12 12C11.8619 12 11.75 11.8881 11.75 11.75C11.75 11.6119 11.8619 11.5 12 11.5C12.1381 11.5 12.25 11.6119 12.25 11.75ZM8 16.25C8 16.3881 7.88807 16.5 7.75 16.5C7.61193 16.5 7.5 16.3881 7.5 16.25C7.5 16.1119 7.61193 16 7.75 16C7.88807 16 8 16.1119 8 16.25Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), ym = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M16.25 7.75H16.255M16.25 11.75H16.255M16.25 16.25H16.255M7.75 7.75H7.755M7.75 11.75H7.755M7.75 16.25H7.755M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21ZM16.5 7.75C16.5 7.88807 16.3881 8 16.25 8C16.1119 8 16 7.88807 16 7.75C16 7.61193 16.1119 7.5 16.25 7.5C16.3881 7.5 16.5 7.61193 16.5 7.75ZM16.5 11.75C16.5 11.8881 16.3881 12 16.25 12C16.1119 12 16 11.8881 16 11.75C16 11.6119 16.1119 11.5 16.25 11.5C16.3881 11.5 16.5 11.6119 16.5 11.75ZM16.5 16.25C16.5 16.3881 16.3881 16.5 16.25 16.5C16.1119 16.5 16 16.3881 16 16.25C16 16.1119 16.1119 16 16.25 16C16.3881 16 16.5 16.1119 16.5 16.25ZM8 7.75C8 7.88807 7.88807 8 7.75 8C7.61193 8 7.5 7.88807 7.5 7.75C7.5 7.61193 7.61193 7.5 7.75 7.5C7.88807 7.5 8 7.61193 8 7.75ZM8 11.75C8 11.8881 7.88807 12 7.75 12C7.61193 12 7.5 11.8881 7.5 11.75C7.5 11.6119 7.61193 11.5 7.75 11.5C7.88807 11.5 8 11.6119 8 11.75ZM8 16.25C8 16.3881 7.88807 16.5 7.75 16.5C7.61193 16.5 7.5 16.3881 7.5 16.25C7.5 16.1119 7.61193 16 7.75 16C7.88807 16 8 16.1119 8 16.25Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), bm = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M11.223 2.43177C11.5066 2.27421 11.6484 2.19543 11.7985 2.16454C11.9315 2.13721 12.0685 2.13721 12.2015 2.16454C12.3516 2.19543 12.4934 2.27421 12.777 2.43177L20.177 6.54288C20.4766 6.70928 20.6263 6.79248 20.7354 6.91082C20.8318 7.01551 20.9049 7.13959 20.9495 7.27477C21 7.42756 21 7.59889 21 7.94153V16.0586C21 16.4013 21 16.5726 20.9495 16.7254C20.9049 16.8606 20.8318 16.9847 20.7354 17.0893C20.6263 17.2077 20.4766 17.2909 20.177 17.4573L12.777 21.5684C12.4934 21.726 12.3516 21.8047 12.2015 21.8356C12.0685 21.863 11.9315 21.863 11.7985 21.8356C11.6484 21.8047 11.5066 21.726 11.223 21.5684L3.82297 17.4573C3.52345 17.2909 3.37369 17.2077 3.26463 17.0893C3.16816 16.9847 3.09515 16.8606 3.05048 16.7254C3 16.5726 3 16.4013 3 16.0586V7.94153C3 7.59889 3 7.42756 3.05048 7.27477C3.09515 7.13959 3.16816 7.01551 3.26463 6.91082C3.37369 6.79248 3.52345 6.70928 3.82297 6.54288L11.223 2.43177Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), xm = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M21.5679 11.223C21.7255 11.5066 21.8042 11.6484 21.8351 11.7985C21.8625 11.9315 21.8625 12.0685 21.8351 12.2015C21.8042 12.3516 21.7255 12.4934 21.5679 12.777L17.4568 20.177C17.2904 20.4766 17.2072 20.6263 17.0889 20.7354C16.9842 20.8318 16.8601 20.9049 16.7249 20.9495C16.5721 21 16.4008 21 16.0582 21H7.94104C7.5984 21 7.42708 21 7.27428 20.9495C7.1391 20.9049 7.01502 20.8318 6.91033 20.7354C6.79199 20.6263 6.70879 20.4766 6.54239 20.177L2.43128 12.777C2.27372 12.4934 2.19494 12.3516 2.16406 12.2015C2.13672 12.0685 2.13672 11.9315 2.16406 11.7985C2.19494 11.6484 2.27372 11.5066 2.43128 11.223L6.54239 3.82297C6.70879 3.52345 6.79199 3.37369 6.91033 3.26463C7.01502 3.16816 7.1391 3.09515 7.27428 3.05048C7.42708 3 7.5984 3 7.94104 3L16.0582 3C16.4008 3 16.5721 3 16.7249 3.05049C16.8601 3.09515 16.9842 3.16816 17.0889 3.26463C17.2072 3.37369 17.2904 3.52345 17.4568 3.82297L21.5679 11.223Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Sm = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M7.39137 2.46863C7.56432 2.29568 7.6508 2.2092 7.75172 2.14736C7.84119 2.09253 7.93873 2.05213 8.04077 2.02763C8.15586 2 8.27815 2 8.52274 2H15.4773C15.7218 2 15.8441 2 15.9592 2.02763C16.0613 2.05213 16.1588 2.09253 16.2483 2.14736C16.3492 2.2092 16.4357 2.29568 16.6086 2.46863L21.5314 7.39137C21.7043 7.56432 21.7908 7.6508 21.8526 7.75172C21.9075 7.84119 21.9479 7.93873 21.9724 8.04077C22 8.15586 22 8.27815 22 8.52274V15.4773C22 15.7218 22 15.8441 21.9724 15.9592C21.9479 16.0613 21.9075 16.1588 21.8526 16.2483C21.7908 16.3492 21.7043 16.4357 21.5314 16.6086L16.6086 21.5314C16.4357 21.7043 16.3492 21.7908 16.2483 21.8526C16.1588 21.9075 16.0613 21.9479 15.9592 21.9724C15.8441 22 15.7218 22 15.4773 22H8.52274C8.27815 22 8.15586 22 8.04077 21.9724C7.93873 21.9479 7.84119 21.9075 7.75172 21.8526C7.6508 21.7908 7.56432 21.7043 7.39137 21.5314L2.46863 16.6086C2.29568 16.4357 2.2092 16.3492 2.14736 16.2483C2.09253 16.1588 2.05213 16.0613 2.02763 15.9592C2 15.8441 2 15.7218 2 15.4773V8.52274C2 8.27815 2 8.15586 2.02763 8.04077C2.05213 7.93873 2.09253 7.84119 2.14736 7.75172C2.2092 7.6508 2.29568 7.56432 2.46863 7.39137L7.39137 2.46863Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Cm = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M11.0605 2.93203C11.3983 2.68689 11.5672 2.56432 11.7518 2.51696C11.9148 2.47514 12.0858 2.47514 12.2488 2.51696C12.4334 2.56432 12.6023 2.68689 12.9401 2.93203L21.0586 8.82396C21.397 9.06956 21.5663 9.19235 21.6686 9.3535C21.7589 9.49579 21.8119 9.65862 21.8224 9.82684C21.8344 10.0174 21.7697 10.2162 21.6404 10.6138L18.5401 20.1449C18.4109 20.5421 18.3463 20.7407 18.2247 20.8876C18.1173 21.0173 17.979 21.1178 17.8224 21.1798C17.6451 21.25 17.4362 21.25 17.0186 21.25H6.98203C6.56437 21.25 6.35554 21.25 6.17822 21.1798C6.02164 21.1178 5.88325 21.0173 5.77589 20.8876C5.65429 20.7407 5.58969 20.5421 5.4605 20.1449L2.36021 10.6138C2.23086 10.2162 2.16619 10.0174 2.17817 9.82684C2.18874 9.65862 2.24166 9.49579 2.33202 9.3535C2.43434 9.19235 2.60355 9.06956 2.94196 8.82396L11.0605 2.93203Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), wm = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M3 7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Tm = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M11.2827 3.45332C11.5131 2.98638 11.6284 2.75291 11.7848 2.67831C11.9209 2.61341 12.0791 2.61341 12.2152 2.67831C12.3717 2.75291 12.4869 2.98638 12.7174 3.45332L14.9041 7.88328C14.9721 8.02113 15.0061 8.09006 15.0558 8.14358C15.0999 8.19096 15.1527 8.22935 15.2113 8.25662C15.2776 8.28742 15.3536 8.29854 15.5057 8.32077L20.397 9.03571C20.9121 9.11099 21.1696 9.14863 21.2888 9.27444C21.3925 9.38389 21.4412 9.5343 21.4215 9.68377C21.3988 9.85558 21.2124 10.0372 20.8395 10.4004L17.3014 13.8464C17.1912 13.9538 17.136 14.0076 17.1004 14.0715C17.0689 14.128 17.0487 14.1902 17.0409 14.2545C17.0321 14.3271 17.0451 14.403 17.0711 14.5547L17.906 19.4221C17.994 19.9355 18.038 20.1922 17.9553 20.3445C17.8833 20.477 17.7554 20.57 17.6071 20.5975C17.4366 20.6291 17.2061 20.5078 16.7451 20.2654L12.3724 17.9658C12.2361 17.8942 12.168 17.8584 12.0962 17.8443C12.0327 17.8318 11.9673 17.8318 11.9038 17.8443C11.832 17.8584 11.7639 17.8942 11.6277 17.9658L7.25492 20.2654C6.79392 20.5078 6.56341 20.6291 6.39297 20.5975C6.24468 20.57 6.11672 20.477 6.04474 20.3445C5.962 20.1922 6.00603 19.9355 6.09407 19.4221L6.92889 14.5547C6.95491 14.403 6.96793 14.3271 6.95912 14.2545C6.95132 14.1902 6.93111 14.128 6.89961 14.0715C6.86402 14.0076 6.80888 13.9538 6.69859 13.8464L3.16056 10.4004C2.78766 10.0372 2.60121 9.85558 2.57853 9.68377C2.55879 9.5343 2.60755 9.38389 2.71125 9.27444C2.83044 9.14863 3.08797 9.11099 3.60304 9.03571L8.49431 8.32077C8.64642 8.29854 8.72248 8.28742 8.78872 8.25662C8.84736 8.22935 8.90016 8.19096 8.94419 8.14358C8.99391 8.09006 9.02793 8.02113 9.09597 7.88328L11.2827 3.45332Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Em = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M11.3063 3.20693C11.5338 2.81107 11.6476 2.61315 11.7962 2.54681C11.9259 2.48895 12.074 2.48895 12.2037 2.54681C12.3524 2.61315 12.4661 2.81107 12.6936 3.20693L14.6487 6.60925C14.733 6.75579 14.7751 6.82906 14.8341 6.88231C14.8863 6.92942 14.9479 6.96498 15.0148 6.98666C15.0905 7.01117 15.175 7.011 15.344 7.01065L19.2681 7.00272C19.7246 7.00179 19.9529 7.00133 20.0847 7.09691C20.1996 7.18028 20.2737 7.30858 20.2884 7.4498C20.3053 7.61171 20.1908 7.80918 19.9617 8.20412L17.9928 11.5985C17.908 11.7447 17.8656 11.8178 17.849 11.8955C17.8343 11.9643 17.8343 12.0355 17.849 12.1043C17.8656 12.182 17.908 12.2551 17.9928 12.4013L19.9617 15.7957C20.1908 16.1906 20.3053 16.3881 20.2884 16.55C20.2737 16.6912 20.1996 16.8195 20.0847 16.9029C19.9529 16.9985 19.7246 16.998 19.2681 16.9971L15.344 16.9891C15.175 16.9888 15.0905 16.9886 15.0148 17.0131C14.9479 17.0348 14.8863 17.0704 14.8341 17.1175C14.7751 17.1707 14.733 17.244 14.6487 17.3905L12.6936 20.7929C12.4661 21.1887 12.3524 21.3867 12.2037 21.453C12.074 21.5108 11.9259 21.5108 11.7962 21.453C11.6476 21.3867 11.5338 21.1887 11.3063 20.7929L9.35116 17.3905C9.26695 17.244 9.22485 17.1707 9.16581 17.1175C9.11357 17.0704 9.05198 17.0348 8.98507 17.0131C8.90943 16.9886 8.82493 16.9888 8.65592 16.9891L4.73183 16.9971C4.27527 16.998 4.04699 16.9985 3.91521 16.9029C3.80027 16.8195 3.7262 16.6912 3.71147 16.55C3.69458 16.3881 3.80913 16.1906 4.03821 15.7957L6.00712 12.4013C6.09193 12.2551 6.13433 12.182 6.15092 12.1043C6.1656 12.0355 6.1656 11.9643 6.15092 11.8955C6.13433 11.8178 6.09192 11.7447 6.00712 11.5985L4.03821 8.20411C3.80913 7.80918 3.69458 7.61171 3.71147 7.4498C3.7262 7.30858 3.80027 7.18028 3.91521 7.09691C4.04699 7.00133 4.27527 7.00179 4.73184 7.00272L8.65592 7.01065C8.82493 7.011 8.90943 7.01117 8.98507 6.98666C9.05198 6.96498 9.11357 6.92942 9.16581 6.88231C9.22485 6.82906 9.26695 6.75579 9.35116 6.60925L11.3063 3.20693Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Dm = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M11.2896 3.36637C11.5193 2.92427 11.6342 2.70323 11.7881 2.63139C11.9221 2.56883 12.077 2.56883 12.211 2.63139C12.3649 2.70323 12.4798 2.92427 12.7095 3.36637L14.2225 6.27865C14.3216 6.46934 14.3711 6.56468 14.4454 6.62803C14.511 6.68394 14.5899 6.72195 14.6745 6.73837C14.7704 6.75697 14.8758 6.73625 15.0867 6.69481L18.3069 6.06197C18.7958 5.9659 19.0402 5.91786 19.1923 5.99342C19.3248 6.05921 19.4214 6.18027 19.456 6.32406C19.4958 6.4892 19.3946 6.71681 19.1922 7.17203L17.8586 10.1707C17.7713 10.3671 17.7276 10.4653 17.7244 10.5628C17.7216 10.649 17.7411 10.7344 17.781 10.8108C17.8262 10.8973 17.9082 10.9668 18.072 11.1058L20.5746 13.229C20.9545 13.5513 21.1445 13.7124 21.1803 13.8785C21.2114 14.0231 21.177 14.174 21.0862 14.2908C20.9819 14.4249 20.7408 14.4876 20.2587 14.6132L17.0827 15.4402C16.8748 15.4944 16.7708 15.5215 16.6925 15.5798C16.6234 15.6313 16.5688 15.6998 16.534 15.7786C16.4945 15.868 16.4912 15.9754 16.4847 16.1901L16.3851 19.4705C16.37 19.9685 16.3624 20.2175 16.2549 20.349C16.1613 20.4635 16.0218 20.5307 15.8739 20.5325C15.704 20.5345 15.5047 20.3852 15.1059 20.0865L12.4791 18.1191C12.3071 17.9903 12.2211 17.9259 12.1267 17.9011C12.0434 17.8791 11.9558 17.8791 11.8724 17.9011C11.778 17.9259 11.692 17.9903 11.52 18.1191L8.8932 20.0865C8.49444 20.3852 8.29506 20.5345 8.12521 20.5325C7.97731 20.5307 7.8378 20.4635 7.74418 20.349C7.63667 20.2175 7.62911 19.9685 7.61399 19.4705L7.51439 16.1901C7.50787 15.9754 7.50461 15.868 7.46514 15.7786C7.43031 15.6998 7.37569 15.6313 7.30658 15.5798C7.22829 15.5215 7.12432 15.4944 6.91636 15.4402L3.74042 14.6132C3.2583 14.4876 3.01724 14.4249 2.91295 14.2908C2.82214 14.174 2.78768 14.0231 2.81884 13.8785C2.85463 13.7124 3.04458 13.5513 3.42448 13.229L5.92706 11.1058C6.09093 10.9668 6.17286 10.8973 6.21808 10.8108C6.258 10.7344 6.27749 10.649 6.27467 10.5628C6.27148 10.4653 6.22782 10.3671 6.1405 10.1707L4.80694 7.17203C4.6045 6.71681 4.50328 6.4892 4.54309 6.32406C4.57775 6.18027 4.6743 6.05921 4.80677 5.99342C4.95891 5.91786 5.20333 5.9659 5.69219 6.06197L8.91245 6.69481C9.1233 6.73625 9.22873 6.75697 9.32458 6.73837C9.4092 6.72195 9.48812 6.68394 9.55371 6.62803C9.62802 6.56468 9.67755 6.46934 9.77662 6.27865L11.2896 3.36637Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Om = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 2L14.012 7.23109C14.294 7.96432 14.435 8.33093 14.6542 8.63931C14.8486 8.91262 15.0874 9.15141 15.3607 9.34575C15.6691 9.56503 16.0357 9.70603 16.7689 9.98804L22 12L16.7689 14.012C16.0357 14.294 15.6691 14.435 15.3607 14.6542C15.0874 14.8486 14.8486 15.0874 14.6542 15.3607C14.435 15.6691 14.294 16.0357 14.012 16.7689L12 22L9.98804 16.7689C9.70603 16.0357 9.56503 15.6691 9.34575 15.3607C9.15141 15.0874 8.91262 14.8486 8.63931 14.6542C8.33093 14.435 7.96432 14.294 7.23109 14.012L2 12L7.23108 9.98804C7.96431 9.70603 8.33093 9.56503 8.63931 9.34575C8.91262 9.15141 9.15141 8.91262 9.34575 8.63931C9.56503 8.33093 9.70603 7.96431 9.98804 7.23108L12 2Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), km = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M12 2L10.6985 7.20599C10.4445 8.22185 10.3176 8.72978 10.0531 9.14309C9.81915 9.50868 9.50868 9.81915 9.14309 10.0531C8.72978 10.3176 8.22185 10.4445 7.20599 10.6985L2 12L7.20599 13.3015C8.22185 13.5555 8.72978 13.6824 9.14309 13.9469C9.50868 14.1808 9.81915 14.4913 10.0531 14.8569C10.3176 15.2702 10.4445 15.7782 10.6985 16.794L12 22L13.3015 16.794C13.5555 15.7782 13.6824 15.2702 13.9469 14.8569C14.1808 14.4913 14.4913 14.1808 14.8569 13.9469C15.2702 13.6824 15.7782 13.5555 16.794 13.3015L22 12L16.794 10.6985C15.7782 10.4445 15.2702 10.3176 14.8569 10.0531C14.4913 9.81915 14.1808 9.50868 13.9469 9.14309C13.6824 8.72978 13.5555 8.22185 13.3015 7.20599L12 2Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Am = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M4.5 22V17M4.5 7V2M2 4.5H7M2 19.5H7M13 3L11.2658 7.50886C10.9838 8.24209 10.8428 8.60871 10.6235 8.91709C10.4292 9.1904 10.1904 9.42919 9.91709 9.62353C9.60871 9.84281 9.24209 9.98381 8.50886 10.2658L4 12L8.50886 13.7342C9.24209 14.0162 9.60871 14.1572 9.91709 14.3765C10.1904 14.5708 10.4292 14.8096 10.6235 15.0829C10.8428 15.3913 10.9838 15.7579 11.2658 16.4911L13 21L14.7342 16.4911C15.0162 15.7579 15.1572 15.3913 15.3765 15.0829C15.5708 14.8096 15.8096 14.5708 16.0829 14.3765C16.3913 14.1572 16.7579 14.0162 17.4911 13.7342L22 12L17.4911 10.2658C16.7579 9.98381 16.3913 9.8428 16.0829 9.62353C15.8096 9.42919 15.5708 9.1904 15.3765 8.91709C15.1572 8.60871 15.0162 8.24209 14.7342 7.50886L13 3Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), jm = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M22 12H20M19.071 19.0711L17.6567 17.6569M4 12H2M6.34292 6.34317L4.92871 4.92896M12 4V2M17.6567 6.34317L19.071 4.92896M12 22V20M4.92871 19.0711L6.34292 17.6569M12 7L13.545 10.13L17 10.635L14.5 13.07L15.09 16.51L12 14.885L8.91 16.51L9.5 13.07L7 10.635L10.455 10.13L12 7Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Mm = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M2.39019 18.0983L10.6151 3.89171C11.0696 3.10655 11.2969 2.71396 11.5935 2.58211C11.8521 2.4671 12.1474 2.4671 12.4061 2.58211C12.7026 2.71396 12.9299 3.10654 13.3844 3.89171L21.6093 18.0983C22.0655 18.8863 22.2936 19.2803 22.2599 19.6037C22.2305 19.8857 22.0827 20.142 21.8534 20.3088C21.5904 20.5 21.1352 20.5 20.2246 20.5H3.77487C2.86435 20.5 2.40908 20.5 2.14613 20.3088C1.91677 20.142 1.769 19.8857 1.73959 19.6037C1.70588 19.2803 1.93398 18.8863 2.39019 18.0983Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Nm = /* @__PURE__ */ k({
	Circle: () => cm,
	Cube01: () => lm,
	Cube02: () => um,
	Cube03: () => dm,
	Cube04: () => fm,
	CubeOutline: () => pm,
	Dice1: () => mm,
	Dice2: () => hm,
	Dice3: () => gm,
	Dice4: () => _m,
	Dice5: () => vm,
	Dice6: () => ym,
	Hexagon01: () => bm,
	Hexagon02: () => xm,
	Octagon: () => Sm,
	Pentagon: () => Cm,
	Square: () => wm,
	Star01: () => Tm,
	Star02: () => Em,
	Star03: () => Dm,
	Star04: () => Om,
	Star05: () => km,
	Star06: () => Am,
	Star07: () => jm,
	Triangle: () => Mm
}), Pm = (e) => /* @__PURE__ */ o("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ o("g", {
		clipPath: "url(#clip0_1027_1528)",
		children: [
			/* @__PURE__ */ a("path", {
				d: "M23.7663 12.2764C23.7663 11.4607 23.7001 10.6406 23.559 9.83807H12.2402V14.4591H18.722C18.453 15.9494 17.5888 17.2678 16.3233 18.1056V21.1039H20.1903C22.4611 19.0139 23.7663 15.9274 23.7663 12.2764Z",
				fill: "#4285F4"
			}),
			/* @__PURE__ */ a("path", {
				d: "M12.2401 24.0008C15.4766 24.0008 18.2059 22.9382 20.1945 21.1039L16.3276 18.1055C15.2517 18.8375 13.8627 19.252 12.2445 19.252C9.11388 19.252 6.45946 17.1399 5.50705 14.3003H1.5166V17.3912C3.55371 21.4434 7.7029 24.0008 12.2401 24.0008Z",
				fill: "#34A853"
			}),
			/* @__PURE__ */ a("path", {
				d: "M5.50277 14.3003C5.00011 12.8099 5.00011 11.1961 5.50277 9.70575V6.61481H1.51674C-0.185266 10.0056 -0.185266 14.0004 1.51674 17.3912L5.50277 14.3003Z",
				fill: "#FBBC04"
			}),
			/* @__PURE__ */ a("path", {
				d: "M12.2401 4.74966C13.9509 4.7232 15.6044 5.36697 16.8434 6.54867L20.2695 3.12262C18.1001 1.0855 15.2208 -0.034466 12.2401 0.000808666C7.7029 0.000808666 3.55371 2.55822 1.5166 6.61481L5.50264 9.70575C6.45064 6.86173 9.10947 4.74966 12.2401 4.74966Z",
				fill: "#EA4335"
			})
		]
	}), /* @__PURE__ */ a("defs", { children: /* @__PURE__ */ a("clipPath", {
		id: "clip0_1027_1528",
		children: /* @__PURE__ */ a("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
}), Fm = /* @__PURE__ */ k({ GoogleBrandDefault: () => Pm }), Im = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M13 2L4.09344 12.6879C3.74463 13.1064 3.57023 13.3157 3.56756 13.4925C3.56524 13.6461 3.63372 13.7923 3.75324 13.8889C3.89073 14 4.16316 14 4.70802 14H12L11 22L19.9065 11.3121C20.2553 10.8936 20.4297 10.6843 20.4324 10.5075C20.4347 10.3539 20.3663 10.2077 20.2467 10.1111C20.1092 10 19.8368 10 19.292 10H12L13 2Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Lm = /* @__PURE__ */ k({ Flash: () => Im }), Rm = (e) => /* @__PURE__ */ a("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ a("path", {
		d: "M11.5 5H11.9344C14.9816 5 16.5053 5 17.0836 5.54729C17.5836 6.02037 17.8051 6.71728 17.6702 7.39221C17.514 8.17302 16.2701 9.05285 13.7823 10.8125L9.71772 13.6875C7.2299 15.4471 5.98599 16.327 5.82984 17.1078C5.69486 17.7827 5.91642 18.4796 6.41636 18.9527C6.99474 19.5 8.51836 19.5 11.5656 19.5H12.5M8 5C8 6.65685 6.65685 8 5 8C3.34315 8 2 6.65685 2 5C2 3.34315 3.34315 2 5 2C6.65685 2 8 3.34315 8 5ZM22 19C22 20.6569 20.6569 22 19 22C17.3431 22 16 20.6569 16 19C16 17.3431 17.3431 16 19 16C20.6569 16 22 17.3431 22 19Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), zm = /* @__PURE__ */ k({ Route: () => Rm }), Bm = {
	...Je,
	...ot,
	...sn,
	...fr,
	...Ci,
	...xo,
	...$o,
	...os,
	...Nc,
	...hf,
	..._f,
	...vf,
	...xf,
	...ip,
	...hp,
	...rm,
	...sm,
	...Nm,
	...Fm,
	...Lm,
	...zm
}, Vm = (e) => /* @__PURE__ */ o("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 24 24",
	enableBackground: "new 0 0 24 24",
	xmlSpace: "preserve",
	...e,
	children: [
		/* @__PURE__ */ o("g", { children: [
			/* @__PURE__ */ a("path", {
				fill: "#303C42",
				d: "M19,10.0253296V5c0-1.1030273-0.8969727-2-2-2H2C0.8969727,3,0,3.8969727,0,5v10 c0,1.1030273,0.8969727,2,2,2h11.2131958C13.8683472,19.3049927,15.987793,21,18.5,21c3.0327148,0,5.5-2.4672852,5.5-5.5 C24,12.6360474,21.7989502,10.2791138,19,10.0253296z"
			}),
			/* @__PURE__ */ a("path", {
				fill: "#FFFFFF",
				d: "M17,4c0.020813,0,0.038269,0.0106201,0.0587769,0.0119019l-7.147644,5.8670044 c-0.2543945,0.1606445-0.6225586,0.1264648-0.7885742,0.0253906L1.9418335,4.0117798C1.9621582,4.0105591,1.9793701,4,2,4H17z"
			}),
			/* @__PURE__ */ a("path", {
				fill: "#FAFAFA",
				d: "M2,16c-0.5512695,0-1-0.4487305-1-1V5c0-0.1416016,0.03125-0.2753296,0.0845947-0.397522 l7.4476318,6.1074829C8.8232422,10.8999023,9.1577148,11,9.5,11c0.3291016,0,0.6508789-0.0927734,0.934082-0.2685547 c0.0283203-0.0151367,0.0551758-0.0332031,0.0805664-0.0541992l7.4006348-6.0748901C17.968689,4.7246094,18,4.8583374,18,5 v5.0253296C15.2010498,10.2791138,13,12.6360474,13,15.5c0,0.1687622,0.010376,0.335083,0.0253296,0.5H2z"
			}),
			/* @__PURE__ */ a("circle", {
				fill: "#7CB342",
				cx: 18.5,
				cy: 15.5,
				r: 4.5
			}),
			/* @__PURE__ */ a("path", {
				opacity: .2,
				fill: "#FFFFFF",
				d: "M14.5,16c0-2.4814453,2.0185547-4.5,4.5-4.5 c1.1132202,0,2.1201782,0.4213867,2.9066162,1.0933838C21.0806274,11.62677,19.8682251,11,18.5,11 c-2.4814453,0-4.5,2.0185547-4.5,4.5c0,1.3682251,0.62677,2.5806274,1.5933838,3.4066162 C14.9213867,18.1201782,14.5,17.1132202,14.5,16z"
			}),
			/* @__PURE__ */ a("path", {
				fill: "#303C42",
				d: "M20.5,15H19v-1.5c0-0.2763672-0.2236328-0.5-0.5-0.5S18,13.2236328,18,13.5V15h-1.5 c-0.2763672,0-0.5,0.2236328-0.5,0.5s0.2236328,0.5,0.5,0.5H18v1.5c0,0.2763672,0.2236328,0.5,0.5,0.5s0.5-0.2236328,0.5-0.5V16 h1.5c0.2763672,0,0.5-0.2236328,0.5-0.5S20.7763672,15,20.5,15z"
			}),
			/* @__PURE__ */ o("linearGradient", {
				id: "SVGID_1_",
				gradientUnits: "userSpaceOnUse",
				x1: 5.2922974,
				y1: .3947754,
				x2: 16.9614258,
				y2: 12.0639038,
				children: [/* @__PURE__ */ a("stop", {
					offset: 0,
					style: {
						stopColor: "#000000",
						stopOpacity: .1
					}
				}), /* @__PURE__ */ a("stop", {
					offset: 1,
					style: {
						stopColor: "#000000",
						stopOpacity: 0
					}
				})]
			}),
			/* @__PURE__ */ a("path", {
				fill: "url(#SVGID_1_)",
				d: "M13.0253296,16C13.010376,15.835083,13,15.6687622,13,15.5 c0-2.8639526,2.2010498-5.2208862,5-5.4746704V5c0-0.1416626-0.031311-0.2753906-0.0847168-0.397644l-7.4006348,6.0748901 c-0.0253906,0.0209961-0.0522461,0.0390625-0.0805664,0.0541992C10.1508789,10.9072266,9.8291016,11,9.5,11 c-0.3422852,0-0.6767578-0.1000977-0.9677734-0.2900391L1.0845947,4.602478L12.4821167,16H13.0253296z"
			}),
			/* @__PURE__ */ o("linearGradient", {
				id: "SVGID_2_",
				gradientUnits: "userSpaceOnUse",
				x1: -.3881513,
				y1: 5.3890796,
				x2: 23.9835968,
				y2: 16.7538128,
				children: [/* @__PURE__ */ a("stop", {
					offset: 0,
					style: {
						stopColor: "#FFFFFF",
						stopOpacity: .2
					}
				}), /* @__PURE__ */ a("stop", {
					offset: 1,
					style: {
						stopColor: "#FFFFFF",
						stopOpacity: 0
					}
				})]
			}),
			/* @__PURE__ */ a("path", {
				fill: "url(#SVGID_2_)",
				d: "M19,10.0253296V5c0-1.1030273-0.8969727-2-2-2H2C0.8969727,3,0,3.8969727,0,5v10 c0,1.1030273,0.8969727,2,2,2h11.2131958C13.8683472,19.3049927,15.987793,21,18.5,21c3.0327148,0,5.5-2.4672852,5.5-5.5 C24,12.6360474,21.7989502,10.2791138,19,10.0253296z"
			})
		] }),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {})
	]
}), Hm = (e) => /* @__PURE__ */ o("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 24 24",
	enableBackground: "new 0 0 24 24",
	xmlSpace: "preserve",
	...e,
	children: [
		/* @__PURE__ */ o("g", { children: [
			/* @__PURE__ */ a("path", {
				fill: "#303C42",
				d: "M17,3H2C0.8974609,3,0,3.8969727,0,5v10c0,1.1030273,0.8974609,2,2,2h15c1.1025391,0,2-0.8969727,2-2V5 C19,3.8969727,18.1025391,3,17,3z"
			}),
			/* @__PURE__ */ a("path", {
				fill: "#FAFAFA",
				d: "M18,15c0,0.5512695-0.4482422,1-1,1H2c-0.5517578,0-1-0.4487305-1-1V5 c0-0.1416016,0.031311-0.2753906,0.0845947-0.397583l7.4476318,6.1075439C8.8232422,10.8999023,9.1582031,11,9.5,11 c0.3398438,0,0.6748047-0.0996094,1.0146484-0.3227539l7.4006958-6.0748901C17.968689,4.7246094,18,4.8583374,18,5V15z"
			}),
			/* @__PURE__ */ o("linearGradient", {
				id: "SVGID_1_",
				gradientUnits: "userSpaceOnUse",
				x1: 5.3869019,
				y1: .4804077,
				x2: 19.1600647,
				y2: 14.2535706,
				children: [/* @__PURE__ */ a("stop", {
					offset: 0,
					style: {
						stopColor: "#000000",
						stopOpacity: .1
					}
				}), /* @__PURE__ */ a("stop", {
					offset: 1,
					style: {
						stopColor: "#000000",
						stopOpacity: 0
					}
				})]
			}),
			/* @__PURE__ */ a("path", {
				fill: "url(#SVGID_1_)",
				d: "M12.5,16H17c0.5517578,0,1-0.4487305,1-1V5c0-0.1416626-0.031311-0.2753906-0.0846558-0.397644 l-7.4006958,6.0748901C10.1748047,10.9003906,9.8398438,11,9.5,11c-0.3417969,0-0.6767578-0.1000977-0.9677734-0.2900391 L1.1836548,4.6836548L12.5,16z"
			}),
			/* @__PURE__ */ a("path", {
				fill: "#FFFFFF",
				d: "M17,4c0.020752,0,0.038147,0.0105591,0.0585938,0.0118408L9.9228516,9.8720703 c-0.2617188,0.1699219-0.6289063,0.1376953-0.8007813,0.0322266L1.9417725,4.0117798C1.9620972,4.0105591,1.9793701,4,2,4H17z"
			}),
			/* @__PURE__ */ a("path", {
				fill: "#303C42",
				d: "M18.5,10c-3.0327148,0-5.5,2.4672852-5.5,5.5s2.4672852,5.5,5.5,5.5 c0.9667969,0,1.9174805-0.2543945,2.7504883-0.7363281c0.2387695-0.1381836,0.3208008-0.4438477,0.1821289-0.6831055 c-0.1381836-0.2392578-0.4443359-0.3217773-0.6831055-0.1821289C20.0688477,19.7919922,19.2910156,20,18.5,20 c-2.4814453,0-4.5-2.0185547-4.5-4.5s2.0185547-4.5,4.5-4.5s4.5,2.0185547,4.5,4.5V16c0,0.5512695-0.4487305,1-1,1 s-1-0.4487305-1-1v-2c0-0.2763672-0.2236328-0.5-0.5-0.5c-0.1344604,0-0.2553101,0.0544434-0.3450928,0.140625 C19.7129517,13.2468262,19.137085,13,18.5,13c-1.378418,0-2.5,1.121582-2.5,2.5s1.121582,2.5,2.5,2.5 c0.7451172,0,1.4076538-0.3342896,1.8660889-0.8532104C20.7282715,17.6613159,21.3242188,18,22,18c1.1030273,0,2-0.8969727,2-2 v-0.5C24,12.4672852,21.5327148,10,18.5,10z M18.5,17c-0.8271484,0-1.5-0.6728516-1.5-1.5s0.6728516-1.5,1.5-1.5 s1.5,0.6728516,1.5,1.5S19.3271484,17,18.5,17z"
			}),
			/* @__PURE__ */ o("linearGradient", {
				id: "SVGID_2_",
				gradientUnits: "userSpaceOnUse",
				x1: -.3880862,
				y1: 5.3891096,
				x2: 23.8781433,
				y2: 16.7046375,
				children: [/* @__PURE__ */ a("stop", {
					offset: 0,
					style: {
						stopColor: "#FFFFFF",
						stopOpacity: .2
					}
				}), /* @__PURE__ */ a("stop", {
					offset: 1,
					style: {
						stopColor: "#FFFFFF",
						stopOpacity: 0
					}
				})]
			}),
			/* @__PURE__ */ a("path", {
				fill: "url(#SVGID_2_)",
				d: "M19,10.0253296V5c0-1.1030273-0.8974609-2-2-2H2C0.8974609,3,0,3.8969727,0,5v10 c0,1.1030273,0.8974609,2,2,2h11.2131958C13.8683472,19.3049927,15.987793,21,18.5,21 c0.9667969,0,1.9174805-0.2543945,2.7504883-0.7363281c0.2387695-0.1381836,0.3208008-0.4438477,0.1821289-0.6831055 c-0.1381836-0.2392578-0.4443359-0.3217773-0.6831055-0.1821289C20.0688477,19.7919922,19.2910156,20,18.5,20 c-1.9529419,0-3.602356-1.2578125-4.2235718-3h2.2363281c0.4568481,0.6034546,1.1737671,1,1.9872437,1 c0.7451172,0,1.4076538-0.3342896,1.8660889-0.8532104C20.7282715,17.6613159,21.3242188,18,22,18c1.1030273,0,2-0.8969727,2-2 v-0.5C24,12.6360474,21.7989502,10.2791138,19,10.0253296z M18.5,17c-0.2496948,0-0.4817505-0.0671997-0.6890259-0.1755371 C18.5098877,16.5123901,19,15.8137207,19,15v-0.9078979c0.5807495,0.2070923,1,0.756897,1,1.4078979 C20,16.3271484,19.3271484,17,18.5,17z M23,16c0,0.5512695-0.4487305,1-1,1s-1-0.4487305-1-1v-2c0-0.2763672-0.2236328-0.5-0.5-0.5 c-0.1344604,0-0.2553101,0.0544434-0.3450928,0.140625C19.8322754,13.3531494,19.4370728,13.1469116,19,13.0549316v-2.0043945 c2.2438354,0.2524414,4,2.1392212,4,4.4494629V16z"
			})
		] }),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {})
	]
}), Um = (e) => /* @__PURE__ */ o("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 24 24",
	enableBackground: "new 0 0 24 24",
	xmlSpace: "preserve",
	...e,
	children: [
		/* @__PURE__ */ o("g", { children: [
			/* @__PURE__ */ a("path", {
				fill: "#303C42",
				d: "M17,3H2C0.8974609,3,0,3.8969727,0,5v10c0,1.1030273,0.8974609,2,2,2h15c1.1025391,0,2-0.8969727,2-2V5 C19,3.8969727,18.1025391,3,17,3z"
			}),
			/* @__PURE__ */ a("path", {
				fill: "#FAFAFA",
				d: "M18,15c0,0.5512695-0.4482422,1-1,1H2c-0.5517578,0-1-0.4487305-1-1V5 c0-0.1416016,0.031311-0.2753906,0.0845947-0.397583l7.4476318,6.1075439C8.8232422,10.8999023,9.1582031,11,9.5,11 c0.3398438,0,0.6748047-0.0996094,1.0146484-0.3227539l7.4006958-6.0748901C17.968689,4.7246094,18,4.8583374,18,5V15z"
			}),
			/* @__PURE__ */ o("linearGradient", {
				id: "SVGID_1_",
				gradientUnits: "userSpaceOnUse",
				x1: 5.3869019,
				y1: .4804077,
				x2: 19.1600647,
				y2: 14.2535706,
				children: [/* @__PURE__ */ a("stop", {
					offset: 0,
					style: {
						stopColor: "#000000",
						stopOpacity: .1
					}
				}), /* @__PURE__ */ a("stop", {
					offset: 1,
					style: {
						stopColor: "#000000",
						stopOpacity: 0
					}
				})]
			}),
			/* @__PURE__ */ a("path", {
				fill: "url(#SVGID_1_)",
				d: "M12.5,16H17c0.5517578,0,1-0.4487305,1-1V5c0-0.1416626-0.031311-0.2753906-0.0846558-0.397644 l-7.4006958,6.0748901C10.1748047,10.9003906,9.8398438,11,9.5,11c-0.3417969,0-0.6767578-0.1000977-0.9677734-0.2900391 L1.1836548,4.6836548L12.5,16z"
			}),
			/* @__PURE__ */ a("path", {
				fill: "#FFFFFF",
				d: "M17,4c0.020752,0,0.038147,0.0105591,0.0585938,0.0118408L9.9228516,9.8720703 c-0.2617188,0.1699219-0.6289063,0.1376953-0.8007813,0.0322266L1.9417725,4.0117798C1.9620972,4.0105591,1.9793701,4,2,4H17z"
			}),
			/* @__PURE__ */ a("path", {
				fill: "#303C42",
				d: "M21.5,21h-5c-1.9296875,0-3.5-1.5703125-3.5-3.5s1.5703125-3.5,3.5-3.5H22 c0.2763672,0,0.5,0.2236328,0.5,0.5S22.2763672,15,22,15h-5.5c-1.378418,0-2.5,1.121582-2.5,2.5s1.121582,2.5,2.5,2.5h5 c0.8271484,0,1.5-0.6728516,1.5-1.5S22.3271484,17,21.5,17h-5c-0.2758789,0-0.5,0.2241211-0.5,0.5s0.2241211,0.5,0.5,0.5H20 c0.2763672,0,0.5,0.2236328,0.5,0.5S20.2763672,19,20,19h-3.5c-0.8271484,0-1.5-0.6728516-1.5-1.5s0.6728516-1.5,1.5-1.5h5 c1.378418,0,2.5,1.121582,2.5,2.5S22.878418,21,21.5,21z"
			}),
			/* @__PURE__ */ o("linearGradient", {
				id: "SVGID_2_",
				gradientUnits: "userSpaceOnUse",
				x1: -.3880862,
				y1: 5.3891096,
				x2: 24.8780384,
				y2: 17.1708965,
				children: [/* @__PURE__ */ a("stop", {
					offset: 0,
					style: {
						stopColor: "#FFFFFF",
						stopOpacity: .2
					}
				}), /* @__PURE__ */ a("stop", {
					offset: 1,
					style: {
						stopColor: "#FFFFFF",
						stopOpacity: 0
					}
				})]
			}),
			/* @__PURE__ */ a("path", {
				fill: "url(#SVGID_2_)",
				d: "M21.5,16h-2.7781982C18.894043,15.7046509,19,15.3659058,19,15h3c0.2763672,0,0.5-0.2236328,0.5-0.5 S22.2763672,14,22,14h-3V5c0-1.1030273-0.8974609-2-2-2H2C0.8974609,3,0,3.8969727,0,5v10c0,1.1030273,0.8974609,2,2,2h11.0505371 C13.0266724,17.1647339,13,17.3287964,13,17.5c0,1.9296875,1.5703125,3.5,3.5,3.5h5c1.378418,0,2.5-1.121582,2.5-2.5 S22.878418,16,21.5,16z M21.5,20h-5c-1.378418,0-2.5-1.121582-2.5-2.5c0-0.1712036,0.0176392-0.3383789,0.0505981-0.5h1.0415039 C15.0360718,17.1571655,15,17.3238525,15,17.5c0,0.8271484,0.6728516,1.5,1.5,1.5H20c0.2763672,0,0.5-0.2236328,0.5-0.5 S20.2763672,18,20,18h-3.5c-0.2758789,0-0.5-0.2241211-0.5-0.5s0.2241211-0.5,0.5-0.5H17h4.5c0.8271484,0,1.5,0.6728516,1.5,1.5 S22.3271484,20,21.5,20z"
			})
		] }),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {})
	]
}), Wm = (e) => /* @__PURE__ */ o("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 24 24",
	enableBackground: "new 0 0 24 24",
	xmlSpace: "preserve",
	...e,
	children: [
		/* @__PURE__ */ o("g", { children: [
			/* @__PURE__ */ a("path", {
				fill: "#303C42",
				d: "M19,10.0253296V5c0-1.1030273-0.8969727-2-2-2H2C0.8969727,3,0,3.8969727,0,5v10 c0,1.1030273,0.8969727,2,2,2h11.2131958C13.8683472,19.3049927,15.987793,21,18.5,21c3.0327148,0,5.5-2.4672852,5.5-5.5 C24,12.6360474,21.7989502,10.2791138,19,10.0253296z"
			}),
			/* @__PURE__ */ a("path", {
				fill: "#FFFFFF",
				d: "M17,4c0.020813,0,0.038269,0.0106201,0.0587769,0.0119019l-7.147644,5.8670044 c-0.2543945,0.1606445-0.6225586,0.1264648-0.7885742,0.0253906L1.9418335,4.0117798C1.9621582,4.0105591,1.9793701,4,2,4H17z"
			}),
			/* @__PURE__ */ a("path", {
				fill: "#FAFAFA",
				d: "M2,16c-0.5512695,0-1-0.4487305-1-1V5c0-0.1416016,0.03125-0.2753296,0.0845947-0.397522 l7.4476318,6.1074829C8.8232422,10.8999023,9.1577148,11,9.5,11c0.3291016,0,0.6508789-0.0927734,0.934082-0.2685547 c0.0283203-0.0151367,0.0551758-0.0332031,0.0805664-0.0541992l7.4006348-6.0748901C17.968689,4.7246094,18,4.8583374,18,5 v5.0253296C15.2010498,10.2791138,13,12.6360474,13,15.5c0,0.1687622,0.010376,0.335083,0.0253296,0.5H2z"
			}),
			/* @__PURE__ */ a("circle", {
				fill: "#FFCA28",
				cx: 18.5,
				cy: 15.5,
				r: 4.5
			}),
			/* @__PURE__ */ a("path", {
				opacity: .2,
				fill: "#FFFFFF",
				d: "M14.5,16c0-2.4814453,2.0185547-4.5,4.5-4.5 c1.1132202,0,2.1201782,0.4213867,2.9066162,1.0933838C21.0806274,11.62677,19.8682251,11,18.5,11 c-2.4814453,0-4.5,2.0185547-4.5,4.5c0,1.3682251,0.62677,2.5806274,1.5933838,3.4066162 C14.9213867,18.1201782,14.5,17.1132202,14.5,16z"
			}),
			/* @__PURE__ */ o("linearGradient", {
				id: "SVGID_1_",
				gradientUnits: "userSpaceOnUse",
				x1: 5.2922974,
				y1: .3947754,
				x2: 16.9614258,
				y2: 12.0639038,
				children: [/* @__PURE__ */ a("stop", {
					offset: 0,
					style: {
						stopColor: "#000000",
						stopOpacity: .1
					}
				}), /* @__PURE__ */ a("stop", {
					offset: 1,
					style: {
						stopColor: "#000000",
						stopOpacity: 0
					}
				})]
			}),
			/* @__PURE__ */ a("path", {
				fill: "url(#SVGID_1_)",
				d: "M13.0253296,16C13.010376,15.835083,13,15.6687622,13,15.5 c0-2.8639526,2.2010498-5.2208862,5-5.4746704V5c0-0.1416626-0.031311-0.2753906-0.0847168-0.397644l-7.4006348,6.0748901 c-0.0253906,0.0209961-0.0522461,0.0390625-0.0805664,0.0541992C10.1508789,10.9072266,9.8291016,11,9.5,11 c-0.3422852,0-0.6767578-0.1000977-0.9677734-0.2900391L1.0845947,4.602478L12.4821167,16H13.0253296z"
			}),
			/* @__PURE__ */ a("path", {
				fill: "#303C42",
				d: "M18.5,12c-0.2763672,0-0.5,0.2236328-0.5,0.5v4c0,0.2763672,0.2236328,0.5,0.5,0.5s0.5-0.2236328,0.5-0.5 v-4C19,12.2236328,18.7763672,12,18.5,12z"
			}),
			/* @__PURE__ */ a("circle", {
				fill: "#303C42",
				cx: 18.5,
				cy: 19,
				r: .5
			}),
			/* @__PURE__ */ o("linearGradient", {
				id: "SVGID_2_",
				gradientUnits: "userSpaceOnUse",
				x1: -.3881513,
				y1: 5.3890796,
				x2: 23.9835968,
				y2: 16.7538128,
				children: [/* @__PURE__ */ a("stop", {
					offset: 0,
					style: {
						stopColor: "#FFFFFF",
						stopOpacity: .2
					}
				}), /* @__PURE__ */ a("stop", {
					offset: 1,
					style: {
						stopColor: "#FFFFFF",
						stopOpacity: 0
					}
				})]
			}),
			/* @__PURE__ */ a("path", {
				fill: "url(#SVGID_2_)",
				d: "M19,10.0253296V5c0-1.1030273-0.8969727-2-2-2H2C0.8969727,3,0,3.8969727,0,5v10 c0,1.1030273,0.8969727,2,2,2h11.2131958C13.8683472,19.3049927,15.987793,21,18.5,21c3.0327148,0,5.5-2.4672852,5.5-5.5 C24,12.6360474,21.7989502,10.2791138,19,10.0253296z"
			})
		] }),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {})
	]
}), Gm = /* @__PURE__ */ k({
	MessageMailEnvelopEmailAdd: () => Vm,
	MessageMailEnvelopEmailAtSymbol: () => Hm,
	MessageMailEnvelopEmailAttache: () => Um,
	MessageMailEnvelopEmailAttention: () => Wm
}), Km = (e) => /* @__PURE__ */ o("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 24 24",
	enableBackground: "new 0 0 24 24",
	xmlSpace: "preserve",
	...e,
	children: [
		/* @__PURE__ */ o("g", { children: [
			/* @__PURE__ */ a("path", {
				fill: "#303C42",
				d: "M19,0H5C3.8969727,0,3,0.8969727,3,2v20c0,1.1030273,0.8969727,2,2,2h14c1.1030273,0,2-0.8969727,2-2V2 C21,0.8969727,20.1030273,0,19,0z"
			}),
			/* @__PURE__ */ a("path", {
				fill: "#FAFAFA",
				d: "M15,1v5.2929688l-1.1464844-1.1464844C13.7558594,5.0488281,13.6279297,5,13.5,5 s-0.2558594,0.0488281-0.3535156,0.1464844L12,6.2929688V1H15z"
			}),
			/* @__PURE__ */ a("path", {
				fill: "#01579B",
				d: "M4,22V2c0-0.5512695,0.4487305-1,1-1h1v22H5C4.4487305,23,4,22.5512695,4,22z"
			}),
			/* @__PURE__ */ a("path", {
				fill: "#3479AF",
				d: "M20,22c0,0.5512695-0.4487305,1-1,1H7V1h4v6.5c0,0.2021484,0.121582,0.3847656,0.3085938,0.4619141 c0.1870117,0.0776367,0.4018555,0.034668,0.5449219-0.1083984L13.5,6.2070313l1.6464844,1.6464844 C15.2421875,7.9492188,15.3701172,8,15.5,8c0.0644531,0,0.1293945-0.012207,0.1914063-0.0380859 C15.878418,7.8847656,16,7.7021484,16,7.5V1h3c0.5512695,0,1,0.4487305,1,1V22z"
			}),
			/* @__PURE__ */ o("linearGradient", {
				id: "SVGID_1_",
				gradientUnits: "userSpaceOnUse",
				x1: 13.9289045,
				y1: 3.0710955,
				x2: 23.776989,
				y2: 12.919179,
				children: [/* @__PURE__ */ a("stop", {
					offset: 0,
					style: {
						stopColor: "#000000",
						stopOpacity: .1
					}
				}), /* @__PURE__ */ a("stop", {
					offset: 1,
					style: {
						stopColor: "#000000",
						stopOpacity: 0
					}
				})]
			}),
			/* @__PURE__ */ a("path", {
				fill: "url(#SVGID_1_)",
				d: "M19,1h-3v6.5c0,0.2021484-0.121582,0.3847656-0.3085938,0.4619141 C15.6293945,7.987793,15.5644531,8,15.5,8c-0.1298828,0-0.2578125-0.0507813-0.3535156-0.1464844L13.5,6.2070313 l-1.6464844,1.6464844c-0.1430664,0.1430664-0.3579102,0.1860352-0.5449219,0.1083984 c-0.0830688-0.0343018-0.1470947-0.0952148-0.1994019-0.1635742l-0.0018311,0.005188L20,16.696167V2 C20,1.4487305,19.5512695,1,19,1z"
			}),
			/* @__PURE__ */ o("linearGradient", {
				id: "SVGID_2_",
				gradientUnits: "userSpaceOnUse",
				x1: .6074345,
				y1: 6.6875596,
				x2: 23.3925648,
				y2: 17.3124409,
				children: [/* @__PURE__ */ a("stop", {
					offset: 0,
					style: {
						stopColor: "#FFFFFF",
						stopOpacity: .2
					}
				}), /* @__PURE__ */ a("stop", {
					offset: 1,
					style: {
						stopColor: "#FFFFFF",
						stopOpacity: 0
					}
				})]
			}),
			/* @__PURE__ */ a("path", {
				fill: "url(#SVGID_2_)",
				d: "M19,0H5C3.8969727,0,3,0.8969727,3,2v20c0,1.1030273,0.8969727,2,2,2h14 c1.1030273,0,2-0.8969727,2-2V2C21,0.8969727,20.1030273,0,19,0z"
			})
		] }),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {})
	]
}), qm = (e) => /* @__PURE__ */ o("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 24 24",
	enableBackground: "new 0 0 24 24",
	xmlSpace: "preserve",
	...e,
	children: [
		/* @__PURE__ */ o("g", { children: [
			/* @__PURE__ */ a("path", {
				fill: "#303C42",
				d: "M22.9084473,13.2277222l0.0075684-0.0050659L21,10.3486328V6.5 c0-0.1328125-0.0527344-0.2597656-0.1464844-0.3535156l-5-5C15.7597656,1.0527344,15.6328125,1,15.5,1H5 C3.8974609,1,3,1.8969727,3,3v7.3486328l-1.9160156,2.8740234l0.0075684,0.0050659C1.0384521,13.3071289,1,13.3971558,1,13.5V21 c0,1.1030273,0.8974609,2,2,2h18c1.1025391,0,2-0.8969727,2-2v-7.5C23,13.3971558,22.9615479,13.3071289,22.9084473,13.2277222z"
			}),
			/* @__PURE__ */ a("polygon", {
				fill: "#8D6E63",
				points: "21.5657349,13 21,13 21,12.1513672  "
			}),
			/* @__PURE__ */ a("path", {
				fill: "#E6E6E6",
				d: "M16,2.7070313L19.2929688,6H17c-0.5517578,0-1-0.4487305-1-1V2.7070313z"
			}),
			/* @__PURE__ */ a("path", {
				fill: "#FFFFFF",
				d: "M5,2h10v3c0,1.1030273,0.8974609,2,2,2h3v6h-1c-1.1025391,0-2,0.8969727-2,2c0,0.5512695-0.4482422,1-1,1H8 c-0.5517578,0-1-0.4487305-1-1c0-1.1030273-0.8974609-2-2-2H4V3C4,2.4487305,4.4482422,2,5,2z"
			}),
			/* @__PURE__ */ o("linearGradient", {
				id: "SVGID_1_",
				gradientUnits: "userSpaceOnUse",
				x1: 12,
				y1: 2,
				x2: 12,
				y2: 16,
				children: [
					/* @__PURE__ */ a("stop", {
						offset: 0,
						style: {
							stopColor: "#000000",
							stopOpacity: 0
						}
					}),
					/* @__PURE__ */ a("stop", {
						offset: .85866,
						style: {
							stopColor: "#000000",
							stopOpacity: .0601062
						}
					}),
					/* @__PURE__ */ a("stop", {
						offset: 1,
						style: {
							stopColor: "#000000",
							stopOpacity: .07
						}
					})
				]
			}),
			/* @__PURE__ */ a("path", {
				fill: "url(#SVGID_1_)",
				d: "M5,2h10v3c0,1.1030273,0.8974609,2,2,2h3v6h-1c-1.1025391,0-2,0.8969727-2,2 c0,0.5512695-0.4482422,1-1,1H8c-0.5517578,0-1-0.4487305-1-1c0-1.1030273-0.8974609-2-2-2H4V3C4,2.4487305,4.4482422,2,5,2z"
			}),
			/* @__PURE__ */ a("polygon", {
				fill: "#8D6E63",
				points: "3,13 2.4342651,13 3,12.1513672  "
			}),
			/* @__PURE__ */ a("path", {
				fill: "#8D6E63",
				d: "M22,21c0,0.5512695-0.4482422,1-1,1H3c-0.5517578,0-1-0.4487305-1-1v-7h3c0.5517578,0,1,0.4487305,1,1 c0,1.1030273,0.8974609,2,2,2h8c1.1025391,0,2-0.8969727,2-2c0-0.5512695,0.4482422-1,1-1h3V21z"
			}),
			/* @__PURE__ */ a("path", {
				fill: "#303C42",
				d: "M7.5,9h9C16.7763672,9,17,8.7763672,17,8.5S16.7763672,8,16.5,8h-9C7.2236328,8,7,8.2236328,7,8.5 S7.2236328,9,7.5,9z"
			}),
			/* @__PURE__ */ a("path", {
				fill: "#303C42",
				d: "M7.5,11h9c0.2763672,0,0.5-0.2236328,0.5-0.5S16.7763672,10,16.5,10h-9C7.2236328,10,7,10.2236328,7,10.5 S7.2236328,11,7.5,11z"
			}),
			/* @__PURE__ */ a("path", {
				fill: "#303C42",
				d: "M7.5,13h5c0.2763672,0,0.5-0.2236328,0.5-0.5S12.7763672,12,12.5,12h-5C7.2236328,12,7,12.2236328,7,12.5 S7.2236328,13,7.5,13z"
			}),
			/* @__PURE__ */ o("linearGradient", {
				id: "SVGID_2_",
				gradientUnits: "userSpaceOnUse",
				x1: 7,
				y1: 9,
				x2: 20.7068176,
				y2: 22.7068176,
				children: [/* @__PURE__ */ a("stop", {
					offset: 0,
					style: {
						stopColor: "#000000",
						stopOpacity: .1
					}
				}), /* @__PURE__ */ a("stop", {
					offset: 1,
					style: {
						stopColor: "#000000",
						stopOpacity: 0
					}
				})]
			}),
			/* @__PURE__ */ a("path", {
				fill: "url(#SVGID_2_)",
				d: "M21,22c0.5517578,0,1-0.4487305,1-1v-7h-3c-0.5517578,0-1,0.4487305-1,1 c0,1.1030273-0.8974609,2-2,2H8c-1.1025391,0-2-0.8969727-2-2c0-0.5512695-0.4482422-1-1-1H2l8,8H21z"
			}),
			/* @__PURE__ */ o("linearGradient", {
				id: "SVGID_3_",
				gradientUnits: "userSpaceOnUse",
				x1: 16.6080017,
				y1: 5.5184021,
				x2: 20.9552002,
				y2: 9.8656006,
				children: [/* @__PURE__ */ a("stop", {
					offset: 0,
					style: {
						stopColor: "#000000",
						stopOpacity: .1
					}
				}), /* @__PURE__ */ a("stop", {
					offset: 1,
					style: {
						stopColor: "#000000",
						stopOpacity: 0
					}
				})]
			}),
			/* @__PURE__ */ a("path", {
				fill: "url(#SVGID_3_)",
				d: "M20,10.8208008V7h-3c-0.5182495,0-0.9868164-0.203186-1.3425293-0.527832L15.652832,6.4735718 L20,10.8208008z"
			}),
			/* @__PURE__ */ o("linearGradient", {
				id: "SVGID_4_",
				gradientUnits: "userSpaceOnUse",
				x1: .4696825,
				y1: 7.9831395,
				x2: 24.1314259,
				y2: 19.0167923,
				children: [/* @__PURE__ */ a("stop", {
					offset: 0,
					style: {
						stopColor: "#FFFFFF",
						stopOpacity: .2
					}
				}), /* @__PURE__ */ a("stop", {
					offset: 1,
					style: {
						stopColor: "#FFFFFF",
						stopOpacity: 0
					}
				})]
			}),
			/* @__PURE__ */ a("path", {
				fill: "url(#SVGID_4_)",
				d: "M22.9084473,13.2277222l0.0075684-0.0050659L21,10.3486328V6.5 c0-0.1328125-0.0527344-0.2597656-0.1464844-0.3535156l-5-5C15.7597656,1.0527344,15.6328125,1,15.5,1H5 C3.8974609,1,3,1.8969727,3,3v7.3486328l-1.9160156,2.8740234l0.0075684,0.0050659C1.0384521,13.3071289,1,13.3971558,1,13.5V21 c0,1.1030273,0.8974609,2,2,2h18c1.1025391,0,2-0.8969727,2-2v-7.5C23,13.3971558,22.9615479,13.3071289,22.9084473,13.2277222z"
			})
		] }),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {})
	]
}), Jm = (e) => /* @__PURE__ */ o("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 24 24",
	enableBackground: "new 0 0 24 24",
	xmlSpace: "preserve",
	...e,
	children: [
		/* @__PURE__ */ o("g", { children: [
			/* @__PURE__ */ a("path", {
				fill: "#303C42",
				d: "M23,7.8720908c0-1.0184221-1.0260677-2.6959376-2.614912-4.2733688 c-1.4369946-1.4276078-3.2470245-2.6663537-4.4037132-2.5958526c-0.2823877,0.0172117-0.5258341,0.1184547-0.7154074,0.3070887 c-0.0293818,0.0291101-0.0598011,0.0664587-0.0897322,0.1060042L15.1746502,1.41462 c-0.0042057,0.0051873-0.0068884,0.011107-0.0110941,0.0162942c-0.0040846,0.0056756-0.007803,0.0116562-0.0118876,0.0175148 c-0.6985331,0.872628-1.0805035,1.9250419-1.1423168,3.0061388l-3.6901731,2.6814737 c-1.9771547-0.3482823-3.968574,0.0413766-5.6372142,1.081707C4.1947775,8.5219078,3.9309456,9.0921459,4.0099487,9.6711721 c0.3285098,2.3880558,1.3616486,4.5532389,2.8764882,6.2865944l-5.7527933,6.2020102 c-0.182878,0.1972408-0.1775136,0.5038414,0.0126795,0.693758C1.2438582,22.9511776,1.371629,23,1.4993997,23 c0.1219187,0,0.2438374-0.0444279,0.3399093-0.1337719l6.1951752-5.7592583 c1.7315502,1.5164642,3.8942652,2.5505714,6.2795429,2.8792629c0.0687618,0.0097637,0.1370363,0.0141582,0.2048235,0.0141582 c0.5042553,0,0.97925-0.2563133,1.2469835-0.6869221c0.7944231-1.2766895,1.2143106-2.7442703,1.2143106-4.2445631 c0-0.4676514-0.053339-0.9430532-0.138073-1.4173565l2.6791019-3.6769495 c1.1227474-0.0671301,2.2359867-0.4963951,3.1239204-1.2385473l-0.0080452-0.0082388 c0.0158482-0.0138531,0.0371227-0.0180025,0.0523033-0.0330763C22.8312645,8.5541306,23,8.297328,23,7.8720908z"
			}),
			/* @__PURE__ */ a("path", {
				fill: "#0288D1",
				d: "M16.1152554,1.9916992c0.4545898,0,1.8295898,0.5673828,3.5898438,2.3144531 c1.9760742,1.9604492,2.4560547,3.4458008,2.309082,3.6748047c-0.2333984,0.1586914-1.7304688-0.3129883-3.7192383-2.2871094 c-1.9760742-1.9604492-2.4560547-3.4458008-2.309082-3.6748047C16.0127163,2.0009766,16.0561733,1.9916992,16.1152554,1.9916992z"
			}),
			/* @__PURE__ */ a("path", {
				opacity: .1,
				d: "M16.1152554,1.9916992c0.4545898,0,1.8295898,0.5673828,3.5898438,2.3144531 c1.9760742,1.9604492,2.4560547,3.4458008,2.309082,3.6748047c-0.2333984,0.1586914-1.7304688-0.3129883-3.7192383-2.2871094 c-1.9760742-1.9604492-2.4560547-3.4458008-2.309082-3.6748047C16.0127163,2.0009766,16.0561733,1.9916992,16.1152554,1.9916992z"
			}),
			/* @__PURE__ */ a("path", {
				fill: "#0288D1",
				d: "M19.250021,9c-2.3432617,0-4.25-1.9067383-4.25-4.25c0-0.008728,0.0021973-0.0171509,0.0022583-0.0258789 h0.0001831l-0.0001221-0.0004883c0.0032349-0.4985352,0.098999-0.9839478,0.2758179-1.4450684 c0.4130859,0.928894,1.2263794,2.0479736,2.3126831,3.1252441c0.9921875,0.9845581,2.1586304,1.8671265,3.1690063,2.3027344 C20.2800503,8.8959351,19.7732143,9,19.250021,9z"
			}),
			/* @__PURE__ */ a("path", {
				fill: "#0288D1",
				d: "M14.0901699,5.6414795c0.3757324,2.177002,2.0869141,3.8900757,4.2632446,4.2678223L16.1445522,12.9375 c-2.6362305-0.3759766-4.7143555-2.4604492-5.0834961-5.0976563L14.0901699,5.6414795z"
			}),
			/* @__PURE__ */ a("path", {
				fill: "#0288D1",
				d: "M14.9355679,18.7841797c-0.0932617,0.1499023-0.2890625,0.2363281-0.4682617,0.2114258 c-4.8969727-0.6743164-8.7885742-4.5654297-9.4628906-9.4624023c-0.0253906-0.1826172,0.0615234-0.3754883,0.2109375-0.46875 c1.4502563-0.9039917,3.1738281-1.2495117,4.901062-0.9537964c0.477356,2.9697266,2.8006592,5.2954102,5.7714844,5.7733765 c0.0679321,0.3967896,0.1121216,0.7938232,0.1121216,1.1838379C16.000021,16.3813477,15.6318569,17.6665039,14.9355679,18.7841797z "
			}),
			/* @__PURE__ */ a("path", {
				opacity: .2,
				fill: "#FFFFFF",
				d: "M15.531271,5.28125c0-0.008728,0.0021973-0.0171509,0.0022583-0.0258789h0.0001831 l-0.0001221-0.0004883c0.0025635-0.3952637,0.0784912-0.7783813,0.1917114-1.1516113 c-0.1763306-0.2857056-0.3311157-0.5638428-0.4471436-0.824707c-0.1768188,0.4611206-0.272583,0.9465332-0.2758179,1.4450684 l0.0001221,0.0004883h-0.0001831C15.0022182,4.7328491,15.000021,4.741272,15.000021,4.75 c0,1.3070679,0.605896,2.4636841,1.5372925,3.2439575C15.9187222,7.2556152,15.531271,6.3174438,15.531271,5.28125z"
			}),
			/* @__PURE__ */ a("path", {
				opacity: .2,
				fill: "#FFFFFF",
				d: "M11.5923061,8.3710938l2.6948242-1.9557495 c-0.0839844-0.2501831-0.151123-0.5083008-0.1969604-0.7738647l-3.0291138,2.1983643 c0.203186,1.4515991,0.9362183,2.722168,1.9830322,3.6461182C12.2870083,10.6271362,11.7589321,9.5613403,11.5923061,8.3710938z"
			}),
			/* @__PURE__ */ a("path", {
				opacity: .2,
				fill: "#FFFFFF",
				d: "M5.5356655,10.0644531c-0.0253906-0.1826172,0.0615234-0.3754883,0.2109375-0.46875 c1.3341064-0.831604,2.8996582-1.1837158,4.4865112-1.0056763c-0.0375977-0.1604614-0.090271-0.3147583-0.1166992-0.4793701 C8.3891811,7.8149414,6.6656094,8.1604614,5.215353,9.0644531c-0.1494141,0.0932617-0.2363281,0.2861328-0.2109375,0.46875 c0.3550415,2.5783081,1.6077881,4.871521,3.4237671,6.569458C6.9014492,14.4697876,5.8548794,12.3828125,5.5356655,10.0644531z"
			}),
			/* @__PURE__ */ o("linearGradient", {
				id: "SVGID_1_",
				gradientUnits: "userSpaceOnUse",
				x1: 3.7933981,
				y1: 9.5710087,
				x2: 19.0335808,
				y2: 16.6776218,
				children: [/* @__PURE__ */ a("stop", {
					offset: 0,
					style: {
						stopColor: "#FFFFFF",
						stopOpacity: .2
					}
				}), /* @__PURE__ */ a("stop", {
					offset: 1,
					style: {
						stopColor: "#FFFFFF",
						stopOpacity: 0
					}
				})]
			}),
			/* @__PURE__ */ a("path", {
				fill: "url(#SVGID_1_)",
				d: "M23,7.8720908c0-1.0184221-1.0260677-2.6959376-2.614912-4.2733688 c-1.4369946-1.4276078-3.2470245-2.6663537-4.4037132-2.5958526c-0.2823877,0.0172117-0.5258341,0.1184547-0.7154074,0.3070887 c-0.0293818,0.0291101-0.0598011,0.0664587-0.0897322,0.1060042L15.1746502,1.41462 c-0.0042057,0.0051873-0.0068884,0.011107-0.0110941,0.0162942c-0.0040846,0.0056756-0.007803,0.0116562-0.0118876,0.0175148 c-0.6985331,0.872628-1.0805035,1.9250419-1.1423168,3.0061388l-3.6901731,2.6814737 c-1.9771547-0.3482823-3.968574,0.0413766-5.6372142,1.081707C4.1947775,8.5219078,3.9309456,9.0921459,4.0099487,9.6711721 c0.3285098,2.3880558,1.3616486,4.5532389,2.8764882,6.2865944l-5.7527933,6.2020102 c-0.182878,0.1972408-0.1775136,0.5038414,0.0126795,0.693758C1.2438582,22.9511776,1.371629,23,1.4993997,23 c0.1219187,0,0.2438374-0.0444279,0.3399093-0.1337719l6.1951752-5.7592583 c1.7315502,1.5164642,3.8942652,2.5505714,6.2795429,2.8792629c0.0687618,0.0097637,0.1370363,0.0141582,0.2048235,0.0141582 c0.5042553,0,0.97925-0.2563133,1.2469835-0.6869221c0.7944231-1.2766895,1.2143106-2.7442703,1.2143106-4.2445631 c0-0.4676514-0.053339-0.9430532-0.138073-1.4173565l2.6791019-3.6769495 c1.1227474-0.0671301,2.2359867-0.4963951,3.1239204-1.2385473l-0.0080452-0.0082388 c0.0158482-0.0138531,0.0371227-0.0180025,0.0523033-0.0330763C22.8312645,8.5541306,23,8.297328,23,7.8720908z"
			})
		] }),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {})
	]
}), Ym = /* @__PURE__ */ k({
	OfficeAgendaCallendarBookNotebook: () => Km,
	OfficeArchiveBoxContain: () => qm,
	OfficePinPinnerDocument: () => Jm
}), Xm = (e) => /* @__PURE__ */ o("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 24 24",
	enableBackground: "new 0 0 24 24",
	xmlSpace: "preserve",
	...e,
	children: [
		/* @__PURE__ */ o("g", { children: [
			/* @__PURE__ */ a("path", {
				fill: "#303C42",
				d: "M21.5,9c-0.6054688,0-1.4511719,0.262207-2.203125,0.6831055 c0.1572266-1.9189453,0.4550781-3.7329102,0.6777344-4.9165039c0.0810547-0.4311523-0.0341797-0.8730469-0.3164063-1.2128906 C19.3671875,3.2016602,18.9335938,3,18.4697266,3h-4.3369141c-0.3652344,0-0.7001953,0.1982422-0.875,0.5175781 c-0.1757813,0.3208008-0.1611328,0.7119141,0.0380859,1.0219727C13.7578125,5.2568359,14,6.0688477,14,6.5 C14,7.3271484,13.1025391,8,12,8s-2-0.6728516-2-1.5c0-0.4311523,0.2421875-1.2431641,0.7050781-1.9614258 c0.1982422-0.309082,0.2128906-0.7001953,0.0371094-1.0209961C10.5673828,3.1982422,10.2324219,3,9.8671875,3H5.5302734 C5.0664063,3,4.6328125,3.2016602,4.3417969,3.5537109C4.0595703,3.8935547,3.9443359,4.3354492,4.0253906,4.7666016 c0.2226563,1.1835938,0.5205078,2.9975586,0.6806641,4.9179688C3.9511719,9.262207,3.1054688,9,2.5,9 C1.1210938,9,0,10.3457031,0,12s1.1210938,3,2.5,3c0.6054688,0,1.4511719-0.262207,2.203125-0.6835938 c-0.1572266,1.9194336-0.4550781,3.7333984-0.6777344,4.9169922c-0.0810547,0.4311523,0.0341797,0.8730469,0.3164063,1.2128906 C4.6337891,20.7983398,5.0664063,21,5.5302734,21h4.3369141c0.3652344,0,0.7001953-0.1982422,0.875-0.5175781 c0.1757813-0.3208008,0.1611328-0.7119141-0.0380859-1.0219727C10.2421875,18.7431641,10,17.9311523,10,17.5 c0-0.8271484,0.8974609-1.5,2-1.5s2,0.6728516,2,1.5c0,0.4311523-0.2421875,1.2431641-0.7050781,1.9614258 c-0.1982422,0.309082-0.2128906,0.7001953-0.0371094,1.0209961C13.4326172,20.8017578,13.7675781,21,14.1328125,21h4.3369141 c0.4638672,0,0.8964844-0.2016602,1.1884766-0.5537109c0.2822266-0.3398438,0.3974609-0.7817383,0.3164063-1.2128906 c-0.2226563-1.1835938-0.5205078-2.9975586-0.6806641-4.9179688C20.0488281,14.737793,20.8945313,15,21.5,15 c1.3789063,0,2.5-1.3457031,2.5-3S22.8789063,9,21.5,9z"
			}),
			/* @__PURE__ */ a("path", {
				fill: "#0288D1",
				d: "M21.5,14c-0.359375,0-1.0292969-0.1723633-1.7177734-0.5571289 c-0.3212891-0.1806641-0.7148438-0.1689453-1.0263672,0.03125c-0.3115234,0.2006836-0.4863281,0.5546875-0.4550781,0.9233398 c0.1591797,1.9628906,0.4638672,3.8134766,0.6914063,5.0205078c0.0351563,0.1884766-0.0498047,0.3251953-0.1035156,0.3896484 C18.7880859,19.9296875,18.6347656,20,18.4697266,20l-4.3339844,0.0024414C14.6523438,19.2006836,15,18.1948242,15,17.5 c0-1.378418-1.3457031-2.5-3-2.5s-3,1.121582-3,2.5c0,0.6948242,0.3476563,1.7006836,0.8671875,2.5H5.5302734 c-0.1650391,0-0.3183594-0.0703125-0.4189453-0.1923828c-0.0537109-0.0644531-0.1386719-0.2011719-0.1035156-0.3896484 c0.2275391-1.2070313,0.5322266-3.0576172,0.6914063-5.0195313c0.03125-0.3696289-0.1435547-0.7236328-0.4550781-0.9243164 c-0.3105469-0.2011719-0.7060547-0.2109375-1.0263672-0.0317383C3.5292969,13.8276367,2.859375,14,2.5,14 C1.6728516,14,1,13.1030273,1,12s0.6728516-2,1.5-2c0.359375,0,1.0292969,0.1723633,1.7177734,0.5571289 c0.3193359,0.1801758,0.7128906,0.168457,1.0263672-0.03125c0.3115234-0.2006836,0.4863281-0.5551758,0.4550781-0.9238281 C5.5390625,7.6396484,5.2353516,5.7890625,5.0078125,4.5820313C4.9726563,4.3935547,5.0576172,4.2568359,5.1113281,4.1923828 C5.2119141,4.0698242,5.3652344,4,5.5302734,4l4.3339844-0.0024414C9.3476563,4.7993164,9,5.8051758,9,6.5 C9,7.878418,10.3457031,9,12,9s3-1.121582,3-2.5c0-0.6948242-0.3476563-1.7006836-0.8671875-2.5h4.3369141 c0.1650391,0,0.3183594,0.0698242,0.4189453,0.1923828c0.0537109,0.0644531,0.1386719,0.2011719,0.1035156,0.3896484 c-0.2275391,1.2070313-0.53125,3.0576172-0.6914063,5.019043c-0.03125,0.3696289,0.1435547,0.7241211,0.4550781,0.9248047 c0.3105469,0.199707,0.7041016,0.2119141,1.0263672,0.0317383C20.4707031,10.1723633,21.140625,10,21.5,10 c0.8271484,0,1.5,0.8969727,1.5,2S22.3271484,14,21.5,14z"
			}),
			/* @__PURE__ */ a("path", {
				opacity: .1,
				d: "M22.1219482,10.1854248c0.2330933,0.3525391,0.3792725,0.8098145,0.3792725,1.3157959 c0,1.1030273-0.6728516,2-1.5,2c-0.359375,0-1.0292969-0.1723633-1.7177734-0.5571289 c-0.3212891-0.1806641-0.7148438-0.1689453-1.0263672,0.03125c-0.3115234,0.2006836-0.4863281,0.5546875-0.4550781,0.9233398 c0.1591797,1.9628906,0.4638672,3.8134766,0.6914063,5.0205078c0.0351563,0.1884766-0.0498047,0.3251953-0.1035156,0.3896484 c-0.1005859,0.1220703-0.2539063,0.1923828-0.4189453,0.1923828l-3.5562134,0.0020142 c-0.0875244,0.1704102-0.1768799,0.3407593-0.2789917,0.4992065L18.4697266,20 c0.1650391,0,0.3183594-0.0703125,0.4189453-0.1923828c0.0537109-0.0644531,0.1386719-0.2011719,0.1035156-0.3896484 c-0.2275391-1.2070313-0.5322266-3.0576172-0.6914063-5.0205078c-0.03125-0.3686523,0.1435547-0.7226563,0.4550781-0.9233398 c0.3115234-0.2001953,0.7050781-0.2119141,1.0263672-0.03125C20.4707031,13.8276367,21.140625,14,21.5,14 c0.8271484,0,1.5-0.8969727,1.5-2C23,11.1936646,22.6385498,10.5016479,22.1219482,10.1854248z"
			}),
			/* @__PURE__ */ a("path", {
				opacity: .2,
				fill: "#FFFFFF",
				d: "M12.5012207,9.5012207c1.6542969,0,3-1.121582,3-2.5 c0-0.6948242-0.3476563-1.7006836-0.8671875-2.5h4.3369141c0.0054321,0,0.0099487,0.0031738,0.0153198,0.0032959 c0.0003662-0.1437988-0.0524902-0.2580566-0.0975952-0.3121338C18.7880859,4.0698242,18.6347656,4,18.4697266,4h-4.3369141 C14.6523438,4.7993164,15,5.8051758,15,6.5C15,7.878418,13.6542969,9,12,9c-0.7857056,0-1.4959106-0.2584839-2.031311-0.671814 C10.5004272,9.0303955,11.4332886,9.5012207,12.5012207,9.5012207z"
			}),
			/* @__PURE__ */ a("path", {
				opacity: .2,
				fill: "#FFFFFF",
				d: "M1.5012207,12.5012207c0-1.1030273,0.6728516-2,1.5-2 c0.359375,0,1.0292969,0.1723633,1.7177734,0.5571289c0.3193359,0.1801758,0.7128906,0.168457,1.0263672-0.03125 c0.3115234-0.2006836,0.4863281-0.5551758,0.4550781-0.9238281C6.0402832,8.1408691,5.7365723,6.2902832,5.5090332,5.083252 C5.473877,4.8947754,5.5588379,4.7580566,5.6125488,4.6936035c0.1005859-0.1225586,0.2539063-0.1923828,0.4189453-0.1923828 l3.5523682-0.0020142c0.0878906-0.1712646,0.1777954-0.3424072,0.2803955-0.5016479L5.5302734,4 C5.3652344,4,5.2119141,4.0698242,5.1113281,4.1923828C5.0576172,4.2568359,4.9726563,4.3935547,5.0078125,4.5820313 c0.2275391,1.2070313,0.53125,3.0576172,0.6914063,5.0200195c0.03125,0.3686523-0.1435547,0.7231445-0.4550781,0.9238281 c-0.3134766,0.199707-0.7070313,0.2114258-1.0263672,0.03125C3.5292969,10.1723633,2.859375,10,2.5,10 C1.6728516,10,1,10.8969727,1,12c0,0.807251,0.3621826,1.5001221,0.8796997,1.8157959 C1.6470337,13.4633789,1.5012207,13.0065918,1.5012207,12.5012207z"
			}),
			/* @__PURE__ */ a("path", {
				opacity: .2,
				fill: "#FFFFFF",
				d: "M5.5090332,19.9191895c0.2275391-1.2070313,0.5322266-3.0576172,0.6914063-5.0195313 c0.03125-0.3696289-0.1435547-0.7236328-0.4550781-0.9243164C5.7039795,13.9485474,5.65802,13.934021,5.6139526,13.9140015 c0.065918,0.1499023,0.0996094,0.3145752,0.0852661,0.484436c-0.1591797,1.9619141-0.4638672,3.8125-0.6914063,5.0195313 c-0.0351563,0.1884766,0.0498047,0.3251953,0.1035156,0.3896484c0.09729,0.118042,0.244812,0.1845703,0.4036255,0.1890869 C5.5150146,19.9691772,5.503418,19.9494629,5.5090332,19.9191895z"
			}),
			/* @__PURE__ */ o("linearGradient", {
				id: "SVGID_1_",
				gradientUnits: "userSpaceOnUse",
				x1: 1.8439993,
				y1: 7.2640934,
				x2: 22.1560669,
				y2: 16.7357655,
				children: [/* @__PURE__ */ a("stop", {
					offset: 0,
					style: {
						stopColor: "#FFFFFF",
						stopOpacity: .2
					}
				}), /* @__PURE__ */ a("stop", {
					offset: 1,
					style: {
						stopColor: "#FFFFFF",
						stopOpacity: 0
					}
				})]
			}),
			/* @__PURE__ */ a("path", {
				fill: "url(#SVGID_1_)",
				d: "M21.5,9c-0.6054688,0-1.4511719,0.262207-2.203125,0.6831055 c0.1572266-1.9189453,0.4550781-3.7329102,0.6777344-4.9165039c0.0810547-0.4311523-0.0341797-0.8730469-0.3164063-1.2128906 C19.3671875,3.2016602,18.9335938,3,18.4697266,3h-4.3369141c-0.3652344,0-0.7001953,0.1982422-0.875,0.5175781 c-0.1757813,0.3208008-0.1611328,0.7119141,0.0380859,1.0219727C13.7578125,5.2568359,14,6.0688477,14,6.5 C14,7.3271484,13.1025391,8,12,8s-2-0.6728516-2-1.5c0-0.4311523,0.2421875-1.2431641,0.7050781-1.9614258 c0.1982422-0.309082,0.2128906-0.7001953,0.0371094-1.0209961C10.5673828,3.1982422,10.2324219,3,9.8671875,3H5.5302734 C5.0664063,3,4.6328125,3.2016602,4.3417969,3.5537109C4.0595703,3.8935547,3.9443359,4.3354492,4.0253906,4.7666016 c0.2226563,1.1835938,0.5205078,2.9975586,0.6806641,4.9179688C3.9511719,9.262207,3.1054688,9,2.5,9 C1.1210938,9,0,10.3457031,0,12s1.1210938,3,2.5,3c0.6054688,0,1.4511719-0.262207,2.203125-0.6835938 c-0.1572266,1.9194336-0.4550781,3.7333984-0.6777344,4.9169922c-0.0810547,0.4311523,0.0341797,0.8730469,0.3164063,1.2128906 C4.6337891,20.7983398,5.0664063,21,5.5302734,21h4.3369141c0.3652344,0,0.7001953-0.1982422,0.875-0.5175781 c0.1757813-0.3208008,0.1611328-0.7119141-0.0380859-1.0219727C10.2421875,18.7431641,10,17.9311523,10,17.5 c0-0.8271484,0.8974609-1.5,2-1.5s2,0.6728516,2,1.5c0,0.4311523-0.2421875,1.2431641-0.7050781,1.9614258 c-0.1982422,0.309082-0.2128906,0.7001953-0.0371094,1.0209961C13.4326172,20.8017578,13.7675781,21,14.1328125,21h4.3369141 c0.4638672,0,0.8964844-0.2016602,1.1884766-0.5537109c0.2822266-0.3398438,0.3974609-0.7817383,0.3164063-1.2128906 c-0.2226563-1.1835938-0.5205078-2.9975586-0.6806641-4.9179688C20.0488281,14.737793,20.8945313,15,21.5,15 c1.3789063,0,2.5-1.3457031,2.5-3S22.8789063,9,21.5,9z"
			})
		] }),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {})
	]
}), Zm = (e) => /* @__PURE__ */ o("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 24 24",
	enableBackground: "new 0 0 24 24",
	xmlSpace: "preserve",
	...e,
	children: [
		/* @__PURE__ */ o("g", { children: [
			/* @__PURE__ */ a("path", {
				fill: "#303C42",
				d: "M21,1H3C1.8969727,1,1,1.8969727,1,3v18c0,1.1030273,0.8969727,2,2,2h18c1.1030273,0,2-0.8969727,2-2V3 C23,1.8969727,22.1030273,1,21,1z"
			}),
			/* @__PURE__ */ a("path", {
				fill: "#5C6671",
				d: "M3,2h18c0.5512695,0,1,0.4487305,1,1v2H2V3C2,2.4487305,2.4487305,2,3,2z"
			}),
			/* @__PURE__ */ o("linearGradient", {
				id: "SVGID_1_",
				gradientUnits: "userSpaceOnUse",
				x1: 3.4401989,
				y1: -.3099827,
				x2: 20.7189465,
				y2: 7.7472296,
				children: [/* @__PURE__ */ a("stop", {
					offset: 0,
					style: {
						stopColor: "#FFFFFF",
						stopOpacity: .2
					}
				}), /* @__PURE__ */ a("stop", {
					offset: 1,
					style: {
						stopColor: "#FFFFFF",
						stopOpacity: 0
					}
				})]
			}),
			/* @__PURE__ */ a("path", {
				fill: "url(#SVGID_1_)",
				d: "M3,2h18c0.5512695,0,1,0.4487305,1,1v2H2V3C2,2.4487305,2.4487305,2,3,2z"
			}),
			/* @__PURE__ */ o("linearGradient", {
				id: "SVGID_2_",
				gradientUnits: "userSpaceOnUse",
				x1: 6.396637,
				y1: -1.8100891,
				x2: 17.603363,
				y2: 9.396637,
				children: [/* @__PURE__ */ a("stop", {
					offset: 0,
					style: {
						stopColor: "#FFFFFF",
						stopOpacity: .2
					}
				}), /* @__PURE__ */ a("stop", {
					offset: 1,
					style: {
						stopColor: "#FFFFFF",
						stopOpacity: 0
					}
				})]
			}),
			/* @__PURE__ */ a("path", {
				fill: "url(#SVGID_2_)",
				d: "M3,2h18c0.5512695,0,1,0.4487305,1,1v2H2V3C2,2.4487305,2.4487305,2,3,2z"
			}),
			/* @__PURE__ */ a("path", {
				fill: "#FFFFFF",
				d: "M21,22H3c-0.5512695,0-1-0.4487305-1-1V6h20v15C22,21.5512695,21.5512695,22,21,22z"
			}),
			/* @__PURE__ */ a("path", {
				fill: "#303C42",
				d: "M9.8842773,11.1796875c-0.1772461-0.2119141-0.4916992-0.2407227-0.7045898-0.0639648l-3,2.5 C6.065918,13.7109375,6,13.8515625,6,14s0.065918,0.2890625,0.1796875,0.3842773l3,2.5 C9.2734375,16.9619141,9.3867188,17,9.4995117,17c0.1435547,0,0.2856445-0.0610352,0.3847656-0.1796875 c0.1767578-0.2124023,0.1479492-0.527832-0.0639648-0.7045898L7.28125,14l2.5390625-2.1157227 C10.0322266,11.7075195,10.0610352,11.3920898,9.8842773,11.1796875z"
			}),
			/* @__PURE__ */ a("path", {
				fill: "#303C42",
				d: "M14.8203125,11.1157227c-0.2128906-0.1767578-0.5273438-0.1479492-0.7045898,0.0639648 c-0.1767578,0.2124023-0.1479492,0.527832,0.0639648,0.7045898L16.71875,14l-2.5390625,2.1157227 c-0.2119141,0.1767578-0.2407227,0.4921875-0.0639648,0.7045898C14.2148438,16.9389648,14.3569336,17,14.5004883,17 c0.112793,0,0.2260742-0.0380859,0.3198242-0.1157227l3-2.5C17.934082,14.2890625,18,14.1484375,18,14 s-0.065918-0.2890625-0.1796875-0.3842773L14.8203125,11.1157227z"
			}),
			/* @__PURE__ */ a("path", {
				fill: "#303C42",
				d: "M13.6967773,10.0405273c-0.2524414-0.109375-0.5473633,0.0078125-0.65625,0.2626953l-3,7 c-0.1088867,0.253418,0.0087891,0.5473633,0.2626953,0.65625C10.3671875,17.9873047,10.434082,18,10.5,18 c0.1938477,0,0.378418-0.1132813,0.4594727-0.3032227l3-7C14.0683594,10.4433594,13.9506836,10.1494141,13.6967773,10.0405273z"
			}),
			/* @__PURE__ */ a("circle", {
				fill: "#303C42",
				cx: 3.5,
				cy: 3.5,
				r: .5
			}),
			/* @__PURE__ */ a("circle", {
				fill: "#303C42",
				cx: 5.5,
				cy: 3.5,
				r: .5
			}),
			/* @__PURE__ */ a("circle", {
				fill: "#303C42",
				cx: 7.5,
				cy: 3.5,
				r: .5
			}),
			/* @__PURE__ */ o("linearGradient", {
				id: "SVGID_3_",
				gradientUnits: "userSpaceOnUse",
				x1: -.6523309,
				y1: 6.100121,
				x2: 24.6523304,
				y2: 17.8998795,
				children: [/* @__PURE__ */ a("stop", {
					offset: 0,
					style: {
						stopColor: "#FFFFFF",
						stopOpacity: .2
					}
				}), /* @__PURE__ */ a("stop", {
					offset: 1,
					style: {
						stopColor: "#FFFFFF",
						stopOpacity: 0
					}
				})]
			}),
			/* @__PURE__ */ a("path", {
				fill: "url(#SVGID_3_)",
				d: "M21,1H3C1.8969727,1,1,1.8969727,1,3v18c0,1.1030273,0.8969727,2,2,2h18 c1.1030273,0,2-0.8969727,2-2V3C23,1.8969727,22.1030273,1,21,1z"
			})
		] }),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {})
	]
}), Qm = (e) => /* @__PURE__ */ o("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 24 24",
	enableBackground: "new 0 0 24 24",
	xmlSpace: "preserve",
	...e,
	children: [
		/* @__PURE__ */ o("g", { children: [
			/* @__PURE__ */ a("path", {
				fill: "#303C42",
				d: "M20.5,14H18v-3.2169189l2.2573242-1.3543701c0.2368164-0.1420898,0.3134766-0.4492188,0.1713867-0.6860352 c-0.1420898-0.2363281-0.449707-0.3139648-0.6860352-0.1713867l-1.8495483,1.1097412 c-0.3378296-1.3966064-1.5115967-2.4564819-2.9623413-2.6374512l-0.2286377-1.3721924 C14.6196899,5.177002,14.3618164,4.7536621,14,4.4559326V3.5C14,2.121582,15.121582,1,16.5,1C16.7763672,1,17,0.7763672,17,0.5 S16.7763672,0,16.5,0C14.5703125,0,13,1.5703125,13,3.5v0.5241089C12.9108887,4.012085,12.8217163,4,12.7294922,4h-1.4589844 C11.1782837,4,11.0891113,4.012085,11,4.0241089V3.5C11,1.5703125,9.4296875,0,7.5,0C7.2236328,0,7,0.2236328,7,0.5 S7.2236328,1,7.5,1C8.878418,1,10,2.121582,10,3.5v0.9559326C9.6381836,4.7536621,9.3803101,5.177002,9.2978516,5.6713867 L9.0692139,7.0435791C7.6184692,7.2245483,6.4447021,8.2844238,6.1068726,9.6810303L4.2573242,8.5712891 C4.0209961,8.4287109,3.7128906,8.5063477,3.5712891,8.7426758C3.4291992,8.9794922,3.5058594,9.2866211,3.7426758,9.4287109 L6,10.7830811V14H3.5C3.2236328,14,3,14.2236328,3,14.5S3.2236328,15,3.5,15H6v3 c0,0.2340698,0.0168457,0.4639893,0.0430298,0.6911621l-2.300354,1.380127 c-0.2368164,0.1420898-0.3134766,0.4492188-0.1713867,0.6860352C3.6650391,20.9135742,3.8305664,21,4.0004883,21 c0.0874023,0,0.1762695-0.0229492,0.2568359-0.0712891l1.9992065-1.1994629C7.0009155,22.1969604,9.2926636,24,12,24 s4.9990845-1.8031616,5.7434692-4.270874l1.9992065,1.199585C19.8232422,20.9770508,19.9121094,21,19.9995117,21 c0.1699219,0,0.3354492-0.0864258,0.4291992-0.2426758c0.1420898-0.2368164,0.0654297-0.5439453-0.1713867-0.6860352 l-2.300354-1.3803101C17.9831543,18.4638672,18,18.2340088,18,18v-3h2.5c0.2763672,0,0.5-0.2236328,0.5-0.5S20.7763672,14,20.5,14z "
			}),
			/* @__PURE__ */ a("path", {
				fill: "#8D6E63",
				d: "M12.7294922,5c0.4907227,0,0.9057617,0.3515625,0.9863281,0.8354492L13.9098511,7h-3.8197021 l0.1940308-1.1645508C10.3647461,5.3515625,10.7797852,5,11.2705078,5H12.7294922z"
			}),
			/* @__PURE__ */ a("path", {
				fill: "#8D6E63",
				d: "M7,18v-7.5C7,9.121582,8.121582,8,9.5,8h2v14.9494629C8.9804688,22.694397,7,20.5856323,7,18z"
			}),
			/* @__PURE__ */ a("path", {
				fill: "#8D6E63",
				d: "M12.5,22.9494629V8h2c1.378418,0,2.5,1.121582,2.5,2.5V18 C17,20.5856323,15.0195313,22.694397,12.5,22.9494629z"
			}),
			/* @__PURE__ */ a("path", {
				opacity: .2,
				fill: "#FFFFFF",
				d: "M8,18v-7.5C8,9.121582,8.8972778,8,10,8H9.5C8.121582,8,7,9.121582,7,10.5V18 c0,2.5856323,1.9804688,4.694397,4.5,4.9494629v-0.0245361C9.5335693,22.6124878,8,20.5415649,8,18z"
			}),
			/* @__PURE__ */ a("path", {
				opacity: .1,
				d: "M14.5,8H14c1.1027222,0,2,1.121582,2,2.5V18c0,2.5415649-1.5335693,4.6124878-3.5,4.9249268v0.0245361 C15.0195313,22.694397,17,20.5856323,17,18v-7.5C17,9.121582,15.878418,8,14.5,8z"
			}),
			/* @__PURE__ */ o("linearGradient", {
				id: "SVGID_1_",
				gradientUnits: "userSpaceOnUse",
				x1: 3.707648,
				y1: 7.4491663,
				x2: 22.5420361,
				y2: 16.2317848,
				children: [/* @__PURE__ */ a("stop", {
					offset: 0,
					style: {
						stopColor: "#FFFFFF",
						stopOpacity: .2
					}
				}), /* @__PURE__ */ a("stop", {
					offset: 1,
					style: {
						stopColor: "#FFFFFF",
						stopOpacity: 0
					}
				})]
			}),
			/* @__PURE__ */ a("path", {
				fill: "url(#SVGID_1_)",
				d: "M20.5,14H18v-3.2169189l2.2573242-1.3543701 c0.2368164-0.1420898,0.3134766-0.4492188,0.1713867-0.6860352c-0.1420898-0.2363281-0.449707-0.3139648-0.6860352-0.1713867 l-1.8495483,1.1097412c-0.3378296-1.3966064-1.5115967-2.4564819-2.9623413-2.6374512l-0.2286377-1.3721924 C14.6196899,5.177002,14.3618164,4.7536621,14,4.4559326V3.5C14,2.121582,15.121582,1,16.5,1C16.7763672,1,17,0.7763672,17,0.5 S16.7763672,0,16.5,0C14.5703125,0,13,1.5703125,13,3.5v0.5241089C12.9108887,4.012085,12.8217163,4,12.7294922,4h-1.4589844 C11.1782837,4,11.0891113,4.012085,11,4.0241089V3.5C11,1.5703125,9.4296875,0,7.5,0C7.2236328,0,7,0.2236328,7,0.5 S7.2236328,1,7.5,1C8.878418,1,10,2.121582,10,3.5v0.9559326C9.6381836,4.7536621,9.3803101,5.177002,9.2978516,5.6713867 L9.0692139,7.0435791C7.6184692,7.2245483,6.4447021,8.2844238,6.1068726,9.6810303L4.2573242,8.5712891 C4.0209961,8.4287109,3.7128906,8.5063477,3.5712891,8.7426758C3.4291992,8.9794922,3.5058594,9.2866211,3.7426758,9.4287109 L6,10.7830811V14H3.5C3.2236328,14,3,14.2236328,3,14.5S3.2236328,15,3.5,15H6v3 c0,0.2340698,0.0168457,0.4639893,0.0430298,0.6911621l-2.300354,1.380127 c-0.2368164,0.1420898-0.3134766,0.4492188-0.1713867,0.6860352C3.6650391,20.9135742,3.8305664,21,4.0004883,21 c0.0874023,0,0.1762695-0.0229492,0.2568359-0.0712891l1.9992065-1.1994629C7.0009155,22.1969604,9.2926636,24,12,24 s4.9990845-1.8031616,5.7434692-4.270874l1.9992065,1.199585C19.8232422,20.9770508,19.9121094,21,19.9995117,21 c0.1699219,0,0.3354492-0.0864258,0.4291992-0.2426758c0.1420898-0.2368164,0.0654297-0.5439453-0.1713867-0.6860352 l-2.300354-1.3803101C17.9831543,18.4638672,18,18.2340088,18,18v-3h2.5c0.2763672,0,0.5-0.2236328,0.5-0.5S20.7763672,14,20.5,14z "
			})
		] }),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {})
	]
}), $m = (e) => /* @__PURE__ */ o("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 24 24",
	enableBackground: "new 0 0 24 24",
	xmlSpace: "preserve",
	...e,
	children: [
		/* @__PURE__ */ o("g", { children: [
			/* @__PURE__ */ a("path", {
				fill: "#303C42",
				d: "M9.5,11h3.9651489C13.3482666,11.9663086,12.9299316,13,12.5,13c-0.2763672,0-0.5,0.2236328-0.5,0.5 s0.2236328,0.5,0.5,0.5h6c0.2763672,0,0.5-0.2236328,0.5-0.5S18.7763672,13,18.5,13c-0.4299316,0-0.8482666-1.0336914-0.9651489-2 H21.5c0.8271484,0,1.5-0.6728516,1.5-1.5v-8C23,0.6728516,22.3271484,0,21.5,0h-12C8.6728516,0,8,0.6728516,8,1.5v8 C8,10.3271484,8.6728516,11,9.5,11z"
			}),
			/* @__PURE__ */ a("path", {
				fill: "#F2F2F2",
				d: "M17.1025391,13h-3.2050781c0.3345947-0.6103516,0.5088501-1.3842773,0.5722656-2h2.0606079 C16.59375,11.6157227,16.7679443,12.3896484,17.1025391,13z"
			}),
			/* @__PURE__ */ a("path", {
				fill: "#F2F2F2",
				d: "M21.5,10h-12C9.2246094,10,9,9.7758789,9,9.5V9h13v0.5C22,9.7758789,21.7753906,10,21.5,10z"
			}),
			/* @__PURE__ */ a("path", {
				fill: "#5C6671",
				d: "M9.5,1h12C21.7753906,1,22,1.2241211,22,1.5V8H9V1.5C9,1.2241211,9.2246094,1,9.5,1z"
			}),
			/* @__PURE__ */ o("linearGradient", {
				id: "SVGID_1_",
				gradientUnits: "userSpaceOnUse",
				x1: 8.9346876,
				y1: 1.5293086,
				x2: 22.1448727,
				y2: 7.6893191,
				children: [/* @__PURE__ */ a("stop", {
					offset: 0,
					style: {
						stopColor: "#FFFFFF",
						stopOpacity: .2
					}
				}), /* @__PURE__ */ a("stop", {
					offset: 1,
					style: {
						stopColor: "#FFFFFF",
						stopOpacity: 0
					}
				})]
			}),
			/* @__PURE__ */ a("path", {
				fill: "url(#SVGID_1_)",
				d: "M9.5,1h12C21.7753906,1,22,1.2241211,22,1.5V8H9V1.5C9,1.2241211,9.2246094,1,9.5,1z"
			}),
			/* @__PURE__ */ o("linearGradient", {
				id: "SVGID_2_",
				gradientUnits: "userSpaceOnUse",
				x1: 10.5733185,
				y1: -.2800446,
				x2: 20.4266815,
				y2: 9.5733185,
				children: [/* @__PURE__ */ a("stop", {
					offset: 0,
					style: {
						stopColor: "#FFFFFF",
						stopOpacity: .2
					}
				}), /* @__PURE__ */ a("stop", {
					offset: 1,
					style: {
						stopColor: "#FFFFFF",
						stopOpacity: 0
					}
				})]
			}),
			/* @__PURE__ */ a("path", {
				fill: "url(#SVGID_2_)",
				d: "M9.5,1h12C21.7753906,1,22,1.2241211,22,1.5V8H9V1.5C9,1.2241211,9.2246094,1,9.5,1z"
			}),
			/* @__PURE__ */ a("path", {
				fill: "#303C42",
				d: "M21,17.5c-0.9762573,0-3,0.5436401-4.0258789,0.8383789 c-0.1361084-1.4348145-1.9746094-1.942688-3.8745117-2.3286133c-0.8671875-0.1757813-1.5126953-0.4868164-2.1367188-0.7880859 C10.1933594,14.8505859,9.4667969,14.5,8.5,14.5c-1.1071167,0-2.1160278,0.2264404-2.6853638,0.3831177 c-0.1505127-0.5236816-0.5775146-0.9458008-1.1447144-1.0588989l-4.0722656-0.8144531 c-0.1464844-0.0292969-0.2988281,0.0087891-0.4150391,0.1035156C0.0673828,13.2084961,0,13.3500977,0,13.5v8 C0,21.7763672,0.2236328,22,0.5,22h3.1328125c0.6174316,0,1.1436157-0.3927612,1.369812-0.9441528 C6.1230469,21.5899658,11.3006592,24,13.5,24c1.9394531,0,5.9326172-1.9628906,8.5742188-3.2617188 c0.6884766-0.3383789,1.2578125-0.6186523,1.6269531-0.7802734C23.8828125,19.8779297,24,19.6982422,24,19.5 C24,18.3222656,22.7666016,17.5,21,17.5z"
			}),
			/* @__PURE__ */ a("path", {
				fill: "#29B6F6",
				d: "M3.6328125,21H1v-6.8901367l3.4746094,0.6948242 c0.2597656,0.0522461,0.4345703,0.2983398,0.3964844,0.5610352l-0.7431641,5.2050781 C4.0927734,20.8154297,3.8798828,21,3.6328125,21z"
			}),
			/* @__PURE__ */ a("path", {
				fill: "#FDD1B0",
				d: "M21.6328125,19.8408203C19.2294922,21.0224609,15.2070313,23,13.5,23 c-1.8183594,0-6.5947266-2.1293945-8.28125-2.949707c-0.0018921-0.0009155-0.0039673-0.0006104-0.0058594-0.0014648 l0.5883179-4.1204834C6.1655273,15.8143921,7.2786255,15.5,8.5,15.5c0.7382813,0,1.3076172,0.2749023,2.0292969,0.6225586 c0.6474609,0.3125,1.3818359,0.6665039,2.3710938,0.8676758C15.0732422,17.4306641,16,17.8823242,16,18.5 c0,0.1220703-0.0371094,0.1972656-0.1318359,0.2680664c-0.3183594,0.237793-1.5595703,0.637207-6.2255859-0.7475586 c-0.2685547-0.0771484-0.5439453,0.0727539-0.6220703,0.3374023s0.0722656,0.5429688,0.3369141,0.621582 c2.3037109,0.6826172,4.0644531,1.0229492,5.3125,1.0229492c0.8134766,0,1.4101563-0.1445313,1.7958984-0.4331055 c0.0332031-0.0247803,0.1501465-0.081543,0.1816406-0.0913086C17.53125,19.2060547,20.0361328,18.5,21,18.5 c0.8154297,0,1.6738281,0.2475586,1.9257813,0.7128906C22.5771484,19.3769531,22.1367188,19.59375,21.6328125,19.8408203z"
			}),
			/* @__PURE__ */ o("linearGradient", {
				id: "SVGID_3_",
				gradientUnits: "userSpaceOnUse",
				x1: 4.6394806,
				y1: 17.1829681,
				x2: 11.4994659,
				y2: 24.0429535,
				children: [/* @__PURE__ */ a("stop", {
					offset: 0,
					style: {
						stopColor: "#000000",
						stopOpacity: .1
					}
				}), /* @__PURE__ */ a("stop", {
					offset: 1,
					style: {
						stopColor: "#000000",
						stopOpacity: 0
					}
				})]
			}),
			/* @__PURE__ */ a("path", {
				fill: "url(#SVGID_3_)",
				d: "M5.7857056,16.0367432l-0.5728149,4.012085 c0.0018921,0.0008545,0.0039673,0.0005493,0.0058594,0.0014648c1.4658203,0.7129517,5.2636719,2.413269,7.4269409,2.8464355 L5.7857056,16.0367432z"
			}),
			/* @__PURE__ */ o("linearGradient", {
				id: "SVGID_4_",
				gradientUnits: "userSpaceOnUse",
				x1: 14.9848785,
				y1: 10.484848,
				x2: 17.3012848,
				y2: 12.8012543,
				children: [/* @__PURE__ */ a("stop", {
					offset: 0,
					style: {
						stopColor: "#000000",
						stopOpacity: .1
					}
				}), /* @__PURE__ */ a("stop", {
					offset: 1,
					style: {
						stopColor: "#000000",
						stopOpacity: 0
					}
				})]
			}),
			/* @__PURE__ */ a("path", {
				fill: "url(#SVGID_4_)",
				d: "M17.1025391,13c-0.3345947-0.6103516-0.5087891-1.3842773-0.5722046-2h-2.0606079l2,2H17.1025391z"
			}),
			/* @__PURE__ */ o("linearGradient", {
				id: "SVGID_5_",
				gradientUnits: "userSpaceOnUse",
				x1: 2.8995497,
				y1: 7.1711512,
				x2: 24.9960155,
				y2: 17.4749031,
				children: [/* @__PURE__ */ a("stop", {
					offset: 0,
					style: {
						stopColor: "#FFFFFF",
						stopOpacity: .2
					}
				}), /* @__PURE__ */ a("stop", {
					offset: 1,
					style: {
						stopColor: "#FFFFFF",
						stopOpacity: 0
					}
				})]
			}),
			/* @__PURE__ */ a("path", {
				fill: "url(#SVGID_5_)",
				d: "M9.5,11h3.9651489C13.3482666,11.9663086,12.9299316,13,12.5,13c-0.2763672,0-0.5,0.2236328-0.5,0.5 s0.2236328,0.5,0.5,0.5h6c0.2763672,0,0.5-0.2236328,0.5-0.5S18.7763672,13,18.5,13c-0.4299316,0-0.8482666-1.0336914-0.9651489-2 H21.5c0.8271484,0,1.5-0.6728516,1.5-1.5v-8C23,0.6728516,22.3271484,0,21.5,0h-12C8.6728516,0,8,0.6728516,8,1.5v8 C8,10.3271484,8.6728516,11,9.5,11z M21,17.5c-0.9762573,0-3,0.5436401-4.0258789,0.8383789 c-0.1361084-1.4348145-1.9746094-1.942688-3.8745117-2.3286133c-0.8671875-0.1757813-1.5126953-0.4868164-2.1367188-0.7880859 C10.1933594,14.8505859,9.4667969,14.5,8.5,14.5c-1.1071167,0-2.1160278,0.2264404-2.6853638,0.3831177 c-0.1505127-0.5236816-0.5775146-0.9458008-1.1447144-1.0588989l-4.0722656-0.8144531 c-0.1464844-0.0292969-0.2988281,0.0087891-0.4150391,0.1035156C0.0673828,13.2084961,0,13.3500977,0,13.5v8 C0,21.7763672,0.2236328,22,0.5,22h3.1328125c0.6174316,0,1.1436157-0.3927612,1.369812-0.9441528 C6.1230469,21.5899658,11.3006592,24,13.5,24c1.9394531,0,5.9326172-1.9628906,8.5742188-3.2617188 c0.6884766-0.3383789,1.2578125-0.6186523,1.6269531-0.7802734C23.8828125,19.8779297,24,19.6982422,24,19.5 C24,18.3222656,22.7666016,17.5,21,17.5z"
			}),
			/* @__PURE__ */ a("path", {
				opacity: .1,
				d: "M1,18v3h2.6328125c0.2470703,0,0.4599609-0.1845703,0.4951172-0.4291992L4.4949951,18H1z"
			})
		] }),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {}),
		/* @__PURE__ */ a("g", {})
	]
}), eh = /* @__PURE__ */ k({
	AddonPuzzlePluginProgram: () => Xm,
	AppCodeWindowCodingProgramPrograming: () => Zm,
	BugCodeProblem: () => Qm,
	HoldHandShareComputerCareProtect: () => $m
}), A = {
	...Gm,
	...Ym,
	...eh
}, th = "data:image/svg+xml,%3csvg%20width='32'%20height='32'%20viewBox='0%200%2032%2032'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20x='0.1'%20y='0.1'%20width='31.8'%20height='31.8'%20rx='7.9'%20fill='white'/%3e%3crect%20x='0.1'%20y='0.1'%20width='31.8'%20height='31.8'%20rx='7.9'%20fill='url(%23paint0_linear_1101_66343)'/%3e%3cpath%20d='M17.1551%2023.2582H22.1002L25.8033%2010.0043H20.8581L17.1551%2023.2582Z'%20fill='%237258FF'/%3e%3cpath%20d='M14.6416%2023.2587L9.69651%2023.256L6%2010L10.9451%2010.0027L14.6416%2023.2587Z'%20fill='%23535066'/%3e%3cpath%20d='M22.1225%2023.2625L17.1773%2023.2598L13.4814%2010.0038L18.426%2010.0065L22.1225%2023.2625Z'%20fill='%23535066'/%3e%3crect%20x='0.1'%20y='0.1'%20width='31.8'%20height='31.8'%20rx='7.9'%20stroke='%23D0D5DD'%20stroke-width='0.2'/%3e%3cdefs%3e%3clinearGradient%20id='paint0_linear_1101_66343'%20x1='16'%20y1='0'%20x2='16'%20y2='32'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='white'/%3e%3cstop%20offset='1'%20stop-color='%23D0D5DD'/%3e%3c/linearGradient%3e%3c/defs%3e%3c/svg%3e", nh = "data:image/svg+xml,%3csvg%20width='126'%20height='48'%20viewBox='0%200%20126%2048'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M28.0111%2047.7226H40.4285L49.727%2014.4415H37.3095L28.0111%2047.7226Z'%20fill='%235FE9D0'/%3e%3cpath%20d='M21.6995%2047.724L9.2821%2047.7172L0%2014.4307L12.4174%2014.4375L21.6995%2047.724Z'%20fill='%235135F3'/%3e%3cpath%20d='M40.4843%2047.7333L28.0669%2047.7265L18.7861%2014.4399L31.2022%2014.4467L40.4843%2047.7333Z'%20fill='%235135F3'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M65.7044%206.26898C65.7044%202.78376%2062.859%200.130371%2059.1492%200.130371C55.4407%200.130371%2052.5953%202.78376%2052.5953%206.26898C52.5953%209.72288%2055.4393%2012.4089%2059.1492%2012.4089C62.859%2012.4089%2065.7044%209.72288%2065.7044%206.26898ZM65.0617%2014.7426H53.231V47.8698H65.0617V14.7426Z'%20fill='%235135F3'/%3e%3cpath%20d='M90.8061%2025.1029C89.3489%2024.5774%2087.8147%2024.2968%2086.2658%2024.2724C83.7077%2024.2724%2081.1496%2026.1266%2081.1496%2030.219V47.8697H69.319V14.7425H81.1496V18.1011C83.2285%2015.479%2086.1378%2013.976%2089.8477%2013.976C90.4874%2013.9726%2091.1236%2014.0695%2091.7332%2014.2633L90.8061%2025.1029Z'%20fill='%235135F3'/%3e%3cpath%20d='M124.059%2014.7425C124.059%2023.2173%20122.045%2028.7487%20118.24%2031.8187L125.728%2047.8697H113.067L107.663%2035.0153H105.29V47.8697H93.4581V1.18555H105.29V24.8741H106.888C109.542%2024.8741%20112.228%2023.1152%20112.228%2014.737L124.059%2014.7425Z'%20fill='%235135F3'/%3e%3c/svg%3e", rh = "data:image/svg+xml,%3csvg%20width='51'%20height='33'%20viewBox='0%200%2051%2033'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M11.1551%2018.9531H16.1002L19.8033%205.69928H14.8581L11.1551%2018.9531Z'%20fill='%239482FF'/%3e%3cpath%20d='M8.64163%2018.9537L3.69651%2018.951L0%205.69495L4.94512%205.69766L8.64163%2018.9537Z'%20fill='%23475467'/%3e%3cpath%20d='M16.1225%2018.9575L11.1773%2018.9548L7.48138%205.69873L12.426%205.70144L16.1225%2018.9575Z'%20fill='%23475467'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M26.1661%202.44464C26.1661%201.05669%2025.033%200%2023.5556%200C22.0787%200%2020.9456%201.05669%2020.9456%202.44464C20.9456%203.82012%2022.0782%204.88982%2023.5556%204.88982C25.033%204.88982%2026.1661%203.82012%2026.1661%202.44464ZM25.9102%205.81913H21.1988V19.0117H25.9102V5.81913Z'%20fill='%23475467'/%3e%3cpath%20d='M36.1627%209.94503C35.5823%209.73576%2034.9714%209.62401%2034.3545%209.61431C33.3358%209.61431%2032.3171%2010.3527%2032.3171%2011.9825V19.0117H27.6056V5.81913H32.3171V7.15666C33.1449%206.11244%2034.3036%205.51389%2035.781%205.51389C36.0357%205.51252%2036.2891%205.55113%2036.5319%205.62829L36.1627%209.94503Z'%20fill='%23475467'/%3e%3cpath%20d='M49.4051%205.81914C49.4051%209.19414%2048.6033%2011.397%2047.0879%2012.6196L50.0698%2019.0117H45.0277L42.8758%2013.8926H41.9308V19.0117H37.2188V0.420227H41.9308V9.85396H42.5673C43.624%209.85396%2044.6937%209.15348%2044.6937%205.81697L49.4051%205.81914Z'%20fill='%23475467'/%3e%3cg%20clip-path='url(%23clip0_1894_485083)'%3e%3crect%20y='21.8008'%20width='29.2229'%20height='10.247'%20rx='5.12349'%20fill='%23475467'/%3e%3cpath%20d='M5.09131%2028.8179C4.90995%2028.4665%204.81927%2028.0783%204.81927%2027.6532C4.81927%2027.2282%204.90995%2026.84%205.09131%2026.4886C5.27267%2026.1372%205.52629%2025.8595%205.85217%2025.6555C6.17805%2025.4514%206.54219%2025.3494%206.94458%2025.3494C7.54249%2025.3494%208.03131%2025.5591%208.41103%2025.9785V23.9212C8.41103%2023.7398%208.50171%2023.6492%208.68307%2023.6492H9.29516C9.47652%2023.6492%209.5672%2023.7398%209.5672%2023.9212V29.583C9.5672%2029.7644%209.47652%2029.8551%209.29516%2029.8551H8.68307C8.50171%2029.8551%208.41103%2029.7644%208.41103%2029.583V29.328C8.03131%2029.7474%207.54249%2029.9571%206.94458%2029.9571C6.54219%2029.9571%206.17805%2029.8551%205.85217%2029.651C5.52629%2029.447%205.27267%2029.1693%205.09131%2028.8179ZM5.99244%2027.6532C5.99244%2028.0131%206.10862%2028.3149%206.34099%2028.5586C6.57336%2028.8023%206.85815%2028.9242%207.19536%2028.9242C7.53541%2028.9242%207.82303%2028.8023%208.05823%2028.5586C8.29343%2028.3121%208.41103%2028.0103%208.41103%2027.6532C8.41103%2027.2962%208.29343%2026.9958%208.05823%2026.7521C7.82303%2026.5056%207.53541%2026.3823%207.19536%2026.3823C6.85815%2026.3823%206.57336%2026.5056%206.34099%2026.7521C6.10862%2026.9958%205.99244%2027.2962%205.99244%2027.6532Z'%20fill='%237258FF'/%3e%3cpath%20d='M11.5882%2028.0018C11.6392%2028.3107%2011.7837%2028.5586%2012.0217%2028.7456C12.2598%2028.9327%2012.5545%2029.0262%2012.9058%2029.0262C13.3819%2029.0262%2013.7985%2028.8859%2014.1555%2028.6054C14.2944%2028.4977%2014.4233%2028.5034%2014.5423%2028.6224L14.7506%2028.8307C14.8838%2028.9638%2014.8866%2029.0928%2014.7591%2029.2175C14.2434%2029.7105%2013.627%2029.9571%2012.9101%2029.9571C12.4199%2029.9571%2011.982%2029.8551%2011.5967%2029.651C11.2141%2029.4442%2010.9194%2029.1665%2010.7125%2028.8179C10.5085%2028.4694%2010.4065%2028.0811%2010.4065%2027.6532C10.4065%2027.3359%2010.4674%2027.0355%2010.5893%2026.7521C10.7111%2026.4687%2010.8769%2026.225%2011.0866%2026.021C11.2991%2025.8141%2011.5542%2025.6512%2011.8517%2025.5322C12.1492%2025.4103%2012.4652%2025.3494%2012.7996%2025.3494C13.2388%2025.3494%2013.6355%2025.45%2013.9898%2025.6512C14.344%2025.8496%2014.6188%2026.1188%2014.8144%2026.4588C15.0099%2026.796%2015.1077%2027.1687%2015.1077%2027.5767C15.1077%2027.6164%2015.1048%2027.6759%2015.0992%2027.7553C15.0822%2027.9196%2014.9844%2028.0018%2014.8059%2028.0018H11.5882ZM12.7911%2026.2803C12.5162%2026.2803%2012.2711%2026.3611%2012.0557%2026.5226C11.8432%2026.6841%2011.6973%2026.8995%2011.6179%2027.1687H13.9047C13.8396%2026.9023%2013.7078%2026.6884%2013.5094%2026.5268C13.3111%2026.3625%2013.0716%2026.2803%2012.7911%2026.2803Z'%20fill='%237258FF'/%3e%3cpath%20d='M16.0569%2028.7031C16.1703%2028.5728%2016.2978%2028.5657%2016.4395%2028.6819C16.7229%2028.9086%2017.0275%2029.0219%2017.3534%2029.0219C17.5546%2029.0219%2017.7118%2028.9837%2017.8252%2028.9072C17.9414%2028.8278%2017.9995%2028.7201%2017.9995%2028.5841C17.9995%2028.4481%2017.9428%2028.339%2017.8294%2028.2568C17.7161%2028.1718%2017.5206%2028.101%2017.2429%2028.0443C16.2879%2027.8488%2015.8104%2027.3784%2015.8104%2026.6331C15.8104%2026.259%2015.9563%2025.9516%2016.2482%2025.7107C16.5429%2025.4698%2016.9269%2025.3494%2017.4001%2025.3494C17.8252%2025.3494%2018.1766%2025.4458%2018.4543%2025.6385C18.7348%2025.8283%2018.9318%2026.0947%2019.0451%2026.4376C19.0734%2026.5282%2019.0649%2026.6019%2019.0196%2026.6586C18.9743%2026.7124%2018.9034%2026.7394%2018.8071%2026.7394H18.246C18.1723%2026.7394%2018.1128%2026.7224%2018.0675%2026.6884C18.025%2026.6543%2017.981%2026.6005%2017.9357%2026.5268C17.8365%2026.3653%2017.6778%2026.2845%2017.4596%2026.2845C17.318%2026.2845%2017.1975%2026.3185%2017.0983%2026.3866C17.002%2026.4517%2016.9538%2026.5396%2016.9538%2026.6501C16.9538%2026.9051%2017.1876%2027.0808%2017.6552%2027.1772C18.1624%2027.2792%2018.5365%2027.4478%2018.7773%2027.683C19.021%2027.9182%2019.1429%2028.2228%2019.1429%2028.5969C19.1429%2028.9936%2018.9856%2029.3195%2018.6711%2029.5745C18.3593%2029.8295%2017.9357%2029.9571%2017.4001%2029.9571C16.8362%2029.9571%2016.3417%2029.7162%2015.9167%2029.2345C15.8062%2029.1098%2015.809%2028.9823%2015.9252%2028.8519L16.0569%2028.7031Z'%20fill='%237258FF'/%3e%3cpath%20d='M23.3393%2025.4514C23.43%2025.4514%2023.498%2025.4755%2023.5434%2025.5237C23.5916%2025.5719%2023.6128%2025.6413%2023.6071%2025.732C23.5618%2026.6983%2023.2685%2027.3472%2022.7273%2027.6787L23.7729%2029.5278C23.8268%2029.6241%2023.8353%2029.7034%2023.7984%2029.7658C23.7616%2029.8253%2023.6893%2029.8551%2023.5816%2029.8551H22.876C22.7315%2029.8551%2022.6238%2029.7913%2022.553%2029.6638L21.5966%2027.9295H21.146V29.583C21.146%2029.7644%2021.0554%2029.8551%2020.874%2029.8551H20.2492C20.0678%2029.8551%2019.9771%2029.7644%2019.9771%2029.583V23.9212C19.9771%2023.7398%2020.0678%2023.6492%2020.2492%2023.6492H20.874C21.0554%2023.6492%2021.146%2023.7398%2021.146%2023.9212V26.9264H21.4818C22.0628%2026.9264%2022.3815%2026.5282%2022.4382%2025.732C22.4524%2025.5449%2022.5445%2025.4514%2022.7145%2025.4514H23.3393Z'%20fill='%237258FF'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_1894_485083'%3e%3crect%20width='29.5181'%20height='10.8434'%20fill='white'%20transform='translate(0%2021.4213)'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", ih = "data:image/svg+xml,%3csvg%20width='51'%20height='33'%20viewBox='0%200%2051%2033'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M11.1551%2018.9531H16.1002L19.8033%205.69928H14.8581L11.1551%2018.9531Z'%20fill='%239482FF'/%3e%3cpath%20d='M8.64163%2018.9537L3.69651%2018.951L0%205.69495L4.94512%205.69766L8.64163%2018.9537Z'%20fill='%23475467'/%3e%3cpath%20d='M16.1225%2018.9575L11.1773%2018.9548L7.48138%205.69873L12.426%205.70144L16.1225%2018.9575Z'%20fill='%23475467'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M26.1661%202.44464C26.1661%201.05669%2025.033%200%2023.5556%200C22.0787%200%2020.9456%201.05669%2020.9456%202.44464C20.9456%203.82012%2022.0782%204.88982%2023.5556%204.88982C25.033%204.88982%2026.1661%203.82012%2026.1661%202.44464ZM25.9102%205.81913H21.1988V19.0117H25.9102V5.81913Z'%20fill='%23475467'/%3e%3cpath%20d='M36.1627%209.94503C35.5823%209.73576%2034.9714%209.62401%2034.3545%209.61431C33.3358%209.61431%2032.3171%2010.3527%2032.3171%2011.9825V19.0117H27.6056V5.81913H32.3171V7.15666C33.1449%206.11244%2034.3036%205.51389%2035.781%205.51389C36.0357%205.51252%2036.2891%205.55113%2036.5319%205.62829L36.1627%209.94503Z'%20fill='%23475467'/%3e%3cpath%20d='M49.4051%205.81914C49.4051%209.19414%2048.6033%2011.397%2047.0879%2012.6196L50.0698%2019.0117H45.0277L42.8758%2013.8926H41.9308V19.0117H37.2188V0.420227H41.9308V9.85396H42.5673C43.624%209.85396%2044.6937%209.15348%2044.6937%205.81697L49.4051%205.81914Z'%20fill='%23475467'/%3e%3cg%20clip-path='url(%23clip0_1019_33137)'%3e%3crect%20y='21.8008'%20width='29.2229'%20height='10.247'%20rx='5.12349'%20fill='%23475467'/%3e%3cpath%20d='M5.09131%2028.8179C4.90995%2028.4665%204.81927%2028.0783%204.81927%2027.6532C4.81927%2027.2282%204.90995%2026.84%205.09131%2026.4886C5.27267%2026.1372%205.52629%2025.8595%205.85217%2025.6555C6.17805%2025.4514%206.54219%2025.3494%206.94458%2025.3494C7.54249%2025.3494%208.03131%2025.5591%208.41103%2025.9785V23.9212C8.41103%2023.7398%208.50171%2023.6492%208.68307%2023.6492H9.29516C9.47652%2023.6492%209.5672%2023.7398%209.5672%2023.9212V29.583C9.5672%2029.7644%209.47652%2029.8551%209.29516%2029.8551H8.68307C8.50171%2029.8551%208.41103%2029.7644%208.41103%2029.583V29.328C8.03131%2029.7474%207.54249%2029.9571%206.94458%2029.9571C6.54219%2029.9571%206.17805%2029.8551%205.85217%2029.651C5.52629%2029.447%205.27267%2029.1693%205.09131%2028.8179ZM5.99244%2027.6532C5.99244%2028.0131%206.10862%2028.3149%206.34099%2028.5586C6.57336%2028.8023%206.85815%2028.9242%207.19536%2028.9242C7.53541%2028.9242%207.82303%2028.8023%208.05823%2028.5586C8.29343%2028.3121%208.41103%2028.0103%208.41103%2027.6532C8.41103%2027.2962%208.29343%2026.9958%208.05823%2026.7521C7.82303%2026.5056%207.53541%2026.3823%207.19536%2026.3823C6.85815%2026.3823%206.57336%2026.5056%206.34099%2026.7521C6.10862%2026.9958%205.99244%2027.2962%205.99244%2027.6532Z'%20fill='white'/%3e%3cpath%20d='M11.5882%2028.0018C11.6392%2028.3107%2011.7837%2028.5586%2012.0217%2028.7456C12.2598%2028.9327%2012.5545%2029.0262%2012.9058%2029.0262C13.3819%2029.0262%2013.7985%2028.8859%2014.1555%2028.6054C14.2944%2028.4977%2014.4233%2028.5034%2014.5423%2028.6224L14.7506%2028.8307C14.8838%2028.9638%2014.8866%2029.0928%2014.7591%2029.2175C14.2434%2029.7105%2013.627%2029.9571%2012.9101%2029.9571C12.4199%2029.9571%2011.982%2029.8551%2011.5967%2029.651C11.2141%2029.4442%2010.9194%2029.1665%2010.7125%2028.8179C10.5085%2028.4694%2010.4065%2028.0811%2010.4065%2027.6532C10.4065%2027.3359%2010.4674%2027.0355%2010.5893%2026.7521C10.7111%2026.4687%2010.8769%2026.225%2011.0866%2026.021C11.2991%2025.8141%2011.5542%2025.6512%2011.8517%2025.5322C12.1492%2025.4103%2012.4652%2025.3494%2012.7996%2025.3494C13.2388%2025.3494%2013.6355%2025.45%2013.9898%2025.6512C14.344%2025.8496%2014.6188%2026.1188%2014.8144%2026.4588C15.0099%2026.796%2015.1077%2027.1687%2015.1077%2027.5767C15.1077%2027.6164%2015.1048%2027.6759%2015.0992%2027.7553C15.0822%2027.9196%2014.9844%2028.0018%2014.8059%2028.0018H11.5882ZM12.7911%2026.2803C12.5162%2026.2803%2012.2711%2026.3611%2012.0557%2026.5226C11.8432%2026.6841%2011.6973%2026.8995%2011.6179%2027.1687H13.9047C13.8396%2026.9023%2013.7078%2026.6884%2013.5094%2026.5268C13.3111%2026.3625%2013.0716%2026.2803%2012.7911%2026.2803Z'%20fill='white'/%3e%3cpath%20d='M16.0569%2028.7031C16.1703%2028.5728%2016.2978%2028.5657%2016.4395%2028.6819C16.7229%2028.9086%2017.0275%2029.0219%2017.3534%2029.0219C17.5546%2029.0219%2017.7118%2028.9837%2017.8252%2028.9072C17.9414%2028.8278%2017.9995%2028.7201%2017.9995%2028.5841C17.9995%2028.4481%2017.9428%2028.339%2017.8294%2028.2568C17.7161%2028.1718%2017.5206%2028.101%2017.2429%2028.0443C16.2879%2027.8488%2015.8104%2027.3784%2015.8104%2026.6331C15.8104%2026.259%2015.9563%2025.9516%2016.2482%2025.7107C16.5429%2025.4698%2016.9269%2025.3494%2017.4001%2025.3494C17.8252%2025.3494%2018.1766%2025.4458%2018.4543%2025.6385C18.7348%2025.8283%2018.9318%2026.0947%2019.0451%2026.4376C19.0734%2026.5282%2019.0649%2026.6019%2019.0196%2026.6586C18.9743%2026.7124%2018.9034%2026.7394%2018.8071%2026.7394H18.246C18.1723%2026.7394%2018.1128%2026.7224%2018.0675%2026.6884C18.025%2026.6543%2017.981%2026.6005%2017.9357%2026.5268C17.8365%2026.3653%2017.6778%2026.2845%2017.4596%2026.2845C17.318%2026.2845%2017.1975%2026.3185%2017.0983%2026.3866C17.002%2026.4517%2016.9538%2026.5396%2016.9538%2026.6501C16.9538%2026.9051%2017.1876%2027.0808%2017.6552%2027.1772C18.1624%2027.2792%2018.5365%2027.4478%2018.7773%2027.683C19.021%2027.9182%2019.1429%2028.2228%2019.1429%2028.5969C19.1429%2028.9936%2018.9856%2029.3195%2018.6711%2029.5745C18.3593%2029.8295%2017.9357%2029.9571%2017.4001%2029.9571C16.8362%2029.9571%2016.3417%2029.7162%2015.9167%2029.2345C15.8062%2029.1098%2015.809%2028.9823%2015.9252%2028.8519L16.0569%2028.7031Z'%20fill='white'/%3e%3cpath%20d='M23.3393%2025.4514C23.43%2025.4514%2023.498%2025.4755%2023.5434%2025.5237C23.5916%2025.5719%2023.6128%2025.6413%2023.6071%2025.732C23.5618%2026.6983%2023.2685%2027.3472%2022.7273%2027.6787L23.7729%2029.5278C23.8268%2029.6241%2023.8353%2029.7034%2023.7984%2029.7658C23.7616%2029.8253%2023.6893%2029.8551%2023.5816%2029.8551H22.876C22.7315%2029.8551%2022.6238%2029.7913%2022.553%2029.6638L21.5966%2027.9295H21.146V29.583C21.146%2029.7644%2021.0554%2029.8551%2020.874%2029.8551H20.2492C20.0678%2029.8551%2019.9771%2029.7644%2019.9771%2029.583V23.9212C19.9771%2023.7398%2020.0678%2023.6492%2020.2492%2023.6492H20.874C21.0554%2023.6492%2021.146%2023.7398%2021.146%2023.9212V26.9264H21.4818C22.0628%2026.9264%2022.3815%2026.5282%2022.4382%2025.732C22.4524%2025.5449%2022.5445%2025.4514%2022.7145%2025.4514H23.3393Z'%20fill='white'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_1019_33137'%3e%3crect%20width='29.5181'%20height='10.8434'%20fill='white'%20transform='translate(0%2021.4213)'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", ah = {
	white: "#FFFFFF",
	black: "#000000",
	primary25: "#FCFAFF",
	primary50: "#F9F5FF",
	primary100: "#F2F0FF",
	primary200: "#EDEAFF",
	primary300: "#DCD6FF",
	primary400: "#C5BBFF",
	primary500: "#AFA0FF",
	primary600: "#9482FF",
	primary700: "#7057FF",
	primary800: "#5135F3",
	primary900: "#1C00BB",
	gray25: "#FCFCFD",
	gray50: "#F9FAFB",
	gray100: "#F2F4F7",
	gray200: "#EAECF0",
	gray300: "#D0D5DD",
	gray400: "#98A2B3",
	gray500: "#667085",
	gray600: "#475467",
	gray700: "#344054",
	gray800: "#1D2939",
	gray900: "#101828",
	error25: "#FFFBFA",
	error50: "#FEF3F2",
	error100: "#FEE4E2",
	error200: "#FECDCA",
	error300: "#FDA29B",
	error400: "#F97066",
	error500: "#F04438",
	error600: "#D92D20",
	error700: "#B42318",
	error800: "#912018",
	error900: "#7A271A",
	warning25: "#FFFCF5",
	warning50: "#FFFAEB",
	warning100: "#FEF0C7",
	warning200: "#FEDF89",
	warning300: "#FEC84B",
	warning400: "#FDB022",
	warning500: "#F79009",
	warning600: "#DC6803",
	warning700: "#B54708",
	warning800: "#93370D",
	warning900: "#7A2E0E",
	success25: "#F6FEF9",
	success50: "#ECFDF3",
	success100: "#D1FADF",
	success200: "#A6F4C5",
	success300: "#6CE9A6",
	success400: "#32D583",
	success500: "#12B76A",
	success600: "#039855",
	success700: "#027A48",
	success800: "#05603A",
	success900: "#054F31"
}, oh = {
	grayblue25: "#FCFCFD",
	grayblue50: "#F8F9FC",
	grayblue100: "#EAECF5",
	grayblue200: "#D5D9EB",
	grayblue300: "#B3B8DB",
	grayblue400: "#717BBC",
	grayblue500: "#4E5BA6",
	grayblue600: "#3E4784",
	grayblue700: "#363F72",
	grayblue800: "#293056",
	grayblue900: "#101323",
	blue25: "#F5FAFF",
	blue50: "#EFF8FF",
	blue100: "#D1E9FF",
	blue200: "#B2DDFF",
	blue300: "#84CAFF",
	blue400: "#53B1FD",
	blue500: "#2E90FA",
	blue600: "#1570EF",
	blue700: "#175CD3",
	blue800: "#1849A9",
	blue900: "#194185",
	lightBlue25: "#F5FBFF",
	lightBlue50: "#F0F9FF",
	lightBlue100: "#E0F2FE",
	lightBlue200: "#B9E6FE",
	lightBlue300: "#7CD4FD",
	lightBlue400: "#36BFFA",
	lightBlue500: "#0BA5EC",
	lightBlue600: "#0086C9",
	lightBlue700: "#026AA2",
	lightBlue800: "#065986",
	lightBlue900: "#0B4A6F",
	indigo50: "#EEF4FF",
	indigo700: "#3538CD",
	pink25: "#FEF6FB",
	pink50: "#FDF2FA",
	pink100: "#FCE7F6",
	pink200: "#FCCEEE",
	pink300: "#FAA7E0",
	pink400: "#F670C7",
	pink500: "#EE46BC",
	pink600: "#DD2590",
	pink700: "#C11574",
	pink800: "#9E165F",
	pink900: "#851651",
	purple50: "#F4F3FF",
	purple100: "#EBE9FE",
	purple700: "#5925DC",
	moss200: "#CEEAB0",
	cyan100: "#CFF9FE",
	rose100: "#FFE4E8",
	yellow25: "#FEFDF0",
	yellow50: "#FEFBE8",
	yellow100: "#FEF7C3",
	yellow200: "#FEEE95",
	yellow300: "#FDE272",
	yellow400: "#FAC515",
	yellow500: "#EAAA08",
	yellow600: "#CA8504",
	yellow700: "#A15C07",
	yellow800: "#854A0E",
	yellow900: "#713B12",
	teal100: "#CCFBEF"
}, j = {
	...ah,
	...oh
}, M = {
	container: {
		sm: "40rem",
		md: "48rem",
		lg: "64rem",
		xl: "80rem"
	},
	fontSize: {
		xs: 12,
		sm: 14,
		md: 16,
		lg: 18,
		xl: 20,
		"2xl": 24,
		"3xl": 30,
		"4xl": 36,
		"5xl": 48,
		"6xl": 60,
		"7xl": 72
	},
	controlInteractiveSize: {
		xs: 12,
		sm: 14,
		md: 16,
		lg: 18,
		xl: 20,
		"2xl": 24,
		"3xl": 30,
		"4xl": 36,
		"5xl": 48,
		"6xl": 60,
		"7xl": 72
	},
	lineHeight: {
		xs: 1,
		sm: 1.25,
		md: 1.5,
		lg: 1.75,
		xl: 2,
		"2xl": 2.5,
		"3xl": 3,
		"4xl": 3.5,
		"5xl": 4,
		"6xl": 6,
		"7xl": 8
	},
	borderRadius: {
		xs: 4,
		sm: 6,
		md: 8,
		lg: 12,
		xl: 16,
		"2xl": 24,
		"3xl": 28,
		full: 999
	}
}, N = {
	definitions: M,
	borderRadius: {
		default: M.borderRadius.md,
		table: M.borderRadius.lg
	},
	controlInteractiveSizes: {
		default: M.controlInteractiveSize.md,
		checkbox: M.controlInteractiveSize.md
	},
	fontSize: {
		default: M.fontSize.sm,
		pageHeader: M.fontSize["2xl"],
		pageHeaderSupporting: M.fontSize["2xl"],
		statisticValue: M.fontSize["4xl"],
		tableHeader: M.fontSize.xs,
		tag: M.fontSize.xs
	},
	fontWeight: {
		default: 400,
		semiBoldParagraph: 500,
		pageHeader: 500,
		pageHeaderSupporting: 400,
		tableHeader: 400
	},
	lineHeight: {
		default: M.lineHeight.sm,
		tag: M.lineHeight.xl
	},
	height: { input: { default: 44 } },
	dimensions: { avatar: {
		xs: 24,
		sm: 32,
		md: 40,
		lg: 48,
		xl: 56,
		"2xl": 64
	} }
}, P = {
	spaces: {
		1: "0.25rem",
		2: "0.5rem",
		3: "0.75rem",
		4: "1rem",
		5: "1.25rem",
		6: "1.5rem",
		8: "2rem",
		10: "2.5rem",
		12: "3rem",
		16: "4rem",
		20: "5rem",
		24: "6rem",
		32: "8rem",
		40: "10rem",
		48: "12rem",
		56: "14rem",
		64: "16rem"
	},
	padding: {
		input: { default: 14 },
		card: { default: 16 }
	}
}, sh = {
	borderRadius: N.borderRadius.default,
	colorError: j.error700,
	colorInfo: j.primary700,
	colorPrimary: j.primary700,
	colorSuccess: j.success500,
	colorWarning: j.warning500,
	fontFamily: "'Caros Soft', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
	fontSize: N.fontSize.default,
	controlHeight: N.height.input.default,
	colorBorder: j.gray300,
	colorPrimaryHover: j.primary600,
	colorTextQuaternary: j.gray500,
	lineHeight: N.lineHeight.default,
	borderRadiusSM: N.definitions.borderRadius.xs,
	colorBgContainerDisabled: j.primary200,
	colorFillAlter: j.gray50,
	colorTextPlaceholder: j.gray500,
	controlInteractiveSize: N.controlInteractiveSizes.default,
	controlItemBgHover: j.primary200,
	paddingSM: P.padding.input.default
}, F = ({ children: e, ...t }) => /* @__PURE__ */ a(h, {
	theme: { token: sh },
	...t,
	children: e
});
function I(e, t) {
	return (n) => {
		let { token: r, ...i } = t || {}, { localThemeToken: o = {}, providerProps: s = {} } = n;
		return /* @__PURE__ */ a(h, {
			theme: {
				token: {
					...r,
					...o
				},
				...i
			},
			...s,
			children: /* @__PURE__ */ a(e, { ...n })
		});
	};
}
//#endregion
//#region src/components/layout/col/col.tsx
var L = ({ localThemeToken: e = {}, ...t }) => /* @__PURE__ */ E(F, {
	theme: { token: {
		...ch,
		...e
	} },
	children: /* @__PURE__ */ E(p, { ...t })
}), ch = {}, lh = ({ localThemeToken: e = {}, ...t }) => {
	let { Content: n } = y;
	return /* @__PURE__ */ E(F, {
		theme: { token: {
			...uh,
			...e
		} },
		children: /* @__PURE__ */ E(n, { ...t })
	});
}, uh = {}, R = ({ localThemeToken: e = {}, ...t }) => /* @__PURE__ */ E(F, {
	theme: { token: {
		...dh,
		...e
	} },
	children: /* @__PURE__ */ E(ee, { ...t })
}), dh = {}, fh = ({ localThemeToken: e = {}, ...t }) => {
	let { Footer: n } = y;
	return /* @__PURE__ */ E(F, {
		theme: { token: {
			...ph,
			...e
		} },
		children: /* @__PURE__ */ E(n, { ...t })
	});
}, ph = {}, mh = ({ localThemeToken: e = {}, ...t }) => {
	let { Header: n } = y;
	return /* @__PURE__ */ E(F, {
		theme: { token: {
			...hh,
			...e
		} },
		children: /* @__PURE__ */ E(n, { ...t })
	});
}, hh = {}, gh = ({ localThemeToken: e = {}, ...t }) => /* @__PURE__ */ E(F, {
	theme: { token: {
		..._h,
		...e
	} },
	children: /* @__PURE__ */ E(y, { ...t })
}), _h = { colorBgLayout: "#FFF" }, z = ({ localThemeToken: e = {}, ...t }) => /* @__PURE__ */ E(F, {
	theme: { token: {
		...vh,
		...e
	} },
	children: /* @__PURE__ */ E(ce, { ...t })
}), vh = {}, yh = ({ localThemeToken: e = {}, ...t }) => {
	let { Sider: n } = y;
	return /* @__PURE__ */ E(F, {
		theme: { token: {
			...bh,
			...e
		} },
		children: /* @__PURE__ */ E(n, { ...t })
	});
}, bh = {}, B = ({ localThemeToken: e = {}, ...t }) => /* @__PURE__ */ E(F, {
	theme: { token: {
		...xh,
		...e
	} },
	children: /* @__PURE__ */ E(ue, { ...t })
}), xh = {}, V = I(function({ size: e = "md", iconRight: t, iconRightProps: n = {}, iconLeft: r, iconLeftProps: i = {}, style: a = {}, type: o, children: s, ref: c, ...l }) {
	let d = {
		...Sh,
		...Th[`${e}`],
		...wh[`${o}`] || {},
		...l.disabled ? Eh : {},
		...a
	};
	return /* @__PURE__ */ E(u, {
		ref: c,
		style: d,
		type: Ch.includes(o) ? o : "default",
		"data-testid": "btn",
		...l,
		children: /* @__PURE__ */ D(z, {
			align: "middle",
			justify: "center",
			children: [
				!!r && /* @__PURE__ */ E(T, { children: /* @__PURE__ */ E(W, {
					css: O`
								margin-right: ${e === "2xl" ? "12" : "8"}px;
							`,
					size: e === "2xl" ? 24 : 20,
					icon: r,
					...i
				}) }),
				s,
				!!t && /* @__PURE__ */ E(T, { children: /* @__PURE__ */ E(W, {
					css: O`
								margin-left: ${e === "2xl" ? "12" : "8"}px;
							`,
					size: e === "2xl" ? 24 : 20,
					icon: t,
					...n
				}) })
			]
		})
	});
}), Sh = {
	height: "auto",
	borderRadius: "8px"
}, Ch = [
	"default",
	"primary",
	"dashed",
	"link",
	"text"
], wh = {
	primary: { borderWidth: 0 },
	text: { padding: 0 },
	submit: {},
	default: {
		backgroundColor: j.primary700,
		color: j.white,
		boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)"
	},
	danger: {
		color: j.error700,
		border: `1px solid ${j.error300}`
	},
	dangerFilled: {
		color: j.white,
		backgroundColor: j.error600,
		border: `1px solid ${j.error600}`
	}
}, Th = {
	inline: {
		display: "inline-block",
		padding: "3px 5px",
		fontSize: N.definitions.fontSize.xs,
		fontWeight: 500
	},
	sm: {
		padding: "8px 14px",
		lineHeight: "20px",
		fontSize: N.definitions.fontSize.sm,
		fontWeight: 500
	},
	md: {
		padding: "10px 16px",
		lineHeight: "20px",
		fontSize: N.definitions.fontSize.sm,
		fontWeight: 500
	},
	lg: {
		padding: "12px 18px",
		lineHeight: "24px",
		fontSize: N.definitions.fontSize.md,
		fontWeight: 500
	},
	xl: {
		padding: "14px 20px",
		lineHeight: "24px",
		fontSize: N.definitions.fontSize.md,
		fontWeight: 500
	},
	"2xl": {
		padding: "18px 28px",
		lineHeight: "28px",
		fontSize: N.definitions.fontSize.lg,
		fontWeight: 500
	}
}, Eh = { color: j.white }, { Group: Dh } = u, Oh = I(function({ icon: e, size: t = "md", iconProps: n = {}, ...r }) {
	return /* @__PURE__ */ E(V, {
		style: {
			...kh[`$${t}`],
			...r.style || {}
		},
		size: t,
		...r,
		"data-testid": "icon-btn",
		children: /* @__PURE__ */ E(W, {
			icon: e,
			width: Ah[`$${t}`].width,
			height: Ah[`$${t}`].height,
			...n
		})
	});
}), kh = {
	$xs: {
		padding: "4px",
		lineHeight: "16px"
	},
	$sm: {
		padding: "8px",
		lineHeight: "16px"
	},
	$md: {
		padding: "10px",
		lineHeight: "16px"
	},
	$lg: {
		padding: "12px",
		lineHeight: "16px"
	},
	$xl: {
		padding: "14px",
		lineHeight: "16px"
	},
	$2xl: {
		padding: "16px",
		lineHeight: "20px"
	}
}, Ah = {
	$xs: {
		height: "16px",
		width: "16px"
	},
	$sm: {
		height: "20px",
		width: "20px"
	},
	$md: {
		height: "20px",
		width: "20px"
	},
	$lg: {
		height: "20px",
		width: "20px"
	},
	$xl: {
		height: "20px",
		width: "20px"
	},
	$2xl: {
		height: "24px",
		width: "24px"
	}
}, jh = ({ localThemeToken: e = {}, ...t }) => /* @__PURE__ */ E(F, {
	theme: { token: {
		...Mh,
		...e
	} },
	children: /* @__PURE__ */ E(ne, { ...t })
}), Mh = { colorTextDisabled: j.gray300 }, Nh = I(function({ mode: e = "inline", theme: t = "light", inlineCollapsed: n = !0, style: r = {}, ...i }) {
	let a = {
		...Ph,
		...r
	}, o = O`
		border-right: 1px solid ${j.gray200} !important;

		.ant-menu-item,
		.ant-menu-submenu-title {
			height: 48px !important;
			width: 48px !important;
			padding-left: 0 !important;
			padding-inline: 0 !important;
			margin-bottom: 0px !important;
			margin-block: 2px !important;
			margin-inline: auto !important;
			display: flex;
			align-items: center;
			justify-content: center !important;
			color: ${j.gray500};
		}
		
		.ant-menu-submenu-arrow {
			inset-inline-end: -1px !important;
		}

		.ant-menu-title-content {
			display: none !important;
		}

		.ant-menu-item-selected {
			color: ${j.gray700};
			background: ${j.gray50};
		}
	`;
	return /* @__PURE__ */ E(ie, {
		style: a,
		mode: e,
		theme: t,
		inlineCollapsed: n,
		...i,
		css: o
	});
}), Ph = {
	height: "100%",
	paddingTop: 30,
	borderInlineEnd: "none",
	borderRight: `1px solid ${j.gray200} !important`
}, { Item: Fh, ItemGroup: Ih, SubMenu: Lh, Divider: Rh } = ie, zh = {
	Item: Fh,
	ItemGroup: Ih,
	SubMenu: Lh,
	Divider: Rh
}, H = I(function({ style: e = {}, ...t }) {
	let n = {
		...Bh,
		...e
	};
	return /* @__PURE__ */ E(ae, {
		style: n,
		...t
	});
}), Bh = {}, { useToken: Vh } = C, Hh = I(function({ type: e = "navigation", style: t = {}, ...n }) {
	let { token: r } = Vh(), i = {
		...Uh,
		...t
	}, a = O`
		// hacky but worky. Removes underline of active step
		.ant-steps-item {
			&:before {
				height: 0 !important;
				color: white !important;
				transition: none !important;
			}
		}
		.ant-steps-item.ant-steps-item-active {
			&:before {
				height: 0 !important;
				color: white !important;
			}

			.ant-steps-item-icon {
				border-color: ${r.colorPrimary};
			}
		}
		.ant-steps-item-process .ant-steps-item-icon {
			background: ${r.colorPrimary} !important;
			color: ${r.colorTextLightSolid} !important;
		}
		.ant-steps-item-icon {
			display: inline-flex;
			align-items: center;
			justify-content: center;
		}
	`;
	return /* @__PURE__ */ E(fe, {
		type: e,
		style: i,
		className: "site-navigation-steps",
		css: a,
		...n
	});
}), Uh = {}, Wh = w("div")`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 48px;
	height: 48px;
	background: ${(e) => e.bgColor};
	${(e) => e.borderColor ? `border: 8px solid ${e.borderColor}` : ""};
	border-radius: 28px;
`, Gh = w("div")`
	display: grid;
	grid-template-columns: repeat(${(e) => e.buttonCount}, 1fr);
	gap: 8px;
`, U = ({ customHeader: e, iconBgColor: t, icon: n, title: r, noIcon: i = !1, iconColor: a, iconBorderColor: o }) => e || (i ? /* @__PURE__ */ E(q, {
	style: { fontWeight: 500 },
	size: "xl",
	color: j.gray900,
	children: r
}) : /* @__PURE__ */ D(T, { children: [/* @__PURE__ */ E(Wh, {
	bgColor: t,
	borderColor: o,
	children: /* @__PURE__ */ E(W, {
		icon: n,
		color: a
	})
}), /* @__PURE__ */ E(q, {
	size: "xl",
	style: { fontWeight: 500 },
	color: j.gray900,
	children: r
})] })), Kh = I(function({ iconBgColor: e, iconBorderColor: t, icon: r, iconColor: i, title: a, actionButtons: o, children: s, width: c, onConfirm: l, customHeader: u, preset: d, ...f }) {
	let p = n(() => {
		switch (d) {
			case "success": return U({
				iconColor: j.success600,
				title: a,
				icon: r || "CheckCircle",
				iconBgColor: j.success100,
				iconBorderColor: j.success50
			});
			case "warning": return U({
				iconColor: j.warning600,
				title: a,
				icon: r || "Save01",
				iconBgColor: j.warning100,
				iconBorderColor: j.warning50
			});
			case "error": return U({
				iconColor: j.error600,
				title: a,
				icon: r || "CheckCircle",
				iconBgColor: j.error100,
				iconBorderColor: j.error50
			});
			default: return U({
				iconBgColor: e,
				iconBorderColor: t,
				icon: r,
				iconColor: i,
				title: a,
				customHeader: u,
				noIcon: !r
			});
		}
	}, [
		e,
		u,
		t,
		a
	]);
	return /* @__PURE__ */ E(H, {
		title: p,
		width: c,
		onOk: l,
		closeIcon: /* @__PURE__ */ E(W, { icon: "XClose" }),
		footer: o?.length ? /* @__PURE__ */ E(Gh, {
			buttonCount: o.length,
			children: o.map((e, t) => /* @__PURE__ */ E(V, {
				disabled: e.disabled,
				type: e.type,
				onClick: e.onClick,
				children: e.text
			}, t))
		}) : [],
		...f,
		children: s
	});
}), qh = ({ style: e = {}, children: t, ...n }) => {
	let r = {
		...Jh,
		...e
	};
	return /* @__PURE__ */ E(oe, {
		style: r,
		...n,
		children: t
	});
}, Jh = {}, Yh = (t, n, ...s) => (c) => {
	let [l, u] = r(!1), d = e(() => {
		u(!0);
	}, []), f = e(() => {
		u(!1), c.onConfirm();
	}, [c]), p = e(() => {
		u(!1);
	}, []);
	return /* @__PURE__ */ o(i, { children: [/* @__PURE__ */ a(t, {
		...c,
		onClick: d
	}), /* @__PURE__ */ a(H, {
		title: c.title,
		open: l,
		onOk: f,
		onCancel: p,
		...s,
		children: n
	})] });
}, W = ({ svgProps: e = {}, icon: t, size: n = 24, color: r, ...i }) => {
	let a = Bm[t];
	return /* @__PURE__ */ E(a, {
		viewBox: "0 0 24 24",
		width: n,
		height: n,
		color: r,
		...i,
		fill: "none",
		...e
	});
}, Xh = O`
	&.ant-radio-button-wrapper-checked {
		border: 1px solid ${j.gray300} !important;
		border-left: 1px solid ${j.gray300} !important;
		color: ${j.gray500} !important;
		background-color: ${j.gray200} !important;

		&:hover {
			background-color: ${j.gray50};
		}
	}

	&&:not(.ant-radio-button-wrapper-disabled)::before {
		background-color: ${j.white} !important;
	}
`, Zh = O`
	&.ant-radio-button-wrapper {
		background: ${j.gray50};
		border: 1px solid ${j.gray300};
		color: ${j.gray800};

		&:hover {
			background-color: ${j.white};
		}
	}
`, Qh = I(function({ onChange: e, size: t = "sm", items: n, value: r, defaultValue: i, ...a }) {
	let o = { ...$h[`${t}`] };
	return /* @__PURE__ */ E(b.Group, {
		onChange: e,
		value: r,
		defaultValue: i,
		...a,
		children: n.map((e) => /* @__PURE__ */ E(b.Button, {
			css: [Xh, Zh],
			value: e.value,
			style: o,
			children: /* @__PURE__ */ D(B, {
				align: "center",
				size: 4,
				children: [!!e.iconLeft && /* @__PURE__ */ E(T, { children: /* @__PURE__ */ E(W, {
					size: o.fontSize,
					icon: e.iconLeft
				}) }), /* @__PURE__ */ E("span", {
					css: O`
									font-weight: 500;
									font-size: ${o.fontSize};
								`,
					children: e.label
				})]
			})
		}, e.value))
	});
}), G = { minWidth: 40 }, $h = {
	inline: {
		...G,
		display: "inline-block",
		padding: "3px 5px",
		fontSize: N.definitions.fontSize.xs
	},
	sm: {
		...G,
		padding: "8px 10px",
		lineHeight: "20px",
		fontSize: N.definitions.fontSize.sm
	},
	md: {
		...G,
		padding: "10px 18px",
		lineHeight: "20px",
		fontSize: N.definitions.fontSize.sm
	},
	lg: {
		...G,
		padding: "10px 20px",
		lineHeight: "24px",
		fontSize: N.definitions.fontSize.md
	},
	xl: {
		...G,
		padding: "12px 22px",
		lineHeight: "24px",
		fontSize: N.definitions.fontSize.md
	},
	"2xl": {
		...G,
		padding: "16px 30px",
		lineHeight: "28px",
		fontSize: N.definitions.fontSize.md
	}
}, K = ({ svgProps: e = {}, icon: t, size: n = 24, color: r, ...i }) => {
	let a = A[t];
	return a ? /* @__PURE__ */ E(a, {
		viewBox: "0 0 24 24",
		width: n,
		height: n,
		color: r,
		...i,
		fill: "none",
		...e
	}) : null;
}, eg = (e) => /* @__PURE__ */ E(re, {
	src: nh,
	...e
}), { Text: tg } = S, q = I(function({ preset: e = "default", size: t, style: n = {}, color: r, ...i }) {
	let a = {
		...ng,
		...rg[e],
		...t ? ag(t) : {},
		...ig(r),
		...n
	};
	return /* @__PURE__ */ E(tg, {
		color: r || j.gray600,
		style: a,
		...i
	});
}, { token: {
	fontSize: N.fontSize.default,
	lineHeight: N.lineHeight.default
} }), ng = { fontWeight: N.fontWeight.default }, rg = { default: {} }, ig = (e) => ({ color: e || j.gray600 }), ag = (e) => ({
	fontSize: N.definitions.fontSize[e],
	lineHeight: N.definitions.lineHeight[e]
}), { Title: og } = S, sg = I(function({ style: e = {}, preset: t = "default", ...n }) {
	let r = {
		...cg,
		...lg[t],
		...e
	};
	return /* @__PURE__ */ E(og, {
		style: r,
		...n
	});
}), cg = {
	marginTop: 0,
	marginBottom: 0
}, lg = {
	default: { fontWeight: 500 },
	supporting: { fontWeight: 400 },
	tablePageTitle: {
		color: j.gray900,
		fontSize: N.definitions.fontSize["2xl"],
		lineHeight: N.definitions.lineHeight.md,
		fontWeight: 500
	},
	singlePageTitle: {
		color: j.gray900,
		fontSize: N.definitions.fontSize.lg,
		lineHeight: N.definitions.lineHeight.md,
		fontWeight: 500
	},
	tablePageSubtitle: {
		color: j.gray900,
		fontSize: N.definitions.fontSize.md,
		lineHeight: N.definitions.lineHeight.md,
		fontWeight: 400
	}
}, { Paragraph: ug } = S, J = I(function({ preset: e = "default", size: t, style: n = {}, noMargin: r = !1, ...i }) {
	let a = {
		...dg,
		...Y[e],
		...t ? fg(t) : {},
		...n,
		...r ? pg : {}
	};
	return /* @__PURE__ */ E(ug, {
		style: a,
		...i
	});
}, { token: {
	margin: 0,
	fontSize: N.fontSize.default,
	lineHeight: N.lineHeight.default,
	colorText: j.gray600
} }), dg = { fontWeight: N.fontWeight.default }, Y = {
	default: {},
	pageHeader: {
		fontSize: N.fontSize.pageHeader,
		fontWeight: N.fontWeight.semiBoldParagraph,
		color: j.gray900
	},
	statisticTitle: {
		fontSize: N.fontSize.default,
		color: j.gray600,
		fontWeight: N.fontWeight.semiBoldParagraph
	},
	statisticValue: {
		fontSize: N.fontSize.statisticValue,
		fontWeight: N.fontWeight.semiBoldParagraph,
		color: j.gray900
	},
	pageHeaderSupporting: {},
	panelCard: {
		fontSize: N.definitions.fontSize.md,
		fontWeight: N.fontWeight.semiBoldParagraph,
		color: j.gray900
	},
	formTitle: {
		fontSize: N.definitions.fontSize.sm,
		color: j.gray700,
		fontWeight: N.fontWeight.semiBoldParagraph
	}
}, fg = (e) => ({
	fontSize: N.definitions.fontSize[e],
	lineHeight: N.definitions.lineHeight[e]
}), pg = { margin: "0px !important" }, mg = I(function({ sizeValue: e, size: t = "md", src: n, ...r }) {
	return /* @__PURE__ */ E(c, {
		size: e || N.dimensions.avatar[t],
		src: n || null,
		icon: /* @__PURE__ */ E(W, {
			icon: "User01",
			size: N.dimensions.avatar[t] * .5,
			color: j.gray600
		}),
		...r,
		"data-testid": "avatar"
	});
}, { token: {
	colorTextLightSolid: j.gray600,
	colorTextPlaceholder: j.gray100
} }), hg = w(mg)`
	background-color: ${(e) => e.style?.backgroundColor || j.gray100};
`, gg = I(function({ icon: e, sizeValue: t, size: n = "md", src: r, ...i }) {
	return /* @__PURE__ */ E(c, {
		size: t || N.dimensions.avatar[n],
		src: r || null,
		icon: /* @__PURE__ */ E(K, {
			icon: e,
			size: N.dimensions.avatar[n] * .55,
			color: j.gray600
		}),
		...i
	});
}, { token: {
	colorTextLightSolid: j.gray600,
	colorTextPlaceholder: j.gray100
} }), _g = w(gg)`
	background-color: ${(e) => e.style?.backgroundColor || j.gray100};
	&.ant-avatar.ant-avatar-icon {
		display: flex !important;
		align-content: center !important;
		justify-content: center !important;
		flex-wrap: wrap !important;
	}

`, vg = I(function({ maxCount: e = 4, maxPopoverTrigger: t = "hover", sizeValue: n, size: r = "md", ...i }) {
	return /* @__PURE__ */ E(c.Group, {
		maxCount: e,
		maxPopoverTrigger: t,
		size: n || N.dimensions.avatar[r],
		...i
	});
}, { token: { colorTextLightSolid: j.gray600 } }), yg = I(function({ style: e = {}, offset: t, ...n }) {
	let r = {
		...bg,
		...e,
		...n
	};
	return /* @__PURE__ */ E(l, {
		offset: t,
		style: r,
		...n
	});
}, { token: {
	fontSize: 24,
	lineWidth: 2
} }), bg = {}, xg = w(d)`
	overflow: hidden;

	.ant-card-body {
		padding: 0;
	}
`, Sg = I(function({ bordered: e = !0, style: t = {}, ...n }) {
	let r = {
		...Cg,
		...t
	};
	return /* @__PURE__ */ E(xg, {
		style: r,
		bordered: e,
		...n,
		"data-testid": "card"
	});
}), Cg = { width: 230 }, { Grid: wg, Meta: Tg } = d, Eg = w(z)`
  position: absolute;
  width: 100%;
  height: 0;
  bottom: 0;
  overflow: hidden;
  transition: height 0.2s ease-in-out;
  z-index: 1;
`, Dg = w(Eg)`
  bottom: 56px;
  background-color: ${j.white};
`, Og = w(Eg)`
  background-color: ${j.gray800};
`, kg = w.div`
  &:hover {
    #hover-card-hover-container {
      height: calc(100% - 56px);
    }
    #hover-card-hover-footer {
      height: 56px;
    }
  }
`, Ag = I(function({ hoverItems: e = [], hoverContent: t, hoverFooterContent: n, overlayFooterContainerProps: r = {}, overlayContentContainerProps: i = {}, ...a }) {
	return /* @__PURE__ */ E(kg, { children: /* @__PURE__ */ D(Fg, {
		...a,
		children: [!!t && /* @__PURE__ */ E(Dg, {
			id: "hover-card-hover-container",
			...i,
			children: t
		}), /* @__PURE__ */ E(Og, {
			id: "hover-card-hover-footer",
			...r,
			children: n || e.map((e, t) => /* @__PURE__ */ E(Oh, {
				type: "text",
				iconProps: { color: j.white },
				...e
			}, `${e.icon}-${t}`))
		})]
	}) });
}), { useToken: jg } = C, Mg = w(z)`
  padding: ${P.padding.card.default}px ${P.padding.card.default}px 0
    ${P.padding.card.default}px;
`, Ng = w(L)`
  padding: 0 ${P.padding.card.default}px;
`, Pg = w(z)`
  max-height: 56px;
  padding: 0 ${P.padding.card.default}px ${P.padding.card.default}px
    ${P.padding.card.default}px;
`, Fg = I(function({ HeaderComponent: e, headerContent: t, headerProps: n = {}, ContentComponent: r, content: i, contentProps: a = {}, FooterComponent: o, footerContent: s, footerProps: c = {}, children: l, ...u }) {
	let { token: d } = jg();
	return /* @__PURE__ */ D(Sg, {
		...u,
		children: [
			e || !!t && /* @__PURE__ */ E(Mg, {
				...n,
				children: t
			}),
			r || !!i && /* @__PURE__ */ E(Ng, {
				...a,
				children: i
			}),
			l,
			o || !!s && /* @__PURE__ */ E(Pg, {
				css: O`
              border-top: 1px solid ${d.colorBorderSecondary};
            `,
				...c,
				children: s
			})
		]
	});
}), X = w.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
	padding: 0 16px;
`;
function Ig({ localThemeToken: e = {}, data: t, columns: n, style: r = {}, ...i }) {
	let a = {
		...Rg,
		...r
	};
	return /* @__PURE__ */ E(F, {
		theme: { token: {
			...Lg,
			...e
		} },
		children: /* @__PURE__ */ E(me, {
			style: a,
			columns: n,
			dataSource: t,
			size: "small",
			pagination: {
				style: {
					border: `1px solid ${j.gray300}`,
					width: "fit-content",
					borderRadius: 8,
					margin: "12px 12px 12px 0",
					marginLeft: "auto"
				},
				itemRender(e, t) {
					if (t === "page") return /* @__PURE__ */ E(X, { children: /* @__PURE__ */ E(q, { children: e }) });
					if (t === "next") return /* @__PURE__ */ D(X, { children: [/* @__PURE__ */ E(q, { children: "Next" }), /* @__PURE__ */ E(W, {
						icon: "ArrowDown",
						size: 20,
						style: { transform: "rotate(270deg)" }
					})] });
					if (t === "prev") return /* @__PURE__ */ D(X, { children: [/* @__PURE__ */ E(W, {
						icon: "ArrowDown",
						size: 20,
						style: { transform: "rotate(90deg)" }
					}), /* @__PURE__ */ E(q, { children: "Prev" })] });
				}
			},
			...i,
			css: O`
					.ant-table-column-title {
						font-weight: 500;
					}
					.ant-pagination-item-active {
						border: none;
					}
					.ant-pagination {
						height: 40px;
						align-items: stretch;
						color: ${j.gray700};

						li {
							height: auto !important;
							margin: 0;
							display: flex;
							align-items: center;
							color: inherit !important;
							border-radius: 0;
						}

						.ant-pagination-item:not(:last-child) {
							border: none;
							border-color: unset;
							border-right: 1px solid ${j.gray300};
						}
					}
					.ant-pagination-next {
						border-radius: 0;
					}
					.ant-pagination-prev {
						border-right: 1px solid ${j.gray300};
						border-radius: 0;
					}
					.ant-pagination-item-active {
						background: ${j.gray50};
					}
					.ant-table-thead {
						.ant-table-cell {
							font-weight: 500;
						}
					}
				`
		})
	});
}
var Lg = {
	fontSize: N.fontSize.tableHeader,
	fontWeightStrong: N.fontWeight.tableHeader,
	colorText: j.gray600
}, Rg = {
	border: `1px solid ${j.gray200}`,
	borderRadius: N.borderRadius.table
}, zg = I(function({ style: e = {}, type: t = "subtle", color: n = "success500", bgColor: r, ...i }) {
	let a = {
		...Bg,
		...Vg(t, n, r),
		...e,
		...i
	};
	return /* @__PURE__ */ E(he, {
		style: a,
		...i,
		"data-testid": "tag"
	});
}, { token: {
	borderRadiusSM: 16,
	lineWidth: 1.5,
	fontSizeSM: N.fontSize.tag,
	lineHeight: N.lineHeight.tag
} }), Bg = {
	display: "flex",
	alignItems: "center",
	width: "fit-content"
}, Vg = (e, t, n) => {
	switch (e) {
		case "custom": return {
			backgroundColor: n,
			color: t
		};
		case "fill": return {
			border: "none",
			backgroundColor: t,
			color: j.white
		};
		case "subtle": return {
			border: "none",
			backgroundColor: t + "20",
			color: t
		};
		case "outline": return {
			border: `1px solid ${t}`,
			backgroundColor: t + "20",
			color: t
		};
	}
}, Hg = I(function({ title: e, value: t, style: n = {}, width: r = 392, ...i }) {
	let a = {
		...Ug(r),
		...n
	};
	return /* @__PURE__ */ E(d, {
		style: a,
		bordered: !1,
		children: /* @__PURE__ */ E(de, {
			title: /* @__PURE__ */ E(J, {
				preset: "statisticTitle",
				children: e
			}),
			value: t,
			valueStyle: Y.statisticValue,
			...i
		})
	});
}), Ug = (e) => ({
	display: "flex",
	flexDirection: "column",
	alignItems: "flex-start",
	padding: P.spaces[6],
	gap: P.spaces[2],
	background: j.white,
	border: `1px solid ${j.gray200}`,
	borderRadius: P.spaces[3],
	minWidth: `${e}px`
}), Wg = I(function({ style: e = {}, ...t }) {
	let n = {
		...Gg,
		...e
	}, r = O`
		.ant-collapse-header {
			padding: 0 !important;
		}

		.ant-collapse-content-box {
			padding: 0 !important;
		}

		.ant-collapse,
		.ant-collapse-content,
		.ant-collapse-content-active {
			border-top: none !important
		}

		.ant-collapse-expand-icon {
			align-self: center
		}
	`;
	return /* @__PURE__ */ E(m, {
		style: n,
		css: r,
		...t
	});
}), Gg = {
	background: "transparent",
	borderColor: j.gray200
}, { Panel: Kg } = m, qg = I(function({ style: e = {}, children: t, ...n }) {
	let r = {
		...Jg,
		...e
	};
	return /* @__PURE__ */ E(Kg, {
		style: r,
		...n,
		children: t
	});
}), Jg = { borderColor: j.gray200 }, Yg = I(function({ style: e = {}, ...t }) {
	let n = {
		...Xg,
		...e
	};
	return /* @__PURE__ */ E(_e, {
		style: n,
		...t
	});
}), Xg = {}, Zg = I(function({ title: e, style: t = {}, width: n, tagText: r, radioButtonGroupProps: i, content: a, ...o }) {
	let s = {
		...Qg(n),
		...t
	};
	return /* @__PURE__ */ D(d, {
		style: s,
		bordered: !1,
		...o,
		children: [/* @__PURE__ */ D(z, {
			justify: "space-between",
			align: "middle",
			children: [/* @__PURE__ */ D(z, {
				css: O`
						gap: 10px;
					`,
				align: "middle",
				children: [/* @__PURE__ */ E(J, {
					css: O`
							margin: 0px !important;
						`,
					preset: "panelCard",
					children: e
				}), r && /* @__PURE__ */ D(zg, {
					type: "custom",
					bgColor: j.success50,
					color: j.success700,
					css: O`
								height: 22px;
							`,
					children: [/* @__PURE__ */ E(W, {
						height: 14,
						color: j.success700,
						icon: "ArrowUp"
					}), r]
				})]
			}), i && /* @__PURE__ */ E(Qh, { ...i })]
		}), /* @__PURE__ */ E(z, { children: a })]
	});
}), Qg = (e) => ({
	background: j.white,
	border: `1px solid ${j.gray200}`,
	borderRadius: "12px",
	minWidth: e
}), Z = I(function({ size: e = "md", icon: t = "User01", borderColor: n, iconBackground: r, iconColor: i, ...a }) {
	let o = { ...$g({
		borderColor: n,
		iconBackground: r,
		size: e
	}) };
	return /* @__PURE__ */ E("div", {
		style: o,
		...a,
		children: /* @__PURE__ */ E(W, {
			icon: t,
			style: e_({ iconColor: i }),
			size: N.dimensions.avatar[e] * .5,
			color: j.gray600
		})
	});
}, { token: {
	colorTextLightSolid: j.gray600,
	colorTextPlaceholder: j.gray100
} }), $g = (e) => ({
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
	width: N.dimensions.avatar[e.size],
	height: N.dimensions.avatar[e.size],
	border: `1.5px solid ${e.borderColor || j.white}`,
	borderRadius: 200,
	backgroundColor: e.iconBackground || j.lightBlue100
}), e_ = (e) => ({ color: e.iconColor || j.lightBlue600 }), t_ = I(function({ avatars: e, maxCount: t = 4 }) {
	let n = e.slice(0, t), r = e.slice(t), i = { items: r.map((e, t) => ({
		key: t,
		label: /* @__PURE__ */ E(Z, { ...e }),
		onClick: () => {
			console.log("click");
		}
	})) };
	return /* @__PURE__ */ D("div", {
		style: n_,
		children: [n.map((e, t) => /* @__PURE__ */ E("div", {
			style: { marginLeft: -12 },
			children: /* @__PURE__ */ E(Z, { ...e })
		}, t)), r.length > 0 && /* @__PURE__ */ E("div", {
			style: { cursor: "pointer" },
			children: /* @__PURE__ */ E(jh, {
				menu: i,
				placement: "bottomRight",
				children: /* @__PURE__ */ E("div", {
					style: r_(n[0].size),
					children: `+${r.length}`
				})
			})
		})]
	});
}, { token: {
	colorTextLightSolid: j.gray600,
	colorTextPlaceholder: j.gray100
} }), n_ = {
	display: "flex",
	alignItems: "center",
	position: "relative"
}, r_ = (e) => ({
	marginLeft: "-12px",
	backgroundColor: j.gray100,
	border: `2px solid ${j.white}`,
	borderRadius: "200px",
	color: j.gray700,
	fontSize: 16,
	fontWeight: 500,
	display: "flex",
	width: N.dimensions.avatar[e.size],
	height: N.dimensions.avatar[e.size],
	justifyContent: "center",
	alignItems: "center",
	padding: "10px"
}), { useToken: i_ } = C, a_ = function({ type: e = "info", showIcon: t = !0, style: n = {}, ...r }) {
	let { token: i } = i_(), a = {
		...s_,
		...n
	};
	return /* @__PURE__ */ E(F, {
		theme: { token: { colorText: i[`color${e.charAt(0).toUpperCase() + e.slice(1)}`] } },
		children: /* @__PURE__ */ E(s, {
			style: a,
			type: e,
			showIcon: t,
			icon: /* @__PURE__ */ E(W, {
				icon: o_[e],
				style: {
					width: 18,
					height: 18
				}
			}),
			...r
		})
	});
}, o_ = {
	success: "CheckCircle",
	error: "AlertCircle",
	warning: "AlertTriangle",
	info: "InfoCircle"
}, s_ = {}, c_ = I(function({ placement: e = "right", style: t = {}, ...n }) {
	let r = {
		...l_,
		...t
	};
	return /* @__PURE__ */ E(te, {
		placement: e,
		style: r,
		...n
	});
}), l_ = {}, u_ = I(function({ style: e = {}, ...t }) {
	let n = {
		...d_,
		...e
	};
	return /* @__PURE__ */ E(se, {
		style: n,
		...t
	});
}), d_ = {}, f_ = w(le)`
	.ant-slider-rail {
		background: ${j.gray200};
		border-radius: 4px;
		height: 8px;
	}

	.ant-slider-track {
		height: 8px;
		background: ${j.primary600};
		border-radius: 4px;
	}

	.ant-slider-handle {
		width: 24px;
		height: 24px;
		margin-top: -5px;
		background: ${j.white};
		border: 1.5px solid ${j.primary600};
		box-shadow: 0 4px 8px -2px rgba(16, 24, 40, 0.1),
			0px 2px 4px -2px rgba(16, 24, 40, 0.06);
		border-radius: 12px;

		&::before {
			display: none;
		}

		&::after {
			display: none;
		}
	}

	.ant-tooltip {
		top: ${({ place: e }) => e === "top" ? "20px" : "80px"};
	}

	.ant-tooltip-arrow {
		display: none;
	}

	.ant-tooltip-inner {
		background-color: transparent;
		color: black;
		box-shadow: unset;
		font-weight: 500;
		font-size: 16px;
		line-height: 24px;
	}
`, p_ = I(function({ range: e, defaultValue: t, place: n = "top", min: r, max: i, tooltipVisible: a = !0, value: o, setValue: s, ...c }) {
	return /* @__PURE__ */ E(f_, {
		place: n,
		range: e,
		value: o,
		defaultValue: t,
		onChange: (e) => {
			s(e);
		},
		min: r,
		max: i,
		tooltip: {
			open: a,
			getPopupContainer: (e) => e.parentNode
		},
		...c
	});
}), m_ = I(function({ style: e = {}, ref: t, ...n }) {
	let r = {
		...h_,
		...e
	};
	return /* @__PURE__ */ E(f, {
		style: r,
		ref: t,
		"data-testid": "checkbox",
		...n
	});
}, { token: {
	fontSizeSM: N.definitions.fontSize.sm,
	fontSizeLG: N.definitions.fontSize.sm,
	controlInteractiveSize: N.controlInteractiveSizes.checkbox
} }), h_ = {}, g_ = I(function({ ...e }) {
	return /* @__PURE__ */ E(f.Group, { ...e });
}), __ = I(function({ style: e = {}, ...t }) {
	let n = {
		...v_,
		...e
	};
	return /* @__PURE__ */ E(g, {
		style: n,
		...t
	});
}, { token: { borderRadiusSM: N.definitions.borderRadius.full } }), v_ = {}, { Dragger: y_ } = ve, b_ = I(function({ withPresetContent: e = !0, onStatusChange: t, onUpload: n, onlyIcon: r = !1, style: i = {}, children: a, ...o }) {
	let s = {
		...x_,
		...i
	};
	return /* @__PURE__ */ D(y_, {
		css: r ? O`
								.ant-upload-drag {
									width: 44px;
									height: 44px;
									border: 1px solid ${j.gray200};
									border-radius: ${N.borderRadius.default};
									display: flex;
									align-items: center;
									justify-content: center;
								}
								.ant-upload-list {
									display: none !important;
								}
								.ant-upload-list-text {
									display: none !important;
								}
						  ` : O`
								.ant-upload-drag {
									border: 1px solid ${j.gray200};
									border-radius: ${N.borderRadius.default};
									padding: 24px 16px;
								}
						  `,
		style: s,
		onChange: (e) => {
			let { status: r } = e.file;
			t?.(r), n?.(e);
		},
		...o,
		children: [
			r && /* @__PURE__ */ E(W, {
				css: O`
							width: 20px;
							height: 20px;
						`,
				icon: "Upload01",
				color: j.gray600
			}),
			e && !r && /* @__PURE__ */ D(B, {
				size: 10,
				direction: "vertical",
				children: [/* @__PURE__ */ E(W, {
					icon: "UploadCloud02",
					color: j.gray600
				}), /* @__PURE__ */ E(q, { children: "Click to upload or drag and drop" })]
			}),
			a
		]
	});
}, { token: { lineType: "solid" } }), x_ = {}, S_ = I(function({ style: e = {}, layout: t = "vertical", ref: n, ...r }) {
	let i = {
		...C_,
		...e
	};
	return /* @__PURE__ */ E(_, {
		ref: n,
		style: i,
		layout: t,
		...r
	});
}), C_ = {}, { ...w_ } = _, T_ = { ...w_ }, E_ = I(function({ style: e = {}, ...t }) {
	let n = {
		...D_,
		...e
	};
	return /* @__PURE__ */ E(_.Item, {
		style: n,
		...t
	});
}), D_ = {}, O_ = I(function({ title: e, description: t, formItems: n, lineBottom: r = !1, table: i, button: a }) {
	return /* @__PURE__ */ D(T, { children: [/* @__PURE__ */ D("div", {
		css: O`
					display: grid;
					grid-template-columns: 1fr 2fr;
					gap: 1rem;
				`,
		children: [/* @__PURE__ */ D("div", {
			css: O`
						padding: 5px;
					`,
			children: [/* @__PURE__ */ E(J, {
				preset: "formTitle",
				css: O`
							margin-bottom: 5px !important;
						`,
				children: e
			}), /* @__PURE__ */ E(J, {
				css: O`
							margin-bottom: 0 !important;
						`,
				children: t
			})]
		}), /* @__PURE__ */ E("div", {
			css: O`
						.ant-form-item-required::before {
							display: none !important;
						}
					`,
			children: n ? /* @__PURE__ */ E(S_, {
				css: O`
								display: grid;
								grid-template-columns: repeat(2, 1fr);
								gap: 1rem;
							`,
				children: n.map((e) => /* @__PURE__ */ E(E_, {
					css: e.takeTwo && O`
												grid-column: span 2;
											`,
					...e,
					children: e.component
				}, String(e.name)))
			}) : /* @__PURE__ */ D(L, {
				css: O`
								gap: 10px;
								display: flex;
								flex-direction: column;
							`,
				children: [/* @__PURE__ */ E(Ig, { ...i }), /* @__PURE__ */ E(V, {
					css: O`
									align-self: flex-end;
								`,
					...a,
					children: a?.children
				})]
			})
		})]
	}), r && /* @__PURE__ */ E(R, { css: O`
						color: ${j.gray200};
						width: 100%;
					` })] });
}), k_ = [
	j.success100,
	j.moss200,
	j.cyan100,
	j.rose100,
	j.yellow100,
	j.purple100,
	j.teal100
], A_ = [
	{
		value: "Compétence",
		label: "Compétence"
	},
	{
		value: "Géographie",
		label: "Géographie"
	},
	{
		value: "Misc",
		label: "Misc"
	}
], j_ = [
	{ iconName: "AlertCircle" },
	{ iconName: "AlertHexagon" },
	{ iconName: "AlertOctagon" },
	{ iconName: "AlertSquare" }
], M_ = w("div")`
	margin-top: 12px;
	display: flex;
	padding: 12px 0;
	justify-content: space-between;
	border-bottom: 1px solid ${j.gray200};
	border-top: 1px solid ${j.gray200};
`, N_ = ({ bgColors: e, selectedColor: t, selectedIcon: n, setSelectedColor: r }) => /* @__PURE__ */ E(M_, { children: e.map((e) => /* @__PURE__ */ E(_g, {
	onClick: () => {
		r(e);
	},
	icon: n,
	style: {
		backgroundColor: e,
		borderColor: t === e ? "black" : "transparent",
		borderWidth: 1,
		borderRadius: "100%"
	}
}, e)) }), P_ = ({ text: e, selectedColor: t, setData: n, selectedIcon: r, setVisible: i }) => /* @__PURE__ */ E(V, {
	type: "primary",
	css: O`
				margin-top: 8px;
				width: 100%;
				display: flex;
				justify-content: center;
			`,
	disabled: !r || !t,
	onClick: () => {
		n({
			iconName: r,
			iconColor: t
		}), i(!1);
	},
	children: /* @__PURE__ */ E(q, {
		color: j.white,
		children: e
	})
}), F_ = w("div")`
	display: flex;
	gap: 26px;
	flex-wrap: wrap;
	padding-top: 17px;
	justify-content: center;
`;
function I_({ searchVal: e, icons: n, setSelectedIcon: i, selectedIcon: a }) {
	let [o, s] = r(n);
	return t(() => {
		let t = n.filter((t) => t.toLowerCase().includes(e.toLowerCase()));
		s(t);
	}, [e]), /* @__PURE__ */ E(F_, { children: o.map((e) => /* @__PURE__ */ E("div", {
		onClick: () => {
			i(e);
		},
		style: {
			border: a === e && `1px solid ${j.black}`,
			borderRadius: "100%",
			width: "40px",
			height: "40px",
			display: "flex",
			justifyContent: "center",
			alignItems: "center"
		},
		children: /* @__PURE__ */ E(K, { icon: e })
	}, e)) });
}
//#endregion
//#region src/components/inputs/icon-input/components/icon-search-content/index.tsx
var L_ = w("div")`
	position: relative;
	top: -5px;
	max-width: 378px;
	padding: 12px 16px;
	border-bottom-right-radius: 8px;
	border-bottom-left-radius: 8px;
	border: 1px solid ${j.gray200};
	background: ${j.white};
`, R_ = w("div")`
	display: flex;
	flex-direction: row-reverse;
`, z_ = ({ bgColors: e, text: t, placeholderText: n, selectedColor: i, setSelectedColor: a, selectedIcon: o, setSelectedIcon: s, onSubmit: c, setVisible: l }) => {
	let [u, d] = r("");
	return /* @__PURE__ */ D(L_, { children: [
		/* @__PURE__ */ E(v, {
			prefix: /* @__PURE__ */ E(be, {}),
			placeholder: n,
			size: "large",
			value: u,
			onChange: (e) => d(e.target.value)
		}),
		/* @__PURE__ */ E(I_, {
			selectedIcon: o,
			setSelectedIcon: s,
			icons: Object.keys(A),
			searchVal: u
		}),
		/* @__PURE__ */ E(N_, {
			selectedColor: i,
			selectedIcon: o,
			setSelectedColor: a,
			bgColors: e
		}),
		/* @__PURE__ */ E(R_, { children: /* @__PURE__ */ E(P_, {
			selectedColor: i,
			selectedIcon: o,
			text: t,
			setData: c,
			setVisible: l
		}) })
	] });
}, B_ = w(ne)`
	padding: 12px 16px;
	max-width: 412px;
	border-radius: 8px;
	border: 1px solid ${j.gray200};
	font-size: 14px;
	line-height: 20px;
	color: ${j.gray700};
	text-align: start;
	font-weight: bold;
	background: ${j.white};
	z-index: 10;
`, V_ = I(function({ titleText: e = "Icone", value: n, bgColors: i, text: a = "Valider", placeholderText: o = "Rechercher", onSubmit: s, autoSubmit: c = !1 }) {
	let [l, u] = r(!1), [d, f] = r(n?.iconName || null), [p, m] = r(n?.iconColor || ""), h = () => {
		s({
			iconName: d,
			iconColor: p
		});
	};
	return t(() => {
		c && h();
	}, [d, p]), t(() => {
		f(n?.iconName), m(n?.iconColor);
	}, [n]), /* @__PURE__ */ E(B_, {
		onOpenChange: () => u(!l),
		trigger: ["click"],
		open: l,
		dropdownRender: () => /* @__PURE__ */ E(z_, {
			setVisible: u,
			text: a,
			selectedColor: p,
			setSelectedColor: m,
			bgColors: i,
			placeholderText: o,
			selectedIcon: d,
			setSelectedIcon: f,
			onSubmit: h
		}),
		children: d ? /* @__PURE__ */ E(K, { icon: d }) : /* @__PURE__ */ E(q, { children: e })
	});
}), H_ = I(function({ style: e, ...t }) {
	let n = {
		...U_,
		...e
	};
	return /* @__PURE__ */ E(v.Password, {
		style: n,
		...t,
		"data-testid": "password-input"
	});
}, { token: { colorBgContainerDisabled: j.gray50 } }), U_ = {}, { RangePicker: W_ } = g, G_ = I(function({ style: e = {}, ...t }) {
	let n = {
		...K_,
		...e
	};
	return /* @__PURE__ */ E(W_, {
		style: n,
		...t
	});
}, { token: { borderRadiusSM: N.definitions.borderRadius.full } }), K_ = {}, q_ = I(function({ style: e = {}, ...t }) {
	let n = {
		...Y_,
		...e
	};
	return /* @__PURE__ */ E(x, {
		style: n,
		...t,
		"data-testid": "select-input",
		css: O`
          &.ant-select-multiple {
            --ant-select-multi-item-border-color: var(--ant-color-split);
          }
        `
	});
}, { token: {
	borderRadiusSM: N.definitions.borderRadius.sm,
	colorBgContainerDisabled: j.gray50,
	colorFillSecondary: j.white
} }), J_ = x.OptGroup, Y_ = { width: "100%" }, { Option: X_, OptGroup: Z_ } = x, Q_ = ({ localThemeToken: e = {}, ...t }) => /* @__PURE__ */ E(F, {
	theme: { token: {
		...$_,
		...e
	} },
	children: /* @__PURE__ */ E(v, {
		...t,
		"data-testid": "text-input",
		css: O`
          .ant-input-group-addon .ant-select {
            background-color: transparent !important;
          }
        `
	})
}), $_ = { colorBgContainerDisabled: j.gray50 }, ev = ({ localThemeToken: e = {}, ...t }) => /* @__PURE__ */ E(F, {
	theme: { token: {
		...tv,
		...e
	} },
	children: /* @__PURE__ */ E(v.TextArea, {
		...t,
		"data-testid": "text-area-input"
	})
}), tv = { colorBgContainerDisabled: j.gray50 }, nv = I(function({ style: e = {}, ...t }) {
	let n = {
		...rv,
		...e
	};
	return /* @__PURE__ */ E(pe, {
		style: n,
		...t,
		"data-testid": "toggle"
	});
}), rv = {}, iv = w(b)`
	&.ant-radio-wrapper {
		.ant-radio-inner {
			border-color: ${j.primary600};
		}

		.ant-radio-inner::after {
			background-color: ${j.primary800};
		}

		.ant-radio-input:focus + .ant-radio-inner {
			border-color: ${j.primary900};
		}

		.ant-radio-checked .ant-radio-inner {
			background-color: ${j.white};
		}

		&:hover .ant-radio-inner {
			border-color: ${j.primary500};
		}
	}
`, av = I(function({ options: e, onChange: t, value: n, style: r = {}, ref: i, ...a }) {
	let o = {
		...ov,
		...r
	};
	return /* @__PURE__ */ E(b.Group, {
		ref: i,
		onChange: t,
		value: n,
		...a,
		children: e.map((e) => /* @__PURE__ */ E(iv, {
			value: e.value,
			style: o,
			children: e.label
		}, String(e.value)))
	});
}), ov = {}, sv = ({ style: e = {}, children: t, ...n }) => {
	let r = {
		...ov,
		...e
	};
	return /* @__PURE__ */ E(iv, {
		style: r,
		...n,
		children: t
	});
}, cv = { ...b }, lv = I(function({ style: e = {}, ...t }) {
	let n = {
		...uv,
		...e
	};
	return /* @__PURE__ */ E(ge, {
		style: n,
		...t
	});
}, { token: { borderRadiusSM: N.definitions.borderRadius.full } }), uv = { width: "100%" }, dv = {
	darkBlue: "rgba(16, 24, 40, 0.1)",
	invisibleDarkBlue: "rgba(16, 24, 40, 0.06)"
}, fv = {}, Q = {
	...dv,
	...fv
}, pv = I(function({ options: t, onChange: n, value: r, style: i = {}, buttonProps: a, ...o }) {
	let s = {
		...mv,
		...i
	}, c = e((e) => e === r ? {
		...$.base,
		...$.active
	} : {
		...$.base,
		...$.nonActive
	}, [r]), l = O`
		.ant-radio-button-wrapper::before {
			display: none !important
		}
	`;
	return /* @__PURE__ */ E(b.Group, {
		style: s,
		optionType: "button",
		buttonStyle: "solid",
		onChange: n,
		css: l,
		...o,
		children: t.map((e) => /* @__PURE__ */ E(b.Button, {
			value: e.value,
			style: c(e.value),
			...a,
			children: e.label
		}, e.value))
	});
}), mv = {
	background: j.gray50,
	border: `1px solid ${j.gray100}`,
	borderRadius: "8px",
	width: "100%",
	padding: "4px"
}, $ = {
	base: {
		color: j.black,
		marginLeft: "8px",
		position: "static"
	},
	active: {
		background: j.white,
		boxShadow: `0px 1px 3px ${Q.darkBlue}, 0px 1px 2px ${Q.invisibleDarkBlue}`,
		borderRadius: "6px",
		border: `1px solid ${Q.darkBlue}`
	},
	nonActive: {
		background: j.gray50,
		border: "none"
	}
};
//#endregion
//#region src/hooks/useDisclosure.ts
function hv(e = {}) {
	let { isOpen: n, isDefaultOpen: i, onOpen: a, onClose: o } = e, [s, c] = r(i || !1);
	return t(() => {
		n !== s && c(n);
	}, [n]), {
		isOpen: s,
		open: () => {
			c(!0), a?.();
		},
		close: () => {
			c(!1), o?.();
		}
	};
}
//#endregion
//#region src/hooks/useModal.ts
function gv() {
	let [e, t] = ae.useModal();
	return [e, t];
}
//#endregion
//#region src/hooks/useNotification.ts
function _v(e) {
	let [t, n] = ye.useNotification(e);
	return {
		showNotification: (e) => {
			let { notificationType: n = "info", ...r } = e;
			t[n](r);
		},
		destroyNotification: (e) => t.destroy(e),
		notification: t,
		contextHolder: n
	};
}
//#endregion
export { Kh as ActionModal, a_ as Alert, th as AppIcon, hg as Avatar, vg as AvatarGroup, _g as AvatarIcon, gg as AvatarIconBase, k_ as BG_COLORS, yg as Badge, mg as BaseAvatar, V as Button, Dh as ButtonGroup, Sg as Card, wg as CardGrid, Tg as CardMeta, m_ as Checkbox, g_ as CheckboxGroup, L as Col, Wg as Collapse, Z as CommonIconAvatar, lh as Content, __ as DatePicker, R as Divider, c_ as Drawer, b_ as DropInput, jh as Dropdown, fh as Footer, S_ as Form, T_ as FormElements, E_ as FormItem, O_ as FormWrapper, mh as Header, Ag as HoverCard, j_ as ICONS_DATA, W as Icon, K as IconAvatar, t_ as IconAvatarGroup, Oh as IconButton, V_ as IconSearch, Fg as LayoutCard, gh as LayoutContainer, eg as Logo, rh as LogoDark, ih as LogoLight, nh as LogoSVG, Nh as Menu, zh as MenuParts, H as Modal, qg as Panel, Zg as PanelCard, J as Paragraph, H_ as PasswordInput, pv as Pills, qh as Popover, p_ as ProgressBar, u_ as ProgressIndicator, av as Radio, Qh as RadioButtonGroup, cv as RadioElements, G_ as RangePicker, z as Row, q_ as SelectInput, Z_ as SelectOptGroup, X_ as SelectOption, J_ as SelectOptionGroup, yh as Sider, sv as SingleRadio, B as Space, Hg as StatisticCard, Hh as Steps, F as StyleConfigProvider, A_ as TABS_DATA, Ig as Table, zg as Tag, q as Text, ev as TextAreaInput, Q_ as TextInput, lv as TimePicker, sg as Title, nv as Toggle, Yg as Tree, Yh as WithModal, j as colors, Y as presets, N as sizes, P as spacing, hv as useDisclosure, gv as useModal, _v as useNotification, I as withStyleConfig };
